(function() {
'use strict';
angular.module('community', [
	'blocks',
	'community.core',
	'community.layout',
	'community.experts',
	'community.grow',
	'community.widgets',
	'community.login',
	'community.wizard',
	'community.projects',
	'community.messaging',
	'community.profile',
	'community.landing',
	'community.about',
	'community.personal',
	'community.ip',
	'community.reports',

	'community.selectizem'
]);

})();
(function() {
'use strict';
angular
	.module('community.about', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('blocks', []);

})();
(function() {
'use strict';
angular
	.module('community.core', [
		'community.core.uihelpers',
		'community.core.forms',

		'ui.router', 'ngResource', 'ngTouch', 'ngMessages', 'textAngular', 'ui.select', 'ngFileUpload',
		'uuid4', 'doowb.angular-pusher', 'infinite-scroll', 'mm.foundation', 'ngAnimate', 'hl.sticky', 'moment-picker',
		'monospaced.elastic', 'ui.sortable', 'checklist-model'
	]);

})();
(function() {
'use strict';
angular
	.module('community.experts', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.grow', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.ip', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.landing', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.layout', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.login', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.messaging', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.personal', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.profile', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.projects', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.reports', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.selectizem', []);

})();
(function() {
'use strict';
angular
	.module('community.widgets', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.wizard', ['community.core']);

})();
(function() {
'use strict';
angular
	.module('community.core.forms', []);

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers', []);

})();
(function() {
'use strict';
angular
	.module('community.about')
	.controller('AboutController', AboutController);

AboutController.$inject = ['$state', 'PekamaConfig', '$stateParams', 'OrganizationService'];

function AboutController($state, PekamaConfig, $stateParams, OrganizationService) {
	var vm = this;

	var BASE_IMG_PATH = PekamaConfig.staticRoot + 'community/images';
	var DEFAULT_USER_TYPE = 'ipo';

	var typeToImgName = {
		ipo: 'ipo-big.png',
		ipl: 'ipl-big.png'
	};

	vm.selectedTab = DEFAULT_USER_TYPE;
	vm.bigImageUrl = _getImagePath(vm.selectedTab);

	vm.changeTab = changeTab;
	vm.goToLanding = goToLanding;

	activate();

	function activate() {
		_getUserType().then(function(userType) {
			vm.selectedTab = userType;
			vm.bigImageUrl = _getImagePath(userType);
		});
	}

	function changeTab(tab) {
		vm.selectedTab = tab;
		vm.userType = tab;

		vm.bigImageUrl = _getImagePath(tab);
	}

	function goToLanding() {
		$state.go('community.landing', {}, {custom: {scrollToPosition: 0}});
	}

	function _getUserType() {
		var urlLeadType = _normalizeUrlParam($stateParams.lt);

		return OrganizationService.primary().$promise.then(function(organization) {
			return organization.user_type;
		}, function() {
			return urlLeadType || DEFAULT_USER_TYPE;
		}).then(function(userType) {
			return userType || DEFAULT_USER_TYPE;
		});
	}

	function _normalizeUrlParam(param) {
		if (param) {
			return param.toLowerCase().trim();
		}
	}

	function _getImagePath(type) {
		if (!(type in typeToImgName)) {
			type = DEFAULT_USER_TYPE;
		}

		return BASE_IMG_PATH + '/' + typeToImgName[type];
	}
}

})();
(function() {
'use strict';
angular
	.module('community.about')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community.about', {
			url: 'about',
			templateUrl: 'templates/about.html',
			controller: 'AboutController as vm'
		})
}

})();
(function() {
'use strict';
angular
	.module('blocks')
	.directive('cmntAutosize', function() {
		return {
			scope: {
				model: '=ngModel'
			},
			link: function(scope, element, attr) {
				if (element.prop('tagName') !== 'INPUT') {
					return;
				}

				var minWidth = parseInt(element.css('minWidth') || '0');
				var sizeDelta = parseInt(attr.sizeDelta || '2');

				var sizer = angular.element('<div style="position: absolute; visibility: hidden; height: 0; width: 0; overflow: scroll; white-space: nowrap;"></div>');
				element.parent().append(sizer);

				var inputStyle = window.getComputedStyle(element[0]);
				angular.forEach([
					'fontFamily',
					'fontSize',
					'fontWeight',
					'fontStyle',
					'letterSpacing',
					'textTransform',
					'wordSpacing',
					'textIndent',
					'boxSizing',
					'borderRightWidth',
					'borderLeftWidth',
					'borderLeftStyle',
					'borderRightStyle',
					'paddingLeft',
					'paddingRight',
					'marginLeft',
					'marginRight'
				], function(value) {
					sizer.css(value, inputStyle[value]);
				});

				function update() {
					var sizerText = element.val() || element.prop('placeholder');
					sizerText = sizerText.replace(/\s/g, '&nbsp;');

					sizer.html(sizerText);
					var newWidth = Math.max(minWidth, sizer.prop('scrollWidth') + sizeDelta);
					element.css('width', newWidth + 'px');
				}

				update();

				if (attr.ngModel) {
					scope.$watch('model', update);
				} else {
					element.on('keydown keyup focus input propertychange change', update);
				}
			}
		}
	});

})();
(function() {
'use strict';
/*
 * Taken from igorissen's https://github.com/igorissen/angular-link-header-parser.
 * Logging removed.
 */

angular
	.module('blocks')
	.factory('linkHeaderParser', linkHeaderParser);

/* @ngInject */
function linkHeaderParser() {
	var service = {
		parse: parse
	};

	return service;

	////////////////////////////////////////////////////

	/**
	 *
	 * @param linkHeader
	 * @returns {*}
	 */
	function parse(linkHeader) {
		var linkHeaderObject = {};

		if (typeof linkHeader !== 'string') {
			return new Error('Expected a string as parameter type but received: \'' + typeof linkHeader + '\'!');
		}

		if (linkHeader.length === 0) {
			return new Error('Empty string provided!');
		}

		var links = linkHeader.split(',');

		_.forEach(links, function(link) {
			_parseElement(link, linkHeaderObject);
		});

		return linkHeaderObject;
	}

	////////////////////////////////////////////////////

	/**
	 *
	 * @param element
	 * @param object
	 * @private
	 */
	function _parseElement(element, object) {
		var items = element.split(';');

		items[0] = items[0].trim();
		items[1] = items[1].trim();

		object[_parseRelElement(items[1])] = _parseURLElement(items[0]);
	}

	/**
	 *
	 * @param relElement
	 * @returns {*}
	 * @private
	 */
	function _parseRelElement(relElement) {
		var items = relElement.split('=');

		items[1] = items[1].trim().toLowerCase();
		items[1] = items[1].replace(/"/g, '');

		return items[1];
	}

	/**
	 *
	 * @param urlElement
	 * @returns {*|{}}
	 * @private
	 */
	function _parseURLElement(urlElement) {
		urlElement = urlElement.replace(/^</, '').replace(/>$/, '');

		var extracted = URIUtil.parse(urlElement);

		extracted.url = urlElement;

		return extracted;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('AlertFactory', AlertFactory);

AlertFactory.$inject = ['$modal'];

function AlertFactory($modal) {
	return function(message, title, customTemplate) {
		function controller($scope, $modalInstance) {
			$scope.message = message;
			$scope.title = title;

			$scope.ok = function() {
				$modalInstance.close();
			}
		}

		return $modal.open({
			templateUrl: customTemplate || 'core/alertFactory.service.html',
			controller: ['$scope', '$modalInstance', controller]
		});
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('ArrayHelper', ArrayHelper);

ArrayHelper.$inject = [];

function ArrayHelper() {
	var self = this;

	this.findById = function(array, id) {
		var cleandId = parseInt(id);

		if (isNaN(cleandId)) {
			return undefined;
		}

		return array.filter(function(object) {
			return object.id === cleandId
		})[0];
	};

	this.getIndexById = function(array, id) {
		var object = self.findById(array, id);

		return array.indexOf(object);
	};

	this.removeById = function(array, id) {
		var index = self.getIndexById(array, id),
			wasRemoved = false;

		if (index > -1) {
			array.splice(index, 1);

			wasRemoved = true;
		}

		return wasRemoved;
	};

	this.remove = function(array, object) {
		var index = array.indexOf(object);

		if (index > -1) {
			array.splice(index, 1);
		}
	};

	this.pushIfIdIsUnique = function(array, object) {
		if (self.findById(array, object.id) === undefined) {
			array.push(object);

			return true;
		}

		return false;
	};

	this.findByPropertyValue = function(array, property, value) {
		return array.filter(function(object) {
			return object[property] === value
		})[0];
	};

	this.removeByPropertyValue = function(array, property, value) {
		var objectToRemove = self.findByPropertyValue(array, property, value);

		if (objectToRemove !== undefined) {
			var index = array.indexOf(objectToRemove);

			if (index > -1) {
				array.splice(index, 1);
			}
		}
	};

	this.replaceSameId = function(array, object) {
		var index = self.getIndexById(array, object.id);

		if (index > -1) {
			array[index] = object;
			return true;
		}

		return false;
	};

	this.leaveUniqueById = function(array) {
		if (array.length <= 1) {
			return array;
		}

		array.sort(function(a, b) {
			return a.id - b.id;
		});

		for (var i = array.length - 2; i >= 0; i--) {
			if (array[i].id === array[i + 1].id) {
				array.splice(i, 1);
			}
		}

		return array;
	};

	this.pushAll = function(array, newElements) {
		Array.prototype.push.apply(array, newElements);

		return array;
	};

	this.replaceAll = function(array, newElements) {
		array.length = 0;

		return self.pushAll(array, newElements);
	};

	this.contains = function(array, objectId) {
		if (!array) {
			return false;
		}

		return array.indexOf(objectId) > -1;
	};

	this.getObjectIds = function(array) {
		return array.map(function(object) {
			return object.id;
		})
	};

	this.sort = function(array, sortPredicate, reverseOrder) {
		// copied from angular and modified not to change array link

		if (!angular.isArray(sortPredicate)) {
			sortPredicate = [sortPredicate];
		}
		if (sortPredicate.length === 0) {
			sortPredicate = ['+'];
		}

		var predicates = processPredicates(sortPredicate, reverseOrder);
		// Add a predicate at the end that evaluates to the element index. This makes the
		// sort stable as it works as a tie-breaker when all the input predicates cannot
		// distinguish between two elements.
		predicates.push({
			get: function() {
				return {};
			}, descending: reverseOrder ? -1 : 1
		});

		// The next three lines are a version of a Swartzian Transform idiom from Perl
		// (sometimes called the Decorate-Sort-Undecorate idiom)
		// See https://en.wikipedia.org/wiki/Schwartzian_transform
		array.sort(doComparison);
		//array = compareValues.map(function (item) {
		//    return item.value;
		//});

		return array;

		function getComparisonObject(value, index) {
			return {
				value: value,
				predicateValues: predicates.map(function(predicate) {
					return getPredicateValue(predicate.get(value), index);
				})
			};
		}

		function doComparison(v1, v2) {
			var result = 0;
			for (var index = 0, length = predicates.length; index < length; ++index) {
				var predicate = predicates[index];
				result = compare(getPredicateValue(predicate.get(v1)),
					getPredicateValue(predicate.get(v2))) * predicates[index].descending;
				if (result) break;
			}
			return result;
		}
	};

	this.getArrayValues = function(object) {
		if (!object) {
			return [];
		}
		var array = [];
		var keys = Object.keys(object);
		keys.forEach(function(key) {
			array.push(object[key]);
		});
		return array;
	};

	function processPredicates(sortPredicate, reverseOrder) {
		reverseOrder = reverseOrder ? -1 : 1;
		return sortPredicate.map(function(predicate) {
			var descending = 1, get;

			if (angular.isFunction(predicate)) {
				get = predicate;
			} else if (angular.isString(predicate)) {
				if ((predicate.charAt(0) == '+' || predicate.charAt(0) == '-')) {
					descending = predicate.charAt(0) == '-' ? -1 : 1;
					predicate = predicate.substring(1);
				}
				if (predicate !== '') {
					get = function(value) {
						return value[predicate];
					};
				}
			}
			return {get: get, descending: descending * reverseOrder};
		});
	}

	function isPrimitive(value) {
		switch (typeof value) {
			case 'number': /* falls through */
			case 'boolean': /* falls through */
			case 'string':
				return true;
			default:
				return false;
		}
	}

	function objectValue(value, index) {
		// If `valueOf` is a valid function use that
		if (typeof value.valueOf === 'function') {
			value = value.valueOf();
			if (isPrimitive(value)) return value;
		}
		// If `toString` is a valid function and not the one from `Object.prototype` use that
		//if (hasCustomToString(value)) {
		value = value.toString();
		if (isPrimitive(value)) return value;
		//}
		// We have a basic object so we use the position of the object in the collection
		return index;
	}

	function getPredicateValue(value, index) {
		var type = typeof value;
		if (value === null) {
			type = 'string';
			value = 'null';
		} else if (type === 'string') {
			value = value.toLowerCase();
		} else if (type === 'object') {
			value = objectValue(value, index);
		}
		return {value: value, type: type};
	}

	function compare(v1, v2) {
		var result = 0;
		if (v1.type === v2.type) {
			if (v1.value !== v2.value) {
				result = v1.value < v2.value ? -1 : 1;
			}
		} else {
			result = v1.type < v2.type ? -1 : 1;
		}
		return result;
	}
}

})();
(function() {
'use strict';
angular
	.module('community')
	.factory('AuthService', AuthService);

AuthService.$inject = ['$q', 'UserService', '$rootScope', '$http', 'Pusher', '$window', 'AuthSignals', 'PekamaConfig',
	'OrganizationService', 'CommunityProfileService', 'PortalService'];

function AuthService($q, UserService, $rootScope, $http, Pusher, $window, AuthSignals, PekamaConfig,
					 OrganizationService, CommunityProfileService, PortalService) {
	var requireLoginDeferred = $q.defer();
	var requireLoginCallback;

	var USER_CHANNEL_PREFIX = 'private-user-';
	var shownMessages = 0;

	var service = {
		initialize: initialize,
		requireLogin: requireLogin,
		logIn: logIn,
		signUp: signUp,
		sendTwoFactorCode: sendTwoFactorCode,
		resetPassword: resetPassword,
		resendCode: resendCode,
		completePasswordReset: completePasswordReset,
		hideLoginBlock: hideLoginBlock,
		isAuthenticated: isAuthenticated,
		logOut: logOut,
		finishLogin: finishLogin,
		activate: activate,
	};

	return service;

	function initialize() {
		_initGlobalFlags();

		UserService.getCurrent().$promise.then(function(user) {
			_setLoggedInStatus(true);
			_subscribeToConcurrentSessionEvents(user);
		});
	}

	/**
	 * Usage examples:
	 * AuthService.requireLogin(callback) - will wait on the promise returned from the callback before broadcasting
	 *                                      the USER_AUTHENTICATED event.
	 *
	 * AuthService.requireLogin().then(callback) - will broadcast the USER_AUTHENTIACTED event without waiting on any
	 *                                             asynchronous actions in the callback.
	 */
	function requireLogin(callback) {
		requireLoginCallback = callback;
		UserService.getCurrent().$promise.then(function() {
			requireLoginDeferred.resolve();

			_performRequireLoginAction();
		}, function() {
			_showLoginBlock();
		});
		return requireLoginDeferred.promise;
	}

	function logIn(email, password, rememberMe) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/login/', {
			email: email,
			password: password,
			remember_me: rememberMe
		}).then(function(response) {
			var data = response.data;
			if (!data['two_factor']) {
				finishLogin();
			}
			return data;
		});
	}

	function activate(firstName, lastName, password) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/activate/', {
			password: password,
			first_name: firstName,
			last_name: lastName
		}).then(function(response) {
			var data = response.data;
			return data;
		});
	}

	function sendTwoFactorCode(code) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/two_factor_code/', {
			code: code
		}).then(function(response) {
			finishLogin();

			return response;
		});
	}

	function signUp(data) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/signup/', data);
	}

	function resetPassword(resetEmail) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/password_reset/', {
			email: resetEmail
		});
	}

	function resendCode(phoneId, toEmail) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/two_factor_resend/', {
			phone: phoneId,
			to_email: toEmail
		}, function(response) {
			return $q.reject(response);
		});
	}

	function completePasswordReset(data) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/complete_password_reset/', data, function(response) {
			return $q.reject(response);
		});
	}

	function hideLoginBlock() {
		_hideLoginBlock();
	}

	function isAuthenticated() {
		var deferred = $q.defer();
		UserService.getCurrent().$promise.then(deferred.resolve, function() {
			deferred.resolve();
		});
		return deferred.promise;
	}

	function logOut() {
		return UserService.logout(function() {
			$window.location = '/';
		});
	}

	function finishLogin() {
		_setLoggedInStatus(true);
		UserService.updateCurrent().$promise.then(function(user) {
			_subscribeToConcurrentSessionEvents(user);
		});
		requireLoginDeferred.resolve();
		_hideLoginBlock();
		OrganizationService.updatePrimary();
		CommunityProfileService.updateMine();
		PortalService.updateMine();
		_performRequireLoginAction().finally(function() {
			$rootScope.$broadcast(AuthSignals.USER_AUTHENITCATED);
		});
	}

	function _performRequireLoginAction() {
		var callback = requireLoginCallback || angular.noop;

		return $q.when(callback()).finally(function() {
			requireLoginCallback = undefined;
		});
	}

	function _initGlobalFlags() {
		$rootScope.authGlobals = {
			loggedIn: false,
			showLogin: false
		};
	}

	function _showLoginBlock() {
		$rootScope.authGlobals.showLogin = true;
	}

	function _hideLoginBlock() {
		$rootScope.authGlobals.showLogin = false;
	}

	function _setLoggedInStatus(status) {
		$rootScope.authGlobals.loggedIn = status;
	}

	function _subscribeToConcurrentSessionEvents(user) {
		if (!user.remember_me) {
			var userChannel = _getUserChannel(user);

			Pusher.subscribe(userChannel, 'user_logged_in', function() {
				_showMessageAndReload('Looks like you logged in from a different place', 'Concurrent session detected');
			});

			Pusher.subscribe(userChannel, 'user_logged_out', function() {
				_showMessageAndReload('Looks like you logged out from a different place', 'You have been logged out');
			});
		}
	}

	function _getUserChannel(user) {
		return USER_CHANNEL_PREFIX + user.id;
	}

	function _showMessageAndReload(message, title) {
		if (shownMessages > 0) return;

		shownMessages += 1;

		//AlertFactory(message, title).result.finally(function (){
		$window.location.reload();
		//})
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.constant('AuthSignals', {
		USER_AUTHENITCATED: 'userAuthenticated'
	});

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('BaseListService', BaseListServiceFactory);

BaseListServiceFactory.$inject = ['pagination'];

function BaseListServiceFactory(pagination) {
	function BaseListService(resource) {
		this.resource = resource;
		this.listPropertyName = this.listPropertyName || 'objects';
		this.objects = this[this.listPropertyName] = [];
		this.pagination = pagination(1, 10);
		this.params = undefined;
	}

	BaseListService.prototype = {
		init: angular.noop,

		load: function(params) {
			var self = this;

			self.pagination.reset();
			self.params = params;

			self.objects.$initial = true;

			self.onInitialLoad();

			self._load(function() {
				self.objects.length = 0;
			}).finally(function() {
				self.objects.$initial = false;
			});

			return self.objects;
		},

		loadMore: function loadMore() {
			var self = this;

			if (!self.pagination.moreObjectsAvailable) {
				return;
			}

			self.pagination.incrementPage();

			return self._load();
		},

		loadEmpty: function loadEmpty() {
			var self = this;

			self.objects = self[self.listPropertyName] = [];
			self.objects.$resolved = true;

			return self.objects;
		},

		_load: function _load(onResult) {
			var self = this;

			onResult = onResult || angular.noop;

			self.objects.$resolved = false;

			self.objects.$promise = self.resource.query(
				self._getQueryParams(),
				self.pagination.handle
			).$promise.then(function(results) {
				onResult(results);

				[].push.apply(self.objects, results);

				self.onObjectsAdded(results);
				return results;
			}).finally(function() {
				self.objects.$resolved = true;
			});

			return self.objects.$promise;
		},

		onObjectsAdded: angular.noop,

		onInitialLoad: angular.noop,

		_getQueryParams: function _getQueryParams() {
			var self = this;

			return angular.extend({}, self.pagination.getParams(), self.params);
		}
	};

	return BaseListService;
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('BaseRelatedValuesService', BaseRelatedValuesService);

BaseRelatedValuesService.$inject = ['$rootScope', 'ArrayHelper'];

function BaseRelatedValuesService($rootScope, ArrayHelper) {
	function BaseService(resourceClass) {
		this.objects = undefined;

		this._resourceClass = resourceClass;
		this._resourceInstance = undefined;

		$rootScope.$on('primaryOrganization-changed', angular.bind(this, function() {
			this.invalidateCache();
		}));
	}

	BaseService.prototype.getList = getList;
	BaseService.prototype.invalidateCache = invalidateCache;
	BaseService.prototype.createObject = createObject;
	BaseService.prototype.updateObject = updateObject;
	BaseService.prototype.deleteObject = deleteObject;
	BaseService.prototype.findById = findById;
	BaseService.prototype._getResourceInstance = _getResourceInstance;

	return BaseService;

	function getList() {
		var resourceInstance = this._getResourceInstance();

		return resourceInstance.$promise.then(angular.bind(this, function() {
			this.objects = resourceInstance;

			return this.objects;
		}));
	}

	function createObject(model) {
		var self = this;

		return this._resourceClass.save(model).$promise.then(function(savedObject) {
			return self.getList().then(function() {
				ArrayHelper.pushIfIdIsUnique(self.objects, savedObject);

				return savedObject;
			});
		});
	}

	function updateObject(model) {
		var self = this;

		return this._resourceClass.update(model).$promise.then(function(updatedObject) {
			return self.getList().then(function() {
				ArrayHelper.replaceSameId(self.objects, updatedObject);

				return updatedObject;
			});
		});
	}

	function deleteObject(model) {
		var self = this;

		return this._resourceClass.delete(model).$promise.then(function() {
			return self.getList().then(function() {
				ArrayHelper.removeById(self.objects, model.id);
			});
		});
	}

	function invalidateCache() {
		this._resourceInstance = undefined;
	}

	function _getResourceInstance() {
		if (!this._resourceInstance) {
			this._resourceInstance = this._resourceClass.query();
		}

		return this._resourceInstance;
	}

	function findById(id) {
		var self = this;

		return self.getList().then(function() {
			return ArrayHelper.findById(self.objects, id);
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.filter('capitalize', capitalize);

capitalize.$inject = [];

function capitalize() {
	return function(s) {
		return (angular.isString(s) && s.length > 0) ? s[0].toUpperCase() + s.substr(1).toLowerCase() : s;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Classes', Classes);

Classes.$inject = ['$resource', 'PekamaConfig'];

function Classes($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'legal/classifications/:id/:action/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('cmntAnchorScroll', cmntAnchorScroll);


cmntAnchorScroll.$inject = ['$window', '$location'];

function cmntAnchorScroll($window, $location) {
	var document = $window.document;

	function nodeName_(element) {
		return angular.lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}

	function getFirstAnchor(list) {
		var result = null;
		Array.prototype.some.call(list, function(element) {
			if (nodeName_(element) === 'a') {
				result = element;
				return true;
			}
		});
		return result;
	}

	function getYOffset() {

		var offset = scroll.yOffset;

		if (angular.isFunction(offset)) {
			offset = offset();
		} else if (angular.isElement(offset)) {
			var elem = offset[0];
			var style = $window.getComputedStyle(elem);
			if (style.position !== 'fixed') {
				offset = 0;
			} else {
				offset = elem.getBoundingClientRect().bottom;
			}
		} else if (!angular.isNumber(offset)) {
			offset = 0;
		}

		return offset;
	}

	function scrollTo(elem) {
		if (elem) {
			var offset = getYOffset();

			if (offset) {
				var elemTop = elem.getBoundingClientRect().top;
				$window.scrollBy(0, elemTop - offset);
			} else {
				elem.scrollIntoView();
			}
		} else {
			$window.scrollTo(0, 0);
		}
	}

	function scroll(hash) {
		hash = angular.isString(hash) ? hash : angular.isNumber(hash) ? hash.toString() : $location.hash();
		var elm;

		if (!hash) scrollTo(null);

		else if ((elm = document.getElementById(hash))) scrollTo(elm);

		else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);

		else if (hash === 'top') scrollTo(null);
	}

	return scroll;
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.filter('cmntDuration', cmntDuration);

cmntDuration.$inject = [];

function cmntDuration() {
	return function durationFilter(seconds) {
		if (seconds) {
			return moment.duration(seconds, 'seconds').humanize();
		} else {
			return undefined;
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('CollaborationService', CollaborationService);

CollaborationService.$inject = ['$rootScope', 'Collaborators', 'OrganizationService', 'ArrayHelper',
	'collaboratorLevels', '$state'];

function CollaborationService($rootScope, Collaborators, OrganizationService, ArrayHelper,
							  collaboratorLevels, $state) {
	var ORGANIZATION_KEY = 'organization_repr';

	var currentMemobox, currentAccessLevel;

	var collaborations = [],
		organizations = [];

	function getOrganization(collaboration) {
		return collaboration[ORGANIZATION_KEY];
	}

	return {
		resolveCollaborations: function(memoboxId) {
			return Collaborators.query({sub_matter: memoboxId}).$promise.then(function(receivedCollaborations) {
				organizations.length = 0;
				collaborations.length = 0;

				ArrayHelper.pushAll(organizations, receivedCollaborations.map(function(collaboration) {
					return collaboration['organization_repr'];
				}));

				return ArrayHelper.pushAll(collaborations, receivedCollaborations);
			})
		},

		add: function(newCollaboration) {
			var collaboratorAdded = ArrayHelper.pushIfIdIsUnique(collaborations, newCollaboration);

			if (collaboratorAdded) {
				ArrayHelper.pushIfIdIsUnique(organizations, getOrganization(newCollaboration));
				$rootScope.$broadcast('collaborator-created');
			}
		},

		remove: function(collaborationToRemove) {
			var collaboratorRemoved = ArrayHelper.removeById(collaborations, collaborationToRemove.id);

			if (collaboratorRemoved) {
				ArrayHelper.removeById(organizations, getOrganization(collaborationToRemove).id);
				$rootScope.$broadcast('collaborator-removed');
			}
		},

		removeById: function(collaboratorId) {
			var deletedCollaboration = ArrayHelper.findById(collaborations, collaboratorId);

			if (deletedCollaboration) {
				this.remove(deletedCollaboration);
			}
		},

		getOrganization: function(collaboration) {
			return getOrganization(collaboration);
		},

		isPrimary: function(collaboration) {
			if (collaboration && OrganizationService.primary()) {
				return collaboration.organization === OrganizationService.primary().id;
			}
		},

		setMemobox: function(memobox) {
			currentMemobox = memobox;
		},

		getMemobox: function() {
			if ($state.includes('memoboxes.detail')) {
				return currentMemobox;
			}
		},

		setAccessLevel: function(level) {
			currentAccessLevel = parseInt(level) || 0;
		},

		getAccessLevel: function() {
			return currentAccessLevel;
		},

		getMemoboxId: function() {
			return currentMemobox.id;
		},

		getOrganizations: function() {
			return organizations;
		},

		getCollaborations: function() {
			return collaborations;
		},

		getLevelName: function(findLevel) {
			for (var level in collaboratorLevels) {
				if (collaboratorLevels.hasOwnProperty(level)) {
					if (collaboratorLevels[level] === findLevel)
						return level;
				}
			}
		},

		getMemoboxOwner: function() {
			return ArrayHelper.findByPropertyValue(collaborations, 'level', 100);
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Collaborators', Collaborators);

Collaborators.$inject = ['$resource', 'PekamaConfig'];

function Collaborators($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'legal/collaborators/:id/:action/', {id: '@id'}, {
		getRecentOrganizations: {
			params: {action: 'recent_organizations'},
			method: 'GET',
			isArray: true
		},
		searchMemberships: {
			params: {action: 'search_memberships'},
			method: 'GET',
			isArray: true
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('CommunityProfile', CommunityProfileFactory);

CommunityProfileFactory.$inject = ['$resource', 'PekamaConfig'];

function CommunityProfileFactory($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'experts/profiles/:id/:action/', {id: '@id'}, {
		getMine: {
			params: {action: 'my'},
			method: 'GET'
		},
		updateMine: {
			method: 'PUT',
			headers: {'X-HTTP-Method-Override': 'PATCH'}
		},
		removeLogo: {
			params: {action: 'logo'},
			method: 'DELETE'
		},
		invite: {
			params: {action: 'invite'},
			method: 'POST'
		},
		changeRating: {
			method: 'POST',
			params: {
				action: 'change_rating'
			}
		},
		save_expert: {
			method: 'POST',
			params: {
				action: 'save'
			}
		},
		unsave_expert: {
			method: 'DELETE',
			params: {
				action: 'save'
			}
		},
		setRepresentative: {
			method: 'POST',
			params: {action: 'set_representative'}
		},
		casesSent: {
			method: 'GET',
			params: {
				action: 'cases_sent'
			}
		},
		casesReceived: {
			method: 'GET',
			params: {
				action: 'cases_received'
			}
		},
		invitedUsers: {
			method: 'GET',
			params: {
				action: 'invited_users'
			}
		},
		getBySlug: {
			method: 'GET',
			params: {
				action: 'get_by_slug'
			}
		},
		recommend: {
			method: 'POST',
			params: {
				action: 'recommend'
			}
		},
		unrecommend: {
			method: 'DELETE',
			params: {
				action: 'recommend'
			}
		}
	});
}


})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('CommunityProfileService', CommunityProfileService);

CommunityProfileService.$inject = ['$rootScope', 'CommunityProfile'];

function CommunityProfileService($rootScope, CommunityProfile) {
	this.getMine = function() {
		if (!this.hasOwnProperty('mineProfile')) {
			this.mineProfile = CommunityProfile.getMine();
		}

		return this.mineProfile;
	};

	this.updateMine = function(isCreated) {
		var self = this;

		this.mineProfile = CommunityProfile.getMine();
		this.mineProfile.$promise.then(function(profile) {
			_broadcastUpdate(self.mineProfile, isCreated);
		});
		return this.mineProfile;
	};

	this.setRepresentative = function(membershipId) {
		var self = this;

		return self.getMine().$promise.then(function() {
			return CommunityProfile.setRepresentative({
				id: self.mineProfile.id,
				membership: membershipId
			}).$promise.then(function(updatedData) {
				angular.extend(self.mineProfile, updatedData);
				_broadcastUpdate(self.mineProfile, false);
			});
		});
	};

	function _broadcastUpdate(profile, isCreated) {
		$rootScope.$broadcast('communityProfileUpdated', profile, isCreated);
	}
}

})();
(function() {
'use strict';
angular.module('community.core')
	.run(moduleRun)
	.config(setConfig);


moduleRun.$inject = ['$transitions', 'AuthService', 'Navigation'];

function moduleRun($transitions, AuthService, Navigation) {
	AuthService.initialize();
	Navigation.initialize();

	$transitions.onStart({}, function() {
		AuthService.hideLoginBlock();
	});

	var requiresAuthCriteria = {
		to: function(state) {
			return state.data && state.data.authRequired && !(state.data.authAllowInactive || state.data.authAllowReadOnly);
		}
	};

	$transitions.onStart(requiresAuthCriteria, function(transition) {
		return AuthService.isAuthenticated().then(function(user) {
			if (user && user.is_active && !user.is_read_only) {
				return true;
			}
			var $state = transition.router.stateService;
			if (user && user.is_read_only) {
				return $state.target("community.ip.families", undefined, {location: true});
			}
			return $state.target("community.login", undefined, {location: false});
		})
	});

	var requiresAuthCriteriaInactive = {//allow inactive but not readonly
		to: function(state) {
			return state.data && state.data.authRequired && state.data.authAllowInactive && !state.data.authAllowReadOnly;
		}
	};

	$transitions.onStart(requiresAuthCriteriaInactive, function(transition) {
		return AuthService.isAuthenticated().then(function(user) {
			if (user && !user.is_read_only) {
				return true;
			}
			var $state = transition.router.stateService;
			if (user && user.is_read_only) {
				return $state.target("community.ip.families", undefined, {location: true});
			}
			return $state.target("community.login", undefined, {location: false});
		})
	});

	var requiresAuthCriteriaReadOnly = {//allow active readonly or inactive readonly
		to: function(state) {
			return state.data && state.data.authRequired && state.data.authAllowReadOnly;
		}
	};

	$transitions.onStart(requiresAuthCriteriaReadOnly, function(transition) {
		return AuthService.isAuthenticated().then(function(user) {
			if (user && (user.is_active || user.is_read_only)) { //can be not active
				return true;
			}
			var $state = transition.router.stateService;
			return $state.target("community.login", undefined, {location: false});
		})
	});
}


setConfig.$inject = ['$httpProvider', '$locationProvider', 'PekamaConfig'];

function setConfig($httpProvider, $locationProvider, PekamaConfig) {
	$httpProvider.defaults.xsrfCookieName = PekamaConfig.csrfCookieName;
	$httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';

	$locationProvider.html5Mode(true);
}

angular.module('community.core').config(['$resourceProvider', function($resourceProvider) {
	$resourceProvider.defaults.stripTrailingSlashes = false;
}]);

angular.module('community.core').config(['uiSelectConfig', function(uiSelectConfig) {
	uiSelectConfig.theme = 'selectize';
}]);


angular.module('community.core').constant('ToolbarDefaulSet', [
	// ['h1', 'h2', 'h3', 'quote', 'ul', 'ol'],
	// ['bold', 'italics', 'underline'],
	// ['insertImage', 'insertLink']
	//, ['justifyLeft', 'justifyCenter', 'justifyRight']
]);


angular.module('community.core').config(['$provide', function($provide) {
	$provide.decorator('taOptions', [
		'$q', '$timeout', 'taRegisterTool', 'ToolbarDefaulSet', '$delegate',
		function($q, $timeout, taRegisterTool, ToolbarDefaulSet, taOptions) {
			taRegisterTool('insertImageFile', {
				iconclass: "pkm-icon-upload",
				tooltiptext: "Upload image",
				action: function(deferred, restoreSelection) {
					var _editor = this.$editor();
					restoreSelection();
					_editor.$parent.toolbarFileHandler = function(files) {
						if (files && files.length > 0) {
							$q.when(_editor.$parent.fileDropHandler(files[0], _editor.wrapSelection)).then(function() {
								deferred.resolve();
							});
						}
					};
					$timeout(function() {
						$('#editorHiddenInput' + _editor.$parent.editorSerial).click();
					}, 0);
					return false;
				}
			});

			taOptions.toolbar = ToolbarDefaulSet;

			return taOptions;
		}
	]);
	$provide.decorator('taTools', ['$delegate', function(taTools) {
		taTools.bold.iconclass = 'icon icon-bold';
		taTools.italics.iconclass = 'icon icon-italic';
		taTools.underline.iconclass = 'icon icon-underline';
		taTools.ul.iconclass = 'icon icon-list-bullet';
		taTools.ol.iconclass = 'icon icon-list-numbered';
		taTools.undo.iconclass = 'icon icon-undo';
		taTools.redo.iconclass = 'icon icon-repeat';
		taTools.justifyLeft.iconclass = 'icon icon-align-left';
		taTools.justifyRight.iconclass = 'icon icon-align-right';
		taTools.justifyCenter.iconclass = 'icon icon-align-center';
		taTools.clear.iconclass = 'icon icon-ban-circle';
		taTools.insertLink.iconclass = 'icon icon-link';
		taTools.insertImage.iconclass = 'icon icon-picture';
		taTools.quote.iconclass = 'icon icon-quote-right';
		return taTools;
	}]);
}]);


angular.module('community.core').config(['PusherServiceProvider', '$httpProvider', 'PekamaConfig',
	function(PusherServiceProvider, $httpProvider, PekamaConfig) {
		var $cookies;
		angular.injector(['ngCookies']).invoke(['$cookies', function(_$cookies_) {
			$cookies = _$cookies_;
		}]);
		var xcsrf_token = $cookies.get($httpProvider.defaults.xsrfCookieName);

		PusherServiceProvider
			.setToken(PekamaConfig.pusherKey)
			.setOptions({
				authEndpoint: PekamaConfig.pusherAuthEndpoint,
				auth: {
					headers: {
						'X-CSRFToken': xcsrf_token
					}
				}
			});
	}
]);


angular.module('community.core').factory('$exceptionHandler', ['$log', function($log) {
	return function(exception, cause) {
		try {
			// try logging to New Relic if available
			NREUM.noticeError(exception);
		} catch (e) {
			// fallback to browser logging
			$log.error.apply($log, [exception, cause]);

		}
	};
}]);


angular.module('community.core')
	.run(['$rootScope', '$state', 'PekamaConfig', function($rootScope, $state, PekamaConfig) {
		$rootScope.$state = $state;
		$rootScope.conf = PekamaConfig;
	}]);


angular.module('community.core').config(['$provide', function($provide) {
	$provide.decorator("$resource", ['$delegate', function($delegate) {
		return function(url, paramDefaults, defaultActions) {
			return $delegate(url, paramDefaults, angular.extend({
				'update': {
					method: 'PUT',
					headers: {'X-HTTP-Method-Override': 'PATCH'}
				}
			}, defaultActions));
		};
	}]);
}]);


var animationClassNameFilter = /enable-animations/;

angular.module('community.core').config(['$animateProvider', function($animateProvider) {
	$animateProvider.classNameFilter(animationClassNameFilter);
}]);


angular.module('community.core').run(['$animate', function($animate) {
	var origEnabled = $animate.enabled;

	$animate.enabled = function(elem) {
		if (arguments.length !== 1) {
			return origEnabled.apply($animate, arguments)
		} else if (origEnabled(elem)) {
			if (!elem.classList) {
				return false;
			}

			for (var i = 0; i < elem.classList.length; i++) {
				var elemClass = elem.classList[i];

				if (animationClassNameFilter.test(elemClass)) {
					return true;
				}
			}

			return false;
		}

		return false;
	}
}]);


angular.module('community.core').config(['$uiRouterProvider', function($uiRouterProvider) {
	$uiRouterProvider.plugin(window['@uirouter/sticky-states'].StickyStatesPlugin);
}]);


angular.module('community.core')
	.run(['$transitions', '$window', '$location', function($transitions, $window, $location) {
		$transitions.onSuccess({}, function() {
			if (!$window.ga)
				return;

			$window.ga('send', 'pageview', {page: $location.path()});
		});
	}]);


angular.module('community.core')
	.run(['$transitions', '$window', function($transitions, $window) {
		$transitions.onSuccess({}, function(transition) {
			var options = transition.options()['custom'] || {};
			var targetScrollPosition = options.scrollToPosition;

			if (targetScrollPosition !== undefined) {
				$window.scrollTo(0, targetScrollPosition);
			}
		});
	}]);


angular.module('community.core')
	.config(['momentPickerProvider', function(momentPickerProvider) {
		momentPickerProvider.options({
			startView: 'month',
			maxView: 'month',
			locale: "en-gb",
			format: "DD MMM YYYY"
		});
	}]);

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Countries', Countries);

Countries.$inject = ['$resource', 'PekamaConfig'];

function Countries($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'preferences/countries/:id/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('cursorPaginiation', cursorPaginiation);

cursorPaginiation.$inject = ['linkHeaderParser'];

function cursorPaginiation(linkHeaderParser) {
	return function(pageSize) {
		return new CursorPagination(pageSize);
	};

	function CursorPagination(pageSize) {
		var self = this;

		self.pageSize = pageSize;
		self.maxSize = 20;
		self.currentPage = undefined;
		self.moreObjectsAvailable = false;

		this.handle = function(data, headers) {
			var linkHeaderValue = headers('Link'),
				pagination = linkHeaderParser.parse(linkHeaderValue);

			if (pagination.next) {
				self.currentPage = pagination.next.cursor;
			} else {
				self.currentPage = undefined;
			}

			self.moreObjectsAvailable = self.hasMore();
		};

		this.getParams = function() {
			return {
				cursor: self.currentPage,
				page_size: self.pageSize
			}
		};

		this.hasMore = function() {
			return self.currentPage !== undefined;
		};

		this.reset = function() {
			self.currentPage = undefined;
		};

		this.incrementPage = angular.noop;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.filter('cmntDateFormat', cmntDateFormat);

cmntDateFormat.$inject = [];

function cmntDateFormat() {
	return function(date, withTime) {
		if (date) {
			if (withTime) {
				return moment(date).calendar();
			}

			return moment(date).format('L');
		}
	}
}

angular
	.module('community.core')
	.filter('cmntFromNow', cmntFromNow);

cmntFromNow.$inject = [];

function cmntFromNow() {
	return function(date) {
		if (date) {
			return moment(date).fromNow();
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('DefiningService', DefiningService);

DefiningService.$inject = ['Definings', 'BaseRelatedValuesService'];

function DefiningService(Definings, BaseRelatedValuesService) {
	var service = new BaseRelatedValuesService(Definings);

	service.byMatterType = byMatterType;
	service.usedInServices = usedInServices;
	service.usedInTargetJurisdictions = usedInTargetJurisdictions;

	return service;

	// TODO: extract into a mixin
	function byMatterType(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {matter_type: matterTypeId});
		});
	}

	function usedInServices(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {
				matter_type: matterTypeId,
				used_in_services: true
			});
		});
	}

	function usedInTargetJurisdictions(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {
				matter_type: matterTypeId,
				used_in_target_jurisdictions: true
			});
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Definings', Definings);

Definings.$inject = ['$resource', 'PekamaConfig'];

function Definings($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'experts/jurisdictions/:id/:action/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('ExpertiseTypes', ExpertiseTypesFactory);

ExpertiseTypesFactory.$inject = ['$resource', 'BaseRelatedValuesService', 'PekamaConfig'];

function ExpertiseTypesFactory($resource, BaseRelatedValuesService, PekamaConfig) {
	var service = new BaseRelatedValuesService($resource(PekamaConfig.apiBaseUrl + 'experts/expertise_types/:id/:action/', {id: '@id'}));

	service.byMatterType = byMatterType;
	service.usedInServices = usedInServices;

	return service;

	// TODO: extract into a mixin
	function byMatterType(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {matter_type: matterTypeId});
		});
	}

	function usedInServices(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {matter_type: matterTypeId, used_in_services: true});
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('FamilyMember', FamilyMember);

FamilyMember.$inject = ['$resource', 'PekamaConfig'];

function FamilyMember($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'community/family_members/:id/:action/', {id: '@id'}, {
		considerFiling: {
			params: {action: 'filing_status'},
			method: 'POST'
		},
		notFiled: {
			params: {action: 'filing_status'},
			method: 'DELETE'
		},
		setFilingDate: {
			params: {action: 'set_filing_date'},
			method: 'POST'
		},
		setClassesNumber: {
			params: {action: 'set_classes_number'},
			method: 'POST'
		},
		clone: {
			params: {action: 'clone'},
			method: 'POST'
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.filter('filesize', filesize);

filesize.$inject = [];

function filesize() {
	return function(bytes, precision) {
		if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return '-';
		if (parseFloat(bytes) === 0) return '0 byte';
		if (typeof precision === 'undefined') precision = 1;
		var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
			number = Math.floor(Math.log(bytes) / Math.log(1024));
		return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('MatterTypes', MatterTypes);

MatterTypes.$inject = ['$resource', 'BaseRelatedValuesService', 'PekamaConfig'];

function MatterTypes($resource, BaseRelatedValuesService, PekamaConfig) {
	return new BaseRelatedValuesService($resource(PekamaConfig.apiBaseUrl + 'community/matter_types/:id/', {id: '@id'}));
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('MemoboxMembershipsService', MemoboxMembershipsService);

MemoboxMembershipsService.$inject = ['$rootScope', 'ArrayHelper', 'SubMatters'];

function MemoboxMembershipsService($rootScope, ArrayHelper, SubMatters) {
	var memberships = [],
		currentMemoboxId;

	var promise;

	return {
		loadMemberships: function(memoboxId) {
			currentMemoboxId = memoboxId;

			promise = SubMatters.membershipsWithAccess({id: currentMemoboxId}).$promise.then(function(receivedMemberships) {
				memberships.length = 0;

				return ArrayHelper.pushAll(memberships, receivedMemberships);
			});

			return promise;
		},

		getMemberships: function() {
			if (!promise) {
				throw new Error('MemoboxMembershipsService: You must call `loadMemberships(memoboxId)` before calling '
					+ '`getMemberships()`.');
			}

			return promise.then(function(memberships) {
				return memberships;
			});
		},

		reload: function() {
			if (currentMemoboxId === undefined) {
				throw new Error('MemoboxMembershipsService: You must call `loadMemberships(memoboxId)` before calling '
					+ '`reload()`.');
			}

			this.loadMemberships(currentMemoboxId).then(function() {
				$rootScope.$broadcast('memberships-reloaded');
			})
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Navigation', Navigation);

var DEFAULT_STATE_NAME = 'community.about';

Navigation.$inject = ['$state', '$rootScope'];

function Navigation($state, $rootScope) {
	var history = [];

	var service = {
		initialize: initialize,

		go: go,
		back: back
	};

	return service;

	function initialize() {
		$rootScope.Navigation = service;
	}

	function go(state, params, options) {
		history.push({
			state: $state.current.name,
			params: _.omit($state.params, '#')
		});

		return $state.go(state, params, options);
	}

	function back(defaultStateName, options) {
		var previous = _getPreviousState();

		if (previous) {
			return $state.go(previous.state, previous.params, options);
		} else {
			return $state.go(defaultStateName || DEFAULT_STATE_NAME);
		}
	}

	function _getPreviousState() {
		return history.splice(history.length - 1, 1)[0];
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('OopHelpers', OopHelpers);

OopHelpers.$inject = [];

function OopHelpers() {
	return {
		subclass: subclass
	};

	function subclass(child, parent) {
		child.prototype = Object.create(parent.prototype);
		child.prototype.constructor = child;

		return child;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('OrganizationService', OrganizationService);

OrganizationService.$inject = ['Organizations', '$rootScope', 'CommunityProfileService'];

function OrganizationService(Organizations, $rootScope, CommunityProfileService) {
	var self = this;
	this.setPrimary = function(organization) {
		self.primaryOrganization = Organizations.setPrimary({id: organization.id, is_primary: true});
		$rootScope.$broadcast('primaryOrganization-changeStarted');
		self.primaryOrganization.$promise.then(function() {
			self.updateBilling();
			self.updateCurrentMembers();
			CommunityProfileService.updateMine();
			$rootScope.$broadcast('primaryOrganization-changed', self.primaryOrganization);
		})
	};

	this.updateBilling = function() {
		self.billing = Organizations.getBilling();
	};

	this.primary = function() {
		if (!self.hasOwnProperty('primaryOrganization')) {
			self.primaryOrganization = Organizations.getPrimary();
		}

		return self.primaryOrganization;
	};

	this.billingState = function() {
		if (!self.hasOwnProperty('billing')) {
			self.updateBilling();
		}

		return self.billing;
	};

	this.currentMembers = function() {
		if (!self.hasOwnProperty('members')) {
			self.updateCurrentMembers();
		}

		return self.members;
	};

	this.updateCurrentMembers = function() {
		self.members = Organizations.currentMembers();
	};

	this.updatePrimary = function() {
		self.primaryOrganization = Organizations.getPrimary();
		self.updateBilling();
		self.updateCurrentMembers();
		self.primaryOrganization.$promise.then(function() {
			_broadcastUpdate(self.primaryOrganization);
		});
		return self.primaryOrganization
	};

	function _broadcastUpdate(organization) {
		$rootScope.$broadcast('primaryOrganizationUpdated', organization);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('OrganizationMemberships', OrganizationMemberships);

OrganizationMemberships.$inject = ['$resource', 'PekamaConfig'];

function OrganizationMemberships($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'organizations/memberships/:id/:action/?', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('OrganizationRelations', OrganizationRelations);

OrganizationRelations.$inject = ['$resource', 'PekamaConfig'];

function OrganizationRelations($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'organizations/relationships/:id/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('OrganizationTypes', OrganizationTypes);

OrganizationTypes.$inject = ['$resource', 'PekamaConfig'];

function OrganizationTypes($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'organizations/types/:id/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Organizations', Organizations);

Organizations.$inject = ['$resource', 'PekamaConfig'];

function Organizations($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'organizations/organizations/:id/:action/?', {id: '@id'}, {
		currentMembers: {
			params: {action: 'current_members'},
			method: 'GET',
			isArray: true
		},
		getEmailDomain: {
			params: {action: 'get_email_domain'},
			method: 'GET'
		},
		setPrimary: {
			params: {action: 'set_primary'},
			method: 'POST'
		},
		getPrimary: {
			params: {action: 'get_primary'},
			method: 'GET'
		},
		getBilling: {
			url: PekamaConfig.apiBaseUrl + 'billing/current/',
			params: {action: 'get_primary'},
			method: 'GET'
		},
		search: {
			params: {action: 'search'},
			method: 'GET',
			isArray: true
		},
		removeLogo: {
			params: {action: 'logo'},
			method: 'DELETE'
		},
		setStorage: {
			params: {action: 'set_storage'},
			method: 'POST'
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('pagination', PaginationService);

function PaginationService() {
	function Pagination(currentPage, pageSize) {
		var self = this;
		self.currentPage = currentPage;
		self.pageSize = pageSize;
		self.maxSize = 20;
		self.moreObjectsAvailable = false;

		this.handle = function(data, headers) {
			self.totalItems = parseInt(headers('Count'));
			if (self.currentPage == 1) {
				self.itemsPerPage = data.length;
			}
			self.pageTotalItems = data.length;

			self.moreObjectsAvailable = self.hasMore();
		};

		this.getParams = function() {
			return {
				page: self.currentPage,
				page_size: self.pageSize
			}
		};

		this.hasMore = function() {
			return self.currentPage * self.pageSize < self.totalItems
		};

		this.reset = function() {
			self.currentPage = 1;
			self.pageTotalItems = 0;
			self.totalItems = 0;
			self.moreObjectsAvailable = false;
		};

		this.incrementPage = function() {
			self.currentPage += 1;
		};
	}

	return function(currentPage, pageSize) {
		return new Pagination(currentPage, pageSize);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('PortalService', PortalService);

PortalService.$inject = ['$rootScope', '$http', 'PekamaConfig'];

function PortalService($rootScope, $http, PekamaConfig) {
	var self = this;
	this.getMine = function() {
		if (!this.hasOwnProperty('minePortal')) {
			self.updateMine();
		}

		return this.minePortal
	};

	this.updateMine = function() {
		this.minePortal = $http.get(PekamaConfig.apiBaseUrl + 'portals/portal_info/').then(function(response) {
			return response.data;
		});
		return this.minePortal;
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Project', Project);

Project.$inject = ['$resource', 'PekamaConfig'];

function Project($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'enquiries/projects/:id/:action/', {id: '@id'}, {
		cancel: {
			method: 'POST',
			params: {action: 'cancel'}
		},
		unreadMessagesCount: {
			method: 'GET',
			params: {action: 'unread_messages_count'}
		},
		getFacets: {
			params: {action: 'get_facets'},
			method: 'GET',
			isArray: true
		},
		getFilters: {
			params: {action: 'get_filters'},
			method: 'GET',
			isArray: true
		},
		archive: {
			params: {action: 'archive'},
			method: 'POST'
		},
		bulkArchive: {
			params: {action: 'bulk_archive'},
			method: 'POST'
		},
		unarchive: {
			params: {action: 'unarchive'},
			method: 'POST'
		},
		count: {
			params: {action: 'count'},
			method: 'GET',
			isArray: false
		},
		loadNested: {
			params: {action: 'load_nested'},
			method: 'GET'
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('RedirectService', RedirectService);

RedirectService.$inject = [];

function RedirectService() {
	var service = {
		getRedirectPath: getRedirectPath,
		getFullRedirectPath: getFullRedirectPath
	};

	return service;

	function getRedirectPath() {
		return '?next=' + encodeURIComponent(window.location.pathname + window.location.search);
	}

	function getFullRedirectPath() {
		return '?next=' + encodeURIComponent(window.location.href)
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.constant('PekamaConfig', _conf);

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('RestErrors', RestErrors);

RestErrors.$inject = [];

function RestErrors() {
	var NON_FIELD_ERRORS = ['__all__', 'non_field_errors', 'detail'],
		ALL_ERRORS_FIELD = 'non_field_errors',
		DEFAULT_STRING_SEPARATOR = ', ';

	return {
		getFormErrors: getFormErrors,
		asString: asString,
		ALL_ERRORS_FIELD: ALL_ERRORS_FIELD
	};

	function getFormErrors(erroneousResponseBody) {
		/* Flattens erroneous responses from the API so they can be used to display error messages on Angular's forms.
		 *
		 * Accepts a dictionary containing the body of the response and outputs a single-level dicitionary where keys
		 * are dot-separated paths to the fields and values are arrays of strings.
		 */

		return _flattenForForms('', erroneousResponseBody);
	}

	function asString(data, separator) {
		separator = separator || DEFAULT_STRING_SEPARATOR;
		var nonFieldErrorsRepr = '', fieldErrorsRepr = '';

		var flatErrors = _flattenForForms('', data);

		Object.keys(flatErrors).forEach(function(fieldName) {
			var errorsRepr = _getErrorsRepr(flatErrors[fieldName], separator);

			if (fieldName === ALL_ERRORS_FIELD) {
				nonFieldErrorsRepr += errorsRepr;
			} else {
				fieldErrorsRepr += fieldName + ': ' + errorsRepr;
			}
		});

		return nonFieldErrorsRepr + fieldErrorsRepr;
	}

	function _getErrorsRepr(arrayOfErrors, separator) {
		if (_isArrayOfStrings(arrayOfErrors)) {
			return arrayOfErrors.join(separator);
		} else {
			var errorsList = [];

			arrayOfErrors.forEach(function(error) {
				var errorsAsString = _getValues(error).join(separator);

				if (errorsAsString) {
					errorsList.push(errorsAsString);
				}
			});

			return errorsList.join(separator);
		}
	}

	function _flattenForForms(path, erroneousResponseBody) {
		var results = {};

		Object.keys(erroneousResponseBody).forEach(function(fieldName) {
			var value = erroneousResponseBody[fieldName];

			if (NON_FIELD_ERRORS.indexOf(fieldName) > -1) {
				results[ALL_ERRORS_FIELD] = _asArray(value);
			} else if (_isString(value) || _isArrayOfStrings(value)) {
				var fieldPath = path + fieldName;

				results[fieldPath] = value;
			} else {
				angular.extend(results, _flattenForForms(path + fieldName + '.', value));
			}
		});

		return results;
	}

	function _getValues(obj) {
		var values = [];

		Object.keys(obj).forEach(function(key) {
			values.push(obj[key]);
		});

		return values;
	}

	function _isArrayOfStrings(obj) {
		if (_isNonEmptyArray(obj)) {
			// Assumes that if the first element is string than the rest are also strings (which is usually the case for
			// erroneous responses from Pekama API)
			return angular.isString(obj[0]);
		}
	}

	function _isNonEmptyArray(obj) {
		return angular.isArray(obj) && obj.length > 0;
	}

	function _isString(obj) {
		return angular.isString(obj);
	}

	function _isStringOrArray(obj) {
		return angular.isString(obj) || angular.isArray(obj);
	}

	function _asArray(obj) {
		if (!angular.isArray(obj)) {
			return [obj];
		}

		return obj;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('returnToService', returnToService);


returnToService.$inject = [];

function returnToService() {
	return function($transition$) {
		if ($transition$.redirectedFrom() != null) {
			return $transition$.redirectedFrom().targetState();
		}

		var $state = $transition$.router.stateService,
			options = $transition$.options();

		if (options.location === 'replace') {
			return $state.target('community.ip.projects');
		}


		if ($transition$.from().name !== '') {
			if ($transition$.from().name === 'community.about') {
				return $state.target('community.ip.projects');
			}

			return $state.target($transition$.from(), $transition$.params("from"));
		}

		return $state.target('community.ip.projects');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.config(setRoutes);

setRoutes.$inject = ['$urlRouterProvider'];

function setRoutes($urlRouterProvider) {
	$urlRouterProvider.otherwise('/');
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('SignalsService', SignalsService);

SignalsService.$inject = [];

function SignalsService() {
	return function() {
		var signals = {};

		return {
			on: on,
			emit: emit
		};

		function on(signal, callback) {
			if (signals[signal] === undefined) {
				signals[signal] = [];
			}

			signals[signal].push(callback);

			return _.once(function() {
				signals[signal] = _.without(signals[signal], callback);
			});
		}

		function emit(signal) {
			var callbacks = signals[signal],
				params = Array.prototype.splice.call(arguments, 1);

			_.forEach(callbacks, function(callback) {
				callback.apply(undefined, params);
			});
		}
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('Storage', Storage);

Storage.$inject = [];

function Storage() {
	var self = this;

	this.put = function(key, value) {
		if (value !== undefined) {
			localStorage.setItem(key, JSON.stringify(value));
		}
	};

	this.get = function(key) {
		var jsonRepr = localStorage.getItem(key);

		if (jsonRepr !== null) {
			return JSON.parse(jsonRepr);
		}

		return undefined;
	};

	this.remove = function(key) {
		localStorage.removeItem(key);
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.directive('cmntStringToNumber', function() {
		return {
			require: 'ngModel',
			link: function(scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function(value) {
					if (value === null || value === undefined) {
						return value;
					} else {
						return '' + value;
					}
				});

				ngModel.$formatters.push(function(value) {
					return parseFloat(value);
				});
			}
		}
	});

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('SubMatters', SubMatters);

SubMatters.$inject = ['$resource', 'PekamaConfig', 'ReportActions'];

function SubMatters($resource, PekamaConfig, ReportActions) {
	var actions = angular.extend({
		storageTypes: {
			params: {action: 'storage_types'},
			method: 'GET',
			isArray: true
		},
		copy: {
			params: {action: 'copy'},
			method: 'POST'
		},
		related: {
			params: {action: 'related'},
			method: 'GET',
			isArray: true
		},
		access: {
			params: {action: 'access'},
			method: 'GET'
		},
		fetchOfficial: {
			params: {action: 'fetch_official'},
			method: 'GET'
		},
		usersWithAccess: {
			params: {action: 'users_with_access'},
			method: 'GET',
			isArray: true
		},
		membershipsWithAccess: {
			params: {action: 'memberships_with_access'},
			method: 'GET',
			isArray: true
		},
		organizationsWithAccess: {
			params: {action: 'organizations_with_access'},
			method: 'GET',
			isArray: true
		},
		shortcut: {
			params: {action: 'shortcut'},
			method: 'POST'
		},
		createCollaborators: {
			params: {action: 'create_collaborators'},
			method: 'POST'
		},
		bulkArchive: {
			params: {action: 'bulk_archive'},
			method: 'POST'
		},
		removeImage: {
			params: {action: 'image'},
			method: 'DELETE'
		},
		pin: {
			params: {action: 'pin'},
			method: 'POST'
		},
		unpin: {
			params: {action: 'unpin'},
			method: 'POST'
		},
		notes: {
			params: {action: 'notes'},
			method: 'POST'
		}
	}, ReportActions);

	return $resource(PekamaConfig.apiBaseUrl + 'legal/sub_matters/:id/:action/', {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('SupplierConversation', SupplierConversation);

SupplierConversation.$inject = ['$resource', 'PekamaConfig'];

function SupplierConversation($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'enquiries/conversations/:id/:action/', {id: '@id'}, {
		sendInstructions: {
			method: 'POST',
			params: {
				action: 'send_instructions'
			}
		},
		withdrawInstructions: {
			method: 'POST',
			params: {
				action: 'withdraw_instructions'
			}
		},
		confirmInstructions: {
			method: 'POST',
			params: {
				action: 'confirm_instructions'
			}
		},
		completeInstructions: {
			method: 'POST',
			params: {
				action: 'complete_instructions'
			}
		},
		cancel: {
			method: 'POST',
			params: {
				action: 'cancel'
			}
		},
		quote: {
			method: 'POST',
			params: {
				action: 'quote'
			}
		},
		confirmInstructionsRequester: {
			method: 'POST',
			params: {
				action: 'confirm_instructions_requester'
			}
		},
		completeInstructionsRequester: {
			method: 'POST',
			params: {
				action: 'complete_instructions_requester'
			}
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('Testimonial', Testimonial);

Testimonial.$inject = ['$resource', 'PekamaConfig'];

function Testimonial($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'community/testimonials/:id/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.factory('User', UserFactory);

UserFactory.$inject = ['$resource', 'PekamaConfig'];

function UserFactory($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'users/users/:id/:action/', {id: '@id'}, {
		updatePassword: {
			params: {action: 'update_password'},
			method: 'POST'
		},
		current: {
			params: {action: 'current'},
			method: 'GET',
			isArray: false
		},
		logout: {
			params: {action: 'logout'},
			method: 'POST'
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.service('UserService', UserService);

UserService.$inject = ['$rootScope', 'User', '$http', 'PekamaConfig'];

function UserService($rootScope, User, $http, PekamaConfig) {
	// var USER_CHANNEL_PREFIX = 'private-user-';
	//
	// function getUserChannel(user) {
	//     return USER_CHANNEL_PREFIX + user.id;
	// }

	this.getCurrent = function() {
		if (!this.hasOwnProperty('currentUser')) {
			this.currentUser = User.current();
		}

		return this.currentUser;
	};

	this.setCurrent = function(user) {
		this.currentUser = user;

		_broadcastUpdate(this.currentUser);
	};

	this.updateCurrent = function() {
		var self = this;

		this.currentUser = User.current();
		this.currentUser.$promise.then(function(currentUser) {
			_broadcastUpdate(self.currentUser);
		});
		return this.currentUser;
	};

	this.logout = function(callback) {
		return User.logout(callback);
	};

	this.logIn = function(email, password) {
		return $http.post(PekamaConfig.apiBaseUrl + 'users/login/', {
			email: email,
			password: password
		});
	};

	// var shownMessages = 0;
	//
	// function showMessageAndReload(message, title) {
	//     if (shownMessages > 0) return;
	//
	//     shownMessages += 1;
	//
	//     AlertFactory(message, title).result.then(function (){
	//         $window.location.reload();
	//     })
	// }
	//
	// this.getCurrent().$promise.then(function(user) {
	//     var userChannel = getUserChannel(user);
	//
	//     Pusher.subscribe(userChannel, 'user_logged_in', function () {
	//         showMessageAndReload('Looks like you logged in from a different place', 'Concurrent session detected');
	//     });
	//
	//     Pusher.subscribe(userChannel, 'user_logged_out', function () {
	//         showMessageAndReload('Looks like you logged out from a different place', 'You have been logged out');
	//     });
	// });

	function _broadcastUpdate(user) {
		$rootScope.$broadcast('currentUserUpdated', user);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntAssociate', function() {
		return {
			scope: {
				associate: '=',
				extraClass: '@?',
				matterType: '=?',
				activeJurisdictions: '=?',
				onBeforeSelectionChange: '&?',
				onSelectionChange: '&?',
				onRemove: '&?',
				disableNoActiveJurisdictions: '=?',
				isReadOnly: '<?'
			},
			templateUrl: 'experts/associate.directive.html',
			controller: AssociateController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

AssociateController.$inject = ['Associate', '$q', 'DefiningService', 'MatterTypes', 'PekamaConfig', '$timeout'];

function AssociateController(Associate, $q, DefiningService, MatterTypes, PekamaConfig, $timeout) {
	var vm = this;

	vm.allJurisdictions = false;

	var activeJurisdictions = undefined;
	if (vm.activeJurisdictions) {
		activeJurisdictions = _.isArray(vm.activeJurisdictions) ? vm.activeJurisdictions : [vm.activeJurisdictions]
	}

	vm.editing = false;
	vm.readonlyFields = ['email'];
	vm.defaultAvatar = PekamaConfig.staticRoot + 'community/images/default_avatar.png';
	vm.isReadOnly = vm.isReadOnly || false;
	vm.selectable = (vm.onSelectionChange !== undefined) && !vm.isReadOnly;
	vm.deletable = vm.onRemove !== undefined;
	vm.associate.expert_disabled = false;
	vm.cursorInside = false;
	vm.onBeforeSelectionChange = vm.onBeforeSelectionChange || function() {
		return true
	};
	vm.disableNoActiveJurisdictions = vm.disableNoActiveJurisdictions || false;

	vm.edit = edit;

	vm.onEditingFinished = onEditingFinished;
	vm.onEditingCancelled = onEditingCancelled;
	vm.toggleSelection = toggleSelection;
	vm.remove = remove;

	activate();

	function activate() {
		_contentFadeIn();

		if (activeJurisdictions) {
			vm.associate.expert_disabled = !_.some(activeJurisdictions, function(jurisdictionId) {
				return _.contains(vm.associate.jurisdictions, jurisdictionId);
			});
		} else {
			if (vm.disableNoActiveJurisdictions) {
				vm.associate.expert_disabled = true;
			}
		}
		_fillJurisdictions(activeJurisdictions);
	}

	function edit() {
		vm.editing = true;

		vm.editModel = angular.extend({}, vm.associate);
	}

	function onEditingFinished(associate) {
		return Associate.update(associate).$promise.then(function(response) {
			vm.editing = false;

			angular.extend(vm.associate, response);

			_fillJurisdictions(activeJurisdictions);
		}, function(response) {
			return $q.reject(response);
		});
	}

	function onEditingCancelled() {
		vm.editing = false;
	}

	function _fillJurisdictions(activeJurisdictions) {
		DefiningService.getList().then(function(definings) {
			var associateJurisdictions = _.map(vm.associate.jurisdictions, function(jurisdictionId) {
				return _.findWhere(definings, {id: jurisdictionId})
			});
			vm.jurisdictionList = _.map(_.groupBy(associateJurisdictions, 'value'), function(jurisdictions, key) {
				var weight = 1;
				if (activeJurisdictions) {
					var isActiveJurisdiction = _.some(jurisdictions, function(jurisdiction) {
						return _.contains(activeJurisdictions, jurisdiction.id);
					});
					if (isActiveJurisdiction) {
						weight = 0;
					}
				}
				return {
					value: key,
					weight: weight
				};
			});
		});
	}

	function getMatterType() {
		if (vm.matterType) {
			return $q.when(vm.matterType);
		} else {
			return MatterTypes.getList().then(function(list) {
				var patent = _.findWhere(list, {slug: 'patents'});

				return patent.id;
			});
		}
	}

	function toggleSelection(event) {
		if (!vm.selectable || vm.editing) {
			return;
		}

		var changeAllowed = vm.onBeforeSelectionChange();

		if (changeAllowed) {
			vm.associate.selected = !vm.associate.selected;
			vm.onSelectionChange({profile: vm.associate});
		} else if (event) {
			event.preventDefault();
		}
	}

	function remove() {
		vm.onRemove({profile: vm.profile});
	}

	function _contentFadeIn() {
		vm.fadeIn = false;

		$timeout(function() {
			vm.fadeIn = true;
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.factory('Associate', Associate);

Associate.$inject = ['$resource', 'PekamaConfig'];

function Associate($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'experts/associates/:id/:action/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntAssociateForm', function() {
		return {
			scope: {
				associate: '=?',
				onAdd: '&?',
				onCancel: '&?',
				readonlyFields: '=?',
				matterType: '=?',
				saveButtonLabel: '@?',
				extraClass: '@?'
			},
			templateUrl: 'experts/associateForm.directive.html',
			controller: AssociateFormController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

AssociateFormController.$inject = ['DefiningService', '$q', '$upload', 'PekamaConfig', 'MatterTypes'];

function AssociateFormController(DefiningService, $q, $upload, PekamaConfig, MatterTypes) {
	var vm = this;

	vm.associate = vm.associate || {};
	vm.readonlyFields = vm.readonlyFields || [];
	vm.readonlyMapping = {};
	vm.saveButtonLabel = vm.saveButtonLabel || "Add";

	vm.newJurisdiction = undefined;
	vm.pickedJurisdictions = [];
	vm.newAvatarUuid = undefined;

	vm.defaultAvatar = PekamaConfig.staticRoot + 'community/images/default_avatar.png';

	vm.add = add;
	vm.cancel = cancel;
	vm.addJurisdiction = addJurisdiction;
	vm.removeJurisdiction = removeJurisdiction;
	vm.uploadAvatar = uploadAvatar;

	vm.onAdd = vm.onAdd || angular.noop;
	vm.onCancel = vm.onCancel || angular.noop;

	activate();

	function activate() {
		getMatterType().then(function(matterTypeId) {
			DefiningService.byMatterType(matterTypeId).then(function(list) {
				vm.jurisdictions = [];
				vm.pickedJurisdictions = [];

				list.forEach(function(jurisdiction) {
					if (vm.associate.jurisdiction_codes.indexOf(jurisdiction.code) === -1) {
						vm.jurisdictions.push(jurisdiction);
					} else {
						vm.pickedJurisdictions.push(jurisdiction);
					}
				});
			});
		});

		vm.readonlyFields.forEach(function(field) {
			vm.readonlyMapping[field] = true;
		});
	}

	function add(associateForm) {
		vm.associate.jurisdiction_codes = _.pluck(vm.pickedJurisdictions, 'code');

		var result = $q.when(vm.onAdd({associate: vm.associate}));

		return result.then(function() {
			associateForm.clearErrors();
		}, function(response) {
			associateForm.displayErrors(response.data);
		});
	}

	function cancel() {
		vm.onCancel();
	}

	function addJurisdiction() {
		vm.pickedJurisdictions.push(vm.newJurisdiction);

		var idx = vm.jurisdictions.indexOf(vm.newJurisdiction);
		if (idx !== -1) {
			vm.jurisdictions.splice(idx, 1);
		}

		vm.newJurisdiction = undefined;
	}

	function removeJurisdiction(jurisdiction) {
		var idx = vm.pickedJurisdictions.indexOf(jurisdiction);

		vm.jurisdictions.unshift(jurisdiction);

		vm.pickedJurisdictions.splice(idx, 1);
	}

	function uploadAvatar(files) {
		if (files.length > 0) {
			vm.logoErrors = '';

			return $upload.upload({
				file: files[0],
				url: PekamaConfig.apiBaseUrl + 'experts/associate_avatar/'
			}).then(function(response) {
				vm.associate.avatar_uuid = response.data['uuid'];
				vm.associate.avatar_url = response.data['image_160'];
			}, function(response) {
				vm.logoErrors = _returnOrJoin(response.data['file'])
			});

			function _returnOrJoin(arrayOrString) {
				if (arrayOrString.constructor === String) {
					return arrayOrString;
				} else {
					return arrayOrString.join(', ');
				}
			}
		}
	}

	function getMatterType() {
		if (vm.matterType) {
			return $q.when(vm.matterType);
		} else {
			return MatterTypes.getList().then(function(list) {
				var patent = _.findWhere(list, {slug: 'patents'});

				return patent.id;
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.controller('ExpertInstructionsController', ExpertInstructionsController);

ExpertInstructionsController.$inject = ['expert', 'ProjectsList', 'ProjectOrdering', 'currentUser'];

function ExpertInstructionsController(expert, ProjectsList, ProjectOrdering, currentUser) {
	var vm = this;

	vm.ordering = ProjectOrdering.RECENT_ACTIVITY;
	vm.status = 'active';
	vm.direction = 'all';

	vm.expert = expert;
	vm.currentUser = currentUser;

	vm.ProjectsList = ProjectsList;

	vm.filtersChanged = filtersChanged;
	vm.searchChanged = searchChanged;
	vm.archive = archive;
	vm.toggleGrouping = toggleGrouping;
	vm.loadMore = loadMore;

	activate();

	function activate() {
		ProjectsList.groupByFamily = true;

		_loadProjects();
	}

	function filtersChanged(newValues) {
		_loadProjects(newValues);
	}

	function searchChanged() {
		_loadProjects({fulltext: vm.search});
	}

	function archive() {
		ProjectsList.archive().then(function() {
			_loadProjects();
		});
	}

	function loadMore() {
		vm.animateTiles = false;
		vm.loadingMore = {$resolved: false};
		ProjectsList.loadMore().finally(function() {
			vm.loadingMore.$resolved = true;
		});
	}

	function toggleGrouping() {
		vm.animateTiles = false;

		ProjectsList.toggleGrouping();
	}

	function _loadProjects(filterParams) {
		vm.animateTiles = true;

		var queryParams = _getQueryParams(filterParams);

		ProjectsList.load(queryParams);
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		return {
			jurisdiction: ('jurisdiction' in newValues) ? newValues.jurisdiction : vm.jurisdiction,
			jurisdiction__matter_type: ('matterType' in newValues) ? newValues.matterType : vm.matterType,
			direction: ('direction' in newValues) ? newValues.direction : vm.direction,
			status: ('status' in newValues) ? newValues.status : vm.status,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			fulltext: ('fulltext' in newValues) ? newValues.fulltext : vm.fulltext,
			expert: expert.id
		};
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntExpertPlaceholder', function() {
		return {
			scope: {
				checkbox: '=?'
			},
			templateUrl: 'experts/expertPlaceholder.directive.html',
			controller: ExpertPlaceholderController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

ExpertPlaceholderController.$inject = [];

function ExpertPlaceholderController() {
	var vm = this;

	vm.checkbox = vm.checkbox || false;
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.controller('ExpertProfileController', ExpertProfileController);

ExpertProfileController.$inject = ['expert', 'CommunityProfile'];

function ExpertProfileController(expert, CommunityProfile) {
	var vm = this;

	vm.expert = expert;

	activate();

	function activate() {
		vm.casesSent = CommunityProfile.casesSent({id: expert.id});
		vm.casesReceived = CommunityProfile.casesReceived({id: expert.id});
		vm.invitedUsers = CommunityProfile.invitedUsers({id: expert.id});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntExpertProfile', function() {
		return {
			templateUrl: 'experts/expertProfile.directive.html',
			scope: {
				profile: '=',
				extraClass: '@?',
				onBeforeSelectionChange: '&?',
				onSelectionChange: '&?',
				onRemove: '&?',
				activeTarget: '=?',
				activeJurisdictions: '=?',
				disableNoActiveJurisdictions: '=?',
				isReadOnly: '<?'
			},
			controller: CmntExpertProfileController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});


CmntExpertProfileController.$inject = ['DefiningService', 'AuthService', '$q', 'Navigation', '$timeout', 'CommunityProfile'];

function CmntExpertProfileController(DefiningService, AuthService, $q, Navigation, $timeout, CommunityProfile) {
	var vm = this;

	var activeJurisdictions = undefined;
	if (vm.activeJurisdictions) {
		activeJurisdictions = _.isArray(vm.activeJurisdictions) ? vm.activeJurisdictions : [vm.activeJurisdictions]
	}

	vm.isReadOnly = vm.isReadOnly || false;
	vm.selectable = (vm.onSelectionChange !== undefined) && !vm.profile.own_profile && !vm.isReadOnly;
	vm.deletable = vm.onRemove !== undefined;
	vm.profile.expert_disabled = false;
	vm.cursorInside = false;
	vm.allJurisdictions = false;
	vm.allTargets = false;
	vm.onBeforeSelectionChange = vm.onBeforeSelectionChange || function() {
		return true
	};
	vm.disableNoActiveJurisdictions = vm.disableNoActiveJurisdictions || false;

	vm.selectionChanged = toggleSelection;
	vm.save = save;
	vm.unsave = unsave;
	vm.remove = remove;
	vm.viewExpert = viewExpert;
	vm.toggleSelection = toggleSelection;
	vm.recommend = recommend;
	vm.unrecommend = unrecommend;

	activate();

	function activate() {
		_contentFadeIn();

		if (activeJurisdictions) {
			vm.profile.expert_disabled = !_.some(vm.profile.services, function(service) {
				return _.contains(activeJurisdictions, service.jurisdiction);
			});
			if (!vm.profile.expert_disabled) {
				_fillJurisdictions(activeJurisdictions);
			} else {
				_fillJurisdictions();
			}
		} else {
			if (vm.disableNoActiveJurisdictions) {
				vm.profile.expert_disabled = true;
			}
			_fillJurisdictions();
		}

		if (vm.activeTarget) {
			DefiningService.findById(vm.activeTarget).then(function(activeTarget) {
				_fillTargets(activeTarget);
			})
		} else {
			_fillTargets()
		}
	}

	function toggleSelection(event) {
		if (!vm.selectable) {
			return;
		}

		var changeAllowed = vm.onBeforeSelectionChange();

		if (changeAllowed) {
			vm.profile.selected = !vm.profile.selected;
			vm.onSelectionChange({profile: vm.profile});
		} else if (event) {
			event.preventDefault();
		}
	}

	function save() {
		var defer = $q.defer();
		AuthService.requireLogin(function() {
			return vm.profile.$save_expert().then(function() {
				vm.profile.relation = 'saved';
				defer.resolve();
			}, defer.reject);
		});
		return defer.promise;
	}

	function unsave() {
		return vm.profile.$unsave_expert().then(function() {
			vm.profile.relation = undefined;
		});
	}

	function remove() {
		vm.onRemove({profile: vm.profile});
	}

	function recommend() {
		if (!vm.profile.is_recommended) {
			var defer = $q.defer();
			AuthService.requireLogin(function() {
				return CommunityProfile.recommend({id: vm.profile.id}).$promise.then(function(response) {
					vm.profile.recommendations_count = response.count;
					vm.profile.is_recommended = true;
					defer.resolve();
				}, defer.reject);
			});
			return defer.promise;
		}
	}

	function unrecommend() {
		return CommunityProfile.unrecommend({id: vm.profile.id}).$promise.then(function(response) {
			vm.profile.recommendations_count = response.count;
			vm.profile.is_recommended = false;
		});
	}

	function _fillJurisdictions(activeJurisdictions) {
		DefiningService.getList().then(function(definings) {
			var profileJurisdictions = _.map(vm.profile.services, function(service) {
				return _.findWhere(definings, {id: service.jurisdiction})
			});
			vm.jurisdictions = _.map(_.groupBy(profileJurisdictions, 'value'), function(jurisdictions, key) {
				var weight = 1;
				if (activeJurisdictions) {
					var isActiveJurisdiction = _.some(jurisdictions, function(jurisdiction) {
						return _.contains(activeJurisdictions, jurisdiction.id);
					});
					if (isActiveJurisdiction) {
						weight = 0;
					}
				}
				return {
					value: key,
					weight: weight
				};
			});
		});
	}

	function viewExpert() {
		Navigation.go("community.experts.expertsDetail", {expertSlug: vm.profile.slug});
	}

	function _fillTargets(activeTarget) {
		vm.targets = _.map(_.groupBy(vm.profile.target_jurisdictions, 'jurisdiction_value'), function(targets, key) {
			return {
				value: key,
				weight: (activeTarget && activeTarget.value === key) ? 0 : 1
			};
		});
	}

	function _contentFadeIn() {
		vm.fadeIn = false;

		$timeout(function() {
			vm.fadeIn = true;
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntExpertValuesList', function() {
		return {
			templateUrl: 'experts/expertProfileValuesList.directive.html',
			scope: {
				objects: '=',
				showAll: '=?',
				expandable: '=?'
			},
			controller: cmntExpertValuesListController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});


cmntExpertValuesListController.$inject = [];

function cmntExpertValuesListController() {
	var vm = this;

	vm.visibleLimit = visibleLimit;
	vm.showAll = false;
	vm.toggleExpand = toggleExpand;
	vm.expandable = vm.expandable !== false;

	function visibleLimit() {
		if (vm.objects && vm.objects.length <= 5) {
			return 5
		}
		return 4
	}

	function toggleExpand() {
		if (!vm.expandable) {
			return;
		}

		vm.showAll = !vm.showAll;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.controller('ExpertServicesController', ExpertServicesController);

ExpertServicesController.$inject = ['expert', 'ExpertiseTypes', 'MatterTypes', 'DefiningService', 'Wizard',
	'$state', 'Navigation', 'currentUser'];

function ExpertServicesController(expert, ExpertiseTypes, MatterTypes, DefiningService, Wizard,
								  $state, Navigation, currentUser) {
	var vm = this;

	vm.expert = expert;
	vm.currentUser = currentUser;

	vm.startNewCase = startNewCase;

	activate();

	function activate() {
		vm.positivePledges = _.chain(vm.expert.pledge_answers).where({value: true}).sortBy('id').value();

		vm.expert.services.forEach(function(service) {
			_addRepr(service, 'expertise_type_repr', ExpertiseTypes, service.expertise_type);
			_addRepr(service, 'matter_type_repr', MatterTypes, service.matter_type);
			_addRepr(service, 'jurisdiction_repr', DefiningService, service.jurisdiction);
		});
	}

	function startNewCase(service) {
		Wizard.setProfileIds([vm.expert.id]);

		Wizard.saveStateInLocalStorage({
			matterType: service.matter_type,
			definings: [service.jurisdiction],
			expertiseType: service.expertise_type
		});

		Navigation.go('community.wizard');
	}

	function _addRepr(obj, reprPropertyName, dataService, propertyId) {
		dataService.findById(propertyId).then(function(reprObj) {
			obj[reprPropertyName] = reprObj;
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntExpertsChooser', function() {
		return {
			templateUrl: 'experts/expertsChooser.directive.html',
			scope: {
				matterType: '=',
				definings: '=',
				expertiseType: '=',

				excludeProfilesIds: '=',

				onExpertsSelected: '&',

				inputCoverage: '=?'
			},
			controller: ExpertsChooserController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

var UrlParams = {
	PROFILE_IDS: 'chooserIds'
};

ExpertsChooserController.$inject = ['$q', 'ProfilesList', 'ProfileOrdering', 'MatterTypes', 'DefiningService',
	'ExpertiseTypes', '$location', '$window', 'JurisdictionCoverage', 'Associate'];

function ExpertsChooserController($q, ProfilesList, ProfileOrdering, MatterTypes, DefiningService,
								  ExpertiseTypes, $location, $window, JurisdictionCoverage, Associate) {
	var vm = this;

	var idToCode = {};

	vm.showSavedOnly = false;
	vm.selectedProfiles = [];
	vm.selectedAssociates = [];
	vm.selectedExperts = [];
	vm.ordering = ProfileOrdering.MOST_RELEVANT;
	vm.ProfilesList = ProfilesList;
	vm.adding = false;
	vm.associatesExpanded = false;
	vm.membersExpanded = true;

	vm.loadMore = loadMore;
	vm.showSavedOnlyChanged = showSavedOnlyChanged;
	vm.profileSelectionChanged = profileSelectionChanged;
	vm.orderingChanged = orderingChanged;
	vm.unselectAllExperts = unselectAllExperts;
	vm.unselectAllAssociates = unselectAllAssociates;
	vm.addProfilesToCase = addProfilesToCase;
	vm.showAssociateForm = showAssociateForm;
	vm.onAssociateAdded = onAssociateAdded;
	vm.onAddingCanceled = onAddingCanceled;
	vm.toggleAssociates = toggleAssociates;
	vm.toggleMembers = toggleMembers;

	activate();

	function activate() {
		_populateCoverage([], []);
		_loadProfiles();
		_getLabels();

		vm.associates = Associate.query({
			matter_type: vm.matterType,
			jurisdiction: vm.definings,
			exclude_ids: vm.excludeProfilesIds
		});

		vm.associates.$promise.then(function(list) {
			vm.associatesExpanded = list.length > 0;
		});

		$window.scrollTo(0, 0);
	}

	function loadMore() {
		vm.loadingMore = {$resolved: false};

		ProfilesList.loadMore().then(function() {
			_restoreSelection();
		}).finally(function() {
			vm.loadingMore.$resolved = true;
		});
	}

	function showSavedOnlyChanged() {
		_loadProfiles();
	}

	function orderingChanged(newValues) {
		_loadProfiles(newValues);
	}

	function profileSelectionChanged() {
		_fillSelectedProfiles();
	}

	function unselectAllExperts() {
		angular.forEach(vm.profiles, function(profile) {
			profile.selected = false;
		});
		_fillSelectedProfiles();
	}

	function unselectAllAssociates() {
		angular.forEach(vm.associates, function(profile) {
			profile.selected = false;
		});
		_fillSelectedProfiles();
	}

	function addProfilesToCase() {
		var callbackResult = vm.onExpertsSelected({profileIds: vm.selectedProfiles});

		return $q.when(callbackResult);
	}

	function _loadProfiles(newValues) {
		vm.profiles = ProfilesList.load(_getQueryParams(newValues));

		vm.profiles.$promise.then(function() {
			_restoreSelection();
		});
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		return {
			matter_type: vm.matterType,
			jurisdiction: vm.definings,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			relation: vm.showSavedOnly ? 'saved' : undefined,
			exclude_ids: vm.excludeProfilesIds,
			suggested: true
		};
	}

	function _fillSelectedProfiles(skipLocationReplace) {
		var selectedExperts = _getSelectedProfiles(vm.profiles);
		vm.selectedExperts = _.pluck(selectedExperts, 'id');

		var selectedAssociates = _getSelectedProfiles(vm.associates);
		vm.selectedAssociates = _.pluck(selectedAssociates, 'id');

		vm.selectedProfiles = [].concat(vm.selectedExperts, vm.selectedAssociates);

		_populateCoverage(selectedExperts, selectedAssociates);

		if (!skipLocationReplace) {
			$location.search(UrlParams.PROFILE_IDS, vm.selectedProfiles).replace();
		}
	}

	function _getSelectedProfiles(profiles) {
		return _.filter(profiles, {selected: true});
	}

	function _restoreSelection() {
		var searchParams = $location.search();

		var idParams = searchParams[UrlParams.PROFILE_IDS];
		idParams = _.isArray(idParams) ? idParams : [idParams];

		var profileIds = _.map(idParams, function(profileId) {
			return parseInt(profileId);
		});

		$q.all([
			vm.profiles.$promise,
			vm.associates.$promise
		]).then(function() {
			_.forEach(profileIds, function(profileId) {
				var profile = _.findWhere([].concat(vm.profiles, vm.associates), {id: profileId});

				if (profile) {
					profile.selected = true;
				}
			});

			_fillSelectedProfiles(true);
		})
	}

	function _getLabels() {
		return $q.all([
			MatterTypes.findById(vm.matterType),
			DefiningService.getList(),
			ExpertiseTypes.findById(vm.expertiseType)
		]).then(function(args) {
			vm.matterTypeLabel = args[0].title;
			vm.expertiseTypeLabel = args[2] && args[2].value;
			var definings = _.isArray(vm.definings) ? vm.definings : [vm.definings];
			vm.definingsRepr = _.map(definings, function(definingID) {
				return _.findWhere(args[1], {id: definingID})
			});
		})
	}

	function _populateCoverage(profiles, associates) {
		if (!vm.inputCoverage) {
			return;
		}

		vm.jurisdictionCoverage = JurisdictionCoverage.getCoverage(vm.definings, profiles, associates);
		JurisdictionCoverage.extendCoverage(vm.jurisdictionCoverage, vm.inputCoverage);
	}

	function showAssociateForm() {
		DefiningService.byMatterType(vm.matterType).then(function(list) {
			list.forEach(function(defining) {
				idToCode[defining.id] = defining.code;
			});
			vm.newAssociateModel = _initAssociate();
			vm.adding = true;
		});
	}

	function onAssociateAdded(associate) {
		return Associate.save(associate).$promise.then(function(response) {
			vm.adding = false;
			vm.associates.unshift(response);
		}, function(response) {
			return $q.reject(response);
		});
	}

	function onAddingCanceled() {
		vm.adding = false;
	}

	function toggleAssociates() {
		vm.associatesExpanded = !vm.associatesExpanded;
	}

	function toggleMembers() {
		vm.membersExpanded = !vm.membersExpanded;
	}

	function _initAssociate() {
		var associate = {
			jurisdiction_codes: []
		};

		if (vm.definings) {
			var definings = vm.definings;

			if (!angular.isArray(vm.definings)) {
				definings = [vm.definings];
			}

			associate.jurisdiction_codes = definings.map(function(definingId) {
				return idToCode[definingId]
			});
		}

		return associate;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.factory('ExpertsChooserDelegate', ExpertsChooserDelegate);

var UrlParams = {
	CHOOSER_OPEN: 'chooserOpen',
	PROFILE_IDS: 'chooserIds'
};

ExpertsChooserDelegate.$inject = ['$location'];

function ExpertsChooserDelegate($location) {
	return Delegate;

	function Delegate() {
		var service = {
			shown: false,

			show: show,
			hide: hide,
			openIfUrlParamPresent: openIfUrlParamPresent
		};

		return service;

		function show() {
			service.shown = true;

			$location.search(UrlParams.CHOOSER_OPEN, true);
			$location.replace();
		}

		function hide() {
			service.shown = false;

			$location.search(UrlParams.CHOOSER_OPEN, null);
			$location.search(UrlParams.PROFILE_IDS, null);
			$location.replace();
		}

		function openIfUrlParamPresent() {
			var searchParams = $location.search();

			if (searchParams[UrlParams.CHOOSER_OPEN]) {
				service.shown = true;
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.controller('ExpertsDetailController', ExpertsDetailController);

ExpertsDetailController.$inject = ['$scope', 'expert', 'Wizard', 'AuthSignals', 'AuthService', 'CommunityProfile', '$q',
	'Navigation', '$window', 'exchangedCasesCount', 'currentUser'];

function ExpertsDetailController($scope, expert, Wizard, AuthSignals, AuthService, CommunityProfile, $q,
								 Navigation, $window, exchangedCasesCount, currentUser) {
	var vm = this;

	vm.expert = expert;
	vm.exchangedCasesCount = exchangedCasesCount;
	vm.currentUser = currentUser;

	vm.startNewCase = startNewCase;
	vm.save = save;
	vm.unsave = unsave;
	vm.recommend = recommend;
	vm.unrecommend = unrecommend;

	acitvate();

	function acitvate() {
		$window.scrollTo(0, 0);

		var unsubscribe = $scope.$on(AuthSignals.USER_AUTHENITCATED, function() {
			_updateProfile();
		});

		$scope.$on('$destory', function() {
			unsubscribe();
		});
	}

	function startNewCase() {
		Wizard.setProfileIds([vm.expert.id]);

		Navigation.go('community.wizard');
	}

	function save() {
		return AuthService.requireLogin(function() {
			return vm.expert.$save_expert().then(function() {
				vm.expert.relation = 'saved';
			});
		});
	}

	function unsave() {
		return expert.$unsave_expert().then(function() {
			expert.relation = null;
		});
	}

	function recommend() {
		if (!vm.expert.is_recommended) {
			var defer = $q.defer();
			AuthService.requireLogin(function() {
				return CommunityProfile.recommend({id: vm.expert.id}).$promise.then(function(response) {
					vm.expert.recommendations_count = response.count;
					vm.expert.is_recommended = true;
					defer.resolve();
				}, defer.reject);
			});
			return defer.promise;
		}
	}

	function unrecommend() {
		return CommunityProfile.unrecommend({id: vm.expert.id}).$promise.then(function(response) {
			vm.expert.recommendations_count = response.count;
			vm.expert.is_recommended = false;
		});
	}

	function _updateProfile() {
		return CommunityProfile.get({id: expert.id}).$promise.then(function(updatedExpert) {
			angular.extend(expert, updatedExpert);
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.controller('ExpertsDetailHeaderController', ExpertsDetailHeaderController);

ExpertsDetailHeaderController.$inject = ['expert'];

function ExpertsDetailHeaderController(expert) {
	var vm = this;

	vm.expert = expert;
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.controller('ExpertsController', ExpertsController);

ExpertsController.$inject = ['$scope', 'ProfileFiltersDelegate', 'ProfilesList', 'ProfileOrdering', 'AuthService', '$q',
	'Wizard', 'Navigation', 'Associate', 'DefiningService', 'currentUser'];

function ExpertsController($scope, ProfileFiltersDelegate, ProfilesList, ProfileOrdering, AuthService, $q,
						   Wizard, Navigation, Associate, DefiningService, currentUser) {
	var vm = this;

	var idToCode = {};

	vm.matterType = undefined;
	vm.loadingMore = undefined;
	vm.defining = undefined;
	vm.search = '';
	vm.showSavedOnly = false;
	vm.selectedProfiles = [];
	vm.selectedAssociates = [];
	vm.selectedExperts = [];
	vm.ordering = ProfileOrdering.MOST_RELEVANT;
	vm.ProfilesList = ProfilesList;
	vm.adding = false;
	vm.associatesExpanded = false;
	vm.associatesExpandedChanged = false;
	vm.membersExpanded = true;
	vm.currentUser = currentUser;

	vm.loadMore = loadMore;
	vm.filtersChanged = filtersChanged;
	vm.searchChanged = _.debounce(searchChanged, 700);
	vm.showSavedOnlyChanged = showSavedOnlyChanged;
	vm.profileSelectionChanged = profileSelectionChanged;
	vm.onBeforeSelectionChanged = onBeforeSelectionChanged;
	vm.orderingChanged = orderingChanged;
	vm.startNewProject = startNewProject;
	vm.unselectAllExperts = unselectAllExperts;
	vm.unselectAllAssociates = unselectAllAssociates;
	vm.showAssociateForm = showAssociateForm;
	vm.onAssociateAdded = onAssociateAdded;
	vm.onAddingCanceled = onAddingCanceled;
	vm.toggleAssociates = toggleAssociates;
	vm.toggleMembers = toggleMembers;

	activate();

	function activate() {
		$scope.$on('userAuthenticated', function() {
			_loadProfiles();
			_loadAssociates();
		});
	}

	function filtersChanged(newValues) {
		_loadProfiles(newValues);
		_loadAssociates(newValues);
	}

	function loadMore() {
		vm.loadingMore = {$resolved: false};
		ProfilesList.loadMore().finally(function() {
			vm.loadingMore.$resolved = true;
		});
	}

	function showSavedOnlyChanged() {
		_loadProfiles();
	}

	function orderingChanged(newValues) {
		_loadProfiles(newValues);
	}

	function searchChanged() {
		_loadProfiles({q: vm.search});
	}

	function onBeforeSelectionChanged() {
		var unselectedFilter = _getUnselectedFilter();

		if (unselectedFilter) {
			ProfileFiltersDelegate.shakeAndFocus(unselectedFilter);

			return false;
		} else {
			return true;
		}
	}

	function profileSelectionChanged(profile) {
		_fillSelectedProfiles();
	}

	function startNewProject() {
		AuthService.requireLogin(function() {
			Wizard.setProfileIds(angular.copy(vm.selectedProfiles));

			Wizard.saveStateInLocalStorage({
				matterType: vm.matterType,
				definings: [vm.defining],
				expertiseType: vm.expertiseType
			});

			Navigation.go('community.wizard');
		});
	}

	function unselectAllExperts() {
		angular.forEach(vm.profiles, function(profile) {
			profile.selected = false;
		});
		_fillSelectedProfiles();
	}

	function unselectAllAssociates() {
		angular.forEach(vm.associates, function(profile) {
			profile.selected = false;
		});
		_fillSelectedProfiles();
	}

	function _loadProfiles(newValues) {
		vm.profiles = ProfilesList.load(_getQueryParams(newValues));
		vm.selectedExperts.splice(0, vm.selectedExperts.length);
		vm.selectedProfiles.splice(0, vm.selectedProfiles.length);
	}

	function _loadAssociates(newValues) {
		vm.associates = Associate.query(_getAssociatesQueryParams(newValues));

		vm.associates.$promise.then(function(list) {
			if (!vm.associatesExpandedChanged && !vm.associatesExpanded) {
				vm.associatesExpanded = list.length > 0;
			}
		});
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		return {
			matter_type: ('matterType' in newValues) ? newValues.matterType : vm.matterType,
			jurisdiction: ('defining' in newValues) ? newValues.defining : vm.defining,
			target_jurisdiction: ('targetJurisdiction' in newValues) ? newValues.targetJurisdiction : vm.targetJurisdiction,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			relation: vm.showSavedOnly ? 'saved' : undefined,
			q: ('q' in newValues) ? newValues.q : vm.search
		}
	}

	function _getAssociatesQueryParams(newValues) {
		newValues = newValues || {};

		return {
			matter_type: ('matterType' in newValues) ? newValues.matterType : vm.matterType,
			jurisdiction: ('defining' in newValues) ? newValues.defining : vm.defining,
		}
	}

	function _fillSelectedProfiles() {
		vm.selectedExperts = _.pluck(_getSelectedProfiles(vm.profiles), 'id');
		vm.selectedAssociates = _.pluck(_getSelectedProfiles(vm.associates), 'id');
		vm.selectedProfiles = [].concat(vm.selectedExperts, vm.selectedAssociates);
	}

	function _getSelectedProfiles(profiles) {
		return _.filter(profiles, {selected: true});
	}

	function _getUnselectedFilter() {
		if (!vm.matterType) {
			return 'matterType';
		} else if (!vm.defining) {
			return 'defining';
		}
	}

	function showAssociateForm() {
		AuthService.requireLogin(function() {
			if (vm.matterType) {
				DefiningService.byMatterType(vm.matterType).then(function(list) {
					list.forEach(function(defining) {
						idToCode[defining.id] = defining.code;
					});
					vm.newAssociateModel = _initAssociate();
					vm.adding = true;
				});
			} else {
				vm.newAssociateModel = _initAssociate();
				vm.adding = true;
			}
		});
	}

	function onAssociateAdded(associate) {
		return Associate.save(associate).$promise.then(function(response) {
			vm.adding = false;
			vm.associates.unshift(response);
		}, function(response) {
			return $q.reject(response);
		});
	}

	function onAddingCanceled() {
		vm.adding = false;
	}

	function toggleAssociates() {
		vm.associatesExpanded = !vm.associatesExpanded;
		vm.associatesExpandedChanged = true;
	}

	function toggleMembers() {
		vm.membersExpanded = !vm.membersExpanded;
	}

	function _initAssociate() {
		var associate = {
			jurisdiction_codes: []
		};

		if (vm.defining) {
			associate.jurisdiction_codes = [idToCode[vm.defining]];
		}

		return associate;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.factory('JurisdictionCoverage', JurisdictionCoverage);

JurisdictionCoverage.$inject = [];

function JurisdictionCoverage() {
	return {
		getCoverage: getCoverage,
		extendCoverage: extendCoverage
	};

	function getCoverage(jurisdictionsIds, experts, associates) {
		return _.reduce(jurisdictionsIds, function(memo, jurisdictionId) {
			memo[jurisdictionId] = _getExpertsCount(jurisdictionId, experts, associates);

			return memo;
		}, {});
	}

	function _getExpertsCount(jurisdictionId, experts, associates) {
		var count = 0;
		count = count + _.reduce(experts, function(memo, expert) {
			var expertJurisdiction = _.findWhere(expert.services, {jurisdiction: jurisdictionId});

			return memo + (expertJurisdiction !== undefined ? 1 : 0);
		}, 0);
		count = count + _.reduce(associates, function(memo, expert) {
			var expertJurisdiction = _.contains(expert.jurisdictions, jurisdictionId);

			return memo + (expertJurisdiction ? 1 : 0);
		}, 0);
		return count;
	}

	function extendCoverage(dest, source) {
		_.forEach(_.keys(source), function(sourceJurisdictionId) {
			if (sourceJurisdictionId in dest) {
				dest[sourceJurisdictionId] += source[sourceJurisdictionId];
			} else {
				dest[sourceJurisdictionId] = source[sourceJurisdictionId];
			}
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntProfileFilters', function() {
		return {
			templateUrl: 'experts/profileFilters.directive.html',
			scope: {
				matterType: '=',
				defining: '=',
				expertiseType: '=',
				targetJurisdiction: '=',

				onFiltersChanged: '&',

				// Should we pick the first value from the list of values if no defaults provided and there's no
				// previous selection saved in local storage.
				autoSelect: '=?',

				// Is it allowed to clear values in the dropdowns.
				allowClear: '=?',

				extraClass: '@?'
			},
			controller: ProfileFiltersController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});


ProfileFiltersController.$inject = ['MatterTypes', 'DefiningService', 'ExpertiseTypes', '$q'];

function ProfileFiltersController(MatterTypes, DefiningService, ExpertiseTypes, $q) {
	var vm = this;

	vm.autoSelect = vm.autoSelect || false;
	vm.allowClear = vm.allowClear !== false;
	vm.processFiltersChange = processFiltersChange;
	vm.matterTypeChanged = matterTypeChanged;

	activate();

	function activate() {
		_initFilterValues().then(function() {
			vm.onFiltersChanged({newValues: _getFilteringParams()});
		});
	}

	function matterTypeChanged() {
		vm.defining = undefined;
		vm.expertiseType = undefined;
		vm.targetJurisdiction = undefined;

		_loadAndSetDependentValues(vm.matterType, vm.autoSelect).then(function() {
			processFiltersChange();
		})
	}

	function processFiltersChange() {
		var filteringParams = _getFilteringParams();

		vm.onFiltersChanged({newValues: filteringParams});
	}

	function _initFilterValues() {
		var canAutoPick = vm.autoSelect && !vm.matterType;

		return _loadMatterTypes().then(function() {
			if (canAutoPick) {
				vm.matterType = _getIdOfFirstObject(vm.matterTypes);
			}

			if (vm.matterType) {
				return _loadAndSetDependentValues(vm.matterType, canAutoPick);
			}
		})
	}

	function _loadMatterTypes() {
		return MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});
	}

	function _loadAndSetDependentValues(matterType, canAutoPick) {
		return $q.all({
			definings: DefiningService.usedInServices(matterType),
			expertiseTypes: ExpertiseTypes.usedInServices(matterType),
			targetJurisdictions: DefiningService.usedInTargetJurisdictions(matterType)
		}).then(function(values) {
			vm.definings = values.definings;
			vm.expertiseTypes = values.expertiseTypes;
			vm.targetJurisdictions = values.targetJurisdictions;

			if (canAutoPick) {
				vm.defining = _getIdOfFirstObject(vm.definings);
				vm.expertiseType = _getIdOfFirstObject(vm.expertiseTypes);
				vm.targetJurisdiction = _getIdOfFirstObject(vm.targetJurisdictions);
			}
		})
	}

	function _getIdOfSingularObject(values) {
		if (values.length === 1) {
			return values[0].id;
		}
	}

	function _getIdOfFirstObject(values) {
		if (values.length > 0 && values[0] !== undefined) {
			return values[0].id;
		}
	}

	function _getFilteringParams() {
		return {
			matterType: vm.matterType,
			defining: vm.defining,
			expertiseType: vm.expertiseType,
			targetJurisdiction: vm.targetJurisdiction
		};
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.factory('ProfileFiltersDelegate', ProfileFiltersDelegate);

var ID_SELECTOR_PREFIX = '#profileFilters-',
	SHAKE_CLASS = 'shake';

ProfileFiltersDelegate.$inject = ['$timeout'];

function ProfileFiltersDelegate($timeout) {
	return {
		shakeAndFocus: shakeAndFocus
	};

	function shakeAndFocus(fieldName) {
		var element = $(_getSelectorByName(fieldName));

		element.find('input').focus();
		element.removeClass(SHAKE_CLASS);

		$timeout(function() {
			element.addClass(SHAKE_CLASS);

			$timeout(function() {
				element.removeClass(SHAKE_CLASS);
			}, 300);
		});
	}

	function _getSelectorByName(fieldName) {
		return ID_SELECTOR_PREFIX + fieldName;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.constant('ProfileOrdering', {
		MOST_RELEVANT: 'most_relevant',
		COMMUNITY_SCORE: 'community_score'
	});

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntProfileOrdering', function() {
		return {
			scope: {
				ordering: '=',
				onOrderingChanged: '&'
			},
			templateUrl: 'experts/profileOrdering.directive.html',
			controller: ProfileOrderingController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

ProfileOrderingController.$inject = ['ProfileOrdering'];

function ProfileOrderingController(ProfileOrdering) {
	var vm = this;

	vm.orderingOptions = [
		{label: 'Most relevant', value: ProfileOrdering.MOST_RELEVANT},
		{label: 'Community score', value: ProfileOrdering.COMMUNITY_SCORE}
	];
	vm.orderingChanges = orderingChanges;

	function orderingChanges() {
		vm.onOrderingChanged({newValues: {ordering: vm.ordering}});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.factory('ProfilesList', ProfilesList);

ProfilesList.$inject = ['CommunityProfile', 'pagination', '$q'];

function ProfilesList(CommunityProfile, pagination, $q) {
	var DEFAULT_PARAMS = {
		active: true,
		activated: true
	};

	var service = {
		profiles: undefined,
		filterParams: undefined,
		pagination: pagination(1, 10),

		dataChange: false,

		load: load,
		loadMore: loadMore
	};

	return service;

	function load(filterParams) {
		service.filterParams = filterParams;
		service.pagination.reset();

		service.dataChange = true;

		service.profiles = CommunityProfile.query(_getQueryParams(), service.pagination.handle);
		service.profiles.$promise.finally(function() {
			service.dataChange = false;
		});

		return service.profiles;
	}

	function loadMore() {
		if (!service.pagination.moreObjectsAvailable) {
			return $q.when();
		}

		service.pagination.incrementPage();
		service.profiles.$resolved = false;

		return CommunityProfile.query(_getQueryParams(), service.pagination.handle).$promise.then(function(newProfiles) {
			[].push.apply(service.profiles, newProfiles);
		}).finally(function() {
			service.profiles.$resolved = true;
		});
	}

	function _getQueryParams() {
		return angular.extend({}, service.pagination.getParams(), DEFAULT_PARAMS, service.filterParams);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community.experts', {
			url: 'experts',
			templateUrl: 'experts/experts.html',
			abstract: true
		})
		.state('community.experts.expertsList', {
			url: '',
			sticky: true,
			views: {
				"expertsList": {
					templateUrl: 'experts/expertsList.html',
					controller: 'ExpertsController as vm'
				}
			},
			resolve: {
				currentUser: getCurrentUser
			}
		})
		.state('community.experts.expertsDetail', {
			url: '/{expertSlug}',
			views: {
				"expertsDetail": {
					controller: 'ExpertsDetailController as vm',
					templateUrl: 'experts/expertsDetail.html'
				},
				"header@community": {
					controller: 'ExpertsDetailHeaderController as vm',
					templateUrl: 'experts/expertsDetailHeader.html'
				}
			},
			resolve: {
				expert: getExpert,
				exchangedCasesCount: getExchangedCasesCount,
				currentUser: getCurrentUser
			},
			onEnter: expertsDetailEnter
		})
		.state('community.experts.expertsDetail.instructions', {
			url: '/instructions',
			templateUrl: 'experts/expertInstructions.html',
			controller: 'ExpertInstructionsController as vm'
		})
		.state('community.experts.expertsDetail.profile', {
			url: '/profile',
			templateUrl: 'experts/expertProfile.html',
			controller: 'ExpertProfileController as vm'
		})
		.state('community.experts.expertsDetail.services', {
			url: '/services',
			templateUrl: 'experts/expertServices.html',
			controller: 'ExpertServicesController as vm'
		})
}

getExpert.$inject = ['$stateParams', 'CommunityProfile'];

function getExpert($stateParams, CommunityProfile) {
	return CommunityProfile.getBySlug({slug: $stateParams.expertSlug}).$promise;
}


getExchangedCasesCount.$inject = ['UserService', 'Project', 'expert'];

function getExchangedCasesCount(UserService, Project, expert) {
	return UserService.getCurrent().$promise.then(function() {
		return Project.count({expert: expert.id}).$promise;
	}, function() {
		return {count: 0};
	});
}


expertsDetailEnter.$inject = ['$transition$', '$state', 'UserService', 'exchangedCasesCount', 'expert'];

function expertsDetailEnter($transition$, $state, UserService, exchangedCasesCount, expert) {
	var name = $transition$.to().name;

	if (name !== 'community.experts.expertsDetail') {
		return;
	}

	return UserService.getCurrent().$promise.then(function() {
		var noCasesExchanged = exchangedCasesCount.count === 0,
			stateName;

		if (expert.own_profile || noCasesExchanged) {
			stateName = '.services';
		} else {
			stateName = '.instructions';
		}

		return _getTargetState(stateName);
	}, function() {
		return _getTargetState('.services');
	});

	function _getTargetState(targetStateName) {
		return $state.target(targetStateName, $transition$.params('to'), {relative: name});
	}
}


getCurrentUser.$inject = ['UserService'];

function getCurrentUser(UserService) {
	return UserService.getCurrent().$promise.then(function(user) {
		return user
	}, function() {

	});
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.filter('daysFrom', daysFrom);

daysFrom.$inject = [];

function daysFrom() {
	return function(date) {
		return moment().diff(moment(date), 'days');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.controller('GrowNetworkController', GrowNetworkController);

GrowNetworkController.$inject = ['AuthService', 'Wizard', 'MatterTypes', 'DefiningService', 'Navigation', '$q', '$state',
	'CommunityProfileService', 'OrganizationMemberships', 'OrganizationService', 'PctList',
	'CommunityProfile', 'UserService', '$scope', '$stateParams', '$location', '$modal', 'BoostResult',
	'ScoreAction'];

function GrowNetworkController(AuthService, Wizard, MatterTypes, DefiningService, Navigation, $q, $state,
							   CommunityProfileService, OrganizationMemberships, OrganizationService, PctList,
							   CommunityProfile, UserService, $scope, $stateParams, $location, $modal, BoostResult,
							   ScoreAction) {
	var vm = this;

	vm.pagination = PctList.pagination;

	vm.orderingOptions = [
		{label: 'By Relevance', value: ''},
		{label: 'By Deadline', value: '-date'}
	];
	vm.ordering = '';
	vm.searchFields = [
		{label: 'All Fields', value: 'all'},
		{label: 'Title', value: 'title'},
		{label: 'Agents', value: 'agent'},
		{label: 'Applicants', value: 'applicant'},
		{label: 'Inventors', value: 'inventor'},
		{label: 'PCT Number', value: 'app_no'},
		{label: 'WO Number', value: 'pub_no'}
	];
	vm.searchField = 'all';

	vm.ScoreAction = ScoreAction;

	vm.startNewCase = startNewCase;
	vm.referAttorney = referAttorney;
	vm.inviteMember = inviteMember;
	vm.matterTypeChanged = matterTypeChanged;
	vm.pctSearch = pctSearch;
	vm.loadMore = loadMore;
	vm.orderingChanged = orderingChanged;
	vm.newCaseFromSearchResult = newCaseFromSearchResult;
	vm.openBoostModal = openBoostModal;

	activate();

	function activate() {
		MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});

		initUserDependentParams();

		var unsubscribe = $scope.$on('userAuthenticated', function() {
			initUserDependentParams();
		});

		$scope.$on('$destroy', function() {
			unsubscribe();
		});
	}

	function initUserDependentParams() {
		vm.profile = CommunityProfileService.getMine();

		_defaultSearch();
	}

	function matterTypeChanged() {
		vm.defining = undefined;

		_loadAndSetDependentValues(vm.matterType);
	}

	function startNewCase() {
		AuthService.requireLogin(function() {
			Wizard.saveStateInLocalStorage({
				matterType: vm.matterType,
				definings: [vm.defining]
			});

			return Navigation.go('community.wizard');
		})
	}

	function referAttorney(form) {
		return AuthService.requireLogin().then(function() {
			return CommunityProfile.invite({
				email: vm.attorneyEmail,
				message: ""
			}).$promise.then(function() {
				form.clearErrors();

				vm.attorneyEmail = "";
			}, function(response) {
				form.displayErrors(response.data);
			});
		});
	}

	function inviteMember(form) {
		return AuthService.requireLogin().then(function() {
			return OrganizationMemberships.save({email: vm.memberEmail}).$promise.then(function() {
				form.clearErrors();

				vm.memberEmail = "";
			}, function(response) {
				form.displayErrors(response.data);
			});
		});
	}

	function pctSearch() {
		_performSearch();
	}

	function loadMore() {
		PctList.loadMore();
	}

	function orderingChanged() {
		if (!vm.results) {
			return;
		}

		_performSearch();
	}

	function newCaseFromSearchResult(result) {
		AuthService.requireLogin(function() {
			return MatterTypes.getList().then(function(matterTypes) {
				var patent = _.findWhere(matterTypes, {slug: 'patents'});
				if (patent) {
					Wizard.saveStateInLocalStorage({
						matterType: patent.id
					});
				}

				Wizard.setTitle(result.pct_number + ' ' + result.title);
				Wizard.setPct(result);

				return Navigation.go('community.wizard');
			});
		});
	}

	function openBoostModal() {
		_openBoostModal().then(function(result) {
			switch (result) {
				case BoostResult.START_NEW_CASE:
					Wizard.resetWizard();
					$state.go('community.wizard');

					break;
			}
		});
	}

	function _loadAndSetDependentValues(matterType) {
		DefiningService.usedInServices(matterType).then(function(definings) {
			vm.definings = definings;
		});
	}

	function _performSearch() {
		_putQueryInUrl();
		vm.results = _getSearchResults();
		_markRequestInProgress(vm.results);
	}

	function _putQueryInUrl() {
		$location.search('q', vm.query);
		$location.search('field', vm.searchField).replace();
	}

	function _getSearchResults() {
		return PctList.load({
			q: vm.query,
			order: vm.ordering,
			field: vm.searchField
		}, 'pct/search/');
	}

	function _markRequestInProgress(resource) {
		vm.requestInProgress = true;
		resource.$promise.finally(function() {
			vm.requestInProgress = false;
		});
	}

	function _defaultSearch() {
		var queryFromUrl = _getQueryFromUrl();

		if (queryFromUrl) {
			vm.query = queryFromUrl.q;
			vm.searchField = queryFromUrl.field;
			_performSearch();
		} else {
			OrganizationService.primary().$promise.then(function(primaryOrg) {
				vm.query = primaryOrg.title;

				_performSearch();
			});
		}
	}

	function _getQueryFromUrl() {
		if ($stateParams.q) {
			return {
				q: $stateParams.q,
				field: $stateParams.field || 'all'
			}
		}
	}

	function _openBoostModal() {
		return $modal.open({
			templateUrl: 'profile/boost/boost.modal.html',
			controller: 'BoostModalController as vm',
			resolve: {
				currentUser: function() {
					return UserService.getCurrent().$promise;
				}
			}
		}).result;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.factory('PctList', PctList);

PctList.$inject = ['$http', 'pagination', 'PekamaConfig'];

function PctList($http, pagination, PekamaConfig) {
	var url = undefined;

	var service = {
		load: load,
		loadMore: loadMore,
		getCount: getCount,

		results: [],

		pagination: pagination(1, 10),
		params: undefined
	};

	return service;

	function load(params, _url) {
		url = _url || 'pct/search_family/';
		service.pagination.reset();
		service.params = params;

		service.results.$initial = true;

		_load(function() {
			service.results.length = 0;
		}).finally(function() {
			service.results.$initial = false;
		});

		return service.results;
	}

	function loadMore() {
		if (!service.pagination.moreObjectsAvailable) {
			return;
		}

		service.pagination.incrementPage();

		return _load();
	}

	function getCount(params, _url) {
		url = _url || 'pct/search_family/';
		params = angular.extend(_getQueryParams(), params || {});

		return $http.get(PekamaConfig.apiBaseUrl + url, {params: params}).then(function(response) {
			return _getTotal(response);
		});
	}

	function _load(onResult) {
		onResult = onResult || angular.noop;

		var queryParams = _getQueryParams();

		service.results.$resolved = false;

		service.results.$promise = $http.get(PekamaConfig.apiBaseUrl + url, {'params': queryParams}).then(function(response) {
			onResult(response);

			service.results.$total = _getTotal(response) || 0;

			var data = response.data || [];

			[].push.apply(service.results, data);
			service.pagination.handle(data, response.headers);
		}).finally(function() {
			service.results.$resolved = true;
		});

		return service.results.$promise;
	}

	function _getQueryParams() {
		var pagination_params = service.pagination.getParams();
		var params = angular.copy(service.params);

		if (pagination_params.page > 1) {
			delete params['parse_applicants']
		}

		return angular.extend({}, pagination_params, params);
	}

	function _getTotal(response) {
		var countHeader = response.headers('Count');

		if (countHeader) {
			return parseInt(countHeader);
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community.grow', {
			url: 'grow?q&field',
			templateUrl: 'grow/growNetwork.html',
			controller: 'GrowNetworkController as vm',
			params: {
				q: {
					dynamic: true,
					replace: true
				},
				field: {
					dynamic: true,
					replace: true
				}
			}
		})
		.state('community.search', {
			url: 'search?q&field&orderBy',
			views: {
				'': {
					templateUrl: 'grow/pctSearch.html',
					controller: 'PctSearchController as vm'
				},
				header: {
					templateUrl: 'grow/pctSearchHeader.html'
				}
			},
			params: {
				q: {
					dynamic: true,
					replace: true
				},
				field: {
					dynamic: true,
					replace: true
				},
				orderBy: {
					dynamic: true,
					replace: true
				}
			}
		})
		.state('community.trademarkSearch', {
			url: 'trademarkSearch?q',
			views: {
				'': {
					templateUrl: 'grow/trademarkSearch.html',
					controller: 'TrademarkSearchController as vm'
				},
				header: {
					templateUrl: 'grow/pctSearchHeader.html'
				}
			},
			params: {
				q: {
					dynamic: true,
					replace: true
				}
			}
		})
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.controller('PctSearchController', PctSearchController);

PctSearchController.$inject = ['PctList', 'OrganizationService', '$http', '$scope', '$stateParams', '$location', '$q',
	'AuthService', 'PekamaConfig', '$timeout', 'ApplicantStatFactory', 'AgentStatFactory'];

function PctSearchController(PctList, OrganizationService, $http, $scope, $stateParams, $location, $q,
							 AuthService, PekamaConfig, $timeout, ApplicantStatFactory, AgentStatFactory) {
	var vm = this;

	vm.pagination = PctList.pagination;

	vm.orderingOptions = [
		{label: 'By Relevance', value: ''},
		{label: 'By Deadline', value: '-date'}
	];
	vm.ordering = '';
	vm.searchFields = [
		{label: 'All Fields', value: 'all'},
		{label: 'Title', value: 'title'},
		{label: 'Applicants', value: 'applicant'},
		{label: 'Inventors', value: 'inventor'},
		{label: 'Agents', value: 'agent'},
		{label: 'Application Number', value: 'app_no'},
		{label: 'Publication Number', value: 'pub_no'}
	];
	vm.searchField = 'applicant';
	vm.showSaved = true;

	vm.pctSearch = pctSearch;
	vm.loadMore = loadMore;
	vm.orderingChanged = orderingChanged;
	vm.createFamily = createFamily;
	vm.showSavedChanged = showSavedChanged;

	activate();

	function activate() {
		initUserDependentParams();

		var unsubscribe = $scope.$on('userAuthenticated', function() {
			initUserDependentParams();
		});

		$scope.$on('$destroy', function() {
			unsubscribe();
		});
	}

	function initUserDependentParams() {
		_defaultSearch();
	}

	function pctSearch() {
		if (vm.searchField === 'applicant') {
			vm.requestInProgress = true;
			ApplicantStatFactory(vm.query, _performSearch);
		} else if (vm.searchField === 'agent') {
			vm.requestInProgress = true;
			AgentStatFactory(vm.query, _performSearch);
		} else {
			_performSearch();
		}
	}

	function loadMore() {
		PctList.loadMore();
	}

	function orderingChanged() {
		if (!vm.results) {
			return;
		}

		_performSearch();
	}

	function createFamily(pctItem) {ґ
		var defer = $q.defer();
		AuthService.requireLogin(function() {
			return $http.post(PekamaConfig.apiBaseUrl + 'pct/create_family/', {id: pctItem.id}).then(function() {
				pctItem.is_family_saved = true;
				defer.resolve();
			}, defer.reject)
		});
		return defer.promise;
	}

	function showSavedChanged() {
		_performSearch();
	}

	function _performSearch() {
		_putQueryInUrl();
		vm.results = _getSearchResults();
		_markRequestInProgress(vm.results);
	}

	function _putQueryInUrl() {
		var currentParams = $location.search();

		if (currentParams.q !== vm.query || currentParams.field !== vm.searchField) {
			$location.search('q', vm.query);
			$location.search('field', vm.searchField).replace();
		}
	}

	function _getSearchResults() {
		return PctList.load({
			q: vm.query,
			order: vm.ordering,
			field: vm.searchField,
			saveInfo: true,
			hide_saved: !vm.showSaved
		});
	}

	function _markRequestInProgress(resource) {
		vm.requestInProgress = true;
		resource.$promise.finally(function() {
			vm.requestInProgress = false;
		});
	}

	function _defaultSearch() {
		var queryFromUrl = _getQueryFromUrl();

		if (queryFromUrl) {
			vm.query = queryFromUrl.q;
			vm.searchField = queryFromUrl.field;
			vm.ordering = queryFromUrl.orderBy;
			_performSearch();
		} else {
			return OrganizationService.primary().$promise.then(function(primaryOrg) {
				vm.query = primaryOrg.title;

				_performSearch();
			});
		}

		return $q.when();
	}

	function _getQueryFromUrl() {
		if ($stateParams.q) {
			return {
				q: $stateParams.q,
				field: $stateParams.field || 'all',
				orderBy: $stateParams.orderBy || ''
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.directive('cmntTrademarkPane', function() {
		return {
			scope: {
				item: '='
			},
			templateUrl: 'grow/trademarkPane.directive.html',
			controller: TrademarkPaneController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

TrademarkPaneController.$inject = ['PekamaConfig', '$q', '$http', 'AuthService'];

function TrademarkPaneController(PekamaConfig, $q, $http, AuthService) {
	var vm = this;

	vm.createFamily = createFamily;

	activate();

	function activate() {
		vm.flagClass = _getFlagClass();
	}

	function createFamily() {
		var defer = $q.defer();
		AuthService.requireLogin(function() {
			return $http.post(PekamaConfig.apiBaseUrl + 'pct/trademark_fetch/', {
				mark_data: JSON.stringify(vm.item)
			}).then(function() {
				vm.item.is_family_saved = true;
				defer.resolve();
			}, defer.reject)
		});
		return defer.promise;
	}

	function _getFlagClass() {
		if (!vm.item.defining_code) {
			return;
		}

		return 'flag32-' + vm.item.defining_code.toLowerCase();
	}
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.controller('TrademarkSearchController', TrademarkSearchController);

TrademarkSearchController.$inject = ['TrademarksList', 'OrganizationService', '$http', '$scope', '$stateParams', '$location', '$q',
	'AuthService', 'PekamaConfig'];

function TrademarkSearchController(TrademarksList, OrganizationService, $http, $scope, $stateParams, $location, $q,
								   AuthService, PekamaConfig) {
	var vm = this;

	vm.pagination = TrademarksList.pagination;

	vm.pctSearch = pctSearch;
	vm.loadMore = loadMore;
	vm.createFamily = createFamily;

	activate();

	function activate() {
		initUserDependentParams();

		var unsubscribe = $scope.$on('userAuthenticated', function() {
			initUserDependentParams();
		});

		$scope.$on('$destroy', function() {
			unsubscribe();
		});
	}

	function initUserDependentParams() {
		_defaultSearch();
	}

	function pctSearch() {
		_performSearch();
	}

	function loadMore() {
		TrademarksList.loadMore();
	}

	function createFamily(pctItem) {
		var defer = $q.defer();
		AuthService.requireLogin(function() {
			return $http.post(PekamaConfig.apiBaseUrl + 'pct/create_family/', {id: pctItem.id}).then(function() {
				pctItem.is_family_saved = true;
				defer.resolve();
			}, defer.reject)
		});
		return defer.promise;
	}

	function _performSearch() {
		_putQueryInUrl();
		vm.results = _getSearchResults();
		_markRequestInProgress(vm.results);
	}

	function _putQueryInUrl() {
		var currentParams = $location.search();

		if (currentParams.q !== vm.query) {
			$location.search('q', vm.query);
		}
	}

	function _getSearchResults() {
		return TrademarksList.load({
			q: vm.query
		});
	}

	function _markRequestInProgress(resource) {
		vm.requestInProgress = true;

		resource.$promise.finally(function() {
			vm.requestInProgress = false;
		});
	}

	function _defaultSearch() {
		var queryFromUrl = _getQueryFromUrl();

		if (queryFromUrl) {
			vm.query = queryFromUrl.q;

			_performSearch();
		} else {
			return OrganizationService.primary().$promise.then(function(primaryOrg) {
				vm.query = primaryOrg.title;

				_performSearch();
			});
		}

		return $q.when();
	}

	function _getQueryFromUrl() {
		if ($stateParams.q) {
			return {
				q: $stateParams.q
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.grow')
	.factory('TrademarksList', TrademarksList);

TrademarksList.$inject = ['$http', 'pagination', 'PekamaConfig', 'Pusher'];

function TrademarksList($http, pagination, PekamaConfig, Pusher) {
	var SEARCH_ENDPOINT = PekamaConfig.apiBaseUrl + 'pct/trademark_search/';

	var service = {
		load: load,
		loadMore: loadMore,
		getCount: getCount,

		imageUrls: {},

		results: [],

		pagination: pagination(1, 10),
		params: undefined
	};

	init();

	return service;

	function init() {
		Pusher.subscribe('mark-images', 'image_fetched', function(data) {
			var markify_trademark_key = data['markify_trademark_key'];
			var url = data['url'];

			var application = _.findWhere(service.results, {'id': markify_trademark_key});

			service.imageUrls[markify_trademark_key] = url;

			if (application) {
				application.image_url = url;
			}
		});
	}

	function load(params) {
		service.pagination.reset();
		service.params = params;

		service.results.$initial = true;

		_load(function() {
			service.results.length = 0;
		}).finally(function() {
			service.results.$initial = false;
		});

		return service.results;
	}

	function loadMore() {
		if (!service.pagination.moreObjectsAvailable) {
			return;
		}

		service.pagination.incrementPage();

		return _load();
	}

	function getCount(params) {
		params = angular.extend(_getQueryParams(), params || {});

		return $http.get(SEARCH_ENDPOINT, {params: params}).then(function(response) {
			return _getTotal(response);
		});
	}

	function _load(onResult) {
		onResult = onResult || angular.noop;

		var queryParams = _getQueryParams();

		service.results.$resolved = false;

		service.results.$promise = $http.get(SEARCH_ENDPOINT, {'params': queryParams}).then(function(response) {
			onResult(response);

			service.results.$total = _getTotal(response) || 0;

			response.data.forEach(function(item) {
				var imageKey = item.id;

				if (!item.image_url && imageKey in service.imageUrls) {
					item.image_url = service.imageUrls[imageKey];
				}
			});

			[].push.apply(service.results, response.data);
			service.pagination.handle(response.data, response.headers);

			return service.results;
		}).finally(function() {
			service.results.$resolved = true;
		});

		return service.results.$promise;
	}

	function _getQueryParams() {
		return angular.extend({}, service.params, service.pagination.getParams());
	}

	function _getTotal(response) {
		var countHeader = response.headers('Count');

		if (countHeader) {
			return parseInt(countHeader);
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.run(runConfig);

runConfig.$inject = ['FamiliesList'];

function runConfig(FamiliesList) {
	FamiliesList.init();
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community.ip', {
			url: '?q&email&sg&sp_id&direct&lt',  // Fake url parameters so the IP page doesn't take precedence over landing
			templateUrl: 'ip/ip.html'
		})
		.state('community.ip.families', {
			url: 'families?timeframe&ordering',
			templateUrl: 'ip/families/families.html',
			controller: 'FamiliesController as vm',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			}
		})
		.state('community.ip.familiesBudget', {
			url: 'families_budget?timeframe',
			templateUrl: 'ip/families_budget/familiesBudget.html',
			controller: 'FamiliesBudgetController as vm',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			}
		})
		.state('community.ip.tasks', {
			url: 'tasks',
			templateUrl: 'ip/tasks/tasks.html',
			controller: 'TasksController as vm',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			}
		})
		.state('community.ip.oldTasks', {
			url: 'old_tasks',
			templateUrl: 'ip/old_tasks/tasks.html',
			controller: 'OldTasksController as vm',
			data: {
				authRequired: true
			}
		})
		.state('community.ip.projects', {
			url: 'projects',
			templateUrl: 'ip/projects/projects.html',
			controller: 'ProjectsController as vm',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			}
		})
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.factory('Portal', Portal);

Portal.$inject = ['Pusher', '$q', '$http', 'PekamaConfig'];

function Portal(Pusher, $q, $http, PekamaConfig) {
	var CHANNEL_ID_LENGTH = 18;
	var PORTAL_CHANNEL_PREFIX = 'portal-';
	var PORTAL_READY_EVENT = 'portal_ready';
	var portalEndpoint = PekamaConfig.apiBaseUrl + 'portals/portal/';

	return {
		createPortal: createPortal
	};

	function createPortal(email, signature, portalData) {
		var channelName = PORTAL_CHANNEL_PREFIX + makeId(CHANNEL_ID_LENGTH);
		var portalLinkDefer = $q.defer();
		var signedEmail = email + ':' + signature;

		Pusher.subscribe(channelName, PORTAL_READY_EVENT, function() {
			$http.get(portalEndpoint + signedEmail).then(function(response) {
				portalLinkDefer.resolve(response.data.portal_link);
			});
		}).then(function() {
			var postData = {
				signed_email: signedEmail,
				channel_name: channelName
			};

			angular.extend(postData, portalData);

			return $http.post(portalEndpoint, postData);
		});

		return portalLinkDefer.promise;
	}

	function makeId(length) {
		var text = "";
		var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

		for (var i = 0; i < length; i++) {
			text += possible.charAt(Math.floor(Math.random() * possible.length));
		}

		return text;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.filter('cmntFactsListFormat', cmntFactsListFormat);

cmntFactsListFormat.$inject = [];

function cmntFactsListFormat() {
	return function(factsList, dataKey) {
		var results = [];
		angular.forEach(factsList.slice(5), function(fact) {
			results.push('' + fact.doc_count + ' ' + fact[dataKey]);
		});
		return results.join('<br>');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.controller('FullReportModalController', FullReportModalController);


FullReportModalController.$inject = ['company_name', 'from_widget', '$modalInstance', 'ReportRequest', '$saveForm',
	'$scope'];

function FullReportModalController(company_name, from_widget, $modalInstance, ReportRequest, $saveForm,
								   $scope) {
	var vm = this;

	vm.first_name = '';
	vm.last_name = '';
	vm.company_name = company_name;
	vm.email = '';

	vm.requestReport = requestReport;

	function requestReport() {
		var params = {
			first_name: vm.first_name,
			last_name: vm.last_name,
			company_name: vm.company_name,
			email: vm.email,
			type: 'cost_report',
			from_widget: from_widget
		};
		var onSave = ReportRequest.save(params).$promise;

		return $saveForm($scope, onSave, function() {
			$modalInstance.close();
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.directive('cmntGtagClick', cmntGtagClick);

cmntGtagClick.$inject = ['$window'];

function cmntGtagClick($window) {
	function link(scope, element, attrs) {
		element.bind('click', function() {
			if (typeof $window[attrs.cmntGtagClick] === typeof Function) {
				$window[attrs.cmntGtagClick]();
			}
		});
	}

	return {
		restrict: 'A',
		link: link
	}
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.controller('LandingController', LandingController);

LandingController.$inject = ['$q', '$timeout', '$stateParams', 'PekamaConfig', '$http', 'ReportRequest',
	'cmntAnchorScroll', '$modal', 'AlertFactory', 'ApplicantStatFactory', 'PctList', 'isWidget',
	'TrademarksList', 'AgentStatFactory'];

function LandingController($q, $timeout, $stateParams, PekamaConfig, $http, ReportRequest,
						   cmntAnchorScroll, $modal, AlertFactory, ApplicantStatFactory, PctList, isWidget,
						   TrademarksList, AgentStatFactory) {
	var vm = this;

	vm.state = {
		companyName: ''
	};
	vm.searchInProgress = false;
	vm.leadType = undefined;
	vm.showCostPopover = false;
	vm.isSearchQueryDone = false;
	vm.hasResults = false;
	vm.companyName = '';
	vm.reportEmail = '';
	vm.national_report = null;
	vm.validation_report = null;
	vm.families = [];
	vm.trademarks = [];
	vm.pagination = PctList.pagination;
	vm.paginationTrademarks = TrademarksList.pagination;

	vm.applicantStat = {};

	vm.search = search;
	vm.acApplicants = acApplicants;
	vm.setSearchQuery = setSearchQuery;
	vm.submitReport = submitReport;
	vm.requestFullReport = requestFullReport;
	vm.loadMore = loadMore;
	vm.loadMoreTrademarks = loadMoreTrademarks;

	activate();

	function activate() {
		var urlCompanyName = $stateParams.q;

		if (urlCompanyName) {
			vm.state.searchQuery = urlCompanyName;
			search();
		}
	}

	var searchField = 'applicant';

	function _search() {
		var reportsPromise = $http.get(PekamaConfig.apiBaseUrl + 'pct/search_deadline_reports/', {
			params: {
				q: vm.state.searchQuery,
				field: searchField
			}
		});

		var _families = PctList.load({
			q: vm.state.searchQuery,
			field: searchField
		});


		var _trademarks = $q.when();
		if (!isWidget) {
			_trademarks = TrademarksList.load({q: vm.state.searchQuery});
		}

		var promise = $q.all([reportsPromise, _families.$promise, _trademarks.$promise]).then(function(resolves) {
			vm.isSearchQueryDone = true;
			vm.families = PctList.results;
			vm.reports = resolves[0].data;
			vm.trademarks = TrademarksList.results;
			vm.hasDeadlines = vm.reports.national !== null || vm.reports.validation !== null;
			vm.hasResults = vm.hasDeadlines || vm.families.length !== 0 || vm.trademarks.length !== 0;
			vm.national_report = vm.reports.national;
			// _calcTotalBudgets(vm.national_report);
			vm.validation_report = vm.reports.validation;
			// _calcTotalBudgets(vm.validation_report);
			$timeout(function() {
				cmntAnchorScroll.yOffset = 20;
				cmntAnchorScroll('search-results');
			})
		});
		return promise;
	}

	function search() {
		vm.applicants = null;
		vm.national_report = null;
		vm.validation_report = null;
		vm.families = [];
		vm.trademarks = [];
		vm.companyName = vm.state.searchQuery;

		vm.applicantStat = {};

		if (isWidget) {
			return ApplicantStatFactory(vm.companyName, _search, vm.applicantStat).promise
		}

		var _applicantStat = $http.get(PekamaConfig.apiBaseUrl + 'pct/applicants_stat/', {
			params: {
				q: vm.companyName,
				put_to_queue: true,
				skip_facts: true
			}
		});

		var _agentStat = $http.get(PekamaConfig.apiBaseUrl + 'pct/agents_stat/', {
			params: {
				q: vm.companyName,
				put_to_queue: true,
				skip_facts: true
			}
		});

		return $q.all([_applicantStat, _agentStat]).then(function(resolves) {
			var applicantStatData = resolves[0].data;
			var agentStatData = resolves[1].data;

			if (agentStatData.official_count > applicantStatData.official_count) {
				searchField = 'agent';
				return AgentStatFactory(vm.companyName, _search, vm.applicantStat).promise
			}

			searchField = 'applicant';
			return ApplicantStatFactory(vm.companyName, _search, vm.applicantStat).promise
		});
	}

	function loadMore() {
		return PctList.loadMore();
	}

	function loadMoreTrademarks() {
		return TrademarksList.loadMore();
	}

	function _calcTotalBudgets(report) {
		if (report !== null) {
			var symbol = null;
			var price = 0;
			var hasTotal = false;
			angular.forEach(report.report.prices, function(priceData) {
				if (priceData.price) {
					symbol = priceData.symbol;
					price += parseInt(priceData.price.replace(/,/g, ''));
					hasTotal = true;
				}
			});
			report.report.$total = {
				symbol: symbol,
				price: price,
				hasTotal: hasTotal
			}
		}
	}


	var inputChangedPromise;
	var acApplicantsDeferred = $q.defer();
	var isFirstAc = true;

	function acApplicants($event) {
		acApplicantsDeferred.reject('CANCELLED');
		acApplicantsDeferred = $q.defer();

		if (!vm.state.searchQuery || $event.keyCode === 13) {
			acApplicantsDeferred.reject('CANCELLED');
			vm.applicants = null;
			return;
		}

		if (inputChangedPromise) {
			$timeout.cancel(inputChangedPromise);
		}

		inputChangedPromise = $timeout(function() {
			vm.applicants = null;
			var promise = $http.get(PekamaConfig.apiBaseUrl + 'pct/applicants_ac/', {
				params: {
					text: vm.state.searchQuery
				}
			});
			promise.then(acApplicantsDeferred.resolve, acApplicantsDeferred.reject);
			acApplicantsDeferred.promise.then(function(response) {
				vm.applicants = response.data;
				if (isFirstAc) {
					isFirstAc = false;
					$timeout(function() {
						cmntAnchorScroll.yOffset = 300;
						cmntAnchorScroll('ac-applicants');
					})
				}
			})
		}, 500);
	}

	function setSearchQuery(applicant) {
		vm.state.searchQuery = applicant;
		vm.applicants = null;
		search();
	}

	function submitReport(emailAddress, form) {
		var params = {email: emailAddress, type: 'cost_report', company_name: vm.companyName, from_widget: isWidget};

		return ReportRequest.save(params).$promise.then(function() {
			form.clearErrors();
			AlertFactory('Thank you! We will be in touch shortly.', '');
		}, function(response) {
			form.displayErrors(response.data);
		});
	}

	function requestFullReport() {
		return $modal.open({
			templateUrl: 'landing/fullReport.modal.html',
			controller: 'FullReportModalController as vm',
			resolve: {
				company_name: function() {
					return vm.companyName;
				},
				from_widget: function() {
					return isWidget
				}
			}
		}).result.then(function() {
			AlertFactory('Thank you! We will be in touch shortly.', '');
		});
	}

}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.directive('cmntPriceData', function() {
		return {
			scope: {
				priceData: '<'
			},
			templateUrl: 'landing/priceData.directive.html',
			controller: PriceDataController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

PriceDataController.$inject = ['$timeout'];

function PriceDataController($timeout) {
	var vm = this;

	vm.state = 'analysing';
	var min = 700;
	var max = 1000;

	function getRandomInt(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}

	$timeout(function() {
		vm.state = 'comparing';
		$timeout(function() {
			vm.state = 'price';
		}, getRandomInt(min, max))
	}, getRandomInt(min, max))
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.factory('ReportRequest', ReportRequest);

ReportRequest.$inject = ['$resource', 'PekamaConfig'];

function ReportRequest($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'community/report_requests/:id/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community.landing', {
			url: 'landing?q&email&sg&sp_id&direct&lt',
			templateUrl: 'templates/landing.html',
			controller: 'LandingController as vm',
			onEnter: ['AuthService', '$state', function(AuthService, $state) {
				return AuthService.isAuthenticated().then(function(isAuthenticated) {
					if (isAuthenticated)
						return $state.target("community.ip.projects", {replace: true});
				});
			}],
			resolve: {
				isWidget: function() {
					return false
				}
			}

		})
		.state('community.landing_widget', {
			url: 'landing_widget?q',
			views: {
				'': {
					templateUrl: 'landing/landing_widget.html',
					controller: 'LandingController as vm'
				},
				header: {}
			},
			resolve: {
				isWidget: function() {
					return true
				}
			}
		})
}

})();
(function() {
'use strict';
angular
	.module('community.landing')
	.directive('cmntSearchAffix', function() {
		return {
			scope: {},
			controller: SearchAffixController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

SearchAffixController.$inject = ['$scope', '$element', '$window', 'hlStickyElement'];

function SearchAffixController($scope, $element, $window, hlStickyElement) {
	var stickyElement = hlStickyElement($element);
	var windowEl = angular.element($window);

	function draw(options) {
		var opt = options || {};
		var offset = opt.offset || {};
		offset.zIndex = 1000;
		opt.offset = offset;
		stickyElement.draw(opt);
	}

	var lastWidth = windowEl.width();

	function resize() {
		var currentWidth = windowEl.width();

		if (lastWidth !== currentWidth) {
			draw({force: true});

			lastWidth = currentWidth;
		}
	}

	var throttledResize = _.throttle(resize, 250, {leading: false});

	windowEl.on('scroll', draw);
	windowEl.on('resize', throttledResize);

	$scope.$on('$destroy', function() {
		stickyElement.destroy();

		windowEl.off('scroll', draw);
		windowEl.off('resize', throttledResize);
	});
}

})();
(function() {
'use strict';
angular
	.module('community.layout')
	.directive('cmntHeader', cmntHeader);

cmntHeader.$inject = ['CommunityProfileService', 'UserService', 'AuthService', 'OrganizationService'];

function cmntHeader(CommunityProfileService, UserService, AuthService, OrganizationService) {
	return {
		link: function(scope, element, attrs) {
			var $toggle = element.find('.header__nav-toggle'),
				$headerNav = element.find('.header-nav'),
				expanded = false;

			function collapse() {
				$headerNav.removeClass('header-nav_expanded');
				element.removeClass('header_expanded');
				expanded = false;
			}

			function expand() {
				$headerNav.addClass('header-nav_expanded');
				element.addClass('header_expanded');
				expanded = true;
			}

			$toggle.click(function(event) {
				if (expanded) collapse();
				else expand();
				event.stopPropagation();
			});

			$(window).click(function() {
				if (expanded) collapse();
			});

			scope.profile = CommunityProfileService.getMine();

			scope.profile.$promise.then(function(profile) {
				if (!profile.is_active) {
					scope.$on('communityProfileUpdated', function() {
						CommunityProfileService.getMine().$promise.then(function(profile) {
							scope.profile = angular.copy(profile);
						});
					});
				}
			});

			scope.currentUser = UserService.getCurrent();

			scope.$on('currentUserUpdated', function() {
				scope.currentUser = UserService.getCurrent();
			});

			scope.logOut = function() {
				return scope.currentUser.$promise.then(function() {
					return AuthService.logOut();
				});
			};

			AuthService.isAuthenticated().then(function(isAuthenticated) {
				if (isAuthenticated) {
					OrganizationService.primary().$promise.then(function(primaryOrganization) {
						scope.headerLogo = primaryOrganization.logo_140;
					})
				}
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.layout')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community', {
			url: '/',
			abstract: true,
			templateUrl: 'layout/main.html'
		})
}

})();
(function() {
'use strict';
angular
    .module('community.login')
    .directive('cmntSignInPrompt', function () {
        return {
            scope: {
                nextState: '=?',
                invitationEmail: '=?',
                invitationCode: '=?',
                redirectUrl: '=?'
            },
            templateUrl: 'login/cmntSignInPrompt.directive.html',
            controller: SignInPromptController,
            controllerAs: 'vm',
            bindToController: true
        }
    });

var LoginScreens = {
    LOGIN: "login",
    TWO_FACTOR: "twoFactor",
    RESET_PASSWORD: "resetPassword"
};

var TwoFactorErrors = {
    MAX_ATTEMPTS_EXCEEDED: 'max_attempts_exceeded',
    EXPIRED: 'expired'
};

SignInPromptController.$inject = ['AuthService', '$state', 'OrganizationRelations', 'OrganizationTypes', 'PekamaConfig',
    'Countries', '$window', '$timeout'];

function SignInPromptController(AuthService, $state, OrganizationRelations, OrganizationTypes, PekamaConfig,
                                Countries, $window, $timeout) {
    var vm = this;

    vm.LoginScreens = LoginScreens;

    vm.logIn = logIn;
    vm.sendTwoFactorCode = sendTwoFactorCode;
    vm.showLoginForm = showLoginForm;
    vm.showResetPasswordForm = showResetPasswordForm;
    vm.resetPassword = resetPassword;
    vm.signUp = signUp;
    vm.resendCode = resendCode;
    vm.loginViaAzure = loginViaAzure;

    vm.twoFactorCode = '';
    vm.email = '';
    vm.resetEmail = '';
    vm.password1 = '';
    vm.password2 = '';
    vm.password = '';
    vm.newEmail = '';
    vm.newPassword = '';
    vm.firstName = '';
    vm.lastName = '';
    vm.company = '';
    // vm.companyType = undefined;
    // vm.companyRel = undefined;
    // vm.phone = '';
    // vm.companyCountry = undefined;
    vm.rememberMe = false;
    vm.agreeToTou = false;

    vm.companyTypes = undefined;
    vm.companyRels = undefined;
    vm.backupPhones = [];
    vm.mainPhone = undefined;
    vm.passwordRules = PekamaConfig.passwordRules;
    vm.termsOfUseUrl = PekamaConfig.termsOfUseUrl;

    vm.loginScreen = LoginScreens.LOGIN;
    vm.twoFactorFailed = false;
    vm.signUpFinished = false;
    vm.passwordResetFinished = false;

    vm.accountType = undefined;
    vm.accountTypes = [
        {value: 'ipo', label: 'IP Firm'},
        {value: 'ipl', label: 'IP Lawyer'}
    ];

    activate();

    function activate() {
        vm.focusSignup = true;
        vm.newEmail = vm.invitationEmail;

        if (_isInvitation()) {
            vm.isInvitation = true;
        } else if (!vm.invitationEmail) {
            vm.focusSignup = false;
        }

        // vm.companyTypes = OrganizationTypes.query({common: true});
        // vm.companyRels = OrganizationRelations.query({common: true});
        // vm.countries = Countries.query();
    }

    function logIn(form) {
        return AuthService.logIn(vm.email, vm.password, vm.rememberMe).then(function (loginParams) {
            form.clearErrors();

            if (loginParams['two_factor']) {
                vm.twoFactorCode = '';
                vm.twoFactorFailed = false;
                vm.backupPhones = loginParams['backup_phones'];
                vm.mainPhone = loginParams['main_phone'];
                vm.loginScreen = LoginScreens.TWO_FACTOR;
            } else {
                _goToNextState();
            }
        }, function (response) {
            form.displayErrors(response.data);
        });
    }

    function sendTwoFactorCode(form) {
        return AuthService.sendTwoFactorCode(vm.twoFactorCode).then(function () {
            form.clearErrors();

            _goToNextState();
        }, function (response) {
            form.displayErrors(response.data);

            var reason = response.data['reason'];

            if ([TwoFactorErrors.MAX_ATTEMPTS_EXCEEDED, TwoFactorErrors.EXPIRED].indexOf(reason) > -1) {
                vm.email = '';
                vm.password = '';
                vm.twoFactorFailed = true;
            }
        });
    }

    function resetPassword(form) {
        return AuthService.resetPassword(vm.resetEmail).then(function () {
            form.clearErrors();

            vm.passwordResetFinished = true;
        }, function (response) {
            form.displayErrors(response.data);
        });
    }

    function signUp(form) {
        var signUpData = {
            email: vm.newEmail,
            password: vm.newPassword,
            first_name: vm.firstName,
            last_name: vm.lastName,
            company: vm.company,
            account_type: vm.accountType
            // company_type: vm.companyType,
            // company_rel: vm.companyRel,
            // phone_number: vm.phone,
            // company_country: vm.companyCountry
        };

        if (_isInvitation()) {
            angular.extend(signUpData, {invitation: vm.invitationCode})
        }

        vm.signupInProgress = true;
        return AuthService.signUp(signUpData).then(function () {
            form.clearErrors();

            vm.signUpFinished = true;

            if (_isInvitation()) {
                AuthService.finishLogin();
                _goToNextState();
            }
        }, function (response) {
            form.displayErrors(response.data);
        }).finally(function () {
            vm.signupInProgress = false;
        });
    }

    function resendCode(backupPhone, form, toEmail) {
        return AuthService.resendCode(backupPhone ? backupPhone.id : undefined, toEmail).catch(function (response) {
            form.displayErrors(response.data);
        });
    }

    function showLoginForm() {
        vm.loginScreen = LoginScreens.LOGIN;
    }

    function showResetPasswordForm() {
        vm.loginScreen = LoginScreens.RESET_PASSWORD;
    }

    function _goToNextState() {
        if (vm.nextState) {
            var state = vm.nextState.state();
            var params = vm.nextState.params();
            var options = angular.extend({}, vm.nextState.options(), {reload: true});
            $state.go(state, params, options);
        } else if (vm.redirectUrl) {
            $window.location.href = vm.redirectUrl;
        }
    }

    function _isInvitation() {
        return vm.invitationEmail && vm.invitationCode;
    }

    function loginViaAzure() {
        var popup = $window.open(PekamaConfig.azureAdLoginUrl + "?next=/accounts/social/popup/", 'azuread',
            'width=600,height=400');

        function _checkPopupClosed() {
            $timeout(function () {
                if (popup.closed) {
                    AuthService.finishLogin();
                    _goToNextState();
                } else
                    _checkPopupClosed();
            }, 1000)
        }

        _checkPopupClosed();
    }
}

})();
(function() {
'use strict';
angular
	.module('community.login')
	.controller('LoginController', LoginController);

LoginController.$inject = ['returnTo', '$stateParams', '$location'];

function LoginController(returnTo, $stateParams, $location) {
	var vm = this;

	activate();

	function activate() {
		vm.invitationEmail = $stateParams.email;
		vm.invitationCode = $stateParams.invitation;

		if ($stateParams.next) {
			vm.nextState = undefined;
			vm.redirectUrl = $stateParams.next;
		} else {
			vm.nextState = returnTo;
		}

		if (vm.invitationEmail || vm.invitationCode) {
			$location.search({});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.login')
	.controller('PasswordResetCompleteController', PasswordResetCompleteController);

PasswordResetCompleteController.$inject = ['AuthService', '$stateParams', '$state'];

function PasswordResetCompleteController(AuthService, $stateParams, $state) {
	var vm = this;

	vm.password1 = '';
	vm.password2 = '';
	vm.reset = reset;

	function reset(form) {
		return AuthService.completePasswordReset({
			password1: vm.password1,
			password2: vm.password2,
			uidb64: $stateParams.uidb64,
			token: $stateParams.token
		}).then(function() {
			$state.go('community.login', {}, {location: "replace"});
		}, function(response) {
			form.displayErrors(response.data);
		})
	}
}

})();
(function() {
'use strict';
angular
	.module('community.login')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	$stateProvider
		.state('community.landingLogin', {
			url: '',
			templateUrl: 'login/login.html',
			controller: 'LoginController as vm',
			resolve: {returnTo: returnTo},
			reloadOnSearch: false,
			onEnter: ['AuthService', '$state', function(AuthService, $state) {
				return AuthService.isAuthenticated().then(function(isAuthenticated) {
					if (isAuthenticated)
						return $state.target("community.ip.projects", {replace: true});
				});
			}]
		})
		.state('community.login', {
			url: 'login?invitation&next&email',
			templateUrl: 'login/login.html',
			controller: 'LoginController as vm',
			resolve: {returnTo: returnTo},
			reloadOnSearch: false
		})
		.state('community.completePasswordReset', {
			url: 'passwordResetComplete/{uidb64}/{token}',
			templateUrl: 'login/passwordResetComplete.html',
			controller: 'PasswordResetCompleteController as vm',
			reloadOnSearch: false
		})
		.state('community.passwordResetInvalid', {
			url: 'passwordResetInvalid',
			templateUrl: 'login/passwordResetInvalid.html'
		})
}

returnTo.$inject = ['returnToService', '$transition$'];

function returnTo(returnToService, $transition$) {
	return returnToService($transition$);
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.directive('cmntAttachmentsList', function() {
		return {
			scope: {
				service: '=',
				editable: '=?'
			},
			templateUrl: 'messaging/attachmentsList.directive.html',
			controller: AttachmentsListController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

AttachmentsListController.$inject = [];

function AttachmentsListController() {
	var vm = this;

	vm.editable = vm.editable !== false;

	vm.UploadService = vm.service;
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.directive('cmntCcMyEmail', function() {
		return {
			scope: {},
			templateUrl: 'messaging/ccMyEmail.directive.html',
			controller: CcMyEmailController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

CcMyEmailController.$inject = ['MessagingSettings'];

function CcMyEmailController(MessagingSettings) {
	var vm = this;

	vm.ccMeChanged = ccMeChanged;

	activate();

	function activate() {
		vm.messagingSettings = MessagingSettings.query();
	}

	function ccMeChanged() {
		return MessagingSettings.save({
			copy_me: vm.messagingSettings.copy_me
		}).$promise;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.filter('collaboratorLevel', collaboratorLevel);

collaboratorLevel.$inject = ['collaboratorLevels', 'CollaborationService'];

function collaboratorLevel(collaboratorLevels, CollaborationService) {
	return function(memobox, requiredRole) {
		var requiredLevel = collaboratorLevels[requiredRole.toUpperCase()] || 0,
			currentUserLevel = CollaborationService.getAccessLevel();

		return currentUserLevel >= requiredLevel;
	};
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.constant('collaboratorLevels', {
		OWNER: 100,
		ADMIN: 50,
		COLLABORATOR: 30,
		VIEWER: 10
	});

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.directive('pkmTeamColoredBox', ['$timeout', function($timeout) {
		return {
			restrict: 'A',
			scope: {
				organization: '=pkmTeamColoredBox'
			},
			link: function(scope, element, attrs) {
				function stringToColor(str) {
					for (var i = 0, hash = 0; i < str.length; hash = str.charCodeAt(i++) + ((hash << 5) - hash)) ;

					// int/hash to hex
					for (var i = 0, colour = "#"; i < 3; colour += ("00" + ((hash >> i++ * 8) & 0xFF).toString(16)).slice(-2)) ;

					return colour;
				}

				$timeout(function() {
					if (scope.organization) {
						var color = stringToColor(scope.organization.title);
						element.css('color', color).css('border-color', color);
					}
				});
			}
		}
	}]);

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('ConversationService', ConversationService);

var WsEvents = {
	MESSAGE_CREATED: 'message_created',
	MESSAGE_ARCHIVED: 'message_archived',
	RECEIPT_STATUS: 'receipt_status',
	RECEIPT_STATUSES: 'receipt_statuses'
};

ConversationService.$inject = ['Messages', 'Pusher', 'cursorPaginiation', '$q'];

function ConversationService(Messages, Pusher, cursorPaginiation, $q) {
	var convChannelPromise;

	var service = {
		messages: undefined,
		pagination: cursorPaginiation(10),

		load: load,
		loadMore: loadMore,
		addMessage: addMessage,
		postMessage: postMessage,
		removeMessage: removeMessage,
		markRead: markRead,
		cleanup: cleanup
	};

	return service;

	function load(filterParams) {
		service.filterParams = filterParams;
		service.pagination.reset();

		service.messages = Messages.query(_getQueryParams(), service.pagination.handle);

		convChannelPromise = _subscribeToWsEvents(filterParams.conversation);

		return service.messages;
	}

	function cleanup() {
		if (convChannelPromise) {
			_unsubscribeFromWsEvents(convChannelPromise);
		}
	}

	function loadMore() {
		if (!service.pagination.moreObjectsAvailable) {
			return;
		}

		service.pagination.incrementPage();
		service.messages.$resolved = false;
		return Messages.query(
			_getQueryParams(),
			service.pagination.handle
		).$promise.then(function(newMessages) {
			Array.prototype.push.apply(service.messages, newMessages);
		}).finally(function() {
			service.messages.$resolved = true;
		});
	}

	function postMessage(text, files) {
		return Messages.save({
			html: text,
			conversation: service.filterParams.conversation,
			uploaded_files: files
		}).$promise;
	}

	function markRead(message) {
		message.is_read = true;

		return Messages.markRead({
			id: message.id
		}).$promise;
	}

	function addMessage(message) {
		_addMessage(message);
	}

	function removeMessage(message) {
		return message.$archive().then(function() {
			var idx = service.messages.indexOf(message);

			if (idx > -1) {
				service.messages.splice(idx, 1);
			}
		});
	}

	function _subscribeToWsEvents(conversationId) {
		var channelName = "conversation-" + conversationId;

		Pusher.subscribe(channelName, WsEvents.MESSAGE_CREATED, _onMessageCreated);
		Pusher.subscribe(channelName, WsEvents.MESSAGE_ARCHIVED, _onMessageArchived);
		Pusher.subscribe(channelName, WsEvents.RECEIPT_STATUS, _onReceiptStatus);
		return Pusher.subscribe(channelName, WsEvents.RECEIPT_STATUSES, _onReceiptStatuses);
	}

	function _unsubscribeFromWsEvents(channelPromise) {
		channelPromise.then(function(channel) {
			channel.unbind(WsEvents.MESSAGE_CREATED);
			channel.unbind(WsEvents.MESSAGE_ARCHIVED);
			channel.unbind(WsEvents.RECEIPT_STATUS);
			channel.unbind(WsEvents.RECEIPT_STATUSES);
		})
	}

	function _addMessage(message) {
		service.messages.unshift(message);
	}

	function _getQueryParams() {
		return angular.extend({}, service.pagination.getParams(), service.filterParams);
	}

	function _onMessageCreated(data) {
		var messageId = data.id;

		service.messages.$promise.then(function() {
			var duplicate = _.findWhere(service.messages, {id: messageId});

			if (!duplicate) {
				Messages.get({id: messageId}).$promise.then(function(message) {
					service.messages.unshift(message);
				});
			}
		});
	}

	function _onMessageArchived(data) {
		var messageId = data.id;

		service.messages.$promise.then(function() {
			var existingMessage = _.findWhere(service.messages, {id: messageId});

			if (existingMessage) {
				var idx = service.messages.indexOf(existingMessage);

				if (idx > -1) {
					service.messages.splice(idx, 1);
				}
			}
		});
	}

	function _onReceiptStatus(data) {
		var affectedMessages = _.filter(service.messages, {id: data.message_id});

		service.messages.$promise.then(function() {
			_updateMessageReceipts(affectedMessages);
		});
	}


	function _onReceiptStatuses(data) {
		var affectedMessages = _.filter(service.messages, function(message) {
			return data.message_ids.indexOf(message.id) > -1;
		});

		service.messages.$promise.then(function() {
			_updateMessageReceipts(affectedMessages);
		});
	}

	function _updateMessageReceipts(messages) {
		messages.forEach(function(message) {
			$q.when(message.$promise || message).then(function() {
				Messages.get({id: message.id}).$promise.then(function(updatedMessage) {
					message.is_read = updatedMessage.is_read;
					message.receipts = updatedMessage.receipts;
				});
			});
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('Conversations', Conversations);

Conversations.$inject = ['$resource', 'PekamaConfig'];

function Conversations($resource, PekamaConfig) {
	var actions = angular.extend({
		follow: {
			params: {action: 'follow'},
			method: 'POST'
		},
		unfollow: {
			params: {action: 'unfollow'},
			method: 'POST'
		},
		archive: {
			method: 'POST',
			params: {action: 'archive'}
		},
		partialUpdate: {
			method: 'PATCH'
		},

		pin: {
			params: {action: 'pin'},
			method: 'POST'
		},
		unpin: {
			params: {action: 'unpin'},
			method: 'POST'
		},
		subject_placeholders: {
			params: {action: 'subject_placeholders'},
			method: 'GET',
			isArray: true
		},
		preview_subject_template: {
			params: {action: 'preview_subject_template'},
			method: 'POST'
		},
		save_subject_template: {
			params: {action: 'save_subject_template'},
			method: 'POST'
		},
		save_subject: {
			params: {action: 'save_subject'},
			method: 'POST'
		}
	});

	return $resource(PekamaConfig.apiBaseUrl + 'messages/conversations/:id/:action/', {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.directive('pkmFollowersPicker', function() {
		return {
			scope: {
				followers: '=',
				object: '=?',
				performAdd: '&',
				performRemove: '&',
				searchCollaborators: '='
			},
			templateUrl: 'messaging/followersPicker.directive.html',
			controller: FollowersPickerController
		}
	});

FollowersPickerController.$inject = ['$q', '$timeout', 'ArrayHelper', 'CollaborationService', 'MemoboxMembershipsService',
	'SubMatters', 'Collaborators', 'collaboratorLevels', '$scope', 'OrganizationService'];

function FollowersPickerController($q, $timeout, ArrayHelper, CollaborationService, MemoboxMembershipsService,
								   SubMatters, Collaborators, collaboratorLevels, $scope, OrganizationService) {
	$scope.uiState = {
		followerSearch: '',
		askForEmail: false,
		addingInProgress: false
	};

	$scope.$watchCollection('followers', function(newValue, oldValue) {
		if (!newValue || !newValue.$resolved) {
			return;
		}

		OrganizationService.primary().$promise.then(function(primaryOrg) {
			$scope.nonMemberFollowers = _.filter(newValue, function(follower) {
				if (follower.membership_repr) {
					return follower.membership_repr.organization.id !== primaryOrg.id;
				}

				return true;
			});
		});
	});

	function getMembershipsIdsFromFollowers(followers) {
		return followers.map(function(follower) {
			return follower.membership;
		});
	}

	var membershipsWithAccess;

	function updateMembershipsWithAccess() {
		MemoboxMembershipsService.getMemberships().then(function(memberships) {
			membershipsWithAccess = memberships;
		});
	}

	updateMembershipsWithAccess();

	$scope.$on('memberships-reloaded', function() {
		updateMembershipsWithAccess();
	});

	function isNewCollaborator(membership, membershipsWithAccess) {
		var found = ArrayHelper.findById(membershipsWithAccess, membership.id);

		return found === undefined;
	}

	$scope.addMembership = function(membership) {
		if ($scope.uiState.addingInProgress === true) {
			return;
		}

		setAddingInProgress();
		var followerModel = {
			membership: membership.id,
			membership_repr: membership
		};

		return MemoboxMembershipsService.getMemberships().then(function(membershipsWithAccess) {
			followerModel.$isNewCollaborator = isNewCollaborator(membership, membershipsWithAccess);

			var promise = $scope.performAdd({follower: followerModel}).then(function(follower) {
				if (follower) {
					ArrayHelper.pushIfIdIsUnique($scope.followers, follower);
				} else {
					$scope.followers.push(followerModel);
				}

				$scope.uiState.followerSearch = '';
			});
			promise.finally(unsetAddingInProgress);
			return promise
		})
	};

	$scope.removeFollower = function(follower) {
		$scope.performRemove({follower: follower}).then(function() {
			ArrayHelper.remove($scope.followers, follower);

			var membership = follower['membership_repr'];
			if (membership) {
				ArrayHelper.remove(($scope.defaultOrganizationIds || []), membership.organization.id);
			}
		});
	};

	function validateEmail(email) {
		var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
		return re.test(email);
	}

	function askForEmail(input) {
		return $q(function(resolve, reject) {
			if (validateEmail(input)) {
				resolve(input)
			} else {
				$scope.uiState.askForEmail = true;
				$scope.uiState.emailInput = '';
				$scope.confirmEmail = function() {
					$scope.uiState.askForEmail = false;
					if (validateEmail($scope.uiState.emailInput)) {
						resolve($scope.uiState.emailInput);
					} else {
						reject();
					}
				};
				$scope.cancelEmail = function() {
					$scope.uiState.askForEmail = false;
					reject();
				};
			}

		});
	}

	$scope.confirmEmail = function() {
		$scope.uiState.askForEmail = false;
	};

	$scope.cancelEmail = function() {
		$scope.uiState.askForEmail = false;
	};

	$scope.addEmail = function(input, invite) {
		if ($scope.uiState.addingInProgress === true) {
			return;
		}
		return askForEmail(input).then(function(email) {
			$scope.uiState.askForEmail = false;

			var emailModel = {
				email: email,
				invite: invite
			};
			setAddingInProgress();
			var promise = $scope.performAdd({follower: emailModel}).then(function(follower) {
				if (follower) {
					ArrayHelper.pushIfIdIsUnique($scope.followers, follower);
				} else {
					$scope.followers.push(emailModel);
				}
				$scope.uiState.followerSearch = '';
			});
			promise.finally(unsetAddingInProgress);
			return promise;
		});
	};

	var findCollaboratorTimeout;

	$scope.findCollaborator = function(search) {
		if (!search) return;

		if (findCollaboratorTimeout) $timeout.cancel(findCollaboratorTimeout);

		findCollaboratorTimeout = $timeout(function() {
			$scope.collaboratorSuggestions = Collaborators.searchMemberships({
				q: search,
				exclude: getMembershipsIdsFromFollowers($scope.followers),
				memobox: CollaborationService.getMemoboxId(),
				include_non_collabs: CollaborationService.getAccessLevel() >= collaboratorLevels.ADMIN
			});
		}, 300); // delay 300 ms

	};

	$scope.isNewCollaborator = function(membership) {
		return isNewCollaborator(membership, membershipsWithAccess);
	};

	$scope.$watch('uiState.followerSearch', function(newValue, oldValue) {
		if (newValue && (newValue !== oldValue)) {
			$scope.findCollaborator(newValue);
			$scope.uiState.askForEmail = false;
		}
	});

	function setAddingInProgress() {
		$scope.uiState.addingInProgress = true;
	}

	function unsetAddingInProgress() {
		$scope.uiState.addingInProgress = false;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('FollowingInfo', FollowingInfo);

FollowingInfo.$inject = ['$resource', 'PekamaConfig'];

function FollowingInfo($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'messages/following_info/:id/:action/', {id: '@id'}, {
		dismissInviteSuggestion: {
			method: 'POST',
			params: {action: 'dismiss_invite_suggestion'}
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('Messages', Messages);

Messages.$inject = ['$resource', 'PekamaConfig'];

function Messages($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'messages/messages/:id/:action/', {id: '@id'}, {
		archive: {
			method: 'POST',
			params: {action: 'archive'}
		},
		markRead: {
			method: 'POST',
			params: {action: 'mark_read'}
		},
		countUnread: {
			method: 'GET',
			params: {action: 'count_unread'}
		},
		previous: {
			method: 'GET',
			params: {action: 'previous'},
			isArray: true
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.directive('cmntMessagesList', function() {
		return {
			scope: {
				conversation: '='
			},
			templateUrl: 'messaging/messagesList.directive.html',
			controller: MessagesListController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

MessagesListController.$inject = ['ConversationService', '$scope'];

function MessagesListController(ConversationService, $scope) {
	var vm = this;

	vm.loadMore = loadMore;
	vm.markRead = _.memoize(markRead, function(msg) {
		return msg.id
	});
	vm.remove = remove;

	activate();

	function activate() {
		vm.messages = ConversationService.load({conversation: vm.conversation.id});

		$scope.$on('$destroy', function() {
			ConversationService.cleanup();
		});
	}

	function loadMore() {
		ConversationService.loadMore();
	}

	function markRead(message) {
		if (!message.is_read) {
			ConversationService.markRead(message);
		}
	}

	function remove(message) {
		ConversationService.removeMessage(message);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('MessagingSettings', MessagingSettings);

MessagingSettings.$inject = ['$resource', 'PekamaConfig'];

function MessagingSettings($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'messages/settings/:id/:action/', {id: '@id'}, {
		query: {
			method: 'GET',
			isArray: false
		}
	});
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.directive('cmntTether', ['$timeout', '$interval', function($timeout, $interval) {
		return {
			link: function(scope, element, attrs) {
				var tether;

				$timeout(function() {
					tether = new Tether({
						element: element,
						target: attrs.target,
						attachment: 'top left',
						targetAttachment: 'bottom left',
						constraints: [
							{
								to: 'window',
								attachment: 'together'
							}
						]
					});
				});

				var repositionInterval = $interval(function() {
					if (tether) {
						tether.position();
					}
				}, 300);

				scope.$on('$destroy', function() {
					element.remove();
					$interval.cancel(repositionInterval);

					if (tether) {
						tether.disable();
					}
				})
			}
		}
	}]);

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('UnreadUpdater', UnreadUpdater);

var UNREAD_CHANGED_EVENT = 'unread_changed';

UnreadUpdater.$inject = ['UserService', 'Pusher'];

function UnreadUpdater(UserService, Pusher) {
	return function() {
		return Updater();
	};

	function Updater() {
		var userChannelPromise;

		var service = {
			conversations: [],

			subscribe: subscribe,
			unsubscribe: unsubscribe,
			setConversations: setConversations,
			addConversation: addConversation,
			clear: clear,
			addConversations: addConversations
		};

		return service;

		function subscribe() {
			userChannelPromise = UserService.getCurrent().$promise.then(function(user) {
				var userChannelName = "private-user-" + user.id;

				return Pusher.subscribe(userChannelName, UNREAD_CHANGED_EVENT, _onUnreadChanged);
			});
		}

		function unsubscribe() {
			if (!userChannelPromise) {
				throw new Error("You must call 'subscribe' before calling 'unsubscribe'.");
			}

			userChannelPromise.then(function(channel) {
				channel.unbind(UNREAD_CHANGED_EVENT);
			});
		}

		function setConversations(newConversations) {
			service.conversations.length = 0;
			Array.prototype.push.apply(service.conversations, newConversations);
		}

		function addConversation(newConversation) {
			service.conversations.push(newConversation);
		}

		function addConversations(newConversations) {
			Array.prototype.push.apply(service.conversations, newConversations);
		}

		function clear() {
			service.conversations.length = 0;
		}

		function _onUnreadChanged(data) {
			_.forEach(service.conversations, function(conversation) {
				if (conversation.id === data.conversation_id) {
					conversation.unread = data.unread;
				}
			})
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.messaging')
	.factory('UploadService', UploadService);

var TOTAL_ATTACHMENT_SIZE_LIMIT = 20450000;
var ERRORS = {
	filesize: "Please keep the file size under {{ sizeLimit }}. Current size is {{ currentSize }}."
};
var UPLOAD_WARNING_TEXT = "Some of your attachments haven't finished uploading yet, and will be lost if you switch " +
	"to another tab. Are you sure you want to continue?";

UploadService.$inject = ['$upload', '$filter', 'RestErrors', 'PekamaConfig', '$modal', '$rootScope', '$interpolate'];

function UploadService($upload, $filter, RestErrors, PekamaConfig, $modal, $rootScope, $interpolate) {
	return function(attachments) {
		var service = {
			activeUploads: 0,

			attachments: [],

			maxAttachmentsSizeExceeded: false,
			TOTAL_ATTACHMENTS_SIZE_LIMIT: TOTAL_ATTACHMENT_SIZE_LIMIT,
			UPLOAD_URL: PekamaConfig.apiBaseUrl + 'files/temp_files/',

			UPLOAD_WARNING_TEXT: UPLOAD_WARNING_TEXT,

			init: init,

			startUploading: startUploading,
			removeAttachment: removeAttachment,
			getUploadedFiles: getUploadedFiles,
			getTotalSize: getTotalSize,
			clear: clear,
			showActiveUploadsWarning: showActiveUploadsWarning
		};

		init();

		return service;

		function init() {
			_clearAttachments();

			if (attachments) {
				Array.prototype.push.apply(service.attachments, attachments);
			}

			_checkTotalSizeLimit();

			service.activeUploads = 0;
		}

		function startUploading(files, uploadUrl) {
			uploadUrl = uploadUrl || service.UPLOAD_URL;

			files.forEach(function(file) {
				service.attachments.push(file);

				if (file.size > PekamaConfig.maxUploadFileSize) {
					file.error = _getFileSizeError(file);

					return;
				}

				var upload = _startUpload(file, uploadUrl);

				file.upload = upload;

				upload.progress(function(event) {
					file.progress = _getProgress(event);
				}).then(function(response) {
					file.uuid = response.data.uuid;
				}, function(response) {
					if (response.data) {
						file.error = RestErrors.asString(response.data);
					}
				});

				_checkTotalSizeLimit();
			});
		}

		function getUploadedFiles() {
			return service.attachments.filter(function(attachment) {
				return attachment.uuid !== undefined;
			}).map(_getFileData);
		}

		function removeAttachment(attachment) {
			var index = service.attachments.indexOf(attachment);

			if (index > -1) {
				service.attachments.splice(index, 1);

				if (attachment.upload) {
					attachment.upload.abort();
				}
			}

			_checkTotalSizeLimit();
		}

		function clear() {
			_clearAttachments();
		}

		function getTotalSize() {
			return _getTotalAttachmentSize(service.attachments);
		}

		function showActiveUploadsWarning() {
			var scope = $rootScope.$new();

			scope.warningText = UPLOAD_WARNING_TEXT;

			return $modal.open({
				templateUrl: 'messaging/uploadWarning.html',
				scope: scope
			}).result;
		}

		function _startUpload(file, uploadUrl) {
			var upload = $upload.upload({url: uploadUrl, file: file});

			service.activeUploads += 1;

			upload.finally(function() {
				service.activeUploads -= 1;
			});

			return upload;
		}

		function _clearAttachments() {
			service.attachments.forEach(function(attachment) {
				if (attachment.upload) {
					attachment.upload.abort();
				}
			});

			service.attachments.length = 0;
		}

		function _checkTotalSizeLimit() {
			var totalSize = _getTotalAttachmentSize(service.attachments);

			service.maxAttachmentsSizeExceeded = totalSize > TOTAL_ATTACHMENT_SIZE_LIMIT;
		}

		function _getTotalAttachmentSize(attachments) {
			return _.chain(attachments).filter(function(file) {
				return !file.error && file.uuid !== undefined;
			}).reduce(function(acc, file) {
				return acc + file.size;
			}, 0).value();
		}

		function _getFileData(file) {
			return _.pick(file, 'name', 'size', 'type', 'uuid', 'progress', 'error');
		}

		function _getFileSizeError(file) {
			return _error('filesize', {
				sizeLimit: $filter('filesize')(PekamaConfig.maxUploadFileSize),
				currentSize: $filter('filesize')(file.size)
			});
		}

		function _error(errorType, errorContext) {
			var renderTemplate = $interpolate(ERRORS[errorType]);

			return renderTemplate(errorContext);
		}

		function _getProgress(uploadEvent) {
			return parseInt(100.0 * uploadEvent.loaded / uploadEvent.total);
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.personal')
	.controller('PersonalController', PersonalController);

PersonalController.$inject = ['$scope', 'UserService', '$saveForm', 'User', 'PekamaConfig', 'RedirectService',
	'$upload', 'AuthService', 'CommunityProfileService', '$window', '$timeout'];

function PersonalController($scope, UserService, $saveForm, User, PekamaConfig, RedirectService,
							$upload, AuthService, CommunityProfileService, $window, $timeout) {
	var vm = this;

	var userModelInitialized;

	vm.conf = PekamaConfig;
	vm.RedirectService = RedirectService;
	vm.passwordModel = {};
	vm.passwordRules = PekamaConfig.PASSWORD_RULES;
	vm.passwordFormShowed = false;
	vm.profile = CommunityProfileService.getMine();

	vm.agreeToTou = false;
	vm.termsOfUseUrl = PekamaConfig.termsOfUseUrl;

	vm.save = save;
	vm.changePassword = changePassword;
	vm.uploadAvatar = uploadAvatar;
	vm.logOut = logOut;
	vm.connectLinkedIn = connectLinkedIn;
	vm.activateUser = activateUser;

	activate();

	function activate() {
		_setUserModel();
		$scope.$on('currentUserUpdated', function() {
			_setUserModel()
		});
	}

	function save() {
		var saveModel = _.pick(vm.userModel, 'id', 'first_name', 'last_name');
		return userModelInitialized.then(function() {
			return $saveForm($scope, User.update(saveModel).$promise, function(updatedUser) {
				UserService.setCurrent(updatedUser);
				CommunityProfileService.updateMine();
			});
		});
	}

	function changePassword(passwordChangeForm) {
		return User.updatePassword(vm.passwordModel).$promise.then(function() {
			vm.passwordModel = {};
			passwordChangeForm.clearErrors();
		}, function(response) {
			passwordChangeForm.displayErrors(response.data);
		});
	}

	function uploadAvatar(files) {
		if (files.length > 0) {
			vm.avatarErrors = '';

			return userModelInitialized.then(function() {
				return $upload.upload({
					url: PekamaConfig.apiBaseUrl + 'users/users/upload_avatar/',
					file: files[0]
				}).then(function() {
					UserService.updateCurrent();
					CommunityProfileService.updateMine();
				}, function(response) {
					vm.avatarErrors = _returnOrJoin(response.data['avatar'])
				})
			});
		}
	}

	function logOut() {
		return userModelInitialized.then(function() {
			return AuthService.logOut();
		});
	}

	function activateUser(form) {
		return AuthService.activate(vm.userModel.first_name, vm.userModel.last_name, vm.passwordModel.newPassword).then(function() {
			form.clearErrors();
			UserService.updateCurrent();

		}, function(response) {
			form.displayErrors(response.data);
		});
	}

	function _setUserModel() {
		userModelInitialized = UserService.getCurrent().$promise.then(function(user) {
			vm.userModel = angular.copy(user);
		});
	}

	function _returnOrJoin(arrayOrString) {
		if (arrayOrString.constructor === String) {
			return arrayOrString;
		} else {
			return arrayOrString.join(', ');
		}
	}

	function connectLinkedIn() {
		var popup = $window.open(vm.conf.linkedInLoginUrl + "?next=/accounts/social/popup/",
			'linkedin', 'width=600,height=400');

		function _checkPopupClosed() {
			$timeout(function() {
				if (popup.closed)
					UserService.updateCurrent();
				else
					_checkPopupClosed();
			}, 1000)
		}

		_checkPopupClosed();
	}
}

})();
(function() {
'use strict';
angular
	.module('community.personal')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];

function setRoutes($stateProvider, $urlRouterProvider) {
	$stateProvider
		.state('community.personal', {
			url: 'personal',
			templateUrl: 'personal/personal.html',
			controller: 'PersonalController as vm',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			}
		})
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.factory('DefiningsByMatterTypes', DefiningsByMatterTypes);

DefiningsByMatterTypes.$inject = ['$q', 'MatterTypes', 'DefiningService'];

function DefiningsByMatterTypes($q, MatterTypes, DefiningService) {
	var self = this;

	var deferred = $q.defer();

	return {
		getData: getData
	};

	function getData() {
		if (!self.hasOwnProperty('definings')) {
			self.definings = {};
			MatterTypes.getList().then(function() {
				$q.all(_.map(MatterTypes.objects, function(matterType) {
					return DefiningService.byMatterType(matterType.id).then(function(definings) {
						self.definings[matterType.id] = definings;
					});
				})).then(function() {
					deferred.resolve(self.definings)
				}, deferred.reject);
			}, deferred.reject);
		}
		return deferred.promise
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('NewTeamModalController', NewTeamModalController);

NewTeamModalController.$inject = ['$scope', 'Organizations', '$modalInstance'];

function NewTeamModalController($scope, Organizations, $modalInstance) {
	var vm = this;

	vm.title = $scope.title;

	vm.create = create;

	function create(form) {
		return Organizations.save({
			title: vm.title
		}).$promise.then(function(newOrganization) {
			$modalInstance.close(newOrganization);
		}, function(response) {
			form.displayErrors(response.data);
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('ProfileController', ProfileController);

ProfileController.$inject = ['$scope', 'UserService', 'OrganizationService', '$upload', '$modal', 'AuthService',
	'Organizations', 'CommunityProfileService', 'PekamaConfig', '$rootScope', '$q', 'PortalService', 'OrganizationSettingsService'];

function ProfileController($scope, UserService, OrganizationService, $upload, $modal, AuthService,
						   Organizations, CommunityProfileService, PekamaConfig, $rootScope, $q, PortalService, OrganizationSettingsService) {
	var vm = this;

	vm.userModel = UserService.getCurrent();
	vm.organizationModel = undefined;
	vm.representativeChooserShowed = false;

	vm.uploadLogo = uploadLogo;
	vm.updateOrganizationTitle = updateOrganizationTitle;
	vm.referAnAttorney = referAnAttorney;
	vm.setPrimary = setPrimary;
	vm.createNewTeam = createNewTeam;
	vm.logOut = logOut;

	activate();

	function activate() {
		vm.organizations = Organizations.query();

		reloadData();

		$scope.$on('communityProfileUpdated', function() {
			_setProfile();
		});

		$scope.$on('primaryOrganization-changed', function() {
			reloadData();
			PortalService.updateMine();
			OrganizationSettingsService.updateMine();
			UserService.updateCurrent();
			vm.userModel = UserService.getCurrent();
		});
	}

	function reloadData() {
		vm.profile = CommunityProfileService.getMine();

		_checkSuspension();
		_setOrganizationModel();
		_setProfile();
	}

	function uploadLogo(files) {
		if (files.length > 0) {
			vm.logoErrors = '';

			return vm.organizationModel.$promise.then(function() {
				return $upload.upload({
					file: files[0],
					url: PekamaConfig.apiBaseUrl + 'organizations/organizations/' + vm.organizationModel.id + '/logo/',
					fileFormDataName: 'logo'
				}).then(function(response) {
					vm.organizationModel.logo_140 = response.data.logo_140;
				}, function(response) {
					vm.logoErrors = _returnOrJoin(response.data['logo'])
				});
			})
		}
	}

	function updateOrganizationTitle(organization) {
		return Organizations.update({id: organization.id, title: organization.title}).$promise;
	}

	function referAnAttorney() {
		$modal.open({
			templateUrl: 'profile/boost/referAttorney.modal.html',
			controller: 'ReferAttorneyController as vm',
			resolve: {
				currentUser: function() {
					return UserService.getCurrent().$promise;
				}
			}
		});
	}

	function setPrimary() {
		OrganizationService.setPrimary({id: vm.primaryOrg});
	}

	function createNewTeam(search) {
		var modalScope = $rootScope.$new();

		angular.extend(modalScope, {
			title: search
		});

		$modal.open({
			templateUrl: 'profile/newTeam.modal.html',
			controller: 'NewTeamModalController',
			controllerAs: 'vm',
			scope: modalScope
		}).result.then(function(newOrganization) {
			OrganizationService.setPrimary(newOrganization);

			vm.organizations.$promise.then(function() {
				vm.primaryOrg = newOrganization.id;
				vm.organizations.push(newOrganization);
			});
		});
	}

	function logOut() {
		return vm.userModel.$promise.then(function() {
			return AuthService.logOut();
		});
	}

	function _setOrganizationModel() {
		vm.organizationModel = OrganizationService.primary();

		$q.all([
			vm.organizationModel.$promise,
			vm.organizations.$promise
		]).then(function() {
			// only set the primaryOrg after the list of organizations has been loaded, to avoid jumping dropdown
			vm.primaryOrg = vm.organizationModel.id;
		});
	}

	function _setProfile() {
		CommunityProfileService.getMine().$promise.then(function(profile) {
			vm.profile = angular.copy(profile);
		});
	}

	function _returnOrJoin(arrayOrString) {
		if (arrayOrString.constructor === String) {
			return arrayOrString;
		} else {
			return arrayOrString.join(', ');
		}
	}

	function _checkSuspension() {
		vm.profile.$promise.then(function() {
			if (vm.profile.suspended) {
				var modalScope = $scope.$new(true);

				var subject = "Suspended account - " + vm.profile.name + " - " + vm.profile.organization.title;

				modalScope.mailTo = 'mailto:support@pekama.com?subject=' + subject;

				$modal.open({
					templateUrl: 'profile/suspensionNotice.modal.html',
					scope: modalScope
				});
			}
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];

function setRoutes($stateProvider, $urlRouterProvider) {
	$urlRouterProvider
		.when("/profile", "/profile/personal");

	$stateProvider
		.state('community.profile', {
			url: 'profile',
			templateUrl: 'profile/profile.html',
			controller: 'ProfileController as vm',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			},
			resolve: {
				// currentUser: currentUser,
				myProfile: myProfile
			}
		})
		.state('community.profile.team', {
			url: '/team',
			templateUrl: 'profile/team/team.html',
			controller: 'ProfileTeamController as vm'
		})
		.state('community.profile.services', {
			url: '/services',
			templateUrl: 'profile/services/services.html'
		})
		//.state('community.profile.forms', {
		//    url: '/forms',
		//    templateUrl: 'profile/forms/forms.html'
		//})
		.state('community.profile.members', {
			url: '/members',
			templateUrl: 'profile/members/members.html',
			controller: 'ProfileMembersController as vm'
		})
		.state('community.profile.personal', {
			url: '/personal',
			templateUrl: 'profile/personal/personal.html',
			controller: 'PersonalController as vm'
		})
		.state('community.profile.experts', {
			url: '/experts',
			templateUrl: 'experts/expertsList.html',
			controller: 'ExpertsController as vm',
			resolve: {
				currentUser: currentUser
			}
		})
}

currentUser.$inject = ['UserService'];

function currentUser(UserService) {
	return UserService.getCurrent().$promise;
}

myProfile.$inject = ['CommunityProfileService'];

function myProfile(CommunityProfileService) {
	return CommunityProfileService.getMine().$promise;
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.factory('ScoreAction', ScoreActionFactory);

ScoreActionFactory.$inject = ['PekamaConfig'];

function ScoreActionFactory(PekamaConfig) {
	return PekamaConfig.scoreActions
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.filter('conversationStatus', conversationStatus);

conversationStatus.$inject = ['ProjectStatusValue'];

function conversationStatus(ProjectStatusValue) {
	return function(conversation) {
		if (conversation.status === 'quoted') {
			return conversation.price + ' ' + conversation.price_currency + ' quoted';
		}

		return ProjectStatusValue[conversation.status];
	};
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.factory('CurrencyList', CurrencyList);


var MAIN_CURRENCIES = ['USD', 'GBP', 'EUR', 'JPY', 'CHF', 'AUD', 'RUB'],
	NUMBER_OF_MAIN_CURRENCIES = MAIN_CURRENCIES.length;

var CURRENCY_STORAGE_KEY = 'lastUsedCurrency';


CurrencyList.$inject = ['$http', '$q', 'Storage', 'PekamaConfig'];

function CurrencyList($http, $q, Storage, PekamaConfig) {
	var service = {
		currencies: undefined,
		load: load,
		getDefaultCurrency: getDefaultCurrency,
		setLastUsedCurrency: setLastUsedCurrency
	};

	return service;

	function load() {
		if (!service.currencies) {
			return $http.get(PekamaConfig.apiBaseUrl + 'enquiries/currencies/').then(function(response) {
				service.currencies = response.data;

				_.forEach(service.currencies, function(currency) {
					var idx = MAIN_CURRENCIES.indexOf(currency.code);

					if (idx === -1) {
						currency.priority = idx;
					} else {
						currency.priority = (NUMBER_OF_MAIN_CURRENCIES - idx) - 1;
					}
				});

				service.currencies.sort(function(a, b) {
					return b.priority - a.priority;
				});

				return service.currencies;
			});
		}

		return $q.when(service.currencies);
	}

	function getDefaultCurrency() {
		var currency = Storage.get(CURRENCY_STORAGE_KEY);

		if (!currency) {
			currency = 'GBP';
		}

		return $q.when(currency);
	}

	function setLastUsedCurrency(currnecy) {
		Storage.put(CURRENCY_STORAGE_KEY, currnecy);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.controller('ParticipantsController', ParticipantsController);

ParticipantsController.$inject = ['conversationId', 'primaryOrganization', 'expert', 'FollowingInfo',
	'OrganizationMemberships', '$q'];

function ParticipantsController(conversationId, primaryOrganization, expert, FollowingInfo,
								OrganizationMemberships, $q) {
	var vm = this;

	vm.toggleFollower = toggleFollower;
	vm.pickerAddFollower = pickerAddFollower;
	vm.pickerRemoveFollower = pickerRemoveFollower;

	activate();

	function activate() {
		vm.expert = expert;
		vm.followers = FollowingInfo.query({conversation: conversationId});
		vm.members = OrganizationMemberships.query({
			organization: primaryOrganization.token,
			is_active: true
		});

		$q.all([
			vm.followers.$promise,
			vm.members.$promise
		]).then(function(resolves) {
			var followers = resolves[0];
			var members = resolves[1];

			followers.forEach(function(follower) {
				var membershipId = follower.membership;

				var member = _.where(members, {id: membershipId})[0];

				if (member) {
					member.$follower = follower.id;
				}
			});
		})
	}

	function toggleFollower(member) {
		var actionResult;

		if (member.$follower) {
			var followerId = member.$follower;

			actionResult = FollowingInfo.delete({id: followerId}).$promise.then(function() {
				delete member['$follower'];

				for (var i = 0; i < vm.followers.length; i++) {
					if (vm.followers[i].id === followerId) {
						vm.followers.splice(i, 1);

						break;
					}
				}
			});
		} else {
			actionResult = FollowingInfo.save({
				conversation: conversationId,
				membership: member.id
			}).$promise.then(function(followingInfo) {
				member.$follower = followingInfo.id;
				vm.followers.push(followingInfo);
			});
		}

		return actionResult;
	}

	function pickerAddFollower(follower) {
		var createData = {
			conversation: conversationId
		};

		angular.extend(createData, follower);

		return FollowingInfo.save(createData).$promise.then(function(followingInfo) {
			var member = _.where(vm.members, {id: followingInfo.membership})[0];

			if (member) {
				member.$follower = followingInfo.id;
			}

			return followingInfo;
		});
	}

	function pickerRemoveFollower(follower) {
		return FollowingInfo.delete({id: follower.id}).$promise;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.directive('cmntProject', function() {
		return {
			templateUrl: 'projects/project.directive.html',
			scope: {
				project: '=',
				onSelectionChange: '&?',
				animated: '=?',
				isReadOnly: '<?'
			},
			controller: CmntProjectController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

CmntProjectController.$inject = ['DefiningService', 'ExpertiseTypes', 'MatterTypes', 'ProjectStatusValue',
	'ProjectStatusIcon', 'Navigation', '$timeout'];

function CmntProjectController(DefiningService, ExpertiseTypes, MatterTypes, ProjectStatusValue,
							   ProjectStatusIcon, Navigation, $timeout) {
	var vm = this;

	vm.isReadOnly = vm.isReadOnly || false;
	vm.selectable = (vm.onSelectionChange !== undefined) && !vm.isReadOnly;
	vm.cursorInside = false;

	vm.selectionChanged = selectionChanged;
	vm.getStatusValue = getStatusValue;
	vm.getStatusIcon = getStatusIcon;
	vm.viewCase = viewCase;
	vm.toggleSelection = toggleSelection;
	vm.viewConversation = viewConversation;

	activate();

	function activate() {
		if (vm.animated) {
			_contentFadeIn();
		}

		MatterTypes.findById(vm.project.matter_type).then(function(matterType) {
			vm.matterType = matterType;
		});

		DefiningService.findById(vm.project.jurisdiction).then(function(jurisdiction) {
			vm.jurisdiction = jurisdiction;
		});

		ExpertiseTypes.findById(vm.project.expertise_type).then(function(expertiseType) {
			vm.expertiseType = expertiseType;
		});
	}

	function getStatusValue(status) {
		return ProjectStatusValue[status];
	}

	function selectionChanged() {
		vm.onSelectionChange({project: vm.project});
	}

	function getStatusIcon(supplier) {
		return ProjectStatusIcon[supplier.status];
	}

	function viewCase() {
		Navigation.go('community.projects.projectsDetail', {projectId: vm.project.id});
	}

	function viewConversation(id) {
		Navigation.go('community.projects.projectsDetail.conversation', {projectId: vm.project.id, conversationId: id});
	}

	function toggleSelection() {
		if (vm.selectable) {
			vm.project.selected = !vm.project.selected;

			vm.onSelectionChange({project: vm.project});
		}
	}

	function _contentFadeIn() {
		vm.fadeIn = false;

		$timeout(function() {
			vm.fadeIn = true;
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.factory('ProjectService', ProjectService);


var Signals = {
	PROJECT_UPDATED: 'projectUpdated',
	CONVERSATION_UPDATED: 'conversationUpdated',
	CONVERSATION_ADDED: 'conversationAdded'
};


var WsEvents = {
	COMMUNITYPROJECT_UPDATED: 'communityproject_updated',
	INSTRUCTIONS_ACTIVITY: 'instructions_activity',
	CONVERSATIONS_ADDED: 'conversations_added'
};

ProjectService.$inject = ['SupplierConversation', 'Project', 'UnreadUpdater', 'Pusher', 'SignalsService', '$filter'];

function ProjectService(SupplierConversation, Project, UnreadUpdater, Pusher, SignalsService, $filter) {
	var signals = SignalsService();

	var projectChannelPromise,
		unreadUpdater = UnreadUpdater(),
		projectStatusFilter = $filter('projectStatus');

	var service = {
		project: {},
		conversations: [],

		init: init,

		setProject: setProject,
		cleanup: cleanup,
		reloadProject: reloadProject,
		loadConversations: loadConversations,
		addConversation: addConversation,
		onProjectUpdated: onProjectUpdated,
		onConversationUpdated: onConversationUpdated,
		onConversationAdded: onConversationAdded
	};

	return service;

	function init() {
		unreadUpdater.subscribe();
	}

	function setProject(projectId) {
		projectChannelPromise = _subscribeToProjectUpdates(projectId);

		service.project = Project.get({id: projectId});

		service.project.$promise.then(function() {
			service.project.$status = projectStatusFilter(service.project, false);
		});

		return service.project.$promise;
	}

	function cleanup() {
		_unsubscribeFromProjectUpdates(projectChannelPromise);
	}

	function reloadProject() {
		return Project.get({id: service.project.id}).$promise.then(function(updatedProject) {
			angular.extend(service.project, updatedProject);
			service.project.$status = projectStatusFilter(service.project, false);
			return service.project;
		});
	}

	function loadConversations() {
		return service.project.$promise.then(function(project) {
			return SupplierConversation.query({
				project: project.id,
				mine_only: project.direction === 'incoming' ? true : undefined
			}).$promise.then(function(conversations) {
				service.conversations.length = 0;
				[].push.apply(service.conversations, conversations);

				unreadUpdater.setConversations(service.conversations);

				if (project.supplier_conversation) {
					_putConversationOnTopById(service.conversations, project.supplier_conversation);
				}
			});
		});
	}

	function addConversation(conversation) {
		service.conversations.push(conversation);
		unreadUpdater.addConversation(conversation);
	}

	function onProjectUpdated(callback) {
		return signals.on(Signals.PROJECT_UPDATED, callback);
	}

	function onConversationUpdated(callback) {
		return signals.on(Signals.CONVERSATION_UPDATED, callback);
	}

	function onConversationAdded(callback) {
		return signals.on(Signals.CONVERSATION_ADDED, callback);
	}

	function _subscribeToProjectUpdates(projectId) {
		var channelName = 'project-' + projectId;

		Pusher.subscribe(channelName, WsEvents.COMMUNITYPROJECT_UPDATED, _onProjectUpdated);
		Pusher.subscribe(channelName, WsEvents.CONVERSATIONS_ADDED, _onConversationsAdded);
		return Pusher.subscribe(channelName, WsEvents.INSTRUCTIONS_ACTIVITY, _onConversationStatusChanged);
	}

	function _unsubscribeFromProjectUpdates(channelPromise) {
		channelPromise.then(function(channel) {
			_.values(WsEvents).forEach(function(wsEvent) {
				channel.unbind(wsEvent);
			});
		});
	}

	function _onProjectUpdated() {
		service.reloadProject().then(function() {
			service.loadConversations().then(function() {
				signals.emit(Signals.PROJECT_UPDATED);
			});
		});
	}

	function _onConversationStatusChanged(data) {
		if (data.bulk) {
			return;
		}

		var conv = _.findWhere(service.conversations, {id: data.id});

		if (!conv) {
			return;
		}

		SupplierConversation.get({id: data.id}).$promise.then(function(updatedConv) {
			angular.extend(conv, updatedConv);

			signals.emit(Signals.CONVERSATION_UPDATED, conv);
		});

		var isIncomingProject = service.project.direction === 'incoming',
			isMainConversation = conv.id === service.project.supplier_conversation;

		if (isIncomingProject || isMainConversation) {
			service.reloadProject().then(function() {
				signals.emit(Signals.PROJECT_UPDATED, conv);
			});
		}
	}

	function _onConversationsAdded(data) {
		if (service.project.direction !== 'outgoing') {
			return;
		}

		return SupplierConversation.query({
			ids: data.ids
		}).$promise.then(function(conversations) {
			[].push.apply(service.conversations, conversations);
			unreadUpdater.addConversations(service.conversations);

			signals.emit(Signals.PROJECT_UPDATED);
			signals.emit(Signals.CONVERSATION_ADDED);
		});
	}

	function _putConversationOnTopById(conversations, convId) {
		var conv = _.findWhere(conversations, {id: convId});

		if (conv) {
			var convIdx = conversations.indexOf(conv);

			conversations.splice(convIdx, 1);
			conversations.unshift(conv);
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.controller('ProjectConversationController', ProjectConversationController);

var _emptyLine = "<p><br></p>";
var defaultMessages = {
	instruct: "<p>Thank you for all the information. Please consider this as instructions to proceed with this case as " +
		"discussed.</p>",
	reject: "<p>Unfortunately, on this occasion, we will not be proceeding with your firm for this piece of work.</p>" +
		_emptyLine + "<p>Thanks for your time and hope to work with you in the future.</p>",
	withdraw: "<p>Please DO NOT proceed with this filing. Kindly confirm immediately.</p>",
	confirm: "<p>I'm pleased to confirm safe receipt of your instructions and will execute them on time. I will report " +
		"immediately once the work is completed.</p>",
	complete: "<p>I'm pleased to confirm that your instructions were executed and the work was completed on time.</p>",
	quote: "<p>My total quote to complete this work for you is <span class='_amount'>[amount]</span> <span class='_currency'>[currency]</span>.<p>" + _emptyLine +
		"<p>The full breakdown is:&nbsp;</p>" +
		"<p>Service fees:&nbsp;</p>" +
		"<p>Government fees:&nbsp;</p>" +
		"<p>Other:&nbsp;</p>" + _emptyLine +
		"<p>I hope this is acceptable and I look forward to hearing back from you.</p>"
};

ProjectConversationController.$inject = ['project', 'currentUser', 'ConversationService', 'SupplierConversation',
	'ProjectService', '$stateParams', 'uploadService', 'StoredInput', 'CurrencyList', '$scope', '$q', '$window',
	'$state'];

function ProjectConversationController(project, currentUser, ConversationService, SupplierConversation, ProjectService,
									   $stateParams, uploadService, StoredInput, CurrencyList, $scope, $q, $window,
									   $state) {
	var vm = this;

	vm.project = project;
	var postTypeToAction = {
		instruct: SupplierConversation.sendInstructions,
		reject: SupplierConversation.cancel,
		withdraw: SupplierConversation.withdrawInstructions,
		confirm: SupplierConversation.confirmInstructions,
		complete: SupplierConversation.completeInstructions
	};

	vm.UploadService = uploadService;

	vm.switchPostType = switchPostType;
	vm.post = post;
	vm.postButtonDisabled = postButtonDisabled;
	vm.priceAmountChanged = priceAmountChanged;
	vm.priceCurrencyChanged = priceCurrencyChanged;

	activate();

	function activate() {
		var savedState = StoredInput.retrieve($stateParams.conversationId) || {};

		vm.postType = savedState.postType || 'message';

		_setInput(savedState, vm.postType);

		_initConversationState(vm.postType);

		var unsubscribeMethods = [
			ProjectService.onConversationUpdated(_onConversationUpdated),
			ProjectService.onProjectUpdated(_onProjectUpdated)
		];

		$scope.$on('$destroy', function() {
			_persistState();

			vm.UploadService.clear();

			unsubscribeMethods.map(function(method) {
				method();
			});
		});

		$window.onbeforeunload = function(event) {
			event = event || $window.event;

			_persistState();

			if (event && vm.UploadService.activeUploads > 0) {
				return vm.UploadService.UPLOAD_WARNING_TEXT;
			}
		}
	}

	function switchPostType(newPostType) {
		var switchConfirmed;

		if (vm.UploadService.activeUploads > 0) {
			switchConfirmed = vm.UploadService.showActiveUploadsWarning();
		}

		$q.when(switchConfirmed).then(function() {
			_persistState();
			_clearInput();
			_setInput(StoredInput.retrieve($stateParams.conversationId, newPostType), newPostType);

			vm.postType = newPostType;

			if (vm.postType === 'quote') {
				_loadAndSetCurrencies();
			}
		});
	}

	function post() {
		var postType = vm.postType,
			action = _getAction(postType);

		return action().then(function() {
			_clearInput();
			StoredInput.clear($stateParams.conversationId, postType);
		});
	}

	function postButtonDisabled() {
		var disabled = !vm.text || vm.UploadService.activeUploads > 0;

		if (vm.postType === 'quote') {
			disabled = disabled || !vm.price.amount;
		}

		return disabled;
	}

	function priceAmountChanged() {
		if (vm.price.amount) {
			var amount = "<span class='_amount'>" + vm.price.amount + "</span>";
			vm.text = vm.text.replace(/\<span\s+class=.{1}_amount.{1}\>.*?<\/span>/, amount)
		}
	}

	function priceCurrencyChanged() {
		if (vm.price.currency) {
			var currency = "<span class='_currency'>" + vm.price.currency + "</span>";
			vm.text = vm.text.replace(/\<span\s+class=.{1}_currency.{1}\>.*?<\/span>/, currency)
		}
	}

	function _postMessage() {
		var files = vm.UploadService.getUploadedFiles();

		return ConversationService.postMessage(vm.text, _getFileUuids(files));
	}

	function _quote() {
		var params = angular.extend({
			price: vm.price.amount,
			price_currency: vm.price.currency
		}, _getMessageApiParams());

		return SupplierConversation.quote(params).$promise.then(function() {
			CurrencyList.setLastUsedCurrency(vm.price.currency);

			vm.priceForm.clearErrors();
		}, function(response) {
			vm.priceForm.displayErrors(response.data);

			return $q.reject();
		});
	}

	function _changeState(resourceAction) {
		return resourceAction(_getMessageApiParams()).$promise;
	}

	function _initConversationState(postType) {
		vm.conversation = _.findWhere(ProjectService.conversations, {id: $stateParams.conversationId});

		if (!vm.conversation) {
			$state.go('community.ip.families', {replace: true});
		}

		vm.postTypes = _getPostTypes(project, vm.conversation);

		if (vm.postTypes.indexOf(postType) === -1) {
			vm.postType = 'message';
		}

		if (postType === 'quote') {
			_loadAndSetCurrencies();
		}

		vm.isAssociate = _getIsAssociate(project, vm.conversation);
	}

	function _onConversationUpdated(conversation) {
		if (conversation.id !== $stateParams.conversationId) {
			return;
		}

		_initConversationState(vm.postType);
	}

	function _onProjectUpdated() {
		_initConversationState(vm.postType);
	}

	function _persistState() {
		StoredInput.store($stateParams.conversationId, vm.postType, _getInput());
	}

	function _getInput() {
		return {
			text: vm.text,
			files: vm.UploadService.getUploadedFiles(),
			price: vm.price
		}
	}

	function _setInput(savedInput, postType) {
		if (!savedInput.text) {
			vm.text = _getDefaultMessage(postType);
		} else {
			vm.text = savedInput.text;
		}

		if (postType === 'quote') {
			if (savedInput.price) {
				vm.price = savedInput.price;
			} else if (project.task.number) {
				vm.price.amount = project.task.number.formatted_no_currency;
				vm.price.currency = project.task.number.currency;
				vm.text = vm.text.replace(/\[amount\]/, vm.price.amount);
				vm.text = vm.text.replace(/\[currency\]/, vm.price.currency);
			}

		}

		vm.UploadService.init(savedInput.files || []);
	}

	function _clearInput() {
		vm.text = '';
		vm.price = {};
		vm.UploadService.clear();
	}

	function _getMessageApiParams() {
		var files = vm.UploadService.getUploadedFiles();

		return {
			id: vm.conversation.id,
			html: vm.text,
			uploaded_files: _getFileUuids(files),
			conversation: vm.conversation.id
		}
	}

	function _loadAndSetCurrencies() {
		if (!vm.currencies) {
			CurrencyList.load().then(function() {
				vm.currencies = CurrencyList.currencies;
			});

			if (!vm.price.currency) {
				CurrencyList.getDefaultCurrency().then(function(defaultCurrency) {
					vm.price.currency = defaultCurrency;
				});
			}
		}
	}

	function _getAction(postType) {
		switch (postType) {
			case 'message':
				return _postMessage;
			case 'quote':
				return _quote;
			default:
				var resourceAction = postTypeToAction[postType];

				return _.partial(_changeState, resourceAction);
		}
	}

	function _getPostTypes(project, conversation) {
		var actions = ['message'];

		if (project.direction === 'outgoing') {
			switch (conversation.status) {
				case 'inquiry':
				case 'quoted':
					actions.push('instruct', 'reject');
					break;
				case 'sent':
					actions.push('withdraw');
					break;
				case 'cancelled':
				case 'withdrawn':
					if (project.status === 'draft') {
						actions.push('instruct')
					}
			}
		} else {
			switch (conversation.status) {
				case 'inquiry':
					actions.push('quote');
					break;
				case 'sent':
					actions.push('confirm');
					break;
				case 'confirmed':
					actions.push('complete');
					break;
			}
		}

		return actions;
	}

	function _getFileUuids(files) {
		return _.pluck(files, 'uuid');
	}

	function _getDefaultMessage(postType) {
		var messageBody = defaultMessages[postType];

		if (!messageBody) {
			return "";
		}

		var greeting = "",
			signature = "";

		var otherPersonName = _getOtherPersonName(project, vm.conversation);
		if (otherPersonName) {
			greeting = "<p>Hi " + otherPersonName + ".</p>" + _emptyLine;
		}

		var ownName = _getOwnName();
		if (ownName) {
			signature = _emptyLine + '<p>' + ownName + '</p>';
		}

		return greeting + messageBody + signature;
	}

	function _getOtherPersonName(project, conversation) {
		if (project.direction === 'outgoing') {
			return conversation.profile.first_name;
		} else {
			return project.creator.first_name;
		}
	}

	function _getOwnName() {
		return currentUser.first_name;
	}

	function _getIsAssociate(project, conversation) {
		return project.direction === 'incoming' && conversation.profile.is_associate;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.controller('ProjectDetailController', ProjectDetailController);

ProjectDetailController.$inject = ['project', 'conversations', 'expertsChooserDelegate', 'MatterTypes', 'DefiningService',
	'ExpertiseTypes', '$state', 'ProjectService', 'ProjectStatusValue', 'uploadService', 'currentUser',
	'ProjectStatusIcon', 'Project', '$scope', 'Wizard', '$q', 'Navigation', '$modal', 'FollowingInfo',
	'OrganizationService', 'MemoboxMembershipsService', 'CollaborationService',
	'SupplierConversation'];

function ProjectDetailController(project, conversations, expertsChooserDelegate, MatterTypes, DefiningService,
								 ExpertiseTypes, $state, ProjectService, ProjectStatusValue, uploadService, currentUser,
								 ProjectStatusIcon, Project, $scope, Wizard, $q, Navigation, $modal, FollowingInfo,
								 OrganizationService, MemoboxMembershipsService, CollaborationService,
								 SupplierConversation) {
	var vm = this;

	var OWNER_PERMISSION = 100;

	vm.project = project;
	vm.conversations = conversations;

	vm.activeConversationId = $state.params.conversationId;
	vm.existingProfilesIds = undefined;
	vm.expertsChooserDelegate = expertsChooserDelegate;
	vm.ProjectStatusValue = ProjectStatusValue;
	vm.ProjectStatusIcon = ProjectStatusIcon;
	vm.UploadService = uploadService;
	vm.currentUser = currentUser;

	vm.archive = archive;
	vm.clone = clone;
	vm.cancel = cancel;
	vm.expertsSelected = expertsSelected;
	vm.openConversation = openConversation;
	vm.openEditParticipantsModal = openEditParticipantsModal;
	vm.removeFollower = removeFollower;
	vm.confirmInstructions = confirmInstructions;
	vm.completeInstructions = completeInstructions;

	activate();

	function activate() {
		vm.isOutgoing = vm.project.direction === 'outgoing';

		_getProjectParamsObjects().then(function() {
			expertsChooserDelegate.openIfUrlParamPresent();
		});

		vm.existingProfilesIds = _getProfileIds(ProjectService.conversations);

		var unsubscribeMethods = [
			ProjectService.onProjectUpdated(_onProjectUpdated),
			ProjectService.onConversationAdded(_onConversationAdded)
		];

		$scope.$on('$destroy', function() {
			unsubscribeMethods.map(function(method) {
				method();
			});
		});

		vm.followers = FollowingInfo.query({conversation: vm.activeConversationId});

		CollaborationService.setMemobox({id: project.sub_matter});
		CollaborationService.setAccessLevel(OWNER_PERMISSION);
		MemoboxMembershipsService.loadMemberships(project.sub_matter);
	}

	function archive() {
		vm.UploadService.clear();

		return Project.archive({id: project.id}).$promise.then(function() {
			Navigation.back('community.ip.families', {reload: true});
		});
	}

	function clone() {
		Wizard.saveStateInLocalStorage({
			matterType: project.matter_type,
			definings: [project.jurisdiction],
			expertiseType: project.expertise_type,
			subMatter: project.sub_matter
		});

		$state.go('community.wizard');
	}

	function cancel() {
		vm.UploadService.clear();

		return Project.cancel({id: project.id});
	}

	function expertsSelected(profileIds) {
		return Project.update({
			id: project.id,
			suppliers: profileIds
		}).$promise.then(function() {
			vm.expertsChooserDelegate.hide();
		});
	}

	function openConversation(conversation) {
		if (vm.activeConversationId === conversation.id) {
			return;
		}

		vm.followers = FollowingInfo.query({conversation: conversation.id});

		$state.go('community.projects.projectsDetail.conversation', {conversationId: conversation.id}).then(function() {
			vm.activeConversationId = conversation.id;
		});
	}

	function removeFollower(follower) {
		FollowingInfo.delete({id: follower.id}).$promise.then(function() {
			var index = vm.followers.indexOf(follower);

			if (index !== -1) {
				vm.followers.splice(index, 1);
			}
		});
	}

	function _onProjectUpdated() {
		vm.existingProfilesIds = _getProfileIds(ProjectService.conversations);
	}

	function _onConversationAdded() {
		if (vm.project.status === 'draft' && vm.project.direction === 'outgoing' && vm.project.supplier_conversations.length === 0) {
			ProjectService.reloadProject();
			openConversation(ProjectService.conversations[0]);
		}
	}

	function _getProjectParamsObjects() {
		return $q.all([
			MatterTypes.findById(project.matter_type),
			DefiningService.findById(project.jurisdiction),
			ExpertiseTypes.findById(project.expertise_type)
		]).then(function(objs) {
			vm.matterType = objs[0];
			vm.defining = objs[1];
			vm.expertiseType = objs[2];
		});
	}

	function _getProfileIds(conversations) {
		return _.map(conversations, function(conv) {
			return conv.profile.id;
		});
	}

	function openEditParticipantsModal() {
		var conversation = _.where(vm.conversations, {id: vm.activeConversationId})[0];

		$modal.open({
			templateUrl: 'projects/participants.modal.html',
			windowClass: 'reveal_maxi',
			controller: 'ParticipantsController as vm',
			resolve: {
				conversationId: function() {
					return vm.activeConversationId;
				},
				primaryOrganization: function() {
					return OrganizationService.primary().$promise;
				},
				expert: function() {
					return conversation.profile;
				}
			}
		}).result.finally(function() {
			var followers = FollowingInfo.query({conversation: vm.activeConversationId});

			followers.$promise.then(function() {
				vm.followers = followers;
			});
		})
	}

	function confirmInstructions($close) {
		return SupplierConversation.confirmInstructionsRequester({
			id: vm.project.supplier_conversation
		}).$promise.then(function() {
			$close();
		})
	}

	function completeInstructions($close) {
		return SupplierConversation.completeInstructionsRequester({
			id: vm.project.supplier_conversation
		}).$promise.then(function() {
			$close();
		})
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.controller('ProjectDetailHeaderController', ProjectDetailHeaderController);

ProjectDetailHeaderController.$inject = ['project', 'expertsChooserDelegate', 'Project', 'currentUser'];

function ProjectDetailHeaderController(project, expertsChooserDelegate, Project, currentUser) {
	var vm = this;

	vm.project = project;
	vm.expertsChooserDelegate = expertsChooserDelegate;
	vm.showBack = currentUser.is_active;

	vm.updateTitle = updateTitle;

	function updateTitle() {
		return Project.update({id: project.id, title: project.title}).$promise;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.directive('cmntProjectDirectionFilter', function() {
		return {
			scope: {
				direction: '=',
				onFiltersChanged: '&',
				label: '@?',
				hideLabel: '@?'
			},
			templateUrl: 'projects/projectDirectionFilter.directive.html',
			controller: ProjectDirectionFilterController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

ProjectDirectionFilterController.$inject = [];

function ProjectDirectionFilterController() {
	var vm = this;

	vm.label = vm.label || 'Show';
	vm.hideLabel = vm.hideLabel || false;

	vm.directionOptions = [
		{title: 'All', value: 'all', icon: 'icon-all'},
		{title: 'Inbound', value: 'incoming', icon: 'icon-inbound'},
		{title: 'Outbound', value: 'outgoing', icon: 'icon-outbound'}
	];

	vm.directionChanged = directionChanged;

	function directionChanged() {
		vm.onFiltersChanged({newValues: {direction: vm.direction}});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.factory('ProjectsList', ProjectsList);

ProjectsList.$inject = ['Project', 'UnreadUpdater', 'pagination', '$state', 'Wizard', 'Navigation', '$q'];

function ProjectsList(Project, UnreadUpdater, pagination, $state, Wizard, Navigation, $q) {
	var unreadUpdater = UnreadUpdater();

	var service = {
		init: init,

		projects: undefined,
		selectedProjects: [],
		projectsByFamily: [],

		groupByFamily: false,
		hasGroups: false,

		filterParams: undefined,
		pagination: pagination(1, 10),

		dataChange: false,

		load: load,
		loadEmpty: loadEmpty,
		loadMore: loadMore,
		toggleGrouping: toggleGrouping,
		onSelectionChanged: onSelectionChanged,
		selectAll: selectAll,
		selectNone: selectNone,
		isArchivePossible: isArchivePossible,
		isClonePossible: isClonePossible,
		archive: archive,
		clone: clone
	};

	return service;

	function init() {
		unreadUpdater.subscribe();
	}

	function loadEmpty() {
		service.projects = [];
		service.projects.$resolved = true;
	}

	function load(filterParams) {
		unreadUpdater.clear();

		service.filterParams = filterParams;
		service.pagination.reset();

		service.selectedProjects = [];
		service.projectsByFamily = [];
		service.hasGroups = false;

		service.projects = Project.query(_getQueryParams(), service.pagination.handle);

		service.dataChange = true;
		service.projects.$promise.then(function(projects) {
			_onNewProjectsAdded(projects);
		}).finally(function() {
			service.dataChange = false;
		});

		return service.projects;
	}

	function loadMore() {
		if (!service.pagination.moreObjectsAvailable) {
			return $q.when();
		}

		service.pagination.incrementPage();
		service.projects.$resolved = false;

		return Project.query(_getQueryParams(), service.pagination.handle).$promise.then(function(newProjects) {
			[].push.apply(service.projects, newProjects);

			_onNewProjectsAdded(newProjects);
		}).finally(function() {
			service.projects.$resolved = true;
		});
	}

	function toggleGrouping() {
		service.groupByFamily = !service.groupByFamily;

		if (service.hasGroups && service.groupByFamily) {
			service.projectsByFamily = _groupByKeepOrder(service.projects, 'matter');
		}
	}

	function onSelectionChanged(project) {
		service.selectedProjects = _getSelectedProjectsIds(service.projects);
	}

	function selectAll() {
		angular.forEach(service.projects, function(project) {
			project.selected = true;
		});

		service.selectedProjects = _getSelectedProjectsIds(service.projects);
	}

	function selectNone() {
		angular.forEach(service.projects, function(project) {
			project.selected = false;
		});

		service.selectedProjects = _getSelectedProjectsIds(service.projects);
	}

	function isArchivePossible() {
		return service.selectedProjects.length > 0;
	}

	function isClonePossible() {
		return service.selectedProjects.length === 1 && _getSelectedProjects(service.projects)[0].direction === 'outgoing';
	}

	function archive() {
		return Project.bulkArchive({selected: service.selectedProjects}).$promise;
	}

	function clone() {
		var project = _.findWhere(service.projects, {
			id: service.selectedProjects[0]
		});

		Wizard.saveStateInLocalStorage({
			matterType: project.matter_type,
			definings: [project.jurisdiction],
			expertiseType: project.expertise_type,
			subMatter: project.sub_matter
		});

		Navigation.go('community.wizard');
	}

	function _getQueryParams() {
		return angular.extend({}, service.pagination.getParams(), service.filterParams);
	}

	function _onNewProjectsAdded(newProjects) {
		service.hasGroups = (_.some(_.countBy(service.projects, 'matter'), function(count) {
			return count > 1;
		}));

		_addToUnreadUpdater(newProjects);

		service.selectedProjects = _getSelectedProjectsIds(service.projects);

		if (service.hasGroups && service.groupByFamily) {
			service.projectsByFamily = _groupByKeepOrder(service.projects, 'matter');
		}
	}

	function _addToUnreadUpdater(projects) {
		_.forEach(projects, function(project) {
			unreadUpdater.addConversations(project.supplier_conversations);
		});
	}

	function _getSelectedProjects(projects) {
		return _.filter(projects, {selected: true});
	}

	function _getSelectedProjectsIds(projects) {
		return _.pluck(_getSelectedProjects(projects), 'id');
	}

	function _groupByKeepOrder(arr, prop) {
		var newArr = [], // array to return, keeps track of order
			wrapObj = {}; // temporary object used for grouping

		_.forEach(arr, function(item) {
			// gets property name to group by and converts it to a string for grouping purposes
			var propName = item[prop];
			if (propName) {
				propName = propName.toString();

				// checks if group exists already and creates a new group if not, pushing it into the array to return ('newArr')
				if (!wrapObj[propName]) {
					wrapObj[propName] = [];
					newArr.push(wrapObj[propName]);
				}

				// adds item to the group
				wrapObj[propName].push(item);
			} else {
				console.warn(
					"utils -> groupByKeepOrder",
					"Property '" + prop + "' not found within object. It will be ignored from the output.",
					item
				);
			}
		});

		return newArr
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.constant('ProjectOrdering', {
		RECENT_ACTIVITY: '-last_activity',
		CREATION_DATE: '-created'
	});

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.directive('cmntProjectOrdering', function() {
		return {
			scope: {
				ordering: '=',
				onOrderingChanged: '&',

				selectTheme: '@?',
				iconExtraClass: '@?'
			},
			templateUrl: 'projects/projectOrdering.directive.html',
			controller: ProjectOrderingController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

ProjectOrderingController.$inject = ['ProjectOrdering'];

function ProjectOrderingController(ProjectOrdering) {
	var vm = this;

	vm.selectTheme = vm.selectTheme || 'select_theme_gray';

	vm.orderingOptions = [
		{label: 'Recent Activity', value: ProjectOrdering.RECENT_ACTIVITY},
		{label: 'Creation Date', value: ProjectOrdering.CREATION_DATE}
	];
	vm.orderingChanges = orderingChanges;

	function orderingChanges() {
		vm.onOrderingChanged({newValues: {ordering: vm.ordering}});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.directive('cmntProjectPlaceholder', function() {
		return {
			scope: {},
			templateUrl: 'projects/projectPlaceholder.directive.html',
			controller: ProjectPlaceholderControlelr,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

ProjectPlaceholderControlelr.$inject = [];

function ProjectPlaceholderControlelr() {
	var vm = this;


}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.constant('ProjectStatusValue', {
		'inquiry': 'Enquiry',
		'sent': 'Instructions sent',
		'confirmed': 'Confirmed',
		'completed': 'Completed',
		'withdrawn': 'Withdrawn',
		'cancelled': 'Rejected',
		'project_cancelled': 'Cancelled',
		'draft': 'Draft'
	});

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.filter('projectStatus', projectStatus);

projectStatus.$inject = ['ProjectStatusValue', '$filter'];

function projectStatus(ProjectStatusValue, $filter) {
	return function(project, isHumanReadable) {
		var perceivedStatus;
		var conversation = _getMainConversation(project);

		if (project.direction === 'outgoing') {
			switch (project.status) {
				case 'draft':
					perceivedStatus = project.supplier_conversations.length > 0 ? 'inquiry' : 'draft';
					break;
				case 'active':
					perceivedStatus = conversation.status;
					break;
				case 'cancelled':
					perceivedStatus = 'project_cancelled';
					break;
			}
		} else {
			perceivedStatus = conversation.status;
		}

		if (isHumanReadable !== false) {
			if (perceivedStatus === 'quoted') {
				return $filter('conversationStatus')(conversation);
			} else {
				return ProjectStatusValue[perceivedStatus];
			}
		} else {
			return perceivedStatus;
		}
	};

	function _getMainConversation(project) {
		if (project.direction === 'incoming') {
			return project.supplier_conversations[0];
		} else {
			var supplierConvId = project.supplier_conversation;

			return _.findWhere(project.supplier_conversations, {id: supplierConvId});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.directive('cmntProjectStatusFilter', function() {
		return {
			scope: {
				status: '=',
				onFiltersChanged: '&',

				showDraftOption: '=?'
			},
			templateUrl: 'projects/projectStatusFilter.directive.html',
			controller: ProjectStatusFilterController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

ProjectStatusFilterController.$inject = ['ProjectStatusValue'];

function ProjectStatusFilterController(ProjectStatusValue) {
	var vm = this;
	vm.showDraftOption = vm.showDraftOption || false;

	vm.statusOptions = [
		{label: 'Active', value: 'active'},
		{label: ProjectStatusValue.inquiry, value: 'inquiry'},
		{label: ProjectStatusValue.sent, value: 'sent'},
		{label: ProjectStatusValue.confirmed, value: 'confirmed'},
		{label: ProjectStatusValue.completed, value: 'completed'},
		{label: ProjectStatusValue.withdrawn, value: 'withdrawn'},
		{label: ProjectStatusValue.cancelled, value: 'cancelled'},
		{label: ProjectStatusValue.project_cancelled, value: 'project_cancelled'}
	];

	if (vm.showDraftOption) {
		vm.statusOptions.push({label: ProjectStatusValue.draft, value: 'draft'});
	}

	vm.statusChanged = statusChanged;

	function statusChanged() {
		vm.onFiltersChanged({newValues: {status: vm.status}});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.constant('ProjectStatusIcon', {
		'inquiry': 'icon-awaiting',
		'draft': 'icon-awaiting',
		'sent': 'icon-case-sent',
		'confirmed': 'icon-case-confirmed',
		'completed': 'icon-case-completed',
		'withdrawn': 'icon-case-withdrawn',
		'cancelled': 'icon-case-cancelled',
		'project_cancelled': 'icon-case-cancelled',
		'quoted': 'icon-dollar'
	});

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.run(runConfig);

runConfig.$inject = ['ProjectService', 'ProjectsList'];

function runConfig(ProjectService, ProjectsList) {
	ProjectService.init();
	ProjectsList.init();
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.controller('ProjectsController', ProjectsController);

ProjectsController.$inject = ['$scope', 'ProjectsList', 'AuthService', 'ProjectOrdering'];

function ProjectsController($scope, ProjectsList, AuthService, ProjectOrdering) {
	var vm = this;

	var currentUser;

	vm.ProjectsList = ProjectsList;

	vm.ordering = ProjectOrdering.RECENT_ACTIVITY;
	vm.status = 'active';
	vm.direction = 'all';

	vm.loadMore = loadMore;
	vm.archive = archive;
	vm.filtersChanged = filtersChanged;
	vm.orderingChanged = orderingChanged;
	vm.directionChanged = directionChanged;
	vm.searchChanged = searchChanged;
	vm.toggleGrouping = toggleGrouping;

	activate();

	$scope.$on('userAuthenticated', function() {
		activate();
	});

	function activate() {
		ProjectsList.groupByFamily = true;

		AuthService.isAuthenticated().then(function(user) {
			currentUser = user;

			if (currentUser)
				_loadProjects();
			else
				ProjectsList.loadEmpty();
		});
	}

	function filtersChanged(newValues) {
		_loadProjects(newValues);
	}

	function orderingChanged(newValues) {
		_loadProjects(newValues);
	}

	function loadMore() {
		vm.animateTiles = false;
		vm.loadingMore = {$resolved: false};
		ProjectsList.loadMore().finally(function() {
			vm.loadingMore.$resolved = true;
		});
	}

	function toggleGrouping() {
		vm.animateTiles = false;

		ProjectsList.toggleGrouping();
	}

	function _loadProjects(filterParams) {
		if (!currentUser) return;

		vm.animateTiles = true;

		var queryParams = _getQueryParams(filterParams);

		ProjectsList.load(queryParams);
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		return {
			jurisdiction: ('jurisdiction' in newValues) ? newValues.jurisdiction : vm.jurisdiction,
			jurisdiction__matter_type: ('matterType' in newValues) ? newValues.matterType : vm.matterType,
			direction: ('direction' in newValues) ? newValues.direction : vm.direction,
			status: ('status' in newValues) ? newValues.status : vm.status,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			fulltext: ('fulltext' in newValues) ? newValues.fulltext : vm.fulltext,
			// relation: 'none'
		};
	}

	function directionChanged() {
		_loadProjects({direction: vm.direction});
	}

	function searchChanged() {
		_loadProjects({fulltext: vm.search});
	}

	function archive() {
		ProjectsList.archive().then(function() {
			_loadProjects();
		});
	}

}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	var searchParamsConfig = {
		dynamic: true,
		replace: true
	};

	$stateProvider
		.state('community.projects', {
			url: 'projects_inst',
			templateUrl: 'projects/projects.html',
			abstract: true
		})
		.state('community.projects.projectsList', {
			url: '',
			sticky: true,
			views: {
				projectsList: {
					templateUrl: 'projects/projectsList.html',
					controller: 'ProjectsController as vm'
				}
			}
		})
		.state('community.projects.projectsDetail', {
			url: '/{projectId:int}?chooserOpen&chooserIds',
			views: {
				projectsDetail: {
					templateUrl: 'projects/projectDetail.html',
					controller: 'ProjectDetailController as vm'
				},
				"header@community": {
					templateUrl: 'projects/projectDetailHeader.html',
					controller: 'ProjectDetailHeaderController as vm'
				}
			},
			resolve: {
				project: getProject,
				conversations: getConversations,
				expertsChooserDelegate: getExpertsChooserDelegate,
				currentUser: getCurrentUser,
				uploadService: getUploadService
			},
			data: {
				authRequired: true,
				authAllowInactive: true
			},
			onEnter: projectsDetailEnter,
			onExit: projectsDetailExit,
			params: {
				chooserOpen: searchParamsConfig,
				chooserIds: searchParamsConfig
			}
		})
		.state('community.projects.projectsDetail.conversation', {
			url: '/conversations/{conversationId:int}',
			templateUrl: 'projects/projectConversation.html',
			controller: 'ProjectConversationController as vm',
			onExit: conversationExit,
			data: {
				authRequired: true,
				authAllowInactive: true
			}
		})
}

getProject.$inject = ['$stateParams', 'ProjectService', '$q', '$state'];

function getProject($stateParams, ProjectService, $q, $state) {
	return ProjectService.setProject($stateParams.projectId).then(function() {
		return ProjectService.project;
	}, function(error) {
		$state.go('community.ip.families');

		return $q.reject(error);
	});
}

getConversations.$inject = ['ProjectService', 'project'];

function getConversations(ProjectService, project) {
	return ProjectService.loadConversations(project).then(function() {
		return ProjectService.conversations;
	});
}

getUploadService.$inject = ['UploadService'];

function getUploadService(UploadService) {
	return UploadService();
}

projectsDetailEnter.$inject = ['$transition$', 'conversations', '$state'];

function projectsDetailEnter($transition$, conversations, $state) {
	var name = $transition$.to().name;

	if (name === 'community.projects.projectsDetail' && conversations.length > 0) {
		var params = angular.extend({
			conversationId: conversations[0].id
		}, $transition$.params('to'));

		return $state.target('.conversation', params, {relative: name});
	}
}

projectsDetailExit.$inject = ['ProjectService'];

function projectsDetailExit(ProjectService) {
	ProjectService.cleanup();
}

getExpertsChooserDelegate.$inject = ['ExpertsChooserDelegate'];

function getExpertsChooserDelegate(ExpertsChooserDelegate) {
	return ExpertsChooserDelegate();
}

getCurrentUser.$inject = ['UserService'];

function getCurrentUser(UserService) {
	return UserService.getCurrent().$promise;
}

conversationExit.$inject = ['uploadService'];

function conversationExit(uploadService) {
	if (uploadService.activeUploads > 0) {
		return uploadService.showActiveUploadsWarning();
	}
}

})();
(function() {
'use strict';
angular
	.module('community.projects')
	.factory('StoredInput', StoredInput);

StoredInput.$inject = ['Storage'];

function StoredInput(Storage) {
	return {
		store: store,
		retrieve: retrieve,
		clear: clear
	};

	function store(conversationId, postType, state) {
		var storageKey = _getKey(conversationId),
			data = Storage.get(storageKey) || {};

		data.postType = postType;

		if (state) {
			data[postType] = state;
		}

		Storage.put(storageKey, data);
	}

	function retrieve(conversationId, postType) {
		var storageKey = _getKey(conversationId),
			data = Storage.get(storageKey) || {};

		postType = postType || data.postType;

		if (postType) {
			return angular.extend(data[postType] || {}, {postType: postType});
		}
	}

	function clear(conversationId, postType) {
		var storageKey = _getKey(conversationId),
			data = Storage.get(storageKey) || {};

		delete data[postType];

		Storage.put(storageKey, data);
	}

	function _getKey(projectId) {
		return 'conversation-input-' + projectId;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.reports').factory('ApiObjectsList', ['ArrayHelper', function(ArrayHelper) {
	return function() {
		var dynamicObjectsList = [];

		dynamicObjectsList.$resolved = false;

		dynamicObjectsList.clearAndUnresolve = function() {
			this.$resolved = false;
			this.length = 0;
		};

		dynamicObjectsList.resolve = function(objects) {
			ArrayHelper.replaceAll(this, objects);

			this.$resolved = true;
		};

		dynamicObjectsList.replace = function(object) {
			return ArrayHelper.replaceSameId(this, object);
		};

		dynamicObjectsList.remove = function(object) {
			ArrayHelper.removeById(this, object.id);
		};

		dynamicObjectsList.extendObject = function(newObject) {
			var oldObject = ArrayHelper.findById(this, newObject.id);
			if (oldObject) {
				angular.extend(oldObject, newObject);
			}
		};

		return dynamicObjectsList;
	}
}]);

})();
(function() {
'use strict';
angular
	.module('community.reports').factory('BaseReportController', [
	'$state', '$modal', 'FilteringStateService', '$location', 'ArrayHelper', 'Storage', '$filter', '$q',
	'Organizations', 'ReportRecipient', '$timeout',
	function($state, $modal, FilteringStateService, $location, ArrayHelper, Storage, $filter, $q,
			 Organizations, ReportRecipient, $timeout) {
		return function(reportService, signalsOrigin) {
			var tableHelper = reportService.getTableHelper(),
				filteringService = reportService.getFilteringService(),
				queriesResource = filteringService.getQueriesResource(),
				facetsGetter = filteringService.getFacetsForField;

			// -- Load initial data --

			var filteringStateKey = (reportService.uiState.filteringStateKeyOverride || $state.current.name) + '-filtering-state';

			var detailedQueryPageParam = 'detailedQueryPage',
				defaultQueryExists = filteringService.defaultStoredQuery !== undefined;

			var currentFilteringState,
				filteringStateDefer = $q.defer(),
				filteringStateReady = filteringStateDefer.promise;

			var storedQueries = queriesResource.query();
			var baseFilters = filteringService.getBaseFilters();

			function getStateFromUrl(filteringStateService) {
				var searchParams = $location.search(),
					specificQueryPage = detailedQueryPageParam in searchParams;

				if (specificQueryPage) {
					return storedQueries.$promise.then(function(storedQueries) {
						var queryId = $location.search()[detailedQueryPageParam],
							query = ArrayHelper.findById(storedQueries, queryId);

						return filteringStateService.getStateFromStoredQuery(query);
					});
				} else {
					return $q(function(resolve) {
						resolve(filteringStateService.getStateFromUrl(searchParams));
					});
				}
			}

			function applyFilters(filteringParams) {
				filteringService.setParams(filteringParams);
				reportService.clearStateAndReload();
			}

			function setUpUiFromFilteringState(filteringState) {
				filteringService.cleanFiltersMap(baseFilters);

				if (filteringState) {
					filteringService.pushFiltersToMap(filteringState.getInstances());
					//filteringService.orderingService.orderBy = filteringState.getOrderingField();

					var storedQueryId = filteringState.getStoredQueryId();
					if (storedQueryId !== undefined) {

						storedQueries.$promise.then(function(storedQueries) {
							filteringService.storedQuery = ArrayHelper.findById(storedQueries, storedQueryId) || {};

							filteringService.newQuery = {name: filteringService.storedQuery.name || ''};
						});

					}

					reportService.uiState.filtersCollapsed = false;
				}
			}

			baseFilters.$promise.then(function(baseFilters) {
				var filteringStateService = FilteringStateService(baseFilters, facetsGetter);

				filteringService.initFiltersMap(baseFilters);

				return getStateFromUrl(filteringStateService).then(function(state) {
					if (!state) {
						var serializedStateData = Storage.get(filteringStateKey);

						if (serializedStateData) {
							state = filteringStateService.getSerializedState(serializedStateData);
							filteringService.hasChanges = serializedStateData['has_changes'] || false;
						} else if (filteringService.defaultFilterInstances.length > 0) {
							state = filteringStateService.getStateFromDefaultFilters(filteringService.defaultFilterInstances)
						} else if (defaultQueryExists) {
							return storedQueries.$promise.then(function(storedQueries) {
								var queryParams = filteringService.defaultStoredQuery,
									query = $filter('filter')(storedQueries, queryParams)[0];

								return [filteringStateService.getStateFromStoredQuery(query), filteringStateService];
							})
						}
					}

					return [state, filteringStateService];
				});
			}).then(function(stateArray) {
				var filteringState = stateArray[0],
					filteringStateService = stateArray[1];

				filteringStateDefer.resolve(filteringStateService);

				if (filteringState) {
					applyFilters(filteringState.getUrlParams());
					//storeFilteringStateInUrl(filteringState);
					setUpUiFromFilteringState(filteringState);

					currentFilteringState = filteringState;
				} else {
					applyFilters({});
				}
			});

			function getFilteringStateFromUi(filteringStateService) {
				return filteringStateService.getStateFromUi(filteringService.storedQuery.id, filteringService.getFilterInstances(),
					filteringService.chosenColumns, filteringService.orderingService.orderBy);
			}

			function clearFilters() {
				currentFilteringState = undefined;

				filteringService.setParams({});
				reportService.clearStateAndReload();
			}

			function clearUi() {
				filteringService.cleanFiltersMap(baseFilters);

				filteringService.storedQuery = {};
				filteringService.newQuery = {name: ''}
			}

			function storeFilteringStateInUrl(filteringState) {
				$location.search(filteringState.getUrlParams());
				$location.state({state: 'reports'});
			}

			function removeFilteringStateFromUrl() {
				$location.search('');
			}

			var popstateHandler = function(event) {
				// Gets called when the user hits "back" in the browser.

				filteringStateReady.then(function(filteringStateService) {
					getStateFromUrl(filteringStateService).then(function(urlFilteringState) {
						if (urlFilteringState) {
							applyFilters(urlFilteringState.getUrlParams());
							setUpUiFromFilteringState(urlFilteringState);

							currentFilteringState = urlFilteringState;
						} else {
							clearUi();
							applyFilters({});
						}
					});
				});
			};

			window.addEventListener('popstate', popstateHandler);

			signalsOrigin.$on('$destroy', function() {
				filteringStateReady.then(function() {
					window.removeEventListener('popstate', popstateHandler);

					if (currentFilteringState) {
						Storage.put(filteringStateKey, angular.extend(currentFilteringState.getSerializedForm(), {
							has_changes: filteringService.hasChanges
						}));
					}
				});
			});

			// stored queries
			function activateStoredQuery(query, filteringStateService) {
				filteringService.hasChanges = false;
				var queryFilteringState = filteringStateService.getStateFromStoredQuery(query);

				applyFilters(queryFilteringState.getUrlParams());
				setUpUiFromFilteringState(queryFilteringState);
				storeFilteringStateInUrl(queryFilteringState);

				currentFilteringState = queryFilteringState;
			}

			return {
				objects: reportService.objects,
				columns: reportService.columns,
				baseFilters: baseFilters,
				storedQueries: storedQueries,
				listLoaded: true,

				reportParams: angular.copy(reportService.getReportParameters()),

				filteringService: filteringService,
				orderingService: reportService.getOrderingService(),
				paginationService: reportService.getPaginationService(),
				selectionService: reportService.getSelectionService(),

				requestInProgress: false,

				uiState: reportService.uiState,

				dropdowns: {
					save: false,
					email: false
				},

				toggleExpand: function(object, stopToggle) {
					//return tableHelper.expandObject(object, detailedObjectCallback);
					if (!stopToggle) {
						if (object.expanded === undefined) {
							object.expanded = true;
						} else {
							object.expanded = !object.expanded;
						}
					}
				},
				reset: function(object) {
					tableHelper.resetObject(object);

					signalsOrigin.$broadcast('formSaved'); // remove errors from the form's fields after reset
				},
				edit: function(object) {
					var self = this;

					self.requestInProgress = true;

					return tableHelper.update(object).then(function() {
						signalsOrigin.$broadcast('formSaved'); // make form pristine
					}, function(response) {
						signalsOrigin.$broadcast('formErrors-inner-' + object.id, response.data);
					}).finally(function() {
						self.requestInProgress = false;
					})
				},
				remove: function(object) {
					return tableHelper.remove(object, this.objects);
				},
				changePage: function() {
					$timeout(function() {
						reportService.reloadData();
					});
				},
				bulkDelete: function() {
					var self = this;
					self.listLoaded = false;
					return reportService.bulkDelete().finally(function() {
						self.listLoaded = true;
					});
				},
				hasDetailedState: function() {
					return reportService.getDetailedStateName() !== undefined;
				},
				goToDetailed: function(object, memoboxId) {
					var detailedState = reportService.getDetailedStateName();

					if (detailedState) {
						$state.go(detailedState, {memobox_id: memoboxId || object.memobox.id, object_id: object.id})
					}
				},
				getDetailedUrl: function(object, memoboxId) {
					var detailedState = reportService.getDetailedStateName();
					if (detailedState) {
						var memoboxId = memoboxId || object.memobox.id;
						detailedState = $state.href(detailedState, {memobox_id: memoboxId, object_id: object.id});
						return detailedState;
					}
					return '';
				},
				orderBy: function(field, fieldLabel, $close) {
					this.uiState.orderManuallyChanged = true;

					this.orderingService.updateOrder(field);

					this.uiState.orderLabel = fieldLabel;
					this.uiState.order = this.orderingService.orderBy;

					if ($close !== undefined) {
						$close();
					}
				},
				showColumns: function() {
					var self = this;
					return $modal.open({
						templateUrl: 'reports/filtering/column_chooser_modal.html',
						size: 'lg',
						resolve: {
							filteringService: function() {
								return filteringService
							}
						},
						controller: ['$scope', '$modalInstance', 'filteringService', function($scope, $modalInstance, filteringService) {
							$scope.availableColumns = angular.copy(filteringService.availableColumns);
							$scope.chosenColumns = angular.copy(filteringService.chosenColumns);

							$scope.close = function() {
								$modalInstance.dismiss();
							};

							$scope.apply = function() {
								$modalInstance.close({
									availableColumns: $scope.availableColumns,
									chosenColumns: $scope.chosenColumns
								});
							}
						}]
					}).result.then(function(columns) {
						filteringService.availableColumns = columns.availableColumns;
						if (!angular.equals(filteringService.chosenColumns, columns.chosenColumns)) {
							filteringService.hasChanges = true;
						}
						filteringService.chosenColumns = columns.chosenColumns;
						self.applyFilters();
					})
				},
				applyFilters: function() {
					filteringStateReady.then(function(filteringStateService) {
						var uiState = getFilteringStateFromUi(filteringStateService);

						applyFilters(uiState.getUrlParams());
						storeFilteringStateInUrl(uiState);

						currentFilteringState = uiState;
					});
				},
				loadQuery: function(storedQuery) {
					return filteringStateReady.then(function(filteringStateService) {
						if (storedQuery.id === filteringService.storedQuery.id) {
							filteringService.storedQuery = {};
							filteringService.newQuery = {name: ''};

							var uiState = getFilteringStateFromUi(filteringStateService);
							storeFilteringStateInUrl(uiState);
							currentFilteringState = uiState;
						} else {
							activateStoredQuery(storedQuery, filteringStateService);
						}
					});
				},
				deleteQuery: function(query) {
					return queriesResource.delete({id: query.id}).$promise.then(function() {
						ArrayHelper.removeById(storedQueries, query.id);

						// clear ui and filtering when deleting currently chosen query
						if (filteringService.storedQuery.id === query.id) {
							clearUi();
							clearFilters();
							removeFilteringStateFromUrl();
						}
					});
				},
				toggleDropdown: function($event, name) {
					$event.preventDefault();
					$event.stopPropagation();
					this.dropdowns[name] = !this.dropdowns[name];
				},
				saveQuery: function() {
					return filteringStateReady.then(function(filteringStateService) {
						var filteringState = getFilteringStateFromUi(filteringStateService);

						var storedQueryFilters = filteringState.getStoredQueryFields();

						angular.extend(filteringService.storedQuery, storedQueryFilters, filteringService.newQuery);

						var savingPromise;
						if (filteringService.storedQuery.id) {
							savingPromise = queriesResource.update(filteringService.storedQuery).$promise;
						} else {
							savingPromise = queriesResource.save(filteringService.storedQuery).$promise.then(function(storedQuery) {
								storedQueries.push(storedQuery);

								return storedQuery;
							})
						}

						return savingPromise.then(function(storedQuery) {
							activateStoredQuery(storedQuery, filteringStateService);
						})
					});
				},
				saveQueryAsNew: function() {
					if (filteringService.storedQuery.id) {
						return filteringStateReady.then(function(filteringStateService) {
							var filteringState = getFilteringStateFromUi(filteringStateService),
								copiedStoredQuery = filteringState.getStoredQueryFields();

							angular.extend(copiedStoredQuery, filteringService.newQuery);

							queriesResource.save(copiedStoredQuery).$promise.then(function(storedQuery) {
								storedQueries.push(storedQuery);

								activateStoredQuery(storedQuery, filteringStateService);
							});
						});
					}
				},
				addRecipients: function() {
					$modal.open({
						templateUrl: '_common/_directives/templates/recipient_picker.html',
						resolve: {
							chooseFrom: function() {
								return Organizations.currentMembers().$promise;
							},
							selectedUsers: function() {
								return ReportRecipient.query({stored_query: filteringService.storedQuery.id}).$promise;
							},
							queriesResource: function() {
								return queriesResource;
							},
							storedQuery: function() {
								return filteringService.storedQuery;
							},
							storedQueryHasChanges: function() {
								return filteringService.hasChanges;
							}
						},
						controller: 'RecipientPickerController'
					}).result.finally(function() {
						//getRecipients($scope.storedQuery.id);
					});
				},
				clearFilters: function() {
					Storage.remove(filteringStateKey);

					clearUi();
					clearFilters();
					removeFilteringStateFromUrl();
				},
				changeView: reportService.changeView
			};
		}
	}]);

})();
(function() {
'use strict';
angular
	.module('community.reports').factory('momentResourceTransformation', function() {
	var ignored_formats = ["YYYY-DDD", "YYYY-DDDD"];
	return function(excludedFields) {
		excludedFields = excludedFields || [];

		var transformResponse = (function(json, headers) {
			if (!json) {
				return json;
			}

			var data = angular.fromJson(json);

			function convertDateFieldsToMoment(transformedObject) {
				for (var fieldName in transformedObject) {
					if (transformedObject.hasOwnProperty(fieldName)) {
						var currentField = transformedObject[fieldName];

						if (angular.isObject(currentField)) {
							convertDateFieldsToMoment(currentField);
						} else if (typeof currentField == 'string' && excludedFields.indexOf(fieldName) === -1) {
							var m = moment(currentField, ignored_formats, true);
							if (!m.isValid()) { //Transform if format is not ignored
								var momentDateYmd = moment(currentField, "YYYY-MM-DD", true);

								if (momentDateYmd.isValid()) {
									momentDateYmd._isDate = true;
									transformedObject[fieldName] = momentDateYmd;
								} else {
									var momentDateIso = moment(currentField, moment.ISO_8601, true);
									if (momentDateIso.isValid()) {
										transformedObject[fieldName] = momentDateIso;
									}
								}
							}
						}
					}
				}
			}

			if (angular.isObject(data)) {
				convertDateFieldsToMoment(data);
			}

			return data;
		});

		var transformRequest = function(data, headers) {
			var dataClone = angular.copy(data);

			function convertMomentFieldsToStrings(transformedObject) {
				for (var fieldName in transformedObject) {
					if (transformedObject.hasOwnProperty(fieldName)) {
						var currentField = transformedObject[fieldName];

						if (typeof fieldName === 'string' && fieldName.charAt(0) === '$') continue;
						if (currentField === undefined) continue;

						if (moment.isMoment(currentField)) {
							if (currentField._isDate) {
								transformedObject[fieldName] = currentField.format("YYYY-MM-DD");
							} else {
								transformedObject[fieldName] = currentField.toISOString();
							}
						} else if (angular.isObject(currentField)) {
							convertMomentFieldsToStrings(currentField);
						}
					}
				}
			}

			if (angular.isObject(dataClone)) {
				convertMomentFieldsToStrings(dataClone);
			}

			return angular.toJson(dataClone);
		};

		return {
			transformRequest: transformRequest,
			transformResponse: transformResponse,
			updateActions: function(actions) {
				Object.keys(actions).forEach(function(key) {
					actions[key] = angular.extend({
						transformResponse: transformResponse,
						transformRequest: transformRequest
					}, actions[key]);

				});
				return actions;
			}
		}
	}
});

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.directive('openSaveDropdown', function() {
		return {
			require: 'dropdownToggle',
			restrict: 'A',
			link: function(scope, element, attrs, $toogleCtrl) {
				var ctrl = $toogleCtrl;
				scope.openSaveDropdownFunc = function() {
					ctrl.toggle();
				}
			}
		};
	});

})();
(function() {
'use strict';
angular
	.module('community.reports').factory('ordering', function() {
	function Ordering(defaultOrder, callback) {
		callback = callback || angular.noop;

		var self = this;
		self.orderBy = defaultOrder;

		function hasMinus(str) {
			if (!str) return false;

			return str.indexOf('-') == 0;
		}

		self.updateOrder = function(field) {
			var orderByNormalized = hasMinus(self.orderBy) ? self.orderBy.substr(1) : self.orderBy,
				fieldNormailzed = hasMinus(field) ? field.substr(1) : field;

			if (orderByNormalized === fieldNormailzed) {
				self.orderBy = (hasMinus(self.orderBy) ? '' : '-') + orderByNormalized;
			} else {
				self.orderBy = field;
			}

			callback();
		};

		self.isAsc = function(field) {
			return self.orderBy == field;
		};

		self.isDesc = function(field) {
			return self.orderBy == '-' + field;
		};

		self.getParams = function() {
			return {
				'ordering': self.orderBy
			}
		}
	}

	return function(defaultOrder, callback) {
		return new Ordering(defaultOrder, callback);
	}
});

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('ReportServiceFactory', [
		'$q', '$timeout',
		'DynamicFiltering', 'ordering', 'pagination', 'SelectionHelper',
		'UserService', 'OrganizationService',
		'ColumnListFactory', 'ApiObjectsList',
		'ArrayHelper', 'TableHelper',
		'defaultExportFormats',
		function($q, $timeout,
				 DynamicFiltering, ordering, pagination, SelectionHelper,
				 UserService, OrganizationService,
				 ColumnListFactory, ApiObjectsList,
				 ArrayHelper, TableHelper,
				 defaultExportFormats) {

			function getDefaultConfig() {
				return {
					defaultOrdering: '-created',
					objectsPerPage: 10,
					objectsResource: undefined,
					queriesResource: undefined,
					exportUrl: undefined,
					exportFormats: defaultExportFormats,
					bulkActionsTemplate: undefined,
					listTemplate: undefined,
					createObjectTemplate: undefined,
					updatePermissionThreshold: 'COLLABORATOR',
					detailedState: undefined,
					listOrderingOptions: [],
					objectsName: undefined,
					visibleFiltersCount: 10,
					hasFreeSearch: false
				}
			}

			function getFilteringService(objectsResource, queriesResource, orderingService, callback) {
				var filteringService = DynamicFiltering(objectsResource, queriesResource);

				filteringService.onFiltersChanged = callback;
				filteringService.orderingService = orderingService;

				return filteringService;
			}

			return function(reportControllerConfig) {
				var uiState = {
					orderLabel: 'None',
					order: '',
					view: 'reports',
					filtersCollapsed: false,
					orderManuallyChanged: false
				};

				var config = angular.extend(getDefaultConfig(), reportControllerConfig);

				var objectsResource = config['objectsResource'],
					queriesResource = config['queriesResource'];

				var orderingField = config['defaultOrdering'];

				if (orderingField) {
					var defaultFieldName = _cutMinus(orderingField);

					var orderingOptions = config['listOrderingOptions'],
						initialOrderingOption = orderingOptions.filter(function(option) {
							return _cutMinus(option.field) === defaultFieldName;
						})[0];

					if (initialOrderingOption) {
						uiState.orderLabel = initialOrderingOption.label;
						uiState.order = orderingField;
					}
				}

				var orderingService = ordering(orderingField, function() {
						reloadData();
					}),
					paginationService = pagination(1, config['objectsPerPage']),
					selectionService = SelectionHelper(),
					filteringService = getFilteringService(objectsResource, queriesResource, orderingService, function() {
						clearStateAndReload();
					});

				function getParamsFromServices() {
					var result = angular.extend({}, filteringService.getParams(), orderingService.getParams(),
						paginationService.getParams());

					if (config['hasFreeSearch'] && ('fulltext' in result) && !uiState.orderManuallyChanged) {
						result['ordering'] = undefined;
						orderingService.orderBy = undefined;
						uiState.order = undefined;
						uiState.orderLabel = 'None';
					}

					return result;
				}

				var columns = [],
					objects = ApiObjectsList();

				function reloadData() {
					var requestParams = getParamsFromServices(),
						action;

					objects.clearAndUnresolve();

					if (uiState.view === 'list') {
						action = objectsResource.listData;
					} else {
						action = objectsResource.dynamicData;
					}

					return action(requestParams, paginationService.handle).$promise.then(function(jsonResponse) {
						var columnList = ColumnListFactory(jsonResponse.columns);

						ArrayHelper.replaceAll(columns, columnList.getChosenOrderedColumns());
						objects.resolve(jsonResponse.data);

						selectionService.listUpdated(jsonResponse.data, paginationService.totalItems);
						filteringService.setColumns(jsonResponse.columns);
					});

				}

				function clearStateAndReload() {
					paginationService.currentPage = 1;
					selectionService.unselectAll();

					return reloadData();
				}

				var currentUser = UserService.getCurrent(),
					primaryOrganization = OrganizationService.primary();

				var tableHelper = TableHelper(objectsResource, paginationService, selectionService, reloadData);

				return {
					columns: columns,
					objects: objects,

					uiState: uiState,

					init: function() {
						return $q.all({
							currentUser: currentUser.$promise,
							primaryOrganization: primaryOrganization.$promise
						});
					},

					reloadData: function() {
						return reloadData();
					},

					getParamsFromServices: function() {
						return getParamsFromServices();
					},

					getOrderingService: function() {
						return orderingService;
					},

					getFilteringService: function() {
						return filteringService;
					},

					getPaginationService: function() {
						return paginationService;
					},

					getSelectionService: function() {
						return selectionService;
					},

					getTableHelper: function() {
						return tableHelper;
					},

					getReportParameters: function() {
						return {
							exportUrl: config['exportUrl'],
							exportFormats: config['exportFormats'],
							bulkActionsTemplate: config['bulkActionsTemplate'],
							listTemplate: config['listTemplate'],
							createObjectTemplate: config['createObjectTemplate'],
							updatePermissionThreshold: config['updatePermissionThreshold'],
							listOrderingOptions: config['listOrderingOptions'],
							objectsName: config['objectsName'],
							visibleFiltersCount: config['visibleFiltersCount'],
							hasFreeSearch: config['hasFreeSearch']
						};
					},

					performBulkAction: function(action) {
						var selection = selectionService.getSelection(),
							queryParams = getParamsFromServices();

						return action(queryParams, selection);
					},

					bulkDelete: function() {
						return this.performBulkAction(function(queryParams, selection) {
							return objectsResource.bulkDelete(queryParams, selection).$promise.then(function() {
								return clearStateAndReload();
							})
						});
					},

					getDetailedStateName: function() {
						return config.detailedState;
					},
					clearStateAndReload: function() {
						return clearStateAndReload()
					},
					changeView: function(name) {
						uiState.view = name;
						reloadData();
					},
					updateObject: function(object) {
						ArrayHelper.replaceSameId(objects, object);
					}
				};

				function _cutMinus(fieldName) {
					var minusIndex = fieldName.indexOf('-');

					if (minusIndex === 0) {
						fieldName = fieldName.slice(1);
					}

					return fieldName;
				}
			}
		}]);


angular
	.module('community.reports')
	.factory('ColumnListFactory', function() {
		return function(allColumns) {
			return {
				getChosenOrderedColumns: function() {
					return allColumns.filter(function(column) {
						return column['chosen'];
					}).sort(function(a, b) {
						return a['weight'] - b['weight'];
					})
				}
			}
		}
	});

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];

function setRoutes($stateProvider, $urlRouterProvider) {
	$urlRouterProvider
		.when("/reports", "/reports/projects");

	$stateProvider
		.state('community.reports', {
			url: 'reports',
			templateUrl: 'reports/reports.html',
			data: {
				authRequired: true,
				authAllowReadOnly: true
			}
		})
		.state('community.reports.projects', {
			url: '/projects?matter_type&{fulltext:any}&relation_contact',
			templateUrl: 'reports/base_report.html',
			controller: 'ProjectsReportController',
			reloadOnSearch: false
		})
		.state('community.reports.events', {
			url: '/events',
			templateUrl: 'reports/base_report.html',
			controller: 'EventsReportController'
		})
		.state('community.reports.tasks', {
			url: '/tasks',
			templateUrl: 'reports/base_report.html',
			controller: 'TasksReportController'
		})

		.state('community.reports.export_results', {
			url: '/export',
			views: {
				"@community": {
					templateUrl: 'reports/export/exportResults.html',
					controller: 'ExportResultsController as vm'
				}
			}
		})
}

})();
(function() {
'use strict';
angular
	.module('community.reports').factory('SelectionHelper', function() {
	function SelectionHelper() {
		var idsOnPage = [], // ids of objects on the currently chosen page
			totalObjectsCount = 0; // the total amount of objects on all available pages

		var selection = {
			all: false,
			unselected: [],
			setUnselected: function(id, value) {
				if (value) {
					if (this.unselected.indexOf(id) === -1) {
						this.unselected.push(id);
					}
				} else {
					var index = this.unselected.indexOf(id);
					if (index > -1) {
						this.unselected.splice(index, 1);
					}
				}
			},
			isUnselected: function(id) {
				return this.unselected.indexOf(id) > -1;
			}
		};

		this.all = false; // not the same thing as `selection.all`. `selection.all` isn't getting unchecked after a
						  // single item has been unselected, but `this.all` is.
		this.model = [];
		this.selectionLength = 0;

		var self = this;

		function isSelected(itemId) {
			return self.model.indexOf(itemId) > -1;
		}

		function select(idArray) {
			angular.forEach(idArray, function(id) {
				if (self.model.indexOf(id) === -1) {
					self.model.push(id);
				}
			});
		}

		this.toggleAll = function(newValue) {
			if (newValue === true) {
				select(idsOnPage);
				selection.unselected.length = 0;
				this.selectionLength = totalObjectsCount;
			} else {
				this.model.length = 0;
				this.selectionLength = 0;
			}

			selection.all = newValue;
		};

		this.checkBoxClick = function(id) {
			var selected = isSelected(id);

			if (this.all === true && !selected) {
				this.all = false;
			}

			if (selection.all) {
				selection.setUnselected(id, !selected);
				this.selectionLength = totalObjectsCount - selection.unselected.length;
			} else {
				this.selectionLength = this.model.length;
			}
		};

		this.listUpdated = function(objects, totalCount) {
			if (objects === undefined) return;

			idsOnPage = objects.map(function(object) {
				return object.id
			});
			totalObjectsCount = totalCount;

			if (selection.all) {
				select(idsOnPage.filter(function(id) {
					return selection.unselected.indexOf(id) === -1;
				}));
			}
		};

		this.setItemSelection = function(id, value) {
			if (value) {
				select([id]);
				this.selectionLength = this.model.length;
			} else {
				if (selection.all) {
					selection.setUnselected(id, false);
					this.selectionLength = totalObjectsCount - selection.unselected.length;
				} else {
					var index = this.model.indexOf(id);

					if (index > -1) this.model.splice(index, 1);
					this.selectionLength = this.model.length;
				}
			}
		};

		this.getSelection = function() {
			var resultingSelection = {
				field: undefined,
				value: undefined,
				all: selection.all
			};

			if (selection.all) {
				resultingSelection.unselected = angular.copy(selection.unselected);
			} else {
				resultingSelection.selected = angular.copy(this.model);
			}

			return resultingSelection;
		};

		this.unselectAll = function() {
			this.all = false;
			this.model.length = 0;
			this.selectionLength = 0;

			selection.all = false;
			selection.unselected.length = 0;
		}
	}

	return function() {
		return new SelectionHelper();
	};
});

})();
(function() {
'use strict';
angular
	.module('community.reports').factory('TableUtils', ['$timeout', function($timeout) {
	function TableUtils(resource, pagination, reloadObjects) {
		this.expandObject = function(object, detailedObjectCallback) {
			detailedObjectCallback = detailedObjectCallback || angular.noop;

			if (!object.expanded && object.detailed === undefined) {
				return resource.get({id: object.id}).$promise.then(function(detailedObject) {
					object.expanded = true;
					object.detailed = detailedObject;
					object.original = angular.copy(detailedObject);

					detailedObjectCallback(detailedObject);
				});
			}

			$timeout(function() {
				object.expanded = !object.expanded;
			})
		};

		this.chosenColumns = function(columns) {
			return columns.filter(function(column) {
				return column['chosen'];
			}).sort(function(a, b) {
				return a['weight'] - b['weight'];
			})
		};

		this.update = function(object) {
			return resource.update(object.detailed).$promise.then(function(updatedObject) {
				resource.dynamicDetail({id: object.id}).$promise.then(function(objectRepr) {
					angular.extend(object, objectRepr);

					object.detailed = updatedObject;
					object.original = angular.copy(updatedObject);
				})
			})
		};

		this.remove = function(object, objectsList) {
			var index = objectsList.indexOf(object);

			return resource.delete({id: object.id}).$promise.then(function() {
				objectsList.splice(index, 1);

				if (objectsList.length === 0) {
					if (pagination.currentPage > 1) {
						pagination.currentPage -= 1;
					}

					reloadObjects();
				}
			});
		};

		this.resetObject = function(object) {
			object.detailed = angular.copy(object.original);
		};
	}

	return function(resource, pagination, reloadObjects) {
		return new TableUtils(resource, pagination, reloadObjects);
	}
}]);


angular
	.module('community.reports').factory('TableHelper', ['$timeout', function($timeout) {
	return function(resource, paginationService, selectionService, reloadObjects) {
		return {
			expandObject: function(object, detailedObjectCallback) {
				detailedObjectCallback = detailedObjectCallback || angular.noop;

				if (!object.expanded && object.detailed === undefined) {
					return resource.get({id: object.id}).$promise.then(function(detailedObject) {
						object.expanded = true;

						object.detailed = detailedObject;
						object.original = angular.copy(detailedObject);

						detailedObjectCallback(detailedObject);
					});
				}

				$timeout(function() {
					object.expanded = !object.expanded;
				})
			},

			update: function(object) {
				return resource.update(object.detailed).$promise.then(function(updatedObject) {
					resource.dynamicDetail({id: object.id}).$promise.then(function(objectRepr) {
						angular.extend(object, objectRepr);

						object.detailed = updatedObject;
						object.original = angular.copy(updatedObject);
					})
				})
			},

			remove: function(object, objectsList) {
				var index = objectsList.indexOf(object);

				return resource.delete({id: object.id}).$promise.then(function() {
					objectsList.splice(index, 1);

					if (objectsList.length === 0) {
						if (paginationService.currentPage > 1) {
							paginationService.currentPage -= 1;
						}

						reloadObjects();
					}

					paginationService.totalItems -= 1;
					selectionService.listUpdated(objectsList, paginationService.totalItems);
					selectionService.setItemSelection(object.id, false);
				});
			},

			resetObject: function(object) {
				object.detailed = angular.copy(object.original);
			}
		}
	}
}]);

})();
(function() {
'use strict';
angular
	.module('community.selectizem')
	.directive('selectizem', function() {
		return {
			require: 'uiSelect',
			restrict: 'A',
			link: function(scope, element, attrs, $select) {
				var ctrl = $select;
				ctrl.sizeSearchInput = sizeSearchInput;
				ctrl.addLabel = attrs.addLabel ? attrs.addLabel : 'Item';

				function sizeSearchInput() {
					ctrl.searchInput.css('width', '100%');
				}
			}
		};
	});

})();
(function() {
'use strict';
angular
	.module('community.widgets')
	.directive('cmntJoinPrompt', function() {
		return {
			templateUrl: 'widgets/joinPrompt.directive.html',
			controller: JoinPromptController,
			controllerAs: 'vm',
			bindToController: true,
			scope: {},
			replace: true
		}
	});

JoinPromptController.$inject = [];

function JoinPromptController() {
	var vm = this;
}

})();
(function() {
'use strict';
angular
	.module('community.widgets')
	.directive('cmntJurisdictionFilter', function() {
		return {
			scope: {
				matterType: '=',
				defining: '=',

				matterTypeLabel: '@?',
				jurisdictionLabel: '@?',

				onFiltersChanged: '&'
			},
			templateUrl: 'widgets/jurisdictionFilter.directive.html',
			controller: JurisdicitonFilterController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

JurisdicitonFilterController.$inject = ['MatterTypes', 'DefiningService'];

function JurisdicitonFilterController(MatterTypes, DefiningService) {
	var vm = this;

	vm.onMatterTypeChanged = onMatterTypeChanged;
	vm.onDefiningChanged = onDefiningChanged;

	vm.matterTypeLabel = vm.matterTypeLabel || 'IP Type';
	vm.jurisdictionLabel = vm.jurisdictionLabel || 'Jurisdiction';

	activate();

	function activate() {
		_loadMatterTypes();
	}

	function onMatterTypeChanged() {
		vm.defining = undefined;

		_loadDefinings(vm.matterType).then(function() {
			_notifyClients();
		})
	}

	function onDefiningChanged() {
		_notifyClients();
	}

	function _notifyClients() {
		vm.onFiltersChanged({newValues: _getFilteringParams()});
	}

	function _loadMatterTypes() {
		return MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});
	}

	function _loadDefinings(matterType) {
		return DefiningService.usedInTargetJurisdictions(matterType).then(function(definings) {
			vm.definings = definings;
		});
	}

	function _getFilteringParams() {
		return {
			matterType: vm.matterType,
			defining: vm.defining,
			jurisdiction: vm.defining //new interface capability
		};
	}
}

})();
(function() {
'use strict';
angular
	.module('community.widgets')
	.directive('cmntPasswordStrength', function() {
		return {
			scope: {
				password: '='
			},
			templateUrl: 'widgets/passwordStrength.directive.html',
			controller: PasswordStrengthController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

var MIN_PASSWORD_LENGTH = 8;

var Scores = {
	SOMEWHAT_GUESSABLE: 2,
	SAFELY_UNGUESSABLE: 3
};

var StrengthLevel = {
	weak: {
		value: 'weak',
		label: 'Weak'
	},
	medium: {
		value: 'medium',
		label: 'Medium'
	},
	strong: {
		value: 'strong',
		label: 'Strong'
	}
};

PasswordStrengthController.$inject = ['$scope'];

function PasswordStrengthController($scope) {
	var vm = this;

	var barsAmountToStrengthLevel = {
		1: StrengthLevel.weak,
		2: StrengthLevel.medium,
		3: StrengthLevel.strong
	};

	vm.barsAmount = 0;
	vm.strengthLevel = undefined;

	activate();

	function activate() {
		$scope.$watch('vm.password', function(newValue, oldValue) {
			vm.barsAmount = newValue ? _passwordToBarsAmount(newValue) : 1;
			vm.strengthLevel = barsAmountToStrengthLevel[vm.barsAmount];
		});
	}

	function _passwordToBarsAmount(password) {
		var score = zxcvbn(password).score;

		if (score <= Scores.SOMEWHAT_GUESSABLE) {
			return 1;
		} else if (score <= Scores.SAFELY_UNGUESSABLE) {
			return 2;
		} else {
			return 3;
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.widgets')
	.directive('cmntStarRating', function() {
		return {
			templateUrl: 'widgets/starRating.directive.html',
			scope: {
				ratingValue: '=',
				extraClass: '@?'
			},
			controller: cmntStarRatingController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});


cmntStarRatingController.$inject = [];

function cmntStarRatingController() {
	var vm = this;

	vm.stars = [];

	updateStars();

	function updateStars() {
		var halfVisible = Math.abs(vm.ratingValue % 1) > 0;

		for (var i = 1; i <= 5; i++) {
			if (i < vm.ratingValue) {
				vm.stars.push({'filled': true})
			} else if (i === Math.ceil(vm.ratingValue)) {
				vm.stars.push({'half': halfVisible, 'filled': !halfVisible})
			} else {
				vm.stars.push({'empty': true})
			}
		}
	}

}

})();
(function() {
'use strict';
angular
	.module('community.widgets')
	.directive('cmntTestimonial', function() {
		return {
			scope: {},
			templateUrl: 'widgets/testimonial.directive.html',
			controller: TestimonialController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

TestimonialController.$inject = ['Testimonial'];

function TestimonialController(Testimonial) {
	var vm = this;

	activate();

	function activate() {
		Testimonial.query().$promise.then(function(objects) {
			vm.testimonial = objects[0];
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.wizard')
	.directive('cmntAttachments', function() {
		return {
			templateUrl: 'wizard/attachments.directive.html',
			scope: {
				uploadedFiles: '='
			},
			controller: CommunityAttachmentsController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

var TOTAL_ATTACHMENT_SIZE_WARNING = 20450000;
var ERRORS = {
	filesize: "Please keep the file size under {{ sizeLimit }}. Current size is {{ currentSize }}.",
	attachmentSize: "The total size of the uploaded files ({{ currentSize  }}) exceeds {{ sizeLimit }}, suppliers " +
		"won't be able to get them as email attachments."
};

CommunityAttachmentsController.$inject = ['$upload', '$filter', 'PekamaConfig', 'RestErrors', '$interpolate'];

function CommunityAttachmentsController($upload, $filter, PekamaConfig, RestErrors, $interpolate) {
	var vm = this;

	vm.startUploading = startUploading;
	vm.removeAttachment = removeAttachment;

	activate();

	function activate() {
		vm.attachments = [];
		vm.attachmentSizeWarning = '';
	}

	function startUploading(files) {
		files.forEach(function(file) {
			if (_exceedsFileSizeLimit(file)) {
				file.error = _error('filesize', {
					sizeLimit: $filter('filesize')(PekamaConfig.maxUploadFileSize),
					currentSize: $filter('filesize')(file.size)
				});

				vm.attachments.push(file);

				return;
			}

			var uploadingProcess = $upload.upload({url: PekamaConfig.apiBaseUrl + 'files/temp_files/', file: file});

			uploadingProcess.progress(function(event) {
				file.progress = parseInt(100.0 * event.loaded / event.total);
			}).then(function(response) {
				var uuid = response.data.uuid;

				file.uuid = uuid;
				vm.uploadedFiles.push(uuid);
			}, function(response) {
				file.error = RestErrors.asString(response.data);
			});

			file.uploadingProcess = uploadingProcess;

			vm.attachments.push(file);

			_updateAttachmentSizeWarning();
		});
	}

	function removeAttachment(attachment) {
		var index = vm.attachments.indexOf(attachment);

		if (index > -1) {
			vm.attachments.splice(index, 1);

			if (attachment.uploadingProcess) {
				attachment.uploadingProcess.abort();
			}

			var uuidIndex = vm.uploadedFiles.indexOf(attachment.uuid);
			if (uuidIndex > -1) {
				vm.uploadedFiles.splice(uuidIndex, 1);
			}
		}

		_updateAttachmentSizeWarning();
	}

	function _exceedsFileSizeLimit(file) {
		return file.size > PekamaConfig.maxUploadFileSize;
	}

	function _updateAttachmentSizeWarning() {
		var totalSize = _.chain(vm.attachments).filter(function(file) {
			return !file.error && file.uploadingProcess;
		}).reduce(function(acc, file) {
			return acc + file.size;
		}, 0).value();

		var errorText = _error('attachmentSize', {
			sizeLimit: $filter('filesize')(TOTAL_ATTACHMENT_SIZE_WARNING),
			currentSize: $filter('filesize')(totalSize)
		});

		vm.attachmentSizeWarning = totalSize > TOTAL_ATTACHMENT_SIZE_WARNING ? errorText : '';
	}

	function _error(errorType, errorContext) {
		var renderTemplate = $interpolate(ERRORS[errorType]);

		return renderTemplate(errorContext);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.wizard')
	.config(setRoutes);

setRoutes.$inject = ['$stateProvider'];

function setRoutes($stateProvider) {
	var searchParamsConfig = {
		dynamic: true,
		replace: true
	};

	$stateProvider
		.state('community.wizard', {
			url: 'wizard?preserveInput&chooserOpen&chooserIds',
			views: {
				'': {
					templateUrl: 'wizard/wizard.html',
					controller: 'WizardController as vm'
				},
				header: {
					templateUrl: 'wizard/wizardHeader.html',
					controller: 'WizardHeaderController as vm'
				}
			},
			data: {
				authRequired: true
			},
			params: {
				preserveInput: searchParamsConfig,
				chooserOpen: searchParamsConfig,
				chooserIds: searchParamsConfig
			},
			resolve: {
				expertsChooserDelegate: getExpertsChooserDelegate
			}
		})
}

getExpertsChooserDelegate.$inject = ['ExpertsChooserDelegate'];

function getExpertsChooserDelegate(ExpertsChooserDelegate) {
	return ExpertsChooserDelegate();
}

})();
(function() {
'use strict';
angular
	.module('community.wizard')
	.controller('WizardController', WizardController);

var _emptyLine = "<p><br></p>";
var INTRODUCTION_TEXT = "<p>Dear [supplier],</p>" +
	_emptyLine + "<p>Jurisdiction: [jurisdiction]</p>" +
	_emptyLine + "<p>I have some work in your jurisdiction. Can you please provide a price quote?</p>" +
	_emptyLine + "<p>Here is some relevant information:</p>" +
	"<p>Our Ref. Number:&nbsp;</p>" +
	"<p>Application number:&nbsp;</p>" +
	"<p>Deadline is: [deadline]</p>" +
	_emptyLine + "<p>Looking forward to hearing from you.</p>";


var INTRODUCTION_PHASE_TEXT = "<p>Dear [supplier],</p>" +
	_emptyLine + "<p>We are considering using your services for [task] in [jurisdiction].</p>" +
	"<p>Pekama auto-calculated the official fee to be [official] [officialcurrency] and a reasonable service charge to" +
	" be [service] [servicecurrency]. Can you please confirm that you are happy to proceed based on these estimates?</p>";

var INPUT_STORAGE_KEY = 'wizardInput';
var PRESERVE_INPUT_URL_PARAM = 'preserveInput';

WizardController.$inject = ['$scope', 'Wizard', 'MatterTypes', 'DefiningService', 'CommunityProfile', 'ProfileOrdering',
	'ArrayHelper', '$state', 'UploadService', '$location', 'Storage', 'expertsChooserDelegate', '$window',
	'JurisdictionCoverage', '$q', 'ExpertiseTypes', 'AlertFactory', 'RestErrors', 'Associate', '$timeout',
	'$http', 'PekamaConfig'];

function WizardController($scope, Wizard, MatterTypes, DefiningService, CommunityProfile, ProfileOrdering,
						  ArrayHelper, $state, UploadService, $location, Storage, expertsChooserDelegate, $window,
						  JurisdictionCoverage, $q, ExpertiseTypes, AlertFactory, RestErrors, Associate, $timeout,
						  $http, PekamaConfig) {
	var vm = this;

	vm.matterType = undefined;
	vm.definings = undefined;
	vm.expertiseType = undefined;

	vm.jurisdictionsWithouExperts = [];

	vm.wizardParams = Wizard.params;
	vm.UploadService = UploadService();
	vm.expertsChooserDelegate = expertsChooserDelegate;
	vm.jurisdictionCoverage = {};

	vm.profiles = undefined;

	vm.isServicesShowed = true;

	vm.customNumbersModels = {};
	vm.customNumbersFilter = customNumbersFilter;
	vm.initCustomNumber = initCustomNumber;

	vm.fileDropHandler = function fileDropHandler(file, insertAction) {
		return true;
	};
	vm.stepTwoDisabled = stepTwoDisabled;
	vm.stepThreeDisabled = stepThreeDisabled;
	vm.stepFourDisabled = stepFourDisabled;
	vm.projectTitleChanged = projectTitleChanged;
	vm.expertsSelected = expertsSelected;
	vm.removeAllExperts = removeAllExperts;
	vm.removeExpert = removeExpert;
	vm.removeAssociate = removeAssociate;
	vm.getActiveExperts = getActiveExperts;
	vm.getExperts = getExperts;
	vm.createFamily = createFamily;
	vm.createTask = createTask;
	vm.createEnquiry = createEnquiry;
	vm.addExperts = addExperts;

	vm.matterTypeChanged = matterTypeChanged;
	vm.processSelectsChange = processSelectsChange;

	vm.taskExpertiseTypeSelected = taskExpertiseTypeSelected;
	vm.taskTitleChanged = taskTitleChanged;

	var activatedWithExperts = false;

	activate();

	function activate() {
		_setDefaultInput();
		_initFilterValues().then(processSelectsChange);

		var inputRestored = $q.when();

		if (_shouldRestoreInput()) {
			var storedInput = _getStoredInput();

			if (storedInput) {
				inputRestored = _setInput(storedInput);
			}
		} else {
			_markInputForPreservation();
			_clearStoredInput();
		}

		inputRestored.then(function() {
			expertsChooserDelegate.openIfUrlParamPresent();
		});

		Wizard.initData();
		vm.matterType = Wizard.params.matterType;
		vm.definings = Wizard.params.definings;
		vm.expertiseType = Wizard.params.expertiseType;
		vm.subMatter = Wizard.params.subMatter;
		vm.projectTitle = Wizard.params.title;

		vm.task = Wizard.params.task;
		vm.taskTitle = Wizard.params.taskTitle;
		if (Wizard.params.taskDueDate && !moment.isMoment(Wizard.params.taskDueDate)) {
			vm.taskDueDate = moment(Wizard.params.taskDueDate);
		} else {
			vm.taskDueDate = Wizard.params.taskDueDate;
		}
		if (Wizard.params.templateText) {
			vm.detailsTextTemplate = Wizard.params.templateText;
		}

		if (!vm.pct) {
			vm.pct = Wizard.params.pct;
		}

		if (Wizard.params.profileIds && Wizard.params.profileIds.length > 0) {
			activatedWithExperts = true;
		}

		if (vm.subMatter && Wizard.params.cloneType) {
			var params = {sub_matter: vm.subMatter, type: Wizard.params.cloneType};
			$http.get(PekamaConfig.apiBaseUrl + 'enquiries/countries-prices/', {'params': params}).then(function(response) {
				vm.coutriesPrices = response.data;
			})
		}

		var listener = $scope.$watch(stepFourDisabled, function(newValue, oldValue) {
			if (!newValue && oldValue) {
				$timeout(function() {
					var element = $("#wizard-send");

					element.focus();
					element.removeClass("shake");

					$timeout(function() {
						element.addClass("shake");

						$timeout(function() {
							element.removeClass("shake");
						}, 300);
					});
				});
			}
		});

		$scope.$on('$destroy', function() {
			_preserveInput();

			Wizard.resetWizard();

			listener()
		});

		$window.onbeforeunload = function() {
			_preserveInput();
		}
	}

	function selectsChanged(newValues) {
		Wizard.saveStateInLocalStorage(newValues);
		Wizard.setFamilyData(newValues.matterType, newValues.definings, vm.subMatter);

		//_setProjectTitle(newValues);

		if (!activatedWithExperts && newValues.definings && newValues.definings.length !== 0) {
			CommunityProfile.query({
				active: true,
				activated: true,
				suggested: true,
				default_for_jurisdiction: newValues.definings,
				jurisdiction: newValues.definings
			}).$promise.then(function(profiles) {
				vm.profiles = profiles;
				Wizard.setProfileIds(_.pluck(getExperts(), 'id'));

				_setJurisdictionsWithouExpertsFromExperts();

				vm.jurisdictionCoverage = JurisdictionCoverage.getCoverage(vm.definings, vm.profiles, vm.associates);
			});
		} else {
			if (Wizard.params.profileIds && Wizard.params.profileIds.length > 0) {
				_loadProfiles(Wizard.params.profileIds);
				_loadAssociates(Wizard.params.profileIds);
			} else {
				_setJurisdictionsWithouExperts(newValues.definings)
			}
		}
	}

	function stepTwoDisabled() {
		return !vm.projectTitle || !vm.matterType || !vm.definings || vm.definings.length === 0;
	}

	function stepThreeDisabled() {
		return stepTwoDisabled() || !vm.taskTitle;
	}

	function stepFourDisabled() {
		return stepThreeDisabled() || !vm.detailsTextTemplate || getActiveExperts().length === 0
			|| !allCustomNumbersFilled();
	}

	function projectTitleChanged() {
		vm.customTitle = true;

		Wizard.setTitle(vm.projectTitle);

		_updateCustomNumbersSubject();
	}

	function expertsSelected(profileIds) {
		Wizard.setProfileIds(_.union(Wizard.params.profileIds, profileIds));

		$q.all([
			_loadProfiles(Wizard.params.profileIds),
			_loadAssociates(Wizard.params.profileIds)
		]).then(function() {
			expertsChooserDelegate.hide();
		});
	}

	function removeAllExperts() {
		vm.profiles = undefined;
		vm.associates = undefined;
		Wizard.setProfileIds(undefined);
		_setJurisdictionsWithouExperts(vm.definings);
	}

	function removeExpert(profile) {
		_removeExpert(vm.profiles, profile);
	}

	function removeAssociate(associate) {
		_removeExpert(vm.associates, associate);
	}

	function _removeExpert(list, expert) {
		ArrayHelper.removeById(list, expert.id);

		Wizard.setProfileIds(_.pluck(getExperts(), 'id'));
		_setJurisdictionsWithouExpertsFromExperts();
	}

	function addExperts() {
		vm.jurisdictionCoverage = JurisdictionCoverage.getCoverage(vm.definings, vm.profiles, vm.associates);
		expertsChooserDelegate.show();
	}

	function getExperts() {
		return [].concat(vm.profiles || [], vm.associates || []);
	}

	function getActiveExperts() {
		return _.filter(getExperts(), {expert_disabled: false});
	}

	function createFamily() {
		Wizard.setTitle(vm.projectTitle);
		return Wizard.createFamily().then(function() {
			_clearStoredInput();

			$state.go('community.ip.families');
		}, function(response) {
			AlertFactory(RestErrors.asString(response.data), 'ERRORS');
		});
	}

	function createTask() {
		Wizard.setTitle(vm.projectTitle);
		Wizard.setTaskData(_.pick(vm, 'task', 'taskTitle', 'taskDueDate'));

		return Wizard.createTask().then(function() {
			_clearStoredInput();

			$state.go('community.ip.families');
		}, function(response) {
			AlertFactory(RestErrors.asString(response.data), 'ERRORS');
		});
	}

	function createEnquiry() {
		Wizard.setTitle(vm.projectTitle);
		Wizard.setTaskData(_.pick(vm, 'task', 'taskTitle', 'taskDueDate'));

		var files = vm.UploadService.getUploadedFiles();
		var customNumbers = _.map(vm.definings, function(defining_id) {
			var model = vm.customNumbersModels[defining_id];
			var number = model.number || "";
			var subject = model.subject || "";
			if (number.length !== 0 && subject.length !== 0) {
				subject = number + " " + subject;
			}
			return {
				jurisdiction: defining_id, number: number, subject: subject
			}
		});
		Wizard.setEnquiryData(vm.detailsTextTemplate, _.pluck(files, 'uuid'), vm.expertiseType, customNumbers);
		Wizard.setProfileIds(_.pluck(getActiveExperts(), 'id'));

		return Wizard.createEnquiry().then(function(data) {
			_clearStoredInput();

			$state.go('community.projects.projectsDetail', {projectId: data.id}, {replace: true});
		}, function(response) {
			AlertFactory(RestErrors.asString(response.data), 'ERRORS');
		});

	}

	function taskExpertiseTypeSelected($item) {
		vm.expertiseType = $item.id;
		vm.isServicesShowed = false;

		_updateCustomNumbersSubject();
	}

	function taskTitleChanged() {
		vm.isServicesShowed = true;

		_updateCustomNumbersSubject();
	}

	function _setDefaultInput() {
		vm.UploadService.init();

		vm.customTitle = false;
		vm.projectTitle = '';
		if (!Wizard.params.cloneType) {
			vm.detailsTextTemplate = INTRODUCTION_TEXT;
		} else {
			vm.detailsTextTemplate = INTRODUCTION_PHASE_TEXT;
		}
		vm.detailsUploadedFiles = [];
	}

	function _setProjectTitle(newValues) {
		if (vm.customTitle) {
			return;
		}

		_getLabels(newValues).then(function(labels) {
			vm.projectTitle = labels.matterTypeLabel + ' in ' + labels.definingLabel;
			Wizard.setTitle(vm.projectTitle);
		})
	}

	function _getLabels(newValues) {
		return MatterTypes.getList().then(function() {
			var matterTypes = MatterTypes.objects;

			return DefiningService.byMatterType(newValues.matterType).then(function(definings) {
				var definingsRepr = _.map(newValues.definings, function(definingID) {
					return _.findWhere(definings, {id: definingID})
				});
				var matterType = _.findWhere(matterTypes, {id: newValues.matterType});

				var definingLabel = '';
				_.forEach(definingsRepr, function(defining) {
					if (!definingLabel) {
						definingLabel = defining.value;
					} else {
						definingLabel = definingLabel + ', ' + defining.value;
					}
				});

				return {
					matterTypeLabel: matterType.title,
					definingLabel: definingLabel
				};
			});
		});
	}

	function _loadProfiles(profileIds) {
		return CommunityProfile.query({
			active: true,
			activated: true,
			suggested: true,
			ids: profileIds,
			ordering: ProfileOrdering.MOST_RELEVANT
		}).$promise.then(function(profiles) {
			vm.profiles = profiles;
			Wizard.setProfileIds(_.pluck(getExperts(), 'id'));

			_setJurisdictionsWithouExpertsFromExperts();

			vm.jurisdictionCoverage = JurisdictionCoverage.getCoverage(vm.definings, vm.profiles, vm.associates);
		});
	}

	function _loadAssociates(associateIds) {
		return Associate.query({
			ids: associateIds
		}).$promise.then(function(associates) {
			vm.associates = associates;
			Wizard.setProfileIds(_.pluck(getExperts(), 'id'));

			_setJurisdictionsWithouExpertsFromExperts();
		})
	}

	function _getInput() {
		return {
			projectTitle: vm.projectTitle,
			customTitle: vm.customTitle,
			detailsTextTemplate: vm.detailsTextTemplate,
			matterType: vm.matterType,
			definings: vm.definings,
			files: vm.UploadService.getUploadedFiles(),
			profileIds: _.pluck(getActiveExperts(), 'id'),
			pct: vm.pct,
			task: vm.task,
			taskTitle: vm.taskTitle,
			taskDueDate: vm.taskDueDate,
			expertiseType: vm.expertiseType
		}
	}

	function _setInput(savedInput) {
		vm.projectTitle = savedInput.projectTitle;
		Wizard.setTitle(vm.projectTitle);

		vm.detailsTextTemplate = savedInput.detailsTextTemplate;
		vm.customTitle = savedInput.customTitle;
		vm.pct = savedInput.pct;

		Wizard.params.matterType = savedInput.matterType;
		Wizard.params.definings = savedInput.definings;
		Wizard.params.expertiseType = savedInput.expertiseType;
		Wizard.params.subMatter = savedInput.subMatter;
		Wizard.params.task = savedInput.task;
		Wizard.params.taskTitle = savedInput.taskTitle;
		Wizard.params.taskDueDate = savedInput.taskDueDate;

		vm.UploadService.init(savedInput.files || []);

		if (savedInput.profileIds.length > 0) {
			return $q.all([
				_loadProfiles(savedInput.profileIds),
				_loadAssociates(savedInput.profileIds)
			]);
		}

		return $q.when();
	}

	function _shouldRestoreInput() {
		var searchParams = $location.search();

		return searchParams[PRESERVE_INPUT_URL_PARAM];
	}

	function _getStoredInput() {
		return Storage.get(INPUT_STORAGE_KEY);
	}

	function _markInputForPreservation() {
		$location.search(PRESERVE_INPUT_URL_PARAM, true);
	}

	function _clearStoredInput() {
		Storage.remove(INPUT_STORAGE_KEY);
	}

	function _preserveInput() {
		Storage.put(INPUT_STORAGE_KEY, _getInput());
	}

	function _setJurisdictionsWithouExperts(jurisdictions) {
		vm.jurisdictionsWithouExperts.splice(0, vm.jurisdictionsWithouExperts.length);
		DefiningService.getList().then(function(definings) {
			_.forEach(jurisdictions, function(jurisdiction) {
				vm.jurisdictionsWithouExperts.push(_.findWhere(definings, {id: jurisdiction}).value);
			})
		});
	}

	function _setJurisdictionsWithouExpertsFromExperts() {
		var jurisdictionsWithouExperts = [];
		_.forEach(vm.definings, function(definigId) {
			var hasExpert = _.find(vm.profiles, function(profile) {
				return _.findWhere(profile.services, {jurisdiction: definigId})
			});
			if (!hasExpert) {
				var hasAssociate = _.find(vm.associates, function(associate) {
					return _.contains(associate.jurisdictions, definigId)
				});
				if (!hasAssociate) {
					jurisdictionsWithouExperts.push(definigId);
				}
			}
		});
		_setJurisdictionsWithouExperts(jurisdictionsWithouExperts)
	}

	function matterTypeChanged() {
		vm.definings = undefined;
		vm.expertiseType = undefined;
		vm.isServicesShowed = true;

		_loadAndSetDependentValues(vm.matterType).then(function() {
			processSelectsChange();
		})
	}

	function _initFilterValues() {
		return _loadMatterTypes().then(function() {
			if (vm.matterType) {
				return _loadAndSetDependentValues(vm.matterType);
			}
		})
	}

	function _loadMatterTypes() {
		return MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});
	}

	function _loadAndSetDependentValues(matterType) {
		return $q.all({
			jurisdictions: DefiningService.byMatterType(matterType),
			expertiseTypes: ExpertiseTypes.usedInServices(matterType)
		}).then(function(values) {
			vm.jurisdictions = values.jurisdictions;
			vm.expertiseTypes = values.expertiseTypes;
		})
	}

	function processSelectsChange() {
		var selectsParams = _getSelectsParams();

		selectsChanged(selectsParams);
	}

	function _getSelectsParams() {
		return {
			matterType: vm.matterType,
			definings: vm.definings
		};
	}

	function customNumbersFilter(jurisdiction) {
		if (vm.definings && vm.definings.length !== 0) {
			return vm.definings.indexOf(jurisdiction.id) !== -1;
		}
		return false;
	}

	function allCustomNumbersFilled() {
		if (vm.definings && vm.definings.length !== 0) {
			return _.every(vm.definings, function(defining_id) {
				if (defining_id in vm.customNumbersModels) {
					var model = vm.customNumbersModels[defining_id];
					if (model.subject) {
						return true
					}
				}
			})
		}
		return false;
	}

	function initCustomNumber(jurisdiction) {
		vm.customNumbersModels[jurisdiction.id] = {repr: jurisdiction.value};
		_setCustomNumberSubject(vm.customNumbersModels[jurisdiction.id]);
	}

	function _updateCustomNumbersSubject() {
		_.forEach(vm.customNumbersModels, function(customNumber) {
			_setCustomNumberSubject(customNumber);
		})
	}

	function _setCustomNumberSubject(customNumber) {
		customNumber.subject = "" + (vm.projectTitle || "") + " - " + customNumber.repr + " - " + (vm.taskTitle || "");
	}
}

})();
(function() {
'use strict';
angular
	.module('community.wizard')
	.factory('Wizard', WizardFactory);

WizardFactory.$inject = ['$q', '$location', 'Storage', '$http', 'PekamaConfig'];

function WizardFactory($q, $location, Storage, $http, PekamaConfig) {
	var service = {
		initData: initData,
		saveStateInLocalStorage: saveStateInLocalStorage,
		resetWizard: resetWizard,

		createFamily: createFamily,
		createTask: createTask,
		createEnquiry: createEnquiry,

		setFamilyData: setFamilyData,
		setTitle: setTitle,
		setPct: setPct,
		setTaskData: setTaskData,
		showExpertsChooser: showExpertsChooser,
		hideExpertsChooser: hideExpertsChooser,
		setProfileIds: setProfileIds,
		setEnquiryData: setEnquiryData,

		params: {
			matterType: undefined,
			definings: undefined,
			title: undefined,
			subMatter: undefined,

			task: undefined,
			taskTitle: undefined,
			taskDueDate: undefined,

			profileIds: undefined,

			expertiseType: undefined,
			templateText: undefined,
			uploadedFiles: undefined,
			customNumbers: undefined,

			cloneType: undefined,

			pct: undefined,

			expertsChooserShowed: false
		}
	};

	var STORAGE_KEY = 'wizardNewState';

	var URL_PARAMS = ['matterType', 'defining', 'expertiseType', 'subMatter', 'title', 'task', 'taskTitle',
		'taskDueDate'];
	var URL_PARAMS_MAPPING = {'defining': 'definings'};
	var URL_STATE_ARRAYS = ['profileIds', 'defining'];

	return service;

	function initData() {
		// var stateFromStorage = _getStateFromLocalStorage() || {};
		var stateFromUrl = _loadStateFromUrl() || {};
		// angular.extend(service.params, stateFromStorage, stateFromUrl);
		angular.extend(service.params, stateFromUrl);
		return service.params.matterType !== undefined
			&& service.params.expertiseType !== undefined
			&& service.params.definings !== undefined;
	}

	function saveStateInLocalStorage(state) {
		angular.extend(service.params, state);
		// Storage.put(STORAGE_KEY, state);
	}

	function setFamilyData(matterType, definings, subMatter) {
		angular.extend(service.params, {
			matterType: matterType,
			definings: definings,
			subMatter: subMatter
		});
	}

	function setTitle(title) {
		service.params.title = title;
	}

	function setPct(pct) {
		service.params.pct = pct;
	}

	function setTaskData(data) {
		angular.extend(service.params, _.pick(data, 'task', 'taskTitle', 'taskDueDate'))
	}

	function showExpertsChooser() {
		service.params.expertsChooserShowed = true;
	}

	function hideExpertsChooser() {
		service.params.expertsChooserShowed = false;
	}

	function setProfileIds(profileIds) {
		service.params.profileIds = profileIds;
	}

	function setEnquiryData(templateText, uploadedFiles, expertiseType, customNumbers) {
		angular.extend(service.params, {
			templateText: templateText,
			uploadedFiles: uploadedFiles,
			expertiseType: expertiseType,
			customNumbers: customNumbers
		});
	}

	function createFamily() {
		var apiParams = _getFamilyData();

		return _postData(apiParams);
	}

	function createTask() {
		var apiParams = angular.extend({}, _getFamilyData(), _getTaskData());

		if (moment.isMoment(apiParams.task.due_date)) {
			apiParams.task.due_date = apiParams.task.due_date.format('YYYY-MM-DD');
		}

		return _postData(apiParams);
	}

	function createEnquiry() {
		var apiParams = angular.extend({}, _getFamilyData(), _getTaskData(), _getEnquiryData());

		if (moment.isMoment(apiParams.task.due_date)) {
			apiParams.task.due_date = apiParams.task.due_date.format('YYYY-MM-DD');
		}

		return _postData(apiParams);
	}

	function resetWizard() {
		angular.extend(service.params, {
			matterType: undefined,
			definings: undefined,
			title: undefined,
			subMatter: undefined,

			task: undefined,
			taskTitle: undefined,
			taskDueDate: undefined,

			profileIds: undefined,

			expertiseType: undefined,
			templateText: undefined,
			uploadedFiles: undefined,
			customNumbers: undefined,

			cloneType: undefined,

			pct: undefined,

			expertsChooserShowed: false
		})
	}

	function _postData(apiParams) {
		return $http.post(PekamaConfig.apiBaseUrl + 'enquiries/wizard/', apiParams).then(function(response) {
			resetWizard();

			return response.data;
		})
	}

	function _getStateFromLocalStorage() {
		return Storage.get(STORAGE_KEY);
	}

	function _loadStateFromUrl() {
		var stateParams = {};
		var searchParams = $location.search();

		var paramsLoaded = false;

		URL_PARAMS.forEach(function(paramName) {
			var value = searchParams[paramName];

			if (value !== undefined) {
				paramsLoaded = true;

				if (angular.isArray(value)) {
					value = value.map(_intOrItself);
				} else {
					value = _intOrItself(value);

					if (value !== undefined && URL_STATE_ARRAYS.indexOf(paramName) !== -1) {
						value = [value];
					}
				}

				stateParams[URL_PARAMS_MAPPING[paramName] || paramName] = value;
				$location.search(paramName, null);
			}
		});

		return paramsLoaded ? stateParams : undefined;
	}

	function _intOrItself(value) {
		var parsed = parseInt(value);

		if (isNaN(parsed) || value !== parsed.toString()) {
			return value;
		}

		return parsed;
	}

	function _getFamilyData() {
		var params = service.params;

		return {
			family: {
				sub_matter: params.subMatter,
				jurisdictions: params.definings,
				title: params.title,
				clone_type: params.cloneType
			}
		}
	}

	function _getTaskData() {
		var params = service.params;

		return {
			task: {
				task: params.task,
				title: params.taskTitle,
				due_date: params.taskDueDate || undefined
			}
		}
	}

	function _getEnquiryData() {
		var params = service.params;

		return {
			enquiry: {
				suppliers: params.profileIds,
				expertise_type: params.expertiseType,
				template_text: params.templateText,
				uploaded_files: params.uploadedFiles,
				custom_numbers: params.customNumbers
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.wizard')
	.controller('WizardHeaderController', WizardHeaderController);

WizardHeaderController.$inject = ['expertsChooserDelegate', 'Wizard'];

function WizardHeaderController(expertsChooserDelegate, Wizard) {
	var vm = this;

	vm.expertsChooserDelegate = expertsChooserDelegate;
	vm.wizardParams = Wizard.params;
}

})();
(function() {
'use strict';
angular
	.module('community.experts')
	.directive('cmntWizardPct', function() {
		return {
			templateUrl: 'wizard/wizardPct.directive.html',
			scope: {
				pct: '=',
				definings: '='
			},
			controller: WizardPctController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});


var ASSUMPTIONS_TEXT = "<p>These estimates are based on reasonable fee quotes by reputable members of our community.</p>" +
	"<p>They assume the standard claim reduction on national phase entry where possible and that the applicant is a " +
	"small entity where relevant. They also make further standard assumptions.</p>" +
	"<p>To obtain accurate quotes, please proceed with the Pekama service.</p>";


WizardPctController.$inject = ['$scope', '$q', '$filter', 'DefiningService', '$http', 'PekamaConfig'];

function WizardPctController($scope, $q, $filter, DefiningService, $http, PekamaConfig) {
	var vm = this;

	vm.getPrice = getPrice;
	vm.prices = {};
	vm.priceUsd = 0;
	vm.onlyUsdPrices = false;
	vm.assumptions = ASSUMPTIONS_TEXT;

	activate();

	function activate() {
		$scope.$watch('vm.definings', function(newValue, oldValue) {
			vm.priceUsd = 0;
			vm.onlyUsdPrices = false;
			var onlyUsdPricesChanged = false;
			angular.forEach(vm.definings, function(defining_id) {
				$q.when(getPrice(defining_id)).then(function(price_obj) {
					if ('price_usd' in price_obj) {
						if (price_obj.price_usd !== null) {
							vm.priceUsd = vm.priceUsd + parseFloat(price_obj.price_usd);
							if (onlyUsdPricesChanged === false) {
								onlyUsdPricesChanged = true;
								vm.onlyUsdPrices = true;
							}
						} else {
							onlyUsdPricesChanged = null;
							vm.onlyUsdPrices = false;
						}
					}
				});
			})
		});
	}

	function getPrice(defining_id) {
		if (defining_id in vm.prices) {
			return vm.prices[defining_id];
		}
		return DefiningService.findById(defining_id).then(function(defining) {
			vm.prices[defining_id] = {value: defining.value};
			var sendData = _.pick(vm.pct, 'claims_n', 'claims_w', 'claims_p', 'description_w', 'description_p',
				'drawings_n', 'drawings_p');
			return $http.post(PekamaConfig.apiBaseUrl + 'enquiries/price-estimate/',
				angular.extend({jurisdiction: defining_id}, sendData)).then(function(response) {
				var data = response.data;
				angular.extend(vm.prices[defining_id], _.pick(data, 'price', 'price_currency', 'price_usd'));
				var price_str = '';
				if (data.price_usd !== null) {
					price_str = '$' + $filter('number')(data.price_usd, 0);
				} else {
					price_str = '' + $filter('number')(data.price, 0) + ' (' + data.price_currency + ')';
				}
				angular.extend(vm.prices[defining_id], {price_str: price_str});
				return vm.prices[defining_id];
			});
		});
	}
}

})();
(function() {
'use strict';
angular.module('community.core').constant('ReportActions', {
	getFacets: {
		params: {action: 'get_facets'},
		method: 'GET',
		isArray: true
	},
	getFilters: {
		params: {action: 'get_filters'},
		method: 'GET',
		isArray: true
	},
	dynamicData: {
		params: {action: 'dynamic_data'},
		method: 'GET'
	},
	listData: {
		params: {action: 'list_data'},
		method: 'GET'
	},
	dynamicDetail: {
		params: {action: 'dynamic_detail'},
		method: 'GET'
	},
	bulkDelete: {
		params: {action: 'bulk_delete'},
		method: 'POST'
	},
	getColumns: {
		params: {action: 'get_columns'},
		method: 'GET',
		isArray: true
	}
});

})();
(function() {
'use strict';
angular
	.module('community.core.forms')
	.directive('cmntFieldErrors', cmntFieldErrors);

cmntFieldErrors.$inject = ['$timeout', '$interpolate'];

function cmntFieldErrors($timeout, $interpolate) {
	return {
		restrict: 'CA',
		require: '^?form',
		link: function(scope, fieldElm, attrs, formCtrl) {
			if (!formCtrl) return;

			var inputName;

			var ERROR_BLOCK_HTML = '<div class="field__errors"></div>',
				ERROR_ITEM_HTML = '<div class="field__error-item">{{ errorText }}</div>',
				renderErrorItem = $interpolate(ERROR_ITEM_HTML),
				ERROR_BLOCK_SELECTOR = '.field__errors',
				ERROR_CLASS = 'field_error';

			$timeout(function() {
				var inputEl = fieldElm[0].querySelector("[name]");

				// convert the native text box element to an angular element
				var inputNgEl = angular.element(inputEl);
				// get the name on the text box so we know the property to check
				// on the form controller
				inputName = inputNgEl.attr('name');
			});

			scope.$watch(function() {
				if (formCtrl[inputName]) {
					return formCtrl[inputName].$invalid && formCtrl[inputName].$pristine;
				}
				return false;
			}, function(hasErrors) {
				fieldElm.toggleClass(ERROR_CLASS, hasErrors);

				if (!formCtrl[inputName]) return;

				if (hasErrors) {
					var errors = _getErrorsList(),
						errorBlock = $(ERROR_BLOCK_HTML);

					errors.forEach(function(errorText) {
						errorBlock.append(renderErrorItem({errorText: errorText}));
					});

					fieldElm.append(errorBlock);
				} else {
					fieldElm.find(ERROR_BLOCK_SELECTOR).remove();
				}
			});

			function _getErrorsList() {
				//var inputErrors = formCtrl[inputName].$error.remote;
				var errorMessages = formCtrl.remoteMessages || {};

				var inputErrors = errorMessages[inputName] || [];

				if (!angular.isArray(inputErrors)) {
					inputErrors = [inputErrors];
				}

				return inputErrors;
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.forms')
	.directive('cmntFormErrors', cmntFormErrors);

cmntFormErrors.$inject = [];

function cmntFormErrors() {
	return {
		restrict: 'AE',
		require: '^form',
		templateUrl: 'core/forms/cmntFormErrors.directive.html',
		replace: true,
		scope: {},
		link: function(scope, el, attrs, formCtrl) {
			scope.form = formCtrl;
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.forms')
	.directive('cmntHandleErrors', cmntHandleErrors);

cmntHandleErrors.$inject = ['RestErrors', '$timeout'];

function cmntHandleErrors(RestErrors, $timeout) {
	return {
		restrict: 'A',
		require: 'form',
		scope: true,//TODO required?
		link: function(scope, el, attrs, formCtrl) {
			var EVENT_FORM_SUBMITTED = 'formSubmitted',
				EVENT_FORM_SAVED = 'formSaved';

			var errorsSignalName = 'formErrors';

			if (!formCtrl) return;

			init();

			function init() {
				if (attrs.signalPostfix !== undefined) {
					errorsSignalName += attrs.signalPostfix;
				}

				formCtrl.displayErrors = displayErrors;
				formCtrl.clearErrors = _cleanErrorsFromForm;

				scope.$on(EVENT_FORM_SAVED, function() {
					_cleanErrorsFromForm();

					scope.$broadcast(EVENT_FORM_SUBMITTED);
				});

				scope.$on(errorsSignalName, function(event, data) {
					_setErrorsOnForm(data);

					scope.$broadcast(EVENT_FORM_SUBMITTED);
				});
			}

			function displayErrors(errorResponse) {
				_cleanErrorsFromForm();

				$timeout(function() {
					_setErrorsOnForm(errorResponse);
				});
			}

			function _setErrorsOnForm(errorResponse) {
				_cleanErrorsFromForm();
				var fieldErrors = RestErrors.getFormErrors(errorResponse);

				formCtrl.remoteMessages = fieldErrors;

				Object.keys(fieldErrors).forEach(function(field) {
					if (field === RestErrors.ALL_ERRORS_FIELD) {
						_setFormValidity(formCtrl, false);
					} else {
						var formField = formCtrl[field];

						if (formField !== undefined) {
							_setFieldValidity(formField, false);
						}
					}
				});
			}

			function _cleanErrorsFromForm() {
				angular.forEach(formCtrl, function(formAttribute) {
					if (formAttribute === undefined) return;

					if (_isFormField(formAttribute)) {
						_setFieldValidity(formAttribute, true);
					}
				});

				_setFormValidity(formCtrl, true);
			}

			function _setFormValidity(form, validity) {
				form.$setValidity('formErrors', validity);
				form.$setPristine();
			}

			function _setFieldValidity(field, validtiy) {
				field.$setValidity('remote', validtiy);
				field.$setPristine();
			}

			function _isFormField(controllerAttribute) {
				return controllerAttribute.hasOwnProperty('$modelValue');
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.forms')
	.factory('$saveForm', saveForm);

saveForm.$inject = ['$q'];

function saveForm($q) {
	return function(scope, promise, success_callback, error_callback) {
		return promise.then(function() {
			if (success_callback !== undefined) {
				success_callback.apply(this, arguments);
			}
			scope.$broadcast('formSaved', arguments[0]);

		}, function() {
			if (arguments[0].status != 400) {
				alert(arguments[0].statusText);
			}

			if (error_callback !== undefined) {
				error_callback.apply(this, arguments);
			}

			scope.$broadcast('formErrors', arguments[0].data);
			return $q.reject();
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.forms')
	.directive('cmntSubmit', cmntSubmit);


function cmntSubmit() {
	return {
		restrict: 'CA',
		require: '^?form',
		scope: {
			'key': '@submit',
			submitEnabled: '='
		},
		link: function(scope, element, attrs, formCtrl) {
			if (!formCtrl) return;

			var IN_PROGRESS = 'in_progress',
				NORMAL = 'normal',
				DISABLED = 'disabled';

			function changeState(elm, state) {
				elm.find('.icon-spinner').remove();
				elm.attr('disabled', false);

				if (state === IN_PROGRESS) {
					elm.attr('disabled', true);
					elm.html('<i class="icon icon-spinner icon-spin6"></i> ' + $(element).html());
				} else if (state === DISABLED) {
					$(element).attr('disabled', true);
				}
			}

			function getKey() {
				if (scope.key) {
					return ':' + scope.key;
				}

				return '';
			}

			function removeErrors(formController) {
				angular.forEach(formController, function(value, key) {
					if (value !== undefined && value.hasOwnProperty('$modelValue')) {
						value.$setValidity('remote', true);
					}
				});

				formController.$error.remote = undefined;
			}

			function removeErrorsAndMakePristine(formController) {
				removeErrors(formController);

				formController.$setPristine();
			}

			$(element).click(function() {
				changeState($(element), IN_PROGRESS);

				removeErrorsAndMakePristine(formCtrl);
			});

			scope.$on('formSubmitted' + getKey(), function() {
				changeState($(element), DISABLED);
			});

			scope.$on('formError', function() {
				changeState($(element), DISABLED);
			});

			scope.$on('removeErrors', function() {
				removeErrors(formCtrl)
			});

			scope.$watch(function() {
				return formCtrl.$pristine;
			}, function(pristine) {
				if (pristine) {
					if (scope.submitEnabled) {
						changeState($(element), NORMAL);
					} else {
						$(element).attr('disabled', true);
					}
				} else {
					changeState($(element), NORMAL);
				}
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntConfirmClick', cmntConfirmClick);

cmntConfirmClick.$inject = ['$modal'];

function cmntConfirmClick($modal) {
	function link(scope, element, attrs) {
		element.bind('click', function() {
			var message = attrs.confirmMessage || "Are you sure?",
				title = attrs.confirmTitle || "Confirm action";

			function controller($scope, $modalInstance) {
				$scope.message = message;
				$scope.title = title;

				$scope.close = function() {
					$modalInstance.dismiss();
				};

				$scope.save = function() {
					scope.$eval(attrs.cmntConfirmClick);
					$modalInstance.close();
				}
			}

			$modal.open({
				templateUrl: 'core/uihelpers/confirmClick.directive.html',
				controller: ['$scope', '$modalInstance', controller],
				scope: scope,
				windowClass: 'reveal_mini'
			});
		});
	}

	return {
		restrict: 'A',
		link: link
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.filter('convertLineBreaks', convertLineBreaks);

convertLineBreaks.$inject = [];

function convertLineBreaks() {
	return function(text) {
		return text.replace(/\n/g, '<br>');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.filter('cmntCustomDateFormat', cmntCustomDateFormat);

cmntCustomDateFormat.$inject = [];

function cmntCustomDateFormat() {
	return function(date, dateFormat) {
	    if (date) {
            return moment(date).format(dateFormat);
        }
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntDisableAction', DisableActionDirective);

DisableActionDirective.$inject = ['$parse'];

function DisableActionDirective($parse) {
	return {
		restrict: 'A',

		link: function(scope, element, attrs, formCtrl) {
			var fn = $parse(attrs.cmntDisableAction);

			$(element).click(function(event) {
				var promise = fn(scope, {$event: event});
				if (promise != undefined) {
					$(element).attr('disabled', true);

					promise.finally(function() {
						$(element).removeAttr('disabled');
					}).then();
				}
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntEditableTitle', EditableTitle);

EditableTitle.$inject = ['$q', '$saveForm', '$timeout'];

function EditableTitle($q, $saveForm, $timeout) {
	return {
		templateUrl: 'core/uihelpers/editableTitle.directive.html',
		scope: {
			model: '=',
			field: '@',
			onFinishEditing: '&',
			extraClass: '@?',
			direction: '@?'
		},
		transclude: true,
		replace: true,
		link: function(scope, elm, attrs) {
			var field = scope.field;
			var modelValueBeforeEdit = '';
			var INPUT_SELECTOR = "input[type='text']";
			var KEY_ENTER = 13,
				KEY_ESCAPE = 27;

			scope.buttonSize = 'button_size_' + (attrs.buttonSize || 'xs');
			scope.fieldClass = attrs.fieldClass || 'field_size_s field_border';

			scope.saving = false;
			scope.editing = false;

			scope.startTitleEditing = startTitleEditing;
			scope.saveEditedTitle = saveEditedTitle;
			scope.cancelTitleEditing = cancelTitleEditing;

			init();

			function init() {
				_toggleForm(false);

				scope.$on('$destroy', function() {
					if (scope.editing) {
						cancelTitleEditing();
					}
				});

				if (scope.model.$new) {
					delete scope.model['$new'];

					$timeout(function() {
						startTitleEditing();
					});
				}
			}

			function startTitleEditing() {
				_toggleForm(true);
				_focusInputField();
				_rememberModelValue();
			}

			function saveEditedTitle() {
				var editingResult = $q.when(scope.onFinishEditing());

				_toggleSaving(true);
				$saveForm(scope, editingResult, function() {
					_toggleForm(false);
				});

				editingResult.finally(function() {
					_toggleSaving(false);
				});
			}

			function cancelTitleEditing() {
				$timeout(function() {
					_toggleForm(false);
					_restoreModelValue();
				});
			}

			function _toggleForm(openState) {
				scope.editing = openState;

				if (openState == true) {
					_setupKeyupHandler()
				}
			}

			function _toggleSaving(savingState) {
				scope.saving = savingState;
			}

			function _setupKeyupHandler() {
				$timeout(function() {
					var input = $(elm).find(INPUT_SELECTOR);

					if (input.length > 0) {
						input.keyup(function(e) {
							if (e.which == KEY_ENTER) {
								saveEditedTitle();

								e.stopPropagation();
								e.preventDefault();
							} else if (e.which == KEY_ESCAPE) {
								cancelTitleEditing();
							}
						});
					}
				});
			}

			function _focusInputField() {
				$timeout(function() {
					$(elm).find(INPUT_SELECTOR).select();
				});
			}

			function _rememberModelValue() {
				modelValueBeforeEdit = scope.model[field];
			}

			function _restoreModelValue() {
				scope.model[field] = modelValueBeforeEdit;
			}
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntEmptyResult', emptyResultDirective);


function emptyResultDirective() {
	return {
		templateUrl: 'core/uihelpers/emptyResult.directive.html',
		controller: function() {
		},
		transclude: true,
		scope: {
			resource: '=',
			title: '@',
			text: '@',
			extraClass: "@?"
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.filter('escapeHtml', escapeHtml);

escapeHtml.$inject = [];

function escapeHtml() {
	return function(text) {
		return text
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#039;");
	}
}

})();
(function() {
'use strict';
angular
	.module('blocks')
	.directive('cmntExtraOption', function() {
		return {
			require: ['cmntExtraOption', 'uiSelect'],
			controller: ExtraOptionController,
			link: function(scope, element, attrs, ctrls) {
				var ownController = ctrls[0];

				ownController.setSelectController(ctrls[1]);
			}
		}
	});

ExtraOptionController.$inject = ['$scope', '$parse', '$attrs'];

function ExtraOptionController($scope, $parse, $attrs) {
	var vm = this,
		selectController;

	var callback;

	if ($attrs.optionCallback) {
		callback = $parse($attrs.optionCallback);
	}

	vm.setSelectController = setSelectController;

	function setSelectController(controller) {
		selectController = controller;

		selectController.extraOptionClick = extraOptionClick;
		selectController.extraOption = {
			'class': $attrs.optionClass,
			label: $attrs.optionLabel || "Extra option..."
		};
	}

	function extraOptionClick() {
		callback($scope, {search: selectController.search});
		selectController.close();
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.factory('cmntFileIcon', cmntFileIcon);

cmntFileIcon.$inject = [];

function cmntFileIcon() {
	var mimeTypeMap = {
		"application/mp4": "icon-file-video",
		"application/mpeg4-generic": "icon-file-video",
		"application/mpeg4-iod": "icon-file-video",
		"application/mpeg4-iod-xmt": "icon-file-video",
		"application/msword": "icon-file-word",
		"application/pdf": "icon-file-pdf",
		"application/rtf": "icon-doc-text",
		"application/vnd.ms-cab-compressed": "icon-file-archive",
		"application/vnd.ms-excel": "icon-file-excel",
		"application/vnd.ms-excel.addin.macroenabled.12": "icon-file-excel",
		"application/vnd.ms-excel.sheet.binary.macroenabled.12": "icon-file-excel",
		"application/vnd.ms-excel.sheet.macroenabled.12": "icon-file-excel",
		"application/vnd.ms-excel.template.macroenabled.12": "icon-file-excel",
		"application/vnd.ms-powerpoint": "icon-file-powerpoint",
		"application/vnd.ms-powerpoint.addin.macroenabled.12": "icon-file-powerpoint",
		"application/vnd.ms-powerpoint.presentation.macroenabled.12": "icon-file-powerpoint",
		"application/vnd.ms-powerpoint.slide.macroenabled.12": "icon-file-powerpoint",
		"application/vnd.ms-powerpoint.slideshow.macroenabled.12": "icon-file-powerpoint",
		"application/vnd.ms-powerpoint.template.macroenabled.12": "icon-file-powerpoint",
		"application/vnd.ms-word.document.macroenabled.12": "icon-file-word",
		"application/vnd.ms-word.template.macroenabled.12": "icon-file-word",
		"application/vnd.oasis.opendocument.text": "icon-doc-text",
		"application/vnd.oasis.opendocument.text-master": "icon-doc-text",
		"application/vnd.oasis.opendocument.text-template": "icon-doc-text",
		"application/vnd.oasis.opendocument.text-web": "icon-doc-text",
		"application/vnd.openxmlformats-officedocument.wordprocessingml.document": "icon-file-word",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "icon-file-excel",
		"application/x-bzip": "icon-file-archive",
		"application/x-bzip2": "icon-file-archive",
		"application/x-gzip": "icon-file-archive",
		"application/x-rar-compressed": "icon-file-archive",
		"application/x-tar": "icon-file-archive",
		"application/zip": "icon-file-archive",
		"audio/32kadpcm": "icon-file-audio",
		"audio/3gpp": "icon-file-audio",
		"audio/3gpp2": "icon-file-audio",
		"audio/ac3": "icon-file-audio",
		"audio/adpcm": "icon-file-audio",
		"audio/amr": "icon-file-audio",
		"audio/amr-wb": "icon-file-audio",
		"audio/amr-wb+": "icon-file-audio",
		"audio/asc": "icon-file-audio",
		"audio/basic": "icon-file-audio",
		"audio/bv16": "icon-file-audio",
		"audio/bv32": "icon-file-audio",
		"audio/clearmode": "icon-file-audio",
		"audio/cn": "icon-file-audio",
		"audio/dat12": "icon-file-audio",
		"audio/dls": "icon-file-audio",
		"audio/dsr-es201108": "icon-file-audio",
		"audio/dsr-es202050": "icon-file-audio",
		"audio/dsr-es202211": "icon-file-audio",
		"audio/dsr-es202212": "icon-file-audio",
		"audio/dvi4": "icon-file-audio",
		"audio/eac3": "icon-file-audio",
		"audio/evrc": "icon-file-audio",
		"audio/evrc-qcp": "icon-file-audio",
		"audio/evrc0": "icon-file-audio",
		"audio/evrc1": "icon-file-audio",
		"audio/evrcb": "icon-file-audio",
		"audio/evrcb0": "icon-file-audio",
		"audio/evrcb1": "icon-file-audio",
		"audio/evrcwb": "icon-file-audio",
		"audio/evrcwb0": "icon-file-audio",
		"audio/evrcwb1": "icon-file-audio",
		"audio/example": "icon-file-audio",
		"audio/g719": "icon-file-audio",
		"audio/g722": "icon-file-audio",
		"audio/g7221": "icon-file-audio",
		"audio/g723": "icon-file-audio",
		"audio/g726-16": "icon-file-audio",
		"audio/g726-24": "icon-file-audio",
		"audio/g726-32": "icon-file-audio",
		"audio/g726-40": "icon-file-audio",
		"audio/g728": "icon-file-audio",
		"audio/g729": "icon-file-audio",
		"audio/g7291": "icon-file-audio",
		"audio/g729d": "icon-file-audio",
		"audio/g729e": "icon-file-audio",
		"audio/gsm": "icon-file-audio",
		"audio/gsm-efr": "icon-file-audio",
		"audio/ilbc": "icon-file-audio",
		"audio/l16": "icon-file-audio",
		"audio/l20": "icon-file-audio",
		"audio/l24": "icon-file-audio",
		"audio/l8": "icon-file-audio",
		"audio/lpc": "icon-file-audio",
		"audio/midi": "icon-file-audio",
		"audio/mobile-xmf": "icon-file-audio",
		"audio/mp4": "icon-file-audio",
		"audio/mp4a-latm": "icon-file-audio",
		"audio/mpa": "icon-file-audio",
		"audio/mpa-robust": "icon-file-audio",
		"audio/mpeg": "icon-file-audio",
		"audio/mpeg4-generic": "icon-file-audio",
		"audio/ogg": "icon-file-audio",
		"audio/parityfec": "icon-file-audio",
		"audio/pcma": "icon-file-audio",
		"audio/pcma-wb": "icon-file-audio",
		"audio/pcmu-wb": "icon-file-audio",
		"audio/pcmu": "icon-file-audio",
		"audio/prs.sid": "icon-file-audio",
		"audio/qcelp": "icon-file-audio",
		"audio/red": "icon-file-audio",
		"audio/rtp-enc-aescm128": "icon-file-audio",
		"audio/rtp-midi": "icon-file-audio",
		"audio/rtx": "icon-file-audio",
		"audio/smv": "icon-file-audio",
		"audio/smv0": "icon-file-audio",
		"audio/smv-qcp": "icon-file-audio",
		"audio/sp-midi": "icon-file-audio",
		"audio/t140c": "icon-file-audio",
		"audio/t38": "icon-file-audio",
		"audio/telephone-event": "icon-file-audio",
		"audio/tone": "icon-file-audio",
		"audio/ulpfec": "icon-file-audio",
		"audio/vdvi": "icon-file-audio",
		"audio/vmr-wb": "icon-file-audio",
		"audio/vnd.3gpp.iufp": "icon-file-audio",
		"audio/vnd.4sb": "icon-file-audio",
		"audio/vnd.audiokoz": "icon-file-audio",
		"audio/vnd.celp": "icon-file-audio",
		"audio/vnd.cisco.nse": "icon-file-audio",
		"audio/vnd.cmles.radio-events": "icon-file-audio",
		"audio/vnd.cns.anp1": "icon-file-audio",
		"audio/vnd.cns.inf1": "icon-file-audio",
		"audio/vnd.digital-winds": "icon-file-audio",
		"audio/vnd.dlna.adts": "icon-file-audio",
		"audio/vnd.dolby.heaac.1": "icon-file-audio",
		"audio/vnd.dolby.heaac.2": "icon-file-audio",
		"audio/vnd.dolby.mlp": "icon-file-audio",
		"audio/vnd.dolby.mps": "icon-file-audio",
		"audio/vnd.dolby.pl2": "icon-file-audio",
		"audio/vnd.dolby.pl2x": "icon-file-audio",
		"audio/vnd.dolby.pl2z": "icon-file-audio",
		"audio/vnd.dts": "icon-file-audio",
		"audio/vnd.dts.hd": "icon-file-audio",
		"audio/vnd.everad.plj": "icon-file-audio",
		"audio/vnd.hns.audio": "icon-file-audio",
		"audio/vnd.lucent.voice": "icon-file-audio",
		"audio/vnd.ms-playready.media.pya": "icon-file-audio",
		"audio/vnd.nokia.mobile-xmf": "icon-file-audio",
		"audio/vnd.nortel.vbk": "icon-file-audio",
		"audio/vnd.nuera.ecelp4800": "icon-file-audio",
		"audio/vnd.nuera.ecelp7470": "icon-file-audio",
		"audio/vnd.nuera.ecelp9600": "icon-file-audio",
		"audio/vnd.octel.sbc": "icon-file-audio",
		"audio/vnd.qcelp": "icon-file-audio",
		"audio/vnd.rhetorex.32kadpcm": "icon-file-audio",
		"audio/vnd.sealedmedia.softseal.mpeg": "icon-file-audio",
		"audio/vnd.vmx.cvsd": "icon-file-audio",
		"audio/vorbis": "icon-file-audio",
		"audio/vorbis-config": "icon-file-audio",
		"audio/x-aac": "icon-file-audio",
		"audio/x-aiff": "icon-file-audio",
		"audio/x-mpegurl": "icon-file-audio",
		"audio/x-ms-wax": "icon-file-audio",
		"audio/x-ms-wma": "icon-file-audio",
		"audio/x-pn-realaudio": "icon-file-audio",
		"audio/x-wav": "icon-file-audio",
		"image/bmp": "icon-file-image",
		"image/cgm": "icon-file-image",
		"image/g3fax": "icon-file-image",
		"image/gif": "icon-file-image",
		"image/ief": "icon-file-image",
		"image/jp2": "icon-file-image",
		"image/jpeg": "icon-file-image",
		"image/jpm": "icon-file-image",
		"image/jpx": "icon-file-image",
		"image/naplps": "icon-file-image",
		"image/pict": "icon-file-image",
		"image/png": "icon-file-image",
		"image/prs.btif": "icon-file-image",
		"image/prs.pti": "icon-file-image",
		"image/svg+xml": "icon-file-image",
		"image/t38": "icon-file-image",
		"image/tiff": "icon-file-image",
		"image/tiff-fx": "icon-file-image",
		"image/vnd.adobe.photoshop": "icon-file-image",
		"image/vnd.cns.inf2": "icon-file-image",
		"image/vnd.djvu": "icon-file-image",
		"image/vnd.dwg": "icon-file-image",
		"image/vnd.dxf": "icon-file-image",
		"image/vnd.fastbidsheet": "icon-file-image",
		"image/vnd.fpx": "icon-file-image",
		"image/vnd.fst": "icon-file-image",
		"image/vnd.fujixerox.edmics-mmr": "icon-file-image",
		"image/vnd.fujixerox.edmics-rlc": "icon-file-image",
		"image/vnd.globalgraphics.pgb": "icon-file-image",
		"image/vnd.microsoft.icon": "icon-file-image",
		"image/vnd.mix": "icon-file-image",
		"image/vnd.ms-modi": "icon-file-image",
		"image/vnd.net-fpx": "icon-file-image",
		"image/vnd.radiance": "icon-file-image",
		"image/vnd.sealed.png": "icon-file-image",
		"image/vnd.sealedmedia.softseal.gif": "icon-file-image",
		"image/vnd.sealedmedia.softseal.jpg": "icon-file-image",
		"image/vnd.svf": "icon-file-image",
		"image/vnd.wap.wbmp": "icon-file-image",
		"image/vnd.xiff": "icon-file-image",
		"image/x-cmu-raster": "icon-file-image",
		"image/x-cmx": "icon-file-image",
		"image/x-freehand": "icon-file-image",
		"image/x-icon": "icon-file-image",
		"image/x-macpaint": "icon-file-image",
		"image/x-pcx": "icon-file-image",
		"image/x-pict": "icon-file-image",
		"image/x-portable-anymap": "icon-file-image",
		"image/x-portable-bitmap": "icon-file-image",
		"image/x-portable-graymap": "icon-file-image",
		"image/x-portable-pixmap": "icon-file-image",
		"image/x-quicktime": "icon-file-image",
		"image/x-rgb": "icon-file-image",
		"image/x-xbitmap": "icon-file-image",
		"image/x-xpixmap": "icon-file-image",
		"image/x-xwindowdump": "icon-file-image",
		"text/css": "icon-doc-text",
		"text/csv": "icon-doc-text",
		"text/html": "icon-file-code",
		"text/javascript": "icon-file-code",
		"text/plain": "icon-doc-text",
		"text/richtext": "icon-doc-text",
		"text/rtf": "icon-doc-text",
		"text/rtx": "icon-doc-text",
		"text/x-pascal": "icon-file-code",
		"text/x-java-source": "icon-file-code",
		"text/xml": "icon-file-code",
		"text/xml-external-parsed-entity": "icon-file-code",
		"video/3gpp": "icon-file-video",
		"video/3gpp-tt": "icon-file-video",
		"video/3gpp2": "icon-file-video",
		"video/bmpeg": "icon-file-video",
		"video/bt656": "icon-file-video",
		"video/celb": "icon-file-video",
		"video/dv": "icon-file-video",
		"video/h261": "icon-file-video",
		"video/h263": "icon-file-video",
		"video/h263-1998": "icon-file-video",
		"video/h263-2000": "icon-file-video",
		"video/h264": "icon-file-video",
		"video/jpeg": "icon-file-video",
		"video/jpeg2000": "icon-file-video",
		"video/jpm": "icon-file-video",
		"video/mj2": "icon-file-video",
		"video/mp1s": "icon-file-video",
		"video/mp2p": "icon-file-video",
		"video/mp2t": "icon-file-video",
		"video/mp4": "icon-file-video",
		"video/mp4v-es": "icon-file-video",
		"video/mpeg": "icon-file-video",
		"video/mpeg4-generic": "icon-file-video",
		"video/mpv": "icon-file-video",
		"video/nv": "icon-file-video",
		"video/ogg": "icon-file-video",
		"video/quicktime": "icon-file-video",
		"video/rtx": "icon-file-video",
		"video/x-dv": "icon-file-video",
		"video/x-f4v": "icon-file-video",
		"video/x-fli": "icon-file-video",
		"video/x-flv": "icon-file-video",
		"video/x-ms-asf": "icon-file-video",
		"video/x-ms-wmv": "icon-file-video"
	};
	return function(file, typeKey) {
		var cssClass = mimeTypeMap[typeKey !== undefined ? file[typeKey] : file.mime_type];
		if (cssClass === undefined) return 'file-1';
		return cssClass;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntFocusMe', FocusMeController);


FocusMeController.$inject = ['$timeout'];

function FocusMeController($timeout) {
	return {
		link: function(scope, element, attrs) {
			scope.$watch(attrs['cmntFocusMe'], function(value) {
				if (value === true) {
					$timeout(function() {
						element[0].focus();
					});
				}
			});
		}
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.directive('cmntInlineArea', function() {
		return {
			require: 'ngModel',
			scope: {
				onValueChanged: '&',
				extraClass: "@?",
				editing: '=?',
				enabled: '<?',
				delegate: '=?'
			},
			templateUrl: 'core/uihelpers/inlineArea.directive.html',
			controller: InlineAreaController,
			controllerAs: 'vm',
			bindToController: true,
			transclude: true
		}
	});

InlineAreaController.$inject = ['$element', '$timeout'];

function InlineAreaController($element, $timeout) {
	var vm = this;

	var KEY_ESCAPE = 27;

	var ngModelController = $element.controller('ngModel');

	vm.startEditing = startEditing;
	vm.finishEditing = finishEditing;
	vm.textAreaId = _.uniqueId('inlineArea-');

	activate();

	function activate() {
		vm.editing = false;

		ngModelController.$render = function() {
			vm.newValue = ngModelController.$viewValue;
		};

		vm.delegate = {
			startEditing: startEditing
		}
	}

	function startEditing() {
		if (!vm.enabled) {
			return;
		}

		vm.newValue = ngModelController.$viewValue;
		vm.editing = true;

		$timeout(function() {
			_setupKeyupHandler();
		});
	}

	function finishEditing() {
		var oldValue = ngModelController.$viewValue;
		ngModelController.$setViewValue(vm.newValue);

		var valueChangePromise = vm.onValueChanged({oldValue: oldValue, newValue: vm.newValue}) || $q.when();

		valueChangePromise.then(angular.noop, function() {
			ngModelController.$setViewValue(oldValue);
		});

		vm.editing = false;
	}

	function _setupKeyupHandler() {
		var textArea = _getTextArea();

		textArea.keyup(function(e) {
			switch (e.which) {
				case KEY_ESCAPE:
					$timeout(function() {
						vm.editing = false;
					});

					break;
			}
		});
	}

	function _getTextArea() {
		return $('#' + vm.textAreaId);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.directive('cmntInlineEdit', function() {
		return {
			require: 'ngModel',
			scope: {
				onValueChanged: '&',
				inputOptions: '@?',
				editing: '=?',
				enabled: '<?',
				delegate: '=?'
			},
			templateUrl: 'core/uihelpers/inlineEdit.directive.html',
			controller: InlineEditController,
			controllerAs: 'vm',
			bindToController: true,
			transclude: true,
			replace: true
		}
	});

InlineEditController.$inject = ['$scope', '$element', '$timeout', '$q', '$compile'];

function InlineEditController($scope, $element, $timeout, $q, $compile) {
	var vm = this;

	var KEY_ENTER = 13,
		KEY_ESCAPE = 27;

	var WIDGET_CONTAINER_SELECTOR = '.inline-edit__widget-container';

	var ngModelController = $element.controller('ngModel');
	var fieldId = _.uniqueId('inlineEdit-');

	var optionsDefinition = {
		type: 'text',
		id: fieldId,
		'ng-blur': "vm.finishEditing()",
		//'ng-click': "vm.finishEditing()",
		'ng-model': "vm.newValue",
		'ng-trim': "false",
		'cmnt-autosize': ""
	};

	vm.startEditing = startEditing;
	vm.finishEditing = finishEditing;

	activate();

	function activate() {
		vm.enabled = vm.enabled === undefined ? true : vm.enabled;

		vm.editing = false;

		if (vm.inputOptions) {
			var parsedInputOptions = $scope.$eval(vm.inputOptions);

			angular.extend(optionsDefinition, parsedInputOptions || {});
		}

		ngModelController.$render = function() {
			vm.newValue = ngModelController.$viewValue;
		};

		vm.delegate = {
			startEditing: startEditing
		};
	}

	function startEditing() {
		if (!vm.enabled) {
			return;
		}

		vm.newValue = ngModelController.$viewValue;
		vm.editing = true;

		$timeout(function() {
			_insertInput();
		}).then(function() {
			_focusField();
			_setupKeyupHandler();
		});
	}

	function finishEditing() {
		var oldValue = ngModelController.$viewValue;
		ngModelController.$setViewValue(vm.newValue);

		if (oldValue !== vm.newValue) {
			var valueChangePromise = vm.onValueChanged({oldValue: oldValue, newValue: vm.newValue}) || $q.when();

			valueChangePromise.then(angular.noop, function() {
				ngModelController.$setViewValue(oldValue);
			});
		}

		_closeWidget();
	}

	function _focusField() {
		_getInput().focus();
	}

	function _insertInput() {
		var inputElement = angular.element('<input>');

		_.keys(optionsDefinition).forEach(function(key) {
			var value = optionsDefinition[key];

			if (key === 'class') {
				inputElement.addClass(value);
			} else {
				inputElement.attr(key, value);
			}
		});

		$element.find(WIDGET_CONTAINER_SELECTOR).append(inputElement);

		$compile(inputElement)($scope);
	}

	function _closeWidget() {
		vm.editing = false;

		_getInput().remove();
	}

	function _setupKeyupHandler() {
		var input = _getInput();

		if (input.length === 0) {
			return;
		}

		input.keyup(function(e) {
			switch (e.which) {
				case KEY_ENTER:
					$timeout(function() {
						finishEditing();
					});

					e.stopPropagation();
					e.preventDefault();

					break;

				case KEY_ESCAPE:
					$timeout(function() {
						_closeWidget();
					});

					break;
			}
		});
	}

	function _getInput() {
		return $('#' + fieldId);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntLoadingIndicator', loadingIndicatorDirective);


function loadingIndicatorDirective() {
	return {
		templateUrl: 'core/uihelpers/loadingIndicator.directive.html',
		replace: true,
		scope: {
			resource: '=',
			spinnerSize: '@?'
		},
		link: function(scope, elm, attrs) {
			if (scope.spinnerSize === undefined) {
				scope.spinnerSize = 'icon-lg'
			}

		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.filter('cmntMiddleTruncate', cmntMiddleTruncate);

cmntMiddleTruncate.$inject = [];

function cmntMiddleTruncate() {
	return function(fullStr, strLen, tailLen, separator) {
		if (fullStr.length <= strLen) return fullStr;

		separator = separator || '...';
		tailLen = tailLen || 7;

		var sepLen = separator.length,
			charsToShow = strLen - sepLen,
			frontChars = charsToShow - tailLen;

		return fullStr.substr(0, frontChars) +
			separator +
			fullStr.substr(fullStr.length - tailLen);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntPreventDefault', preventDefaultDirective);


function preventDefaultDirective() {
	return {
		link: function(scope, elm) {
			$(elm).click(function(event) {
				event.preventDefault();
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntSelectionOrClick', cmntSelectionOrClick);

function cmntSelectionOrClick() {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			var time = Date.now();

			element.on("mousedown mouseup", function(e) {
				if (e.type === "mousedown") {
					time = Date.now();
				} else if (e.type === "mouseup") {
					Date.now() - time < 300 ?  scope.$evalAsync(attrs.cmntSelectionOrClick) : false;
				}
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntSelectionOrClickStopPropagation', cmntSelectionOrClickStopPropagation);

function cmntSelectionOrClickStopPropagation() {
	return {
		link: function (scope, element) {
			element.on("mouseup", function(event) {
				event.stopPropagation();
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntSpinnerAction', cmntSpinnerAction);

cmntSpinnerAction.$inject = ['$parse'];

function cmntSpinnerAction($parse) {
	return {
		restrict: 'A',

		link: function(scope, element, attrs, formCtrl) {
			var fn = $parse(attrs.cmntSpinnerAction);
			$(element).click(function(event) {
				var ngDisabled = false;
				if (attrs.ngDisabled) {
					ngDisabled = $parse(attrs.ngDisabled)(scope);
				}

				if (!(ngDisabled || $(element).attr('disabled'))) {
					var promise = fn(scope, {$event: event});
					if (promise != undefined) {
						scope.$apply(function() {
							$(element).attr('disabled', true);
							$(element).prepend('<i class="icon icon-spinner icon-spin6"></i>');
						});

						promise.finally(function() {
							scope.$evalAsync(function() {
								$(element).find('.icon-spinner').remove();
								$(element).removeAttr('disabled');
							});
						})
					}
				}
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntStopPropagation', stopPropagationDirective);


function stopPropagationDirective() {
	return {
		link: function(scope, elm) {
			$(elm).click(function(event) {
				event.stopPropagation();
			});
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('cmntStringToNumber', cmntStringToNumber);


function cmntStringToNumber() {
	return {
		require: 'ngModel',
		link: function(scope, element, attrs, ngModel) {
			ngModel.$parsers.push(function(value) {
				if (value === null || value === undefined) {
					return value;
				} else {
					return '' + value;
				}
			});

			ngModel.$formatters.push(function(value) {
				return parseFloat(value);
			});
		}
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.directive('uiSelectFix', uiSelectFixDirective);
//TODO Delete after https://github.com/angular-ui/ui-select/pull/1936 merge.
//not fully solution(not works if $select.$animate is null)

uiSelectFixDirective.$inject = ['$timeout', 'uisOffset', '$document'];

function uiSelectFixDirective($timeout, uisOffset, $document) {
	return {
		require: '^uiSelect',
		restrict: 'A',
		link: function(scope, element1, attrs, $select) {
			var element = $select.$element;

			var dropdown = null,
				directionUpClassName = 'direction-up';

			var setDropdownPosUp = function(offset, offsetDropdown) {

				offset = offset || uisOffset(element);
				offsetDropdown = offsetDropdown || uisOffset(dropdown);

				dropdown[0].style.position = 'absolute';
				dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
				element.addClass(directionUpClassName);

			};

			var setDropdownPosDown = function(offset, offsetDropdown) {

				element.removeClass(directionUpClassName);

				offset = offset || uisOffset(element);
				offsetDropdown = offsetDropdown || uisOffset(dropdown);

				dropdown[0].style.position = '';
				dropdown[0].style.top = '';

			};

			var calculateDropdownPosAfterAnimation = function() {
				// Delay positioning the dropdown until all choices have been added so its height is correct.
				$timeout(function() {
					if ($select.dropdownPosition === 'up') {
						//Go UP
						setDropdownPosUp();
					} else {
						//AUTO
						element.removeClass(directionUpClassName);

						var offset = uisOffset(element);
						var offsetDropdown = uisOffset(dropdown);

						//https://code.google.com/p/chromium/issues/detail?id=342307#c4
						var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).

						// Determine if the direction of the dropdown needs to be changed.
						if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
							//Go UP
							setDropdownPosUp(offset, offsetDropdown);
						} else {
							//Go DOWN
							setDropdownPosDown(offset, offsetDropdown);
						}
					}

					// Display the dropdown once it has been positioned.
					dropdown[0].classList.remove('ui-select-detached');
				});
			};

			var opened = false;

			scope.calculateDropdownPos = function() {
				if ($select.open) {
					dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');

					if (dropdown.length === 0) {
						return;
					}

					// Hide the dropdown so there is no flicker until $timeout is done executing.
					if ($select.search === '' && !opened) {
						dropdown[0].classList.add('ui-select-detached');
						opened = true;
					}

					if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
						var needsCalculated = true;

						$select.$animate.on('enter', dropdown, function(elem, phase) {
							if (phase === 'close' && needsCalculated) {
								calculateDropdownPosAfterAnimation();
								needsCalculated = false;
							}
						});
					} else {
						calculateDropdownPosAfterAnimation();
					}
				} else {
					if (dropdown === null || dropdown.length === 0) {
						return;
					}

					// Reset the position of the dropdown.
					dropdown[0].classList.add('ui-select-detached');
					dropdown[0].style.position = '';
					dropdown[0].style.top = '';
					element.removeClass(directionUpClassName);
				}
			};
		}
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.directive('cmntButtonGroup', function() {
		return {
			scope: {
				choices: '='
			},
			templateUrl: 'core/widgets/buttonGroup.diretive.html',
			controller: TimeframeController,
			controllerAs: 'vm',
			bindToController: true,
			require: 'ngModel'
		}
	});

TimeframeController.$inject = ['$element'];

function TimeframeController($element) {
	var vm = this;

	vm.ngModel = $element.controller('ngModel');
	vm.setValue = setValue;

	function setValue(timeframe) {
		vm.ngModel.$setViewValue(timeframe);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.core')
	.directive('cmntSearchField', function() {
		return {
			scope: {},
			templateUrl: 'core/widgets/searchField.directive.html',
			controller: SearchField,
			controllerAs: 'vm',
			bindToController: true,
			require: 'ngModel',
			replace: true
		}
	});

SearchField.$inject = ['$element'];

function SearchField($element) {
	var vm = this;

	vm.queryChanged = queryChanged;
	vm.searchBlur = searchBlur;

	activate();

	function activate() {
		vm.ngModel = $element.controller('ngModel');
		vm.lastQuery = '';
		vm.query = '';
	}

	function queryChanged() {
		vm.lastQuery = vm.query;
		vm.ngModel.$setViewValue(vm.query);
	}

	function searchBlur() {
		if (vm.query !== vm.lastQuery) {
			queryChanged();
		}
	}
}

})();
(function() {
'use strict';
angular.module('community.core')

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
	.factory('typeaheadParser', ['$parse', function($parse) {
		//                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
		var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
		return {
			parse: function(input) {
				var match = input.match(TYPEAHEAD_REGEXP);
				if (!match) {
					throw new Error(
						'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
						' but got "' + input + '".');
				}

				return {
					itemName: match[3],
					source: $parse(match[4]),
					viewMapper: $parse(match[2] || match[1]),
					modelMapper: $parse(match[1])
				};
			}
		};
	}])

	.factory('$$debounce', ['$timeout', function($timeout) {
		return function(callback, debounceTime) {
			var timeoutPromise;

			return function() {
				var self = this;
				var args = Array.prototype.slice.call(arguments);
				if (timeoutPromise) {
					$timeout.cancel(timeoutPromise);
				}

				timeoutPromise = $timeout(function() {
					callback.apply(self, args);
				}, debounceTime);
			};
		};
	}])

	.controller('CmntTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$position', 'typeaheadParser',
		function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
			var HOT_KEYS = [9, 13, 27, 38, 40];
			var eventDebounceTime = 200;
			var modelCtrl, ngModelOptions;
			//SUPPORTED ATTRIBUTES (OPTIONS)

			//minimal no of characters that needs to be entered before typeahead kicks-in
			var minLength = originalScope.$eval(attrs.typeaheadMinLength);
			if (!minLength && minLength !== 0) {
				minLength = 1;
			}

			originalScope.$watch(attrs.typeaheadMinLength, function(newVal) {
				minLength = !newVal && newVal !== 0 ? 1 : newVal;
			});

			//minimal wait time after last character typed before typeahead kicks-in
			var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

			//should it restrict model values to the ones selected from the popup only?
			var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
			originalScope.$watch(attrs.typeaheadEditable, function(newVal) {
				isEditable = newVal !== false;
			});

			//binding to a variable that indicates if matches are being retrieved asynchronously
			var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

			//a function to determine if an event should cause selection
			var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
				var evt = vals.$event;
				return evt.which === 13 || evt.which === 9;
			};

			//a callback executed when a match is selected
			var onSelectCallback = $parse(attrs.typeaheadOnSelect);

			//should it select highlighted popup value when losing focus?
			var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

			//binding to a variable that indicates if there were no results after the query is completed
			var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

			var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

			var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

			var appendTo = attrs.typeaheadAppendTo ?
				originalScope.$eval(attrs.typeaheadAppendTo) : null;

			var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

			//If input matches an item of the list exactly, select it automatically
			var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

			//binding to a variable that indicates if dropdown is open
			var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

			var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

			//INTERNAL VARIABLES

			//model setter executed upon match selection
			var parsedModel = $parse(attrs.ngModel);
			var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
			var $setModelValue = function(scope, newValue) {
				if (angular.isFunction(parsedModel(originalScope)) &&
					ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
					return invokeModelSetter(scope, {$$$p: newValue});
				}

				return parsedModel.assign(scope, newValue);
			};

			//expressions used by typeahead
			var parserResult = typeaheadParser.parse(attrs.typeahead);

			var hasFocus;

			//Used to avoid bug in iOS webview where iOS keyboard does not fire
			//mousedown & mouseup events
			//Issue #3699
			var selected;

			//create a child scope for the typeahead directive so we are not polluting original scope
			//with typeahead-specific data (matches, query etc.)
			var scope = originalScope.$new();
			var offDestroy = originalScope.$on('$destroy', function() {
				scope.$destroy();
			});
			scope.$on('$destroy', offDestroy);

			// WAI-ARIA
			var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
			element.attr({
				'aria-autocomplete': 'list',
				'aria-expanded': false,
				'aria-owns': popupId
			});

			var inputsContainer, hintInputElem;
			//add read-only input to show hint
			if (showHint) {
				inputsContainer = angular.element('<div></div>');
				inputsContainer.css('position', 'relative');
				element.after(inputsContainer);
				hintInputElem = element.clone();
				hintInputElem.attr('placeholder', '');
				hintInputElem.attr('tabindex', '-1');
				hintInputElem.val('');
				hintInputElem.css({
					'position': 'absolute',
					'top': '0px',
					'left': '0px',
					'border-color': 'transparent',
					'box-shadow': 'none',
					'opacity': 1,
					'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
					'color': '#999'
				});
				element.css({
					'position': 'relative',
					'vertical-align': 'top',
					'background-color': 'transparent'
				});

				if (hintInputElem.attr('id')) {
					hintInputElem.removeAttr('id'); // remove duplicate id if present.
				}
				inputsContainer.append(hintInputElem);
				hintInputElem.after(element);
			}

			//pop-up element used to display matches
			var popUpEl = angular.element('<div typeahead-popup></div>');
			popUpEl.attr({
				id: popupId,
				matches: 'matches',
				active: 'activeIdx',
				select: 'select(activeIdx, evt)',
				'move-in-progress': 'moveInProgress',
				query: 'query',
				position: 'position',
				'assign-is-open': 'assignIsOpen(isOpen)',
				debounce: 'debounceUpdate'
			});
			//custom item template
			if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
				popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
			}

			if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
				popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
			}

			var resetHint = function() {
				if (showHint) {
					hintInputElem.val('');
				}
			};

			var resetMatches = function() {
				scope.matches = [];
				scope.activeIdx = -1;
				element.attr('aria-expanded', false);
				resetHint();
			};

			var getMatchId = function(index) {
				return popupId + '-option-' + index;
			};

			// Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
			// This attribute is added or removed automatically when the `activeIdx` changes.
			scope.$watch('activeIdx', function(index) {
				if (index < 0) {
					element.removeAttr('aria-activedescendant');
				} else {
					element.attr('aria-activedescendant', getMatchId(index));
				}
			});

			var inputIsExactMatch = function(inputValue, index) {
				if (scope.matches.length > index && inputValue) {
					return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
				}

				return false;
			};

			var getMatchesAsync = function(inputValue, evt) {
				var locals = {$viewValue: inputValue};
				isLoadingSetter(originalScope, true);
				isNoResultsSetter(originalScope, false);
				$q.when(parserResult.source(originalScope, locals)).then(function(matches) {
					//it might happen that several async queries were in progress if a user were typing fast
					//but we are interested only in responses that correspond to the current view value
					var onCurrentRequest = inputValue === modelCtrl.$viewValue;
					if (onCurrentRequest && hasFocus) {
						if (matches && matches.length > 0) {
							scope.activeIdx = focusFirst ? 0 : -1;
							isNoResultsSetter(originalScope, false);
							scope.matches.length = 0;

							//transform labels
							for (var i = 0; i < matches.length; i++) {
								locals[parserResult.itemName] = matches[i];
								scope.matches.push({
									id: getMatchId(i),
									label: parserResult.viewMapper(scope, locals),
									model: matches[i]
								});
							}

							scope.query = inputValue;
							//position pop-up with matches - we need to re-calculate its position each time we are opening a window
							//with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
							//due to other elements being rendered
							recalculatePosition();

							element.attr('aria-expanded', true);

							//Select the single remaining option if user input matches
							if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
								if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
									$$debounce(function() {
										scope.select(0, evt);
									}, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
								} else {
									scope.select(0, evt);
								}
							}

							if (showHint) {
								var firstLabel = scope.matches[0].label;
								if (angular.isString(inputValue) &&
									inputValue.length > 0 &&
									firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
									hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
								} else {
									hintInputElem.val('');
								}
							}
						} else {
							resetMatches();
							isNoResultsSetter(originalScope, true);
						}
					}
					if (onCurrentRequest) {
						isLoadingSetter(originalScope, false);
					}
				}, function() {
					resetMatches();
					isLoadingSetter(originalScope, false);
					isNoResultsSetter(originalScope, true);
				});
			};

			// bind events only if appendToBody params exist - performance feature
			if (appendToBody) {
				angular.element($window).on('resize', fireRecalculating);
				$document.find('body').on('scroll', fireRecalculating);
			}

			// Declare the debounced function outside recalculating for
			// proper debouncing
			var debouncedRecalculate = $$debounce(function() {
				// if popup is visible
				if (scope.matches.length) {
					recalculatePosition();
				}

				scope.moveInProgress = false;
			}, eventDebounceTime);

			// Default progress type
			scope.moveInProgress = false;

			function fireRecalculating() {
				if (!scope.moveInProgress) {
					scope.moveInProgress = true;
					scope.$digest();
				}

				debouncedRecalculate();
			}

			// recalculate actual position and set new values to scope
			// after digest loop is popup in right position
			function recalculatePosition() {
				scope.position = appendToBody ? $position.offset(element) : $position.position(element);
				scope.position.top += element.prop('offsetHeight');
			}

			//we need to propagate user's query so we can higlight matches
			scope.query = undefined;

			//Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
			var timeoutPromise;

			var scheduleSearchWithTimeout = function(inputValue) {
				timeoutPromise = $timeout(function() {
					getMatchesAsync(inputValue);
				}, waitTime);
			};

			var cancelPreviousTimeout = function() {
				if (timeoutPromise) {
					$timeout.cancel(timeoutPromise);
				}
			};

			resetMatches();

			scope.assignIsOpen = function(isOpen) {
				isOpenSetter(originalScope, isOpen);
			};

			scope.select = function(activeIdx, evt) {
				//called from within the $digest() cycle
				var locals = {};
				var model, item;

				selected = true;
				locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
				model = parserResult.modelMapper(originalScope, locals);
				$setModelValue(originalScope, model);
				modelCtrl.$setValidity('editable', true);
				modelCtrl.$setValidity('parse', true);

				onSelectCallback(originalScope, {
					$item: item,
					$model: model,
					$label: parserResult.viewMapper(originalScope, locals),
					$event: evt
				});

				resetMatches();

				//return focus to the input element if a match was selected via a mouse click event
				// use timeout to avoid $rootScope:inprog error
				if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
					$timeout(function() {
						element[0].focus();
					}, 0, false);
				}
			};

			//bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
			element.on('keydown', function(evt) {
				//typeahead is open and an "interesting" key was pressed
				if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
					return;
				}

				var shouldSelect = isSelectEvent(originalScope, {$event: evt});

				/**
				 * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
				 * or
				 * shift + tab is pressed to bring focus to the previous element
				 * then clear the results
				 */
				if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
					resetMatches();
					scope.$digest();
					return;
				}

				evt.preventDefault();
				var target;
				switch (evt.which) {
					case 27: // escape
						evt.stopPropagation();

						resetMatches();
						originalScope.$digest();
						break;
					case 38: // up arrow
						scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
						scope.$digest();
						target = popUpEl[0].querySelectorAll('.typeahead-match')[scope.activeIdx];
						target.parentNode.scrollTop = target.offsetTop;
						break;
					case 40: // down arrow
						scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
						scope.$digest();
						target = popUpEl[0].querySelectorAll('.typeahead-match')[scope.activeIdx];
						target.parentNode.scrollTop = target.offsetTop;
						break;
					default:
						if (shouldSelect) {
							scope.$apply(function() {
								if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
									$$debounce(function() {
										scope.select(scope.activeIdx, evt);
									}, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
								} else {
									scope.select(scope.activeIdx, evt);
								}
							});
						}
				}
			});

			element.bind('focus', function(evt) {
				hasFocus = true;
				if (minLength === 0 && !modelCtrl.$viewValue) {
					$timeout(function() {
						getMatchesAsync(modelCtrl.$viewValue, evt);
					}, 0);
				}
			});

			element.bind('blur', function(evt) {
				if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
					selected = true;
					scope.$apply(function() {
						if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
							$$debounce(function() {
								scope.select(scope.activeIdx, evt);
							}, scope.debounceUpdate.blur);
						} else {
							scope.select(scope.activeIdx, evt);
						}
					});
				}
				if (!isEditable && modelCtrl.$error.editable) {
					modelCtrl.$setViewValue();
					scope.$apply(function() {
						// Reset validity as we are clearing
						modelCtrl.$setValidity('editable', true);
						modelCtrl.$setValidity('parse', true);
					});
					element.val('');
				}
				hasFocus = false;
				selected = false;
			});

			// Keep reference to click handler to unbind it.
			var dismissClickHandler = function(evt) {
				// Issue #3973
				// Firefox treats right click as a click on document
				if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
					resetMatches();
					if (!$rootScope.$$phase) {
						originalScope.$digest();
					}
				}
			};

			$document.on('click', dismissClickHandler);

			originalScope.$on('$destroy', function() {
				$document.off('click', dismissClickHandler);
				if (appendToBody || appendTo) {
					$popup.remove();
				}

				if (appendToBody) {
					angular.element($window).off('resize', fireRecalculating);
					$document.find('body').off('scroll', fireRecalculating);
				}
				// Prevent jQuery cache memory leak
				popUpEl.remove();

				if (showHint) {
					inputsContainer.remove();
				}
			});

			var $popup = $compile(popUpEl)(scope);

			if (appendToBody) {
				$document.find('body').append($popup);
			} else if (appendTo) {
				angular.element(appendTo).eq(0).append($popup);
			} else {
				element.after($popup);
			}

			this.init = function(_modelCtrl, _ngModelOptions) {
				modelCtrl = _modelCtrl;
				ngModelOptions = _ngModelOptions;

				scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

				//plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
				//$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
				modelCtrl.$parsers.unshift(function(inputValue) {
					hasFocus = true;

					if (minLength === 0 || inputValue && inputValue.length >= minLength) {
						if (waitTime > 0) {
							cancelPreviousTimeout();
							scheduleSearchWithTimeout(inputValue);
						} else {
							getMatchesAsync(inputValue);
						}
					} else {
						isLoadingSetter(originalScope, false);
						cancelPreviousTimeout();
						resetMatches();
					}

					if (isEditable) {
						return inputValue;
					}

					if (!inputValue) {
						// Reset in case user had typed something previously.
						modelCtrl.$setValidity('editable', true);
						return null;
					}

					modelCtrl.$setValidity('editable', false);
					return undefined;
				});

				modelCtrl.$formatters.push(function(modelValue) {
					var candidateViewValue, emptyViewValue;
					var locals = {};

					// The validity may be set to false via $parsers (see above) if
					// the model is restricted to selected values. If the model
					// is set manually it is considered to be valid.
					if (!isEditable) {
						modelCtrl.$setValidity('editable', true);
					}

					if (inputFormatter) {
						locals.$model = modelValue;
						return inputFormatter(originalScope, locals);
					}

					//it might happen that we don't have enough info to properly render input value
					//we need to check for this situation and simply return model value if we can't apply custom formatting
					locals[parserResult.itemName] = modelValue;
					candidateViewValue = parserResult.viewMapper(originalScope, locals);
					locals[parserResult.itemName] = undefined;
					emptyViewValue = parserResult.viewMapper(originalScope, locals);

					return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
				});
			};
		}])

	.directive('typeahead', function() {
		return {
			controller: 'CmntTypeaheadController',
			require: ['ngModel', '^?ngModelOptions', 'typeahead'],
			link: function(originalScope, element, attrs, ctrls) {
				ctrls[2].init(ctrls[0], ctrls[1]);
			}
		};
	})

	.directive('typeaheadPopup', ['$$debounce', function($$debounce) {
		return {
			scope: {
				matches: '=',
				query: '=',
				active: '=',
				position: '&',
				moveInProgress: '=',
				select: '&',
				assignIsOpen: '&',
				debounce: '&'
			},
			replace: true,
			templateUrl: function(element, attrs) {
				return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
			},
			link: function(scope, element, attrs) {
				scope.templateUrl = attrs.templateUrl;

				scope.isOpen = function() {
					var isDropdownOpen = scope.matches.length > 0;
					scope.assignIsOpen({isOpen: isDropdownOpen});
					return isDropdownOpen;
				};

				scope.isActive = function(matchIdx) {
					return scope.active === matchIdx;
				};

				scope.selectActive = function(matchIdx) {
					scope.active = matchIdx;
				};

				scope.selectMatch = function(activeIdx, evt) {
					var debounce = scope.debounce();
					if (angular.isNumber(debounce) || angular.isObject(debounce)) {
						$$debounce(function() {
							scope.select({activeIdx: activeIdx, evt: evt});
						}, angular.isNumber(debounce) ? debounce : debounce['default']);
					} else {
						scope.select({activeIdx: activeIdx, evt: evt});
					}
				};
			}
		};
	}])

	.directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
		return {
			scope: {
				index: '=',
				match: '=',
				query: '='
			},
			link: function(scope, element, attrs) {
				var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
				$templateRequest(tplUrl).then(function(tplContent) {
					var tplEl = angular.element(tplContent.trim());
					element.replaceWith(tplEl);
					$compile(tplEl)(scope);
				});
			}
		};
	}])

	.filter('typeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
		var isSanitizePresent;
		isSanitizePresent = $injector.has('$sanitize');

		function escapeRegexp(queryToEscape) {
			// Regex: capture the whole query string and replace it with the string that will be used to match
			// the results, for example if the capture is "a" the result will be \a
			return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
		}

		function containsHtml(matchItem) {
			return /<.*>/g.test(matchItem);
		}

		return function(matchItem, query) {
			if (!isSanitizePresent && containsHtml(matchItem)) {
				$log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
			}
			matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
			if (!isSanitizePresent) {
				matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
			}
			return matchItem;
		};
	}]);

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('autoselect', autoselectDirective);

autoselectDirective.$inject = ['$timeout'];

function autoselectDirective($timeout) {
	return {
		restrict: 'A',
		link: function(scope, element, attrs) {
			$timeout(function() {
				$(element).select();
			});
		}
	};
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('BaseFamiliesList', BaseFamiliesListService);

BaseFamiliesListService.$inject = ['UnreadUpdater', 'BaseListService', 'OopHelpers'];

function BaseFamiliesListService(UnreadUpdater, BaseListService, OopHelpers) {
	function BaseFamiliesList(resource) {
		this.unreadUpdater = UnreadUpdater();
		this.listPropertyName = 'families';
		this.countsByType = {};

		BaseListService.call(this, resource);
	}

	OopHelpers.subclass(BaseFamiliesList, BaseListService);

	BaseFamiliesList.prototype.init = function() {
		this.unreadUpdater.subscribe();
	};

	BaseFamiliesList.prototype.onInitialLoad = function() {
		this.unreadUpdater.clear();
	};

	// BaseFamiliesList.prototype.onObjectsAdded = function(objects) {
	//     var self = this;
	//
	//     _.forEach(objects, function(family) {
	//         _.forEach(family.family_members, function(familyMember) {
	//             _.forEach(familyMember.tasks, function(task) {
	//                 var enquiry = task.enquiry;
	//
	//                 if (enquiry) {
	//                     self.unreadUpdater.addConversations(enquiry.supplier_conversations);
	//                 }
	//             });
	//         });
	//     });
	// };

	BaseFamiliesList.prototype.onEnquiryAdded = function(enquiry) {
		var self = this;

		if (enquiry) {
			self.unreadUpdater.addConversations(enquiry.supplier_conversations);
		}
	};

	BaseFamiliesList.prototype.anticipatedCost = function() {
		var self = this;

		return self.resource.anticipatedCost(self.params);
	};

	return BaseFamiliesList;
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntBudgetToggle', function() {
		return {
			scope: {
				task: '=',
				currentUser: '<',
				baseCurrency: '=?'
			},
			templateUrl: 'ip/families/budgetToggle.directive.html',
			controller: BudgetToggleController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

BudgetToggleController.$inject = ['Task', '$scope', 'PekamaConfig'];

function BudgetToggleController(Task, $scope, PekamaConfig) {
	var vm = this;

	vm.setChoice = setChoice;
	vm.priceChanged = priceChanged;
	vm.supplierPriceChanged = supplierPriceChanged;

	activate();

	function activate() {
		vm.editBudgetInProgress = false;
		vm.editSupplierBudgetInProgress = false;
		_setNumber();
		_setSupplierBudget();
	}

	function setChoice(budgetOption) {
		return Task.budgetStatus({id: vm.task.id, budget_status: budgetOption}).$promise.then(function() {
			vm.task.budget_status = budgetOption;

			$scope.$emit('budget_updated');
		});
	}

	function priceChanged(oldValue, newValue) {
		return Task.update({
			id: vm.task.id,
			number: newValue,
			number_currency: vm.baseCurrency || PekamaConfig.defaultCurrency
		}).$promise.then(function(data) {
			angular.extend(vm.task, _.pick(data, 'number', 'converted_number', 'multiplied_budget',
				'converted_multiplied_budget'));

			_setNumber();

			$scope.$emit('budget_updated');
		});
	}

	function supplierPriceChanged(oldValue, newValue) {
		return Task.update({
			id: vm.task.id,
			supplier_budget: newValue,
			supplier_budget_currency: vm.baseCurrency || PekamaConfig.defaultCurrency
		}).$promise.then(function(data) {
			angular.extend(vm.task, _.pick(data, 'supplier_budget', 'converted_supplier_budget',
				'multiplied_supplier_budget', 'converted_multiplied_supplier_budget'));

			_setSupplierBudget();
		});
	}

	function _setNumber() {
		if (vm.task.converted_multiplied_budget) {
			vm.convertedLabel = 'Estimated total service fee<br>Converted from ' + vm.task.multiplied_budget.formatted;
			vm.multiplied_budget = vm.task.converted_multiplied_budget;
			vm.number = vm.task.converted_number;
		} else {
			vm.convertedLabel = 'Estimated total service fee';
			vm.multiplied_budget = vm.task.multiplied_budget;
			vm.number = vm.task.number;
		}
	}

	function _setSupplierBudget() {
		if (vm.task.converted_multiplied_supplier_budget) {
			vm.convertedExistingLabel = 'Official fee<br>Converted from ' + vm.task.multiplied_supplier_budget.formatted;
			vm.multiplied_supplier_budget = vm.task.converted_multiplied_supplier_budget;
			vm.supplier_budget = vm.task.converted_supplier_budget;
		} else {
			vm.convertedExistingLabel = 'Official fee';
			vm.multiplied_supplier_budget = vm.task.multiplied_supplier_budget;
			vm.supplier_budget = vm.task.supplier_budget;
		}
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.filter('cmntContactsListFormat', cmntContactsListFormat);

cmntContactsListFormat.$inject = [];

function cmntContactsListFormat() {
	return function(contacts) {
		var r = _.rest(contacts);
		return r.join('; ');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntCountsByType', function() {
		return {
			scope: {
				families: '=',
				familiesCounts: '='
			},
			templateUrl: 'ip/families/countsByType.directive.html',
			controller: CountsByTypeController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

CountsByTypeController.$inject = ['$scope', 'MatterTypes', 'ArrayHelper'];

function CountsByTypeController($scope, MatterTypes, ArrayHelper) {
	var vm = this;

	vm.countsByType = {};

	MatterTypes.getList().then(function() {
		vm.matterTypes = MatterTypes.objects;

		$scope.$watchCollection('vm.familiesCounts', function(newValue, oldValue) {
			if (newValue && newValue.$resolved) {
				for (var key in vm.countsByType) {
					if (!vm.countsByType.hasOwnProperty(key)) {
						continue;
					}

					delete vm.countsByType[key];
				}

				_.forEach(newValue, function(countsResult) {
					var id = countsResult.matter_type;

					var matterType = ArrayHelper.findById(vm.matterTypes, id);

					var countsData = {
						label: matterType.title,
						label_plural: matterType.title_verbose,
						results: countsResult.results
					};

					vm.countsByType[id] = countsData;
				});
			}
		});
	});
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntDropdown', function() {
		return {
			scope: {},
			templateUrl: 'ip/families/dropdown.directive.html',
			controller: DropdownController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

DropdownController.$inject = ['$scope', '$element', 'Navigation', '$timeout',
	'CommunityProfileService'];

function DropdownController($scope, $element, Navigation, $timeout,
							CommunityProfileService) {
	var vm = this;
	var $body = angular.element(document.querySelector('body'));

	vm.active = false;
	vm.toggleMenu = toggleMenu;
	vm.goToSearch = goToSearch;
	vm.goToTrademarkSearch = goToTrademarkSearch;

	vm.Navigation = Navigation;

	function toggleMenu() {
		if (vm.active) {
			close();
		} else {
			open();
		}
	}

	function close(e) {
		vm.active = false;

		$body.off('click', closeOnClick);
	}

	function open(e) {
		vm.active = true;

		$body.on('click', closeOnClick);
	}

	function closeOnClick(e) {
		var elementContents = Array.prototype.slice.apply($element[0].querySelectorAll('*'));

		if (!elementContents.length) {
			return;
		}

		var isOuterElement = _.every(elementContents, function(node) {
			return node !== e.target
		});

		if (isOuterElement) {
			close();
			$scope.$apply();
		}
	}

	function goToSearch() {
		Navigation.go('community.search');
	}

	function goToTrademarkSearch() {
		Navigation.go('community.trademarkSearch');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('FamiliesController', FamiliesController);

FamiliesController.$inject = ['FamiliesList', 'FlatFamiliesList', 'FamilyStatusService', 'Navigation', 'Wizard',
	'$scope', 'AuthService', 'CommunityProfileService', 'PekamaConfig', '$window', 'Family', '$stateParams',
	'Onboarding', 'OrganizationSettingsService', '$http', 'FamilyMember', 'PortalService', 'Task', 'RestErrors',
	'DefiningService', '$httpParamSerializer', '$timeout', 'Pusher', 'AlertFactory', 'SubMatters', '$modal',
	'cmntAnchorScroll', 'SubMatterPrimaryStatusesService'];

function FamiliesController(FamiliesList, FlatFamiliesList, FamilyStatusService, Navigation, Wizard,
							$scope, AuthService, CommunityProfileService, PekamaConfig, $window, Family, $stateParams,
							Onboarding, OrganizationSettingsService, $http, FamilyMember, PortalService, Task, RestErrors,
							DefiningService, $httpParamSerializer, $timeout, Pusher, AlertFactory, SubMatters, $modal,
							cmntAnchorScroll, SubMatterPrimaryStatusesService) {
	var vm = this;

	var currentUser;

	var ISO_DATE = 'YYYY-MM-DD';
	var DEFAULT_TIMEFRAME = 365;
	var TIMEFRAME_THROTTLE_MS = 1000;
	var ORDERING_LOCAL_STORAGE_KEY = 'ipPageOrdering';
	var LOCAL_STORAGE_VERSION_KEY = 'ipPageStorageVersion';
	var CURRENT_LOCAL_STORAGE_VERSION = 1;
	var DEFAULT_ORDERING = 'created';
	var EXPANDED_STATUS = 'considering filing';
	var COLLAPSED_STATUS = 'not filed';
	var FILED_STATUS = 'filed';
	var CHECKBOX_STATUSES = [EXPANDED_STATUS, COLLAPSED_STATUS];
	var MAYBE_INCLUDED = 'maybe_included';
	var DISCARDED = 'discarded';

	vm.orderingOptions = [
		{label: 'Approaching deadlines', value: 'closest_deadline'},
		{label: 'Recently active', value: 'last_activity'},
		{label: 'All families', value: 'created'}
	];
	vm.direction = 'all';
	vm.lastSearch = '';
	vm.showTasks = true;
	vm.profile = undefined;

	vm.timeframe = DEFAULT_TIMEFRAME;
	vm.convertableCurrencies = PekamaConfig.convertableCurrencies;
	vm.baseCurrency = PekamaConfig.defaultCurrency;

	vm.loadMore = loadMore;
	vm.filtersChanged = filtersChanged;
	vm.searchChanged = searchChanged;
	vm.searchBlur = searchBlur;
	vm.orderingChanged = orderingChanged;
	vm.viewConversation = viewConversation;
	vm.addTask = addTask;
	vm.timeframeChanged = _.throttle(timeframeChanged, TIMEFRAME_THROTTLE_MS);
	vm.newFamily = newFamily;
	vm.currencyChanged = currencyChanged;
	vm.toggleDiscarded = toggleDiscarded;
	vm.needsActivation = false;
	vm.updateTitle = updateTitle;
	vm.onDeadlineChanged = onDeadlineChanged;
	vm.hideJedMessage = hideJedMessage;
	vm.toggleCollapse = toggleCollapse;
	vm.toggleTasksVisibility = toggleTasksVisibility;
	vm.toggleNotFiled = toggleNotFiled;
	vm.initFamilyMemberState = initFamilyMemberState;
	vm.eyeVisible = eyeVisible;
	vm.showMemberAddingForm = showMemberAddingForm;
	vm.cancelAddingMember = cancelAddingMember;
	vm.addMember = addMember;
	vm.changeFilingDate = changeFilingDate;
	vm.classesNumberChanged = classesNumberChanged;
	vm.downloadExportedFile = downloadExportedFile;
	vm.archiveFamily = archiveFamily;
	vm.archiveMember = archiveMember;
	vm.onEnquiryLoaded = onEnquiryLoaded;
	vm.inviteReadOnlyMembership = inviteReadOnlyMembership;
	vm.changeStatus = changeStatus;
	vm.showSetFilingDateModal = showSetFilingDateModal;
	vm.getQuotationsWithClone = getQuotationsWithClone;

	vm.subMatterStatuses = {};

	vm.listService = FamiliesList;

	activate();

	$scope.$on('userAuthenticated', function() {
		activate();
		SubMatterPrimaryStatusesService.invalidateCache();
	});

	$scope.$on('currentUserUpdated', function() {
		activate();
		SubMatterPrimaryStatusesService.invalidateCache();
	});

	function activate() {
		vm.needsActivation = false;
		vm.displayPlaceholders = true;
		vm.statusMatterType = undefined;
		vm.profile = CommunityProfileService.getMine();
		vm.ordering = restoreOrdering();
		vm.timeframe = getTimeframe();
		vm.startDate = todayAsISODate();
		vm.endDate = moment(vm.startDate).add(vm.timeframe, 'days');

		vm.jedMessageDismissed = true;

		Onboarding.jedMessageDismissed().then(function(dismissed) {
			vm.jedMessageDismissed = dismissed;
		});

		AuthService.isAuthenticated().then(function(user) {
			vm.currentUser = user;
			currentUser = user;

			if (currentUser) {
				OrganizationSettingsService.getMine().then(function() {
					vm.baseCurrency = PekamaConfig.defaultCurrency;

					_loadFamilies();

					vm.families.$promise.finally(function() {
						vm.displayPlaceholders = false;
					});

					FamilyStatusService.invalidateCache();
				});
				vm.profile.$promise.then(function() {
					_subscribeToUpdates(vm.profile.organization.id);
				});

				vm.applicantsFacets = Family.getApplicantsFacets();
			} else {
				vm.families = vm.listService.loadEmpty();
			}
			if (user && user.first_name === "" && !user.is_read_only) {
				vm.needsActivation = true;
			}

		});

		// $scope.$on('budget_updated', function() {
		//     vm.anticipatedCost = vm.listService.anticipatedCost();
		// });

		$scope.$on('$destroy', function() {
			saveOrdering();
		});

		$window.onbeforeunload = function() {
			saveOrdering();
		};

		PortalService.getMine();
	}

	function loadMore() {
		vm.listService.loadMore();
	}

	function filtersChanged(newValues) {
		if ('matterType' in newValues && newValues.matterType !== vm.statusMatterType) {
			vm.statusMatterType = newValues.matterType;
			newValues['status'] = vm.status = undefined;

			FamilyStatusService.byMatterType(newValues.matterType).then(function(statuses) {
				vm.statuses = statuses;
			});
		}

		_loadFamilies(newValues);
	}

	function searchChanged() {
		vm.lastSearch = vm.fulltext;

		_loadFamilies({fulltext: vm.fulltext});
	}

	function searchBlur() {
		if (vm.fulltext !== vm.lastSearch) {
			searchChanged();
		}
	}

	function orderingChanged() {
		return _loadFamilies({ordering: vm.ordering});
	}

	function viewConversation(enquiry, conv) {
		Navigation.go('community.projects.projectsDetail.conversation', {
			projectId: enquiry.id,
			conversationId: conv.id
		});
	}

	function addTask(familyMember, family) {
		return Task.save({
			base_currency: vm.baseCurrency
		}, {
			sub_matter: familyMember.id,
			title: 'New task'
		}).$promise.then(function(taskData) {
			taskData.$new = true;

			familyMember.tasks.unshift(taskData);
		});
	}

	function _newFamily(matterTypeId) {
		return Family.save({
			matter_type_id: matterTypeId,
			title: 'New Family'
		}).$promise.then(function(familyData) {
			familyData.$new = true;

			vm.families.unshift(familyData);

			if (vm.listService.pagination.moreObjectsAvailable) {
				vm.families.pop();
			}

			vm.familiesCounts = Family.counts(_getQueryParams());

			return familyData;
		});
	}

	function newFamily(matterTypeId) {
		if (vm.ordering === 'closest_deadline') {
			vm.ordering = 'created';
			return orderingChanged().then(function() {
				return _newFamily(matterTypeId)
			});
		}
		return _newFamily(matterTypeId)
	}

	function timeframeChanged(startDate, endDate) {
		_loadFamilies({startDate: startDate, endDate: endDate});
	}

	function toggleDiscarded(familyMember, $close) {
		familyMember.$hideDiscarded = !familyMember.$hideDiscarded;
		$close();
	}

	function currencyChanged(newCurrency) {
		filtersChanged({base_currency: newCurrency});
		$http.post(PekamaConfig.apiBaseUrl + 'community/organization_settings/', {currency: newCurrency}).then(function(res) {
			PekamaConfig.defaultCurrency = res.data.currency;
		});
	}

	function _loadFamilies(filterParams) {
		if (!currentUser) {
			return;
		}

		var queryParams = _getQueryParams(filterParams);

		vm.listService = vm.ordering === 'closest_deadline' ? FlatFamiliesList : FamiliesList;

		vm.families = vm.listService.load(queryParams);
		// vm.anticipatedCost = vm.listService.anticipatedCost();

		if (vm.ordering !== 'closest_deadline') {
			vm.familiesCounts = Family.counts(queryParams);
		}

		return vm.families.$promise
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		var startDate = ('startDate' in newValues) ? newValues.startDate : vm.startDate;
		var endDate = ('endDate' in newValues) ? newValues.endDate : vm.endDate;

		if (startDate) {
			startDate = startDate.format(ISO_DATE);
		}

		if (endDate) {
			endDate = endDate.format(ISO_DATE);
		}

		return {
			matter_type: ('matterType' in newValues) ? newValues.matterType : vm.matterType,
			defining: ('defining' in newValues) ? newValues.jurisdiction : vm.jurisdiction,
			status: ('status' in newValues) ? newValues.status : vm.status,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			fulltext: ('fulltext' in newValues) ? newValues.fulltext : vm.fulltext,
			base_currency: ('base_currency' in newValues) ? newValues.base_currency : vm.baseCurrency,
			start_date: startDate,
			end_date: endDate,
			applicant: ('applicant' in newValues) ? newValues.applicant : vm.applicant
		};
	}

	function todayAsISODate() {
		return moment(new Date().toISOString().slice(0, 10), ISO_DATE);
	}

	function restoreOrdering() {
		return DEFAULT_ORDERING;
		// var storedVersion = parseInt($window.localStorage[LOCAL_STORAGE_VERSION_KEY]);
		//
		// if (!storedVersion || storedVersion !== CURRENT_LOCAL_STORAGE_VERSION) {
		//     $window.localStorage.removeItem(ORDERING_LOCAL_STORAGE_KEY);
		// }
		//
		// if ($stateParams.ordering) {
		//     return $stateParams.ordering;
		// }
		//
		// return $window.localStorage[ORDERING_LOCAL_STORAGE_KEY] || DEFAULT_ORDERING;
	}

	function saveOrdering() {
		$window.localStorage[LOCAL_STORAGE_VERSION_KEY] = CURRENT_LOCAL_STORAGE_VERSION;
		$window.localStorage[ORDERING_LOCAL_STORAGE_KEY] = vm.ordering;
	}

	function updateTitle(family) {
		return Family.update({
			id: family.id,
			title: family.title
		}).$promise;
	}

	function getTimeframe() {
		var timeframeFromUrl = $stateParams.timeframe;

		if (timeframeFromUrl) {
			var parsed = parseInt(timeframeFromUrl);

			if (!isNaN(parsed)) {
				return parsed;
			}
		}

		return DEFAULT_TIMEFRAME;
	}

	function onDeadlineChanged(task) {
		var momentDueDate = moment(task.due_date, ISO_DATE);
		var rangeDefined = vm.startDate && vm.endDate;
		var dueDateInRange = (momentDueDate >= vm.startDate && momentDueDate <= vm.endDate);

		if (task.due_date && rangeDefined && !dueDateInRange) {
			vm.listService.removeTask(task.id);
		}
	}

	function hideJedMessage() {
		vm.jedMessageDismissed = true;
	}

	function _setExpandMarkers(familyMember, family) {
		var expanded = true;
		var expandAvailable = false;

		if (familyMember.status && family.owned) {
			var status = _normalizeStatus(familyMember.status);

			expandAvailable = (CHECKBOX_STATUSES.indexOf(status) !== -1);
			expanded = (status !== COLLAPSED_STATUS);
		}

		familyMember.$expanded = expanded;
		familyMember.$checkboxTooltip = (expanded ? 'Collapse' : 'Expand') + " this jurisdiction";
		familyMember.$expandAvailable = expandAvailable && family.owned;
	}


	var _momentToday = moment().endOf('day');

	function initFamilyMemberState(familyMember, family) {
		_setExpandMarkers(familyMember, family);

		familyMember.$hideDiscarded = true;
		familyMember.$skipFilingDateChange = familyMember.application_date;

		var showMemberTasks = _restoreTasksVisibilityState(familyMember);
		if (showMemberTasks !== undefined) {
			familyMember.$showTasks = (showMemberTasks !== "false");
		} else {
			familyMember.$showTasks = familyMember.$expandAvailable || false;
			if (!familyMember.$showTasks && familyMember.defining_code === 'WO') {
				familyMember.$showTasks = _.some(familyMember.tasks, function(task) {
					if (task.due_date) {
						var momentDueDate = moment(task.due_date, 'YYYY-MM-DD');
						if (momentDueDate.isSame(_momentToday, 'day') || momentDueDate.isAfter(_momentToday, 'day')) {
							return true;
						}
					}
				})
			}
		}
		familyMember.$showTasksCheckboxTooltip = (familyMember.$showTasks ? 'Collapse' : 'Expand') + " this jurisdiction";

		if (!(familyMember.matter_type_id in vm.subMatterStatuses)) {
			vm.subMatterStatuses[familyMember.matter_type_id] = undefined;
			SubMatterPrimaryStatusesService.byMatterType(familyMember.matter_type_id).then(function(statuses) {
				vm.subMatterStatuses[familyMember.matter_type_id] = statuses;
			});
		}
	}

	function toggleCollapse(familyMember) {
		var action;

		familyMember.$checkboxTooltip = "";

		action = familyMember.$expanded ? FamilyMember.notFiled : FamilyMember.considerFiling;

		return action({id: familyMember.id}).$promise.then(function(resource) {
			familyMember.$expanded = !familyMember.$expanded;
			familyMember.$checkboxTooltip = (familyMember.$expanded ? 'Collapse' : 'Expand') + " this jurisdiction";
			familyMember.status = resource.status;
			familyMember.status_id = resource.status_id;
			familyMember.tasks.forEach(function(task) {
				task.budget_status = MAYBE_INCLUDED;
			});

			// vm.anticipatedCost = vm.listService.anticipatedCost();
		});
	}

	function toggleTasksVisibility(familyMember) {
		familyMember.$showTasks = !familyMember.$showTasks;
		familyMember.$showTasksCheckboxTooltip = (familyMember.$showTasks ? 'Collapse' : 'Expand') + " this jurisdiction";
		_saveTasksVisibilityState(familyMember, familyMember.$showTasks);
	}

	function toggleNotFiled(family, $close) {
		return Family.update({
			id: family.id,
			show_not_filed: !family.show_not_filed
		}).$promise.then(function(updatedResource) {
			family.show_not_filed = updatedResource.show_not_filed;
			$close();
		});
	}

	function eyeVisible(family) {
		if (!family.owned) {
			return false;
		}

		var hasNotFiledMembers = false;

		for (var i = 0; i < family.family_members.length; i++) {
			var member = family.family_members[i];

			if (member.status && _normalizeStatus(member.status) === COLLAPSED_STATUS) {
				hasNotFiledMembers = true;
				break;
			}
		}

		return hasNotFiledMembers;
	}

	function showMemberAddingForm(family, parentMember) {
		family.$addingMember = true;

		var matterTypeId = family.matter_type_id;

		if (matterTypeId && family.$jurisdictions === undefined) {
			DefiningService.byMatterType(matterTypeId).then(function(jurisdictions) {
				family.$jurisdictions = jurisdictions;
			});
		}

		if (parentMember) {
			family.$newJurisdictionCloneParent = parentMember;

			$timeout(function() {
				cmntAnchorScroll.yOffset = 100;
				cmntAnchorScroll('new-jurisdiction-form-' + family.id);
			})
		}
	}

	function cancelAddingMember(family) {
		family.$newJurisdiction = undefined;
		family.$newJurisdictionCloneParent = undefined;
		family.$addingMember = false;
	}

	function _addMemberFinally(family, familyMember) {
		family.$addingMember = false;
		family.family_members.unshift(familyMember);
		family.$newJurisdictionCloneParent = undefined;

		vm.familiesCounts = Family.counts(_getQueryParams());
	}

	function addMember(family) {
		if (family.$newJurisdictionCloneParent) {
			return FamilyMember.clone({
				id: family.$newJurisdictionCloneParent.id,
				defining: family.$newJurisdiction,
				type: family.$newJurisdictionCloneParent.defining_code == 'WO' ? 'nationalise' : 'validate'
			}).$promise.then(function(familyMember) {
				_addMemberFinally(family, familyMember)
			});
		}
		return FamilyMember.save({
			defining_id: family.$newJurisdiction,
			matter: family.id,
			title: family.title
		}).$promise.then(function(familyMember) {
			_addMemberFinally(family, familyMember)
		});
	}

	function showSetFilingDateModal(familyMember) {
		return $modal.open({
			templateUrl: 'ip/families/setFilingDate.modal.html',
			controller: 'SetFilingDateModalController as vm',
			windowClass: 'reveal_mini',
			resolve: {
				familyMember: function() {
					return familyMember;
				}
			}
		}).result.then(function(updatedData) {
			familyMember.$skipFilingDateChange = true;

			var status = '';
			if (familyMember.status) {
				status = _normalizeStatus(familyMember.status);
			}

			angular.extend(familyMember, updatedData);

			familyMember.$expanded = true;
			familyMember.$expandAvailable = false;

			if (status === COLLAPSED_STATUS) {
				familyMember.tasks.forEach(function(task) {
					task.budget_status = MAYBE_INCLUDED;
				});

				// vm.anticipatedCost = vm.listService.anticipatedCost();
			}
		});
	}

	function changeFilingDate(oldDate, newDate, familyMember, family) {
		if (familyMember.$skipFilingDateChange) {
			familyMember.$skipFilingDateChange = false;
			return;
		}

		_setFilingDate(familyMember, family, newDate)
	}

	function _setFilingDate(familyMember, family, newDate) {
		return FamilyMember.setFilingDate({
			id: familyMember.id,
			date: newDate.format(ISO_DATE)
		}).$promise.then(function(updatedData) {
			angular.extend(familyMember, updatedData);
		});
	}

	function _normalizeStatus(status) {
		return status.toLowerCase().trim();
	}

	function classesNumberChanged(oldValue, newValue, familyMember) {
		return FamilyMember.setClassesNumber({
			id: familyMember.id,
			classes_number: newValue
		}).$promise.then(function(data) {
			vm.listService.resource.get(angular.extend({id: familyMember.matter}, _getQueryParams())).$promise.then(function(updatedFamily) {
				var updatedMember = _.findWhere(updatedFamily.family_members, {id: familyMember.id});
				_.forEach(familyMember.tasks, function(oldTask) {
					var updatedTask = _.findWhere(updatedMember.tasks, {id: oldTask.id});
					if (!_.isEqual(updatedTask.number, oldTask.number) || !_.isEqual(updatedTask.supplier_budget, oldTask.supplier_budget)) {
						oldTask.$hideBudget = true;
						angular.extend(oldTask, _.pick(updatedTask, 'number', 'converted_number', 'multiplied_budget',
							'converted_multiplied_budget', 'supplier_budget', 'converted_supplier_budget',
							'multiplied_supplier_budget', 'converted_multiplied_supplier_budget'));

						$timeout(function() {
							oldTask.$hideBudget = false;
						}, 0);
					}
				})
			});
			// vm.anticipatedCost = vm.listService.anticipatedCost();
			return data;
		});
	}

	function downloadExportedFile() {
		if (vm.ordering === 'closest_deadline') {
			return
		}

		var exportFileLocation = PekamaConfig.apiBaseUrl + 'community/families/export/';

		var encodedUrlParams = $httpParamSerializer(_getQueryParams());

		if (encodedUrlParams.length > 0) {
			exportFileLocation += '?' + encodedUrlParams;
		}

		$window.location = exportFileLocation;
	}

	function archiveFamily(family) {
		return Family.archive({id: family.id}).$promise.then(function() {
			_loadFamilies();
		}, function(response) {
			if (response.status === 400) {
				var errorMessage = RestErrors.asString(response.data);

				if (errorMessage !== undefined) {
					AlertFactory(errorMessage, "Invalid action");
				}
			}
		});
	}

	function archiveMember(family, familyMember) {
		return SubMatters.delete({id: familyMember.id}).$promise.then(function() {
			var index = family.family_members.indexOf(familyMember);
			if (index > -1) {
				family.family_members.splice(index, 1);

				if (family.family_members.length === 0) {
					_loadFamilies()
				} else {
					// vm.anticipatedCost = vm.listService.anticipatedCost();
					vm.familiesCounts = Family.counts(_getQueryParams());
				}
			}
		}, function(response) {
			if (response.status === 400) {
				var errorMessage = RestErrors.asString(response.data);

				if (errorMessage !== undefined) {
					AlertFactory(errorMessage, "Invalid action");
				}
			}
		});
	}

	function onEnquiryLoaded(enquiry) {
		vm.listService.onEnquiryAdded(enquiry);
	}

	function inviteReadOnlyMembership() {
		return $modal.open({
			templateUrl: 'ip/families/inviteReadOnlyMembership.modal.html',
			controller: 'InviteReadOnlyMembershipModalController as vm',
			closeOnClick: false
		}).result.then(function(inactiveMember) {

		});
	}

	function _subscribeToUpdates(organizationId) {
		var organizationChannelName = "organization-" + organizationId;
		var organizationChannelPromise = Pusher.subscribe(organizationChannelName, 'sub_matter_bulk_created', _onMembersCreated);
		Pusher.subscribe(organizationChannelName, 'task_bulk_created', _onTasksCreated);

		$scope.$on('$destroy', function() {
			organizationChannelPromise.then(function(channel) {
				channel.unbind('sub_matter_bulk_created');
				channel.unbind('task_bulk_created');
			})
		});
	}

	function _onMembersCreated(data) {
		vm.families.$promise.then(function() {
			var family = _.findWhere(vm.families, {id: data.matter_id});
			if (family) {
				_updateFamily(family);
			}
		})
	}

	function _onTasksCreated(data) {
		vm.families.$promise.then(function() {
			var family = _.find(vm.families, function(family) {
				return _.findWhere(family.family_members, {id: data.sub_matter_id})
			});
			if (family) {
				_updateFamily(family);
			}
		})
	}

	function _updateFamily(family) {
		vm.listService.resource.get(angular.extend({id: family.id}, _getQueryParams())).$promise.then(function(updatedFamily) {
			family.family_members.splice(0, family.family_members);
			family.family_members = updatedFamily.family_members;
		});
		// vm.anticipatedCost = vm.listService.anticipatedCost();
	}

	function changeStatus(newStatus, familyMember, family, $close) {
		return SubMatters.update({
			id: familyMember.id,
			status: newStatus.id
		}).$promise.then(function(updatedFamilyMember) {
			familyMember.status_id = newStatus.id;
			familyMember.status = newStatus.value;
			_setExpandMarkers(familyMember, family);
			$close();
		})
	}

	function _getTasksVisibilityStorageKey(familyMember) {
		return 'ipPageTasksVisibility' + familyMember.id;
	}

	function _restoreTasksVisibilityState(familyMember) {
		return $window.localStorage[_getTasksVisibilityStorageKey(familyMember)]
	}

	function _saveTasksVisibilityState(familyMember, visibility) {
		return $window.localStorage[_getTasksVisibilityStorageKey(familyMember)] = visibility;
	}

	function getQuotationsWithClone(family, familyMember) {
		Wizard.saveStateInLocalStorage({
			matterType: familyMember.matter_type_id,
			subMatter: familyMember.id,
			definings: [],
			title: family.title,
			cloneType: familyMember.defining_code === 'WO' ? 'nationalise' : 'validate'
		});

		Navigation.go('community.wizard');
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FamiliesList', FamiliesList);

FamiliesList.$inject = ['BaseFamiliesList', 'Family', 'OopHelpers'];

function FamiliesList(BaseFamiliesList, Family, OopHelpers) {
	function FamiliesListService(resource) {
		BaseFamiliesList.call(this, resource);
	}

	OopHelpers.subclass(FamiliesListService, BaseFamiliesList);

	FamiliesListService.prototype.removeTask = function(taskId) {
		for (var familyIdx = 0; familyIdx < this.objects.length; familyIdx++) {
			var family = this.objects[familyIdx];

			for (var memberIdx = 0; memberIdx < family.family_members.length; memberIdx++) {
				var familyMember = family.family_members[memberIdx];

				for (var taskIdx = 0; taskIdx < familyMember.tasks.length; taskIdx++) {
					var task = familyMember.tasks[taskIdx];

					if (task.id === taskId) {
						familyMember.tasks.splice(taskIdx, 1);

						return;
					}

				}
			}
		}
	};

	return new FamiliesListService(Family);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('Family', Family);

Family.$inject = ['$resource', 'PekamaConfig'];

function Family($resource, PekamaConfig) {
	var url = PekamaConfig.apiBaseUrl + 'community/families/:id/:action/';

	var actionsConfig = {
		anticipatedCost: {
			params: {action: 'anticipated_cost'},
			method: "GET"
		},
		counts: {
			params: {action: 'counts'},
			method: "GET",
			isArray: true
		},
		archive: {
			params: {action: 'archive'},
			method: 'DELETE'
		},
		getApplicantsFacets: {
			params: {action: 'get_applicants_facets'},
			method: 'GET',
			isArray: true
		}
	};

	return $resource(url, {id: '@id'}, actionsConfig);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntFamilyPlaceholder', function() {
		return {
			scope: {},
			templateUrl: 'ip/families/familyPlaceholder.directive.html',
			controller: cmntFamilyPlaceholder,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

cmntFamilyPlaceholder.$inject = [];

function cmntFamilyPlaceholder() {
	var vm = this;


}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FamilyStatus', FamilyStatus);

FamilyStatus.$inject = ['$resource', 'PekamaConfig'];

function FamilyStatus($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'community/family_statuses/:id/:action/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FamilyStatusService', FamilyStatusService);

FamilyStatusService.$inject = ['FamilyStatus', 'BaseRelatedValuesService'];

function FamilyStatusService(FamilyStatus, BaseRelatedValuesService) {
	var service = new BaseRelatedValuesService(FamilyStatus);

	service.byMatterType = byMatterType;

	return service;

	function byMatterType(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {matter_type: matterTypeId});
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FlatFamiliesList', FlatFamiliesList);

FlatFamiliesList.$inject = ['BaseFamiliesList', 'FlatFamily', 'OopHelpers'];

function FlatFamiliesList(BaseFamiliesList, FlatFamily, OopHelpers) {
	function FlatFamiliesListService(resource) {
		BaseFamiliesList.call(this, resource);
	}

	OopHelpers.subclass(FlatFamiliesListService, BaseFamiliesList);

	FlatFamiliesListService.prototype.removeTask = function(taskId) {
		for (var i = 0; i < this.objects.length; i++) {
			var family = this.objects[i];

			if (family.family_members[0].tasks[0].id === taskId) {
				this.objects.splice(i, 1);

				break;
			}
		}
	};

	return new FlatFamiliesListService(FlatFamily);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FlatFamily', FlatFamily);

FlatFamily.$inject = ['$resource', 'PekamaConfig'];

function FlatFamily($resource, PekamaConfig) {
	var url = PekamaConfig.apiBaseUrl + 'community/flat_families/:id/:action/';

	var actionsConfig = {
		anticipatedCost: {
			params: {action: 'anticipated_cost'},
			method: "GET"
		}
	};

	return $resource(url, {id: '@id'}, actionsConfig);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntInlineTask', function() {
		return {
			scope: {
				task: '=',
				familyMember: '=',
				family: '=',
				currentUser: '<',
				baseCurrency: '=?',
				onDeadlineChanged: '&?',
				onEnquiryLoaded: '&?'
			},
			templateUrl: 'ip/families/inlineTask.directive.html',
			controller: InlineTaskController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

InlineTaskController.$inject = ['ProjectStatusIcon', '$filter', 'Wizard', 'Navigation', 'TaskStatusLabels', 'Task',
	'Project', '$state', 'AlertFactory', 'RestErrors', '$timeout', 'OrganizationService', '$q', '$modal',
	'SupplierConversation', 'PekamaConfig', '$scope'];

function InlineTaskController(ProjectStatusIcon, $filter, Wizard, Navigation, TaskStatusLabels, Task,
							  Project, $state, AlertFactory, RestErrors, $timeout, OrganizationService, $q, $modal,
							  SupplierConversation, PekamaConfig, $scope) {
	var vm = this;

	var skipDeadlineChange;

	vm.getQuotations = getQuotations;
	vm.getQuotationsNationalise = getQuotationsNationalise;
	vm.viewEnquiry = viewEnquiry;
	vm.viewConversation = viewConversation;
	vm.titleChanged = titleChanged;
	vm.deadlineChanged = deadlineChanged;
	vm.descriptionChanged = descriptionChanged;
	vm.getStatusIcon = getStatusIcon;
	vm.startEditing = startEditing;
	vm.confirmInstructions = confirmInstructions;
	vm.completeInstructions = completeInstructions;
	vm.openMultiplierModal = openMultiplierModal;
	vm.showEnquiry = showEnquiry;
	vm.onDeadlineChanged = vm.onDeadlineChanged || angular.noop;
	vm.onEnquiryLoaded = vm.onEnquiryLoaded || angular.noop;
	vm.TaskStatusLabels = TaskStatusLabels;
	vm.inlineEditDelegate = undefined;
	vm.addingDescription = !!(vm.task.text);
	vm.textAreaDelegate = undefined;
	vm.isApproachingDeadline = false;
	vm.isNextDayDeadline = false;

	var projectStatusFilter = $filter('projectStatus');

	var DISPLAYED_CONVS_LIMIT = 10;

	activate();

	function activate() {
		vm.editInProgress = false;

		skipDeadlineChange = vm.task.due_date;

		if (vm.task.$new) {
			delete vm.task['$new'];

			$timeout(function() {
				vm.inlineEditDelegate.startEditing();
			});
		}

		_setDeadlineMarkers();
	}

	function getQuotations() {
		return OrganizationService.primary().$promise.then(function(organization) {
			if (organization.user_type === 'ipo') {
				return Project.save({'task_id': vm.task.id}).$promise.then(function(project) {
					$state.go('community.projects.projectsDetail', {projectId: project.id}, {replace: true});
				}, function(response) {
					AlertFactory(RestErrors.asString(response.data), 'ERRORS');
				})
			} else {
				Wizard.saveStateInLocalStorage({
					matterType: vm.familyMember.matter_type_id,
					subMatter: vm.familyMember.id,
					definings: [vm.familyMember.defining_id],
					title: vm.family.title,
					task: vm.task.id,
					taskTitle: vm.task.title,
					taskDueDate: vm.task.due_date
				});

				Navigation.go('community.wizard');
			}
		});
	}

	function getQuotationsNationalise() {
		Wizard.saveStateInLocalStorage({
			matterType: vm.familyMember.matter_type_id,
			subMatter: vm.familyMember.id,
			definings: [],
			title: vm.family.title,
			taskTitle: vm.task.title,
			taskDueDate: vm.task.due_date,
			cloneType: 'nationalise'
		});

		Navigation.go('community.wizard');
	}

	function viewEnquiry(enquiry) {
		Navigation.go('community.projects.projectsDetail', {projectId: enquiry.id});
	}

	function viewConversation(enquiry, conversation) {
		Navigation.go('community.projects.projectsDetail.conversation', {
			projectId: enquiry.id,
			conversationId: conversation.id
		});
	}

	function titleChanged(oldValue, newValue) {
		return Task.update({
			id: vm.task.id,
			title: newValue
		}).$promise.then(function(data) {
			vm.task.title = data['title'];
		});
	}

	function deadlineChanged(oldValue, newValue) {
		if (skipDeadlineChange) {
			skipDeadlineChange = false;

			return;
		}

		return Task.update({
			id: vm.task.id,
			due_date: newValue.format('YYYY-MM-DD')
		}).$promise.then(function() {
			vm.onDeadlineChanged({task: vm.task});
			_setDeadlineMarkers();
		})
	}

	function descriptionChanged(oldValue, newValue) {
		if (!newValue) {
			vm.addingDescription = false;
		}

		if (oldValue === newValue) {
			return $q.when();
		}

		return Task.update({
			id: vm.task.id,
			text: newValue
		}).$promise.then(function(data) {
			vm.task.text = data['text'];
		});
	}

	function getStatusIcon(supplier) {
		return ProjectStatusIcon[supplier.status];
	}

	function startEditing() {
		vm.addingDescription = true;

		$timeout(function() {
			vm.textAreaDelegate.startEditing();
		});
	}

	function confirmInstructions($close) {
		return SupplierConversation.confirmInstructionsRequester({
			id: vm.enquiry.supplier_conversation
		}).$promise.then(function() {
			_setStatus('confirmed', $close);
		})
	}

	function completeInstructions($close) {
		return SupplierConversation.completeInstructionsRequester({
			id: vm.enquiry.supplier_conversation
		}).$promise.then(function() {
			_setStatus('completed', $close);
		})
	}

	function openMultiplierModal() {
		if (vm.currentUser.is_read_only) {
			return;
		}

		return $modal.open({
			templateUrl: 'ip/families/taskMultiplier.modal.html',
			windowClass: 'reveal_mini',
			controller: 'TaskMultiplierModalController as vm',
			resolve: {
				multiplier: function() {
					return vm.task.multiplier;
				}
			}
		}).result.then(function(multiplier) {
			if (multiplier && vm.task.multiplier !== multiplier) {
				return Task.update({
					base_currency: vm.baseCurrency || PekamaConfig.defaultCurrency
				}, {
					id: vm.task.id,
					multiplier: multiplier
				}).$promise.then(function(data) {
					vm.task.$hideBudget = true;
					angular.extend(vm.task, _.pick(data, 'number', 'converted_number', 'multiplied_budget',
						'converted_multiplied_budget', 'multiplier', 'supplier_budget', 'converted_supplier_budget',
						'multiplied_supplier_budget', 'converted_multiplied_supplier_budget'));

					$scope.$emit('budget_updated');

					$timeout(function() {
						vm.task.$hideBudget = false;
					}, 0);
				});
			}
		})
	}

	function showEnquiry() {
		if (vm.task.community) {
			return Project.loadNested({id: vm.task.community}).$promise.then(function(data) {
				vm.enquiry = data;

				if (vm.enquiry && !vm.task.enquiry_archived) {
					vm.enquiryGroup = vm.enquiry.status === 'draft' && vm.enquiry.direction === 'outgoing';

					vm.convs = vm.enquiry.supplier_conversations.slice(0, DISPLAYED_CONVS_LIMIT);

					vm.supplier_conv = vm.convs[0];

					vm.directionIconClass = 'icon-';

					if (vm.enquiry.direction === 'outgoing') {
						vm.directionIconClass += 'outbound';
						vm.directionLabel = 'Outbound';
					} else {
						vm.directionIconClass += 'inbound';
						vm.directionLabel = 'Inbound';
					}

					_setStatusBasedParams();
				}

				vm.onEnquiryLoaded({enquiry: vm.enquiry});
			});
		}
	}

	function _getSupplierConversation(project) {
		var supplierConvId = project.supplier_conversation;

		return _.findWhere(project.supplier_conversations, {id: supplierConvId});
	}

	function _setStatus(status, $close) {
		var supplierConversation = _getSupplierConversation(vm.enquiry);
		supplierConversation.status = status;
		_setStatusBasedParams();
		$close();
	}

	function _setDeadlineMarkers() {
		if (vm.task.due_date) {
			var momentDueDate = moment(vm.task.due_date, 'YYYY-MM-DD');
			var today = moment().endOf('day');
			var tomorrow = moment().add(1, 'day').endOf('day');
			var deadlineDate = moment().add(5, 'day').endOf('day');

			if ((momentDueDate.isSame(today, 'day') || momentDueDate.isAfter(today, 'day')) &&
				(momentDueDate.isSame(deadlineDate, 'day') || momentDueDate.isBefore(deadlineDate, 'day'))) {
				vm.isApproachingDeadline = true;
				vm.isNextDayDeadline = !!(momentDueDate.isSame(today, 'day') || momentDueDate.isSame(tomorrow, 'day'));
			} else {
				vm.isApproachingDeadline = false;
				vm.isNextDayDeadline = false;
			}
		} else {
			vm.isApproachingDeadline = false;
			vm.isNextDayDeadline = false;
		}
	}

	function _setStatusBasedParams() {
		vm.projectStatusLabel = projectStatusFilter(vm.enquiry);
		vm.projectStatus = projectStatusFilter(vm.enquiry, false);

		vm.statusIconClass = ProjectStatusIcon[vm.projectStatus];
		vm.casePersonClass = 'case-person-info-status_' + vm.projectStatus;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('InviteReadOnlyMembershipModalController', InviteReadOnlyMembershipModalController);

InviteReadOnlyMembershipModalController.$inject = ['$http', 'PekamaConfig', '$modalInstance', '$saveForm', '$scope'];

function InviteReadOnlyMembershipModalController($http, PekamaConfig, $modalInstance, $saveForm, $scope) {
	var vm = this;

	vm.invite = invite;
	vm.copyLink = copyLink;
	vm.email = '';

	function invite() {
		var onSave = $http.post(PekamaConfig.apiBaseUrl + 'community/invite_readonly_membership/', {
			email: vm.email
		});

		return $saveForm($scope, onSave, function(response) {
			$modalInstance.close(response.data);
		});
	}

	function copyLink() {
		var onSave = $http.post(PekamaConfig.apiBaseUrl + 'community/invite_readonly_membership/', {
			email: vm.email,
			send_notice: false
		});

		return $saveForm($scope, onSave, function(response) {
			vm.url = response.data.url;
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntNewip', function() {
		return {
			scope: {
				onNewFamily: '&'
			},
			templateUrl: 'ip/families/newip.directive.html',
			controller: NewipController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

NewipController.$inject = ['MatterTypes', '$q'];

function NewipController(MatterTypes, $q) {
	var vm = this;
	vm.newFamily = newFamily;

	activate();

	function activate() {
		MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});
	}

	function newFamily(matterTypeId, $close) {
		return $q.when(vm.onNewFamily({'matterTypeId': matterTypeId})).then(function() {
			$close();
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('Onboarding', Onboarding);

Onboarding.$inject = ['UserService', '$q'];

function Onboarding(UserService, $q) {
	var DISMISSED_KEY = 'onboardingDismissed';
	var AUTO_DISMISS_DAYS = 15;

	return {
		rememberDismiss: rememberDismiss,
		jedMessageDismissed: jedMessageDismissed
	};

	function rememberDismiss() {
		return UserService.getCurrent().$promise.then(function(currentUser) {
			var dismissedKey = _getDismissedKey(currentUser.id);

			localStorage[dismissedKey] = true;
		});
	}

	function jedMessageDismissed() {
		return UserService.getCurrent().$promise.then(function(currentUser) {
			if (currentUser.is_read_only) {
				return true;
			}

			var dismissedKey = _getDismissedKey(currentUser.id);
			var dismissed = localStorage[dismissedKey];

			if (dismissed) {
				return $q.when(true);
			}

			var duration = moment.duration(moment(currentUser.date_joined).diff(new Date()));
			var daysSinceJoined = Math.floor(Math.abs(duration.asDays()));

			if (daysSinceJoined >= AUTO_DISMISS_DAYS) {
				localStorage[dismissedKey] = true;

				return true;
			} else {
				return false;
			}
		});
	}

	function _getDismissedKey(userId) {
		return DISMISSED_KEY + '-' + userId;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.service('OrganizationSettingsService', OrganizationSettingsService);

OrganizationSettingsService.$inject = ['$rootScope', '$http', 'PekamaConfig'];

function OrganizationSettingsService($rootScope, $http, PekamaConfig) {
	var self = this;
	this.getMine = function() {
		if (!this.hasOwnProperty('mineCurrency')) {
			self.updateMine();
		}

		return this.mineCurrency
	};

	this.updateMine = function() {
		this.mineCurrency = $http.get(PekamaConfig.apiBaseUrl + 'community/organization_settings/').then(function(response) {
			PekamaConfig.defaultCurrency = response.data.currency;
			PekamaConfig.priceVisibilityDays = response.data.price_visibility_days;
			return response.data;
		});
		return this.mineCurrency;
	};
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('SetFilingDateModalController', SetFilingDateModalController);

SetFilingDateModalController.$inject = ['$saveForm', '$scope', '$modalInstance', 'FamilyMember', 'familyMember'];

function SetFilingDateModalController($saveForm, $scope, $modalInstance, FamilyMember, familyMember) {
	var vm = this;

	vm.submit = submit;
	vm.number = '';

	function submit() {
		var onSave = FamilyMember.setFilingDate({
			id: familyMember.id,
			date: vm.date ? vm.date.format('YYYY-MM-DD') : undefined,
			number: vm.number
		}).$promise;

		return $saveForm($scope, onSave, function(updatedData) {
			$modalInstance.close(updatedData);
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('SubMatterStatuses', SubMatterStatuses);

SubMatterStatuses.$inject = ['$resource', 'PekamaConfig'];

function SubMatterStatuses($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'legal/sub_matter_statuses/:id/:action/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('SubMatterPrimaryStatusesService', SubMatterPrimaryStatusesService);

SubMatterPrimaryStatusesService.$inject = ['SubMatterStatuses', 'BaseRelatedValuesService'];

function SubMatterPrimaryStatusesService(SubMatterStatuses, BaseRelatedValuesService) {
	var service = new BaseRelatedValuesService(SubMatterStatuses);

	service.byMatterType = byMatterType;
	service._getResourceInstance = _getResourceInstance;

	return service;

	function byMatterType(matterTypeId) {
		var self = this;

		return self.getList().then(function() {
			return _.filter(self.objects, {matter_type: matterTypeId});
		});
	}

	function _getResourceInstance() {
		var self = this;
		if (!self._resourceInstance) {
			self._resourceInstance = self._resourceClass.query({'primary': true});
		}

		return self._resourceInstance;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntTaskChangeStatus', function() {
		return {
			scope: {
				task: '='
			},
			templateUrl: 'ip/families/taskChangeStatus.directive.html',
			controller: TaskChangeStatusController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

TaskChangeStatusController.$inject = ['TaskStatusLabels', 'Task'];

function TaskChangeStatusController(TaskStatusLabels, Task) {
	var vm = this;

	vm.TaskStatusLabels = TaskStatusLabels;
	vm.taskStatuses = Object.keys(TaskStatusLabels).map(function(value) {
		return {
			title: TaskStatusLabels[value],
			value: value
		};
	});
	vm.changeStatus = changeStatus;

	function changeStatus(newStatus, $close) {
		return Task.update({id: vm.task.id, status: newStatus}).$promise.then(function(updatedTask) {
			vm.task.status = updatedTask.status;
			$close();
		})
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('TaskMultiplierModalController', TaskMultiplierModalController);

TaskMultiplierModalController.$inject = ['$modalInstance', 'multiplier'];

function TaskMultiplierModalController($modalInstance, multiplier) {
	var vm = this;

	vm.multiplier = multiplier || 1;

	vm.changeMultiplier = changeMultiplier;

	function changeMultiplier() {
		$modalInstance.close(vm.multiplier || 1);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntTimeFrame', function() {
		return {
			scope: {
				timeframe: '=',
				startDate: '=',
				endDate: '=',
				onChange: '&?',
				timeframePastDates: '<?'
			},
			templateUrl: 'ip/families/timeframe.directive.html',
			controller: TimeFrameController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

TimeFrameController.$inject = [];

function TimeFrameController() {
	var vm = this;

	var ISO_DATE = 'YYYY-MM-DD',
		DISPLAY_DATE = 'DD MMM YYYY';

	vm.predefinedOptions = [
		{label: '30', value: 30},
		{label: '90', value: 90},
		{label: '180', value: 180},
		{label: '365', value: 365},
		{label: 'All', value: 'all'}
	];

	vm.timeframePastDates = vm.timeframePastDates || false;

	vm.showRangePanel = false;

	vm.setTimeframe = setTimeframe;
	vm.onStartDateChange = onStartDateChange;
	vm.onEndDateChange = onEndDateChange;
	vm.showRangeSelector = showRangeSelector;

	activate();

	var autoChange = {
		start: false,
		end: false
	};

	function setTimeframe(value) {
		if (vm.timeframe === value) {
			return;
		}

		autoChange.start = true;
		autoChange.end = true;

		vm.timeframe = value;

		vm.showRangePanel = false;

		if (value === 'all') {
			vm.startDate = undefined;
			vm.endDate = undefined;
		} else {
			var newStartDate = todayAsISODate();
			var newEndDate = moment(newStartDate).add(vm.timeframe, 'days');

			if (vm.timeframePastDates) {
				newStartDate = moment(newStartDate).subtract(vm.timeframe, 'days');
			}

			if (vm.startDate && vm.startDate.isSame(newStartDate)) {
				autoChange.start = false;
			}

			if (vm.endDate && vm.endDate.isSame(newEndDate)) {
				autoChange.end = false;
			}

			vm.startDate = newStartDate;
			vm.endDate = newEndDate;

			vm.startDateStr = vm.startDate.format(DISPLAY_DATE);
			vm.endDateStr = vm.endDate.format(DISPLAY_DATE);
		}

		vm.onChange({startDate: vm.startDate, endDate: vm.endDate});
	}

	function activate() {
		setDateLabels();
	}

	function onStartDateChange() {
		manualChange('start');
	}

	function onEndDateChange() {
		manualChange('end');
	}

	function manualChange(autoChangeProperty) {
		if (autoChange[autoChangeProperty]) {
			autoChange[autoChangeProperty] = false;

			return;
		}

		vm.timeframe = undefined;

		vm.onChange({startDate: vm.startDate, endDate: vm.endDate});
	}

	function showRangeSelector() {
		vm.timeframe = undefined;

		vm.showRangePanel = true;

		autoChange.start = false;
		autoChange.end = false;

		if (!vm.startDate || !vm.endDate) {
			initDateRange(365);
			setDateLabels();
			manualChange('start');
		}
	}

	function setDateLabels() {
		if (vm.startDate && vm.endDate) {
			vm.startDateStr = vm.startDate.format(DISPLAY_DATE);
			vm.endDateStr = vm.endDate.format(DISPLAY_DATE);
		}
	}

	function initDateRange(days) {
		vm.startDate = todayAsISODate();
		vm.endDate = moment(vm.startDate).add(days, 'days');
	}

	function todayAsISODate() {
		return moment(new Date().toISOString().slice(0, 10), ISO_DATE);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('FamiliesBudgetController', FamiliesBudgetController);

FamiliesBudgetController.$inject = ['FamiliesBudgetList', 'FlatFamiliesList', 'FamilyStatusService', 'Navigation', 'Wizard',
	'$scope', 'AuthService', 'CommunityProfileService', 'PekamaConfig', '$window', 'FamilyBudget', '$stateParams',
	'OrganizationSettingsService', '$http', 'FamilyMember', 'PortalService', 'Task', 'MatterTypes', '$q', '$modal', '$timeout'];

function FamiliesBudgetController(FamiliesBudgetList, FlatFamiliesList, FamilyStatusService, Navigation, Wizard,
								  $scope, AuthService, CommunityProfileService, PekamaConfig, $window, FamilyBudget, $stateParams,
								  OrganizationSettingsService, $http, FamilyMember, PortalService, Task, MatterTypes, $q, $modal, $timeout) {
	var vm = this;

	var currentUser;

	var ISO_DATE = 'YYYY-MM-DD',
		DISPLAY_DATE = 'DD MMM YYYY';
	var DEFAULT_TIMEFRAME = 365;
	var TIMEFRAME_THROTTLE_MS = 1000;

	vm.direction = 'all';
	vm.lastSearch = '';
	vm.profile = undefined;

	vm.timeframe = DEFAULT_TIMEFRAME;
	vm.convertableCurrencies = PekamaConfig.convertableCurrencies;
	vm.baseCurrency = PekamaConfig.defaultCurrency;

	vm.loadMore = loadMore;
	vm.filtersChanged = filtersChanged;
	vm.searchChanged = searchChanged;
	vm.searchBlur = searchBlur;
	vm.timeframeChanged = _.throttle(timeframeChanged, TIMEFRAME_THROTTLE_MS);
	vm.currencyChanged = currencyChanged;
	vm.updateTitle = updateTitle;
	vm.toggleFamilyMemberSelection = toggleFamilyMemberSelection;
	vm.toggleCleanFamilySelection = toggleCleanFamilySelection;
	vm.initFamilyMemberState = initFamilyMemberState;
	vm.initCleanFamilyState = initCleanFamilyState;
	vm.initFamilyState = initFamilyState;
	vm.classesNumberChanged = classesNumberChanged;
	vm.openMultiplierModal = openMultiplierModal;
	vm.openCleanFamilyMultiplierModal = openCleanFamilyMultiplierModal;

	vm.listService = FamiliesBudgetList;

	vm.totalBudgets = {
		current_year: {},
		next_year: {},
		range: {}
	};
	var cleanFamiliesDeffered = $q.defer();

	activate();

	$scope.$on('userAuthenticated', function() {
		activate();
	});

	$scope.$on('currentUserUpdated', function() {
		activate();
	});

	function activate() {
		vm.displayPlaceholders = true;
		vm.profile = CommunityProfileService.getMine();
		vm.ordering = 'created';
		vm.timeframe = getTimeframe();
		vm.startDate = todayAsISODate();
		vm.endDate = moment(vm.startDate).add(vm.timeframe, 'days');
		setDateLabels();
		vm.currentYearStr = moment().format('YYYY');
		vm.nextYearStr = moment().add(1, 'years').format('YYYY');

		AuthService.isAuthenticated().then(function(user) {
			vm.currentUser = user;
			currentUser = user;

			if (currentUser) {
				OrganizationSettingsService.getMine().then(function() {
					vm.baseCurrency = PekamaConfig.defaultCurrency;

					_loadFamilies();

					vm.families.$promise.finally(function() {
						vm.displayPlaceholders = false;
					});

					FamilyStatusService.invalidateCache();
				});
			} else {
				vm.families = vm.listService.loadEmpty();
			}

		});

		MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});

		PortalService.getMine();
	}

	function loadMore() {
		vm.listService.loadMore().then(function(families) {
			cleanFamiliesDeffered.promise.then(function() {
				var isFamilyAdded = false;
				angular.forEach(families, function(family) {
					var cleanFamily = _.findWhere(vm.cleanFamilies, {id: family.id});
					if (_.findWhere(vm.cleanFamilies, {id: family.id}) === undefined) {
						vm.cleanFamilies.push(family);
						isFamilyAdded = true;
					} else {
						$timeout(function() {
							_setFamilyMultiplier(cleanFamily.$multiplier, family);
						});
					}
				});
				if (isFamilyAdded) {
					_calcTotalBudgets();
				}
			});
		});
	}

	function filtersChanged(newValues) {
		_loadFamilies(newValues);
	}

	function searchChanged() {
		vm.lastSearch = vm.fulltext;

		_loadFamilies({fulltext: vm.fulltext});
	}

	function searchBlur() {
		if (vm.fulltext !== vm.lastSearch) {
			searchChanged();
		}
	}

	function timeframeChanged(startDate, endDate) {
		_loadFamilies({startDate: startDate, endDate: endDate});
		setDateLabels();
	}

	function currencyChanged(newCurrency) {
		filtersChanged({base_currency: newCurrency});
		$http.post(PekamaConfig.apiBaseUrl + 'community/organization_settings/', {currency: newCurrency}).then(function(res) {
			PekamaConfig.defaultCurrency = res.data.currency;
		});
	}

	function _loadFamilies(filterParams) {
		if (!currentUser) {
			return;
		}

		var queryParams = _getQueryParams(filterParams);

		vm.listService = FamiliesBudgetList;

		var cleanFamiliesPromise = _loadCleanFamilies(filterParams);
		vm.families = vm.listService.load(queryParams);
		vm.anticipatedCost = vm.listService.anticipatedCost();

		vm.familiesCounts = FamilyBudget.counts(queryParams);

		return $q.all([vm.families.$promise, cleanFamiliesPromise])
	}

	function _loadCleanFamilies(filterParams) {
		var queryParams = _getQueryParams(filterParams);
		vm.cleanFamilies = FamilyBudget.query(angular.extend({
			page: 1,
			page_size: 50,
			only_family_data: true
		}, queryParams));
		vm.cleanFamilies.$promise.then(function(families) {
			cleanFamiliesDeffered.resolve(families);
			_calcTotalBudgets();
		});
		return vm.cleanFamilies.$promise
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		var startDate = ('startDate' in newValues) ? newValues.startDate : vm.startDate;
		var endDate = ('endDate' in newValues) ? newValues.endDate : vm.endDate;

		if (startDate) {
			startDate = startDate.format(ISO_DATE);
		}

		if (endDate) {
			endDate = endDate.format(ISO_DATE);
		}

		return {
			matter_type: ('matterType' in newValues) ? newValues.matterType : vm.matterType,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			fulltext: ('fulltext' in newValues) ? newValues.fulltext : vm.fulltext,
			base_currency: ('base_currency' in newValues) ? newValues.base_currency : vm.baseCurrency,
			start_date: startDate,
			end_date: endDate
		};
	}

	function todayAsISODate() {
		return moment(new Date().toISOString().slice(0, 10), ISO_DATE);
	}

	function updateTitle(family) {
		return FamilyBudget.update({
			id: family.id,
			title: family.title
		}).$promise;
	}

	function getTimeframe() {
		var timeframeFromUrl = $stateParams.timeframe;

		if (timeframeFromUrl) {
			var parsed = parseInt(timeframeFromUrl);

			if (!isNaN(parsed)) {
				return parsed;
			}
		}

		return DEFAULT_TIMEFRAME;
	}

	function initFamilyMemberState(familyMember, family) {
		familyMember.$checked = true;
		familyMember.$budgets = angular.copy(familyMember.budgets);
	}

	function initCleanFamilyState(family) {
		family.$checked = true;
		family.$budgets = angular.copy(family.budgets);
		family.$multiplier = 1;
	}

	function initFamilyState(family) {
		family.$multiplier = 1;
	}

	function toggleFamilyMemberSelection(familyMember, family) {
		familyMember.$checked = !familyMember.$checked;

		return cleanFamiliesDeffered.promise.then(function() {
			angular.forEach(['current_year', 'next_year', 'range'], function(budgetKey) {
				family.budgets[budgetKey].amount = parseFloat(family.budgets[budgetKey].amount);
				if (!familyMember.$checked) {
					family.budgets[budgetKey].amount -= parseFloat(familyMember.budgets[budgetKey].amount);
				} else {
					family.budgets[budgetKey].amount += parseFloat(familyMember.budgets[budgetKey].amount);
				}
			});

			var cleanFamily = _.findWhere(vm.cleanFamilies, {id: family.id});
			if (cleanFamily) {
				angular.extend(cleanFamily.budgets, family.budgets);
				_calcTotalBudgets();
			}
		});
	}

	function toggleCleanFamilySelection(family) {
		family.$checked = !family.$checked;
		_calcTotalBudgets();
	}

	function classesNumberChanged(oldValue, newValue, familyMember) {
		return FamilyMember.setClassesNumber({
			id: familyMember.id,
			classes_number: newValue
		}).$promise;
	}

	function setDateLabels() {
		if (vm.startDate && vm.endDate) {
			vm.startDateStr = vm.startDate.format(DISPLAY_DATE);
			vm.endDateStr = vm.endDate.format(DISPLAY_DATE);
		}
	}

	function openMultiplierModal(family) {
		return $modal.open({
			templateUrl: 'ip/families_budget/familyMultiplier.modal.html',
			windowClass: 'reveal_mini',
			controller: 'FamilyMultiplierModalController as vm',
			resolve: {
				multiplier: function() {
					return family.$multiplier;
				}
			}
		}).result.then(function(multiplier) {
			_setFamilyMultiplier(multiplier, family);
		})
	}

	function openCleanFamilyMultiplierModal(cleanFamily) {
		return $modal.open({
			templateUrl: 'ip/families_budget/familyMultiplier.modal.html',
			windowClass: 'reveal_mini',
			controller: 'FamilyMultiplierModalController as vm',
			resolve: {
				multiplier: function() {
					return cleanFamily.$multiplier;
				}
			}
		}).result.then(function(multiplier) {
			if (multiplier && cleanFamily.$multiplier !== multiplier) {
				vm.families.$promise.then(function() {
					var family = _.findWhere(vm.families, {id: cleanFamily.id});
					if (family) {
						_setFamilyMultiplier(multiplier, family);
					} else {
						cleanFamily.$multiplier = multiplier;
						angular.forEach(['current_year', 'next_year', 'range'], function(budgetKey) {
							cleanFamily.budgets[budgetKey].amount = parseFloat(cleanFamily.$budgets[budgetKey].amount) * multiplier;
						});
						_calcTotalBudgets();
					}
				});
			}
		})
	}

	function _setFamilyMultiplier(multiplier, family) {
		if (multiplier && family.$multiplier !== multiplier) {
			family.$multiplier = multiplier;
			angular.forEach(['current_year', 'next_year', 'range'], function(budgetKey) {
				family.budgets[budgetKey].amount = 0;
				angular.forEach(family.family_members, function(familyMember) {
					familyMember.budgets[budgetKey].amount = parseFloat(familyMember.$budgets[budgetKey].amount) * multiplier;
					family.budgets[budgetKey].amount += familyMember.budgets[budgetKey].amount;
					if (multiplier > 1) {
						familyMember.budgets[budgetKey].$tooltip = '' + familyMember.$budgets[budgetKey].symbol
							+ familyMember.$budgets[budgetKey].amount + ' * ' + multiplier;
					} else {
						familyMember.budgets[budgetKey].$tooltip = undefined;
					}
				});
			});

			var cleanFamily = _.findWhere(vm.cleanFamilies, {id: family.id});
			if (cleanFamily) {
				angular.extend(cleanFamily.budgets, family.budgets);
				cleanFamily.$multiplier = family.$multiplier;
				_calcTotalBudgets();
			}
		}
	}

	function _calcTotalBudgets() {
		cleanFamiliesDeffered.promise.then(function() {
			vm.totalBudgets.current_year.amount = 0;
			vm.totalBudgets.next_year.amount = 0;
			vm.totalBudgets.range.amount = 0;
			angular.forEach(vm.cleanFamilies, function(family) {
				if (family.$checked === undefined || family.$checked === true) {
					angular.forEach(['current_year', 'next_year', 'range'], function(budgetKey) {
						vm.totalBudgets[budgetKey].amount += parseFloat(family.budgets[budgetKey].amount);
						vm.totalBudgets[budgetKey].symbol = family.budgets[budgetKey].symbol;
					})
				}
			});
		})
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FamiliesBudgetList', FamiliesBudgetList);

FamiliesBudgetList.$inject = ['BaseFamiliesList', 'FamilyBudget', 'OopHelpers'];

function FamiliesBudgetList(BaseFamiliesList, FamilyBudget, OopHelpers) {
	function FamiliesBudgetListService(resource) {
		BaseFamiliesList.call(this, resource);
	}

	OopHelpers.subclass(FamiliesBudgetListService, BaseFamiliesList);

	return new FamiliesBudgetListService(FamilyBudget);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntFamiliesBudgetPlaceholder', function() {
		return {
			scope: {},
			templateUrl: 'ip/families_budget/familiesBudgetPlaceholder.directive.html',
			controller: cmntFamiliesBudgetPlaceholder,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

cmntFamiliesBudgetPlaceholder.$inject = [];

function cmntFamiliesBudgetPlaceholder() {
	var vm = this;


}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('FamilyBudget', FamilyBudget);

FamilyBudget.$inject = ['$resource', 'PekamaConfig'];

function FamilyBudget($resource, PekamaConfig) {
	var url = PekamaConfig.apiBaseUrl + 'community/families_budget/:id/:action/';

	var actionsConfig = {
		anticipatedCost: {
			params: {action: 'anticipated_cost'},
			method: "GET"
		},
		counts: {
			params: {action: 'counts'},
			method: "GET",
			isArray: true
		}
	};

	return $resource(url, {id: '@id'}, actionsConfig);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('FamilyMultiplierModalController', FamilyMultiplierModalController);

FamilyMultiplierModalController.$inject = ['$modalInstance', 'multiplier'];

function FamilyMultiplierModalController($modalInstance, multiplier) {
	var vm = this;

	vm.multiplier = multiplier || 1;

	vm.changeMultiplier = changeMultiplier;

	function changeMultiplier() {
		$modalInstance.close(vm.multiplier || 1);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntMatterTypeFilter', function() {
		return {
			scope: {
				matterType: '=',
				matterTypeLabel: '@?',

				onFiltersChanged: '&'
			},
			templateUrl: 'ip/families_budget/matterTypeFilter.directive.html',
			controller: MatterTypeFilterController,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

MatterTypeFilterController.$inject = ['MatterTypes'];

function MatterTypeFilterController(MatterTypes) {
	var vm = this;

	vm.onMatterTypeChanged = onMatterTypeChanged;

	vm.matterTypeLabel = vm.matterTypeLabel || 'IP Type';

	activate();

	function activate() {
		_loadMatterTypes();
	}

	function onMatterTypeChanged() {
		_notifyClients();
	}


	function _notifyClients() {
		vm.onFiltersChanged({newValues: _getFilteringParams()});
	}

	function _loadMatterTypes() {
		return MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;
		});
	}


	function _getFilteringParams() {
		return {
			matterType: vm.matterType
		};
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntTimeRange', function() {
		return {
			scope: {
				timeframe: '=',
				startDate: '=',
				endDate: '=',
				onChange: '&?'
			},
			templateUrl: 'ip/families_budget/timeRange.directive.html',
			controller: TimeRangeController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

TimeRangeController.$inject = [];

function TimeRangeController() {
	var vm = this;

	var ISO_DATE = 'YYYY-MM-DD',
		DISPLAY_DATE = 'DD MMM YYYY';

	vm.onStartDateChange = onStartDateChange;
	vm.onEndDateChange = onEndDateChange;
	vm.showRangeSelector = showRangeSelector;

	var autoChange = {
		start: false,
		end: false
	};

	activate();

	function activate() {
		setDateLabels();
		showRangeSelector();
	}

	function onStartDateChange() {
		manualChange('start');
	}

	function onEndDateChange() {
		manualChange('end');
	}

	function manualChange(autoChangeProperty) {
		if (autoChange[autoChangeProperty]) {
			autoChange[autoChangeProperty] = false;

			return;
		}

		vm.timeframe = undefined;

		vm.onChange({startDate: vm.startDate, endDate: vm.endDate});
	}

	function showRangeSelector() {
		vm.timeframe = undefined;

		vm.showRangePanel = true;

		autoChange.start = false;
		autoChange.end = false;

		if (!vm.startDate || !vm.endDate) {
			initDateRange(365);
			setDateLabels();
			manualChange('start');
		}
	}

	function setDateLabels() {
		if (vm.startDate && vm.endDate) {
			vm.startDateStr = vm.startDate.format(DISPLAY_DATE);
			vm.endDateStr = vm.endDate.format(DISPLAY_DATE);
		}
	}

	function initDateRange(days) {
		vm.startDate = todayAsISODate();
		vm.endDate = moment(vm.startDate).add(days, 'days');
	}

	function todayAsISODate() {
		return moment(new Date().toISOString().slice(0, 10), ISO_DATE);
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('Task', Task);

Task.$inject = ['$resource', 'PekamaConfig'];

function Task($resource, PekamaConfig) {
	var url = PekamaConfig.apiBaseUrl + 'community/tasks_old/:id/:action/';

	var actionsConfig = {
		anticipatedCost: {
			params: {action: 'anticipated_cost'},
			method: "GET"
		},
		budgetStatus: {
			params: {action: 'budget_status'},
			method: "POST"
		}
	};

	return $resource(url, {id: '@id'}, actionsConfig);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntTaskPlaceholder', function() {
		return {
			scope: {},
			templateUrl: 'ip/old_tasks/taskPlaceholder.directive.html',
			controller: TaskPlaceholder,
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

TaskPlaceholder.$inject = [];

function TaskPlaceholder() {
	var vm = this;
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.constant('TaskStatusLabels', {
		'new': 'Not Started',
		'in_progress': 'In Progress',
		'completed': 'Completed',
		'approved': 'Accepted',
		'rejected': 'Rejected',
		'cancelled': 'Cancelled'
	});

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('OldTasksController', OldTasksController);

OldTasksController.$inject = ['TasksList', 'TaskStatusLabels', 'PekamaConfig'];

function OldTasksController(TasksList, TaskStatusLabels, PekamaConfig) {
	var vm = this;

	vm.status = 'active';
	vm.ordering = 'soonest_deadline';
	vm.baseCurrency = PekamaConfig.defaultCurrency;
	vm.convertableCurrencies = PekamaConfig.convertableCurrencies;
	vm.timeframe = undefined;

	vm.TaskStatusLabels = TaskStatusLabels;

	vm.loadMore = loadMore;
	vm.filtersChanged = filtersChanged;
	vm.expandTimeframe = expandTimeframe;
	vm.timeframeChanged = _.throttle(timeframeChanged, 1000);
	vm.currencyChanged = currencyChanged;

	activate();

	function activate() {
		vm.statusChoices = _getStatusChoices();
		vm.orderingChoices = [{value: 'soonest_deadline', label: "Soonest Deadline"}];
		vm.timeframeChoices = _getTimeframeChoices();

		_loadTasks();

		vm.displayPlaceholders = true;
		vm.tasks.$promise.finally(function() {
			vm.displayPlaceholders = false;
		})
	}

	function loadMore() {
		TasksList.loadMore();
	}

	function filtersChanged(newValues) {
		_loadTasks(newValues);
	}

	function expandTimeframe() {
		vm.timeframe = undefined;

		filtersChanged();
	}

	function timeframeChanged(timeframe) {
		filtersChanged({timeframe: timeframe});
	}

	function currencyChanged(newCurrency) {
		filtersChanged({base_currency: newCurrency});
	}

	function _loadTasks(filterParams) {
		var queryParams = _getQueryParams(filterParams);

		vm.tasks = TasksList.load(queryParams);
		vm.anticipatedCost = TasksList.anticipatedCost();
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		return {
			timeframe: ('timeframe' in newValues) ? newValues.timeframe : vm.timeframe,
			status: ('status' in newValues) ? newValues.status : vm.status,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			fulltext: ('fulltext' in newValues) ? newValues.fulltext : vm.fulltext,
			base_currency: ('base_currency' in newValues) ? newValues.base_currency : vm.baseCurrency
		};
	}

	function _getStatusChoices() {
		var customStatuses = [
			{value: 'active', label: 'Active'}
		];

		var realStatuses = _.chain(TaskStatusLabels)
			.omit('cancelled')
			.map(function(value, key) {
				return {value: key, label: value}
			})
			.value();

		return customStatuses.concat(realStatuses);
	}

	function _getTimeframeChoices() {
		return [
			{value: 7, label: '7'},
			{value: 30, label: '30'},
			{value: 90, label: '90'},
			{value: 180, label: '180'},
			{value: 365, label: '365'},
			{value: undefined, label: 'All'}
		];
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('TasksList', TasksList);

TasksList.$inject = ['Task', 'BaseListService', 'OopHelpers'];

function TasksList(Task, BaseListService, OopHelpers) {
	function TasksListService(resource) {
		this.listPropertyName = 'tasks';

		BaseListService.call(this, resource);
	}

	OopHelpers.subclass(TasksListService, BaseListService);

	TasksListService.prototype.anticipatedCost = function() {
		var self = this;

		return self.resource.anticipatedCost(self.params);
	};

	return new TasksListService(Task);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntActivatePortal', function() {
		return {
			templateUrl: 'ip/portal/cmntActivatePortal.directive.html',
			controller: ActivateController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

ActivateController.$inject = ['AuthService', 'PekamaConfig', 'CommunityProfileService', 'UserService'];

function ActivateController(AuthService, PekamaConfig, CommunityProfileService, UserService) {
	var vm = this;

	vm.activateUser = activateUser;

	vm.password = '';
	vm.firstName = '';
	vm.lastName = '';
	vm.agreeToTou = false;
	vm.termsOfUseUrl = PekamaConfig.termsOfUseUrl;

	activate();

	function activate() {
		vm.profile = CommunityProfileService.getMine();
	}

	function activateUser(form) {
		return AuthService.activate(vm.firstName, vm.lastName, vm.password).then(function() {
			form.clearErrors();
			UserService.updateCurrent();

		}, function(response) {
			form.displayErrors(response.data);
		});
	}
}

})();
(function() {
'use strict';
angular
    .module('community.ip')
    .factory('CmntSubMatters', CmntSubMatters);

CmntSubMatters.$inject = ['$resource', 'PekamaConfig', 'ReportActions'];

function CmntSubMatters($resource, PekamaConfig, ReportActions) {
    var actions = angular.extend({}, ReportActions);

    return $resource(PekamaConfig.apiBaseUrl + 'community/sub_matters/:id/:action/', {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
    .module('community.ip')
    .controller('ProjectsController', ProjectsController);

ProjectsController.$inject = ['$scope', '$q', '$modal', '$state', '$http',
    'ReportServiceFactory',
    'CmntSubMatters', 'SubMatterQueries',
    'BaseReportController',
    'Files', 'AlertFactory'];

function ProjectsController($scope, $q, $modal, $state, $http,
                            ReportServiceFactory,
                            CmntSubMatters, SubMatterQueries,
                            BaseReportController,
                            Files, AlertFactory) {

    var reportService = ReportServiceFactory({
        defaultOrdering: '-matter__id',
        objectsResource: CmntSubMatters,
        queriesResource: SubMatterQueries,
        exportUrl: '/api/community/sub_matters/export_delay/',
        listTemplate: 'ip/projects/projectsTemplateList.html',
        listOrderingOptions: [
            {field: 'matter__id', label: 'Family'}
        ],
        hasFreeSearch: true,
        visibleFiltersCount: 10,
    });

    reportService.uiState.view = 'list';
    reportService.uiState.filteringStateKeyOverride = 'community.reports.projects';

    var parent = BaseReportController(reportService, $scope);
    angular.extend($scope, parent);

    $scope.darkMode = false;

    $scope.toggleDarkMode = function () {
        $scope.darkMode = !$scope.darkMode;
    };

    $scope.openSharedFilesModal = function(projectId) {
        return Files.query({sub_matter: projectId, search: 'Official & Client Docs (shared)', first: true}).$promise.then(function(folders) {
            var sharedFolder = folders[0];
            if (!sharedFolder) return AlertFactory('No Official & Client Docs were found');

            return $modal.open({
                templateUrl: 'ip/projects/files/sharedFiles.modal.html',
                controller: 'SharedFilesModalController as vm',
                resolve: {
                    rootFolderId: function() {
                        return sharedFolder.id
                    },
                    projectId: function() {
                        return projectId
                    }
                }
            });
        })
    };
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.directive('cmntInlineEnquiry', function() {
		return {
			scope: {
				task: '=',
				currentUser: '<'
			},
			templateUrl: 'ip/tasks/inlineEnquiry.directive.html',
			controller: InlineEnquiryController,
			controllerAs: 'vm',
			bindToController: true
		}
	});

InlineEnquiryController.$inject = ['ProjectStatusIcon', '$filter', 'SupplierConversation', 'Navigation'];

function InlineEnquiryController(ProjectStatusIcon, $filter, SupplierConversation, Navigation) {
	var vm = this;

	vm.getStatusIcon = getStatusIcon;
	vm.viewEnquiry = viewEnquiry;
	vm.viewConversation = viewConversation;
	vm.confirmInstructions = confirmInstructions;
	vm.completeInstructions = completeInstructions;

	var projectStatusFilter = $filter('projectStatus');

	var DISPLAYED_CONVS_LIMIT = 10;

	activate();

	function activate() {
		vm.enquiry = vm.task.enquiry;

		if (vm.enquiry && !vm.task.enquiry_archived) {
			vm.enquiryGroup = vm.enquiry.status === 'draft' && vm.enquiry.direction === 'outgoing';

			vm.convs = vm.enquiry.supplier_conversations.slice(0, DISPLAYED_CONVS_LIMIT);

			vm.supplier_conv = vm.convs[0];

			vm.directionIconClass = 'icon-';

			if (vm.enquiry.direction === 'outgoing') {
				vm.directionIconClass += 'outbound';
				vm.directionLabel = 'Outbound';
			} else {
				vm.directionIconClass += 'inbound';
				vm.directionLabel = 'Inbound';
			}

			_setStatusBasedParams();
		}
	}

	function getStatusIcon(supplier) {
		return ProjectStatusIcon[supplier.status];
	}

	function viewEnquiry(enquiry) {
		Navigation.go('community.projects.projectsDetail', {projectId: enquiry.id});
	}

	function viewConversation(enquiry, conversation) {
		Navigation.go('community.projects.projectsDetail.conversation', {
			projectId: enquiry.id,
			conversationId: conversation.id
		});
	}

	function confirmInstructions($close) {
		return SupplierConversation.confirmInstructionsRequester({
			id: vm.enquiry.supplier_conversation
		}).$promise.then(function() {
			_setStatus('confirmed', $close);
		})
	}

	function completeInstructions($close) {
		return SupplierConversation.completeInstructionsRequester({
			id: vm.enquiry.supplier_conversation
		}).$promise.then(function() {
			_setStatus('completed', $close);
		})
	}

	function _getSupplierConversation(project) {
		var supplierConvId = project.supplier_conversation;

		return _.findWhere(project.supplier_conversations, {id: supplierConvId});
	}

	function _setStatus(status, $close) {
		var supplierConversation = _getSupplierConversation(vm.enquiry);
		supplierConversation.status = status;
		_setStatusBasedParams();
		$close();
	}

	function _setStatusBasedParams() {
		vm.projectStatusLabel = projectStatusFilter(vm.enquiry);
		vm.projectStatus = projectStatusFilter(vm.enquiry, false);

		vm.statusIconClass = ProjectStatusIcon[vm.projectStatus];
		vm.casePersonClass = 'case-person-info-status_' + vm.projectStatus;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('TasksController', TasksController);

var _emptyLine = "<p><br></p>";
var ENQUIRY_TEXT = "<p>Dear [supplier],</p>" +
	"<p>Jurisdiction: [jurisdiction]</p>" +
	"<p>Task: [jurisdiction]</p>" +
	"<p>The deadline is: [deadline]</p>" +
	_emptyLine + "<p>I have some work in your jurisdiction. I want to confirm with you that you can undertake the work for Pekama's estimated price of [estimated cost]. Can you please confirm?</p>" +
	_emptyLine + "<p>Looking forward to hearing from you.</p>";

TasksController.$inject = ['TasksPricesList', 'TaskStatusLabels', 'PekamaConfig', 'CommunityProfileService', '$http',
	'MatterTypes', 'DefiningService', 'Project', 'AuthService', 'OrganizationService', '$state', 'AlertFactory',
	'RestErrors', 'Wizard', 'Navigation', 'Task', '$modal', 'OrganizationSettingsService',
	'$httpParamSerializer', '$window', '$filter'];

function TasksController(TasksPricesList, TaskStatusLabels, PekamaConfig, CommunityProfileService, $http,
						 MatterTypes, DefiningService, Project, AuthService, OrganizationService, $state, AlertFactory,
						 RestErrors, Wizard, Navigation, Task, $modal, OrganizationSettingsService,
						 $httpParamSerializer, $window, $filter) {
	var vm = this;

	var ISO_DATE = 'YYYY-MM-DD';
	var DEFAULT_TIMEFRAME = 90;
	var TIMEFRAME_THROTTLE_MS = 1000;

	vm.status = undefined;
	vm.ordering = 'due_date_normalized';
	vm.convertableCurrencies = PekamaConfig.convertableCurrencies;
	vm.baseCurrency = PekamaConfig.defaultCurrency;
	vm.timeframe = undefined;
	vm.matterTypeSlug = undefined;
	vm.defining = undefined;

	vm.TaskStatusLabels = TaskStatusLabels;

	var staticMatterTypes = ['patents', 'trademarks', 'Designs'];
	vm.matterTypes = [];
	vm.matterTypesById = {};
	vm.definings = {};

	vm.loadMore = loadMore;
	vm.filtersChanged = filtersChanged;
	vm.expandTimeframe = expandTimeframe;
	vm.timeframeChanged = _.throttle(timeframeChanged, TIMEFRAME_THROTTLE_MS);
	vm.matterTypeChanged = _.throttle(matterTypeChanged, 1000);
	vm.toggleExpand = toggleExpand;
	vm.loadEnquiry = loadEnquiry;
	vm.getQuotations = getQuotations;
	vm.setBudgetStatus = setBudgetStatus;
	vm.requestVisibility = requestVisibility;
	vm.initTaskState = initTaskState;
	vm.currencyChanged = currencyChanged;
	vm.downloadExportedFile = downloadExportedFile;

	activate();

	function activate() {
		vm.statusChoices = _getStatusChoices();
		vm.timeframe = DEFAULT_TIMEFRAME;
		var today = todayAsISODate();
		vm.startDate = today;
		vm.endDate = moment(today).add(vm.timeframe, 'days');

		vm.displayPlaceholders = true;

		vm.profile = CommunityProfileService.getMine();

		MatterTypes.getList().then(function(matterTypes) {
			vm.matterTypes = matterTypes;

			DefiningService.getList().then(function(definings) {
				vm.definings['others'] = [];
				angular.forEach(matterTypes, function(matterType) {
					vm.matterTypesById[matterType.id] = matterType;
					vm.definings[matterType.slug] = _.filter(definings, {matter_type: matterType.id});

					if (staticMatterTypes.indexOf(matterType.slug) === -1) {
						vm.definings['others'] = vm.definings['others'].concat(vm.definings[matterType.slug]);
					}
				});
			})
		});

		AuthService.isAuthenticated().then(function(user) {
			vm.currentUser = user;
		});

		OrganizationSettingsService.getMine().then(function() {
			vm.priceVisibilityDays = PekamaConfig.priceVisibilityDays;
			vm.baseCurrency = PekamaConfig.defaultCurrency;

			_loadTasks();

			vm.tasks.$promise.finally(function() {
				vm.displayPlaceholders = false;
			});
		});
	}

	function loadMore() {
		TasksPricesList.loadMore();
	}

	function filtersChanged(newValues) {
		_loadTasks(newValues);
	}

	function expandTimeframe() {
		vm.timeframe = undefined;

		filtersChanged();
	}

	function timeframeChanged(startDate, endDate) {
		filtersChanged({startDate: startDate, endDate: endDate});
	}

	function matterTypeChanged(matterTypeSlug) {
		vm.defining = undefined;
		if (matterTypeSlug === vm.matterTypeSlug) {
			vm.matterTypeSlug = undefined;
		} else {
			vm.matterTypeSlug = matterTypeSlug;
		}

		filtersChanged({matterTypeSlug: vm.matterTypeSlug});
	}

	function toggleExpand(task) {
		if (!task.enquiry_archived) {
			if (!task.$quoteActions) {
				var actions = [
					{value: 'pekama', label: 'Discuss with Pekama (Free)'},
					{value: 'attorney', label: 'Instruct Via Pekama'}
				];
				if (task.visibility_type !== 'invisible') {
					actions[1].label = actions[1].label + ' for '
						+ $filter('currency')(task.$budgets_sum, task.converted_multiplied_budget.symbol, 0)
				}
				task.$quoteActions = actions
			}

			task.$isExpanded = !task.$isExpanded;

			loadEnquiry(task)
		}
	}

	function loadEnquiry(task) {
		if (task.community && !task.$enquiry && task.direction) {
			task.$enquiry = {$resolved: false};
			return Project.loadNested({id: task.community}).$promise.then(function(data) {
				task.enquiry = data;
				task.$enquiry.$resolved = true
			});
		}
	}

	function getQuotations(task) {
		if (task.$quoteAction === 'pekama') {
			return Project.save({'task_id': task.id}).$promise.then(function(project) {
				$state.go('community.projects.projectsDetail', {projectId: project.id}, {replace: true});
			}, function(response) {
				AlertFactory(RestErrors.asString(response.data), 'ERRORS');
			})
		} else {
			if (task.visibility_type !== 'invisible') {
				var templateText = ENQUIRY_TEXT.replace(/\[estimated cost\]/, task.converted_multiplied_budget.formatted);
				Wizard.saveStateInLocalStorage({
					matterType: task.sub_matter_data.matter_type,
					subMatter: task.sub_matter_data.id,
					definings: [task.sub_matter_data.defining],
					title: task.sub_matter_data.title || task.title,
					task: task.id,
					taskTitle: task.title,
					taskDueDate: task.due_date,
					templateText: templateText
				});

				Navigation.go('community.wizard');
			} else {
				var text = 'This option is only available if you have access to future pricing data. Would you like such access?';

				return _requestVisibility(text);
			}
		}
	}

	function setBudgetStatus(task, budgetOption) {
		task.$isBudgetChanges = true;
		return Task.budgetStatus({id: task.id, budget_status: budgetOption}).$promise.then(function(data) {
			if (budgetOption === 'not_included') {
				_loadTasks();
			} else {
				task.budget_status = data.budget_status;
				task.$isBudgetChanges = false;
			}
		});
	}

	function _requestVisibilityModalController($modalScope, $modalInstance, TaskPrices, text) {
		$modalScope.text = text;

		$modalScope.yes = function() {
			return TaskPrices.requestVisibility().$promise.then(function() {
				$modalInstance.close('yes');
			});
		}
	}

	function _requestVisibility(text) {
		return $modal.open({
			templateUrl: 'ip/tasks/requestVisibility.modal.html',
			controller: ['$scope', '$modalInstance', 'TaskPrices', 'text', _requestVisibilityModalController],
			resolve: {
				text: function() {
					return text;
				}
			}
		}).result.then(function() {
			AlertFactory('Thank you! This is the time of the year for special offers. We will shortly get back to you with one!', '');
		});
	}

	function requestVisibility(task) {
		if (task && task.visibility_type !== 'invisible') {
			toggleExpand(task);
			return;
		}

		return AuthService.isAuthenticated().then(function(user) {
			if (user && !user.is_read_only) {
				var text = 'Would you like to have access to this price and other future pricing data?';
				if (!task) {
					text = 'Would you like to have access to future pricing data?'
				}

				return _requestVisibility(text);
			}
		});
	}

	function initTaskState(task) {
		task.$quoteAction = 'pekama';
		task.$budgets_sum = null;
		if (task.converted_multiplied_budget) {
			task.$budgets_sum = parseFloat(task.converted_multiplied_budget.amount) +
				parseFloat(task.converted_multiplied_supplier_budget.amount);
			task.$budget_tooltip = 'Total service fee: ' + task.multiplied_budget.formatted + ', official fee: ' +
				task.multiplied_supplier_budget.formatted;
		}
	}

	function _loadTasks(filterParams) {
		var queryParams = _getQueryParams(filterParams);

		vm.tasks = TasksPricesList.load(queryParams);
	}

	function _getQueryParams(newValues) {
		newValues = newValues || {};

		var startDate = ('startDate' in newValues) ? newValues.startDate : vm.startDate;
		var endDate = ('endDate' in newValues) ? newValues.endDate : vm.endDate;

		if (startDate) {
			startDate = startDate.format(ISO_DATE);
		}

		if (endDate) {
			endDate = endDate.format(ISO_DATE);
		}

		return {
			status: ('status' in newValues) ? newValues.status : vm.status,
			ordering: ('ordering' in newValues) ? newValues.ordering : vm.ordering,
			fulltext: ('fulltext' in newValues) ? newValues.fulltext : vm.fulltext,
			matter_type_slug: ('matterTypeSlug' in newValues) ? newValues.matterTypeSlug : vm.matterTypeSlug,
			defining: ('defining' in newValues) ? newValues.defining : vm.defining,
			start_date: startDate,
			end_date: endDate,
			base_currency: ('base_currency' in newValues) ? newValues.base_currency : vm.baseCurrency
		};
	}

	function _getStatusChoices() {
		var customStatuses = [
			{value: 'active', label: 'Active'}
		];

		var realStatuses = _.chain(TaskStatusLabels)
			.omit('cancelled')
			.map(function(value, key) {
				return {value: key, label: value}
			})
			.value();

		return customStatuses.concat(realStatuses);
	}

	function todayAsISODate() {
		return moment(new Date().toISOString().slice(0, 10), ISO_DATE);
	}

	function currencyChanged(newCurrency) {
		filtersChanged({base_currency: newCurrency});
		$http.post(PekamaConfig.apiBaseUrl + 'community/organization_settings/', {currency: newCurrency}).then(function(res) {
			PekamaConfig.defaultCurrency = res.data.currency;
		});
	}

	function downloadExportedFile() {
		var exportFileLocation = PekamaConfig.apiBaseUrl + 'community/tasks_prices/export/';

		var encodedUrlParams = $httpParamSerializer(_getQueryParams());

		if (encodedUrlParams.length > 0) {
			exportFileLocation += '?' + encodedUrlParams;
		}

		$window.location = exportFileLocation;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('TaskPrices', TaskPrices);

TaskPrices.$inject = ['$resource', 'PekamaConfig'];

function TaskPrices($resource, PekamaConfig) {
	var url = PekamaConfig.apiBaseUrl + 'community/tasks_prices/:id/:action/';

	var actionsConfig = {
		requestVisibility: {
			params: {action: 'request_visibility'},
			method: "POST"
		}
	};

	return $resource(url, {id: '@id'}, actionsConfig);
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('TasksPricesList', TasksPricesList);

TasksPricesList.$inject = ['TaskPrices', 'BaseListService', 'OopHelpers'];

function TasksPricesList(TaskPrices, BaseListService, OopHelpers) {
	function TasksPricesListService(resource) {
		this.listPropertyName = 'tasks';

		BaseListService.call(this, resource);
	}

	OopHelpers.subclass(TasksPricesListService, BaseListService);

	return new TasksPricesListService(TaskPrices);
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('BoostModalController', BoostModalController);

BoostModalController.$inject = ['CommunityProfileService', 'BoostResult', '$modalInstance', '$modal', '$state',
	'$q', '$timeout', '$location', '$anchorScroll', 'currentUser'];

function BoostModalController(CommunityProfileService, BoostResult, $modalInstance, $modal, $state,
							  $q, $timeout, $location, $anchorScroll, currentUser) {
	var vm = this;

	vm.startNewCase = startNewCase;
	vm.referAnAttorney = referAnAttorney;
	vm.inviteMember = inviteMember;

	activate();

	function activate() {
		vm.currentUser = currentUser;
		vm.profile = CommunityProfileService.getMine();
	}

	function startNewCase() {
		$modalInstance.close(BoostResult.START_NEW_CASE);
	}

	function referAnAttorney() {
		$modalInstance.close(BoostResult.REFER_AN_ATTORNEY);

		$modal.open({
			templateUrl: 'profile/boost/referAttorney.modal.html',
			controller: 'ReferAttorneyController as vm',
			resolve: {
				currentUser: function() {
					return currentUser;
				}
			}
		});
	}

	function _stateGoIfNeed(name) {
		if ($state.current.name != name) {
			return $state.go(name, {}, {location: 'replace'});
		}
	}

	function inviteMember() {
		$modalInstance.close(BoostResult.INVITE_MEMBER);
		$q.when(_stateGoIfNeed('community.profile.members')).then(function() {
			$timeout(function() {
				$location.hash('inviteMemberButton');
				$anchorScroll();
			});
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.constant('BoostResult', {
		START_NEW_CASE: 0,
		REFER_AN_ATTORNEY: 1,
		INVITE_MEMBER: 2
	});

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('ReferAttorneyController', ReferAttorneyController);

var DEFAULT_TEXT = "Hi ,\n\nI’ve been using Pekama for a while now and would like to invite you to join.\n\n" +
	"It’s helped me find IP firms in other countries and get more work. I find it very useful.\n\n" +
	"Would be great if you could join too so we could work together.\n\n" +
	"See you on Obviously Manage soon!";

ReferAttorneyController.$inject = ['$scope', '$saveForm', '$modal', '$modalInstance', 'CommunityProfile', 'currentUser',
	'ScoreAction'];

function ReferAttorneyController($scope, $saveForm, $modal, $modalInstance, CommunityProfile, currentUser,
								 ScoreAction) {
	var vm = this;

	vm.ScoreAction = ScoreAction;

	vm.next = next;
	vm.invite = invite;

	activate();

	function activate() {
		vm.step = 1;
		vm.attorneyEmail = '';
		vm.message = _getDefaultText();
		vm.ignoreUnchanged = false;
	}

	function next() {
		vm.step = 2;
	}

	function invite() {
		if (vm.message === _getDefaultText() && !vm.ignoreUnchanged) {
			return _showUnchangedMessageWarning().then(function() {
				vm.ignoreUnchanged = true;

				return _invite();
			});
		} else {
			return _invite();
		}
	}

	function _invite() {
		var inviteAction = CommunityProfile.invite({
			email: vm.attorneyEmail,
			message: vm.message
		}).$promise;

		inviteAction.then(function(data) {
			if (data.is_existing) {
				_showExistingMemberWarning();
			}
		});

		return $saveForm($scope, inviteAction, function() {
			$modalInstance.close();
		});
	}

	function _showUnchangedMessageWarning() {
		return $modal.open({
			templateUrl: 'profile/boost/unchangedWarning.modal.html'
		}).result;
	}

	function _showExistingMemberWarning() {
		return $modal.open({
			templateUrl: 'profile/boost/existingMemberWarning.modal.html'
		}).result;
	}

	function _getDefaultText() {
		var text = DEFAULT_TEXT;

		if (currentUser.first_name) {
			text += '\n\n' + currentUser.first_name;
		}

		return text;
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('InviteModalController', InviteModalController);

InviteModalController.$inject = ['OrganizationMemberships', '$modalInstance', '$saveForm', '$scope'];

function InviteModalController(OrganizationMemberships, $modalInstance, $saveForm, $scope) {
	var vm = this;

	vm.invite = invite;
	vm.email = '';

	function invite() {
		var onSave = OrganizationMemberships.save({email: vm.email}).$promise;

		return $saveForm($scope, onSave, function(inactiveMember) {
			$modalInstance.close(inactiveMember);
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('ProfileMembersController', ProfileMembersController);

ProfileMembersController.$inject = ['$scope', '$modal', 'UserService', 'OrganizationService', 'OrganizationMemberships',
	'CommunityProfileService', 'CommunityProfile', 'AlertFactory', '$rootScope', 'ScoreAction', 'myProfile'];

function ProfileMembersController($scope, $modal, UserService, OrganizationService, OrganizationMemberships,
								  CommunityProfileService, CommunityProfile, AlertFactory, $rootScope, ScoreAction, myProfile) {
	var vm = this;

	vm.invite = invite;
	vm.setRepresentative = setRepresentative;
	vm.remove = remove;

	activate();

	function activate() {
		vm.currentUser = UserService.getCurrent();

		reloadData();

		$scope.$on('communityProfileUpdated', function() {
			_setProfile();
		});

		$scope.$on('primaryOrganization-changed', function() {
			reloadData();
		});

		$scope.$on('currentUserUpdated', function() {
			vm.currentUser = UserService.getCurrent();
		})
	}

	function reloadData() {
		vm.primaryOrganization = OrganizationService.primary();
		_setProfile();

		vm.primaryOrganization.$promise.then(function(organization) {
			vm.members = OrganizationMemberships.query({organization: organization.token});
		});
	}

	function invite() {
		return $modal.open({
			templateUrl: 'profile/members/invite.modal.html',
			controller: 'InviteModalController as vm'
		}).result.then(function(inactiveMember) {
			vm.members.push(inactiveMember);
			$rootScope.$broadcast('primaryOrganizationMembersChanged');
			AlertFactory('The community score will be raised by ' + ScoreAction.MEMBER_JOINED + ' once your team member joins Pekama', '');
		});
	}


	function setRepresentative(member) {
		return CommunityProfileService.setRepresentative(member.id);
	}

	function remove(member) {
		return OrganizationMemberships.delete({id: member.id}).$promise.then(function() {
			CommunityProfileService.updateMine();
			$rootScope.$broadcast('primaryOrganizationMembersChanged');
			var index = vm.members.indexOf(member);

			if (index > -1) {
				vm.members.splice(index, 1);
			}
		});
	}

	function _setProfile() {
		CommunityProfileService.getMine().$promise.then(function(profile) {
			vm.profile = profile;
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.factory('CommunityServices', CommunityServicesResource);

CommunityServicesResource.$inject = ['$resource', 'PekamaConfig'];

function CommunityServicesResource($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'experts/services/:id/:action/', {id: '@id'});
}


})();
(function() {
'use strict';
angular
	.module('community.profile')
	.directive('cmntMyProfilePledges', function() {
		return {
			templateUrl: 'profile/services/myProfilePledges.directive.html',
			controller: MyProfilePledgesCtrl,
			scope: {},
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

MyProfilePledgesCtrl.$inject = ['Pledge', 'CommunityProfileService', 'CommunityProfile', '$scope', 'UserService'];

function MyProfilePledgesCtrl(Pledge, CommunityProfileService, CommunityProfile, $scope, UserService) {
	var vm = this;

	vm.updatePledgeAnswer = updatePledgeAnswer;
	vm.currentUser = UserService.getCurrent();

	activate();

	function activate() {
		reloadData();

		$scope.$on('primaryOrganization-changed', function() {
			reloadData();
		});
	}

	function reloadData() {
		vm.pledges = Pledge.query();
		vm.pledgeAnswers = {};
		vm.profile = CommunityProfileService.getMine();

		vm.profile.$promise.then(function(profile) {
			profile.pledge_answers.forEach(function(pledgeAnswer) {
				vm.pledgeAnswers[pledgeAnswer.pledge] = pledgeAnswer.value;
			});
		});
	}

	function updatePledgeAnswer(pledgeId) {
		return CommunityProfile.updateMine({
			id: vm.profile.id,
			pledge_answers: [{pledge: pledgeId, value: vm.pledgeAnswers[pledgeId]}]
		}).$promise.then(function() {
			CommunityProfileService.updateMine();
		});
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.directive('cmntMyProfileServices', function() {
		return {
			templateUrl: 'profile/services/myProfileServices.directive.html',
			controller: MyProfileServicesCtrl,
			scope: {},
			controllerAs: 'vm',
			bindToController: true,
			replace: true
		}
	});

MyProfileServicesCtrl.$inject = ['$q', 'MatterTypes', 'ExpertiseTypes', 'DefiningsByMatterTypes', 'CommunityProfileService',
	'DefiningService', 'CommunityServices', '$scope', 'PekamaConfig', 'UploadService', 'OrganizationMemberships',
	'OrganizationService', 'UserService'];

function MyProfileServicesCtrl($q, MatterTypes, ExpertiseTypes, DefiningsByMatterTypes, CommunityProfileService,
							   DefiningService, CommunityServices, $scope, PekamaConfig, UploadService, OrganizationMemberships,
							   OrganizationService, UserService) {
	var vm = this;

	vm.placeholderIsVisible = true;
	vm.descriptionIsFocused = false;
	vm.uploadService = UploadService();

	vm.matterTypes = [];
	vm.definings = {};
	vm.expertiseTypes = {};

	vm.matterTypeChanged = matterTypeChanged;
	vm.serviceButtonDisabled = serviceButtonDisabled;
	vm.addService = addService;
	vm.removeService = removeService;
	vm.getServiceRowModel = getServiceRowModel;
	vm.updateService = updateService;

	vm.hidePlaceholder = hidePlaceholder;
	vm.focusDescription = focusDescription;
	vm.startUploading = startUploading;

	var controllerInitialized;

	activate();

	function activate() {
		var matterTypesDeferred = $q.defer(),
			expertiseTypesDeferred = $q.defer();

		MatterTypes.getList().then(function() {
			vm.matterTypes = MatterTypes.objects;

			$q.all(_.map(vm.matterTypes, function(matterType) {
				return ExpertiseTypes.byMatterType(matterType.id).then(function(expertiseTypes) {
					vm.expertiseTypes[matterType.id] = expertiseTypes;
				});
			})).then(expertiseTypesDeferred.resolve, expertiseTypesDeferred.reject);
			matterTypesDeferred.resolve()
		}, matterTypesDeferred.reject);

		controllerInitialized = $q.all([
			matterTypesDeferred.promise,
			DefiningsByMatterTypes.getData().then(function(groupedDefinings) {
				vm.definings = groupedDefinings;
			}),
			expertiseTypesDeferred.promise
		]);

		controllerInitialized.then(function() {
			if (!vm.newService.matter_type) {
				vm.newService.matter_type = _getIdOfSingularObject(vm.matterTypes);

				if (vm.newService.matter_type) {
					_setDependentValues(vm.newService);
				}
			}
		});

		reloadData(controllerInitialized);

		$scope.$on('primaryOrganization-changed', function() {
			reloadData(controllerInitialized);
		});

		$scope.$on('communityProfileUpdated', function(event, profile) {
			vm.membersReadyPromise.then(function() {
				_setDefaultMemberLabel(profile, vm.members);
			});
		});

		vm.currentUser = UserService.getCurrent();

		$scope.$on('currentUserUpdated', function() {
			vm.currentUser = UserService.getCurrent();
		})
	}

	function reloadData(controllerInitialized) {
		vm.newService = {
			autoresponse_text: PekamaConfig.defaultAutoresponse
		};

		vm.profile = CommunityProfileService.getMine();

		_loadMembers();

		$q.all({
			profile: vm.profile.$promise,
			members: vm.membersReadyPromise
		}).then(function(resolves) {
			_setDefaultMemberLabel(resolves['profile'], vm.members);
		});

		vm.services = [];
		vm.profile.$promise.then(function(profile) {
			return controllerInitialized.then(function() {
				_pushProfileServicesToServices(profile);
			});
		});
	}

	function matterTypeChanged(service) {
		service.jurisdiction = undefined;
		service.expertise_type = undefined;

		_setDependentValues(service);
	}

	function serviceButtonDisabled(service, form) {
		if (!form.$valid) {
			return true;
		}

		if (!service.matter_type || !service.jurisdiction || !service.expertise_type) {
			return true
		}

		var uploadService = service._uploadService || vm.uploadService;

		if (uploadService.activeUploads > 0) {
			return true;
		}

		return !_isUniqueService(service);
	}

	function addService(form) {
		vm.newService._inProgress = true;

		return CommunityServices.save(angular.extend({
			profile: vm.profile.id,
			uploaded_files: _.pluck(vm.uploadService.getUploadedFiles(), 'uuid')
		}, vm.newService)).$promise.then(function(newService) {
			_pushToServices(newService);
			vm.newService = {
				autoresponse_text: PekamaConfig.defaultAutoresponse
			};
			vm.uploadService.clear();
			CommunityProfileService.updateMine();
			form.clearErrors();
			vm.placeholderIsVisible = true;
			vm.descriptionIsFocused = false;
		}, function(response) {
			form.displayErrors(response.data);
		}).finally(function() {
			vm.newService._inProgress = false;
		})
	}

	function removeService(service) {
		return CommunityServices.delete({id: service.id}).$promise.then(function() {
			var index = vm.services.indexOf(service);
			if (index != -1) {
				vm.services.splice(index, 1)
			}
			CommunityProfileService.updateMine();
		})
	}

	function getServiceRowModel(service) {
		var rowModel = angular.extend({}, service, {
			_originalService: service,
			_uploadService: UploadService(service.autoresponse_files)
		});

		if (rowModel.autoresponse_text === '') {
			rowModel.autoresponse_text = PekamaConfig.defaultAutoresponse;
		}

		return rowModel;
	}

	function updateService(service, rowModel, form) {
		if (!_isUniqueService(rowModel)) {
			return;
		}

		var sendModel = _.omit(rowModel, function(value, key) {
			return key.indexOf('_') === 0;
		});

		sendModel['uploaded_files'] = _.pluck(rowModel._uploadService.getUploadedFiles(), 'uuid');

		rowModel._inProgress = true;
		return CommunityServices.update(sendModel).$promise.then(function(updatedService) {
			return _getServiceData(rowModel).then(function(args) {
				angular.extend(updatedService, {
					matter_type_repr: args[0],
					jurisdiction_repr: args[1],
					expertise_type_repr: args[2]
				});
				angular.extend(service, updatedService);
				service._isEditing = false;
				CommunityProfileService.updateMine();
				form.clearErrors();
			});

		}, function(response) {
			form.displayErrors(response.data);
		}).finally(function() {
			rowModel._inProgress = false;
		});
	}

	function hidePlaceholder() {
		vm.placeholderIsVisible = false;
	}

	function focusDescription() {
		hidePlaceholder();
		vm.descriptionIsFocused = true;
	}

	function startUploading($files, uploadService) {
		uploadService.startUploading($files, PekamaConfig.apiBaseUrl + 'experts/autoresponse_files/');
	}

	function _loadMembers() {
		vm.membersReadyPromise = OrganizationService.primary().$promise.then(function(organization) {
			vm.members = OrganizationMemberships.query({
				organization: organization.token,
				is_active: true,
				is_read_only: false
			});

			return vm.members.$promise;
		});
	}

	function _setDefaultMemberLabel(myProfile, members) {
		if (myProfile.representative) {
			var primaryMember = _.find(members, {id: myProfile.representative});

			vm.defaultMemberLabel = primaryMember.user.full_name + ' (primary)';
		} else {
			vm.defaultMemberLabel = 'Primary contact';
		}
	}

	function _setDependentValues(service) {
		controllerInitialized.then(function() {
			if (!service.jurisdiction) {
				service.jurisdiction = _getIdOfFirstObject(vm.definings[service.matter_type]);
			}
			if (!service.expertise_type) {
				service.expertise_type = _getIdOfSingularObject(vm.expertiseTypes[service.matter_type]);
			}
		})
	}

	function _getIdOfSingularObject(values) {
		if (values.length === 1) {
			return values[0].id;
		}
	}

	function _getIdOfFirstObject(values) {
		if (values.length > 0 && values[0] !== undefined) {
			return values[0].id;
		}
	}

	function _getServiceData(service) {
		return $q.all([
			MatterTypes.findById(service.matter_type),
			DefiningService.findById(service.jurisdiction),
			ExpertiseTypes.findById(service.expertise_type)
		])
	}

	function _pushToServices(service) {
		if (_isUniqueService(service)) {
			_getServiceData(service).then(function(args) {
				vm.services.push(angular.extend(service, {
					matter_type_repr: args[0],
					jurisdiction_repr: args[1],
					expertise_type_repr: args[2]
				}));
			});
		}
	}

	function _pushProfileServicesToServices(profile) {
		_.each(profile.services, function(service) {
			_pushToServices(service);
		});
	}

	function _isUniqueService(service) {
		return _.every(vm.services, function(otherService) {
			if (('_originalService' in service) && service._originalService == otherService) {
				return true;
			}

			return !(otherService.jurisdiction == service.jurisdiction && otherService.expertise_type == service.expertise_type);
		})
	}
}

})();
(function() {
'use strict';
angular
	.module('community.profile')
	.factory('Pledge', PledgeFactory);

PledgeFactory.$inject = ['$resource', 'PekamaConfig'];

function PledgeFactory($resource, PekamaConfig) {
	return $resource(PekamaConfig.apiBaseUrl + 'experts/pledges/:id/:action/', {id: '@id'}, {
		query: {
			method: 'GET',
			isArray: true,
			cache: true
		}
	})
}


})();
(function() {
'use strict';
angular
	.module('community.profile')
	.controller('ProfileTeamController', ProfileTeamController);

ProfileTeamController.$inject = ['$state', '$modal', 'myProfile', 'CommunityProfile', 'Wizard', 'BoostResult',
	'OrganizationService', '$location', 'UserService', '$scope', 'CommunityProfileService'];

function ProfileTeamController($state, $modal, myProfile, CommunityProfile, Wizard, BoostResult,
							   OrganizationService, $location, UserService, $scope, CommunityProfileService) {
	var vm = this;

	vm.profile = myProfile;

	vm.isWebsitePlcVisible = !vm.profile.website;
	vm.isWebsiteFocused = false;
	vm.isDescriptionPlcVisible = !vm.profile.description;
	vm.isDescriptionFocused = false;
	vm.isOrganizationDataChanged = false;

	vm.isCompetencePlcVisible = !vm.profile.competence;
	vm.isCompetenceFocused = false;
	vm.isCompetenceChanged = false;

	vm.focusInput = focusInput;

	vm.onWebSiteFocus = onWebSiteFocus;
	vm.onWebSiteBlur = onWebSiteBlur;
	vm.updateOrganizationData = updateOrganizationData;

	vm.updateCompetence = updateCompetence;

	vm.boostScore = boostScore;

	activate();

	function activate() {
		reloadData();

		$scope.$on('primaryOrganization-changed', function() {
			reloadData();
		});

		var location = $location.search();
		if (location.openBoost) {
			boostScore();
			$location.search('openBoost', null);
		}

		vm.currentUser = UserService.getCurrent();

		$scope.$on('currentUserUpdated', function() {
			vm.currentUser = UserService.getCurrent();
		})
	}

	function reloadData() {
		_setOrganizationModel();

		vm.profile = CommunityProfileService.getMine();

		vm.profile.$promise.then(function() {
			vm.casesSent = CommunityProfile.casesSent({id: vm.profile.id});
			vm.casesReceived = CommunityProfile.casesReceived({id: vm.profile.id});
			vm.invitedUsers = CommunityProfile.invitedUsers({id: vm.profile.id});
		});
	}

	function focusInput(name) {
		vm['is' + name + 'PlcVisible'] = false;
		vm['is' + name + 'Focused'] = true;
	}

	function onWebSiteFocus() {
		var website = vm.profile.website;

		if (website === undefined || website.trim() === '') {
			vm.profile.website = 'http://'
		}
	}

	function onWebSiteBlur() {
		if (vm.profile.website === 'http://') {
			vm.profile.website = undefined;
		}
	}

	function updateOrganizationData(form) {
		var saveModel = _.pick(vm.profile, 'id', 'website', 'description');
		return CommunityProfile.updateMine(saveModel).$promise.then(function() {
			vm.isOrganizationDataChanged = false;
			form.clearErrors();
			if (!vm.profile.website) {
				vm.isWebsitePlcVisible = true;
				vm.isWebsiteFocused = false;
			}
			if (!vm.profile.description) {
				vm.isDescriptionPlcVisible = true;
				vm.isDescriptionFocused = false;
			}
		}, function(response) {
			form.displayErrors(response.data);
		});
	}

	function updateCompetence(form) {
		return CommunityProfile.updateMine({
			id: vm.profile.id,
			competence: vm.profile.competence
		}).$promise.then(function() {
			vm.isCompetenceChanged = false;
			form.clearErrors();
		}, function(response) {
			form.displayErrors(response.data);
		});
	}

	function boostScore() {
		_openBoostModal().then(function(result) {
			switch (result) {
				case BoostResult.START_NEW_CASE:
					Wizard.resetWizard();
					$state.go('community.wizard');

					break;
			}
		});
	}

	function _openBoostModal() {
		return $modal.open({
			templateUrl: 'profile/boost/boost.modal.html',
			controller: 'BoostModalController as vm',
			resolve: {
				currentUser: function() {
					return UserService.getCurrent().$promise;
				}
			}
		}).result;
	}

	function _setOrganizationModel() {
		vm.organizationModel = OrganizationService.primary();
	}
}

})();
(function() {
'use strict';
angular
    .module('community.reports')
    .factory('CmntEvents', CmntEvents);

CmntEvents.$inject = ['$resource', 'PekamaConfig', 'ReportActions'];

function CmntEvents($resource, PekamaConfig, ReportActions) {
    var url = PekamaConfig.apiBaseUrl + 'community/events/:id/:action/';

    var actions = angular.extend({}, ReportActions);

    return $resource(url, {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('Events', Events);

Events.$inject = ['$resource', 'PekamaConfig', 'ReportActions'];

function Events($resource, PekamaConfig, ReportActions) {
	var url = PekamaConfig.apiBaseUrl + 'legal/events/:id/:action/';

	var actions = angular.extend({}, ReportActions);

	return $resource(url, {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('EventsQueries', EventsQueries);

EventsQueries.$inject = ['$resource', 'PekamaConfig', 'momentResourceTransformation'];

function EventsQueries($resource, PekamaConfig, momentResourceTransformation) {
	var url = PekamaConfig.apiBaseUrl + 'legal/event_queries/:id/:action/';

	return $resource(url, {id: '@id'},
		momentResourceTransformation(['value']).updateActions({
			getFilters: {
				params: {action: 'get_filters'},
				method: 'GET',
				isArray: true
			},
			changeFollowers: {
				params: {action: 'change_followers'},
				method: 'POST'
			},
			sendNow: {
				params: {action: 'send_now'},
				method: 'POST'
			},
			'get': {
				method: 'GET'
			},
			'save': {
				method: 'POST'
			},
			'query': {
				method: 'GET',
				isArray: true
			},
			'update': {
				method: 'PUT',
				headers: {'X-HTTP-Method-Override': 'PATCH'}
			}
		})
	);
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.controller('EventsReportController', EventsReportController);

EventsReportController.$inject = ['$scope',
	'ReportServiceFactory',
	'CmntEvents', 'EventsQueries',
	'BaseReportController'];

function EventsReportController($scope,
								ReportServiceFactory,
								CmntEvents, EventsQueries,
								BaseReportController) {
	var reportService = ReportServiceFactory({
		objectsResource: CmntEvents,
		queriesResource: EventsQueries,
		exportUrl: '/api/community/events/export_delay/',
		bulkActionsTemplate: 'reports/events/bulk_actions.html',
		listOrderingOptions: [
			{field: '-created', label: 'Last created'},
			{field: '-date', label: 'Date'},
			{field: 'event_type__value', label: 'Event Type'}
		],
		objectsName: 'Events'
	});

	var parent = BaseReportController(reportService, $scope);
	angular.extend($scope, parent);
}

})();
(function() {
'use strict';
angular.module('community.reports').value('defaultExportFormats', [
	{format: 'xlsx'},
	{format: 'json'},
	{format: 'xml'},
	{format: 'csv'},
	{format: 'pdf'},
	{format: 'html'}
]);

})();
(function() {
'use strict';
angular.module('community.reports').directive('export', function () {
    return {
        templateUrl: 'reports/export/export.directive.html',
        restrict: 'E',
        scope: {
            exportUrl: '@',
            formats: '=',
            filtering: '=?',
            ordering: '=?'
        },

        controller: ['$scope', '$modal', '$http', 'AlertFactory', 'RestErrors', function ($scope, $modal, $http, AlertFactory, RestErrors) {
            $scope.formats.forEach(function (format) {
                if (!format.hasOwnProperty('title')) {
                    format.title = format.format.toUpperCase();
                }
            });

            $scope.downloadExportedFile = function (exportFormat) {
                var url = exportFormat.customUrl || $scope.exportUrl;

                var params = {
                    file_format: exportFormat.format
                };

                if ($scope.filtering !== undefined) {
                    angular.extend(params, $scope.filtering.getParams());
                }

                if ($scope.ordering !== undefined) {
                    angular.extend(params, $scope.ordering.getParams());
                }

                if ($scope.formats.extraParams !== undefined)
                    angular.extend(params, $scope.formats.extraParams);

                return $http.get(url, {params: params}).then(function (response) {
                    $modal.open({
                        templateUrl: 'reports/export/exportResult.modal.html',
                        controller: 'ExportResultModalController as vm',
                        resolve: {
                            exportResultData: function () {
                                return response.data;
                            }
                        }
                    }).result;
                }, function(response) {
                    AlertFactory(RestErrors.asString(response.data), 'ERRORS');
                });
            }
        }]
    }
});
})();
(function() {
'use strict';
angular
    .module('community.reports')
    .controller('ExportResultModalController', ExportResultModalController);


ExportResultModalController.$inject = ['$modalInstance', 'exportResultData', '$http', '$timeout', '$q', '$scope',
    'PekamaConfig'];
function ExportResultModalController($modalInstance, exportResultData, $http, $timeout, $q, $scope,
                                     PekamaConfig) {
    var vm = this;

    vm.progress = 4;
    vm.downloadLink = null;

    vm.cancel = cancel;

    var requestProgressTimeout;
    var progressRequestCanceller = $q.defer();

    activate();

    function activate() {
        requestProgressTimeout = $timeout(_getProgress, 1500);

        $scope.$on('$destroy', function() {
            progressRequestCanceller.resolve();
            _stopRequestProgressTimeout();
        });
    }

    function _getProgress() {
        $http.get(PekamaConfig.apiBaseUrl + 'export/results/' + exportResultData.id + '/', {
            timeout: progressRequestCanceller.promise
        }).then(function (response) {
            vm.progress = Math.max(response.data.progress, 4);
            if (response.data.status === 'finished') {
                vm.downloadLink = response.data.url;
            } else {
                requestProgressTimeout = $timeout(_getProgress, 1500);
            }
        });
    }

    function _stopRequestProgressTimeout() {
        if (angular.isDefined(requestProgressTimeout)) {
            $timeout.cancel(requestProgressTimeout);
            requestProgressTimeout = undefined;
        }
    }

    function cancel() {
        progressRequestCanceller.resolve();
        _stopRequestProgressTimeout();
        $modalInstance.close();
    }
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.controller('ExportResultsController', ExportResultsController);

ExportResultsController.$inject = ['$scope','ExportResults', '$timeout', 'pagination',];

function ExportResultsController($scope, ExportResults, $timeout, pagination) {
	var vm = this;

	vm.requestProgressTimeout = undefined;
	vm.exportResults = [];
	vm.paginationService = pagination(1, 20);
	vm.loadExportResults = loadExportResults;
	vm.changePage = changePage;

	function loadExportResults() {
		$timeout.cancel(vm.requestProgressTimeout);
		vm.exportResults = ExportResults.query(vm.paginationService.getParams(), vm.paginationService.handle);
		return vm.exportResults.$promise.then(function() {
			vm.requestProgressTimeout = $timeout(loadExportResults, 60000);
		})
	}

	function changePage() {
		$timeout(loadExportResults)
	}

	loadExportResults();

	$scope.$on('$destroy', function() {
		if (angular.isDefined(vm.requestProgressTimeout)) {
			$timeout.cancel(vm.requestProgressTimeout);
			vm.requestProgressTimeout = undefined;
		}
	});
}

})();
(function() {
'use strict';
angular
    .module('community.ip')
    .factory('ExportResults', ExportResults);

ExportResults.$inject = ['$resource', 'PekamaConfig'];

function ExportResults($resource, PekamaConfig) {

    return $resource(PekamaConfig.apiBaseUrl + 'export/results/:id/:action/', {id: '@id'});
}

})();
(function() {
'use strict';
angular.module('community.reports').directive('cmntColumnChooser', ['$timeout', '$filter', function($timeout, $filter) {
	return {
		templateUrl: 'reports/filtering/columnChooser.directive.html',
		scope: {
			'allColumns': '=',
			'chosenColumns': '='
		},
		link: function(scope, elm, attrs) {
			var columns = $(elm).find('.column-list-container > .column-list'),
				leftColumn = $(columns[0]),
				rightColumn = $(columns[1]);

			scope.currentItem = undefined;
			scope.rightActive = false;

			scope.select = function(item, side) {
				if (scope.currentItem === undefined) {
					scope.currentItem = {};
				}

				scope.currentItem.selected = false;

				item.selected = true;
				scope.currentItem = item;

				scope.rightActive = (side === 'right');
			};

			function moveSideways(item, from, to, destColumn) {
				var i = from.indexOf(item);

				if (i > -1) {
					from.splice(i, 1);
					to.push(item);

					$timeout(function() {
						destColumn.scrollTop(destColumn[0].scrollHeight);
					});
				}
			}

			scope.moveRight = function() {
				moveSideways(scope.currentItem, scope.filteredAvailable, scope.chosenColumns, rightColumn);
				scope.rightActive = true;
			};

			scope.moveLeft = function() {
				moveSideways(scope.currentItem, scope.chosenColumns, scope.filteredAvailable, leftColumn);
				scope.rightActive = false;
			};

			function moveVertically(item, list, offset) {
				var i = list.indexOf(item);

				if ((offset > 0 && i < list.length - 1) || (offset < 0 && i > 0)) {
					list.splice(i, 1);
					list.splice(i + offset, 0, item);
				}
			}

			scope.moveUp = function() {
				moveVertically(scope.currentItem, scope.chosenColumns, -1);
			};

			scope.moveDown = function() {
				moveVertically(scope.currentItem, scope.chosenColumns, 1);
			};

			scope.$watch('allColumns', function(newColumns, oldColumns) {
				scope.filteredAvailable = scope.allColumns;
			});

			scope.filterAvailableColumns = function() {
				scope.filteredAvailable = $filter('filter')(scope.allColumns, {title: scope.availableFilter}).filter(
					function(column) {
						return scope.chosenColumns.indexOf(column) === -1;
					}
				);
			};

			scope.sortableOptions = {
				placeholder: 'column-placeholder',
				connectWith: '.column-list'
			};
		}
	}
}]);

})();
(function() {
'use strict';
angular.module('community.reports').constant('facetResourceConfig', {
	getFacets: {
		params: {action: 'get_facets'},
		method: 'GET',
		isArray: true
	}
});


angular.module('community.reports').value('filterLookups', {
	dt: [
		{value: "exact", name: "is"},
		{value: "gte", name: ">="},
		{value: "lte", name: "<="},
		{value: "range", name: "Between"},
		{value: "ltda", name: "Less than days ago"},
		{value: "mtda", name: "More than days ago"},
		{value: "itp", name: "In the past"},
		{value: "dago", name: "Days ago"},
		{value: "itn", name: "In the next"},
		{value: "today", name: "Today"},
		{value: "yest", name: "Yesterday"},
		{value: "m", name: "This month"},
		{value: "lm", name: "Last month"},
		{value: "y", name: "This year"},
		{value: "dft", name: "Days from today"}
	],
	negated: [
		{value: false, name: "Is"},
		{value: true, name: "Is not"}
	]
});


angular.module('community.reports').constant('filteringUrlParams', {
	storedQuery: 'storedQuery',
	columns: 'columns',
	orderingField: 'orderingField'
});

})();
(function() {
'use strict';
angular.module('community.reports').controller('RecipientPickerController', [
	'$scope', '$uibModalInstance', 'ArrayHelper', 'UserService', 'Pusher', 'uuid4', 'chooseFrom', 'selectedUsers',
	'ReportRecipient', 'queriesResource', 'storedQuery', 'storedQueryHasChanges',
	function($scope, $modalInstance, ArrayHelper, UserService, Pusher, uuid4, chooseFrom, selectedUsers,
			 ReportRecipient, queriesResource, storedQuery, storedQueryHasChanges) {
		function getRecipientParams(recipientModel) {
			if (recipientModel) {
				return {
					id: recipientModel.id,
					sending_interval: recipientModel.sending_interval,
					selected: recipientModel.selected,
					stored_query: recipientModel.stored_query
				}
			}

			return {};
		}

		$scope.recipientModels = [];
		$scope.state = {
			hasRecipients: false,
			hasChanges: false,
			storedQueryHasChanges: storedQueryHasChanges,
			allSelected: false
		};

		function buildRecipientsModels(selectedUsers) {
			$scope.recipientModels.splice(0, $scope.recipientModels.length);
			for (var i = 0; i < chooseFrom.length; i++) {
				var member = chooseFrom[i],
					searchResult = ArrayHelper.findByPropertyValue(selectedUsers, 'user', member.id);

				if (searchResult && searchResult.unsubscribed) continue;

				var recipientModel = {
					user: member.id,
					user_repr: member.repr,
					selected: false,
					stored_query: storedQuery.id
				};

				$scope.recipientModels.push(angular.extend(recipientModel, getRecipientParams(searchResult)));
			}

			angular.forEach(selectedUsers, function(recipient) {
				if (recipient.user_type == 'email') {
					if (recipient.unsubscribed) {
						recipient.selected = false;
					}
					$scope.recipientModels.push(recipient);
				}
			})
		}

		buildRecipientsModels(selectedUsers);


		$scope.checkHasRecipients = function() {
			$scope.state.hasRecipients = $scope.recipientModels.some(function(recipientModel) {
				return recipientModel.selected && recipientModel.sending_interval;
			})
		};
		$scope.checkHasRecipients();

		$scope.newEmailFollower = {};

		$scope.addEmailFollower = function() {
			var model = {
				stored_query: storedQuery.id
			};

			angular.extend(model, $scope.newEmailFollower);

			return ReportRecipient.save(model).$promise.then(function(emailFollower) {
				$scope.$broadcast('formSaved');
				$scope.newEmailFollower = {
					email: '',
					sending_interval: undefined
				};

				$scope.recipientModels.push(emailFollower);
				$scope.checkHasRecipients();
				$scope.state.hasChanges = true;
			}, function(response) {
				$scope.$broadcast('formErrors-email-only', response.data);
			});
		};

		$scope.allChange = function() {
			$scope.recipientModels.forEach(function(user) {
				if (!user.unsubscribed) {
					user.selected = $scope.state.allSelected;
				}
			});
			$scope.checkHasRecipients();
			$scope.state.hasChanges = true;
		};

		$scope.toggleSelected = function() {
			$scope.state.allSelected = false;
			$scope.checkHasRecipients();
			$scope.state.hasChanges = true;
		};

		$scope.button = {};
		$scope.save = function() {
			var changed = $scope.recipientModels.filter(function(recipientModel) {
				if ('id' in recipientModel) {
					// existing report recipient
					return true;
				}

				if (!('id' in recipientModel) && recipientModel.selected) {
					// member without corresponding reportrecipient model
					return true;
				}

				return false;
			});

			if (changed.length > 0) {
				return queriesResource.changeFollowers({id: storedQuery.id}, changed).$promise.then(function() {
					if ($scope.button.type === 'saveSubmit') {
						$scope.state.hasChanges = false;
						$scope.form.$submitted = false;
						$scope.button = {};
						ReportRecipient.query({stored_query: storedQuery.id}).$promise.then(function(selectedUsers) {
							buildRecipientsModels(selectedUsers)
						});
						return $scope.sendNow();
					} else {
						return $modalInstance.close();
					}
				});
			} else {
				return $modalInstance.close();
			}
		};

		$scope.noop = angular.noop;


		// "send now" button
		var latestRequestId;
		$scope.sendingInProgress = false;
		$scope.storedQuery = storedQuery;

		function resetSendNowState() {
			latestRequestId = undefined;
			$scope.sendingInProgress = false;
		}

		$scope.activateMailingList = function() {
			return queriesResource.update({id: storedQuery.id, mailing_list_enabled: true}).$promise.then(function() {
				storedQuery.mailing_list_enabled = true;
			});
		};

		$scope.deactivateMailingList = function() {
			return queriesResource.update({id: storedQuery.id, mailing_list_enabled: false}).$promise.then(function() {
				storedQuery.mailing_list_enabled = false;
			});
		};

		var subscribed = UserService.currentUser.$promise.then(function(user) {
			return Pusher.subscribe('private-user-' + user.id, 'mailing_list_sent',
				function(data) {
					if (latestRequestId === data['request_id']) {
						resetSendNowState();
					}
				}
			);
		});

		$scope.sendNow = function() {
			return subscribed.then(function() {
				latestRequestId = uuid4.generate();
				$scope.sendingInProgress = true;

				return queriesResource.sendNow({id: storedQuery.id, request_id: latestRequestId});
			})
		};
	}]);

})();
(function() {
'use strict';
angular.module('community.reports').directive('cmntFiltering', function() {
	function controller($scope, $timeout, FilterInstanceFactory, filterLookups) {

		var filteringService = $scope.filteringService,
			facetsGetter = filteringService.getFacetsForField;

		$scope.filterInstancesMap = filteringService.filterInstancesMap;
		$scope.filtersCollapsed = true;

		// lookups for filters in UI
		$scope.lookups = filterLookups;
		$scope.dayLookups = ['mtda', 'ltda', 'itp', 'dago', 'itn', 'dft'];
		$scope.noValueLookups = ['today', 'yest', 'm', 'lm', 'y'];


		// list of filter instances
		$scope.copyFilterInstance = function(filterInstance) {
			var copiedInstance = FilterInstanceFactory(filterInstance.baseFilter, facetsGetter);

			filteringService.pushFilterToMap(copiedInstance);
		};

		$scope.removeFilterInstance = function(filterInstance) {
			var filterInstances = $scope.filterInstancesMap[filterInstance.baseFilter.key].filterInstances,
				index = filterInstances.indexOf(filterInstance);

			if (index > -1) {
				filterInstances.splice(index, 1);
			}

			if (filterInstances.length === 0) {
				filterInstances.push(FilterInstanceFactory(filterInstance.baseFilter, facetsGetter));
			}
			$scope.onSearch();
		};

		$scope.dateLookupChanged = function(lookup, valueStruct) {
			valueStruct.valueParts.length = 0;

			if ($scope.dayLookups.indexOf(lookup) > -1) {
				valueStruct.valueParts[0] = 1;
			} else if ($scope.noValueLookups.indexOf(lookup) > -1) {
				valueStruct.valueParts[0] = 'novalue';
			} else {
				valueStruct.valueParts[0] = moment();

				if (lookup === 'range') {
					valueStruct.valueParts[1] = moment(valueStruct.valueParts[0]).add({weeks: 1});
				}
			}
		};

		$scope.filterInstanceChanged = function(filterInstance) {
			if (!filterInstance.isEmpty()) $scope.onSearch();
		};

		var filterInstanceChangedTimeout;
		$scope.delayFilterInstanceChanged = function(filterInstance) {
			if (filterInstanceChangedTimeout) $timeout.cancel(filterInstanceChangedTimeout);

			filterInstanceChangedTimeout = $timeout(function() {
				$scope.onSearch();
			}, 500);
		}
	}

	return {
		scope: {
			'filteringService': '=filtering',
			'baseFilters': '=filters',
			'visibleFiltersCount': '=',
			'onSearch': '&'
		},
		controller: ['$scope', '$timeout', 'FilterInstanceFactory', 'filterLookups', controller],
		templateUrl: 'reports/filtering/filtering.directive.html'
	}
});

})();
(function() {
'use strict';
angular.module('community.reports').directive('cmntPreventOuterScroll', function() {
	return {
		link: function(scope, elm, attrs) {
			// http://stackoverflow.com/a/16324762/695503
			$(elm).on('DOMMouseScroll mousewheel', function(ev) {
				var $this = $(this),
					scrollTop = this.scrollTop,
					scrollHeight = this.scrollHeight,
					height = $this.height(),
					delta = ev.originalEvent.wheelDelta,
					up = delta > 0;

				var prevent = function() {
					ev.stopPropagation();
					ev.preventDefault();
					ev.returnValue = false;
					return false;
				};

				if (!up && -delta > scrollHeight - height - scrollTop) {
					// Scrolling down, but this will take us past the bottom.
					$this.scrollTop(scrollHeight);
					return prevent();
				} else if (up && delta > scrollTop) {
					// Scrolling up, but this will take us past the top.
					$this.scrollTop(0);
					return prevent();
				}
			});
		}
	}
});

})();
(function() {
'use strict';
angular.module('community.reports').factory('FilterMailingList', ['$resource', function($resource) {
	return $resource('/api/filtering/mailinglist/:id/:action/', {id: '@id'}, {
		activate: {
			params: {action: 'activate'},
			method: 'POST'
		},
		deactivate: {
			params: {action: 'deactivate'},
			method: 'POST'
		}
	});
}]);


angular.module('community.reports').factory('ReportRecipient', ['$resource', function($resource) {
	return $resource('/api/filtering/recipients/:id/:action/', {id: '@id'});
}]);

})();
(function() {
'use strict';
angular.module('community.reports').factory('DynamicFiltering', [
	'$q', '$timeout', 'FilteringUtils', 'FilterInstanceFactory',
	function($q, $timeout, FilteringUtils, FilterInstanceFactory) {
		function DynamicFiltering(ObjectResource, QueriesResource, config) {
			var self = this;
			config = config || {};

			this.orderingService = null;
			this.onFiltersChanged = angular.noop;
			this.onColumnsSet = angular.noop;
			this.availableColumns = [];
			this.chosenColumns = [];
			this.filterInstancesMap = {};
			this.storedQuery = {};
			this.newQuery = {name: ''};
			this.hasChanges = false;

			var initDefer = $q.defer();
			this.initialized = initDefer.promise;
			this.init = function() {
				initDefer.resolve();
			};

			this.addDefaultFilterInstance = addDefaultFilterInstance;
			this.cleanFiltersMap = cleanFiltersMap;
			this.getBaseFilters = getBaseFilters;
			this.getFacetsForField = getFacetsForField;
			this.getFilterInstances = getFilterInstances;
			this.getParams = getParams;
			this.getQueriesResource = getQueriesResource;
			this.initFiltersMap = initFiltersMap;
			this.pushFilterToMap = pushFilterToMap;
			this.pushFiltersToMap = pushFiltersToMap;
			this.setColumns = setColumns;
			this.setDefaultStoredQuery = setDefaultStoredQuery;
			this.setParams = setParams;

			function setParams(params) {
				self.params = params;
			}

			function getParams() {
				return self.params;
			}

			function setColumns(columns) {
				self.chosenColumns.length = 0;
				self.availableColumns.length = 0;

				for (var i = 0; i < columns.length; i++) {
					var column = columns[i];

					if (column.chosen) {
						self.chosenColumns.push(column);
					} else {
						self.availableColumns.push(column);
					}
				}

				$timeout(function() {
					self.availableColumns.sort(function(a, b) {
						return a['available_weight'] - b['available_weight']
					});
				});
				self.chosenColumns.sort(FilteringUtils.sortByWeight);
			}

			this.defaultFilterInstances = [];

			function addDefaultFilterInstance(storedFilterStruct) {
				self.defaultFilterInstances.push(storedFilterStruct);
			}

			this.defaultStoredQuery = undefined;

			function setDefaultStoredQuery(storedQueryParameters) {
				self.defaultStoredQuery = storedQueryParameters;
			}

			var cachedFacets = {};

			function getFacetsForField(field) {
				if (!(field in cachedFacets)) {
					var facetParams = config['facetParams'] || {};

					cachedFacets[field] = ObjectResource.getFacets(angular.extend({field: field}, facetParams));
				}

				return cachedFacets[field];
			}

			function getBaseFilters() {
				return ObjectResource.getFilters();
			}

			function getQueriesResource() {
				return QueriesResource;
			}

			function initFiltersMap(baseFilters) {
				angular.forEach(baseFilters, function(baseFilter) {
					self.filterInstancesMap[baseFilter.key] = {
						baseFilter: baseFilter,
						filterInstances: [FilterInstanceFactory(baseFilter, self.getFacetsForField)]
					}
				});
			}

			function pushFilterToMap(filterInstance) {
				self.filterInstancesMap[filterInstance.baseFilter.key].filterInstances.push(filterInstance);
			}

			function cleanFiltersMap(baseFilters) {
				angular.forEach(baseFilters, function(baseFilter) {
					self.filterInstancesMap[baseFilter.key].filterInstances.length = 0;
					self.pushFilterToMap(FilterInstanceFactory(baseFilter, self.getFacetsForField))
				});
			}

			function pushFiltersToMap(filterInstances) {
				var keyCleaningMarker = {};
				filterInstances.forEach(function(filterInstance) {
					if (keyCleaningMarker[filterInstance.baseFilter.key]) {
						self.pushFilterToMap(filterInstance);
					} else {
						self.filterInstancesMap[filterInstance.baseFilter.key].filterInstances.length = 0;
						self.pushFilterToMap(filterInstance);
						keyCleaningMarker[filterInstance.baseFilter.key] = true;
					}
				})
			}

			function getFilterInstances() {
				var result = [];
				angular.forEach(self.filterInstancesMap, function(value) {
					value.filterInstances.forEach(function(filterInstance) {
						if (!filterInstance.isEmpty()) {
							result.push(filterInstance);
						}
					})
				});
				return result;
			}
		}

		return function(ObjectResource, QueriesResource, config) {
			return new DynamicFiltering(ObjectResource, QueriesResource, config);
		};
	}]);


angular.module('community.reports').factory('FilterInstanceFactory', ['ArrayHelper', function(ArrayHelper) {
	function strToDate(string) {
		var momentObject = moment(string);

		if (String(momentObject) === 'Invalid date') {
			return undefined;
		}

		return momentObject;
	}

	// convert an array of filterInstance's valueStructs into compressed string representation
	function parseInstanceValue(value, baseFilter, lookup, facetsGetter) {
		var types = baseFilter.type.split('|'),
			values = value.split('|');

		var valueSturcts = [],
			currentValueIndex = 0;

		types.forEach(function(type, index) {
			var valueStruct = {
				type: type,
				valueParts: []
			};

			if (type === 'sl') {
				valueStruct['facets'] = facetsGetter(baseFilter.facets_keys[index]);
			}

			if (type === 'dt') {
				if (['exact', 'gte', 'lte'].indexOf(lookup) > -1) {
					valueStruct.valueParts.push(strToDate(values[currentValueIndex]));
				} else if (lookup === 'range') {
					var from = strToDate(values[currentValueIndex]),
						to = strToDate(values[currentValueIndex + 1]);

					ArrayHelper.pushAll(valueStruct.valueParts, [from, to]);
					currentValueIndex += 1;
				} else {
					valueStruct.valueParts.push(values[currentValueIndex]);
				}
			} else {
				valueStruct.valueParts.push(types.length === 1 ? value : values[currentValueIndex]);
			}

			valueSturcts.push(valueStruct);
			currentValueIndex += 1;
		});

		return valueSturcts;
	}

	return function(baseFilter, facetsGetter, initialValues) {
		var instance = {
			baseFilter: baseFilter,
			negated: baseFilter.negated,
			values: [],

			getCompressedValue: function() {
				var lookup = this.lookup,
					allValueParts = [];

				this.values.forEach(function(valueStruct) {
					var cleanValues = angular.copy(valueStruct.valueParts);

					// convert dates from moment objects into strings of "YYYY-MM-DD" format
					if (valueStruct.type === 'dt' && ['exact', 'gte', 'lte', 'range'].indexOf(lookup) > -1) {
						for (var i = 0; i < cleanValues.length; i++) {
							if (cleanValues[i]) {
								cleanValues[i] = cleanValues[i].format("YYYY-MM-DD");
							}
						}
					}

					allValueParts = allValueParts.concat(cleanValues);
				});

				return allValueParts.join('|');
			},

			getSerializedForm: function() {
				return {
					filter_key: this.baseFilter.key,
					lookup: this.lookup,
					value: this.getCompressedValue(),
					is_not: this.negated
				}
			},
			isEmpty: function() {
				var empty = false;
				this.values.forEach(function(valueStruct) {
					if (valueStruct.valueParts.length == 0) {
						empty = true
					} else {
						valueStruct.valueParts.forEach(function(value) {
							if (value === undefined || value === null || value === '') {
								empty = true;
							}
						})
					}
				});
				return empty;
			}
		};

		if (initialValues) {
			instance.negated = initialValues['is_not'] || false;
			instance.lookup = initialValues['lookup'];

			if (initialValues.hasOwnProperty('value')) {
				instance.values = parseInstanceValue(initialValues['value'], baseFilter, initialValues['lookup'], facetsGetter);
			}
		} else {
			baseFilter.type.split('|').forEach(function(type, index) {
				var newValue = {type: type, valueParts: []};
				if (type === 'sl') {
					newValue['facets'] = facetsGetter(baseFilter.facets_keys[index]);
					newValue['facets'].$promise.then(function(facets) {
						var defaultOption = ArrayHelper.findByPropertyValue(facets, 'default', true);
						if (defaultOption) {
							newValue.valueParts.push(defaultOption.val);
						}
					})
				}
				instance.values.push(newValue);
			});
		}

		return instance;
	}
}]);


angular.module('community.reports').factory('FilteringStateService', [
	'FilteringUtils', 'FilteringStateFactory', 'FilterInstanceFactory', 'ArrayHelper', 'filteringUrlParams',
	function(FilteringUtils, FilteringStateFactory, FilterInstanceFactory, ArrayHelper, filteringUrlParams) {
		return function(baseFilters, facetsGetter) {
			function convertStoredFiltersToInstances(storedFilters) {
				var instances = [];

				storedFilters.forEach(function(storedFilterInstance) {
					var baseFilter = ArrayHelper.findByPropertyValue(baseFilters, 'key', storedFilterInstance.filter_key);

					if (baseFilter) {
						var instance = FilterInstanceFactory(baseFilter, facetsGetter, storedFilterInstance);

						instances.push(instance);
					}
				});

				return instances;
			}

			function restoreColumns(compressedColumns) {
				if (compressedColumns) {
					return compressedColumns.split(',');
				}

				return [];
			}

			return {
				getStateFromUi: function(storedQueryId, filterInstances, columns, orderingField) {
					var columnNames = columns.map(function(column) {
						return column.name;
					});

					return FilteringStateFactory(storedQueryId, filterInstances, columnNames, orderingField);
				},

				getSerializedState: function(serialized) {
					var filterInstances = convertStoredFiltersToInstances(serialized['filters']),
						storedQueryId = serialized['stored_query_id'],
						columns = serialized['columns'],
						orderingField = serialized['ordering_field'];

					return FilteringStateFactory(storedQueryId, filterInstances, restoreColumns(columns), orderingField);
				},

				getStateFromUrl: function(urlParams) {
					var urlFilters = [];

					for (var urlParam in urlParams) {
						if (urlParams.hasOwnProperty(urlParam)) {
							for (var i = 0; i < baseFilters.length; i++) {
								var baseFilter = baseFilters[i],
									expr = new RegExp('^' + baseFilter.key + '(__not)?(__[\\w]+?)?$'),
									match = urlParam.match(expr);

								if (match !== null) {
									var negated = match[1] !== undefined,
										lookup_part = match[2];

									var values = urlParams[urlParam];

									if (!angular.isArray(values)) {
										values = [values];
									}

									for (var j = 0; j < values.length; j++) {
										var instanceStruct = {
											value: values[j],
											is_not: negated
										};

										if (lookup_part !== undefined) {
											instanceStruct['lookup'] = lookup_part.substr(2);
										}

										var instance = FilterInstanceFactory(baseFilter, facetsGetter, instanceStruct);

										urlFilters.push(instance);
									}
								}
							}
						}
					}

					var storedQueryId = urlParams[filteringUrlParams.storedQuery],
						columns = restoreColumns(urlParams[filteringUrlParams.columns]),
						orderingField = urlParams[filteringUrlParams.storedQuery.orderingField];

					if (urlFilters.length === 0 && !storedQueryId && columns.length === 0 && !orderingField) {
						return undefined;
					}

					return FilteringStateFactory(storedQueryId, urlFilters, columns, orderingField);
				},

				getStateFromStoredQuery: function(query) {
					var filterInstances = convertStoredFiltersToInstances(query.filters),
						storedQueryId = query.id,
						columns = (query.columns || []).sort(FilteringUtils.sortByWeight),
						columnNames = [],
						orderingField = query.ordering_field;

					if (columns.length > 0) {
						columnNames = columns.map(function(storedColumn) {
							return storedColumn['column_key'];
						})
					}

					return FilteringStateFactory(storedQueryId, filterInstances, columnNames, orderingField);
				},

				getStateFromDefaultFilters: function(filterStructs) {
					var filterInstances = convertStoredFiltersToInstances(filterStructs);

					return FilteringStateFactory(undefined, filterInstances, [], undefined);
				}
			}
		}
	}]);


angular.module('community.reports').factory('FilteringStateFactory', ['filteringUrlParams', function(filteringUrlParams) {
	function compressColumns(columns) {
		return columns.join(',') || undefined;
	}

	return function(storedQueryId, filterInstances, columns, orderingField) {
		return {
			getSerializedForm: function() {
				return {
					stored_query_id: storedQueryId,
					filters: filterInstances.map(function(filterInstance) {
						return filterInstance.getSerializedForm();
					}),
					columns: compressColumns(columns),
					ordering_field: orderingField
				}
			},

			getUrlParams: function() {
				var filteringParameters = {};

				filteringParameters[filteringUrlParams.storedQuery] = storedQueryId;
				filteringParameters[filteringUrlParams.columns] = compressColumns(columns);
				//filteringParameters[filteringUrlParams.orderingField] = orderingField;

				if (filterInstances) {
					filterInstances.forEach(function(filterInstance) {
						var key = filterInstance.baseFilter.key;

						if (filterInstance.negated) key += '__not';
						if (filterInstance.lookup) key += '__' + filterInstance.lookup;

						var paramsList = filteringParameters[key] || [];
						if (!(key in filteringParameters)) {
							filteringParameters[key] = paramsList;
						}

						var compressedValue = filterInstance.getCompressedValue();
						if (compressedValue && compressedValue.length > 0) {
							paramsList.push(compressedValue);
						}
					});
				}

				return filteringParameters;
			},

			getStoredQueryFields: function() {
				var columnStructs = [];

				for (var i = 0; i < columns.length; i++) {
					columnStructs.push({
						column_key: columns[i],
						weight: i
					});
				}

				return {
					columns: columnStructs,
					filters: filterInstances.map(function(filterInstance) {
						return filterInstance.getSerializedForm();
					}),
					ordering_field: orderingField
				}
			},

			getStoredQueryId: function() {
				return storedQueryId;
			},

			getInstances: function() {
				return filterInstances;
			},

			getColumns: function() {
				return columns;
			},

			getOrderingField: function() {
				return orderingField;
			}
		};
	}
}]);


angular.module('community.reports').service('FilteringUtils', ['ArrayHelper', function(ArrayHelper) {
	var self = this;

	this.sortByWeight = function(a, b) {
		return a['weight'] - b['weight'];
	};

	this.getQueryColumns = function(query, allColumns) {
		var queryColumns = [];

		if (query.columns.length > 0) {
			query.columns.forEach(function(storedColumn) {
				var column = ArrayHelper.findByPropertyValue(allColumns, 'name', storedColumn.column_key);

				if (column !== undefined) {
					column.weight = storedColumn.weight;
					queryColumns.push(column);
				}
			});
		} else {
			// If the query doesn't have any stored columns at all, load the default columns
			queryColumns = allColumns.filter(function(column) {
				return column.default;
			})
		}

		queryColumns.sort(self.sortByWeight);

		return queryColumns;
	}
}]);

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.controller('ProjectsReportController', ProjectsReportController);

ProjectsReportController.$inject = ['$scope', '$q', '$modal', '$state', '$http',
	'ReportServiceFactory',
	'CmntSubMatters', 'SubMatterQueries',
	'BaseReportController', 'ArrayHelper'];

function ProjectsReportController($scope, $q, $modal, $state, $http,
								  ReportServiceFactory,
								  CmntSubMatters, SubMatterQueries,
								  BaseReportController, ArrayHelper) {
	var reportService = ReportServiceFactory({
		defaultOrdering: '-matter__id',
		objectsResource: CmntSubMatters,
		queriesResource: SubMatterQueries,
		exportUrl: '/api/community/sub_matters/export_delay/',
		bulkActionsTemplate: 'reports/memoboxes/bulk_actions.html',
		listTemplate: 'ip/projects/projectsTemplateList.html',
		listOrderingOptions: [
			{field: 'title', label: 'Name'},
			{field: 'matter_type__title', label: 'Project Type'},
			{field: 'defining__value', label: 'Country'},
			{field: 'status__value', label: 'Status'},
			{field: '-created', label: 'Last created'},
			{field: '-modified', label: 'Last modified'},
			{field: 'type__value', label: 'Type'},
			{field: 'sub_type__value', label: 'Sub Type'},
			{field: 'matter__id', label: 'Family'}
		],
		objectsName: 'Projects',
		hasFreeSearch: true,
		visibleFiltersCount: 10
	});

	var parent = BaseReportController(reportService, $scope);
	angular.extend($scope, parent);

	$scope.$watchCollection('columns', function() { //watch for array modification
		$scope.classificationTextColumn = ArrayHelper.findByPropertyValue($scope.columns, 'title', 'Classification Text');
	});

	$scope.toggleClassificationText = function() {
		if ($scope.classificationTextColumn) {
			ArrayHelper.remove($scope.filteringService.chosenColumns, $scope.classificationTextColumn);
			$scope.applyFilters()
		} else {
			var classificationTextColumn = ArrayHelper.findByPropertyValue($scope.filteringService.availableColumns, 'title', 'Classification Text');
			$scope.filteringService.chosenColumns.push(classificationTextColumn);
			$scope.applyFilters()
		}
	};

	var selectionService = reportService.getSelectionService();

	$scope.bulkArchive = function() {
		$scope.listLoaded = false;
		return reportService.performBulkAction(function(queryParameters, selection) {
			return CmntSubMatters.bulkArchive(queryParameters, selection).$promise;
		}).then(function() {
			selectionService.unselectAll();

			return reportService.reloadData();
		}).finally(function() {
			$scope.listLoaded = true;
		});

	};
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('SubMatterQueries', SubMatterQueries);

SubMatterQueries.$inject = ['$resource', 'PekamaConfig', 'momentResourceTransformation'];

function SubMatterQueries($resource, PekamaConfig, momentResourceTransformation) {
	var url = PekamaConfig.apiBaseUrl + 'legal/sub_matter_queries/:id/:action/';

	return $resource(url, {id: '@id'}, momentResourceTransformation(['value']).updateActions({
		getFilters: {
			params: {action: 'get_filters'},
			method: 'GET',
			isArray: true
		},
		changeFollowers: {
			params: {action: 'change_followers'},
			method: 'POST'
		},
		sendNow: {
			params: {action: 'send_now'},
			method: 'POST'
		},
		'get': {
			method: 'GET'
		},
		'save': {
			method: 'POST'
		},
		'query': {
			method: 'GET',
			isArray: true
		},
		'update': {
			method: 'PUT',
			headers: {'X-HTTP-Method-Override': 'PATCH'}
		}
	}));
}

})();
(function() {
'use strict';
angular.module('community.reports').filter('cmntDueDateExceeded', function() {
	return function(task) {
		var now = moment();
		return moment(task.due_date).isBefore([now.year(), now.month(), now.date()]);
	}
});

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('CmntTasks', CmntTasks);

CmntTasks.$inject = ['$resource', 'PekamaConfig', 'ReportActions'];

function CmntTasks($resource, PekamaConfig, ReportActions) {
	var url = PekamaConfig.apiBaseUrl + 'community/tasks/:id/:action/';

	var actions = angular.extend({}, ReportActions);

	return $resource(url, {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('TaskQueries', TaskQueries);

TaskQueries.$inject = ['$resource', 'PekamaConfig', 'momentResourceTransformation'];

function TaskQueries($resource, PekamaConfig, momentResourceTransformation) {
	var url = PekamaConfig.apiBaseUrl + 'tasks/task_queries/:id/:action/';

	return $resource(url, {id: '@id'},
		momentResourceTransformation(['value']).updateActions({
			getFilters: {
				params: {action: 'get_filters'},
				method: 'GET',
				isArray: true
			},
			changeFollowers: {
				params: {action: 'change_followers'},
				method: 'POST'
			},
			sendNow: {
				params: {action: 'send_now'},
				method: 'POST'
			},
			'get': {
				method: 'GET'
			},
			'save': {
				method: 'POST'
			},
			'query': {
				method: 'GET',
				isArray: true
			},
			'update': {
				method: 'PUT',
				headers: {'X-HTTP-Method-Override': 'PATCH'}
			}
		})
	);
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.factory('Tasks', Tasks);

Tasks.$inject = ['$resource', 'PekamaConfig', 'ReportActions'];

function Tasks($resource, PekamaConfig, ReportActions) {
	var url = PekamaConfig.apiBaseUrl + 'tasks/tasks/:id/:action/';

	var actions = angular.extend({}, ReportActions);

	return $resource(url, {id: '@id'}, actions);
}

})();
(function() {
'use strict';
angular
	.module('community.reports')
	.controller('TasksReportController', TasksReportController);

TasksReportController.$inject = ['$scope',
	'ReportServiceFactory',
	'CmntTasks', 'TaskQueries',
	'BaseReportController'];

function TasksReportController($scope,
							   ReportServiceFactory,
							   CmntTasks, TaskQueries,
							   BaseReportController) {

	var reportService = ReportServiceFactory({
		objectsResource: CmntTasks,
		queriesResource: TaskQueries,
		exportUrl: '/api/community/tasks/export_delay/',
		bulkActionsTemplate: 'reports/tasks/bulk_actions.html',
		defaultOrdering: 'due_date',
		listOrderingOptions: [
			{field: '-created', label: 'Last created'},
			{field: '-modified', label: 'Last modified'},
			{field: 'due_date', label: 'Due date'},
			{field: 'title', label: 'Title'},
			{field: 'assignee__first_name', label: 'Assignee'}
		],
		objectsName: 'Tasks',
		visibleFiltersCount: 10
	});

	var parent = BaseReportController(reportService, $scope);
	angular.extend($scope, parent);

	var filteringService = reportService.getFilteringService();
	filteringService.setDefaultStoredQuery({name: 'My Active Tasks', is_default: true});
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.factory('AgentStatFactory', AgentStatFactory);

AgentStatFactory.$inject = ['PartyStatFactory'];

function AgentStatFactory(PartyStatFactory) {
	return function(agentName, callback, agentStat) {
		return PartyStatFactory(agentName, callback, agentStat, 'pct/agents_stat/')
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.factory('ApplicantStatFactory', ApplicantStatFactory);

ApplicantStatFactory.$inject = ['PartyStatFactory'];

function ApplicantStatFactory(PartyStatFactory) {
	return function(applicantName, callback, applicantStat) {
		return PartyStatFactory(applicantName, callback, applicantStat, 'pct/applicants_stat/')
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.factory('PartyStatFactory', PartyStatFactory);

PartyStatFactory.$inject = ['$q', '$http', 'PekamaConfig', 'AlertFactory', '$modal'];

function PartyStatFactory($q, $http, PekamaConfig, AlertFactory, $modal) {
	return function(partyName, callback, partyStat, urlPart) {
		var statDefer = $q.defer();

		$http.get(PekamaConfig.apiBaseUrl + urlPart, {
			params: {
				q: partyName,
				put_to_queue: true
			}
		}).then(function(response) {
			var stat = response.data;

			if (partyStat !== undefined) {
				angular.extend(partyStat, stat);
			}

			if (stat.official_requested && stat.official_status !== 200 && stat.official_status !== 404) {
				AlertFactory('We are trying to pull patent data from the official databases but they are not responding. This happens sometimes because the databases prioritise human requests and I\'m just a robot. Please try again in 15 minutes or so and this will probably work!', '');
				$q.when(callback()).finally(statDefer.resolve);
			} else if (stat.official_count === 0 && stat.scraped_count === 0 && (stat.official_status === 404 || !stat.official_requested)) {
				AlertFactory('Unfortunately, we did not find anything in the official databases.', '');
				$q.when(callback()).finally(statDefer.resolve);
			} else if (stat.official_count > 0 && (Math.min(stat.scraped_count, 2000) < Math.min(stat.official_count, 2000))) {
				var proximity = 5;
				var scraped_count = Math.min(stat.scraped_count, 2000);
				var official_count = Math.min(stat.official_count, 2000);
				if (scraped_count < (official_count - Math.round(official_count / 100 * proximity))) {
					$modal.open({
						templateUrl: 'core/uihelpers/partyStat.modal/partyStat.modal.html',
						controller: 'PartyStatModalController as vm',
						resolve: {
							companyName: function() {
								return partyName;
							},
							stat: function() {
								return stat
							},
							urlPart: function() {
								return urlPart
							}
						}
					}).result.finally(function() {
						$q.when(callback()).finally(statDefer.resolve);
					});
				} else {
					$q.when(callback()).finally(statDefer.resolve);
				}
			} else {
				$q.when(callback()).finally(statDefer.resolve);
			}
		});

		return statDefer;
	};
}

})();
(function() {
'use strict';
angular
	.module('community.core.uihelpers')
	.controller('PartyStatModalController', PartyStatModalController);


PartyStatModalController.$inject = ['$modalInstance', 'companyName', 'stat', '$timeout', '$http', 'PekamaConfig',
	'$scope', '$interval', '$q', 'urlPart'];

function PartyStatModalController($modalInstance, companyName, stat, $timeout, $http, PekamaConfig,
								  $scope, $interval, $q, urlPart) {
	var vm = this;

	vm.companyName = companyName;
	vm.stat = stat;
	vm.progress = 4;
	vm.officialCountNormalized = stat.official_count;

	var requestStatTimeout;
	var minuteInterval;
	var statRequestCanceller = $q.defer();

	vm.countdown = 60;

	vm.showResults = showResults;

	activate();

	function activate() {
		var proximity = 5;

		vm.officialCountNormalized = Math.min(stat.official_count, 2000);
		vm.officialCountNormalized = vm.officialCountNormalized - Math.round(vm.officialCountNormalized / 100 * proximity);

		_setProgress(stat.scraped_count);

		requestStatTimeout = $timeout(_getStat, 1900);
		minuteInterval = $interval(function() {
			vm.countdown = vm.countdown - 1;
			if (vm.countdown === 0) {
				showResults();
			}
		}, 1000);

		$scope.$on('$destroy', function() {
			statRequestCanceller.resolve();
			_stopMinuteInterval();
			_stopRequestStatTimeout();
		});
	}

	function _setProgress(scrapedCount) {
		var scrapedCountNormalized = Math.min(scrapedCount, 2000);
		var progress = Math.max(vm.progress, Math.round(scrapedCountNormalized / vm.officialCountNormalized * 100)); //not less than initial progress
		vm.progress = Math.min(progress, 100); //not more then 100;
	}

	function _getStat() {
		$http.get(PekamaConfig.apiBaseUrl + urlPart, {
			params: {
				q: vm.companyName,
				skip_facts: true
			},
			timeout: statRequestCanceller.promise
		}).then(function(response) {
			_setProgress(response.data.scraped_count);
			if (vm.progress === 100) {
				showResults()
			} else {
				requestStatTimeout = $timeout(_getStat, 1900);
			}
		});
	}

	function _stopRequestStatTimeout() {
		if (angular.isDefined(requestStatTimeout)) {
			$timeout.cancel(requestStatTimeout);
			requestStatTimeout = undefined;
		}
	}

	function _stopMinuteInterval() {
		if (angular.isDefined(minuteInterval)) {
			$interval.cancel(minuteInterval);
			minuteInterval = undefined;
		}
	}

	function showResults() {
		statRequestCanceller.resolve();
		_stopMinuteInterval();
		_stopRequestStatTimeout();
		$modalInstance.close();
	}
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.factory('Files', Files);

Files.$inject = ['$resource', 'PekamaConfig'];

function Files($resource, PekamaConfig) {

	return $resource(PekamaConfig.apiBaseUrl + 'files/files/:id/', {id: '@id'});
}

})();
(function() {
'use strict';
angular
	.module('community.ip')
	.controller('SharedFilesModalController', SharedFilesModalController);

SharedFilesModalController.$inject = ['$modalInstance', 'projectId', 'rootFolderId', 'Files', 'cmntFileIcon'];

function SharedFilesModalController($modalInstance,  projectId, rootFolderId, Files, cmntFileIcon) {
	var vm = this;

	vm.$fileIcon = cmntFileIcon;
	vm.rootFolderId = rootFolderId;
	vm.downloadLink = downloadLink;

	_loadFiles();

	vm.openChildFolder = function(childFolder) {
		_loadFiles(childFolder);
	};

	vm.goToRoot = function() {
		_loadFiles();
	};

	function _loadFiles(childFolder) {
		var folderId = childFolder ? childFolder.id : vm.rootFolderId;
		vm.childFolderName = childFolder ? childFolder.name : '';

		vm.files = Files.query({sub_matter: projectId, for_parent: folderId});
		return vm.files.$promise;
	}

	function downloadLink(signerUrl) {
		return new URL(signerUrl).pathname;
	}
}

})();
(function() {
'use strict';
angular.module('community.core').run(['$templateCache', function($templateCache) {$templateCache.put('core/alertFactory.service.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title modal-header__title_align-center">{{ title }}</h2>\n\t\t</div>\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">{{ message }}</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<button class="button button_size_s button_color_pink" ng-click=\'ok()\' autofocus>OK</button>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/associate.directive.html','<div class="expert" ng-click="vm.toggleSelection()"\n\t\t ng-mouseenter="vm.cursorInside = true"\n\t\t ng-mouseleave="vm.cursorInside = false"\n\t\t ng-class="[vm.extraClass, {\n        expert_checked : vm.associate.selected,\n        expert_disabled: vm.associate.expert_disabled,\n        expert_selectable: vm.selectable,\n        expert_highlighted: vm.cursorInside && vm.selectable && !vm.associate.selected\n     }]">\n\n\t\t<div class="expert__content" ng-if="!vm.editing" ng-class="{\'expert__content_fade-in\': vm.fadeIn}">\n\t\t\t\t<div class="expert-header">\n\t\t\t\t\t\t<div class="expert-header__checkbox" ng-if="vm.selectable && !vm.isReadOnly" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t<label class="checkbox expert__checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-checked="vm.associate.selected"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.toggleSelection($event)">\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">Select</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-header__checkbox" ng-if="vm.deletable">\n\t\t\t\t\t\t\t\t<button class="expert-remove expert-remove_color-pink" ng-click="vm.remove()">\n\t\t\t\t\t\t\t\t\t\t<i class="expert-remove__icon icon icon-delete-line"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="expert-remove__label">Remove</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-header__title">\n\t\t\t\t\t\t\t\t{{ vm.associate.name }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="expert-body">\n\t\t\t\t\t\t<div class="expert-body-userpic">\n\t\t\t\t\t\t\t\t<div class="expert-body-userpic__wrapper">\n\t\t\t\t\t\t\t\t\t\t<img class="expert-body-userpic__img" ng-src="{{ vm.associate.avatar_url || vm.defaultAvatar }}"\n\t\t\t\t\t\t\t\t\t\t\t\t alt="associate">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-body-details">\n\t\t\t\t\t\t\t\t<div class="expert-body-details__pane">\n\t\t\t\t\t\t\t\t\t\t<h5 class="expert-body-details__name">{{ vm.associate.first_name }} {{ vm.associate.last_name}}</h5>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="expert-body-details__pane">\n\t\t\t\t\t\t\t\t\t\t<h5 class="expert-body-details__name">{{ vm.associate.email }}</h5>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="expert-body-country expert-body-country_new-expert">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country-pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country__title">Practices in</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-details-timer"\n\t\t\t\t\t\t\t\t\t\t\t\t tooltip-html-unsafe="<strong>Typical response time</strong><br><br>This indicates how quickly an expert typically responds to a new case introduction."\n\t\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true" tooltip-placement="bottom">\n                        <span class="expert-body-details-timer__time" ng-if-start="vm.associate.avg_response_time">\n                            {{ ::(vm.associate.avg_response_time|cmntDuration) }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="expert-body-details-timer__icon icon icon-timer" ng-if-end></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<cmnt-expert-values-list objects="vm.jurisdictionList" expandable="false">\n\t\t\t\t\t\t\t\t</cmnt-expert-values-list>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="expert-footer">\n\t\t\t\t\t\t<div class="expert-footer-pane">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-footer-pane">\n\t\t\t\t\t\t\t\t<button type="button" class="button button_size_s button_transparent button_text_blue"\n\t\t\t\t\t\t\t\t\t\t\t\tng-if="!vm.deletable && !vm.isReadOnly"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.edit()" cmnt-stop-propagation>Edit\n\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t<!--a class="expert-footer-link" ng-click="vm.edit()" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\tEdit\n\t\t\t\t\t\t\t\t</a-->\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<cmnt-associate-form ng-if="vm.editing" associate="vm.editModel" on-add="vm.onEditingFinished(associate)"\n\t\t\t\t\t\t\t\t\t\t\t\t save-button-label="Save" matter-type="vm.matterType" extra-class="expert__content_fade-in"\n\t\t\t\t\t\t\t\t\t\t\t\t on-cancel="vm.onEditingCancelled()" readonly-fields="vm.readonlyFields"></cmnt-associate-form>\n</div>\n');
$templateCache.put('experts/associateForm.directive.html','<div class="expert__content expert__content_add-form" ng-class="vm.extraClass">\n\t\t<form cmnt-handle-errors name="vm.associateForm" class="shake-on-errors">\n\t\t\t\t<div class="expert-body">\n\t\t\t\t\t\t<div class="expert-body-userpic">\n\t\t\t\t\t\t\t\t<div class="expert-body-userpic__wrapper">\n\t\t\t\t\t\t\t\t\t\t<img class="expert-body-userpic__img" ng-src="{{ vm.associate.avatar_url }}"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.associate.avatar_url"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-file-select ng-file-change="vm.uploadAvatar($files)" accept="image/*">\n\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-userpic__without-pic" ng-file-select\n\t\t\t\t\t\t\t\t\t\t\t\t ng-file-change="vm.uploadAvatar($files)"\n\t\t\t\t\t\t\t\t\t\t\t\t accept="image/*" ng-if="!vm.associate.avatar_url">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-userpic__icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-userpic__descr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tLogo\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="expert-body-userpic__errors" ng-if="vm.logoErrors">\n\t\t\t\t\t\t\t\t\t\t{{ vm.logoErrors }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="expert-body expert-body_column">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="name" cmnt-focus-me="true">Practice name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" id="name" name="name" ng-model="vm.associate.name">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label for="email">Email</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="email" name="email" id="email"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.associate.email"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-readonly="vm.readonlyMapping[\'email\']">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field field-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_width_half field_placeholder-i"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="First"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.associate.first_name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="first_name" cmnt-focus-me="vm.focusSignup">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_width_half field_placeholder-i"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Last"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.associate.last_name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="last_name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label>Practises in</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_back-white select_size_s">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.newJurisdiction" name="jurisdiction_codes">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="jurisdiction in vm.jurisdictions | filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="jurisdiction.value | highlight:$select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" ng-click="vm.addJurisdiction()" ng-disabled="!vm.newJurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<ul class="expert-body__locations-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body__locations-item" ng-repeat="jurisdiction in vm.pickedJurisdictions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ jurisdiction.value }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="expert-body__locations-delete"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.removeJurisdiction(jurisdiction)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="expert-footer">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-footer-pane">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="expert-footer-pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="button button_size_s button_transparent button_text_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.cancel()" cmnt-stop-propagation>Cancel\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="button button_size_s button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.add(vm.associateForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.saveButtonLabel }}\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('experts/expertInstructions.html','<div class="filter-pane filter-pane_filled profile__filter-pane">\n\t\t<div class="filter-pane__item filter-pane__item_align-bottom">\n\t\t\t\t<cmnt-project-direction-filter\n\t\t\t\t\t\t\t\tdirection="vm.direction"\n\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)">\n\t\t\t\t</cmnt-project-direction-filter>\n\n\t\t\t\t<cmnt-project-status-filter\n\t\t\t\t\t\t\t\tstatus="vm.status"\n\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)">\n\t\t\t\t</cmnt-project-status-filter>\n\n\t\t\t\t<cmnt-jurisdiction-filter\n\t\t\t\t\t\t\t\tmatter-type="vm.matterType"\n\t\t\t\t\t\t\t\tdefining="vm.jurisdiction"\n\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)">\n\t\t\t\t</cmnt-jurisdiction-filter>\n\n\t\t\t\t<form ng-submit="vm.searchChanged()" class="filter__form">\n\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_100">\n\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Find..." name="search"\n\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.search" ng-blur="vm.searchChanged()"/>\n\t\t\t\t\t\t\t\t<button class="field__button" type="submit">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t</div>\n</div>\n\n\n<section class="sub-filter">\n\t\t<div class="sub-filter-pane">\n\t\t\t\t<cmnt-project-ordering ordering="vm.ordering" on-ordering-changed="vm.filtersChanged(newValues)">\n\t\t\t\t</cmnt-project-ordering>\n\t\t\t\t<label class="checkbox checkbox_color-gray" ng-show="vm.ProjectsList.hasGroups">\n\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-checked="vm.ProjectsList.groupByFamily"\n\t\t\t\t\t\t\t\t\t ng-click="vm.toggleGrouping()">\n\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t<span class="checkbox__title">Group by Family</span>\n\t\t\t\t</label>\n\t\t</div>\n\n\t\t<!--div class="sub-filter-pane" ng-if="::(!vm.currentUser.is_read_only)">\n\n\t\t\t\t<span ng-if="vm.ProjectsList.selectedProjects.length > 0">\n\t\t\t\t\t\t<strong class="sub-filter-pane__selected-number">{{ vm.ProjectsList.selectedProjects.length }}</strong> selected\n\t\t\t\t</span>\n\n\t\t\t\t<div class="sub-filter-pane__item icons-menu-list icons-menu-list_theme_gray">\n\t\t\t\t\t\t<button class="icons-menu-list__item"\n\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="vm.archive()"\n\t\t\t\t\t\t\t\t\t\tconfirm-title="Are you sure?"\n\t\t\t\t\t\t\t\t\t\tconfirm-message="This action will hide selected projects for you and your team members."\n\t\t\t\t\t\t\t\t\t\tng-if="vm.ProjectsList.isArchivePossible()">\n\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icons-menu-list__icon_color_pink icon icon-delete"></i>\n\t\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="icons-menu-list__item" ng-if="vm.ProjectsList.isClonePossible()"\n\t\t\t\t\t\t\t\t\t\tng-click="vm.ProjectsList.clone()">\n\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icons-menu-list__icon_color_blue icon icon-clone"></i>\n\t\t\t\t\t\t\t\tClone\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<a href="#" class="sub-filter-pane__link" ng-click="vm.ProjectsList.selectAll()">Select All</a>\n\t\t\t\t<a href="#" class="sub-filter-pane__link" ng-click="vm.ProjectsList.selectNone()">Select None</a>\n\t\t</div-->\n</section>\n\n<div infinite-scroll="vm.loadMore()" infinite-scroll-distance="1" infinite-scroll-immediate-check="false"\n\t\t infinite-scroll-disabled="!vm.ProjectsList.projects.$resolved"\n\t\t ng-if="!(vm.ProjectsList.groupByFamily && vm.ProjectsList.hasGroups) && !vm.ProjectsList.dataChange">\n\t\t<cmnt-project project="project" ng-repeat="project in vm.ProjectsList.projects" animated="vm.animateTiles"\n\t\t\t\t\t\t\t\t\tis-read-only="::vm.currentUser.is_read_only">\n\t\t</cmnt-project>\n</div>\n\n<div infinite-scroll="vm.loadMore()" infinite-scroll-distance="1" infinite-scroll-immediate-check="false"\n\t\t infinite-scroll-disabled="!vm.ProjectsList.projects.$resolved"\n\t\t ng-if="vm.ProjectsList.groupByFamily && vm.ProjectsList.hasGroups && !vm.ProjectsList.dataChange">\n\t\t<div class="case-group"\n\t\t\t\t ng-repeat="(familyId, projects) in vm.ProjectsList.projectsByFamily">\n\t\t\t\t<div class="case-group-header">\n\t\t\t\t\t\t<i class="case-group-header__icon icon"\n\t\t\t\t\t\t\t ng-class="{\'icon-inbound\': projects[0].direction === \'incoming\', \'icon-outbound\': projects[0].direction === \'outgoing\'}"\n\t\t\t\t\t\t\t tooltip="{{ (projects[0].direction === \'incoming\')?\'Inbound\':\'Outbound\' }}"></i>\n\t\t\t\t\t\t<h3 class="case-group-header__title">{{ projects[0].title }}</h3>\n\t\t\t\t</div>\n\t\t\t\t<cmnt-project\n\t\t\t\t\t\t\t\tproject="project" animated="vm.animateTiles"\n\t\t\t\t\t\t\t\tis-read-only="::vm.currentUser.is_read_only"\n\t\t\t\t\t\t\t\tng-repeat="project in projects">\n\t\t\t\t</cmnt-project>\n\t\t</div>\n</div>\n\n<cmnt-loading-indicator class="loading-indicator_align-center" resource="vm.loadingMore"></cmnt-loading-indicator>\n\n<div ng-if="vm.ProjectsList.dataChange" class="cases-grid_fade-in enable-animations">\n\t\t<cmnt-project-placeholder ng-repeat="i in [1,2,3,4,5,6,7,8,9,10]">\n\t\t</cmnt-project-placeholder>\n</div>\n\n<cmnt-empty-result resource="vm.ProjectsList.projects" title="No cases to show">\n\t\tEither create a new case <b>or</b> change your filtering criteria to reveal existing cases\n</cmnt-empty-result>\n');
$templateCache.put('experts/expertPlaceholder.directive.html','<div class="expert expert_placeholder experts-grid__item" ng-class="\'expert_fade-in\'">\n\t\t<div class="expert-header">\n\t\t\t\t<div class="expert-header__checkbox" ng-if="vm.checkbox">\n\t\t\t\t\t\t<div class="fake-checkbox expert-header__fake-checkbox">\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="expert-header__title">\n\t\t\t\t\t\t<span>Placehodler organization</span>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="expert-header__score">\n\t\t\t\t\t\t<span>250</span>\n\t\t\t\t\t\t<span class="label">Community Score</span>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="expert-body">\n\t\t\t\t<div class="expert-body-userpic">\n\t\t\t\t\t\t<div class="expert-body-userpic__wrapper">\n\t\t\t\t\t\t\t\t<div class="expert-body-userpic__img expert-body-userpic__img_fake"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="expert-body-details">\n\t\t\t\t\t\t<h5 class="expert-body-details__name">\n\t\t\t\t\t\t\t\t<span>John Smith</span>\n\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t<div class="expert-body-details__pane">\n\t\t\t\t\t\t\t\t<div class="expert-body-details-timer">\n\t\t\t\t\t\t\t\t\t\t<span>2 hours</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-body-country">\n\t\t\t\t\t\t\t\t<div class="expert-body-country-pane">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country__title">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>Practices in</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<ul class="expert-body-country-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>United Kingdom</span></li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>Belarus</span></li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>Belarus</span></li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="expert-body-country-pane">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country__title">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>Sends cases to</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<ul class="expert-body-country-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>United Kingdom</span></li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>Belarus</span></li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>Some long country</span></li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>Belarus</span></li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="expert-body-country-list__item"><span>France</span></li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="expert-footer">\n\t\t\t\t<div class="expert-footer-pane">\n            <span href class="expert-footer-link">\n                Pre-Existing Relationship\n            </span>\n\t\t\t\t</div>\n\t\t\t\t<div class="expert-footer-pane">\n            <span class="expert-footer-link">\n                View full profile\n            </span>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/expertProfile.directive.html','<div class="expert" ng-click="vm.toggleSelection()"\n\t\t ng-mouseenter="vm.cursorInside = true"\n\t\t ng-mouseleave="vm.cursorInside = false"\n\t\t ng-class="[vm.extraClass, {\n        expert_checked : vm.profile.selected,\n        expert_disabled: vm.profile.expert_disabled,\n        expert_selectable: vm.selectable,\n        expert_highlighted: vm.cursorInside && vm.selectable && !vm.profile.selected\n     }]">\n\n\t\t<div class="expert__content" ng-class="{\'expert__content_fade-in\': vm.fadeIn}">\n\t\t\t\t<div class="expert-header">\n\t\t\t\t\t\t<div class="expert-header__checkbox" ng-if="vm.selectable && !vm.isReadOnly" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t<label class="checkbox expert__checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-checked="vm.profile.selected"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.toggleSelection($event)">\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">Select</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-header__checkbox" ng-if="vm.deletable">\n\t\t\t\t\t\t\t\t<button class="expert-remove expert-remove_color-pink" ng-click="vm.remove()">\n\t\t\t\t\t\t\t\t\t\t<i class="expert-remove__icon icon icon-delete-line"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="expert-remove__label">Remove</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-header__title">\n\t\t\t\t\t\t\t\t{{ ::vm.profile.organization.title }}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-header__score">\n\t\t\t\t\t\t\t\t{{ ::vm.profile.community_score }}\n\t\t\t\t\t\t\t\t<span class="label">Community Score</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="expert-body">\n\t\t\t\t\t\t<div class="expert-body-userpic">\n\t\t\t\t\t\t\t\t<div class="expert-body-userpic__wrapper">\n\t\t\t\t\t\t\t\t\t\t<img class="expert-body-userpic__img" ng-src="{{ ::vm.profile.avatar160 }}"\n\t\t\t\t\t\t\t\t\t\t\t\t alt="{{ ::vm.profile.name }}">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-body-details">\n\t\t\t\t\t\t\t\t<div class="expert-body-details__pane">\n\t\t\t\t\t\t\t\t\t\t<h5 class="expert-body-details__name">{{ ::vm.profile.name }}</h5>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="expert-body-details__pane">\n\t\t\t\t\t\t\t\t\t\t<!--cmnt-star-rating rating-value="vm.profile.average_rating" extra-class="rating_color-green">\n\t\t\t\t\t\t\t\t\t\t</cmnt-star-rating-->\n\t\t\t\t\t\t\t\t\t\t<div class="like-module" cmnt-stop-propagation>\n                        <span class="like-module__icon" ng-if="::(!vm.profile.own_profile && !vm.isReadOnly)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-switch="vm.profile.is_recommended">\n                            <i ng-switch-when="false" class="icon"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.recommend()" tooltip="Recommend this firm"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-placement="bottom" tooltip-popup-delay="500" ng-init="likeHover=false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-mouseenter="likeHover=true" ng-mouseleave="likeHover=false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'icon-like-empty\': !likeHover, \'icon-like-fill\': likeHover}"></i>\n                            <i ng-switch-when="true" class="icon icon-like-fill icon-like-active"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.unrecommend()"></i>\n                        </span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="like-module__icon" ng-if="::(vm.profile.own_profile || vm.isReadOnly)">\n                            <i class="icon icon-like-empty"></i>\n                        </span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="like-module__label">{{ vm.profile.recommendations_count }}</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-details-timer" ng-if="::vm.profile.avg_response_time"\n\t\t\t\t\t\t\t\t\t\t\t\t tooltip-html-unsafe="<strong>Typical response time</strong><br><br>This indicates how quickly an expert typically responds to a new case introduction."\n\t\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true" tooltip-placement="bottom">\n                        <span class="expert-body-details-timer__time">\n                            {{ ::(vm.profile.avg_response_time|cmntDuration) }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="expert-body-details-timer__icon icon icon-timer"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="expert-body-country">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country-pane" ng-if="vm.allJurisdictions"></div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country-pane"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'expert-body-country-pane_extended-left\': vm.allJurisdictions}"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-mouseleave="vm.allJurisdictions && (vm.allJurisdictions = false)"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.allJurisdictions && $event.stopPropagation()">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country__title">Practices in</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-expert-values-list objects="vm.jurisdictions" show-all="vm.allJurisdictions">\n\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-expert-values-list>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country-pane"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'expert-body-country-pane_extended-right\': vm.allTargets}"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-mouseleave="vm.allTargets && (vm.allTargets = false)"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.allTargets && $event.stopPropagation()">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-country__title">Sends cases to</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-expert-values-list objects="vm.targets" show-all="vm.allTargets">\n\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-expert-values-list>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="expert-footer">\n\t\t\t\t\t\t<div class="expert-footer-pane" ng-switch="vm.profile.relation">\n\t\t\t\t\t\t\t\t<a href class="expert-footer-link" ng-switch-default cmnt-spinner-action="vm.save()"\n\t\t\t\t\t\t\t\t\t cmnt-stop-propagation ng-if="::(!vm.profile.own_profile && !vm.isReadOnly)">\n\t\t\t\t\t\t\t\t\t\t<i class="expert-footer-link__icon expert-footer-link__icon_color-blue icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<span ng-switch-default ng-if="vm.profile.own_profile">This is you</span>\n\t\t\t\t\t\t\t\t<a href class="expert-footer-link" ng-switch-when="saved" cmnt-spinner-action="vm.unsave()"\n\t\t\t\t\t\t\t\t\t cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t<i class="expert-footer-link__icon expert-footer-link__icon_color-green icon icon-confirm"></i>\n\t\t\t\t\t\t\t\t\t\tSaved\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t<span ng-switch-when="worked_with">Existing Relationship</span>\n\t\t\t\t\t\t\t\t<span ng-switch-when="invite">Pre-Existing Relationship</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="expert-footer-pane">\n\t\t\t\t\t\t\t\t<a class="expert-footer-link" ng-click="vm.viewExpert()" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\tView full profile\n\t\t\t\t\t\t\t\t\t\t<i class="expert-footer-link__icon expert-footer-link__icon_color-blue icon icon-arrow-right margin-left"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/expertProfile.html','<div class="profile-tab">\n\t\t<div class="profile-tab__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-build"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">{{ ::vm.expert.organization.title }}</h3>\n\n\t\t\t\t\t\t\t\t<div class="profile-body__website">\n\t\t\t\t\t\t\t\t\t\t<a ng-href="{{ ::vm.expert.website }}" target="_blank">{{ ::vm.expert.website }}</a>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="profile-body__description">\n\t\t\t\t\t\t\t\t\t\t{{ ::vm.expert.organization.description }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-portfolio"></i>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">Expertise</h3>\n\n\t\t\t\t\t\t\t\t<div class="profile-body__description">\n\t\t\t\t\t\t\t\t\t\t{{ ::vm.expert.competence }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="profile-tab__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-heart"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\t\t\t\t\tCommunity score\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<div class="community-score">\n\t\t\t\t\t\t\t\t\t\t<span class="community-score__number">{{ vm.expert.community_score }}</span>\n\t\t\t\t\t\t\t\t\t\t<ul class="community-score-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="community-score-list__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__number">{{ ::vm.casesReceived.count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__label">cases received</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="community-score-list__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__number">{{ ::vm.casesSent.count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__label">cases sent</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="community-score-list__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__number">{{ ::vm.invitedUsers.count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__label">people invited to Obviously Manage</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/expertProfileValuesList.directive.html','<ul class="expert-body-country-list">\n\t\t<li class="expert-body-country-list__item"\n\t\t\t\tng-repeat="object in ::vm.objects|orderBy:[\'weight\', \'value\']|limitTo:vm.visibleLimit()"\n\t\t\t\tng-class="{\'expert-body-country-list__item_active\': object.weight===0 }">{{ ::object.value }}\n\t\t</li>\n\n\t\t<li ng-if="::(vm.objects.length>5)" class="expert-body-country-list__item" ng-hide="vm.showAll"\n\t\t\t\tng-class="{\'expert-body-country-list__item_inactive\': !vm.expandable}">\n\t\t\t\t<!--<a ng-click="vm.showAll=!vm.showAll" cmnt-stop-propagation>+ {{ ::(vm.objects.length-4) }} more</a>-->\n\t\t\t\t<a ng-click="vm.toggleExpand()" cmnt-stop-propagation>+ {{ ::(vm.objects.length-4) }} more</a>\n\t\t</li>\n\n\t\t<li ng-repeat="object in ::vm.objects|orderBy:[\'weight\', \'value\']|limitTo:(4-vm.objects.length)"\n\t\t\t\tclass="expert-body-country-list__item" ng-if="vm.showAll"\n\t\t\t\tng-class="{\'expert-body-country-list__item_active\': object.weight===0 }">{{ ::object.value }}\n\t\t</li>\n</ul>\n');
$templateCache.put('experts/expertServices.html','<div class="profile-body-container" ng-if="vm.positivePledges.length > 0">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-confirm-round"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\tPledges {{ ::vm.expert.name }} makes to you\n\t\t\t\t</h3>\n\n\t\t\t\t<div class="profile-committed-pledge">\n\t\t\t\t\t\t<div class="profile-committed-pledge-item" ng-repeat="pledge in vm.positivePledges">\n\t\t\t\t\t\t\t\t<h6 class="profile-committed-pledge__title">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-confirm profile-committed-pledge__icon"></i>\n\t\t\t\t\t\t\t\t\t\t{{ pledge.pledge_text }}\n\t\t\t\t\t\t\t\t</h6>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n\n<div class="profile-body-container" ng-repeat="service in vm.expert.services">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-dollar-round"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\t{{ ::service.matter_type_repr.title }} {{ ::service.jurisdiction_repr.value }} {{\n\t\t\t\t\t\t::service.expertise_type_repr.value }}\n\t\t\t\t</h3>\n\n\t\t\t\t<div class="profile-body__description">\n\t\t\t\t\t\t{{ ::service.description }}\n\t\t\t\t</div>\n\n\t\t\t\t<div class="profile-body__new-service" ng-if="!vm.expert.own_profile && !vm.currentUser.is_read_only">\n\t\t\t\t\t\t<a class="profile-body__new-service-link" ng-click="vm.startNewCase(service)">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\tStart discussing\n\t\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/experts.html','<div ui-view="expertsList" ng-show="$state.includes(\'community.experts.expertsList\')"></div>\n<div ui-view="expertsDetail" ng-show="$state.includes(\'community.experts.expertsDetail\')"></div>\n');
$templateCache.put('experts/expertsChooser.directive.html','<section class="filter filter_response_v2">\n\t\t<div class="content">\n\t\t\t\t<h3 class="filter__title">Add experts</h3>\n\t\t\t\t<div class="filter-pane filter-pane_align-center">\n\t\t\t\t\t\t<!-- TODO: Need to reconsider the structure -->\n\t\t\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_150 filter__select">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">IP Type</label>\n\t\t\t\t\t\t\t\t\t\t<span class="select__choice">{{ vm.matterTypeLabel }}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_250 filter__select">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Service</label>\n\t\t\t\t\t\t\t\t\t\t<span class="select__choice">{{ vm.expertiseTypeLabel }}</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_150 filter__select">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.definingsRepr.length"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twhen="{\'one\': \'Jurisdiction\', \'other\': \'Jurisdictions\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t<span class="select__choice" ng-repeat="defining in vm.definingsRepr"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="!vm.inputCoverage">{{ defining.value + ($last?\'\':\',&nbsp\') }}</span>\n\t\t\t\t\t\t\t\t\t\t<span class="select__choice" ng-repeat="defining in vm.definingsRepr"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.inputCoverage">\n                        {{ defining.value }} ({{ vm.jurisdictionCoverage[defining.id] || 0 }}){{$last ? \'\' : \',&nbsp\'}}\n                    </span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_align-bottom filter-pane__item_direction-column">\n\t\t\t\t\t\t\t\t<div class="filter-pane-sub-item filter-pane-sub-item_width_155">\n\t\t\t\t\t\t\t\t\t\t<div class="filter__selected-label">\n\t\t\t\t\t\t\t\t\t\t\t\t<strong class="filter__selected-number">{{ vm.selectedProfiles.length }}</strong> Selected\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue" ng-disabled="vm.selectedProfiles.length==0"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{button_disabled: vm.selectedProfiles.length==0}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.addProfilesToCase()">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tAdd to Your Enquiry\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<!--div class="filter-pane-sub-item">\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_100">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Find..." />\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="field__button">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n\n<div class="content-header-select" ng-click="vm.toggleAssociates()">\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__icon">\n\t\t\t\t\t\t<i class="icon icon-chevron-right" ng-class="{\'icon_down\': vm.associatesExpanded}"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="content-header-select__title">\n\t\t\t\t\t\tYour own foreign associates\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__counter">\n\t\t\t\t\t\t{{ vm.selectedAssociates.length }} selected\n\t\t\t\t</div>\n\t\t</div>\n</div>\n\n<div class="content" ng-if="vm.associatesExpanded">\n\t\t<section class="sub-filter">\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t</div>\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<a href class="sub-filter-pane__link" ng-click="vm.unselectAllAssociates()"\n\t\t\t\t\t\t\t ng-if="vm.selectedAssociates.length > 0">Clear Selection</a>\n\t\t\t\t</div>\n\t\t</section>\n\n\t\t<div class="experts-grid">\n\t\t\t\t<div class="expert experts-grid__item" ng-class="{\'experts-grid__item_add-new\': !vm.adding}"\n\t\t\t\t\t\t ng-click="!vm.adding && vm.showAssociateForm()">\n\t\t\t\t\t\t<div class="expert__content" ng-if="!vm.adding">\n\t\t\t\t\t\t\t\t<div class="expert-body">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-add-new">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-add-new__icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-add-new__text">Add new</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<p class="expert-body-add-new__descr">\n\t\t\t\t\t\t\t\t\t\t\t\tIf you have foreign associates who are not members of Obviously Manage, you can still discuss cases with\n\t\t\t\t\t\t\t\t\t\t\t\tthem via Obviously Manage - we\u2019ll just use email to keep them in the conversation.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<cmnt-associate-form associate="vm.newAssociateModel" ng-if="vm.adding" matter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-add="vm.onAssociateAdded(associate)" on-cancel="vm.onAddingCanceled()">\n\t\t\t\t\t\t</cmnt-associate-form>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-associate associate="associate" ng-repeat="associate in vm.associates"\n\t\t\t\t\t\t\t\t\t\t\t\textra-class="experts-grid__item expert_animated"\n\t\t\t\t\t\t\t\t\t\t\t\ton-selection-change="vm.profileSelectionChanged(associate)"\n\t\t\t\t\t\t\t\t\t\t\t\tactive-jurisdictions="vm.definings" matter-type="vm.matterType">\n\t\t\t\t</cmnt-associate>\n\t\t</div>\n</div>\n\n<div class="content-header-select" ng-click="vm.toggleMembers()">\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__icon">\n\t\t\t\t\t\t<i class="icon icon-chevron-right" ng-class="{\'icon_down\': vm.membersExpanded}"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="content-header-select__title">\n\t\t\t\t\t\tObviously Manage members\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__counter">\n\t\t\t\t\t\t{{ vm.selectedExperts.length }} selected\n\t\t\t\t</div>\n\t\t</div>\n</div>\n\n<div class="content" ng-if="vm.membersExpanded">\n\t\t<section class="sub-filter">\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<cmnt-profile-ordering ordering="vm.ordering" on-ordering-changed="vm.orderingChanged(newValues)">\n\t\t\t\t\t\t</cmnt-profile-ordering>\n\n\t\t\t\t\t\t<label class="checkbox checkbox_color-gray">\n\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.showSavedOnly"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.showSavedOnlyChanged()"/>\n\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t<span class="checkbox__title">My saved experts only</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<a href class="sub-filter-pane__link" ng-click="vm.unselectAllExperts()"\n\t\t\t\t\t\t\t ng-if="vm.selectedExperts.length > 0">Clear Selection</a>\n\t\t\t\t</div>\n\t\t</section>\n\n\t\t<div class="experts-grid" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t ng-if="!vm.ProfilesList.dataChange"\n\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.profiles.$resolved">\n\t\t\t\t<cmnt-expert-profile\n\t\t\t\t\t\t\t\tprofile="profile"\n\t\t\t\t\t\t\t\textra-class="experts-grid__item expert_animated"\n\t\t\t\t\t\t\t\ton-selection-change="vm.profileSelectionChanged(profile)"\n\t\t\t\t\t\t\t\tactive-jurisdictions="vm.definings"\n\t\t\t\t\t\t\t\tng-repeat="profile in vm.profiles">\n\t\t\t\t</cmnt-expert-profile>\n\t\t</div>\n\n\t\t<cmnt-loading-indicator class="loading-indicator_align-center" resource="vm.loadingMore"></cmnt-loading-indicator>\n\n\t\t<div class="experts-grid experts-grid_animated enable-animations" ng-if="vm.ProfilesList.dataChange">\n\t\t\t\t<cmnt-expert-placeholder ng-repeat="i in [1,2,3,4,5,6,7,8,9,0]">\n\t\t\t\t</cmnt-expert-placeholder>\n\t\t</div>\n\n\t\t<cmnt-empty-result resource="vm.profiles" title="No experts to show">\n\t\t\t\tChange your filtering criteria to reveal existing cases\n\t\t</cmnt-empty-result>\n</div>\n');
$templateCache.put('experts/expertsDetail.html','<div class="profile">\n\t\t<div class="content">\n\t\t\t\t<div class="profile-invite">\n\t\t\t\t\t\t<button class="button button_size_m button_color_purple" ng-click="vm.startNewCase()"\n\t\t\t\t\t\t\t\t\t\tng-if="!vm.expert.own_profile && !vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\tStart discussing a new case\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_m button_color_blue" cmnt-spinner-action="vm.save()"\n\t\t\t\t\t\t\t\t\t\tng-if="!vm.expert.relation && !vm.expert.own_profile && !vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\tSave to My Experts\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_m button_transparent profile-invite__secondary-button"\n\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.unsave()"\n\t\t\t\t\t\t\t\t\t\tng-if="vm.expert.relation === \'saved\' && !vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t<i class="icon icon-cancel"></i>\n\t\t\t\t\t\t\t\tUnfollow\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class="profile-header">\n\t\t\t\t\t\t<div class="profile-header__row">\n\t\t\t\t\t\t\t\t<div class="profile-header-left profile-header-left_no-border">\n\t\t\t\t\t\t\t\t\t\t<img ng-if="vm.expert.organization.logo" ng-src="{{ vm.expert.organization.logo }}">\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="profile-header-user">\n\t\t\t\t\t\t\t\t\t\t<div class="profile-header-left profile-header-left_user profile-header-left_no-border">\n\t\t\t\t\t\t\t\t\t\t\t\t<img ng-if="vm.expert.avatar160" ng-src="{{ vm.expert.avatar160 }}">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="profile-header-user__company">{{ ::vm.expert.organization.title }}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="profile-header-user__name">{{ ::vm.expert.name }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="profile-header-score">\n\t\t\t\t\t\t\t\t\t\t<span class="profile-header-score__value">{{ ::vm.expert.community_score }}</span>\n\t\t\t\t\t\t\t\t\t\tCommunity Score\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="profile-header__row">\n\t\t\t\t\t\t\t\t<div class="profile-header__services">\n\t\t\t\t\t\t\t\t\t\t<a ui-sref=".services" class="profile-header__services-link">\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.expert.services.length"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twhen="{\'0\': \'no services\', \'1\': \'{} service\', \'other\': \'{} services\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="profile-header__recommend">\n                    <span class="like-module" ng-if="!vm.expert.own_profile && !vm.currentUser.is_read_only"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-switch="vm.expert.is_recommended">\n                        <a class="like-module__link" href ng-switch-when="false" cmnt-spinner-action="vm.recommend()">+ Recommend</a>\n                        <span class="like-module__label-count">{{ vm.expert.recommendations_count }}</span>\n                        <span class="like-module__icon like-module__icon_shift">\n                            <i class="icon icon-like-empty" ng-switch-when="false"></i>\n                            <a href ng-switch-when="true" cmnt-spinner-action="vm.unrecommend()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="like-module__icon-link"><i class="icon icon-like-fill"></i></a>\n                        </span>\n                    </span>\n\t\t\t\t\t\t\t\t\t\t<span class="like-module" ng-if="vm.expert.own_profile || vm.currentUser.is_read_only">\n                        <span class="like-module__label-count">{{ vm.expert.recommendations_count }}</span>\n                        <span class="like-module__icon like-module__icon_shift">\n                            <i class="icon icon-like-empty"></i>\n                        </span>\n                    </span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<nav class="profile-menu" ng-class="{\'profile-menu_no-space\': $state.includes(\'.instructions\')}">\n\t\t\t\t\t\t<a ui-sref=".instructions" ui-sref-active="profile-menu__item_active" class="profile-menu__item"\n\t\t\t\t\t\t\t ng-if="authGlobals.loggedIn && !vm.expert.own_profile && vm.exchangedCasesCount.count > 0">\n\t\t\t\t\t\t\t\tCases exchanged\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a ui-sref=".services" ui-sref-active="profile-menu__item_active" class="profile-menu__item">Services</a>\n\t\t\t\t\t\t<a ui-sref=".profile" ui-sref-active="profile-menu__item_active" class="profile-menu__item">Profile</a>\n\t\t\t\t</nav>\n\t\t\t\t<div class="profile__body" ui-view></div>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/expertsDetailHeader.html','<div class="sub-header">\n\t\t<div class="content">\n\t\t\t\t<a ng-click="Navigation.back(\'community.profile.experts\')" class="sub-header-back">\n\t\t\t\t\t\t<i class="sub-header-back__icon icon icon-arrow-left"></i>\n\t\t\t\t</a>\n\n\t\t\t\t<h2 class="sub-header__title">{{ vm.expert.name }}</h2>\n\t\t</div>\n</div>\n');
$templateCache.put('experts/expertsList.html','<section class="promo" ng-if="!authGlobals.loggedIn">\n\t\t<div class="promo__content">\n\t\t\t\t<h1 class="promo__title">Grow your IP practice</h1>\n\t\t\t\t<h2 class="promo__subtitle">We help IP attorneys get better service, better price and more reciprocal work from\n\t\t\t\t\t\ttheir network of foreign associates</h2>\n\t\t</div>\n</section>\n\n<section class="filter">\n\t\t<div class="content">\n\t\t\t\t<h3 class="filter__title">Find a foreign associate</h3>\n\t\t\t\t<div class="filter-pane">\n\t\t\t\t\t\t<cmnt-profile-filters\n\t\t\t\t\t\t\t\t\t\tmatter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\tdefining="vm.defining"\n\t\t\t\t\t\t\t\t\t\texpertise-type="vm.expertiseType"\n\t\t\t\t\t\t\t\t\t\ttarget-jurisdiction="vm.targetJurisdiction"\n\t\t\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)"\n\t\t\t\t\t\t\t\t\t\textra-class="filter-pane__item">\n\t\t\t\t\t\t</cmnt-profile-filters>\n\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_direction-column filter-pane__item_pull-left">\n\t\t\t\t\t\t\t\t<form ng-submit="vm.searchChanged()" class="filter__form">\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_100">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Find..." name="search" ng-model="vm.search"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.searchChanged()" maxlength="100" cmnt-focus-me="true">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="field__button" type="submit">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_direction-column">\n\t\t\t\t\t\t\t\t<div class="filter__selected-label">\n\t\t\t\t\t\t\t\t\t\t<strong class="filter__selected-number">{{ vm.selectedProfiles.length }}</strong> Selected\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue" ng-disabled="vm.selectedProfiles.length==0"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{button_disabled: vm.selectedProfiles.length==0}" ng-click="vm.startNewProject()"\n\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(!vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\tDiscuss\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n\n<div class="content-header-select" ng-click="vm.toggleAssociates()">\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__icon">\n\t\t\t\t\t\t<i class="icon icon-chevron-right" ng-class="{\'icon_down\': vm.associatesExpanded}"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="content-header-select__title">\n\t\t\t\t\t\tYour own foreign associates\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__counter">\n\t\t\t\t\t\t{{ vm.selectedAssociates.length }} selected\n\t\t\t\t</div>\n\t\t</div>\n</div>\n\n<div class="content" ng-if="vm.associatesExpanded">\n\t\t<section class="sub-filter">\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t</div>\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<a href class="sub-filter-pane__link" ng-click="vm.unselectAllAssociates()"\n\t\t\t\t\t\t\t ng-if="vm.selectedAssociates.length > 0">Clear Selection</a>\n\t\t\t\t</div>\n\t\t</section>\n\n\t\t<div class="experts-grid">\n\t\t\t\t<div class="expert experts-grid__item" ng-class="{\'experts-grid__item_add-new\': !vm.adding}"\n\t\t\t\t\t\t ng-click="!vm.adding && vm.showAssociateForm()" ng-if="::(!vm.currentUser.is_read_only)">\n\t\t\t\t\t\t<div class="expert__content" ng-if="!vm.adding">\n\t\t\t\t\t\t\t\t<div class="expert-body">\n\t\t\t\t\t\t\t\t\t\t<div class="expert-body-add-new">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-add-new__icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="expert-body-add-new__text">Add new</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<p class="expert-body-add-new__descr">\n\t\t\t\t\t\t\t\t\t\t\t\tIf you have foreign associates who are not members of Obviously Manage, you can still discuss cases with\n\t\t\t\t\t\t\t\t\t\t\t\tthem via Obviously Manage - we\u2019ll just use email to keep them in the conversation.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<cmnt-associate-form associate="vm.newAssociateModel" ng-if="vm.adding" matter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-add="vm.onAssociateAdded(associate)" on-cancel="vm.onAddingCanceled()">\n\t\t\t\t\t\t</cmnt-associate-form>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-associate associate="associate" ng-repeat="associate in vm.associates"\n\t\t\t\t\t\t\t\t\t\t\t\textra-class="experts-grid__item expert_animated"\n\t\t\t\t\t\t\t\t\t\t\t\ton-selection-change="vm.profileSelectionChanged(associate)"\n\t\t\t\t\t\t\t\t\t\t\t\ton-before-selection-change="vm.onBeforeSelectionChanged(associate)"\n\t\t\t\t\t\t\t\t\t\t\t\tactive-jurisdictions="vm.defining" matter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\tis-read-only="::vm.currentUser.is_read_only">\n\t\t\t\t</cmnt-associate>\n\t\t</div>\n</div>\n\n<div class="content-header-select" ng-click="vm.toggleMembers()">\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__icon">\n\t\t\t\t\t\t<i class="icon icon-chevron-right" ng-class="{\'icon_down\': vm.membersExpanded}"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="content-header-select__title">\n\t\t\t\t\t\tObviously Manage members\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="content-header-select__item">\n\t\t\t\t<div class="content-header-select__counter">\n\t\t\t\t\t\t{{ vm.selectedExperts.length }} selected\n\t\t\t\t</div>\n\t\t</div>\n</div>\n\n<div class="content content_fixed-height" ng-if="vm.membersExpanded">\n\n\t\t<section class="sub-filter">\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<cmnt-profile-ordering ordering="vm.ordering" on-ordering-changed="vm.orderingChanged(newValues)">\n\t\t\t\t\t\t</cmnt-profile-ordering>\n\n\t\t\t\t\t\t<label class="checkbox checkbox_color-gray" ng-if="authGlobals.loggedIn">\n\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.showSavedOnly"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.showSavedOnlyChanged()"/>\n\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t<span class="checkbox__title">My saved experts only</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<a href class="sub-filter-pane__link" ng-click="vm.unselectAllExperts()"\n\t\t\t\t\t\t\t ng-if="vm.selectedExperts.length > 0">Clear Selection</a>\n\t\t\t\t</div>\n\t\t</section>\n\n\t\t<div class="experts-grid" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t ng-if="!vm.ProfilesList.dataChange"\n\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.profiles.$resolved">\n\t\t\t\t<cmnt-expert-profile\n\t\t\t\t\t\t\t\tprofile="profile"\n\t\t\t\t\t\t\t\textra-class="experts-grid__item expert_animated"\n\t\t\t\t\t\t\t\ton-selection-change="vm.profileSelectionChanged(profile)"\n\t\t\t\t\t\t\t\ton-before-selection-change="vm.onBeforeSelectionChanged(profile)"\n\t\t\t\t\t\t\t\tactive-jurisdictions="vm.defining"\n\t\t\t\t\t\t\t\tactive-target="vm.targetJurisdiction"\n\t\t\t\t\t\t\t\tis-read-only="::vm.currentUser.is_read_only"\n\t\t\t\t\t\t\t\tng-repeat="profile in vm.profiles">\n\t\t\t\t</cmnt-expert-profile>\n\n\t\t\t\t<cmnt-join-prompt class="experts-grid__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.profiles.$resolved && !authGlobals.loggedIn"></cmnt-join-prompt>\n\t\t</div>\n\n\t\t<cmnt-loading-indicator class="loading-indicator_align-center" resource="vm.loadingMore"></cmnt-loading-indicator>\n\n\t\t<div class="experts-grid experts-grid_fade-in enable-animations" ng-if="vm.ProfilesList.dataChange">\n\t\t\t\t<cmnt-expert-placeholder checkbox="true" ng-repeat="i in [1,2,3,4,5,6,7,8,9,10]">\n\t\t\t\t</cmnt-expert-placeholder>\n\t\t</div>\n\n\t\t<cmnt-empty-result resource="vm.profiles" title="No experts to show">\n\t\t\t\tChange your filtering criteria to reveal existing cases\n\t\t</cmnt-empty-result>\n</div>\n');
$templateCache.put('experts/profileFilters.directive.html','<div ng-class="vm.extraClass">\n\t\t<div class="select select_theme_gray select_size_s select_width_180 filter__select">\n\t\t\t\t<label class="select__label">IP Type</label>\n\t\t\t\t<ui-select ng-model="vm.matterType" name=\'matterType\' ng-change="vm.matterTypeChanged()"\n\t\t\t\t\t\t\t\t\t id="profileFilters-matterType">\n\t\t\t\t\t\t<ui-select-match allow-clear="{{vm.allowClear}}" placeholder="Select">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.title"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices repeat="matterType.id as matterType in vm.matterTypes|filter:{title:$select.search}">\n\t\t\t\t\t\t\t\t<span ng-bind-html="matterType.title | highlight: $select.search"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t<!--ui-select-no-choice>\n\t\t\t\t\t\t\t\t<ng-include src="\'core/uihelpers/valueDropdownNoChoice.html\'"></ng-include>\n\t\t\t\t\t\t</ui-select-no-choice-->\n\t\t\t\t</ui-select>\n\t\t</div>\n\n\t\t<div class="select select_theme_gray select_size_s select_width_150 filter__select">\n\t\t\t\t<label class="select__label">Practices in</label>\n\t\t\t\t<ui-select ng-model="vm.defining" name=\'defining\' ng-disabled="!vm.matterType"\n\t\t\t\t\t\t\t\t\t ng-change="vm.processFiltersChange()" id="profileFilters-defining">\n\t\t\t\t\t\t<ui-select-match allow-clear="{{vm.allowClear}}" placeholder="Select">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices repeat="defining.id as defining in vm.definings|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t<span ng-bind-html="defining.value | highlight: $select.search"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t<!--ui-select-no-choice>\n\t\t\t\t\t\t\t\t<ng-include src="\'core/uihelpers/valueDropdownNoChoice.html\'"></ng-include>\n\t\t\t\t\t\t</ui-select-no-choice-->\n\t\t\t\t</ui-select>\n\t\t</div>\n\n\t\t<div class="select select_theme_gray select_size_s select_width_150 filter__select">\n\t\t\t\t<label class="select__label">Sends cases to</label>\n\t\t\t\t<ui-select ng-model="vm.targetJurisdiction" name=\'targetJurisdiction\' ng-disabled="!vm.matterType"\n\t\t\t\t\t\t\t\t\t ng-change="vm.processFiltersChange()" id="profileFilters-targetJurisdiction">\n\t\t\t\t\t\t<ui-select-match allow-clear="{{vm.allowClear}}" placeholder="Select">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices repeat="defining.id as defining in vm.targetJurisdictions|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t<span ng-bind-html="defining.value | highlight: $select.search"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t</ui-select>\n\t\t</div>\n\t\t<!--div class="select select_theme_gray select_size_s select_width_250 filter__select">\n\t\t\t\t<label class="select__label">Service</label>\n\t\t\t\t<ui-select ng-model="vm.expertiseType" name=\'expertiseType\' ng-disabled="!vm.matterType"\n\t\t\t\t\t\t\t\t\t ng-change="vm.processFiltersChange()" id="profileFilters-expertiseType">\n\t\t\t\t\t\t<ui-select-match allow-clear="{{vm.allowClear}}" placeholder="Select">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\trepeat="expertiseType.id as expertiseType in vm.expertiseTypes|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t<span ng-bind-html="expertiseType.value | highlight: $select.search"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t</ui-select-->\n</div>\n</div>\n');
$templateCache.put('experts/profileOrdering.directive.html','<div class="select select_theme_gray select_without-border select_size_s select_fixed-width_160 sub-filter__select select_icon-mode">\n\t\t<i class="select__icon icon icon-filter"></i>\n\t\t<ui-select ng-model="vm.ordering" search-enabled="false" ng-change="vm.orderingChanges()">\n\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t</ui-select-match>\n\t\t\t\t<ui-select-choices repeat="orderingOption.value as orderingOption in vm.orderingOptions">\n\t\t\t\t\t\t<span ng-bind="orderingOption.label"></span>\n\t\t\t\t</ui-select-choices>\n\t\t</ui-select>\n</div>\n');
$templateCache.put('grow/growNetwork.html','<section class="promo" ng-if="!authGlobals.loggedIn">\n\t\t<div class="promo__content">\n\t\t\t\t<h1 class="promo__title">Get more work</h1>\n\t\t\t\t<h2 class="promo__subtitle">Identify growth opportunities in other jurisdictions</h2>\n\t\t</div>\n</section>\n\n<div class="grow">\n\t\t<div class="grow-wrapper">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="grow-header">\n\t\t\t\t\t\t\t\t<h3 class="grow-header__title">The easiest way to grow your practice</h3>\n\t\t\t\t\t\t\t\t<div class="grow-header-score">\n\t\t\t\t\t\t\t\t\t\t<div class="grow-header-score__boost" ng-if="authGlobals.loggedIn">\n\t\t\t\t\t\t\t\t\t\t\t\tHow to<br/><a href ng-click="vm.openBoostModal()">boost your community score</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="grow-header-score__boost" ng-if="!authGlobals.loggedIn">\n\t\t\t\t\t\t\t\t\t\t\t\tHow to<br/><a>boost your community score</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="grow-header-score__value">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-heart grow-header-score__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.profile.community_score || 0 }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<label class="grow__label">Each of these activities increase your community score. It\u2019s the best way to get\n\t\t\t\t\t\t\t\tnoticed in the community and to receive more work.</label>\n\t\t\t\t\t\t<div class="grow-forms">\n\t\t\t\t\t\t\t\t<div class="grow-form">\n\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header__number">1</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header__title">Start discussing a case</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="heart-score heart-score_color-green grow-form-header__heart">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t+ <span class="heart-score__value">{{ ::vm.ScoreAction.INSTRUCTIONS_SENT }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-heart heart-score__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<p class="grow-form__text">Community members are 84% more likely to receive reciprocal work if they\n\t\t\t\t\t\t\t\t\t\t\t\tsend a case to a firm</p>\n\t\t\t\t\t\t\t\t\t\t<form class="grow-form__fields" cmnt-handle-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_placeholder-i login__select"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">IP Type</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.matterType" ng-change="vm.matterTypeChanged()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.title"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="matterType.id as matterType in vm.matterTypes|filter:{title:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="matterType.title | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_placeholder-i login__select grow-form__select"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Jurisdiction</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.defining" ng-disabled="!vm.matterType">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="defining.id as defining in vm.definings|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="defining.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button ng-click="vm.startNewCase()" ng-disabled="!vm.matterType || !vm.defining"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_color_blue grow-form__button">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-cases"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tStart a new case\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="grow-form">\n\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header__number">2</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header__title">Invite IP firms to Obviously Manage</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="heart-score heart-score_color-green grow-form-header__heart">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t+ <span class="heart-score__value">{{ ::vm.ScoreAction.REFERRAL }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-heart heart-score__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<p class="grow-form__text">Expanding your network of experts in other jurisdictions makes you more\n\t\t\t\t\t\t\t\t\t\t\t\tlikely to receive work</p>\n\t\t\t\t\t\t\t\t\t\t<form class="grow-form__fields" cmnt-handle-errors name="referAttorneyForm">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">IP attorney\u2019s email</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder" type="text" placeholder="email"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="email" ng-model="vm.attorneyEmail" style=""/>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button cmnt-spinner-action="vm.referAttorney(referAttorneyForm)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_color_blue grow-form__button">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-email"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tInvite IP attorneys\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="grow-form">\n\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header__number">3</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-form-header__title">Add your team members</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="heart-score heart-score_color-green grow-form-header__heart">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t+ <span class="heart-score__value">{{ ::vm.ScoreAction.MEMBER_JOINED }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-heart heart-score__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<p class="grow-form__text">With your team set up on Obviously Manage, it\u2019s easy to manage the work in one\n\t\t\t\t\t\t\t\t\t\t\t\tplace.</p>\n\t\t\t\t\t\t\t\t\t\t<form class="grow-form__fields" cmnt-handle-errors name="inviteMemberForm">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_border field_placeholder-i"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Colleague\u2019s email</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text  field__text_light-palceholder" type="text" placeholder="email"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="email"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.memberEmail">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button cmnt-spinner-action="vm.inviteMember(inviteMemberForm)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_color_blue grow-form__button">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-experts"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd to your team\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<!--div class="grow-result">\n\t\t\t\t<div class="grow-form-header grow-result__header">\n\t\t\t\t\t\t<div class="grow-form-header__number">4</div>\n\t\t\t\t\t\t<div class="grow-form-header__title">Work on an upcoming case</div>\n\t\t\t\t\t\t<div class="grow-form-header__score">\n\t\t\t\t\t\t\t\t<div class="heart-score heart-score_color-green">\n\t\t\t\t\t\t\t\t\t\t+ <span class="heart-score__value">{{ ::vm.ScoreAction.INSTRUCTIONS_SENT }}</span>\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-heart heart-score__icon"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="grow-result-search">\n\t\t\t\t\t\t<div class="grow-result-search__title">Find your upcoming cases, or cases you\u2019d like to take on.</div>\n\t\t\t\t\t\t<div class="grow-result-search__form">\n\t\t\t\t\t\t\t\t<form class="field-group-flex">\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s grow-result-search__select select_theme_gray" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Search by</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.searchField" search-enabled="false">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="searchField.value as searchField in vm.searchFields">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="searchField.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_m field_theme_gray field_placeholder-i grow-result-search__field" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Containing</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder" type="text" ng-model="vm.query"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="E.g. company name, attorney, inventor, application number...">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue grow-result-search__button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.pctSearch()" ng-disabled="!vm.query || vm.requestInProgress">\n\t\t\t\t\t\t\t\t\t\t\t\t<i ng-if="!vm.requestInProgress" class="button__icon icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<i ng-if="vm.requestInProgress" class="button__icon icon icon-spinner icon-spin6"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tSearch\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<div class="grow-result-search__pane">\n\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_without-border select_size_s select_width_150 sub-filter__select select_icon-mode">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="select__icon icon icon-filter"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.ordering" search-enabled="false" ng-change="vm.orderingChanged()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="orderingOption.value as orderingOption in vm.orderingOptions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="orderingOption.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="grow-result__list" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false"\n\t\t\t\t\t\t infinite-scroll-disabled="!vm.results.$resolved || !vm.pagination.moreObjectsAvailable">\n\t\t\t\t\t\t<div class="grow-result-item" ng-repeat="result in vm.results" ng-click="vm.newCaseFromSearchResult(result)">\n\t\t\t\t\t\t\t\t<div class="grow-result-item-header">\n\t\t\t\t\t\t\t\t\t\t<h3 class="grow-result-item-header__title">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon-cases icon grow-result-item-header__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ ::result.title }}\n\t\t\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t\t\t<div class="heart-score heart-score_color-green">\n\t\t\t\t\t\t\t\t\t\t\t\t+ <span class="heart-score__value">{{ ::vm.ScoreAction.INSTRUCTIONS_SENT }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-heart heart-score__icon"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="grow-result-item-body">\n\t\t\t\t\t\t\t\t\t\t<div class="grow-result-item-body__title">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-result-item-body__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::result.pct_number }} (Published: {{ ::result.publication_date|cmntCustomDateFormat:"DD MMM YYYY" }})\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-result-item-body__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::result.deadline.date|cmntCustomDateFormat:"DD MMM YYYY" }}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="grow-result-item-body-pct">\n\t\t\t\t\t\t\t\t\t\t\t\t<ul class="grow-result-item-body-pct-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="grow-result-item-body-pct-list__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="applicant in ::result[\'applicants\']">{{ ::applicant.name }}</li>\n\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="grow-result-item-body-pct__time">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::result.deadline.days }} days {{ ::result.deadline.expired ? \'ago\' : \'\' }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-timer grow-result-item-body-pct__timer-ico"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="grow-result-item-footer">\n\t\t\t\t\t\t\t\t\t\t<ul class="grow-result-item-footer-company">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="grow-result-item-footer-company__item" ng-repeat="agent in ::result[\'agents\']">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-build grow-result-item-footer-company__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::agent.name }}\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t<a class="grow-result-item-footer-view">\n\t\t\t\t\t\t\t\t\t\t\t\tStart a new case\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-arrow-right grow-result-item-footer-view__icon"></i>\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<cmnt-loading-indicator resource="vm.results" ng-if="!vm.results.$initial"></cmnt-loading-indicator>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="grow-result-try-search" ng-if="!vm.results">\n\t\t\t\t\t\t<h3 class="grow-result-try-search__title">Try searching for:</h3>\n\t\t\t\t\t\t<ul class="grow-result-try-search__list">\n\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">Your firm</li>\n\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">The representing attorney</li>\n\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">The client</li>\n\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">Words in the case title</li>\n\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">PCT or WO number</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-empty-result resource="vm.results" title="No results">\n\t\t\t\t</cmnt-empty-result>\n\t\t</div-->\n</div>\n');
$templateCache.put('grow/pctSearch.html','<div class="search">\n\t\t<div class="search__header">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<h3 class="search__title">Search</h3>\n\t\t\t\t\t\t<form class="field-group-flex">\n\t\t\t\t\t\t\t\t<div class="field field_size_s grow-result-search__select select_theme_gray" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Search by</label>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.searchField" search-enabled="false">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="searchField.value as searchField in vm.searchFields">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="searchField.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field_size_m field_theme_gray field_placeholder-i search__field" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Containing</label>\n\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder" type="text" ng-model="vm.query"\n\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="E.g. company name, attorney, inventor, application number...">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue search__button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.pctSearch()" ng-disabled="!vm.query || vm.requestInProgress">\n\t\t\t\t\t\t\t\t\t\t<i ng-if="!vm.requestInProgress" class="button__icon icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t<i ng-if="vm.requestInProgress" class="button__icon icon icon-spinner icon-spin6"></i>\n\t\t\t\t\t\t\t\t\t\tSearch\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="content search__result">\n\t\t\t\t<section class="sub-filter">\n\t\t\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-gray" ng-if="authGlobals.loggedIn">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.showSaved"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.showSavedChanged()"/>\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">Show families I\u2019ve already saved to my IP</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_without-border select_size_s select_fixed-width_160 sub-filter__select select_icon-mode">\n\t\t\t\t\t\t\t\t\t\t<i class="select__icon icon icon-filter"></i>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.ordering" search-enabled="false" ng-change="vm.orderingChanged()">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="orderingOption.value as orderingOption in vm.orderingOptions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="orderingOption.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<div class="families" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false"\n\t\t\t\t\t\t infinite-scroll-disabled="!vm.results.$resolved || !vm.pagination.moreObjectsAvailable">\n\t\t\t\t\t\t<div class="family families__family" ng-repeat="family in vm.results">\n\t\t\t\t\t\t\t\t<div class="family-header family-header_align-stretch">\n\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-header__label">{{ ::family.matter_type }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="family-header__title">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::family.title }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--a ng-href="{{ ::family.link }}" target="_blank" class="family-header__title-link">VIEW</a-->\n\t\t\t\t\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.inventors">\n                            <span tooltip="{{ ::(family.inventors|cmntContactsListFormat) }}">\n                                <i class="icon icon-inventor family-header__title-icon"></i>{{ ::family.inventors[0] }}\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.applicants">\n                            <span tooltip="{{ ::(family.applicants|cmntContactsListFormat) }}">\n                                <i class="icon icon-build family-header__title-icon"></i>{{ ::family.applicants[0] }}\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane family-header__pane_right">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="family__action family__action_shift" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="!family.is_family_saved"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tid="{{ \'saveFamily-\' + $index }}" cmnt-spinner-action="vm.createFamily(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSave to my IP\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-header__save" ng-if="family.is_family_saved">\n                            <span class="family__action family__action_saved family__action_shift">\n                                <i class="icon icon-confirm icon-margin-right"></i>\n                                Saved\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--button class="family__action">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tView\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-arrow-right icon-margin-left"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button-->\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<!--<button class="icon icon-menu family-header__drop"></button>-->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="family-body">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member" ng-repeat="familyMember in ::family.members">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n                                <span class="family-member-jurisdiction__icon">\n                                    <i class="flag32"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::\'flag32-\' + familyMember.defining_code.toLowerCase()"></i>\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.defining }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href class="family-member-jurisdiction__label-espacenet-link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-href="https://worldwide.espacenet.com/searchResults?query={{ ::familyMember.number }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t target="_blank"><i class="icon icon-espacenet"></i></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{ ::familyMember.type }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{ ::familyMember.number }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label family-member-jurisdiction__label_light">on</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t::familyMember.filing_date|cmntCustomDateFormat:"DD MMM YYYY" }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item">{{ ::familyMember.status }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="icon icon-timer-clock family-member-status__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::familyMember.deadline_date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.deadline_date|cmntCustomDateFormat:"DD MMM YYYY" }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="icon icon-timer-clock family-member-status__item family-member-status__item_disabled"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::!familyMember.deadline_date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNo deadline\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<cmnt-loading-indicator resource="vm.results" ng-if="!vm.results.$initial"></cmnt-loading-indicator>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="search-placeholders">\n\t\t\t\t\t\t<!--div class="search-placeholders__empty">No IP to show</div-->\n\t\t\t\t\t\t<div class="grow-result-try-search" ng-if="vm.results.$resolved && vm.results.length == 0">\n\t\t\t\t\t\t\t\t<h3 class="grow-result-try-search__title">No matches found</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="grow-result-try-search" ng-if="!vm.results">\n\t\t\t\t\t\t\t\t<h3 class="grow-result-try-search__title">Try searching for:</h3>\n\t\t\t\t\t\t\t\t<ul class="grow-result-try-search__list">\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">Your firm</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">The representing attorney</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">The client</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">Words in the case title</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">PCT or WO number</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('grow/pctSearchHeader.html','<div class="sub-header">\n\t\t<div class="content">\n\t\t\t\t<a href class="sub-header-back" ng-click="Navigation.back()">\n\t\t\t\t\t\t<i class="sub-header-back__icon icon icon-arrow-left"></i>\n\t\t\t\t</a>\n\t\t\t\t<h2 class="sub-header__title">Find my existing intellectual property</h2>\n\t\t\t\t<a class="button button_size_s button_color_blue sub-header__button" ui-sref="community.ip.families">\n\t\t\t\t\t\t<i class="button__icon icon icon-light"></i>\n\t\t\t\t\t\tView my IP\n\t\t\t\t</a>\n\t\t</div>\n</div>\n');
$templateCache.put('grow/trademarkPane.directive.html','<div class="family families__family">\n\t\t<div class="family-header family-header_align-stretch">\n\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t<label class="family-header__label">{{ ::vm.item.matter_type }}</label>\n\t\t\t\t\t\t<h3 class="family-header__title">\n\t\t\t\t\t\t\t\t{{ ::(vm.item.title || "No text in this mark" ) }}\n\t\t\t\t\t\t\t\t<!--a ng-href="{{ ::vm.item.link }}" target="_blank" class="family-header__title-link">VIEW</a-->\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::vm.item.applicant">\n\t\t\t\t\t\t\t\t<i class="icon icon-build family-header__title-icon"></i>{{ ::vm.item.applicant }}\n\t\t\t\t\t\t</h5>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="family-header__pane family-header__pane_right">\n\t\t\t\t\t\t<button class="family__action family__action_shift" type="button" ng-if="!vm.item.is_family_saved"\n\t\t\t\t\t\t\t\t\t\tid="{{ \'saveFamily-\' + $index }}" cmnt-spinner-action="vm.createFamily()">\n\t\t\t\t\t\t\t\t<i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\tSave to my IP\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<div class="family-header__save" ng-if="vm.item.is_family_saved">\n                <span class="family__action family__action_saved family__action_shift">\n                    <i class="icon icon-confirm icon-margin-right"></i>\n                    Saved\n                </span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="family-body">\n\t\t\t\t<div class="family-member family-member_trademark">\n\t\t\t\t\t\t<div ng-if="vm.item.image_url" class="family-member__image">\n\t\t\t\t\t\t\t\t<img ng-src="{{ vm.item.image_url }}">\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="family-member__header" style="width: 100%; margin-right: 14px;">\n\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n                    <span class="family-member-jurisdiction__icon">\n                        <i class="flag32" ng-class="::vm.flagClass"></i>\n                    </span>\n\n\t\t\t\t\t\t\t\t\t\t{{ ::vm.item.defining }}\n\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{ ::vm.item.kind_mark }}</label>\n\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{ ::vm.item.application_number }}</label>\n\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label family-member-jurisdiction__label_light">on</label>\n\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{\n\t\t\t\t\t\t\t\t\t\t\t\t::vm.item.application_date|cmntCustomDateFormat:"DD MMM YYYY" }}</label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item">{{ ::vm.item.status }}</div>\n\t\t\t\t\t\t\t\t\t\t<!--div class="icon icon-timer-clock family-member-status__item family-member-status__item_disabled">\n\t\t\t\t\t\t\t\t\t\t\t\tNo deadline\n\t\t\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('grow/trademarkSearch.html','<div class="search">\n\t\t<div class="search__header">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<h3 class="search__title">Search</h3>\n\t\t\t\t\t\t<form class="field-group-flex">\n\t\t\t\t\t\t\t\t<div class="field field_size_m field_theme_gray field_placeholder-i search__field" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Containing</label>\n\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder" type="text" ng-model="vm.query"\n\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="Company name">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue search__button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.pctSearch()" ng-disabled="!vm.query || vm.requestInProgress">\n\t\t\t\t\t\t\t\t\t\t<i ng-if="!vm.requestInProgress" class="button__icon icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t<i ng-if="vm.requestInProgress" class="button__icon icon icon-spinner icon-spin6"></i>\n\t\t\t\t\t\t\t\t\t\tSearch\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="content search__result">\n\t\t\t\t<section class="sub-filter"></section>\n\n\t\t\t\t<div class="families" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false"\n\t\t\t\t\t\t infinite-scroll-disabled="!vm.results.$resolved || !vm.pagination.moreObjectsAvailable">\n\n\t\t\t\t\t\t<cmnt-trademark-pane item="searchResult" ng-repeat="searchResult in vm.results"></cmnt-trademark-pane>\n\n\t\t\t\t\t\t<cmnt-loading-indicator resource="vm.results" ng-if="!vm.results.$initial"></cmnt-loading-indicator>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="search-placeholders">\n\t\t\t\t\t\t<!--div class="search-placeholders__empty">No IP to show</div-->\n\t\t\t\t\t\t<div class="grow-result-try-search" ng-if="vm.results.$resolved && vm.results.length == 0">\n\t\t\t\t\t\t\t\t<h3 class="grow-result-try-search__title">No matches found</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="grow-result-try-search" ng-if="!vm.results">\n\t\t\t\t\t\t\t\t<h3 class="grow-result-try-search__title">Try searching for:</h3>\n\t\t\t\t\t\t\t\t<ul class="grow-result-try-search__list">\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">Your firm</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">The representing attorney</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">The client</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">Words in the case title</li>\n\t\t\t\t\t\t\t\t\t\t<li class="grow-result-try-search__item">PCT or WO number</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/ip.html','<!--div class="header-tabs ip__header-tabs">\n    <div class="ip-content">\n        <button class="header-tabs__tab" ui-sref="community.ip.families" ui-sref-active="header-tabs__tab_active">\n            Assets\n        </button>\n\n        <button class="header-tabs__tab" ui-sref="community.ip.tasks" ui-sref-active="header-tabs__tab_active">\n            To-do\n        </button>\n\n        <button class="header-tabs__tab" ui-sref="community.ip.familiesBudget" ui-sref-active="header-tabs__tab_active">\n            Budget\n        </button>\n\n        <button class="header-tabs__tab" ui-sref="community.ip.report" ui-sref-active="header-tabs__tab_active">\n            IP Report\n        </button>\n    </div>\n</div-->\n\n<ui-view></ui-view>');
$templateCache.put('landing/fullReport.modal.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title">Request full IP report</h2>\n\t\t</div>\n\n\t\t<form cmnt-handle-errors>\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\n\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t<div class="field-group field-group_icon">\n\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-profile"></i>\n\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="First name" ng-model="vm.first_name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="first_name">\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Last name" ng-model="vm.last_name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="last_name">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field_icon field_size_s field_border form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-build"></i>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Company</label>\n\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" ng-model="vm.company_name" name="company_name">\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="field field_icon field_size_s field_border form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-email"></i>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Email</label>\n\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" ng-model="vm.email" name="email">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" cmnt-submit ng-click=\'vm.requestReport()\'\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-gtag-click="gtagIpReport">OK\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>CANCEL\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('landing/landing_widget.html','<section class="key-ip key-ip_v2">\n\t\t<div class="content-container">\n\t\t\t\t<form class="chat-lp-form">\n\t\t\t\t\t\t<label class="chat-lp-form__title">Get instant patent information</label>\n\t\t\t\t\t\t<div class="chat-lp-form__pane">\n\t\t\t\t\t\t\t\t<div class="field field_size_x field_theme_blue-border field_italic">\n\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_static field__text_light-palceholder"\n\t\t\t\t\t\t\t\t\t\t\t\t\t type="text" placeholder="My company name" ng-model="vm.state.searchQuery"\n\t\t\t\t\t\t\t\t\t\t\t\t\t id="searchbox" ng-keyup="vm.acApplicants($event)" autocomplete="off"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'field__text_autocomplete\': vm.applicants && vm.applicants.length!==0}">\n\t\t\t\t\t\t\t\t\t\t<ul class="field__autocomplete-list field__autocomplete-list_active"\n\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.applicants && vm.applicants.length!==0" id="ac-applicants">\n\t\t\t\t\t\t\t\t\t\t\t\t<li ng-repeat="applicant in vm.applicants track by $index"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.setSearchQuery(applicant)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-gtag-click="gtagCmntSearch">{{ ::applicant }}\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="button button_landing button_size_x button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.search()"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_not-allowed\': !vm.state.searchQuery}"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!vm.state.searchQuery"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-gtag-click="gtagCmntSearch">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search" ng-if="!vm.searchInProgress"></i>\n\t\t\t\t\t\t\t\t\t\tSearch for my IP\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t</div>\n</section>\n\n<section class="chat-lp" ng-if="vm.isSearchQueryDone" id="search-results">\n\t\t<div class="content-element content-element_widget-facts">\n\t\t\t\t<div class="content-element__facts content-element__facts_static"\n\t\t\t\t\t\t ng-if="vm.hasResults && vm.families.length !== 0">\n\t\t\t\t\t\t<span class="content-element__facts-text"><b>Interesting Facts</b> about <b>{{ vm.companyName }}</b></span>\n\t\t\t\t\t\t<br>\n\t\t\t\t\t\t<br>\n\t\t\t\t\t\t<span class="content-element__facts-text">{{ vm.applicantStat.families }} Patent Families</span>\n\t\t\t\t\t\t<br>\n\t\t\t\t\t\t<span class="content-element__facts-text">{{ vm.applicantStat.scraped_count }} Individual Patents</span>\n\n\t\t\t\t\t\t<p class="content-element__facts-text"\n\t\t\t\t\t\t\t ng-if-start="vm.applicantStat.countries && vm.applicantStat.countries.length > 0">\n\t\t\t\t\t\t\t\t<b tooltip-append-to-body="true" tooltip-placement="right"\n\t\t\t\t\t\t\t\t\t tooltip-html-unsafe="{{ ::(vm.applicantStat.countries|cmntFactsListFormat:\'repr\') }}">Main\n\t\t\t\t\t\t\t\t\t\tcountries:</b>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<ul class="fact-list" ng-if-end>\n\t\t\t\t\t\t\t\t<li class="fact-list__item" ng-repeat="country in ::vm.applicantStat.countries|limitTo:5">\n                    <span class="fact-list__icon">\n                        <i class="flag32" ng-class="::\'flag32-\' + country.key.toLowerCase()"></i>\n                    </span>\n\t\t\t\t\t\t\t\t\t\t<span class="fact-list__item-count">{{ ::country.doc_count }}</span>\n\t\t\t\t\t\t\t\t\t\t<span class=" fact-list__item-value">{{ ::country.repr }}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t<p class="content-element__facts-text"\n\t\t\t\t\t\t\t ng-if-start="vm.applicantStat.inventors && vm.applicantStat.inventors.length > 0">\n\t\t\t\t\t\t\t\t<b tooltip-append-to-body="true" tooltip-placement="right"\n\t\t\t\t\t\t\t\t\t tooltip-html-unsafe="{{ ::(vm.applicantStat.inventors|cmntFactsListFormat:\'key\') }}">Main\n\t\t\t\t\t\t\t\t\t\tinventors:</b>\n\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t<ul class="fact-list" ng-if-end>\n\t\t\t\t\t\t\t\t<li class="fact-list__item" ng-repeat="inventor in ::vm.applicantStat.inventors|limitTo:5">\n\t\t\t\t\t\t\t\t\t\t<span class="fact-list__item-count">{{ ::inventor.doc_count }}</span>\n\t\t\t\t\t\t\t\t\t\t<span class="fact-list__item-value">{{ ::inventor.key }}</span>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<main class="main-content">\n\t\t\t\t<!-- Has results -->\n\t\t\t\t<section class="content-element content-element_widget-families"\n\t\t\t\t\t\t\t\t ng-if="vm.hasResults && vm.families.length !== 0">\n\t\t\t\t\t\t<div class="content-container content-container_widget">\n\t\t\t\t\t\t\t\t<div class="family content-element__family content-element__family_widget"\n\t\t\t\t\t\t\t\t\t\t ng-repeat="family in vm.families">\n\t\t\t\t\t\t\t\t\t\t<div class="family-header family-header_align-stretch">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-header__label">{{ ::family.matter_type }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="family-header__title">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::family.title }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.inventors">\n                                <span tooltip="{{ ::(family.inventors|cmntContactsListFormat) }}">\n                                    <i class="icon icon-inventor family-header__title-icon"></i>{{ ::family.inventors[0] }}\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.applicants">\n                                <span tooltip="{{ ::(family.applicants|cmntContactsListFormat) }}">\n                                    <i class="icon icon-build family-header__title-icon"></i>{{ ::family.applicants[0] }}\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane family-header__pane_right">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="family__action family__action_shift" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.requestFullReport()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMore Info\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-body">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member" ng-repeat="familyMember in ::family.members">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n                                    <span class="family-member-jurisdiction__icon">\n                                        <i class="flag32"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::\'flag32-\' + familyMember.defining_code.toLowerCase()"></i>\n                                    </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.defining }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href class="family-member-jurisdiction__label-espacenet-link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-href="https://worldwide.espacenet.com/searchResults?query={{ ::familyMember.number }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t target="_blank"><i class="icon icon-espacenet"></i></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{ ::familyMember.type }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{ ::familyMember.number }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label family-member-jurisdiction__label_light">on</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t::familyMember.filing_date|cmntCustomDateFormat:"DD MMM YYYY" }}</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="family__action" type="button" ng-click="vm.requestFullReport()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMore Info\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="content-element__family-load-more content-element__family-load-more_widget"\n\t\t\t\t\t\t\t\t\t\t ng-if="vm.families.$resolved && vm.pagination.moreObjectsAvailable">\n\t\t\t\t\t\t\t\t\t\t<button type="button" cmnt-spinner-action="vm.loadMore()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_s button_color_blue">Load More\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<section class="content-element-upcoming" ng-if-start="vm.hasDeadlines">\n\t\t\t\t\t\t<div class="content-container">\n\t\t\t\t\t\t\t\t<div class="content-element__content">\n\t\t\t\t\t\t\t\t\t\t<h3 class="content-element__content-title">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>SOME UPCOMING ACTIVITIES</span>\n\t\t\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t\t\t<div class="content-element__content-text">\n\t\t\t\t\t\t\t\t\t\t\t\tHere are your important upcoming activities and what they should cost to complete\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t\t<section class="content-element" ng-if-end>\n\t\t\t\t\t\t<div class="content-container">\n\t\t\t\t\t\t\t\t<div class="content-element__table content-table content-table_columns_4">\n\t\t\t\t\t\t\t\t\t\t<div class="content-table__thead">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h2>Patent</h2>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">To do</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tShould cost\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ng-include src="\'landing/shouldCostPopover.html\'"></ng-include>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">Deadline</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="content-table__bg">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tbody">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr" ng-if="vm.national_report !== null"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-repeat="priceData in vm.national_report.report.prices">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::vm.national_report.family.members[0].number }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>National phase - {{ ::priceData.country }}</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-price-data price-data="priceData"></cmnt-price-data>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t::vm.national_report.family.first_deadline|cmntCustomDateFormat:"DD MMM YYYY" }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--div class="content-table__tr" ng-if="vm.national_report !== null">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td content-table__td_total">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="loading-data" ng-if="!vm.national_report.report.$total.hasTotal">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="loading-data__icon icon icon-loading"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="loading-data__text">Calculating total...</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="vm.national_report.report.$total.hasTotal">{{ ::vm.national_report.report.$total.symbol }}{{ ::vm.national_report.report.$total.price }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div-->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr" ng-if="vm.validation_report !== null"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-repeat="priceData in vm.validation_report.report.prices">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::vm.validation_report.report.validation_data.number }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>Validation - {{ ::priceData.country }}</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-price-data price-data="priceData"></cmnt-price-data>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t::vm.validation_report.report.validation_data.validation_date|cmntCustomDateFormat:"DD;\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tMMM; YYYY;" }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--div class="content-table__tr" ng-if="vm.validation_report !== null">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td content-table__td_total">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="loading-data" ng-if="!vm.validation_report.report.$total.hasTotal">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="loading-data__icon icon icon-loading"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="loading-data__text">Calculating total...</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="vm.validation_report.report.$total.hasTotal">{{ ::vm.validation_report.report.$total.symbol }}{{ ::vm.validation_report.report.$total.price }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<h2>All upcoming activities</h2>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tbody content-table__tbody_blur">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__overlay">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__overlay-title">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tFor next steps and detailed costing\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_landing button_size_x button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.requestFullReport()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-file-1"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tRequest full IP report\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEP1972178\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>File a trademark in 2 classes in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">19 Dec 2018</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEP1972178\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>File a trademark in 2 classes in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">19 Dec 2018</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEP1972178\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>File a trademark in 2 classes in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">19 Dec 2018</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEP1972178\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>File a trademark in 2 classes in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">19 Dec 2018</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEP1972178\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>File a trademark in 2 classes in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">19 Dec 2018</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t\t<!-- End has results -->\n\n\n\t\t\t\t<!-- No results -->\n\t\t\t\t<section class="content-element" ng-if-start="!vm.hasResults">\n\t\t\t\t\t\t<div class="content-container">\n\t\t\t\t\t\t\t\t<div class="content-element__head">\n\t\t\t\t\t\t\t\t\t\t<h2 class="content-element__title">\n\t\t\t\t\t\t\t\t\t\t\t\tMeanwhile,\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t\t<div class="content-element__description">\n\t\t\t\t\t\t\t\t\t\t\t\tHere are some typical costs for maintaining your IP portfolio:\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="content-element__table content-table content-table_columns_3">\n\t\t\t\t\t\t\t\t\t\t<div class="content-table__thead">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">Typical activity</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tShould cost\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ng-include src="\'landing/shouldCostPopover.html\'"></ng-include>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__th">Deadline</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="content-table__bg">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tbody">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>Draft and file a new patent in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">-</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__tr">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<b>File a trademark in 2 classes in the UK</b>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\xA3100\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="content-table__td">-</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<!--div class="content-element__chat">\n\t\t\t\t\t\t\t\t\t\t<button class="button button_landing button_size_s button_color_blue ng-binding ng-scope">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-blog"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tChat about next steps\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<section class="content-element" ng-if-end>\n\t\t\t\t\t\t<div class="content-container">\n\t\t\t\t\t\t\t\t<div class="content-element__head">\n\t\t\t\t\t\t\t\t\t\t<h2 class="content-element__title">\n\t\t\t\t\t\t\t\t\t\t\t\tLet\u2019s find your IP\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t\t<div class="content-element__description">\n\t\t\t\t\t\t\t\t\t\t\t\tAlternatively, we can perform a thorough manual check and email you back with the results.\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<form class="content-element__form chat-lp-form" name="emailForm" cmnt-handle-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="chat-lp-form__title">Email address</label>\n\t\t\t\t\t\t\t\t\t\t<div class="chat-lp-form__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_x field_theme_blue-border field_italic" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_static field__text_light-palceholder" type="text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="email" ng-model="vm.reportEmail">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_landing button_size_x button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.submitReport(vm.reportEmail, emailForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tFind my IP and email me the results\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\t\t\t\t<!-- End no results -->\n\t\t</main>\n</section>\n');
$templateCache.put('landing/priceData.directive.html','<div class="content-table__td">\n\t\t<div class="loading-data" ng-if="vm.state === \'analysing\' || vm.state === \'comparing\'">\n\t\t\t\t<i class="loading-data__icon icon icon-loading"></i>\n\t\t\t\t<div class="loading-data__text" ng-if="vm.state === \'analysing\'">Analysing...</div>\n\t\t\t\t<div class="loading-data__text" ng-if="vm.state === \'comparing\'">Comparing...</div>\n\t\t</div>\n\t\t<span ng-if="vm.state === \'price\'">{{ ::vm.priceData.symbol }}{{ ::(vm.priceData.price || \'N/A\') }}</span>\n</div>\n');
$templateCache.put('landing/shouldCostPopover.html','<div class="message-icon" ng-mouseenter="vm.showCostPopover=true">\n\t\t<i class="icon icon-info"></i>\n\t\t<div class="message-icon__dropdown" ng-if="vm.showCostPopover">\n\t\t\t\t<i class="message-icon__close icon icon-close" ng-click="vm.showCostPopover=false"></i>\n\t\t\t\t<h4>How we calculate \u2018Should cost\u2019</h4>\n\n\t\t\t\t<p>We\u2019re able to compare and benchmark against thousands of similar tasks that are completed on the Obviously Manage\n\t\t\t\t\t\tplatform.</p>\n\n\t\t\t\t<p>This helps you see whether the costs you\u2019re quoted for comparable work are low, high or about right.</p>\n\t\t</div>\n</div>\n');
$templateCache.put('layout/main.html','<header class="header" ui-view="header" cmnt-header>\n\t\t<div class="header__nav">\n\t\t\t\t<nav class="header-nav">\n\t\t\t\t\t\t<a href="/" class="header__logo">\n\t\t\t\t\t\t\t\t<img class="header__logo-image" src="{{ ::conf.staticRoot }}community/images/logo_dark.png" alt=""/>\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<!--<a ui-sref="community.landing" class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active" ng-if="!authGlobals.loggedIn">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-iambic"></i>\n\t\t\t\t\t\t\t\tObviously Manage\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<a ui-sref="community.about" class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-about"></i>\n\t\t\t\t\t\t\t\tAbout\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href="https://blog.pekama.com" target="_blank" class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ng-if-end>\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-blog"></i>\n\t\t\t\t\t\t\t\tBlog\n\t\t\t\t\t\t</a>-->\n\n\t\t\t\t\t\t<a ui-sref="community.ip.projects" ng-if-start="authGlobals.loggedIn"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-light"></i>\n\t\t\t\t\t\t\t\tMy IP\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!--<a ui-sref="community.ip.tasks"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-tasks"></i>\n\t\t\t\t\t\t\t\tTo Do\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a ui-sref="community.projects.projectsList"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-portfolio"></i>\n\t\t\t\t\t\t\t\tInstructions\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a ui-sref="community.ip.familiesBudget"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-budget-1"></i>\n\t\t\t\t\t\t\t\tBudget\n\t\t\t\t\t\t</a>-->\n\t\t\t\t\t\t<a ui-sref="community.reports" ng-if-end\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-cases"></i>\n\t\t\t\t\t\t\t\tReports\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<!-- a ui-sref="community.grow" ng-if="profile.is_active && !currentUser.is_read_only"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active"\n\t\t\t\t\t\t\t ui-sref-opts="{reload: true}">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-grow"></i>\n\t\t\t\t\t\t\t\tGrow\n\t\t\t\t\t\t</a-->\n\t\t\t\t</nav>\n\t\t\t\t<nav class="header-nav">\n\t\t\t\t\t\t<!--div class="ip-attorney" ng-if="!authGlobals.loggedIn">\n\t\t\t\t\t\t\t\t<a href="mailto:ip@pekama.com" target="_blank" class="ip-attorney__link">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-right-open-mini"></i>\n\t\t\t\t\t\t\t\t\t\tip@pekama.com\n\t\t\t\t\t\t\t\t</a-->\n\t\t\t\t\t\t<!--a href="tel:+44(0)1223123456" class="ip-attorney__phone">+44 (0) 1223 123456</a-->\n\t\t\t\t\t\t<!--/div-->\n\n\t\t\t\t\t\t<!--a ui-sref="community.personal" ui-sref-active="header-nav__item_style-active" ng-if-start="authGlobals.loggedIn"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-profile"></i>\n\t\t\t\t\t\t\t\tMe\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a ui-sref="community.experts.expertsList"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link"\n\t\t\t\t\t\t\t ui-sref-active="header-nav__item_style-active"\n\t\t\t\t\t\t\t ui-sref-opts="{reload: true}">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-experts"></i>\n\t\t\t\t\t\t\t\tExperts\n\t\t\t\t\t\t</a-->\n\t\t\t\t\t\t<!--a ui-sref="community.profile" ui-sref-active="header-nav__item_style-active" ng-if="authGlobals.loggedIn"\n\t\t\t\t\t\t\t class="header-nav__item header-nav__item_style-link">\n\t\t\t\t\t\t\t\t<i class="header-nav__item-icon icon icon-build"></i>\n\t\t\t\t\t\t\t\tProfile\n\t\t\t\t\t\t</a-->\n\t\t\t\t\t\t<div class="header__logo header__logo_brand">\n\t\t\t\t\t\t\t\t<img ng-src="{{ ::headerLogo }}" alt=""/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div ng-if="!authGlobals.loggedIn" class="header-nav__item">\n\t\t\t\t\t\t\t\t<a class="button button_landing button_size_s button_color_pink" ui-sref="community.login">Sign In</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div ng-if="authGlobals.loggedIn" class="header-nav__item">\n\t\t\t\t\t\t\t\t<a class="button button_landing button_size_s button_color_pink" ng-click="logOut()">Sign Out</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</nav>\n\t\t</div>\n\t\t<button class="header__nav-toggle" ng-show="authGlobals.loggedIn">\n\t\t\t\t<i class="icon icon-menu"></i>\n\t\t</button>\n</header>\n\n<ui-view ng-hide="authGlobals.showLogin"></ui-view>\n\n<cmnt-sign-in-prompt ng-if="authGlobals.showLogin"></cmnt-sign-in-prompt>\n');
$templateCache.put('login/cmntSignInPrompt.directive.html','<div class="login-height-full">\n    <div class="help-panel">\n        <!--<div class="content">\n                <h2 class="help-panel__title">Join Pekama</h2>\n                <p class="help-panel__text">Pekama starts at a one-off \xA3350 charge for IP firms and \xA31,000 charge for IP\n                        owners (+VAT when applicable). This includes the ability to find and saves the firm\'s IP into its\n                        portal, send work and list its services to other members. For IP owners, get in touch for a discussion\n                        on your IP strategy and how our technology can fit in. This covers getting valuable information about\n                        IP, benchmarking prices in any jurisdiction and managing your patent and trademark cases on Obviously Manage.</p>\n        </div>-->\n    </div>\n    <div class="login">\n        <div class="login-left-pane">\n            <div class="login-left-pane__position" ng-switch="vm.signUpFinished">\n                <h3 class="login__title">Let\'s get you set up</h3>\n\n                <form cmnt-handle-errors name="signUpForm" ng-switch-when="false" class="shake-on-errors">\n                    <cmnt-form-errors></cmnt-form-errors>\n\n                    <div class="field-list login__field-list">\n                        <div class="field-group field-group_icon">\n                            <i class="field__icon field__icon_absolute icon icon-profile"></i>\n                            <label class="field-group__label">Name</label>\n                            <div class="field field_size_s field_width_half" cmnt-field-errors>\n                                <input class="field__text" type="text" placeholder="First" ng-model="vm.firstName"\n                                       name="first_name" cmnt-focus-me="vm.focusSignup">\n                            </div>\n\n                            <div class="field field_size_s field_width_half" cmnt-field-errors>\n                                <input class="field__text" type="text" placeholder="Last" ng-model="vm.lastName"\n                                       name="last_name">\n                            </div>\n                        </div>\n\n                        <div class="field field_icon field_size_s form-group_icon" cmnt-field-errors>\n                            <i class="field__icon field__icon_absolute icon icon-build"></i>\n                            <label class="field__label">Company</label>\n                            <input class="field__text" type="text" ng-model="vm.company" name="company">\n                        </div>\n\n                        <div class="field field_icon field_size_s form-group_icon" cmnt-field-errors>\n                            <i class="field__icon field__icon_absolute icon icon-email"></i>\n                            <label class="field__label">Email</label>\n                            <input class="field__text" type="text" ng-model="vm.newEmail" name="email"\n                                   ng-readonly="vm.isInvitation">\n                        </div>\n\n                        <div class="field field_margin-bottom field_icon field_size_s form-group_icon"\n                             cmnt-field-errors>\n                            <i class="field__icon field__icon_absolute icon icon-security"></i>\n                            <label class="field__label">Choose a password</label>\n                            <input class="field__text" type="password" ng-model="vm.newPassword" name="password"\n                                   autocomplete="new-password">\n\n                            <cmnt-password-strength password="vm.newPassword"></cmnt-password-strength>\n                        </div>\n\n                        <!--<div class="field field_margin-bottom field_icon field_size_s form-group_icon login__select"\n                                 cmnt-field-errors>\n                                <i class="field__icon field__icon_absolute icon icon-carts"></i>\n                                <label class="field__label">Account type</label>\n\n                                <ui-select ng-model="vm.accountType" name="account_type">\n                                        <ui-select-match>\n                                                <span ng-bind="$select.selected.label"></span>\n                                        </ui-select-match>\n                                        <ui-select-choices ui-select-fix\n                                                                             repeat="accountType.value as accountType in vm.accountTypes">\n                                                <span ng-bind="accountType.label"></span>\n                                        </ui-select-choices>\n                                </ui-select>\n                        </div>\n\n                        <div class="field-group field-group_icon">\n                                <div class="field field_size_s field_width_half login__select" cmnt-field-errors>\n                                        <label class="field__label">Business type</label>\n\n                                        <ui-select ng-model="vm.companyType" name="company_type">\n                                                <ui-select-match>\n                                                        <span ng-bind="$select.selected.value"></span>\n                                                </ui-select-match>\n                                                <ui-select-choices ui-select-fix\n                                                                                     repeat="companyType.id as companyType in (vm.companyTypes | filter: $select.search) track by companyType.id">\n                                                        <span ng-bind="companyType.value"></span>\n                                                </ui-select-choices>\n                                        </ui-select>\n                                </div>\n\n                                <div class="field field_size_s field_width_half login__select" cmnt-field-errors>\n                                        <label class="field__label">Your role</label>\n\n                                        <ui-select ng-model="vm.companyRel" name="company_rel">\n                                                <ui-select-match>\n                                                        <span ng-bind="$select.selected.value"></span>\n                                                </ui-select-match>\n                                                <ui-select-choices ui-select-fix\n                                                                                     repeat="companyRel.id as companyRel in (vm.companyRels | filter: $select.search) track by companyRel.id">\n                                                        <span ng-bind="companyRel.value"></span>\n                                                </ui-select-choices>\n                                        </ui-select>\n                                </div>\n                        </div-->\n\n                        <!--div class="field-group field-group_icon">\n                                <div class="field field_size_s field_width_half" cmnt-field-errors>\n                                        <label class="field__label">Phone</label>\n                                        <input class="field__text" type="text" ng-model="vm.phone" name="phone_number">\n                                </div>\n\n                                <div class="field field_width_half login__select" cmnt-field-errors>\n                                        <label class="field__label">Country</label>\n\n                                        <ui-select ng-model="vm.companyCountry" name="company_country">\n                                                <ui-select-match>\n                                                        <span ng-bind="$select.selected.value"></span>\n                                                </ui-select-match>\n                                                <ui-select-choices ui-select-fix\n                                                                                     repeat="country.id as country in vm.countries | filter: $select.search">\n                                                        <span ng-bind="country.value"></span>\n                                                </ui-select-choices>\n                                        </ui-select>\n                                </div>\n                        </div-->\n                    </div>\n\n                    <!--<div class="login-checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.agreeToTou"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">\n                                    I agree to the <a target="_blank" ng-href="{{::vm.termsOfUseUrl}}">Terms of use and privacy policy</a>\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>-->\n\n                    <button type="submit" class="button button_size_m button_color_pink button_width-100"\n                            cmnt-spinner-action="vm.signUp(signUpForm)">\n                        Join Manage by Obviously\n                    </button>\n                </form>\n                <div class="login__result" ng-switch-when="true">\n                    <h3 class="login__primary-heading">Great!</h3>\n\n                    <h5 class="login__secondary-heading">...now check your email</h5>\n\n                    <p class="login__result-text">\n                        We\u2019ve just sent an account activation link to {{ vm.newEmail }}\n                    </p>\n                </div>\n            </div>\n        </div>\n\n        <div class="login-right-pane" ng-if="vm.loginScreen === vm.LoginScreens.LOGIN">\n            <form cmnt-handle-errors name="logInForm" class="shake-on-errors">\n                <div class="login-right-pane__position">\n                    <h3 class="login__title">Already a member?</h3>\n\n                    <cmnt-form-errors></cmnt-form-errors>\n                    <div class="field-list login__field-list">\n                        <div class="field field_icon field_size_s field-group_icon" cmnt-field-errors>\n                            <i class="field__icon field__icon_absolute icon icon-email"></i>\n                            <label class="field__label">Email</label>\n\n                            <input class="field__text" type="text" name="email" ng-model="vm.email"\n                                   cmnt-focus-me="!vm.focusSignup">\n                        </div>\n\n                        <div class="field field_icon field_size_s form-group_icon" cmnt-field-errors>\n                            <i class="field__icon field__icon_absolute icon icon-security"></i>\n                            <label class="field__label">Password</label>\n\n                            <input class="field__text" type="password" name="password" ng-model="vm.password">\n                        </div>\n                    </div>\n\n                    <div class="checkbox-list checkbox-list_offset-top">\n                        <label class="checkbox checkbox_color-darkgray">\n                            <input class="checkbox__input" type="checkbox" ng-model="vm.rememberMe"/>\n                            <i class="checkbox__icon icon icon-checkbox"></i>\n                            <span class="checkbox__title">\n                                Remember me\n                            </span>\n                        </label>\n                    </div>\n\n                    <div class="form-actions login__form-actions">\n                        <a class="form-actions__link" ng-click="vm.showResetPasswordForm()">\n                            Reset my password\n                        </a>\n                        <button type="submit" class="button button_size_s button_color_river"\n                                cmnt-spinner-action="vm.logIn(logInForm)">\n                            Sign In\n                        </button>\n                    </div>\n\n                    <button type="button" class="button button_size_m button_color_darkblue button_width-100"\n                            ng-click="vm.loginViaAzure()">\n                        Login with Azure AD\n                    </button>\n                </div>\n            </form>\n        </div>\n\n        <div class="login-right-pane" ng-if="vm.loginScreen === vm.LoginScreens.TWO_FACTOR">\n            <div class="login-right-pane__position">\n                <h3 class="login__title">Already a member?</h3>\n\n                <form cmnt-handle-errors name="twoFactorForm" class="shake-on-errors">\n                    <cmnt-form-errors></cmnt-form-errors>\n\n                    <div class="field field_icon field_size_s field-group_icon" cmnt-field-errors>\n                        <i class="field__icon field__icon_absolute icon icon-security"></i>\n                        <label class="field__label">Code</label>\n\n                        <input class="field__text" type="text" name="code" ng-model="vm.twoFactorCode"\n                               autocomplete="off" cmnt-focus-me="true">\n                    </div>\n\n                    <div class="form-actions form-actions_offset-top">\n                        <button class="button button_size_s button_color_silver" ng-if="vm.twoFactorFailed"\n                                ng-click="vm.showLoginForm()">\n                            Back\n                        </button>\n\n                        <button class="button form-actions__right button_size_s button_color_river"\n                                ng-disabled="vm.twoFactorFailed"\n                                cmnt-spinner-action="vm.sendTwoFactorCode(twoFactorForm)">\n                            Submit\n                        </button>\n                    </div>\n\n                    <div class="two-factor-resend login__two-factor-resend">\n                        <div class="two-factor-resend__help">\n                            Didn\'t get the code? Click one of your phone numbers to have it re-sent to you again:\n                        </div>\n\n                        <ul class="two-factor-resend__phones-list">\n                            <li class="two-factor-resend__item">\n                                <a class="two-factor-resend__phone"\n                                   cmnt-spinner-action="vm.resendCode(undefined, twoFactorForm)">\n                                    {{ ::vm.mainPhone }}\n                                </a>\n                            </li>\n                            <li class="two-factor-resend__item" ng-repeat="backupPhone in vm.backupPhones">\n                                <a class="two-factor-resend__phone"\n                                   cmnt-spinner-action="vm.resendCode(backupPhone, twoFactorForm)">\n                                    {{ ::backupPhone.phone }}\n                                </a>\n                            </li>\n                            <li class="two-factor-resend__item">\n                                <a class="two-factor-resend__phone"\n                                   cmnt-spinner-action="vm.resendCode(undefined, twoFactorForm, true)">\n                                    {{ ::vm.email }}\n                                </a>\n                            </li>\n                        </ul>\n                    </div>\n                </form>\n            </div>\n        </div>\n\n        <div class="login-right-pane" ng-if="vm.loginScreen === vm.LoginScreens.RESET_PASSWORD">\n            <form cmnt-handle-errors name="resetPasswordForm" ng-switch="vm.passwordResetFinished"\n                  class="shake-on-errors">\n                <h3 class="login__title">Already a member?</h3>\n\n                <cmnt-form-errors></cmnt-form-errors>\n\n                <div class="login-right-pane__position" ng-switch-when=\'false\'>\n                    <div class="field login__field-list field_icon field_size_s field-group_icon" cmnt-field-errors>\n                        <i class="field__icon field__icon_absolute icon icon-email"></i>\n                        <label class="field__label">Email</label>\n\n                        <input class="field__text" type="text" name="email" ng-model="vm.resetEmail"\n                               cmnt-focus-me="true">\n                    </div>\n\n                    <div class="form-actions form-actions_offset-top">\n                        <button type="button" class="button button_size_s button_color_silver"\n                                ng-click="vm.showLoginForm()">\n                            Back\n                        </button>\n\n                        <button type="submit" class="button button_size_s button_color_river"\n                                cmnt-spinner-action="vm.resetPassword(resetPasswordForm)">\n                            Submit\n                        </button>\n                    </div>\n                </div>\n\n                <div ng-switch-when=\'true\'>\n                    The password restoration instructions has been sent to your email address, please check your inbox.\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('login/login.html','<cmnt-sign-in-prompt\n\t\t\t\tnext-state="vm.nextState"\n\t\t\t\tinvitation-email="vm.invitationEmail"\n\t\t\t\tinvitation-code="vm.invitationCode"\n\t\t\t\tredirect-url="vm.redirectUrl">\n</cmnt-sign-in-prompt>\n');
$templateCache.put('login/passwordResetComplete.html','<div class="login-height-full">\n\t\t<div class="login">\n\t\t\t\t<div class="login-left-pane">\n\t\t\t\t\t\t<div class="login-left-pane__position">\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="resetForm" class="shake-on-errors">\n\t\t\t\t\t\t\t\t\t\t<div class="login-right-pane__position">\n\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="login__title">Reset password</h3>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-list login__field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_icon field_size_s field-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-security"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">New password</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" name="password1" ng-model="vm.password1"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-focus-me="true">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-password-strength password="vm.password1"></cmnt-password-strength>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_icon field_size_s form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-security"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Repeat password</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" name="password2" ng-model="vm.password2">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="form-actions login__form-actions pull-right">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="button button_size_s button_color_river"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.reset(resetForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tReset\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('login/passwordResetInvalid.html','<div class="login-height-full">\n\t\t<div class="login">\n\t\t\t\t<div class="login-left-pane">\n\t\t\t\t\t\t<div class="login-left-pane__position">\n\t\t\t\t\t\t\t\t<div class="login-right-pane__position">\n\t\t\t\t\t\t\t\t\t\t<h3 class="login__title">Invalid restoration link</h3>\n\n\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\tThe password reset link was invalid, possibly because it has already been used. Please request a\n\t\t\t\t\t\t\t\t\t\t\t\tnew password reset.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('messaging/attachmentsList.directive.html','<div class="upload-file">\n\t\t<div class="alert alert_theme_default" ng-if="vm.UploadService.maxAttachmentsSizeExceeded">\n\t\t\t\tThe total size of the uploaded files ({{ ::vm.UploadService.getTotalSize()|filesize }})\n\t\t\t\texceeds {{ ::vm.UploadService.TOTAL_ATTACHMENTS_SIZE_LIMIT|filesize }}. The recipients of your message won\'t be\n\t\t\t\table to get these files as email attachments.\n\t\t</div>\n\n\t\t<div class="upload-file-list" ng-if="vm.UploadService.attachments.length">\n\t\t\t\t<div class="upload-file-list-item" ng-repeat="attachment in vm.UploadService.attachments">\n\t\t\t\t\t\t<div class="upload-file-list-item__name">\n\t\t\t\t\t\t\t\t<i class="icon-file icon"></i>\n\t\t\t\t\t\t\t\t{{ attachment.name|cmntMiddleTruncate:25 }}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="upload-file-list-item__progress">\n\t\t\t\t\t\t\t\t<div class="upload-file-list-item__error" ng-if="attachment.error">{{ attachment.error }}</div>\n\t\t\t\t\t\t\t\t<div class="progress-bar progress-bar_size_m"\n\t\t\t\t\t\t\t\t\t\t ng-if="!attachment.error && attachment.progress && !attachment.uuid"\n\t\t\t\t\t\t\t\t\t\t ng-style="{width: (attachment.progress || 0) + \'%\'}">\n\t\t\t\t\t\t\t\t\t\t{{ attachment.progress || 0 }}%\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="upload-file-list-item__delete" ng-click="vm.UploadService.removeAttachment(attachment)"\n\t\t\t\t\t\t\t\t ng-if="vm.editable">\n\t\t\t\t\t\t\t\t<i class="icon-delete icon"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('messaging/ccMyEmail.directive.html','<label class="checkbox checkbox_color-gray">\n\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.messagingSettings.copy_me" ng-change="vm.ccMeChanged()">\n\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t<span class="checkbox__title">CC my email</span>\n</label>\n');
$templateCache.put('messaging/followersPicker.directive.html','<div class="follower-tags">\n\t\t<div class="search-container">\n\t\t\t\t<ul class="search-choices">\n\t\t\t\t\t\t<li class="search-choice" ng-repeat="follower in nonMemberFollowers">\n                <span class="tag" pkm-team-colored-box="follower.membership_repr.organization"\n\t\t\t\t\t\t\t\t\t\t\tng-class="{\'tag_no-avatar\': !follower.membership_repr}">\n                    <span class="team-circle" ng-if="follower.membership_repr"\n\t\t\t\t\t\t\t\t\t\t\t\t\tpkm-team-colored-box="follower.membership_repr.organization">\n                        {{ follower.membership_repr.organization.two_letter_code  }}\n                    </span>\n\n                    <span class="name">{{ follower.membership_repr.user.repr || follower.email }}</span>\n\n                    <span ng-if="follower.invite">(invite)</span>\n\n                    <a href class="remove" ng-click="removeFollower(follower); $event.stopPropagation()">\n                        <i class="icon icon-cancel"></i>\n                    </a>\n                </span>\n\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t<li class="search-field">\n\t\t\t\t\t\t\t\t<input type="text" placeholder="Type Name or E-mail..." ng-model="uiState.followerSearch"\n\t\t\t\t\t\t\t\t\t\t\t autocomplete="off">\n\t\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\n\t\t\t\t<div class="search-drop" ng-if="uiState.followerSearch" cmnt-tether target=".search-choices">\n\t\t\t\t\t\t<ul class="search-results">\n\t\t\t\t\t\t\t\t<cmnt-loading-indicator resource="collaboratorSuggestions" show-text="false">\n\t\t\t\t\t\t\t\t</cmnt-loading-indicator>\n\n\n\t\t\t\t\t\t\t\t<li class="organization-picker" ng-repeat="membership in collaboratorSuggestions">\n\t\t\t\t\t\t\t\t\t\t<a class="organization-user" href ng-click="addMembership(membership, true)">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="result-name">{{ membership.user.repr }}</span>\n\t\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t\t<a class="organization-description" href="" ng-click="addMembership(membership, true)">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="team-circle organization-circle" pkm-team-colored-box="membership.organization">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ membership.organization.two_letter_code }}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="organization-title">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ membership.organization.title }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="new" ng-if="isNewCollaborator(membership)"> - New Collaborator</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t<div class="buttons organization-add">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="button button_size_xs button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="addMembership(membership, true)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="uiState.addingInProgress">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tadd\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t<li class="not-found" ng-if="uiState.followerSearch">\n                    <span class="result-name">\n                        {{ uiState.followerSearch  }}\n                        <span> - Not Found</span>\n                    </span>\n\n\t\t\t\t\t\t\t\t\t\t<div class="buttons" ng-if="!uiState.askForEmail">\n\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="button button_size_xs button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="addEmail(uiState.followerSearch)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="uiState.addingInProgress">add as guest\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<form ng-if="uiState.askForEmail" class="email-prompt">\n\t\t\t\t\t\t\t\t\t\t\t\t<label>Email:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="email" class=\'form-control\' name="email" required ng-model=\'uiState.emailInput\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-focus-me="true">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="email-prompt__buttons">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="submit" class="button button_size_xs button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="confirmEmail()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button type="button" class="button button_size_xs button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="cancelEmail()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('messaging/messagesList.directive.html','<div class="messages-list" infinite-scroll="vm.loadMore()" infinite-scroll-distance="2"\n\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.messages.$resolved">\n\t\t<div class="message" ng-repeat="message in vm.messages" ng-mouseenter="vm.markRead(message)"\n\t\t\t\t ng-click="vm.markRead(message)">\n\t\t\t\t<div class="message__head" ng-class="{\'message__head_notification\': !message.is_read}">\n\t\t\t\t\t\t<img class="message__avatar" ng-src="{{ ::message.author.avatar_40 }}">\n\t\t\t\t\t\t<div class="message__author">{{ ::message.author.full_name }}</div>\n\t\t\t\t\t\t<div class="message__date">{{ ::message.created|cmntDateFormat:true }}</div>\n\t\t\t\t\t\t<!--div class="message__actions">\n\t\t\t\t\t\t\t\t<button class="button button_size_xs button_color_clear button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="vm.remove(message)" title="Delete message..."\n\t\t\t\t\t\t\t\t\t\t\t\tng-if="message.is_own"\n\t\t\t\t\t\t\t\t\t\t\t\tconfirm-title="Delete message?"\n\t\t\t\t\t\t\t\t\t\t\t\tconfirm-message="You can\'t undo this action.">\n\t\t\t\t\t\t\t\t\t\tDelete\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div-->\n\t\t\t\t</div>\n\t\t\t\t<div class="message__body">\n\t\t\t\t\t\t<div class="message__text" ng-bind-html="message.clean_html"></div>\n\t\t\t\t\t\t<a class="message-file" ng-repeat="file in message.attached_files" ng-href="{{ file.signed_url }}"\n\t\t\t\t\t\t\t target="_blank">\n\t\t\t\t\t\t\t\t<i class="message-file__icon icon icon-file-1"></i>\n\t\t\t\t\t\t\t\t{{ file.name }}\n\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t<ul class="message__receipts">\n\t\t\t\t\t\t\t\t<li class="message__receipts-label">Delivery tracker:</li>\n\n\t\t\t\t\t\t\t\t<li ng-repeat="receipt in message.receipts" class="message__receipt"\n\t\t\t\t\t\t\t\t\t\tng-class="\'message__receipt_\'+receipt.status">\n\t\t\t\t\t\t\t\t\t\t<a href tooltip-html-unsafe="{{receipt.status}} {{receipt.created|cmntFromNow}}">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ receipt.recipient_repr }}\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<cmnt-loading-indicator ng-show="!vm.messages.$resolved || vm.messages.length === 0" resource="vm.messages"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tmessage="No messages."></cmnt-loading-indicator>\n</div>\n');
$templateCache.put('messaging/uploadWarning.html','<div class="modall">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title modal-header__title_align-center">You have active uploads</h2>\n\t\t</div>\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">\n\t\t\t\t\t\t{{ warningText }}\n\t\t\t\t</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group button-group_compact">\n\t\t\t\t\t\t<button class="button button_size_s button_color_blue" ng-click=\'$close()\'>Yes</button>\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_blue" ng-click=\'$dismiss()\'\n\t\t\t\t\t\t\t\t\t\tcmnt-focus-me="true">No\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('personal/personal.html','<div class="my-account-header">\n\t\t<div class="content">\n\t\t\t\t<a href="" class="button my-account-header_sign-out button_size_s button_color_river" ng-click="vm.logOut()">Sign\n\t\t\t\t\t\tout</a>\n\t\t\t\t<div class="my-account-header__title">My account</div>\n\t\t\t\t<div class="my-account-header__pane" ng-show="vm.profile.name===undefined">\n\t\t\t\t\t\t<div class="my-account-header-note">\n\t\t\t\t\t\t\t\t<i class="my-account-header-note__icon icon icon-about"></i>\n\t\t\t\t\t\t\t\t<p class="my-account-header-note__text">Note: As the first person from your firm to join Obviously Manage, you\u2019ll\n\t\t\t\t\t\t\t\t\t\tbe set as the primary contact for your firm</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<a ui-sref="community.profile" class="button button_size_m button_color_blue">\n\t\t\t\t\t\t\t\t<i class="button__icon icon icon-build"></i>\n\t\t\t\t\t\t\t\tSet up your firm\'s profile\n\t\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n<div class="my-account-body">\n\t\t<div class="my-account-body__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-profile"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">About me</h3>\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="accountForm" class="profile-body__settings"\n\t\t\t\t\t\t\t\t\t\t\tng-if="vm.userModel.is_active">\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group field-group_icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-profile"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="First"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.first_name" name="first_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Last"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.last_name" name="last_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<!--div class="field field_icon field_size_s field_border form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-build"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Company</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" ng-model="vm.company" name="company">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_icon field_size_s field_border form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-email"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Email</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" ng-model="vm.newEmail" name="email">\n\t\t\t\t\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-actions">\n\t\t\t\t\t\t\t\t\t\t\t\t<a href class="form-actions__link" ng-click="vm.passwordFormShowed=!vm.passwordFormShowed">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tChange password\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river" cmnt-submit ng-click="vm.save()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="passwordChangeForm" ng-show="vm.passwordFormShowed"\n\t\t\t\t\t\t\t\t\t\t\tclass="profile-body__settings profile-body__settings_password">\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Old password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="password" class="field__text" name="original_password"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.passwordModel.original_password"/>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">New password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" ng-model="vm.passwordModel.password1"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="password1"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t autocomplete="off" tooltip-html-unsafe="{{::vm.passwordRules}}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-trigger="focus" tooltip-placement="top"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-password-strength password="vm.passwordModel.password1"></cmnt-password-strength>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Repeat new password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="password" class="field__text" name="password2" autocomplete="off"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.passwordModel.password2"/>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="form-actions form-actions_offset-top form-actions_align-right">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="passwordChangeForm.$pristine"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.changePassword(passwordChangeForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="activateForm" class="profile-body__settings"\n\t\t\t\t\t\t\t\t\t\t\tng-if="!vm.userModel.is_active">\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group field-group_icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-profile"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="First"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.first_name" name="first_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Last"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.last_name" name="last_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Choose a password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" ng-model="vm.passwordModel.newPassword"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="password"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t autocomplete="off">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-password-strength password="vm.passwordModel.newPassword"></cmnt-password-strength>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="login-checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.agreeToTou"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">\n                                    I agree to the <a target="_blank" ng-href="{{::vm.termsOfUseUrl}}">Terms of use and privacy policy</a>\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-actions form-actions_offset-top form-actions_align-right">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river" type="submit"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!vm.agreeToTou"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.activateUser(activateForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tActivate\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="profile-body-container" ng-if="vm.userModel.is_active">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-linkedin-squared"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">{{ vm.userModel.linkedin_url ? \'\' : \'Connect \' }}LinkedIn account</h3>\n\t\t\t\t\t\t\t\t<div class="profile-body__settings">\n\t\t\t\t\t\t\t\t\t\t<a ng-if="!vm.userModel.linkedin_url" class="button button_size_s button_color_darkblue"\n\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.connectLinkedIn()">\n\t\t\t\t\t\t\t\t\t\t\t\tConnect LinkedIn\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" ng-if="vm.userModel.linkedin_url">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="field__text" ng-model="vm.userModel.linkedin_url" readonly>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="my-account-body__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-photo"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">Picture</h3>\n\t\t\t\t\t\t\t\t<p class="profile-body__text">We recommend using a photo of yourself to present your firm as friendly\n\t\t\t\t\t\t\t\t\t\tand approachable</p>\n\t\t\t\t\t\t\t\t<div class="alert alert_theme_default" ng-if="vm.avatarErrors">Avatar error: {{ vm.avatarErrors }}</div>\n\t\t\t\t\t\t\t\t<button class="picture-uploader picture-uploader_user picture-uploader_personal-picture"\n\t\t\t\t\t\t\t\t\t\t\t\tng-file-select ng-file-change="vm.uploadAvatar($files)" accept="image/*" ng-capture="\'camera\'"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'picture-uploader_no-border\': vm.userModel.has_avatar}">\n\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ vm.userModel.avatar_160 }}" ng-if="vm.userModel.has_avatar">\n\t\t\t\t\t\t\t\t\t\t<i ng-if-start="!vm.userModel.has_avatar" class="picture-uploader__icon icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t<span ng-if-end>Profile picture</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!--div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-news"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">News</h3>\n\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.agreeToTou"/>\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">\n\t\t\t\t\t\t\t\t\t\t\t\tSend me occasional Pekama news\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div-->\n\t\t</div>\n</div>\n');
$templateCache.put('profile/newTeam.modal.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title">Create new team</h2>\n\t\t</div>\n\n\t\t<form cmnt-handle-errors name="newTeamForm">\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t<label class="field__label" for="title">Team name</label>\n\t\t\t\t\t\t\t\t<input id="title" type="text" ng-model=\'vm.title\' class=\'field__text\' name="title" autofocus>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" submit\n\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action=\'vm.create(newTeamForm)\'>Create\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('profile/profile.html','<div class="profile">\n\t\t<div class="content">\n\t\t\t\t<div class="alert alert_theme_default" ng-if="vm.logoErrors">Company logo error: {{ vm.logoErrors }}</div>\n\t\t\t\t<div class="profile-invite">\n\t\t\t\t\t\t<div class="profile-invite__points">\n\t\t\t\t\t\t\t\t<!--p>Your profile is 10% complete</p>\n\t\t\t\t\t\t\t\t<p>490 community points available for completion</p-->\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<button class="button button_size_m button_color_blue" ng-click="vm.referAnAttorney()"\n\t\t\t\t\t\t\t\t\t\tng-if="!vm.userModel.is_read_only">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\tInvite people to Obviously Manage\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class="profile-header">\n\t\t\t\t\t\t<div class="profile-header__row">\n\t\t\t\t\t\t\t\t<div class="profile-header-left">\n\t\t\t\t\t\t\t\t\t\t<button class="picture-uploader profile-header-left__picture-uploader"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="vm.userModel.id!==vm.organizationModel.owner"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\n                                \'button_disabled\': vm.userModel.id!==vm.organizationModel.owner,\n                                \'picture-uploader_no-border\': vm.organizationModel.logo_140\n                            }"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-file-select ng-file-change="vm.uploadLogo($files)" accept="image/*">\n\t\t\t\t\t\t\t\t\t\t\t\t<img ng-if="vm.organizationModel.logo_140" ng-src="{{ vm.organizationModel.logo_140 }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="picture-uploader__preview">\n\t\t\t\t\t\t\t\t\t\t\t\t<i ng-if-start="!vm.organizationModel.logo_140"\n\t\t\t\t\t\t\t\t\t\t\t\t\t class="picture-uploader__icon icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if-end>Company logo</span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="profile-header-user">\n\t\t\t\t\t\t\t\t\t\t<button class="picture-uploader picture-uploader_user picture-uploader_cursor-default"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="vm.userModel.id!==vm.organizationModel.owner"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{button_disabled: vm.userModel.id!==vm.organizationModel.owner}">\n\t\t\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ vm.profile.avatar160 }}" ng-if="vm.profile.avatar160">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="profile-header-left__title" ng-if-start="!vm.profile.avatar160">Primary<br/>Contact</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="profile-header-left__subtitle" ng-if-end>No primary contact yet</span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<div class="profile-header-user__company" ng-if="vm.userModel.id!=vm.organizationModel.owner">{{\n\t\t\t\t\t\t\t\t\t\t\t\tvm.organizationModel.title }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<cmnt-editable-title model="vm.organizationModel" field="title"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-finish-editing="vm.updateOrganizationTitle(vm.organizationModel)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.userModel.id==vm.organizationModel.owner">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="profile-header-user__company">{{ vm.organizationModel.title }}</div>\n\t\t\t\t\t\t\t\t\t\t</cmnt-editable-title>\n\t\t\t\t\t\t\t\t\t\t<div class="profile-header-user__name" ng-hide="vm.representativeChooserShowed">{{ vm.profile.name\n\t\t\t\t\t\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<!--\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.profile.representative" on-select="vm.setRepresentative($item, $model)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-show="vm.representativeChooserShowed">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Choose primary contact...">{{ $select.selected.user.repr }}</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="member.id as member in vm.members|filter:$select.search">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="member.user.repr | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t<a class="profile-header-user__link" ng-if="vm.userModel.id==vm.organizationModel.owner" href=""\n\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.representativeChooserShowed=!vm.representativeChooserShowed"\n\t\t\t\t\t\t\t\t\t\t\t ng-hide="vm.representativeChooserShowed">{{ vm.profile.name ? \'Change\':\'Set\' }} primary contact</a>\n\t\t\t\t\t\t\t\t\t -->\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="profile-header-score">\n\t\t\t\t\t\t\t\t\t\t<span class="profile-header-score__value"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-if-start="$state.is(\'community.profile.team\') || $state.is(\'community.profile.services\')">{{ vm.profile.community_score }}</span>\n\t\t\t\t\t\t\t\t\t\t<span ng-if-end>Community Score</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="profile-header__row profile-header__row_no-overflow profile-header__row_align-end">\n\t\t\t\t\t\t\t\t<div class="profile-header__current-team">\n\t\t\t\t\t\t\t\t\t\t<div class="select select_fixed-width_160 select_theme_gray select_size_s"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.organizations.$resolved">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">Current team:</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.primaryOrg" ng-change="vm.setPrimary($item, $model)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-extra-option option-label="Create new team..." option-class="create-new-team"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t option-callback="vm.createNewTeam(search)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Switch team...">{{ $select.selected.repr }}</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="organization.id as organization in vm.organizations|filter:$select.search">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="organization.repr | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<!--div class="profile-header__recommend">\n\t\t\t\t\t\t\t\t\t\t<span class="like-module like-module_shift-bottom">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="like-module__label-count">{{ vm.profile.recommendations_count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="like-module__icon like-module__icon_shift">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-like-empty"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t\t\t<div class="profile-header__sign-out">\n\t\t\t\t\t\t\t\t\t\t<a href="" class="button button_size_s button_color_river" ng-click="vm.logOut()">Sign out</a>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<nav class="profile-menu profile-menu_flex">\n\t\t\t\t\t\t<div class="profile-menu__flex_item">\n\t\t\t\t\t\t\t\t<a ui-sref=".personal" ui-sref-active="profile-menu__item_active"\n\t\t\t\t\t\t\t\t\t class="profile-menu__item">Personal</a>\n\t\t\t\t\t\t\t\t<!--a ui-sref=".forms" ui-sref-active="profile-menu__item_active" class="profile-menu__item">Forms</a-->\n\t\t\t\t\t\t\t\t<a ui-sref=".members" ui-sref-active="profile-menu__item_active" class="profile-menu__item">Team\n\t\t\t\t\t\t\t\t\t\tmembers</a>\n\t\t\t\t\t\t\t\t<a ui-sref=".experts" ui-sref-active="profile-menu__item_active" class="profile-menu__item">My\n\t\t\t\t\t\t\t\t\t\texperts</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-menu__flex_item">\n\t\t\t\t\t\t\t\t<span class="profile-menu__item-label">FOR IP LAWYERS:</span>\n\t\t\t\t\t\t\t\t<a ui-sref=".team" ui-sref-active="profile-menu__item_active" class="profile-menu__item">Firm\n\t\t\t\t\t\t\t\t\t\tProfile</a>\n\t\t\t\t\t\t\t\t<a ui-sref=".services" ui-sref-active="profile-menu__item_active"\n\t\t\t\t\t\t\t\t\t class="profile-menu__item">Services</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</nav>\n\t\t\t\t<div class="profile__body" ui-view></div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/suspensionNotice.modal.html','<div class="modal">\n\t\t<div class="modal-header modal-header_theme-red">\n\t\t\t\t<h2 class="modal-header__title">Your Obviously Manage supplier account is inactive</h2>\n\t\t</div>\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">\n\t\t\t\t\t\tYour supplier account was currently marked inactive by Obviously Manage. If you don\'t know why this happened,\n\t\t\t\t\t\tplease contact <a target="_blank" ng-href="{{ mailTo }}">support@obviously.digital</a> for more details and in\n\t\t\t\t\t\torder to release your account.\n\t\t\t\t</p>\n\t\t\t\t<p class="modal-body__text">\n\t\t\t\t\t\tKindly note that creating a new supplier account is not allowed and members whose supplier accounts were\n\t\t\t\t\t\tsuspended and may lead to permanently banning such users from our community.\n\t\t\t\t</p>\n\t\t\t\t<p class="modal-body__text">Please contact us and we will help you find out why this happened and resolve the\n\t\t\t\t\t\tissue.</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t<a class="button button_size_m button_color_blue" target="_blank" ng-href="{{ mailTo }}"\n\t\t\t\t\t\t\t ng-click="$dismiss()">Contact Us</a>\n\t\t\t\t\t\t<button ng-click="$dismiss()" class="button button_size_m button_transparent button_border_blue">\n\t\t\t\t\t\t\t\tNot now\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('projects/participants.modal.html','<div class="modal">\n\t\t<div class="modal-header modal-conversation">\n\t\t\t\t<div class="modal-conversation__title">Edit participants in this convertation</div>\n\t\t\t\t<button class="modal-conversation__close" ng-click="$dismiss()">\n\t\t\t\t\t\t<i class="icon icon-delete-line"></i>\n\t\t\t\t</button>\n\t\t</div>\n\n\t\t<div class="modal-body">\n\t\t\t\t<div class="modal-conversation__person">\n\t\t\t\t\t\t<div class="modal-conversation__person-pic">\n\t\t\t\t\t\t\t\t<img class="modal-conversation__person-pic-img" ng-src="{{ ::vm.expert.avatar }}">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="modal-conversation__person-name">\n\t\t\t\t\t\t\t\t{{ ::vm.expert.organization.title }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-conversation__body">\n\t\t\t\t\t\t<div class="modal-conversation__team">\n\t\t\t\t\t\t\t\t<div class="modal-conversation__body-title">\n\t\t\t\t\t\t\t\t\t\tTeam members\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="modal-conversation__desctription">\n\t\t\t\t\t\t\t\t\t\tChoose participants\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<ul class="modal-conversation__items">\n\t\t\t\t\t\t\t\t\t\t<li class="modal-conversation__item" ng-repeat="member in vm.members">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="modal-conversation__check">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" class="checkbox__input" ng-checked="member.$follower"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-disable-action="vm.toggleFollower(member)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="modal-conversation__avatar">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="modal-conversation__avatar-img" ng-src="{{ ::member.user.avatar_38 }}">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="modal-conversation__name">{{ ::member.user.full_name }}</div>\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="modal-conversation__external">\n\t\t\t\t\t\t\t\t<div class="modal-conversation__body-title">\n\t\t\t\t\t\t\t\t\t\tExternal\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="modal-conversation__desctription">\n\t\t\t\t\t\t\t\t\t\tInvite participants by email\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<pkm-followers-picker followers="vm.followers"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tperform-add="vm.pickerAddFollower(follower)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tperform-remove="vm.pickerRemoveFollower(follower)">\n\t\t\t\t\t\t\t\t</pkm-followers-picker>\n\n\t\t\t\t\t\t\t\t<!--div class="modal-conversation__search">\n\t\t\t\t\t\t\t\t\t\t<button class="modal-conversation__email">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-email"></i>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<form action="">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="modal-conversation__input" type="text" placeholder="email addres">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="modal-conversation__submit">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="modal-conversation__del">\n\t\t\t\t\t\t\t\t\t\tmindy.mswindy@flimflam.co.uk\n\t\t\t\t\t\t\t\t\t\t<button class="modal-conversation__delete">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete"></i>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="modal-footer modal-footer_align-right modal-conversation__actions">\n\t\t\t\t<button class="button button_size_s button_transparent modal-conversation__action-close" ng-click="$dismiss()">\n\t\t\t\t\t\tClose\n\t\t\t\t</button>\n\t\t\t\t<!--button class="button button_size_s button_color_blue" disabled>\n\t\t\t\t\t\tApply changes\n\t\t\t\t</button-->\n\t\t</div>\n</div>\n');
$templateCache.put('projects/project.directive.html','<div class="case" ng-click="vm.viewCase()"\n\t\t ng-mouseenter="vm.cursorInside = true"\n\t\t ng-mouseleave="vm.cursorInside = false"\n\t\t ng-class="{\n        case_checked : vm.project.selected,\n        case_selectable: vm.selectable,\n        case_highlighted: vm.cursorInside && !vm.project.selected,\n        case_animated: vm.animated\n     }">\n\t\t<div class="case__content" ng-class="{\'case__content_fade-in\': vm.fadeIn}">\n\t\t\t\t<div class="case-sub-header">\n\t\t\t\t\t\t<i class="case-sub-header__icon icon"\n\t\t\t\t\t\t\t ng-class="{\'icon-inbound\': vm.project.direction === \'incoming\', \'icon-outbound\': vm.project.direction === \'outgoing\'}"\n\t\t\t\t\t\t\t tooltip="{{ (vm.project.direction === \'incoming\')?\'Inbound\':\'Outbound\' }}"></i>\n\n\t\t\t\t\t\t<h3 class="case-sub-header__title">{{ vm.project.title }}</h3>\n\t\t\t\t</div>\n\t\t\t\t<div class="case-header">\n\t\t\t\t\t\t<div class="case-header__checkbox" ng-click="vm.toggleSelection()" cmnt-stop-propagation\n\t\t\t\t\t\t\t\t ng-if="vm.selectable">\n\t\t\t\t\t\t\t\t<label class="checkbox case__checkbox checkbox_color-blue" for="projectid{{ ::vm.project.id }}">\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">Select</span>\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" id="projectid{{ ::vm.project.id }}" type="checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.project.selected" ng-change="vm.selectionChanged()">\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-header-list">\n\t\t\t\t\t\t\t\t<div class="case-header-list__item">\n\t\t\t\t\t\t\t\t\t\t{{ vm.matterType.title }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="case-header-list__item">\n\t\t\t\t\t\t\t\t\t\t<i class="case-header-list__icon flag flag-{{ vm.jurisdiction.code|lowercase }}"></i>\n\t\t\t\t\t\t\t\t\t\t{{ vm.jurisdiction.value }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="case-header-list__item" ng-if="vm.expertiseType">\n\t\t\t\t\t\t\t\t\t\t{{ vm.expertiseType.value }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-header__activity">\n\t\t\t\t\t\t\t\t<span class="label">Last activity</span>\n\t\t\t\t\t\t\t\t{{ vm.project.last_activity | cmntFromNow }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="case-body">\n\t\t\t\t\t\t<div class="case-person" ng-if="::(vm.project.direction==\'outgoing\')"\n\t\t\t\t\t\t\t\t ng-repeat="supplier in ::vm.project.supplier_conversations"\n\t\t\t\t\t\t\t\t ng-class="{\'case-person_notification\': supplier.unread > 0}">\n\t\t\t\t\t\t\t\t<div class="case-person-pic" cmnt-stop-propagation ng-click="vm.viewConversation(supplier.id)">\n\t\t\t\t\t\t\t\t\t\t<img class="case-person-pic__img" ng-src="{{ supplier.representative.avatar_38 }}"\n\t\t\t\t\t\t\t\t\t\t\t\t alt="{{ supplier.representative.full_name }}">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="case-person-info" cmnt-stop-propagation ng-click="vm.viewConversation(supplier.id)">\n\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ supplier.organization_title }}\n\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info__name">{{ supplier.representative.full_name }}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status case-person-info-status_{{ supplier.status }}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="case-person-info-status__icon icon {{ vm.getStatusIcon(supplier) }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="supplier.status !== \'quoted\'"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ supplier|conversationStatus }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-person"\n\t\t\t\t\t\t\t\t ng-class="{\'case-person_notification\': vm.project.supplier_conversations[0].unread > 0}"\n\t\t\t\t\t\t\t\t ng-if="::(vm.project.direction==\'incoming\')">\n\t\t\t\t\t\t\t\t<div class="case-person-pic" cmnt-stop-propagation ng-click="vm.viewCase()">\n\t\t\t\t\t\t\t\t\t\t<img class="case-person-pic__img" ng-src="{{ vm.project.creator.avatar_38 }}"\n\t\t\t\t\t\t\t\t\t\t\t\t alt="{{ vm.project.creator.full_name }}">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="case-person-info" cmnt-stop-propagation ng-click="vm.viewCase()">\n\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.project.organization_title }}\n\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info__name">{{ vm.project.creator.full_name }}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status case-person-info-status_{{ vm.project.supplier_conversations[0].status }}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="case-person-info-status__icon icon {{ vm.getStatusIcon(vm.project.supplier_conversations[0]) }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.project.supplier_conversations[0].status !== \'quoted\'"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.project.supplier_conversations[0]|conversationStatus }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="case-footer">\n\t\t\t\t\t\t<div class="case-footer-pane">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-footer-pane">\n\t\t\t\t\t\t\t\t<a href class="case-footer-link" ng-if="::(!vm.isReadOnly)">\n\t\t\t\t\t\t\t\t\t\tView case\n\t\t\t\t\t\t\t\t\t\t<i class="case-footer-link__icon case-footer-link__icon_color-blue icon icon-arrow-right margin-left"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('projects/projectConversation.html','<div class="response-block">\n\t\t<h3 class="response-block__title">Your response</h3>\n\t\t<div class="response-block__tabs">\n\t\t\t\t<div class="response-block-tab" ng-class="{\'response-block-tab_active\': vm.postType === postType}"\n\t\t\t\t\t\t ng-repeat="postType in vm.postTypes" ng-click="vm.switchPostType(postType)" ng-switch="postType">\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="message">Message</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Send a general message</div>\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="instruct">Instruct</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Instruct this expert</div>\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="reject">Reject</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Reject this expert</div>\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="withdraw">Withdraw</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Cancel this project</div>\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="confirm">Confirm</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Confirm instructions</div>\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="complete">Complete</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Confirm completion</div>\n\n\t\t\t\t\t\t<div class="response-block-tab__name" ng-switch-when-start="quote">Quote</div>\n\t\t\t\t\t\t<div class="response-block-tab__hint" ng-switch-when-end>Reply with a quote</div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="response-block__text">\n\t\t\t\t<text-angular class="field__text" ng-model="vm.text" required name="text">\n\t\t\t\t</text-angular>\n\t\t</div>\n\n\t\t<div class="response-block__actions">\n\t\t\t\t<div class="response-block__cc-checkbox">\n\t\t\t\t\t\t<cmnt-cc-my-email></cmnt-cc-my-email>\n\t\t\t\t</div>\n\n\t\t\t\t<form ng-if="vm.postType === \'quote\'" cmnt-handle-errors name="vm.priceForm">\n\t\t\t\t\t\t<div class="field-group-flex field-group-flex_align-center">\n\t\t\t\t\t\t\t\t<div class="response-block__actions-label field-group-flex__item">Quote</div>\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field-group-flex__item response-block__actions-number"\n\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="number" ng-model="vm.price.amount" cmnt-focus-me="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t name="price"\n\t\t\t\t\t\t\t\t\t\t\t\t\t min="0" cmnt-string-to-number ng-change="vm.priceAmountChanged()">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="select select_size_s select_theme_gray field-group-flex__item response-block__actions-select"\n\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.price.currency" name=\'price_currency\' ng-change="vm.priceCurrencyChanged()">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{ $select.selected.name }} ({{ $select.selected.code }})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="currency.code as currency in vm.currencies|filter:$select.search">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>{{ ::currency.name }} ({{ ::currency.code }})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</form>\n\n\t\t\t\t<button class="button button_attach" ng-file-select\n\t\t\t\t\t\t\t\tng-file-change="vm.UploadService.startUploading($files)" ng-multiple="true">\n\t\t\t\t\t\t<i class="icon icon-attach-file"></i> Attach\n\t\t\t\t</button>\n\n\t\t\t\t<button cmnt-spinner-action="vm.post(priceForm)" class="button button_size_s button_color_blue"\n\t\t\t\t\t\t\t\tng-disabled="vm.postButtonDisabled()">\n\t\t\t\t\t\t<i class="button__icon icon icon-arrow"></i>\n\t\t\t\t\t\t{{ vm.postType | capitalize }}\n\t\t\t\t</button>\n\t\t</div>\n\t\t<div class="response-block__actions-text" ng-if="vm.postType === \'quote\' && vm.project.task.fee && !vm.isAssociate">\n\t\t\t\tIncludes <span class="response-block__actions-text-black">Obviously Manage membership fee</span> of {{\n\t\t\t\tvm.project.task.fee.formatted }}\n\t\t\t\t<i class="icon icon-help-circled"\n\t\t\t\t\t tooltip-html-unsafe="If you are instructed by the client, this fee will be deducted from their payment to you."\n\t\t\t\t\t tooltip-append-to-body="true"></i>\n\t\t</div>\n\n\t\t<cmnt-attachments-list service="vm.UploadService"></cmnt-attachments-list>\n</div>\n\n<cmnt-messages-list conversation="vm.conversation"></cmnt-messages-list>\n');
$templateCache.put('projects/projectDetail.html','<cmnt-experts-chooser ng-if="vm.expertsChooserDelegate.shown"\n\t\t\t\t\t\t\t\t\t\t\tmatter-type="vm.matterType.id"\n\t\t\t\t\t\t\t\t\t\t\tdefinings="vm.defining.id"\n\t\t\t\t\t\t\t\t\t\t\texpertise-type="vm.expertiseType.id"\n\t\t\t\t\t\t\t\t\t\t\texclude-profiles-ids="vm.existingProfilesIds"\n\t\t\t\t\t\t\t\t\t\t\ton-experts-selected="vm.expertsSelected(profileIds)">\n</cmnt-experts-chooser>\n\n<section ng-hide="vm.expertsChooserDelegate.shown" class="case-full-height">\n\t\t<div class="filter filter_theme_dark filter_response_v2">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="filter-pane filter-pane_align-center">\n\t\t\t\t\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_white select_size_s select_width_justify filter__select">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">IP Type</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="select__choice">{{ vm.matterType.title }}</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_white select_size_s select_width_justify filter__select"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.expertiseType">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">Service</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="select__choice">{{ vm.expertiseType.value }}</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_white select_size_s select_width_justify  filter__select">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">Jurisdiction</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="select__choice">{{ vm.defining.value }}</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_white select_size_s select_width_justify filter__select"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::!vm.isOutgoing">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">Status</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="select__choice">{{ vm.project|projectStatus }}</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_white select_size_s select_width_justify filter__select"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::vm.isOutgoing">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">Status</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="left" class="hamburger-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.project.$status === \'sent\' || vm.project.$status === \'confirmed\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n                                <span class="select__choice">\n                                    {{ vm.project|projectStatus }}\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane ng-if="vm.project.$status === \'sent\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel hamburger-menu-panel_static hamburger-menu-panel_width_110">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" cmnt-spinner-action="vm.confirmInstructions($close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tConfirm instructions\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane ng-if="vm.project.$status === \'confirmed\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel hamburger-menu-panel_static hamburger-menu-panel_width_110">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" cmnt-spinner-action="vm.completeInstructions($close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tConfirm completion\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="select__choice"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.project.$status !== \'sent\' && vm.project.$status !== \'confirmed\'">\n                            {{ vm.project|projectStatus }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t\t\t\t\t<div class="icons-menu-list icons-menu-list_theme_white">\n\t\t\t\t\t\t\t\t\t\t\t\t<!--button class="icons-menu-list__item" cmnt-confirm-click="vm.cancel()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.project.direction === \'outgoing\' && vm.project.status === \'draft\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icon icon-delete-line"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tCancel\n\t\t\t\t\t\t\t\t\t\t\t\t</button-->\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="icons-menu-list__item" ng-click="vm.expertsChooserDelegate.show()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.project.direction === \'outgoing\' && vm.project.status === \'draft\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tExperts\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<!--button class="icons-menu-list__item" cmnt-confirm-click="vm.archive()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.currentUser.is_active">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icon icon-delete"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="icons-menu-list__item" ng-click="vm.clone()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.currentUser.is_active">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icon icon-clone"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tClone\n\t\t\t\t\t\t\t\t\t\t\t\t</button-->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="case-detail">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="case-detail-pane case-detail-pane_left">\n\t\t\t\t\t\t\t\t<div class="case-detail-tabs">\n\t\t\t\t\t\t\t\t\t\t<div class="case-detail-tabs__tab"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'case-detail-tabs__tab_active\': conversation.id === vm.activeConversationId}"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.openConversation(conversation)"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-repeat="conversation in vm.conversations" ng-switch="vm.project.direction">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-switch-when="outgoing"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'case-person_notification\': conversation.unread > 0}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="case-person-pic__img" ng-src="{{ ::conversation.profile.avatar }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">{{ ::conversation.profile.organization.title }}</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info__name">{{ ::conversation.profile.name }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="\'case-person-info-status_\' + conversation.status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="case-person-info-status__icon icon"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="conversation.status !== \'quoted\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="vm.ProjectStatusIcon[conversation.status]">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ conversation|conversationStatus }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-switch-when="incoming"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'case-person_notification\': conversation.unread > 0}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="case-person-pic__img" ng-src="{{ vm.project.creator.avatar_38 }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">{{ vm.project.organization_title }}</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info__name">{{ vm.project.creator.full_name }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="\'case-person-info-status_\' + conversation.status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="case-person-info-status__icon icon"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="conversation.status !== \'quoted\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="vm.ProjectStatusIcon[conversation.status]"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ conversation|conversationStatus }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-conversation" ng-if="conversation.id === vm.activeConversationId">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-conversation__title">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tIn this conversation:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="case-conversation__people">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="case-conversation__person" ng-repeat="follower in vm.followers">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-conversation__person-pic">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img class="case-conversation__person-pic-img" ng-if="follower.membership_repr"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-src="{{ ::follower.membership_repr.user.avatar_38 }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-conversation__person-name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ follower.membership_repr.user.full_name || follower.repr }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="case-conversation__delete" ng-click="vm.removeFollower(follower)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.isOutgoing" tooltip="Remove from conversation"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttooltip-append-to-body="true" tooltip-placement="top">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a class="case-conversation__edit" ng-click="vm.openEditParticipantsModal()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-stop-propagation ng-if="vm.isOutgoing">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-edit"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEdit participants\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-detail-pane case-detail-pane_right">\n\t\t\t\t\t\t\t\t<div class="case-detail-content">\n\t\t\t\t\t\t\t\t\t\t<ui-view></ui-view>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n');
$templateCache.put('projects/projectDetailHeader.html','<div class="sub-header">\n\t\t<div class="content">\n\t\t\t\t<a ng-click="Navigation.back(\'community.ip.families\')" class="sub-header-back"\n\t\t\t\t\t ng-if="!vm.expertsChooserDelegate.shown && vm.showBack">\n\t\t\t\t\t\t<i class="sub-header-back__icon icon icon-arrow-left"></i>\n\t\t\t\t</a>\n\n\t\t\t\t<a class="sub-header-back" ng-if="vm.expertsChooserDelegate.shown"\n\t\t\t\t\t ng-click="vm.expertsChooserDelegate.hide()">\n\t\t\t\t\t\t<i class="sub-header-back__icon icon icon-delete-line"></i>\n\t\t\t\t</a>\n\n\t\t\t\t<h2 class="sub-header__title">{{ ::vm.project.title }}</h2>\n\t\t\t\t<!--cmnt-editable-title model="vm.project" field="title" on-finish-editing="vm.updateTitle(vm.project)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(vm.project.direction==\'outgoing\')" extra-class="sub-header__title"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t direction="inline" button-size="m" field-class="sub-header__field">\n\t\t\t\t\t\t<span>{{ vm.project.title }}</span>\n\t\t\t\t</cmnt-editable-title-->\n\t\t</div>\n</div>\n');
$templateCache.put('projects/projectDirectionFilter.directive.html','<div class="select select_theme_gray select_size_s select_placeholder-i select_width_160 filter__select">\n\t\t<label class="select__label" ng-if="!vm.hideLabel">{{ ::vm.label }}</label>\n\t\t<ui-select ng-model="vm.direction" name=\'direction\' ng-change="vm.directionChanged()">\n\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t<i class="icon" ng-class="$select.selected.icon"></i>\n\t\t\t\t\t\t<span ng-bind="$select.selected.title"></span>\n\t\t\t\t</ui-select-match>\n\t\t\t\t<ui-select-choices repeat="o.value as o in vm.directionOptions">\n\t\t\t\t\t\t<i class="icon" ng-class="o.icon"></i>\n\t\t\t\t\t\t<span ng-bind-html="o.title"></span>\n\t\t\t\t</ui-select-choices>\n\t\t</ui-select>\n</div>\n');
$templateCache.put('projects/projectOrdering.directive.html','<div class="select select_without-border select_size_s select_fixed-width_150 sub-filter__select select_icon-mode"\n\t\t ng-class="vm.selectTheme">\n\t\t<i class="select__icon icon icon-filter" ng-class="vm.iconExtraClass"></i>\n\t\t<ui-select ng-model="vm.ordering" search-enabled="false" ng-change="vm.orderingChanges()">\n\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t</ui-select-match>\n\t\t\t\t<ui-select-choices repeat="orderingOption.value as orderingOption in vm.orderingOptions">\n\t\t\t\t\t\t<span ng-bind="orderingOption.label"></span>\n\t\t\t\t</ui-select-choices>\n\t\t</ui-select>\n</div>\n');
$templateCache.put('projects/projectPlaceholder.directive.html','<div class="case case_placeholder">\n\t\t<div class="case-sub-header">\n\t\t\t\t<div class="case-sub-header__icon case-sub-header__icon_fake"></div>\n\t\t\t\t<h3 class="case-sub-header__title"><span>Patent in All countries</span></h3>\n\t\t</div>\n\t\t<div class="case-header">\n\t\t\t\t<div class="case-header__checkbox" cmnt-stop-propagation>\n\t\t\t\t\t\t<label class="checkbox case__checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t<!--<span class="checkbox__title">Select</span>-->\n\t\t\t\t\t\t\t\t<div class="fake-checkbox case-header__fake-checkbox"></div>\n\t\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t\t\t<div class="case-header-list">\n\t\t\t\t\t\t<div class="case-header-list__item">\n\t\t\t\t\t\t\t\t<span>Patent</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-header-list__item">\n\t\t\t\t\t\t\t\t<span>Belarus</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-header-list__item">\n\t\t\t\t\t\t\t\t<span>Foreign Associate</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="case-header__activity">\n\t\t\t\t\t\t<span>2 days ago</span>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="case-body">\n\t\t\t\t<div class="case-person">\n\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t<div class="case-person-pic__img"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm"><span>Root Organization</span></h4>\n\t\t\t\t\t\t\t\t<div class="case-person-info__name"><span>John Smith</span></div>\n\t\t\t\t\t\t\t\t<div class="case-person-info-status">\n\t\t\t\t\t\t\t\t\t\t<span>Enquiry</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="case-person">\n\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t<div class="case-person-pic__img"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm"><span>John Smith</span></h4>\n\t\t\t\t\t\t\t\t<div class="case-person-info__name"><span>Root Organization</span></div>\n\t\t\t\t\t\t\t\t<div class="case-person-info-status">\n\t\t\t\t\t\t\t\t\t\t<span>Enquiry</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="case-footer">\n\t\t\t\t<div class="case-footer-pane">\n\t\t\t\t</div>\n\t\t\t\t<div class="case-footer-pane">\n\t\t\t\t\t\t<span>View case la-la-la</span>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('projects/projectStatusFilter.directive.html','<div class="select select_theme_gray select_size_s select_width_160 filter__select">\n\t\t<label class="select__label">Status</label>\n\t\t<ui-select ng-model="vm.status" search-enabled="true" ng-change="vm.statusChanged()">\n\t\t\t\t<ui-select-match allow-clear="true" placeholder="All">\n\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t</ui-select-match>\n\t\t\t\t<ui-select-choices repeat="statusOption.value as statusOption in vm.statusOptions">\n\t\t\t\t\t\t<span ng-bind="statusOption.label"></span>\n\t\t\t\t</ui-select-choices>\n\t\t</ui-select>\n</div>\n');
$templateCache.put('projects/projects.html','<ui-view name="projectsList" ng-show="$state.includes(\'community.projects.projectsList\')"></ui-view>\n<ui-view name="projectsDetail" ng-show="$state.includes(\'community.projects.projectsDetail\')"></ui-view>\n');
$templateCache.put('projects/projectsList.html','<section class="filter">\n\t\t<div class="ip-content">\n\t\t\t\t<h3 class="filter__title">Instructions</h3>\n\t\t\t\t<div class="filter-pane">\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_align-bottom">\n\t\t\t\t\t\t\t\t<cmnt-project-direction-filter\n\t\t\t\t\t\t\t\t\t\t\t\tdirection="vm.direction"\n\t\t\t\t\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)">\n\t\t\t\t\t\t\t\t</cmnt-project-direction-filter>\n\n\t\t\t\t\t\t\t\t<cmnt-project-status-filter\n\t\t\t\t\t\t\t\t\t\t\t\tstatus="vm.status"\n\t\t\t\t\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)"\n\t\t\t\t\t\t\t\t\t\t\t\tshow-draft-option="true">\n\t\t\t\t\t\t\t\t</cmnt-project-status-filter>\n\n\t\t\t\t\t\t\t\t<cmnt-jurisdiction-filter\n\t\t\t\t\t\t\t\t\t\t\t\tmatter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\tdefining="vm.jurisdiction"\n\t\t\t\t\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)">\n\t\t\t\t\t\t\t\t</cmnt-jurisdiction-filter>\n\n\t\t\t\t\t\t\t\t<form ng-submit="vm.searchChanged()" class="filter__form">\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_100">\n\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Find..." name="search"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.search" ng-blur="vm.searchChanged()"/>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="field__button" type="submit">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_offset-left">\n\t\t\t\t\t\t\t\t<a ng-click="Navigation.go(\'community.wizard\')"\n\t\t\t\t\t\t\t\t\t class="button button_size_s button_color_blue button_nowrap">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\tNew Price Quote\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n\n<div class="black-background-content">\n\t\t<div class="content content_fixed-height">\n\t\t\t\t<section class="sub-filter">\n\t\t\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t\t\t<cmnt-project-ordering ordering="vm.ordering" on-ordering-changed="vm.orderingChanged(newValues)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t select-theme="select_theme_light" icon-extra-class="icon_color_white">\n\t\t\t\t\t\t\t\t</cmnt-project-ordering>\n\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-white" ng-show="vm.ProjectsList.hasGroups">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-checked="vm.ProjectsList.groupByFamily"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.toggleGrouping()">\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">Group by Family</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="sub-filter-pane sub-filter-pane_theme-white">\n                <span ng-if="vm.ProjectsList.selectedProjects.length > 0">\n                    <strong class="sub-filter-pane__selected-number">{{ vm.ProjectsList.selectedProjects.length }}</strong> selected\n                </span>\n\n\t\t\t\t\t\t\t\t<div class="sub-filter-pane__item icons-menu-list icons-menu-list_theme_light">\n\t\t\t\t\t\t\t\t\t\t<button class="icons-menu-list__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="vm.archive()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tconfirm-title="Are you sure?"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tconfirm-message="This action will hide selected projects for you and your team members."\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.ProjectsList.isArchivePossible()">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icons-menu-list__icon_color_pink icon icon-delete"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tArchive\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button class="icons-menu-list__item" ng-if="vm.ProjectsList.isClonePossible()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.ProjectsList.clone()">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icons-menu-list__icon icons-menu-list__icon_color_blue icon icon-clone"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tClone\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<a href="#" class="sub-filter-pane__link" ng-click="vm.ProjectsList.selectAll()">Select All</a>\n\t\t\t\t\t\t\t\t<a href="#" class="sub-filter-pane__link" ng-click="vm.ProjectsList.selectNone()">Select None</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<div class="cases-grid" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t\t\t ng-if="!(vm.ProjectsList.groupByFamily && vm.ProjectsList.hasGroups) && !vm.ProjectsList.dataChange"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.ProjectsList.projects.$resolved">\n\t\t\t\t\t\t<cmnt-project project="project"\n\t\t\t\t\t\t\t\t\t\t\t\t\ton-selection-change="vm.ProjectsList.onSelectionChanged(project)"\n\t\t\t\t\t\t\t\t\t\t\t\t\tanimated="vm.animateTiles"\n\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="project in vm.ProjectsList.projects">\n\t\t\t\t\t\t</cmnt-project>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="cases-grid" infinite-scroll="vm.loadMore()" infinite-scroll-distance=\'1\'\n\t\t\t\t\t\t ng-if="vm.ProjectsList.groupByFamily && vm.ProjectsList.hasGroups && !vm.ProjectsList.dataChange"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.ProjectsList.projects.$resolved">\n\t\t\t\t\t\t<div class="case-group"\n\t\t\t\t\t\t\t\t ng-repeat="(familyId, projects) in vm.ProjectsList.projectsByFamily track by familyId">\n\t\t\t\t\t\t\t\t<div class="case-group-header">\n\t\t\t\t\t\t\t\t\t\t<i class="case-group-header__icon icon"\n\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'icon-inbound\': projects[0].direction === \'incoming\', \'icon-outbound\': projects[0].direction === \'outgoing\'}"\n\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ (projects[0].direction === \'incoming\')?\'Inbound\':\'Outbound\' }}"></i>\n\t\t\t\t\t\t\t\t\t\t<h3 class="case-group-header__title">{{ projects[0].title }}</h3>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<cmnt-project\n\t\t\t\t\t\t\t\t\t\t\t\tproject="project"\n\t\t\t\t\t\t\t\t\t\t\t\ton-selection-change="vm.ProjectsList.onSelectionChanged(project)"\n\t\t\t\t\t\t\t\t\t\t\t\tanimated="vm.animateTiles"\n\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="project in projects">\n\t\t\t\t\t\t\t\t</cmnt-project>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-loading-indicator class="loading-indicator_align-center loading-indicator_white-spinner"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tresource="vm.loadingMore"></cmnt-loading-indicator>\n\n\t\t\t\t<div class="cases-grid cases-grid_fade-in enable-animations"\n\t\t\t\t\t\t ng-if="vm.ProjectsList.dataChange && authGlobals.loggedIn">\n\t\t\t\t\t\t<cmnt-project-placeholder project="project" ng-repeat="i in [1,2,3,4,5,6,7,8,9,10]">\n\t\t\t\t\t\t</cmnt-project-placeholder>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-empty-result resource="vm.ProjectsList.projects" title="No cases to show"\n\t\t\t\t\t\t\t\t\t\t\t\t\t extra-class="empty-result_theme-white">\n\t\t\t\t\t\t<p ng-if="authGlobals.loggedIn">\n\t\t\t\t\t\t\t\tEither <a ng-click="Navigation.go(\'community.wizard\')">create a new case</a>\n\t\t\t\t\t\t\t\t<b>or</b> change your filtering criteria to reveal existing cases</p>\n\n\t\t\t\t\t\t<p ng-if="!authGlobals.loggedIn">\n\t\t\t\t\t\t\t\tEither <a ng-click="Navigation.go(\'community.wizard\')">create a new case</a>\n\t\t\t\t\t\t\t\t<b>or</b> <a ui-sref="community.login">log in</a> to reveal existing cases</p>\n\t\t\t\t</cmnt-empty-result>\n\t\t</div>\n</div>\n');
$templateCache.put('reports/base_report.html','<div class="reports-body" ng-class="{\'sidebar-collapsed\': uiState.filtersCollapsed}">\n\n\t\t<div class="reports-body__content">\n\n\t\t\t\t<div class="content-col">\n\t\t\t\t\t\t<div class="panel panel-general">\n\t\t\t\t\t\t\t\t<div class="panel-heading">\n\t\t\t\t\t\t\t\t\t\t<div class="title-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="title">{{ reportParams.objectsName }}</h4>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="panel-heading__view-btns flex">\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-include src="\'reports/memoboxes/headingButtons.html\'"  ng-if="reportParams.listTemplate"></ng-include>\n\t\t\t\t\t\t\t\t\t\t\t\t<a class="button button_enlarged button_color_flamingo reports-body__download" ui-sref="community.reports.export_results">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="reports-body__projects reports-body__projects_no-border-radius" ng-if="uiState.view == \'list\' && reportParams.listTemplate">\n\t\t\t\t\t\t\t\t\t\t<ng-include src="reportParams.listTemplate"></ng-include>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="panel-body" ng-if="uiState.view==\'reports\'">\n\t\t\t\t\t\t\t\t\t<!--<div class="list-with-label-holder shifted-left fade-out"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'fade-in\': selectionService.selectionLength > 0, \'fade-out\': selectionService.selectionLength === 0}">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="list-label">With Selected ({{ selectionService.selectionLength }})</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-include src="reportParams.bulkActionsTemplate"></ng-include>\n\t\t\t\t\t\t\t\t\t\t</div>-->\n\n\t\t\t\t\t\t\t\t\t\t<ul class="items">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="items-header clearfix">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--<div class="reports-body__all-checkbox pull-left">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="selectionService.all"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="selectionService.toggleAll(selectionService.all)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="!objects.$resolved">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">All</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>-->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="pull-left list-sort">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="list-item list-item_ml-0">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="list-label">Sort by:</span>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="right"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="dropdown-sort hamburger-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'desc\': uiState.order.indexOf(\'-\') === 0, \'no-sort\': uiState.orderLabel === \'None\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href class="dropdown-sort__link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'disabled\': !objects.$resolved, \'desc\': uiState.order.indexOf(\'-\') === 0, \'asc\': uiState.order.indexOf(\'-\') !== 0}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ uiState.orderLabel }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="column in columns|filter:{sorting_key:\'!!\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="orderBy(column.sorting_key, column.title, $close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ column.title }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="list-item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button ng-disabled="!objects.$resolved" class="button button_transparent btn-link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="showColumns()">Show\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="pull-right">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="list-with-label-holder">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<export export-url="{{ reportParams.exportUrl }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tformats="reportParams.exportFormats"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfiltering="filteringService" ordering="orderingService">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</export>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="table-responsive">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<table class="table-container table-container_striped report-style">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--<<th></th>-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<th ng-repeat="column in columns">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="orderBy(column.sorting_key, column.title)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ column.title }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</th>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</thead>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-repeat="object in objects">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--<td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t checklist-model="selectionService.model"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t checklist-value="object.id"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="selectionService.checkBoxClick(object.id)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox" cmnt-stop-propagation></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td class="reports-body__media-body" ng-repeat="column in columns"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-include="\'reports/_table_cells/\' + column.type + \'.html\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<tr ng-show="!objects.$resolved || objects.length === 0">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<td colspan="100">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-loading-indicator resource="objects"></cmnt-loading-indicator>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-empty-result resource="objects" title="No data available."\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t extra-class="reports-body__empty-result">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-empty-result>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</tbody>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</table>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<nav class="pagination-holder">\n\t\t\t\t\t\t\t\t<pagination ng-if="objects.$resolved" items-per-page="paginationService.pageSize"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttotal-items="paginationService.totalItems" max-size="paginationService.maxSize"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpage="paginationService.currentPage" on-select-page="changePage()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tprevious-text="<" next-text=">"></pagination>\n\t\t\t\t\t\t</nav>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Search sidebar -->\n\n\t\t\t\t<div class="sidebar-col">\n\t\t\t\t\t\t<div class="panel panel-general">\n\t\t\t\t\t\t\t\t<div class="panel-heading">\n\t\t\t\t\t\t\t\t\t\t<div class="title-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="title">Search by</h4>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="header-panel-nav">\n\t\t\t\t\t\t\t\t\t\t\t\t<a href="" class="search-arrow" ng-click="uiState.filtersCollapsed=!uiState.filtersCollapsed"><i\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="icon icon-chevron-right"></i></a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="panel-body">\n\t\t\t\t\t\t\t\t\t\t<div class="search-sidebar">\n\t\t\t\t\t\t\t\t\t\t\t\t<form>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-filtering filtering="filteringService" filters="baseFilters"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-search="applyFilters()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvisible-filters-count="reportParams.visibleFiltersCount"></cmnt-filtering>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="search-sidebar__actions button-group button-group_align-space-between">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button" ng-click="clearFilters()">Clear\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_pink" ng-click="applyFilters()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i> Search\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t</form>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="saved">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="search-header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4>System reports</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="search-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-loading-indicator resource="storedQueries"></cmnt-loading-indicator>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li ng-repeat="sq in storedQueries|filter:{\'is_default\': true}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{active: sq.id === filteringService.storedQuery.id}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="loadQuery(sq)">{{ sq.name }}</a>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="filteringService.storedQuery.id === sq.id"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="actions-holder button-group_compact button-group">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_xs button_color_white button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="openSaveDropdownFunc($event, \'save\')" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Save as</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="search-header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4>Your reports</h4>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--a href="" ng-click="toggleDropdown($event, \'save\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tSave search...\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="right" pane-offset="-50"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="search-sidebar__dropdown" open-save-dropdown>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="">Save search...</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-click="$event.stopPropagation();">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Save this Search as:</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="field__text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="filteringService.newQuery.name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="Query name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="button-group button-group_align-space-between search-sidebar__dropdown-buttons">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button ng-if="!filteringService.storedQuery.is_default"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_color_pink"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="saveQuery()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!(filteringService.newQuery.name)">Save\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button ng-if="filteringService.storedQuery.id"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_transparent button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="saveQueryAsNew()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!(filteringService.newQuery.name)">Save as New\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="search-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-loading-indicator resource="storedQueries"></cmnt-loading-indicator>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li ng-repeat="sq in storedQueries|filter:{\'is_default\': false}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{active: sq.id === filteringService.storedQuery.id}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" ng-click="loadQuery(sq)">{{ sq.name }}</a>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="filteringService.storedQuery.id === sq.id"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="actions-holder button-group_compact button-group">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_xs button_color_white button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="openSaveDropdownFunc($event, \'save\')" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Update</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_xs button_color_white button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="deleteQuery(sq)" type="button">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDelete\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t</div>\n\n</div>\n');
$templateCache.put('reports/reports.html','<section class="head-report">\n\t\t<div class="head-report__inner">\n\t\t\t\t<div class="head-report__content">\n\t\t\t\t\t\t<h2 class="head-report__title">REPORTS</h2>\n\t\t\t\t\t\t<p class="head-report__description">Here are some reports of your IP in a flexible format</p>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<section class="filter filter_tasks filter_response_v2 filter_response_v3">\n\t\t<div class="filter-pane">\n\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t<div class="choose-params">\n\t\t\t\t\t\t\t\t<div class="choose-params__label">Show</div>\n\t\t\t\t\t\t\t\t<div class="choose-params__buttons">\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button choose-params__button_wihout-icon"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tui-sref="community.reports.projects" ui-sref-active="button_color_flamingo_active">\n\t\t\t\t\t\t\t\t\t\t\t\tALL IP\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button choose-params__button_wihout-icon"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tui-sref="community.reports.tasks" ui-sref-active="button_color_flamingo_active">\n\t\t\t\t\t\t\t\t\t\t\t\tTasks\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button choose-params__button_wihout-icon"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tui-sref="community.reports.events" ui-sref-active="button_color_flamingo_active">\n\t\t\t\t\t\t\t\t\t\t\t\tActivity\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<ui-view></ui-view>\n');
$templateCache.put('selectizem/choices.tpl.html','<div class="multiselect-scroll">\n\t\t<div class="multiselect-list ui-select-choices-content">\n\t\t\t\t<div role="option" class="ui-select-choices-row multiselect-list__item"\n\t\t\t\t\t\t ng-class="{active: $select.isActive(this)}">\n\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t<span class="ui-select-choices-row-inner"></span>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('selectizem/match-multiple.tpl.html','<label class="multiselect-header-values__item ui-select-match" ng-repeat="$item in $select.selected track by $index"\n\t\t\t ng-class="{\'select-locked\':$select.isLocked(this, $index)}" ui-select-sort="$select.selected">\n\t\t<i class="multiselect-header-values__icon icon icon-cancel"\n\t\t\t ng-hide="$select.disabled||$select.isLocked(this, $index)"\n\t\t\t ng-click="$selectMultiple.removeChoice($index)"></i>\n\t\t<span uis-transclude-append=""></span>\n</label>\n');
$templateCache.put('selectizem/match.tpl.html','<div ng-hide="$select.searchEnabled && ($select.open || $select.isEmpty())" class="ui-select-match">\n    <span ng-show="!$select.searchEnabled && ($select.isEmpty() || $select.open)"\n\t\t\t\t\tclass="ui-select-placeholder text-muted">{{$select.placeholder}}</span>\n\t\t<span ng-hide="$select.isEmpty() || $select.open" ng-transclude=""></span>\n</div>\n');
$templateCache.put('selectizem/no-choice.tpl.html','<div class="ui-select-no-choice selectize-dropdown" ng-show="$select.items.length == 0">\n\t\t<div class="selectize-dropdown-content">\n\t\t\t\t<div data-selectable="" ng-transclude=""></div>\n\t\t</div>\n</div>\n');
$templateCache.put('selectizem/select-multiple.tpl.html','<div class="multiselect" ng-class="{\'open\': $select.open, \'multiselect_disabled\': $select.disabled}">\n\n\t\t<div class="multiselect-header">\n\t\t\t\t<div class="multiselect-header-values">\n\t\t\t\t\t\t<div class="ui-select-match"></div>\n\t\t\t\t\t\t<button class="multiselect-header-add" ng-click="$select.toggle($event)">\n\t\t\t\t\t\t\t\t<i class="multiselect-header-add__icon icon icon-plus-circle"></i>\n\t\t\t\t\t\t\t\t<span class="multiselect-header-add__label" ng-hide="$select.selected.length>=1">Add {{ $select.addLabel }}</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="multiselect-body" ng-show="$select.open">\n\t\t\t\t<button class="multiselect-close" ng-click="$select.toggle($event)">\n\t\t\t\t\t\t<i class="multiselect-close__icon icon icon-cancel"></i>\n\t\t\t\t</button>\n\t\t\t\t<div class="multiselect-body-title">\n\t\t\t\t\t\t<i class="multiselect-body-title__icon icon icon-plus-circle"></i>\n\t\t\t\t\t\tAdd {{ $select.addLabel }}\n\t\t\t\t</div>\n\t\t\t\t<div class="multiselect-search">\n\t\t\t\t\t\t<input type="text" autocomplete="off" tabindex="-1" class="multiselect-search__text ui-select-search"\n\t\t\t\t\t\t\t\t\t ng-class="{\'ui-select-search-hidden\':!$select.searchEnabled}"\n\t\t\t\t\t\t\t\t\t placeholder="Find..." ng-model="$select.search"\n\t\t\t\t\t\t\t\t\t ng-disabled="$select.disabled" ondrop="return false;">\n\t\t\t\t\t\t<button class="multiselect-search__button">\n\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class="ui-select-choices"></div>\n\t\t\t\t<div class="ui-select-no-choice"></div>\n\t\t</div>\n\n</div>\n');
$templateCache.put('selectizem/select.tpl.html','<div class="ui-select-container selectize-control single selectizem" ng-class="{\'open\': $select.open}">\n\t\t<div class="selectize-input"\n\t\t\t\t ng-class="{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}"\n\t\t\t\t ng-click="$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()">\n\t\t\t\t<div class="ui-select-match"></div>\n\t\t\t\t<input type="search" autocomplete="off" tabindex="-1" class="ui-select-search ui-select-toggle"\n\t\t\t\t\t\t\t ng-class="{\'ui-select-search-hidden\':!$select.searchEnabled}" ng-click="$select.toggle($event)"\n\t\t\t\t\t\t\t placeholder="{{$select.placeholder}}" ng-model="$select.search"\n\t\t\t\t\t\t\t ng-hide="!$select.isEmpty() && !$select.open" ng-disabled="$select.disabled"\n\t\t\t\t\t\t\t aria-label="{{ $select.baseTitle }}"></div>\n\t\t<div class="ui-select-choices"></div>\n\t\t<div class="ui-select-no-choice"></div>\n</div>\n');
$templateCache.put('widgets/joinPrompt.directive.html','<div class="join-project join-project_expert-grid">\n\t\t<div class="join-project-userpic">\n\t\t\t\t<div class="join-project-userpic__icon">You</div>\n\t\t</div>\n\t\t<div class="join-project-content">\n\t\t\t\t<h3 class="join-project-content__title">Start getting more business</h3>\n\t\t\t\t<a ui-sref="community.login" class="join-project-content__sub-title">Join Obviously Manage</a>\n\t\t\t\t<p class="join-project-content__text">Ensure your name appears in this list when people are searching for IP\n\t\t\t\t\t\tLawyers</p>\n\t\t</div>\n</div>\n');
$templateCache.put('widgets/jurisdictionFilter.directive.html','<div class="filter__select-group">\n\t\t<div class="select select_theme_gray select_size_s select_width_180 filter__select">\n\t\t\t\t<label class="select__label">{{ ::vm.matterTypeLabel }}</label>\n\t\t\t\t<ui-select ng-model="vm.matterType" ng-change="vm.onMatterTypeChanged()">\n\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="All">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.title"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\trepeat="matterType.id as matterType in (vm.matterTypes | filter: $select.search) track by matterType.id">\n\t\t\t\t\t\t\t\t<span ng-bind="matterType.title"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t</ui-select>\n\t\t</div>\n\n\t\t<div class="select select_theme_gray select_size_s select_width_250 filter__select">\n\t\t\t\t<label class="select__label">{{ ::vm.jurisdictionLabel }}</label>\n\t\t\t\t<ui-select ng-model="vm.defining" ng-change="vm.onDefiningChanged()"\n\t\t\t\t\t\t\t\t\t ng-disabled="!vm.matterType">\n\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="All">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\trepeat="defining.id as defining in (vm.definings | filter: $select.search) track by defining.id">\n\t\t\t\t\t\t\t\t<span ng-bind="defining.value"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t</ui-select>\n\t\t</div>\n</div>\n');
$templateCache.put('widgets/passwordStrength.directive.html','<div class="field-group-line" ng-show="vm.barsAmount > 0">\n\t\t<div class="field-group-line__item" ng-class="\'field-group-line__item_\' + vm.strengthLevel.value">\n\t\t\t\t<span ng-show="vm.barsAmount >= 1"></span>\n\t\t\t\t<span ng-show="vm.barsAmount >= 2"></span>\n\t\t\t\t<span ng-show="vm.barsAmount >= 3"></span>\n\t\t</div>\n\t\t<div class="field-group-line__label">{{ vm.strengthLevel.label }}</div>\n</div>\n');
$templateCache.put('widgets/starRating.directive.html','<div class="rating" ng-class="vm.extraClass">\n\t\t<i class="rating__icon icon" ng-repeat="star in vm.stars track by $index"\n\t\t\t ng-class="{\'icon-star\':star.filled, \'icon-star-half\':star.half, \'icon-star-empty\':star.empty}"></i>\n</div>\n');
$templateCache.put('widgets/testimonial.directive.html','<div class="quote quote_expert-grid">\n\t\t<i class="quote__icon icon icon-quote"></i>\n\t\t<div class="quote__text">\n\t\t\t\t{{ ::vm.testimonial.text }}\n\t\t</div>\n\t\t<div class="quote-autor">\n\t\t\t\t<div class="quote-autor__name">\n\t\t\t\t\t\t{{ ::vm.testimonial.name }}\n\t\t\t\t</div>\n\t\t\t\t<div class="quote-autor__company">\n\t\t\t\t\t\t{{ ::vm.testimonial.firm }}\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('wizard/attachments.directive.html','<div class="upload-file">\n\t\t<div class="upload-file-attach" ng-file-select ng-file-change="vm.startUploading($files)" ng-multiple="true">\n\t\t\t\t<i class="upload-file-attach__icon icon icon-attach"></i>\n\t\t</div>\n\t\t<div class="alert alert_theme_default" ng-if="vm.attachmentSizeWarning">\n\t\t\t\t{{ vm.attachmentSizeWarning }}\n\t\t</div>\n\t\t<div class="upload-file-list" ng-if="vm.attachments.length">\n\t\t\t\t<div class="upload-file-list-item" ng-repeat="attachment in vm.attachments">\n\t\t\t\t\t\t<div class="upload-file-list-item__name">\n\t\t\t\t\t\t\t\t<i class="icon-file icon"></i>\n\t\t\t\t\t\t\t\t{{ attachment.name }}\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="upload-file-list-item__progress">\n\t\t\t\t\t\t\t\t<div class="upload-file-list-item__error" ng-if="attachment.error">{{ attachment.error }}</div>\n\t\t\t\t\t\t\t\t<div class="progress-bar progress-bar_size_m" ng-if="!attachment.error && attachment.uploadingProcess"\n\t\t\t\t\t\t\t\t\t\t ng-style="{width: (attachment.progress || 0) + \'%\'}">\n\t\t\t\t\t\t\t\t\t\t{{ attachment.progress || 0 }}%\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="upload-file-list-item__delete" ng-click="vm.removeAttachment(attachment)">\n\t\t\t\t\t\t\t\t<i class="icon-delete icon"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('wizard/wizard.html','<div class="wizard" ng-hide="vm.expertsChooserDelegate.shown">\n\t\t<div class="wizard-step wizard-step_bg-white"\n\t\t\t\t ng-class="{\'wizard-step_disabled\': vm.task, \'wizard-step_completed\': vm.task}">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="wizard-step-title">\n\t\t\t\t\t\t\t\t<div class="wizard-step-title__number">1</div>\n\t\t\t\t\t\t\t\t<div class="wizard-step-title-name">\n\t\t\t\t\t\t\t\t\t\t<h3 class="wizard-step-title-name__title">Add new IP to Obviously Manage</h3>\n\t\t\t\t\t\t\t\t\t\t<label class="wizard-step-title-name__label">Describe the new IP that you wish to add to\n\t\t\t\t\t\t\t\t\t\t\t\tObviously Manage</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="wizard-step-body">\n\t\t\t\t\t\t\t\t<div class="wizard-step-form">\n\t\t\t\t\t\t\t\t\t\t<form name="vm.familyForm" cmnt-handle-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_150 select_maxwidth_250">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">IP Type</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.matterType" name=\'matterType\' ng-change="vm.matterTypeChanged()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="vm.subMatter!==undefined">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.title"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="matterType.id as matterType in vm.matterTypes|filter:{title:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="matterType.title | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i" cmnt-field-errors\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'field_error-manual\': !vm.projectTitle && vm.familyForm.title.$touched}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">IP Family Name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder" type="text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.projectTitle" name="title" maxlength="128"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.projectTitleChanged()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="Add a short descriptive name for this case and any relevant reference numbers">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__errors-manual"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-show="!vm.projectTitle && vm.familyForm.title.$touched">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__error-item">Name is required.</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.definings.length"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\twhen="{\'one\': \'Jurisdiction\', \'other\': \'Jurisdictions\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.definings" name=\'definings\' ng-disabled="!vm.matterType" multiple\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.processSelectsChange()" theme="selectizem" close-on-select="false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t selectizem\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t add-label="Jurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ $item.value }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="defining.id as defining in vm.jurisdictions|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="defining.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group-flex-list wizard-step-form__custom-numbers"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.coutriesPrices && vm.definings.length > 0">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group-flex field-group-flex_align-center">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCountry\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tOfficial Fee\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEstimated Service Fee\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEstimated Total\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group-flex field-group-flex_align-center"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-repeat="defining in vm.definings">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.coutriesPrices[defining].repr }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.coutriesPrices[defining].official.formatted || \'N/A\' }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.coutriesPrices[defining].service.formatted || \'N/A\' }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.coutriesPrices[defining].sum.formatted || \'N/A\' }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t\t\t<cmnt-wizard-pct ng-if="::vm.pct" pct="vm.pct" definings="vm.definings"></cmnt-wizard-pct>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="wizard-step"\n\t\t\t\t ng-class="{\'wizard-step_disabled\': vm.stepTwoDisabled() || vm.task, \'wizard-step_completed\': vm.task}">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="wizard-step-title">\n\t\t\t\t\t\t\t\t<div class="wizard-step-title__number">2</div>\n\t\t\t\t\t\t\t\t<div class="wizard-step-title-name">\n\t\t\t\t\t\t\t\t\t\t<h3 class="wizard-step-title-name__title">What is the next task?</h3>\n\t\t\t\t\t\t\t\t\t\t<label class="wizard-step-title-name__label">What is the next thing that needs to be done with this\n\t\t\t\t\t\t\t\t\t\t\t\tcase</label>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s wizard-step-title-name__skip-button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.createFamily()">Skip this. Add a task later.\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="wizard-step-body">\n\t\t\t\t\t\t\t\t<div class="wizard-step-form">\n\t\t\t\t\t\t\t\t\t\t<form name="vm.taskForm" cmnt-handle-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i" cmnt-field-errors\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'field_error-manual\': !vm.taskTitle && vm.taskForm.taskTitle.$touched}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Choose or type</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder field__text_width-half" type="text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.taskTitle" autocomplete="off"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t typeahead="expertiseType.value for expertiseType in vm.expertiseTypes | filter:{value:$viewValue}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t typeahead-on-select="vm.taskExpertiseTypeSelected($item)" typeahead-min-length="0"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="taskTitle" maxlength="128" ng-change="vm.taskTitleChanged()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__errors-manual" ng-show="!vm.taskTitle && vm.taskForm.taskTitle.$touched">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field__error-item">Title is required.</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">What is due data / deadline? (optional)</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder field__text_width-100" type="text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.taskDueDate" name="taskDueDate" moment-picker="vm.taskDueDate"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t today="true" ng-model-options="{ updateOn: \'blur\' }">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="wizard-step wizard-step_bg-white" ng-class="{\'wizard-step_disabled\': vm.stepThreeDisabled()}">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="wizard-step-title">\n\t\t\t\t\t\t\t\t<div class="wizard-step-title__number">3</div>\n\t\t\t\t\t\t\t\t<div class="wizard-step-title-name">\n\t\t\t\t\t\t\t\t\t\t<h3 class="wizard-step-title-name__title">Get Quotes From IP Experts</h3>\n\t\t\t\t\t\t\t\t\t\t<label class="wizard-step-title-name__label">Choose one or more firms/experts to discuss this case\n\t\t\t\t\t\t\t\t\t\t\t\twith and obtain quotes. Note: you will later decide from their responses who you\'d like to\n\t\t\t\t\t\t\t\t\t\t\t\tformally instruct.</label>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s wizard-step-title-name__skip-button" ng-hide="vm.task"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.createTask()">Skip this. Get Quotes later.\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="wizard-step-body">\n\t\t\t\t\t\t\t\t<div class="wizard-step-experts">\n\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-form">\n\t\t\t\t\t\t\t\t\t\t\t\t<form name="vm.enquiryForm" cmnt-handle-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group-flex-list wizard-step-form__custom-numbers">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group-flex field-group-flex_align-center"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-repeat="jurisdiction in vm.jurisdictions|filter:vm.customNumbersFilter|orderBy:\'value\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item field-group-flex__item_maxwidth_65"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-init="vm.initCustomNumber(jurisdiction)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ jurisdiction.value }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i field-group-flex__item field-group-flex__item_maxwidth_130">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="field__text" placeholder="Reference Number"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t maxlength="15" ng-model="vm.customNumbersModels[jurisdiction.id].number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label field-group-flex__item field-group-flex__item_maxwidth_75">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEmail Subject\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_placeholder-i\n                                                field-group-flex__item wizard-step-form__custom-numbers-subject">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="field__text wizard-step-form__custom-numbers-subject-number">{{ vm.customNumbersModels[jurisdiction.id].number }}&nbsp;</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="field__text wizard-step-form__custom-numbers-subject-text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="Email Subject"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t maxlength="300"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.customNumbersModels[jurisdiction.id].subject">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field-textarea field_size_s field_theme_gray" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Give the Experts more information about the task</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<text-angular class="field__text" ng-model="vm.detailsTextTemplate"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-file-drop="vm.fileDropHandler" required name="template_text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-text-editor-class="field__text">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</text-angular>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-form__actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-cc-my-email></cmnt-cc-my-email>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_attach" ng-file-select ng-multiple="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-file-change="vm.UploadService.startUploading($files)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-attach-file"></i> Attach\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-attachments-list service="vm.UploadService"></cmnt-attachments-list>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--<cmnt-attachments uploaded-files="vm.detailsUploadedFiles"></cmnt-attachments>-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_250 filter__select"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-show="vm.isServicesShowed">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="select__label">Are you looking for one of these services?</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.expertiseType" name=\'expertiseType\' ng-disabled="!vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.processFiltersChange()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="expertiseType.id as expertiseType in vm.expertiseTypes|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="expertiseType.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-text" ng-show="vm.isServicesShowed">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tChoosing an Obviously Manage pre-approved service often means you will get a response from the most\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trelevant person and that the response will arrive faster\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-experts-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'wizard-step-experts-menu_hidden\': vm.getExperts().length === 0}">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-experts-menu__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" class="wizard-step-experts-menu__link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.addExperts()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="wizard-step-experts-menu__icon icon-plus icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd more experts\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-experts-menu__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href class="wizard-step-experts-menu__link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.removeAllExperts()">Remove all</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-experts-add" ng-if="vm.getExperts().length === 0">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.addExperts()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="button__icon icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd experts\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="wizard-step-experts-add__title">No experts added to this case yet</h4>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<cmnt-expert-profile\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tprofile="profile"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tactive-jurisdictions="vm.definings"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-remove="vm.removeExpert(profile)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisable-no-active-jurisdictions="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="profile in vm.profiles">\n\t\t\t\t\t\t\t\t\t\t</cmnt-expert-profile>\n\n\t\t\t\t\t\t\t\t\t\t<cmnt-associate\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tassociate="associate"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tactive-jurisdictions="vm.definings"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-remove="vm.removeAssociate(associate)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tdisable-no-active-jurisdictions="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="associate in vm.associates">\n\t\t\t\t\t\t\t\t\t\t</cmnt-associate>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="wizard-step wizard-step_last" ng-class="{\'wizard-step_disabled\': vm.stepFourDisabled()}">\n\t\t\t\t<div class="content">\n\t\t\t\t\t\t<div class="wizard-step-title">\n\t\t\t\t\t\t\t\t<div class="wizard-step-title__number">4</div>\n\t\t\t\t\t\t\t\t<div class="wizard-step-title-name">\n\t\t\t\t\t\t\t\t\t\t<h3 class="wizard-step-title-name__title">Start talking</h3>\n\t\t\t\t\t\t\t\t\t\t<label class="wizard-step-title-name__label">Each recipient will get their own invitation and will\n\t\t\t\t\t\t\t\t\t\t\t\tbe unaware of the other recipients</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="wizard-step-body">\n\t\t\t\t\t\t\t\t<div class="wizard-step-send-case">\n\t\t\t\t\t\t\t\t\t\t<a href="" class="button button_size_s button_color_blue wizard-step-send-case__send-button"\n\t\t\t\t\t\t\t\t\t\t\t id="wizard-send" cmnt-spinner-action="vm.createEnquiry()">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="button__icon icon icon-email"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tSend case details and start talking\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-send-case-selected-number">\n\t\t\t\t\t\t\t\t\t\t\t\t<b class="wizard-step-send-case-selected-number__value">{{ vm.getActiveExperts().length }}</b>\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="vm.getActiveExperts().length" when="{\'one\': \'expert\', \'other\': \'experts\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-send-case-alert" ng-if="vm.stepTwoDisabled()">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="wizard-step-send-case-alert__icon icon icon-about"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tInstruction details not defined yet\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="wizard-step-send-case-alert" ng-if="vm.jurisdictionsWithouExperts.length>0">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="wizard-step-send-case-alert__icon icon icon-about"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tNo experts added for:\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="wizard-step-send-case-alert__country"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="value in vm.jurisdictionsWithouExperts track by $index">\n                            {{ value + ($last?\'\':\', \') }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n<cmnt-experts-chooser ng-if="vm.expertsChooserDelegate.shown"\n\t\t\t\t\t\t\t\t\t\t\tmatter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\tdefinings="vm.definings"\n\t\t\t\t\t\t\t\t\t\t\texpertise-type="vm.expertiseType"\n\t\t\t\t\t\t\t\t\t\t\texclude-profiles-ids="vm.wizardParams.profileIds"\n\t\t\t\t\t\t\t\t\t\t\ton-experts-selected="vm.expertsSelected(profileIds)"\n\t\t\t\t\t\t\t\t\t\t\tinput-coverage="vm.jurisdictionCoverage">\n</cmnt-experts-chooser>\n');
$templateCache.put('wizard/wizardHeader.html','<div class="sub-header">\n\t\t<div class="content">\n\t\t\t\t<a href class="sub-header-back" ng-if="!vm.expertsChooserDelegate.shown"\n\t\t\t\t\t ng-click="Navigation.back()">\n\t\t\t\t\t\t<i class="sub-header-back__icon icon icon-arrow-left"></i>\n\t\t\t\t</a>\n\t\t\t\t<a href class="sub-header-back" ng-if="vm.expertsChooserDelegate.shown"\n\t\t\t\t\t ng-click="vm.expertsChooserDelegate.hide()">\n\t\t\t\t\t\t<i class="sub-header-back__icon icon icon-delete-line"></i>\n\t\t\t\t</a>\n\t\t\t\t<h2 class="sub-header__title">{{ vm.wizardParams.title || \'New Price Quote\' }}</h2>\n\t\t</div>\n</div>\n');
$templateCache.put('wizard/wizardPct.directive.html','<div class="wizard-pct">\n\t\t<div class="wizard-pct-field">\n\t\t\t\t<div class="wizard-pct-field__label">Application</div>\n\t\t\t\t<div class="wizard-pct-field__value">{{ ::vm.pct.pct_number }}</div>\n\t\t</div>\n\n\t\t<a ng-href="{{ ::vm.pct.link }}" target="_blank" class="wizard-pct__link">View</a>\n\n\t\t<div class="wizard-pct__field-group">\n\t\t\t\t<div class="wizard-pct-field" ng-if="::vm.pct.claims_n">\n\t\t\t\t\t\t<div class="wizard-pct-field__label">Claims</div>\n\t\t\t\t\t\t<div class="wizard-pct-field__value">{{ ::vm.pct.claims_n }}</div>\n\t\t\t\t</div>\n\t\t\t\t<!--div class="wizard-pct-field" ng-if="::vm.pct.claims_w">Claims words: {{ ::vm.pct.claims_w }}</div>\n\t\t\t\t<div class="wizard-pct-field" ng-if="::vm.pct.claims_p">Claims pages: {{ ::vm.pct.claims_p }}</div-->\n\t\t\t\t<div class="wizard-pct-field" ng-if="::vm.pct.description_w">\n\t\t\t\t\t\t<div class="wizard-pct-field__label">Description</div>\n\t\t\t\t\t\t<div class="wizard-pct-field__value">{{ ::vm.pct.description_w }}\n\t\t\t\t\t\t\t\t<span class="wizard-pct-field__value-lower">words</span></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="wizard-pct-field" ng-if="::vm.pct.drawings_n">\n\t\t\t\t\t\t<div class="wizard-pct-field__label">Drawings</div>\n\t\t\t\t\t\t<div class="wizard-pct-field__value">{{ ::vm.pct.drawings_n }}</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<!--div class="wizard-pct-field" ng-if="::vm.pct.drawings_p">Drawings pages: {{ ::vm.pct.drawings_p }}</div-->\n\t\t<div class="wizard-pct-field" ng-if="vm.onlyUsdPrices">\n\t\t\t\t<div class="wizard-pct-field__label">\n\t\t\t\t\t\tCost estimate\n\t\t\t\t\t\t<i class="icon icon-help-circled" tooltip-html-unsafe="{{ ::vm.assumptions }}"\n\t\t\t\t\t\t\t tooltip-append-to-body="true" data-template-classes="wide"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class="wizard-pct-field__value">${{ vm.priceUsd|number:0 }}</div>\n\t\t</div>\n\n\t\t<div class="wizard-pct__field-group wizard-pct__field-group_align-left">\n\t\t\t\t<div class="wizard-pct-field" ng-repeat="defining in vm.definings">\n\t\t\t\t\t\t<div class="wizard-pct-field__label">{{ vm.prices[defining].value }}</div>\n\t\t\t\t\t\t<div class="wizard-pct-field__value wizard-pct-field__value_size-s">{{ vm.prices[defining].price_str ||\n\t\t\t\t\t\t\t\t\'N/A\' }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('core/forms/cmntFormErrors.directive.html','<div class="form-errors" role="alert" ng-show="form.$error.formErrors">\n\t\t<p ng-repeat="message in form.remoteMessages[\'non_field_errors\'] track by $index" class="form-errors__error">\n\t\t\t\t{{ message }}\n\t\t</p>\n</div>\n');
$templateCache.put('core/uihelpers/confirmClick.directive.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title modal-header__title_align-center">{{ title }}</h2>\n\t\t</div>\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">{{ message }}</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group button-group_compact">\n\t\t\t\t\t\t<button class="button button_size_s button_color_pink" ng-click=\'save()\'>Yes</button>\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_pink" ng-click=\'close()\' autofocus>No\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('core/uihelpers/editableTitle.directive.html','<div class="editable-title" ng-class="extraClass">\n\t\t<div ng-hide="editing" class="editable-title__container" ng-click="startTitleEditing()" cmnt-stop-propagation\n\t\t\t\t ng-transclude></div>\n\n\t\t<form ng-if="editing" cmnt-handle-errors cmnt-stop-propagation\n\t\t\t\t\tng-class="{\'field-group-flex field-group-flex_align-center\': direction==\'inline\'}">\n\t\t\t\t<div class="field" cmnt-field-errors\n\t\t\t\t\t\t ng-class="[fieldClass, {\'field-group-flex__item\': direction==\'inline\'}]">\n\t\t\t\t\t\t<input type="text" class="field__text" ng-model="model[field]" name="{{ ::field }}" ng-disabled="saving">\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-actions"\n\t\t\t\t\t\t ng-class="{\'field-group-flex__item\': direction==\'inline\', \'form-actions_small-offset-top\': direction!=\'inline\'}">\n\t\t\t\t\t\t<div class="button-group button-group_compact">\n\t\t\t\t\t\t\t\t<button ng-click="saveEditedTitle()" ng-show="editing" class="button button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="saving" ng-class="[buttonSize, {button_di1sabled: saving}]">\n\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button ng-click="cancelTitleEditing()" ng-show="editing"\n\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_transparent button_border_blue"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="saving" ng-class="[buttonSize, {button_disa1bled: saving}]">\n\t\t\t\t\t\t\t\t\t\t<span>Cancel</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('core/uihelpers/emptyResult.directive.html','<div class="empty-result" ng-if="resource.$resolved && resource.length == 0" ng-class="extraClass">\n\t\t<h3 class="empty-result__title">{{ title }}</h3>\n\t\t<p class="empty-result__text">\n\t\t\t\t<ng-transclude></ng-transclude>\n\t\t</p>\n</div>\n');
$templateCache.put('core/uihelpers/inlineArea.directive.html','<div class="inline-area" ng-class="vm.extraClass">\n\t\t<div ng-if="!vm.editing" class="inline-area__label-container" ng-click="vm.startEditing()" cmnt-stop-propagation\n\t\t\t\t ng-transclude>\n\n\t\t</div>\n\n\t\t<div ng-if="vm.editing" class="inline-area__widget-container">\n        <textarea id="{{ ::vm.textAreaId }}" ng-model="vm.newValue" ng-blur="vm.finishEditing()" msd-elastic rows="1"\n\t\t\t\t\t\t\t\t\tclass="inline-area__widget" cmnt-focus-me="true">\n        </textarea>\n\t\t</div>\n</div>\n');
$templateCache.put('core/uihelpers/inlineEdit.directive.html','<div class="inline-edit">\n\t\t<div ng-if="!vm.editing" class="inline-edit__label-container" ng-click="vm.startEditing()" cmnt-stop-propagation\n\t\t\t\t ng-transclude>\n\n\t\t</div>\n\n\t\t<div ng-if="vm.editing" class="inline-edit__widget-container">\n\n\t\t</div>\n</div>\n');
$templateCache.put('core/uihelpers/loadingIndicator.directive.html','<div class="loading-indicator">\n\t\t<div ng-show=\'resource.$resolved === false\'>\n\t\t\t\t<i class=\'icon icon-spinner icon-spin6\' ng-class="spinnerSize"></i>\n\t\t</div>\n</div>\n');
$templateCache.put('core/uihelpers/valueDropdownNoChoice.html','<div class="ui-select-choices-row">\n    <span>\n        Nothing found\n    </span>\n</div>');
$templateCache.put('core/widgets/buttonGroup.diretive.html','<div class="choose-field-list">\n\t\t<button class="choose-field-list__item" ng-repeat="choice in vm.choices"\n\t\t\t\t\t\tng-class="{\'choose-field-list__item_active\': vm.ngModel.$modelValue === choice.value}"\n\t\t\t\t\t\tng-click="vm.setValue(choice.value)">\n\t\t\t\t{{ ::choice.label }}\n\t\t</button>\n</div>\n');
$templateCache.put('core/widgets/searchField.directive.html','<form ng-submit="vm.queryChanged()" class="filter__form">\n\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_145">\n\t\t\t\t<input class="field__text" type="text" placeholder="Find..." name="search" ng-model="vm.query"\n\t\t\t\t\t\t\t maxlength="100" cmnt-focus-me="true" ng-blur="vm.searchBlur()">\n\t\t\t\t<button class="field__button" type="submit">\n\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t</button>\n\t\t</div>\n</form>\n');
$templateCache.put('ip/families/budgetToggle.directive.html','<div class="extra-button-panel">\n\n\t\t<div class="extra-button-panel__price extra-button-panel__price_wait task-header-options__absolute-label-wraper">\n        <span tooltip-append-to-body="true" tooltip-html-unsafe="{{ vm.convertedExistingLabel }}">\n            <span ng-if="vm.editSupplierBudgetInProgress && vm.task.multiplier > 1">{{ vm.task.multiplier }} * </span>\n            {{ vm.multiplied_supplier_budget.symbol }}<cmnt-inline-edit ng-model="vm.supplier_budget.amount" enable=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tinput-options="{\n                                                        type: \'number\',\n                                                        step: \'0.01\',\n                                                        class: \'extra-button-panel__input\',\n                                                        \'min-value\': \'0\',\n                                                        \'max-value\': \'99999999999999.99\',\n                                                        \'cmnt-string-to-number\': \'\',\n                                                        \'size-delta\': \'20\'\n                                                    }"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-value-changed="vm.supplierPriceChanged(oldValue, newValue)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tediting="vm.editSupplierBudgetInProgress"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tenabled="::(!vm.currentUser.is_read_only)">\n                {{ vm.multiplied_supplier_budget.formatted_no_currency }}\n            </cmnt-inline-edit>\n        </span>\n\t\t\t\t<div class="task-header-options__absolute-label task-header-options__absolute-label_budget-label">Official:\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="extra-button-panel__price task-header-options__absolute-label-wraper"\n\t\t\t\t ng-class="{\'extra-button-panel__price_yes\': vm.task.budget_status === \'included\',\n                    \'extra-button-panel__price_wait\': vm.task.budget_status === \'maybe_included\'}">\n        <span tooltip-append-to-body="true" tooltip-html-unsafe="{{ vm.convertedLabel }}">\n            <span ng-if="vm.editBudgetInProgress && vm.task.multiplier > 1">{{ vm.task.multiplier }} * </span>\n            {{ vm.multiplied_budget.symbol }}<cmnt-inline-edit ng-model="vm.number.amount" enable=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t input-options="{\n                                                        type: \'number\',\n                                                        step: \'0.01\',\n                                                        class: \'extra-button-panel__input\',\n                                                        \'min-value\': \'0\',\n                                                        \'max-value\': \'99999999999999.99\',\n                                                        \'cmnt-string-to-number\': \'\',\n                                                        \'size-delta\': \'20\'\n                                                    }"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-value-changed="vm.priceChanged(oldValue, newValue)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t editing="vm.editBudgetInProgress"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t enabled="::(!vm.currentUser.is_read_only)">\n                {{ vm.multiplied_budget.formatted_no_currency }}\n            </cmnt-inline-edit>\n        </span>\n\t\t\t\t<div class="task-header-options__absolute-label task-header-options__absolute-label_budget-label">Estimated:\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="extra-button-panel__group">\n\t\t\t\t<button ng-click="vm.setChoice(\'included\')" ng-class="{\'active\': vm.task.budget_status === \'included\'}"\n\t\t\t\t\t\t\t\tclass="extra-button-panel__button"\n\t\t\t\t\t\t\t\ttooltip-append-to-body="true" tooltip-placement="bottom" tooltip="Budget for this task">\n\t\t\t\t\t\t<i class="icon icon-confirm"></i>\n\t\t\t\t</button>\n\n\t\t\t\t<button ng-click="vm.setChoice(\'maybe_included\')"\n\t\t\t\t\t\t\t\tng-class="{\'active\': vm.task.budget_status === \'maybe_included\'}"\n\t\t\t\t\t\t\t\tclass="extra-button-panel__button"\n\t\t\t\t\t\t\t\ttooltip-append-to-body="true" tooltip-placement="bottom" tooltip="Tentatively budget for this task">\n\t\t\t\t\t\t<i class="icon icon-question"></i>\n\t\t\t\t</button>\n\n\t\t\t\t<button ng-click="vm.setChoice(\'not_included\')" ng-class="{\'active\' : vm.task.budget_status === \'not_included\'}"\n\t\t\t\t\t\t\t\tclass="extra-button-panel__button"\n\t\t\t\t\t\t\t\ttooltip-append-to-body="true" tooltip-placement="bottom" tooltip="Discard this task">\n\t\t\t\t\t\t<i class="icon icon-delete-line"></i>\n\t\t\t\t</button>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families/calendly.modal.html','<div class="modal">\n\t\t<div class="modal-body">\n\t\t\t\t<div class="calendly-inline-widget" data-url="{{ vm.portal.calendly }}"\n\t\t\t\t\t\t style="min-width:320px;height:580px;"></div>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t<button class="button button_size_s button_color_blue" ng-click="$close()">Close</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families/countsByType.directive.html','<div class="showing showing_theme-white">\n\t\t<h5 class="showing__title">Total:</h5>\n\t\t<ul class="showing-list">\n\t\t\t\t<li class="showing-list__item" ng-repeat="(id, countsData) in vm.countsByType">\n\t\t\t\t\t\t{{ countsData.results.families }} {{ countsData.label }}\n\t\t\t\t\t\t<ng-pluralize count="countsData.results.families"\n\t\t\t\t\t\t\t\t\t\t\t\t\twhen="{\'one\': \'family\', \'other\': \'families\'}"></ng-pluralize>\n\t\t\t\t\t\t.\n\t\t\t\t\t\t{{ countsData.results.members }} family\n\t\t\t\t\t\t<ng-pluralize count="countsData.results.members"\n\t\t\t\t\t\t\t\t\t\t\t\t\twhen="{\'one\': \'member\', \'other\': \'members\'}"></ng-pluralize>\n\t\t\t\t\t\t.\n\t\t\t\t</li>\n\n\t\t\t\t<li class="showing-list__item" ng-if="!vm.families.$resolved">...</li>\n\t\t</ul>\n</div>\n');
$templateCache.put('ip/families/dropdown.directive.html','<div class="hamburger-menu hamburger-menu_offset-small" id="burgerStep">\n\t\t<button ng-click="vm.toggleMenu()"\n\t\t\t\t\t\tclass="button button_size_s button_color_blue button_nowrap hamburger-menu__button">\n\t\t\t\t<i class="icon icon-fetch"></i> Fetch IP\n\t\t</button>\n\t\t<ul class="hamburger-menu-panel" ng-if="vm.active">\n\t\t\t\t<li class="hamburger-menu-panel__item" id="fetchIpLink">\n\t\t\t\t\t\t<a href ng-click="vm.goToSearch()"><i class="icon icon-fetch"></i> Fetch existing patents</a>\n\t\t\t\t</li>\n\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t<a href ng-click="vm.goToTrademarkSearch()"><i class="icon icon-fetch"></i> Fetch existing trademarks</a>\n\t\t\t\t</li>\n\t\t\t\t<!--li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t<a href="#"><i class="icon icon-print"></i> Print investor report</a>\n\t\t\t\t</li-->\n\t\t</ul>\n</div>\n');
$templateCache.put('ip/families/families.html','<cmnt-activate-portal ng-if="vm.needsActivation"></cmnt-activate-portal>\n\n<section class="filter">\n\t\t<div class="ip-content">\n\t\t\t\t<div class="filter-pane filter-pane_align-center filter-pane_famile-title">\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_justify-media-start">\n\t\t\t\t\t\t\t\t<h3 class="filter__title" ng-if="authGlobals.loggedIn">{{ vm.profile.organization.title }}</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="filter-pane filter-pane_ip">\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_justify-media-start filter-pane__item_align-bottom">\n\t\t\t\t\t\t\t\t<cmnt-jurisdiction-filter\n\t\t\t\t\t\t\t\t\t\t\t\tmatter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\tdefining="vm.jurisdiction"\n\t\t\t\t\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)"\n\t\t\t\t\t\t\t\t\t\t\t\tmatter-type-label="IP Type">\n\t\t\t\t\t\t\t\t</cmnt-jurisdiction-filter>\n\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_150 filter__select">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Status</label>\n\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.status" search-enabled="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="!vm.matterType || !vm.statuses || vm.statuses.length === 0"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.filtersChanged({status: vm.status})">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="All">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="status.id as status in vm.statuses">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="status.value"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_150 filter__select">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Applicant</label>\n\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.applicant" search-enabled="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="!vm.applicantsFacets || vm.applicantsFacets.length === 0"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.filtersChanged({applicant: vm.applicant})">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="All">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.repr"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="applicant.id as applicant in vm.applicantsFacets|filter: $select.search|orderBy:\'repr\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="applicant.repr | highlight:$select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<form ng-submit="vm.searchChanged()" class="filter__form">\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_150">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Find..." name="fulltext"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.fulltext" ng-blur="vm.searchBlur()">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="field__button" type="submit">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<div class="choose-field choose-field_offset-left">\n\t\t\t\t\t\t\t\t\t\t<label class="choose-field__label">Timeframe</label>\n\n\t\t\t\t\t\t\t\t\t\t<cmnt-time-frame start-date="vm.startDate" end-date="vm.endDate" timeframe="vm.timeframe"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-change="vm.timeframeChanged(startDate, endDate)">\n\t\t\t\t\t\t\t\t\t\t</cmnt-time-frame>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_justify-media-start">\n\t\t\t\t\t\t\t\t<div class="button-group button-group_offset-small">\n\t\t\t\t\t\t\t\t\t\t<cmnt-newip on-new-family="vm.newFamily(matterTypeId)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(!vm.currentUser.is_read_only)"></cmnt-newip>\n\n\t\t\t\t\t\t\t\t\t\t<cmnt-dropdown ng-if="::(!vm.currentUser.is_read_only)"></cmnt-dropdown>\n\n\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="right" class="hamburger-menu">\n\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue button_nowrap hamburger-menu__button hamburger-menu__button_menu">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-menu"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'hamburger-menu-panel__item_not-allowed\': vm.ordering === \'closest_deadline\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.downloadExportedFile()"><i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tDownload CSV report</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item" ng-if="::(!vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.inviteReadOnlyMembership()"><i\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="icon icon-eyeopen hamburger-menu-panel__item-icon-eyeopen"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t&nbsp;Grant a view-only access to this portal for a month</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<section class="sub-filter sub-filter_ip">\n\t\t<div class="ip-content ip-content_relative">\n\t\t\t\t<div class="ip-content__families">\n\t\t\t\t\t\t<div class="sub-filter-pane ip-content__first-sub-filter-pane">\n\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-gray sub-filter-pane__item">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.showTasks">\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">Show tasks</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="ip-content__currency select select_without-border select_back-white select_currency">\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.baseCurrency" search-enabled="false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.currencyChanged(vm.baseCurrency)">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="currency in vm.convertableCurrencies">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="currency"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!--div class="sub-filter-pane">\n\t\t\t\t\t\t<div class="budget-filter" ng-if="vm.anticipatedCost.count > 0">\n\t\t\t\t\t\t\t\tAnticipated budget for the {{ vm.anticipatedCost.count }} selected&nbsp;<ng-pluralize count="vm.anticipatedCost.count" when="{\'one\': \'task\', \'other\': \'tasks\'}"></ng-pluralize>&nbsp;is between:\n\t\t\t\t\t\t\t\t<div class="budget-filter__pane">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-budget"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="budget-filter__one">{{ vm.anticipatedCost.from.formatted }}</span> and\n\t\t\t\t\t\t\t\t\t\t<span class="budget-filter__two">{{ vm.anticipatedCost.to.formatted }}</span>\n\n\t\t\t\t\t\t\t\t\t\t<div class="select select_without-border select_currency anticipated-cost__currency">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.baseCurrency" search-enabled="false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.currencyChanged(vm.baseCurrency)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="currency in vm.convertableCurrencies">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="currency"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div-->\n\t\t</div>\n</section>\n<div class="black-background-content">\n\t\t<div class="content">\n\t\t\t\t<section class="sub-filter sub-filter_no-padding-bottom">\n\t\t\t\t\t\t<div class="sub-filter-pane"></div>\n\t\t\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t\t\t<!--div class="select select_theme_light select_without-border select_size_s select_fixed-width_180 sub-filter__select select_icon-mode">\n\t\t\t\t\t\t\t\t\t\t<i class="select__icon icon icon-filter icon_color_white"></i>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.ordering" search-enabled="false" ng-change="vm.orderingChanged()">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="orderingOption.value as orderingOption in vm.orderingOptions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="orderingOption.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t</div>\n\t\t\t\t</section>\n\n\t\t\t\t<cmnt-counts-by-type families="vm.families" ng-if="vm.families.length > 0 && vm.ordering != \'closest_deadline\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t families-counts="vm.familiesCounts"></cmnt-counts-by-type>\n\n\t\t\t\t<div class="families" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t\t\t ng-if="!vm.displayPlaceholders"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.families.$resolved"\n\t\t\t\t\t\t ng-class="{\'families_blur\': vm.needsActivation}">\n\t\t\t\t\t\t<div class="family families__family" ng-repeat="family in vm.families">\n\t\t\t\t\t\t\t\t<div class="family-header">\n\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-header__label">{{ ::family.matter_type }}</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="::family.image_url" class="family-header__image">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ ::family.image_url }}">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane-content">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-header__title-line">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-editable-title direction="inline" model="family" field="title"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(family.owned && !vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t field-class="family-header__field"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-finish-editing="vm.updateTitle(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="family-header__title">{{ family.title }}</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-editable-title>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="family-header__title"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(!family.owned || vm.currentUser.is_read_only)">{{ ::family.title }}</h3>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="right" class="hamburger-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(family.owned && vm.ordering !== \'closest_deadline\' && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_transparent button_size_s button_nowrap hamburger-menu__button hamburger-menu__button_menu">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-menu"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href cmnt-confirm-click="vm.archiveFamily(family)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t confirm-message="Are you sure you want to delete this family?">Delete\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tentire family</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item" ng-if="vm.eyeVisible(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.toggleNotFiled(family, $close)">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamily.show_not_filed ? \'Hide\' : \'Show\' }} unbudgeted work</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.inventors">\n                                <span tooltip="{{ ::(family.inventors|cmntContactsListFormat) }}">\n                                    <i class="icon icon-inventor family-header__title-icon"></i>{{ ::family.inventors[0] }}\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.applicants">\n                                <span tooltip="{{ ::(family.applicants|cmntContactsListFormat) }}">\n                                    <i class="icon icon-build family-header__title-icon"></i>{{ ::family.applicants[0] }}\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="family-body">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(family.owned && vm.ordering !== \'closest_deadline\' && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header family-member__header_bodyless"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'family-member__header_form\': family.$addingMember}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-new">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="icon icon-plus enquiries__new-entity"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.showMemberAddingForm(family)" ng-if="!family.$addingMember">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNew Jurisdiction\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-new__form" ng-if="family.$addingMember">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_back-white select_size_s\n                                                family-member-new__select" id="new-jurisdiction-form-{{ ::family.id }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="family.$newJurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select jurisdiction...">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="jurisdiction.id as jurisdiction in family.$jurisdictions | filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="jurisdiction.value | highlight:$select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-new__actions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_xs button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.addMember(family)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!family.$newJurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tsave\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_xs button_transparent family-member-new__cancel"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.cancelAddingMember(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcancel\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="family-member" ng-repeat="familyMember in family.family_members"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-show="familyMember.$expanded || family.show_not_filed"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-init="vm.initFamilyMemberState(familyMember, family)">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'family-member__header_bodyless\': !vm.showTasks || !familyMember.$expanded}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction__checkbox-holder"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ familyMember.$checkboxTooltip }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="familyMember.$expandAvailable && !vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" class="family-member-jurisdiction__checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-checked="familyMember.$expanded"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-disable-action="vm.toggleCollapse(familyMember)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction__checkbox-holder"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ familyMember.$showTasksCheckboxTooltip }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="!familyMember.$expandAvailable">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" class="family-member-jurisdiction__checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-checked="familyMember.$showTasks"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-disable-action="vm.toggleTasksVisibility(familyMember)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="family-member-jurisdiction__icon">\n                                    <i class="flag32"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::\'flag32-\' + familyMember.defining_code.toLowerCase()"></i>\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.defining }}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label family-member-jurisdiction__label_light"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(familyMember.matter_type_slug === \'trademarks\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-inline-edit ng-model="familyMember.classes_number"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tinput-options="{\n                                                        type: \'number\',\n                                                        step: \'1\',\n                                                        class: \'family-member-jurisdiction__class-input\',\n                                                        \'min-value\': \'1\',\n                                                        \'max-value\': \'45\',\n                                                        \'cmnt-string-to-number\': \'\',\n                                                        \'size-delta\': \'20\'\n                                                      }"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-value-changed="vm.classesNumberChanged(oldValue, newValue, familyMember)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tenabled="::(familyMember.matter_type_slug === \'trademarks\' && family.owned && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize when="{\'one\': \'{} class\', \'other\': \'{} classes\'}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcount="familyMember.classes_number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-inline-edit>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(familyMember.matter_type_slug === \'patents\' && familyMember.application_number)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href class="family-member-jurisdiction__label-espacenet-link"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-href="https://worldwide.espacenet.com/searchResults?query={{ ::familyMember.application_number }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t target="_blank"><i class="icon icon-espacenet"></i></a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label" ng-if="::familyMember.type">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.type }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::familyMember.application_number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.application_number }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label family-member-jurisdiction__label_light"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="familyMember.application_date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label" ng-if="familyMember.application_date"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t moment-picker="familyMember.application_date"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t change="vm.changeFilingDate(oldValue, newValue, familyMember, family)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::{\'arrow-cursor\': !family.owned || vm.currentUser.is_read_only}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t format="YYYY-MM-DD" disable="::(!family.owned || vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ familyMember.application_date|cmntCustomDateFormat:"DD MMM YYYY" }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(family.owned && !vm.currentUser.is_read_only && vm.ordering !== \'closest_deadline\' && (familyMember.defining_code==\'WO\' || familyMember.defining_code==\'EP\'))">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="icon icon-plus enquiries__new-entity"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.getQuotationsWithClone(family, familyMember)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::(familyMember.defining_code==\'WO\'? \'Nationalise\' : \'Validate\') }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="left" pane-offset="-20"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="family-member-status__item hamburger-menu">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__status-text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::{\'family-member-status__status-text_change-allowed\': family.owned && !vm.currentUser.is_read_only}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ familyMember.status }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel hamburger-menu-panel hamburger-menu-panel_static hamburger-menu-panel_width_300 hamburger-menu-panel_heigth_400"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(family.owned && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li ng-repeat="status in ::vm.subMatterStatuses[familyMember.matter_type_id]"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tclass="hamburger-menu-panel__item hamburger-menu-panel__item_tosize">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.changeStatus(status, familyMember, family, $close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::status.value }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="right" class="hamburger-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(family.owned && !vm.currentUser.is_read_only && vm.ordering !== \'closest_deadline\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_transparent button_size_s button_nowrap hamburger-menu__button hamburger-menu__button_menu">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-menu"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href cmnt-confirm-click="vm.archiveMember(family, familyMember)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t confirm-message="Are you sure you want to delete this case? This is irreversible.">Delete\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcase</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.showTasks && familyMember.$expanded && (familyMember.tasks|filter:{budget_status:\'not_included\'}).length > 0">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.toggleDiscarded(familyMember, $close)">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamilyMember.$hideDiscarded ? \'Show\' : \'Hide\' }} discarded</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="!familyMember.application_date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.showSetFilingDateModal(familyMember)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tEnter filing data\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(family.owned && !vm.currentUser.is_read_only && vm.ordering !== \'closest_deadline\' && (familyMember.defining_code==\'WO\' || familyMember.defining_code==\'EP\'))">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.showMemberAddingForm(family, familyMember)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="!family.$addingMember">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::(familyMember.defining_code==\'WO\'? \'Create national case from\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tthis; PCT;\' : \';Create; validation; case; from; this; EP;\') }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__body"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.showTasks && familyMember.$expanded && familyMember.$showTasks">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiries">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiries-new-task" ng-if="::family.owned">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class="icon icon-plus enquiries__new-entity enquiries__new-entity_enquiry"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(vm.ordering !== \'closest_deadline\' && !vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.addTask(familyMember, family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tNew task\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-inline-task task="task" family-member="familyMember" family="family"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-repeat="task in familyMember.tasks" base-currency="vm.baseCurrency"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'task-first\': $first && family.owned,\n                                                  \'task-first_closest-deadline\': vm.ordering === \'closest_deadline\' || vm.currentUser.is_read_only}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-deadline-changed="vm.onDeadlineChanged(task)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-enquiry-loaded="vm.onEnquiryLoaded(enquiry)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcurrent-user="vm.currentUser"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="familyMember.$hideDiscarded ? task.budget_status !== \'not_included\' : true">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-inline-task>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="families families_fade-in enable-animations" ng-if="vm.displayPlaceholders && authGlobals.loggedIn">\n\t\t\t\t\t\t<cmnt-family-placeholder ng-repeat="i in [1,2,3,4,5,6,7,8,9,10]">\n\t\t\t\t\t\t</cmnt-family-placeholder>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-loading-indicator class="loading-indicator_align-center loading-indicator_white-spinner"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tresource="vm.families" ng-if="!vm.families.$initial">\n\t\t\t\t</cmnt-loading-indicator>\n\n\t\t\t\t<cmnt-empty-result resource="vm.families" title="No families to show" extra-class="empty-result_theme-white">\n\t\t\t\t\t\t<p ng-if="authGlobals.loggedIn">\n\t\t\t\t\t\t\t\tEither <a ng-click="Navigation.go(\'community.wizard\')">create a new enquiry</a>\n\t\t\t\t\t\t\t\t<b>or</b> change your filtering criteria to reveal existing families</p>\n\n\t\t\t\t\t\t<p ng-if="!authGlobals.loggedIn">\n\t\t\t\t\t\t\t\tEither <a ng-click="Navigation.go(\'community.wizard\')">create a new enquiry</a>\n\t\t\t\t\t\t\t\t<b>or</b> <a ui-sref="community.login">log in</a> to reveal existing families</p>\n\t\t\t\t</cmnt-empty-result>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families/familyPlaceholder.directive.html','<div class="family family_placeholder">\n\t\t<div class="family-header">\n\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t<label class="family-header__label"><span>Patent</span></label>\n\t\t\t\t\t\t<h3 class="family-header__title"><span>Method of producing invisibility socks</span></h3>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="family-body">\n\t\t\t\t<div class="family-member">\n\t\t\t\t\t\t<div class="family-member__header">\n\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction__icon"></div>\n\t\t\t\t\t\t\t\t\t\t<span>United Kingdom</span>\n\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label"><span>National Phase</span></label>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item family-member-status__item_fixed-width">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>Approaching Deadline</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>27 oct 2017</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="family-member__body">\n\t\t\t\t\t\t\t\t<div class="enquiries">\n\t\t\t\t\t\t\t\t\t\t<button class="enquiries__new-entity">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>Start new enquriy</span>\n\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t<div class="enquiry">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__userpic-group">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__userpic"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__subscription"><span>Filing an application</span></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status">\n                                    <span class="enquiry__label">\n                                        <span>Enquiry</span>\n                                    </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="enquiry enquiry_group">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry-group-pane">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__subscription"><span>Patent Drafting</span></div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status enquiry-group-pane__status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="enquiry__label"><span>Instructions Sent</span></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-body">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic__img"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Fresh Ip</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Enquiry</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic__img"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Fresh Ip</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Enquiry</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic__img"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Fresh Ip</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span>Enquiry</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families/inlineTask.directive.html','<div class="task">\n\t\t<div class="task-header">\n\t\t\t\t<h4 class="task-header__title">\n\t\t\t\t\t\t<cmnt-inline-edit ng-model="vm.task.title" on-value-changed="vm.titleChanged(oldValue, newValue)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tinput-options="{class: \'task-header__input\', \'size-delta\': \'7\'}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tdelegate="vm.inlineEditDelegate"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tediting="vm.editInProgress" enabled="::(vm.family.owned && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t{{ vm.task.title }}\n\t\t\t\t\t\t</cmnt-inline-edit>\n\n\t\t\t\t\t\t<a href ng-if="vm.family.owned && !vm.editInProgress" class="task-header__multiplier"\n\t\t\t\t\t\t\t ng-click="vm.openMultiplierModal()">({{ vm.task.multiplier }})</a>\n\t\t\t\t</h4>\n\n\t\t\t\t<div class="task-header-options">\n\t\t\t\t\t\t<div class="task-header-options__date task-header-options__absolute-label-wraper"\n\t\t\t\t\t\t\t\t ng-class="{\'task-header-options__date_empty\': !vm.task.due_date,\n                 \'task-header-options__date_deadline\': vm.isApproachingDeadline,\n                 \'task-header-options__date_deadline_next-date\': vm.isNextDayDeadline,\n                 \'task-header-options__date_owned_task\': vm.family.owned}"\n\t\t\t\t\t\t\t\t moment-picker="vm.task.due_date" change="vm.deadlineChanged(oldValue, newValue)" format="YYYY-MM-DD"\n\t\t\t\t\t\t\t\t disable="::(!vm.family.owned || vm.currentUser.is_read_only)" today="true">\n\t\t\t\t\t\t\t\t<i class="icon icon-timer-clock"></i> {{ vm.task.due_date ? (vm.task.due_date|cmntCustomDateFormat:"DD\n\t\t\t\t\t\t\t\tMMM; YYYY;") : ";No; deadline;" }}\n\t\t\t\t\t\t\t\t<div class="task-header-options__absolute-label task-header-options__absolute-label_not-clickable task-header-options__absolute-label_left-10">\n\t\t\t\t\t\t\t\t\t\tDeadline:\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<cmnt-budget-toggle task="vm.task" ng-if="vm.family.owned && !vm.task.$hideBudget"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tbase-currency="vm.baseCurrency" current-user="vm.currentUser">\n\t\t\t\t\t\t</cmnt-budget-toggle>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="task-header">\n\t\t\t\t<h4 class="task-header__title">\n\t\t\t\t\t\t<div class="task-header__status task-header-options">\n\t\t\t\t\t\t\t\t<cmnt-task-change-status ng-if="::(vm.family.owned && !vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t task="vm.task"></cmnt-task-change-status>\n\n\t\t\t\t\t\t\t\t<div ng-if="::(!vm.family.owned || vm.currentUser.is_read_only)" class="task-header-options__status"\n\t\t\t\t\t\t\t\t\t\t ng-class="\'task-header-options__status_\' + vm.task.status">\n\t\t\t\t\t\t\t\t\t\t{{ ::vm.TaskStatusLabels[vm.task.status] }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<a href class="task-header__get-quotations" cmnt-spinner-action="vm.getQuotations()"\n\t\t\t\t\t\t\t ng-if="::(!vm.task.community && !vm.task.enquiry_archived && !vm.currentUser.is_read_only && vm.familyMember.defining_code!==\'WO\')">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i> Discuss / Instruct\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href class="task-header__get-quotations" ng-click="vm.getQuotationsNationalise()"\n\t\t\t\t\t\t\t ng-if="::(!vm.task.community && !vm.task.enquiry_archived && !vm.currentUser.is_read_only && vm.familyMember.defining_code===\'WO\')">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i> Discuss / Instruct\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<a href class="task-header__get-quotations" ng-mouseover="showEnquiryTimer=true;vm.showEnquiry()"\n\t\t\t\t\t\t\t ng-init="showEnquiryTimer=false"\n\t\t\t\t\t\t\t ng-if="(vm.task.community && !vm.task.enquiry_archived && !vm.enquiry)">\n\t\t\t\t\t\t\t\t<i class="icon icon-spinner icon-spin6" ng-if="showEnquiryTimer"></i><i class="icon icon-awaiting"></i>\n\t\t\t\t\t\t\t\tenquiry\n\t\t\t\t\t\t</a>\n\t\t\t\t</h4>\n\t\t</div>\n\n\t\t<div class="task__description-container task__description-container_no-text"\n\t\t\t\t ng-if="!vm.addingDescription && vm.family.owned && !vm.currentUser.is_read_only"\n\t\t\t\t ng-click="vm.startEditing()">\n\t\t\t\t+\n\t\t</div>\n\n\t\t<div class="task__description-container" ng-if="vm.addingDescription">\n\t\t\t\t<cmnt-inline-area ng-model="vm.task.text" on-value-changed="vm.descriptionChanged(oldValue, newValue)"\n\t\t\t\t\t\t\t\t\t\t\t\t\tenabled="::(vm.family.owned && !vm.currentUser.is_read_only)" extra-class="task__description"\n\t\t\t\t\t\t\t\t\t\t\t\t\tdelegate="vm.textAreaDelegate">\n\t\t\t\t\t\t<div class="task__description-text" ng-bind-html="vm.task.text|escapeHtml|convertLineBreaks"></div>\n\t\t\t\t</cmnt-inline-area>\n\t\t</div>\n\n\t\t<div class="task__enquiry">\n\t\t\t\t<div class="enquiry" ng-click="vm.viewEnquiry(vm.enquiry)" ng-if="vm.enquiry && !vm.task.enquiry_archived"\n\t\t\t\t\t\t ng-class="{\'enquiry_group\': vm.enquiryGroup}">\n\n\t\t\t\t\t\t<!-- collapsed enquiry -->\n\n\t\t\t\t\t\t<div class="enquiry__pane" ng-if="!vm.enquiryGroup">\n\t\t\t\t\t\t\t\t<div class="enquiry__info" ng-if="::vm.enquiry.direction === \'outgoing\'">\n\t\t\t\t\t\t\t\t\t\t<div class="enquiry__userpic-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="enquiry__userpic" cmnt-stop-propagation\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-repeat="conv in ::vm.convs"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'enquiry__userpic_notification\': conv.unread}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.viewConversation(vm.enquiry, conv)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ ::conv.avatar }}">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="enquiry__subscription">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon enquiry__icon_direction enquiry__icon" ng-class="::vm.directionIconClass"\n\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ ::vm.directionLabel }}" tooltip-append-to-body="true">\n\t\t\t\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ ::vm.enquiry.expertise }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="enquiry__info" ng-if="::vm.enquiry.direction === \'incoming\'">\n\t\t\t\t\t\t\t\t\t\t<div class="enquiry__userpic"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'enquiry__userpic_notification\': vm.supplier_conv.unread}">\n\t\t\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ ::vm.enquiry.creator_avatar }}">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="enquiry__subscription">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon enquiry__icon_direction enquiry__icon" ng-class="::vm.directionIconClass"\n\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ ::vm.directionLabel }}" tooltip-append-to-body="true">\n\t\t\t\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ ::vm.enquiry.expertise }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="enquiry__status" ng-if="::!vm.family.owned">\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status" ng-class="::vm.casePersonClass">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon enquiry__icon" ng-class="::vm.statusIconClass"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::vm.supplier_conv.status !== \'quoted\'">\n\t\t\t\t\t\t\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="enquiry__label">\n                            {{ ::vm.projectStatusLabel }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="enquiry__status" ng-if="::vm.family.owned">\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status" ng-class="vm.casePersonClass" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon enquiry__icon" ng-class="vm.statusIconClass">\n\t\t\t\t\t\t\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="left" pane-offset="-20"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="hamburger-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.projectStatus === \'sent\' || vm.projectStatus === \'confirmed\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<toggle>\n                                <span class="enquiry__label">\n                                    {{ vm.projectStatusLabel }}\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel hamburger-menu-panel_static hamburger-menu-panel_width_110"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(!vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a ng-if="vm.projectStatus === \'sent\'" href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.confirmInstructions($close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tConfirm instructions\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a ng-if="vm.projectStatus === \'confirmed\'" href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.completeInstructions($close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tConfirm completion\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t\t\t\t\t</dropdown-toggle>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="enquiry__label"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="vm.projectStatus !== \'sent\' && vm.projectStatus !== \'confirmed\'">\n                            {{ ::vm.projectStatusLabel }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- expanded enquiry -->\n\n\t\t\t\t\t\t<div class="enquiry-group-pane" ng-if-start="vm.enquiryGroup">\n\t\t\t\t\t\t\t\t<div class="enquiry__subscription">\n\t\t\t\t\t\t\t\t\t\t<i class="icon enquiry__icon_direction enquiry__icon"\n\t\t\t\t\t\t\t\t\t\t\t ng-class="::vm.directionIconClass"\n\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ ::vm.directionLabel }}">\n\t\t\t\t\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t\t\t\t\t{{ ::vm.enquiry.expertise }}\n\t\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t\t\t<div class="case-person-info-status enquiry-group-pane__status" ng-class="::vm.casePersonClass">\n\t\t\t\t\t\t\t\t\t\t<i class="icon enquiry__icon" ng-class="::vm.statusIconClass"></i>\n\n\t\t\t\t\t\t\t\t\t\t<span class="enquiry__label">\n                        {{ ::vm.projectStatusLabel }}\n                    </span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="case-body" ng-if-end="vm.enquiryGroup">\n\t\t\t\t\t\t\t\t<div class="case-person" ng-repeat="conv in vm.enquiry.supplier_conversations"\n\t\t\t\t\t\t\t\t\t\t ng-class="{\'case-person_notification\': conv.unread > 0}"\n\t\t\t\t\t\t\t\t\t\t cmnt-stop-propagation\n\t\t\t\t\t\t\t\t\t\t ng-click="vm.viewConversation(vm.enquiry, conv)">\n\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-pic" ng-if="vm.enquiry.direction === \'outgoing\'">\n\t\t\t\t\t\t\t\t\t\t\t\t<img class="case-person-pic__img" ng-src="{{ ::conv.avatar }}">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm" ng-if="vm.enquiry.direction === \'outgoing\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::conv.firm }}\n\t\t\t\t\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="case-person-info-status case-person-info-status_{{ conv.status }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon case-person-info-status__icon {{ vm.getStatusIcon(conv) }}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="conv.status !== \'quoted\'"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ conv|conversationStatus }}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families/inviteReadOnlyMembership.modal.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title">Share portal</h2>\n\t\t</div>\n\n\t\t<form cmnt-handle-errors>\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label" for="newFollowerEmail">Email</label>\n\t\t\t\t\t\t\t\t\t\t<input type="text" ng-model=\'vm.email\' class=\'field__text\' name="email" autofocus\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="vm.url!==undefined"/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" ng-if="vm.url">\n\t\t\t\t\t\t\t\t\t\t<label class="field__label" for="newFollowerEmail">Link</label>\n\t\t\t\t\t\t\t\t\t\t<input type="text" ng-model=\'vm.url\' class=\'field__text\' autoselect readonly/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action=\'vm.copyLink()\' ng-disabled="vm.url!==undefined">Copy link\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" submit\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action=\'vm.invite()\' ng-disabled="vm.url!==undefined">Send link\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('ip/families/newip.directive.html','<dropdown-toggle close-on-click="true" pane-align="right" class="hamburger-menu hamburger-menu_offset-small">\n\t\t<toggle>\n\t\t\t\t<button class="button button_size_s button_color_blue button_nowrap hamburger-menu__button">\n\t\t\t\t\t\t<i class="icon icon-plus"></i> New IP\n\t\t\t\t</button>\n\t\t</toggle>\n\t\t<pane>\n\t\t\t\t<ul class="hamburger-menu-panel">\n\t\t\t\t\t\t<li class="hamburger-menu-panel__item" ng-repeat="matterType in vm.matterTypes">\n\t\t\t\t\t\t\t\t<a href ng-click="vm.newFamily(matterType.id, $close)">New {{ matterType.title }}</a>\n\t\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t</pane>\n</dropdown-toggle>\n');
$templateCache.put('ip/families/setFilingDate.modal.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title">Enter data about this case</h2>\n\t\t</div>\n\n\t\t<form cmnt-handle-errors>\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\n\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Filing date</label>\n\t\t\t\t\t\t\t\t\t\t<input class="field__text field__text_light-palceholder field__text_width-100" type="text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.date" name="date" moment-picker="vm.date"\n\t\t\t\t\t\t\t\t\t\t\t\t\t today="true" ng-model-options="{ updateOn: \'blur\' }" placeholder="Select a date">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field-textarea field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Additional information (e.g. application number)</label>\n\t\t\t\t\t\t\t\t\t\t<textarea class="field__text modal-body__textarea modal-body__textarea_compact" ng-model="vm.number"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tname="number" rows="1">\n                    </textarea>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" cmnt-submit ng-click=\'vm.submit()\'>Submit\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('ip/families/taskChangeStatus.directive.html','<div class="task-header-options__status">\n\t\t<dropdown-toggle close-on-click="true" pane-align="left" pane-offset="-20" class="hamburger-menu">\n\t\t\t\t<toggle>\n\t\t\t\t\t\t<div ng-class="\'task-header-options__status_\' + vm.task.status">\n\t\t\t\t\t\t\t\t{{ vm.TaskStatusLabels[vm.task.status] }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</toggle>\n\t\t\t\t<pane>\n\t\t\t\t\t\t<ul class="hamburger-menu-panel hamburger-menu-panel_static hamburger-menu-panel_width_110">\n\t\t\t\t\t\t\t\t<li ng-repeat="status in ::vm.taskStatuses" class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t<a href="" cmnt-spinner-action="vm.changeStatus(status.value, $close)">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ ::status.title }}\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t</pane>\n\t\t</dropdown-toggle>\n</div>\n');
$templateCache.put('ip/families/taskMultiplier.modal.html','<div class="modal">\n\t\t<div class="modal-header"></div>\n\n\t\t<form ng-submit="vm.changeMultiplier()">\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<p class="modal-body__text">If you want to calculate the budget for more than one task of this type, change\n\t\t\t\t\t\t\t\tthe number below</p>\n\t\t\t\t\t\t<div class="field field_size_s field_border">\n\t\t\t\t\t\t\t\t<label class="field__label">Multiplier</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model=\'vm.multiplier\' min="1" max="100" step="1" class=\'field__text\' required\n\t\t\t\t\t\t\t\t\t\t\t name="multiplier" autofocus/>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" type="submit">Change</button>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('ip/families/timeframe.directive.html','<div class="choose-field-list">\n\t\t<button class="choose-field-list__item"\n\t\t\t\t\t\tng-class="{\'choose-field-list__item_active\': vm.timeframe === option.value}"\n\t\t\t\t\t\tng-repeat="option in vm.predefinedOptions"\n\t\t\t\t\t\tng-click="vm.setTimeframe(option.value)">\n\t\t\t\t{{ option.label }}\n\t\t</button>\n\n\t\t<button class="choose-field-list__item" ng-click="vm.showRangeSelector()"\n\t\t\t\t\t\tng-class="{\'choose-field-list__item_active\': vm.showRangePanel}">\n\t\t\t\tRange\n\t\t</button>\n\t\t<div class="range-panel" ng-if="vm.showRangePanel">\n\t\t\t\t<div ng-model="vm.startDate" moment-picker="vm.startDateStr" change="vm.onStartDateChange()"\n\t\t\t\t\t\t max-date="vm.endDate">\n\t\t\t\t\t\t{{ vm.startDateStr }}\n\t\t\t\t</div>\n\n\t\t\t\t<div class="range-panel__label">to</div>\n\n\t\t\t\t<div ng-model="vm.endDate" moment-picker="vm.endDateStr" change="vm.onEndDateChange()"\n\t\t\t\t\t\t min-date="vm.startDate">\n\t\t\t\t\t\t{{ vm.endDateStr }}\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families_budget/familiesBudget.html','<section class="filter">\n\t\t<div class="ip-content">\n\t\t\t\t<div class="filter-pane filter-pane_align-center filter-pane_famile-title">\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_justify-media-start">\n\t\t\t\t\t\t\t\t<h3 class="filter__title" ng-if="authGlobals.loggedIn">{{ vm.profile.organization.title }}</h3>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_justify-media-start"></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="filter-pane filter-pane_ip">\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_justify-media-start filter-pane__item_align-bottom">\n\t\t\t\t\t\t\t\t<cmnt-matter-type-filter\n\t\t\t\t\t\t\t\t\t\t\t\tmatter-type="vm.matterType"\n\t\t\t\t\t\t\t\t\t\t\t\ton-filters-changed="vm.filtersChanged(newValues)"\n\t\t\t\t\t\t\t\t\t\t\t\tmatter-type-label="IP Type">\n\t\t\t\t\t\t\t\t</cmnt-matter-type-filter>\n\n\t\t\t\t\t\t\t\t<form ng-submit="vm.searchChanged()" class="filter__form">\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_gray field_group-button field_width_150">\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Find..." name="fulltext"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.fulltext" ng-blur="vm.searchBlur()">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="field__button" type="submit">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-search"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<div class="choose-field choose-field_offset-left">\n\t\t\t\t\t\t\t\t\t\t<label class="choose-field__label">Timeframe</label>\n\n\t\t\t\t\t\t\t\t\t\t<cmnt-time-range start-date="vm.startDate" end-date="vm.endDate" timeframe="vm.timeframe"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-change="vm.timeframeChanged(startDate, endDate)">\n\t\t\t\t\t\t\t\t\t\t</cmnt-time-range>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<section class="sub-filter sub-filter_ip">\n\t\t<div class="ip-content">\n\t\t\t\t<div class="sub-filter-pane"></div>\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<div class="budget-filter" ng-if="vm.anticipatedCost.count > 0">\n\t\t\t\t\t\t\t\tAnticipated budget:\n\t\t\t\t\t\t\t\t<div class="budget-filter__pane">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-budget"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="budget-filter__one">{{ vm.anticipatedCost.from.formatted }}</span>\n\n\t\t\t\t\t\t\t\t\t\t<div class="select select_without-border select_currency anticipated-cost__currency">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.baseCurrency" search-enabled="false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.currencyChanged(vm.baseCurrency)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="currency in vm.convertableCurrencies">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="currency"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<div class="black-background-content">\n\t\t<div class="content">\n\t\t\t\t<section class="sub-filter sub-filter_no-padding-bottom">\n\t\t\t\t\t\t<div class="sub-filter-pane"></div>\n\t\t\t\t\t\t<div class="sub-filter-pane"></div>\n\t\t\t\t</section>\n\n\t\t\t\t<cmnt-counts-by-type families="vm.families" ng-if="vm.families.length > 0"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t families-counts="vm.familiesCounts"></cmnt-counts-by-type>\n\n\t\t\t\t<div class="families" ng-if="vm.cleanFamilies.$resolved">\n\t\t\t\t\t\t<div class="family families__family">\n\t\t\t\t\t\t\t\t<div class="family-header">\n\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-header__label">Your IP Budget</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="family-budget">\n\t\t\t\t\t\t\t\t\t\t<div class="family-budget__year">{{ ::vm.currentYearStr }}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-budget__year">{{ ::vm.nextYearStr }}</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-budget__year family-budget__year_last">{{ vm.startDateStr }} - {{ vm.endDateStr\n\t\t\t\t\t\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="family-body">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header family-member__header_total-budget">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction__checkbox-holder"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tTotal budgets:\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.totalBudgets.current_year.amount|currency:vm.totalBudgets.current_year.symbol:0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.totalBudgets.next_year.amount|currency:vm.totalBudgets.next_year.symbol:0 }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money family-member-status__money_last">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.totalBudgets.range.amount|currency:vm.totalBudgets.range.symbol:0 }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-member" ng-repeat="family in vm.cleanFamilies"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-init="vm.initCleanFamilyState(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction__checkbox-holder">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" class="family-member-jurisdiction__checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-checked="family.$checked"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-disable-action="vm.toggleCleanFamilySelection(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::family.title }}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="family-member-jurisdiction__label family-member-jurisdiction__label_green-small"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.openCleanFamilyMultiplierModal(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::family.matter_type }}<span ng-if="family.$multiplier && family.$multiplier>1">&nbsp;({{ family.$multiplier }})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamily.budgets.current_year.amount|currency:family.budgets.current_year.symbol:0 }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamily.budgets.next_year.amount|currency:family.budgets.next_year.symbol:0 }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money family-member-status__money_last">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamily.budgets.range.amount|currency:family.budgets.range.symbol:0 }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="families families_fade-in enable-animations" ng-if="!vm.cleanFamilies.$resolved">\n\t\t\t\t\t\t<cmnt-families-budget-placeholder></cmnt-families-budget-placeholder>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="families" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t\t\t ng-if="!vm.displayPlaceholders"\n\t\t\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.families.$resolved">\n\t\t\t\t\t\t<div class="family families__family" ng-repeat="family in vm.families" ng-init="vm.initFamilyState(family)">\n\t\t\t\t\t\t\t\t<div class="family-header">\n\t\t\t\t\t\t\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t\t\t\t\t\t\t<a href="" class="family-header__label" ng-click="vm.openMultiplierModal(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::family.matter_type }}<span ng-if="family.$multiplier && family.$multiplier>1">&nbsp;({{ family.$multiplier }})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-header__title-line">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-editable-title direction="inline" model="family" field="title"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="::(family.owned && !vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t field-class="family-header__field"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-finish-editing="vm.updateTitle(family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="family-header__title">{{ family.title }}</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-editable-title>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="family-header__title" ng-if="::(!family.owned || vm.currentUser.is_read_only)">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t::family.title }}</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.inventors">\n                            <span tooltip="{{ ::(family.inventors|cmntContactsListFormat) }}">\n                                <i class="icon icon-inventor family-header__title-icon"></i>{{ ::family.inventors[0] }}\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\t\t\t\t\t\t\t\t\t\t\t\t<h5 class="family-header__title family-header__title_small" ng-if="::family.applicants">\n                            <span tooltip="{{ ::(family.applicants|cmntContactsListFormat) }}">\n                                <i class="icon icon-build family-header__title-icon"></i>{{ ::family.applicants[0] }}\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t</h5>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-budget">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-budget__year">{{ ::vm.currentYearStr }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-budget__year">{{ ::vm.nextYearStr }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-budget__year family-budget__year_last">{{ vm.startDateStr }} - {{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tvm.endDateStr }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="family-body">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member" ng-repeat="familyMember in family.family_members"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-init="vm.initFamilyMemberState(familyMember, family)">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member__header">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction__checkbox-holder">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" class="family-member-jurisdiction__checkbox"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-checked="familyMember.$checked"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-disable-action="vm.toggleFamilyMemberSelection(familyMember, family)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="family-member-jurisdiction__icon">\n                                    <i class="flag32"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::\'flag32-\' + familyMember.defining_code.toLowerCase()"></i>\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.defining }}\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label family-member-jurisdiction__label_light"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="familyMember.matter_type_slug === \'trademarks\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-inline-edit ng-model="familyMember.classes_number"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tinput-options="{\n                                                        type: \'number\',\n                                                        step: \'1\',\n                                                        class: \'family-member-jurisdiction__class-input\',\n                                                        \'min-value\': \'1\',\n                                                        \'max-value\': \'45\',\n                                                        \'cmnt-string-to-number\': \'\',\n                                                        \'size-delta\': \'20\'\n                                                      }"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ton-value-changed="vm.classesNumberChanged(oldValue, newValue, familyMember)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tenabled="::(familyMember.matter_type_slug === \'trademarks\' && family.owned && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize when="{\'one\': \'{} class\', \'other\': \'{} classes\'}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcount="familyMember.classes_number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</cmnt-inline-edit>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="family-member-jurisdiction__label" ng-if="::familyMember.type">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::familyMember.type }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money" tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ familyMember.budgets.current_year.$tooltip }}">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamilyMember.budgets.current_year.amount|currency:familyMember.budgets.current_year.symbol:0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money" tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ familyMember.budgets.next_year.$tooltip }}">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamilyMember.budgets.next_year.amount|currency:familyMember.budgets.next_year.symbol:0\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__money family-member-status__money_last"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-append-to-body="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip="{{ familyMember.budgets.range.$tooltip }}">{{\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfamilyMember.budgets.range.amount|currency:familyMember.budgets.range.symbol:0 }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="families families_fade-in enable-animations" ng-if="vm.displayPlaceholders && authGlobals.loggedIn">\n\t\t\t\t\t\t<cmnt-family-placeholder ng-repeat="i in [1,2,3,4,5,6,7,8,9,10]">\n\t\t\t\t\t\t</cmnt-family-placeholder>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-loading-indicator class="loading-indicator_align-center loading-indicator_white-spinner"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tresource="vm.families" ng-if="!vm.families.$initial">\n\t\t\t\t</cmnt-loading-indicator>\n\n\t\t\t\t<cmnt-empty-result resource="vm.families" title="No families to show" extra-class="empty-result_theme-white">\n\t\t\t\t\t\t<p ng-if="authGlobals.loggedIn">\n\t\t\t\t\t\t\t\tEither <a ng-click="Navigation.go(\'community.wizard\')">create a new enquiry</a>\n\t\t\t\t\t\t\t\t<b>or</b> change your filtering criteria to reveal existing families</p>\n\n\t\t\t\t\t\t<p ng-if="!authGlobals.loggedIn">\n\t\t\t\t\t\t\t\tEither <a ng-click="Navigation.go(\'community.wizard\')">create a new enquiry</a>\n\t\t\t\t\t\t\t\t<b>or</b> <a ui-sref="community.login">log in</a> to reveal existing families</p>\n\t\t\t\t</cmnt-empty-result>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families_budget/familiesBudgetPlaceholder.directive.html','<div class="family family_placeholder">\n\t\t<div class="family-header">\n\t\t\t\t<div class="family-header__pane">\n\t\t\t\t\t\t<label class="family-header__label"><span>Your IP Budget</span></label>\n\t\t\t\t\t\t<h3 class="family-header__title"><span></span></h3>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="family-body">\n\t\t\t\t<div class="family-member" ng-repeat="i in [1,2,3,4]">\n\t\t\t\t\t\t<div class="family-member__header">\n\t\t\t\t\t\t\t\t<div class="family-member-jurisdiction">\n\t\t\t\t\t\t\t\t\t\t<span>Method of producing invisibility socks</span>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="family-member-status">\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>27 oct 2017</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>27 oct 2017</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="family-member-status__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>27 oct 2017</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families_budget/familyMultiplier.modal.html','<div class="modal">\n\t\t<div class="modal-header"></div>\n\n\t\t<form ng-submit="vm.changeMultiplier()">\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<p class="modal-body__text">If you want to calculate the budget for more than one family of this type,\n\t\t\t\t\t\t\t\tchange the number below</p>\n\t\t\t\t\t\t<div class="field field_size_s field_border">\n\t\t\t\t\t\t\t\t<label class="field__label">Multiplier</label>\n\t\t\t\t\t\t\t\t<input type="number" ng-model=\'vm.multiplier\' min="1" max="100" step="1" class=\'field__text\' required\n\t\t\t\t\t\t\t\t\t\t\t name="multiplier" autofocus/>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" type="submit">Change</button>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('ip/families_budget/matterTypeFilter.directive.html','<div class="filter__select-group">\n\t\t<div class="select select_theme_gray select_size_s select_width_180 filter__select">\n\t\t\t\t<label class="select__label">{{ ::vm.matterTypeLabel }}</label>\n\t\t\t\t<ui-select ng-model="vm.matterType" ng-change="vm.onMatterTypeChanged()">\n\t\t\t\t\t\t<ui-select-match allow-clear="true" placeholder="All">\n\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.title"></span>\n\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\trepeat="matterType.id as matterType in (vm.matterTypes | filter: $select.search) track by matterType.id">\n\t\t\t\t\t\t\t\t<span ng-bind="matterType.title"></span>\n\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t</ui-select>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/families_budget/timeRange.directive.html','<div class="choose-field-list">\n\t\t<button class="choose-field-list__item choose-field-list__item_active">\n\t\t\t\tfrom\n\t\t</button>\n\t\t<div class="range-panel">\n\t\t\t\t<div ng-model="vm.startDate" moment-picker="vm.startDateStr" change="vm.onStartDateChange()"\n\t\t\t\t\t\t max-date="vm.endDate">\n\t\t\t\t\t\t{{ vm.startDateStr }}\n\t\t\t\t</div>\n\n\t\t\t\t<div class="range-panel__label">to</div>\n\n\t\t\t\t<div ng-model="vm.endDate" moment-picker="vm.endDateStr" change="vm.onEndDateChange()"\n\t\t\t\t\t\t min-date="vm.startDate">\n\t\t\t\t\t\t{{ vm.endDateStr }}\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/old_tasks/taskPlaceholder.directive.html','<div class="task task_placeholder">\n\t\t<div class="task-header">\n\t\t\t\t<h4 class="task-header__title"><span>Check all documents sent and applications filed</span></h4>\n\t\t\t\t<div class="task-header-options">\n\t\t\t\t\t\t<div class="task-header-options__price">\n\t\t\t\t\t\t\t\t<span>$1200</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="task-header-options__status">\n\t\t\t\t\t\t\t\t<span>In Progress</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="task-header-options__date">\n\t\t\t\t\t\t\t\t<div class="icon icon_fake"></div>\n\t\t\t\t\t\t\t\t<span>17 Nov 2017</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="task-body">\n\t\t\t\t<p class="task-body__text">\n\t\t\t\t\t\t<span>Method of finding ivnisibility socks you can\'t see (because they\'re invisible)</span></p>\n\t\t</div>\n\t\t<div class="task-footer">\n\t\t\t\t<div class="task-footer-label">\n\t\t\t\t\t\t<div class="task-footer-label__country">\n\t\t\t\t\t\t\t\t<div class="icon icon_fake"></div>\n\t\t\t\t\t\t\t\t<span>United Kingdom</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="task-footer-label__type">\n\t\t\t\t\t\t\t\t<span>National Phase</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!--a class="task-footer__view">\n\t\t\t\t\t <span>View task</span>\n\t\t\t\t</a-->\n\t\t</div>\n</div>\n');
$templateCache.put('ip/old_tasks/tasks.html','<section class="filter filter_response_v2 filter_response_v3">\n\t\t<div class="content">\n\t\t\t\t<div class="filter-pane">\n\t\t\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t\t\t<div class="choose-field">\n\t\t\t\t\t\t\t\t\t\t<label class="choose-field__label">Timeframe</label>\n\n\t\t\t\t\t\t\t\t\t\t<cmnt-button-group ng-model="vm.timeframe" choices="vm.timeframeChoices"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.timeframeChanged(vm.timeframe)">\n\t\t\t\t\t\t\t\t\t\t</cmnt-button-group>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_180 filter__select">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Status</label>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.status" name=\'status\' ng-change="vm.filtersChanged({status: vm.status})">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="All" allow-clear="true">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="status.value as status in vm.statusChoices">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="status.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="filter-pane__item filter-pane__item_direction-column filter-pane__item_pull-left">\n\t\t\t\t\t\t\t\t<cmnt-search-field ng-model="vm.fulltext" ng-change="vm.filtersChanged({fulltext: vm.fulltext})">\n\t\t\t\t\t\t\t\t</cmnt-search-field>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t\t\t<div class="anticipated-cost filter-pane__text">\n                    <span class="anticipated-cost__sum">\n                        Anticipated cost over timeframe:\n                        {{ vm.anticipatedCost.$resolved ? vm.anticipatedCost.cost.formatted : "..." }}\n                    </span>\n\n\t\t\t\t\t\t\t\t\t\t<div class="select select_without-border select_currency anticipated-cost__currency">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="vm.baseCurrency" search-enabled="false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.currencyChanged(vm.baseCurrency)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="currency in vm.convertableCurrencies">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="currency"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<div class="content">\n\t\t<section class="sub-filter">\n\t\t\t\t<div class="sub-filter-pane"></div>\n\t\t\t\t<div class="sub-filter-pane">\n\t\t\t\t\t\t<div class="select select_theme_gray select_without-border select_size_s select_fixed-width_160 sub-filter__select select_icon-mode">\n\t\t\t\t\t\t\t\t<i class="select__icon icon icon-filter"></i>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.ordering" search-enabled="false"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.filtersChanged({ordering: vm.ordering})">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="orderingChoice.value as orderingChoice in vm.orderingChoices">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="orderingChoice.label"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</section>\n</div>\n<div class="content">\n\t\t<div class="tasks" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1" ng-if="!vm.displayPlaceholders"\n\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.tasks.$resolved">\n\t\t\t\t<div class="task" ng-repeat="task in vm.tasks">\n\t\t\t\t\t\t<div class="task-header">\n\t\t\t\t\t\t\t\t<h4 class="task-header__title">{{ ::task.title }}</h4>\n\t\t\t\t\t\t\t\t<div class="task-header-options">\n\t\t\t\t\t\t\t\t\t\t<div class="task-header-options__price" ng-if="task.number">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ ::task.number.formatted }} {{ task.converted_number !== null ? \'(\' +\n\t\t\t\t\t\t\t\t\t\t\t\ttask.converted_number.formatted + \')\' : \'\' }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-header-options__status" ng-class="\'task-header-options__status_\' + task.status">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ ::vm.TaskStatusLabels[task.status] }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-header-options__date" ng-if="task.due_date">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-timer-clock"></i> {{ ::task.due_date|cmntCustomDateFormat:"DD MMM YYYY" }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-header-options__date task-header-options__date_empty" ng-if="!task.due_date">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-timer-clock"></i> No deadline\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="task-body">\n\t\t\t\t\t\t\t\t<p class="task-body__text">{{ task.sub_matter_data.title }}</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="task-footer">\n\t\t\t\t\t\t\t\t<div class="task-footer-label">\n\t\t\t\t\t\t\t\t\t\t<div class="task-footer-label__country">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon flag32"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::\'flag32-\' + task.sub_matter_data.defining_code.toLowerCase()"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t{{ task.sub_matter_data.defining }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-footer-label__type">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ task.sub_matter_data.type }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<!--a class="task-footer__view">\n\t\t\t\t\t\t\t\t\t View task <i class="icon icon-arrow-right"></i>\n\t\t\t\t\t\t\t\t</a-->\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="tasks tasks_fade-in enable-animations" ng-if="vm.displayPlaceholders">\n\t\t\t\t<cmnt-task-placeholder ng-repeat="i in [1,2,3,4,5,6,7,8,9,10]">\n\t\t\t\t</cmnt-task-placeholder>\n\t\t</div>\n\n\t\t<cmnt-loading-indicator class="loading-indicator_align-center" resource="vm.tasks" ng-if="!vm.families.$initial">\n\t\t</cmnt-loading-indicator>\n\n\t\t<cmnt-empty-result resource="vm.tasks" title="There are no deadlines in the chosen date range.">\n\t\t\t\t<p>\n\t\t\t\t\t\tTry to <a ng-click="vm.expandTimeframe()">expand</a> the date range\n\t\t\t\t\t\t<b>or</b> <a ng-click="Navigation.go(\'community.search\')">find and fetch</a> your patents and trademarks\n\t\t\t\t</p>\n\t\t</cmnt-empty-result>\n</div>\n');
$templateCache.put('ip/portal/cmntActivatePortal.directive.html','<div class="activate-portal-bg"></div>\n<div class="activate-portal">\n\t\t<div class="activate-portal-header">\n\t\t\t\t<h2 class="activate-portal-header-title">\n\t\t\t\t\t\t<img class="activate-portal-header-title__icon"\n\t\t\t\t\t\t\t\t src="{{ ::conf.staticRoot }}community/images/icon-report-fake.png" alt=""/>\n\t\t\t\t\t\tIP Report\n\t\t\t\t</h2>\n\t\t\t\t<div class="activate-portal-header__label">prepared by Jed for</div>\n\t\t\t\t<div class="activate-portal-header-company">\n\t\t\t\t\t\t<h3 class="activate-portal-header-company__name">{{ vm.profile.organization.title }}</h3>\n\t\t\t\t</div>\n\t\t\t\t<div class="activate-portal-header__bot"><img src="{{ ::conf.staticRoot }}community/images/bot-user.png"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\talt=""/></div>\n\t\t</div>\n\t\t<div class="activate-portal-body">\n\t\t\t\t<div class="activate-portal-body__content">\n\t\t\t\t\t\t<h5 class="activate-portal-body__subtitle">To view your IP report</h5>\n\t\t\t\t\t\t<h3 class="activate-portal-body__title">Let\'s get your IP portal set up</h3>\n\n\t\t\t\t\t\t<form cmnt-handle-errors name="activateForm" class="activate-portal-body-form shake-on-errors">\n\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t<div class="field-group">\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" name="first_name" placeholder="First name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-focus-me="true" ng-model="vm.firstName">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" name="last_name" placeholder="Last name"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-focus-me="true" ng-model="vm.lastName">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Choose a password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" name="password" ng-model="vm.password"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-focus-me="true">\n\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-password-strength password="vm.password"></cmnt-password-strength>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="activate-portal-body-form__confirm">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="activate-portal-body-form__tou-checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.agreeToTou"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">\n                                        I agree to the <a target="_blank" ng-href="{{::vm.termsOfUseUrl}}">Terms of use and privacy policy</a>\n                                    </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_m button_color_blue" type="submit"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!vm.agreeToTou"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.activateUser(activateForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-pekama"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tView report and create IP Portal\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/projects/projects.html','<section class="head-report">\n    <div class="head-report__inner">\n        <div class="head-report__content">\n            <h2 class="head-report__title">PROJECTS</h2>\n        </div>\n        <div class="head-report__buttons flex flex_align-end">\n            <ng-include src="\'reports/memoboxes/headingButtons.html\'" ng-if="reportParams.listTemplate"></ng-include>\n\n            <a class="button button_enlarged button_color_flamingo reports-body__download" ui-sref="community.reports.export_results">\n                <i class="icon icon-download"></i>\n            </a>\n        </div>\n    </div>\n</section>\n\n<section class="reports-body" ng-class="{\'sidebar-collapsed\': uiState.filtersCollapsed}">\n    <div class="reports-body__content">\n        <div class="content-col">\n            <div class="reports-body" ng-class="{\'reports-body__projects\': uiState.view==\'list\'}">\n                <cmnt-loading-indicator resource="objects"></cmnt-loading-indicator>\n\n                <cmnt-empty-result resource="objects"\n                                   title="No data available."></cmnt-empty-result>\n\n                <ng-include src="reportParams.listTemplate" ng-if="uiState.view==\'list\'"></ng-include>\n            </div>\n\n            <nav class="pagination-holder">\n                <pagination ng-if="objects.$resolved" items-per-page="paginationService.pageSize"\n                            total-items="paginationService.totalItems" max-size="paginationService.maxSize"\n                            page="paginationService.currentPage" on-select-page="changePage()"\n                            previous-text="<" next-text=">">\n                </pagination>\n            </nav>\n        </div>\n\n        <!-- Search sidebar -->\n\n        <div class="sidebar-col">\n            <div class="panel panel-general">\n                <div class="panel-heading">\n                    <div class="title-panel">\n                        <h4 class="title">Search by</h4>\n                    </div>\n                    <div class="header-panel-nav">\n                        <a href="" class="search-arrow" ng-click="uiState.filtersCollapsed=!uiState.filtersCollapsed"><i\n                                class="icon icon-chevron-right"></i></a>\n                    </div>\n                </div>\n                <div class="panel-body">\n                    <div class="search-sidebar">\n                        <form>\n\n                            <cmnt-filtering filtering="filteringService" filters="baseFilters"\n                                            on-search="applyFilters()"\n                                            visible-filters-count="reportParams.visibleFiltersCount"></cmnt-filtering>\n\n                            <div class="search-sidebar__actions button-group button-group_align-space-between">\n                                <button class="button button_size_s button_transparent button_border_silver"\n                                        type="button" ng-click="clearFilters()">Clear\n                                </button>\n\n                                <button class="button button_size_s button_color_pink" ng-click="applyFilters()"\n                                        type="button">\n                                    <i class="icon icon-search"></i> Search\n                                </button>\n                            </div>\n\n                        </form>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n');
$templateCache.put('ip/projects/projectsTemplateList.html','<div ng-repeat="project in objects" class="relative">\n\t\t<div class="project" ng-class="{\'project_no-mb\': $last, \'project_expanded\': project.expanded, \'project_dark\': darkMode}"\n\t\t\t\t cmnt-selection-or-click="project.expanded = !project.expanded">\n\t\t\t\t<div class="project__content">\n\t\t\t\t\t\t<div class="project__row">\n\t\t\t\t\t\t\t\t<div class="project__column project__column_25 flex flex_align-center">\n\t\t\t\t\t\t\t\t\t\t<div class="project__country-flag">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="flag32" ng-class="::(\'flag32-\' + (project.defining_repr.code.toLowerCase() === \'em\' ? \'eu\': project.defining_repr.code.toLowerCase()))"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__heading">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__type">{{ ::project.sub_type_repr.value}}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field text-uppercase">{{ ::project.defining_repr.value}}</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_35 flex flex_align-stretch">\n\t\t\t\t\t\t\t\t\t\t<div class="project__logo" ng-if="::project.image70">\n\t\t\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ ::project.image70 }}" alt="project-logo"/>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="flex flex_column">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field project__field_mb-10">{{ ::project.subject_name}}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__label" ng-if="project.classes.length">Class(es)</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-repeat="class in project.classes | orderBy: \'class_no\' | filter: {class_no: \'!!\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::((class.class_no !== null && class.class_no < 10 ? \'0\' + class.class_no : class.class_no) + ( $last ? \'\' : \', \')) }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_40 flex flex_wrap flex_space-between">\n\t\t\t\t\t\t\t\t\t\t<div class="project__column project__column_50 project__column_pd-0 project__column_mb-15">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__label">Application Date</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::(project.application_date|cmntCustomDateFormat:"DD MMM YYYY") }}</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__column project__column_50 project__column_pd-0 project__column_mb-15">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__label">Application Number</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::project.application_number }}</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__column project__column_50 project__column_pd-0">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__label">Status</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::project.status }}</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__column project__column_50 project__column_pd-0">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__label">Legal Owner</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::project.legal_owner }}</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="project__row" ng-if="project.expanded">\n\t\t\t\t\t\t\t\t<div class="project__column project__column_25"></div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_35">\n\t\t\t\t\t\t\t\t\t\t<div class="project__label">TM TYPE</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::project.trademark_type }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_20">\n\t\t\t\t\t\t\t\t\t\t<div class="project__label">Registration No.</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::project.registration_number }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_20 project__column_plr-0">\n\t\t\t\t\t\t\t\t\t\t<div class="project__label">Registration Date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::(project.registration_date|cmntCustomDateFormat:"DD MMM YYYY") }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="project__row" ng-if="project.expanded">\n\t\t\t\t\t\t\t\t<div class="project__column project__column_25"></div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_35">\n\t\t\t\t\t\t\t\t\t\t<div class="project__label">Earliest Priority Date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::(project.earliest_priority_date|cmntCustomDateFormat:"DD MMM YYYY") }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_20">\n\t\t\t\t\t\t\t\t\t\t<div class="project__label">Publication Date</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::(project.publication_date|cmntCustomDateFormat:"DD MMM YYYY") }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="project__column project__column_20 project__column_plr-0">\n\t\t\t\t\t\t\t\t\t\t<div class="project__label">Next Renewal Due</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__field">{{ ::(project.next_renewal_due|cmntCustomDateFormat:"DD MMM YYYY") }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="project__classes project__column project__column_100  flex flex_column" ng-if="project.expanded">\n\t\t\t\t\t\t\t\t<div class="project__class flex" ng-repeat="class in project.classes | orderBy: \'class_no\'">\n\t\t\t\t\t\t\t\t\t\t<div class="project__column project__column_10 project__column_mr-10 project__class-field flex flex_align-center flex_column flex_content-center"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'project__class-field_white\': darkMode}">CLASS\n\t\t\t\t\t\t\t\t\t\t\t\t<span class="project__field project__field_mt-10">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::(class.class_no !== null && class.class_no < 10 ? \'0\' + class.class_no : (class.class_no || \'\')) }}\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="project__column project__column_90 project__class-field"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="{\'project__class-field_white\': darkMode}">{{ ::class.description }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<button class="project__folder" ng-class="{\'project__folder_white\': darkMode}" cmnt-spinner-action="openSharedFilesModal(project.id)"\n\t\t\t\t\t\t\t\t\t\tcmnt-selection-or-click-stop-propagation>\n\t\t\t\t\t\t\t\t<i class="icon" ng-class="{\'icon-folder\': project.shared_folder_has_children, \'icon-folder-empty\': !project.shared_folder_has_children}"></i>\n\t\t\t\t\t\t</button>\n\n\t\t\t\t\t\t<button class="project__dots flex flex_space-between flex_align-center"\n\t\t\t\t\t\t\t\t\t\tng-class="{\'project__dots_white\': darkMode}">\n\t\t\t\t\t\t\t\t<span class="dot"></span><span class="dot"></span><span class="dot"></span>\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/tasks/inlineEnquiry.directive.html','<div class="enquiry" ng-click="vm.viewEnquiry(vm.enquiry)"\n\t\t ng-class="{\'enquiry_group\': vm.enquiryGroup}">\n\n\t\t<!-- collapsed enquiry -->\n\n\t\t<div class="enquiry__pane" ng-if="!vm.enquiryGroup">\n\t\t\t\t<div class="enquiry__info" ng-if="::vm.enquiry.direction === \'outgoing\'">\n\t\t\t\t\t\t<div class="enquiry__userpic-group">\n\t\t\t\t\t\t\t\t<div class="enquiry__userpic" cmnt-stop-propagation\n\t\t\t\t\t\t\t\t\t\t ng-repeat="conv in ::vm.convs"\n\t\t\t\t\t\t\t\t\t\t ng-class="{\'enquiry__userpic_notification\': conv.unread}"\n\t\t\t\t\t\t\t\t\t\t ng-click="vm.viewConversation(vm.enquiry, conv)">\n\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ ::conv.avatar }}">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="enquiry__subscription">\n\t\t\t\t\t\t\t\t<i class="icon enquiry__icon_direction enquiry__icon" ng-class="::vm.directionIconClass"\n\t\t\t\t\t\t\t\t\t tooltip="{{ ::vm.directionLabel }}" tooltip-append-to-body="true">\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t{{ ::vm.enquiry.expertise }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="enquiry__info" ng-if="::vm.enquiry.direction === \'incoming\'">\n\t\t\t\t\t\t<div class="enquiry__userpic"\n\t\t\t\t\t\t\t\t ng-class="{\'enquiry__userpic_notification\': vm.supplier_conv.unread}">\n\t\t\t\t\t\t\t\t<img ng-src="{{ ::vm.enquiry.creator_avatar }}">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="enquiry__subscription">\n\t\t\t\t\t\t\t\t<i class="icon enquiry__icon_direction enquiry__icon" ng-class="::vm.directionIconClass"\n\t\t\t\t\t\t\t\t\t tooltip="{{ ::vm.directionLabel }}" tooltip-append-to-body="true">\n\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t{{ ::vm.enquiry.expertise }}\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="enquiry__status" ng-if="::!vm.task.owned">\n\t\t\t\t\t\t<div class="case-person-info-status" ng-class="::vm.casePersonClass">\n\t\t\t\t\t\t\t\t<i class="icon enquiry__icon" ng-class="::vm.statusIconClass"\n\t\t\t\t\t\t\t\t\t ng-if="::vm.supplier_conv.status !== \'quoted\'">\n\t\t\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t\t\t<span class="enquiry__label">\n                    {{ ::vm.projectStatusLabel }}\n                </span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="enquiry__status" ng-if="::vm.task.owned">\n\t\t\t\t\t\t<div class="case-person-info-status" ng-class="vm.casePersonClass" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t<i class="icon enquiry__icon" ng-class="vm.statusIconClass">\n\t\t\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="left" pane-offset="-20"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t class="hamburger-menu"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="vm.projectStatus === \'sent\' || vm.projectStatus === \'confirmed\'">\n\t\t\t\t\t\t\t\t\t\t<toggle>\n                        <span class="enquiry__label">\n                            {{ vm.projectStatusLabel }}\n                        </span>\n\t\t\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel hamburger-menu-panel_static hamburger-menu-panel_width_110"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="::(!vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a ng-if="vm.projectStatus === \'sent\'" href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.confirmInstructions($close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tConfirm instructions\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a ng-if="vm.projectStatus === \'confirmed\'" href=""\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.completeInstructions($close)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tConfirm completion\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t\t\t</dropdown-toggle>\n\n\t\t\t\t\t\t\t\t<span class="enquiry__label" ng-if="vm.projectStatus !== \'sent\' && vm.projectStatus !== \'confirmed\'">\n                    {{ ::vm.projectStatusLabel }}\n                </span>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- expanded enquiry -->\n\n\t\t<div class="enquiry-group-pane" ng-if-start="vm.enquiryGroup">\n\t\t\t\t<div class="enquiry__subscription">\n\t\t\t\t\t\t<i class="icon enquiry__icon_direction enquiry__icon"\n\t\t\t\t\t\t\t ng-class="::vm.directionIconClass"\n\t\t\t\t\t\t\t tooltip-append-to-body="true"\n\t\t\t\t\t\t\t tooltip="{{ ::vm.directionLabel }}">\n\t\t\t\t\t\t</i>\n\n\t\t\t\t\t\t{{ ::vm.enquiry.expertise }}\n\t\t\t\t</div>\n\n\n\t\t\t\t<div class="case-person-info-status enquiry-group-pane__status" ng-class="::vm.casePersonClass">\n\t\t\t\t\t\t<i class="icon enquiry__icon" ng-class="::vm.statusIconClass"></i>\n\n\t\t\t\t\t\t<span class="enquiry__label">\n                {{ ::vm.projectStatusLabel }}\n            </span>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="case-body" ng-if-end="vm.enquiryGroup">\n\t\t\t\t<div class="case-person" ng-repeat="conv in vm.enquiry.supplier_conversations"\n\t\t\t\t\t\t ng-class="{\'case-person_notification\': conv.unread > 0}"\n\t\t\t\t\t\t cmnt-stop-propagation\n\t\t\t\t\t\t ng-click="vm.viewConversation(vm.enquiry, conv)">\n\n\t\t\t\t\t\t<div class="case-person-pic" ng-if="vm.enquiry.direction === \'outgoing\'">\n\t\t\t\t\t\t\t\t<img class="case-person-pic__img" ng-src="{{ ::conv.avatar }}">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="case-person-info">\n\t\t\t\t\t\t\t\t<h4 class="case-person-info__firm" ng-if="vm.enquiry.direction === \'outgoing\'">\n\t\t\t\t\t\t\t\t\t\t{{ ::conv.firm }}\n\t\t\t\t\t\t\t\t</h4>\n\t\t\t\t\t\t\t\t<div class="case-person-info-status case-person-info-status_{{ conv.status }}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon case-person-info-status__icon {{ vm.getStatusIcon(conv) }}"\n\t\t\t\t\t\t\t\t\t\t\t ng-if="conv.status !== \'quoted\'"></i>\n\t\t\t\t\t\t\t\t\t\t{{ conv|conversationStatus }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/tasks/requestVisibility.modal.html','<div class="modal">\n\t\t<div class="modal-header"></div>\n\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">{{ ::text }}</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group button-group_compact">\n\t\t\t\t\t\t<button class="button button_size_s button_color_blue" type="button" cmnt-spinner-action="yes()">Yes\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_blue" ng-click=\'$dismiss()\'\n\t\t\t\t\t\t\t\t\t\tautofocus type="button">No\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/tasks/tasks.html','<section class="head-report">\n\t\t<div class="head-report__inner">\n\t\t\t\t<div class="head-report__content">\n\t\t\t\t\t\t<h2 class="head-report__title">{{ vm.profile.organization.title }}</h2>\n\t\t\t\t\t\t<p class="head-report__description">Here are your important upcoming deadlines and what they should cost to\n\t\t\t\t\t\t\t\tcomplete</p>\n\t\t\t\t</div>\n\t\t\t\t<!--button class="button button_landing button_size_s button_color_blue">\n\t\t\t\t\t\t<i class="icon icon-print"></i>\n\t\t\t\t\t\tPrint report\n\t\t\t\t</button-->\n\t\t</div>\n</section>\n<section class="filter filter_tasks filter_response_v2 filter_response_v3">\n\t\t<div class="filter-pane">\n\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t<div class="choose-params">\n\t\t\t\t\t\t\t\t<div class="choose-params__label">Show</div>\n\t\t\t\t\t\t\t\t<div class="choose-params__buttons">\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.matterTypeChanged(\'patents\')"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_color_flamingo_active\': vm.matterTypeSlug===\'patents\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-lamp"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tPatents\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.matterTypeChanged(\'trademarks\')"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_color_flamingo_active\': vm.matterTypeSlug===\'trademarks\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-tm_circle"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tTrademarks\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.matterTypeChanged(\'Designs\')"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_color_flamingo_active\': vm.matterTypeSlug===\'Designs\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-carts"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tDesigns\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_enlarged button_color_flamingo choose-params__button" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.matterTypeChanged(\'others\')"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_color_flamingo_active\': vm.matterTypeSlug===\'others\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-grow"></i>\n\t\t\t\t\t\t\t\t\t\t\t\tOthers\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_145 filter__select">\n\t\t\t\t\t\t\t\t<label class="select__label">Status</label>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.status" name=\'status\' ng-change="vm.filtersChanged({status: vm.status})">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="All" allow-clear="true">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="status.value as status in vm.statusChoices">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="status.label"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!--div class="filter-pane__item">\n\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_145 filter__select">\n\t\t\t\t\t\t\t\t<label class="select__label">Jurisdiction</label>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.defining" name=\'defining\' ng-change="vm.filtersChanged({defining: vm.defining})"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="!vm.matterTypeSlug">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="All" allow-clear="true">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.value"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="defining.id as defining in vm.definings[vm.matterTypeSlug]|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t<span>{{ defining.value }}</span><span ng-if="vm.matterTypeSlug===\'others\'">&nbsp;({{ vm.matterTypesById[defining.matter_type].title }})</span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div-->\n\n\t\t\t\t<div class="filter-pane__item filter-pane__item_direction-column filter-pane__item_search">\n\t\t\t\t\t\t<cmnt-search-field ng-model="vm.fulltext" ng-change="vm.filtersChanged({fulltext: vm.fulltext})">\n\t\t\t\t\t\t</cmnt-search-field>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="filter-pane__item filter-pane__item_pull-left">\n\t\t\t\t\t\t<div class="choose-field">\n\t\t\t\t\t\t\t\t<label class="choose-field__label">Timeframe</label>\n\n\t\t\t\t\t\t\t\t<cmnt-time-frame start-date="vm.startDate" end-date="vm.endDate" timeframe="vm.timeframe"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t on-change="vm.timeframeChanged(startDate, endDate)">\n\t\t\t\t\t\t\t\t</cmnt-time-frame>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="filter-pane__item">\n\t\t\t\t\t\t<div class="filter-subscription">\n\t\t\t\t\t\t\t\t<div class="filter-subscription__title">\n\t\t\t\t\t\t\t\t\t\tSubscription\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="filter-subscription__content">\n\t\t\t\t\t\t\t\t\t\t<div class="filter-subscription__icon">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-logo"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="filter-subscription__text">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="filter-subscription__description">Price visibility for</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="filter-subscription__deadlines">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="filter-subscription__remainder">{{ ::vm.priceVisibilityDays }} days</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="" class="filter-subscription__link" ng-click="vm.requestVisibility()">Change</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<section class="line-info">\n\t\t<div class="line-info__inner">\n\t\t\t\t<h3 class="line-info__title">Deadlines</h3>\n\t\t\t\t<div class="line-info__message">\n\t\t\t\t\t\t<div class="line-info__message-text">\n\t\t\t\t\t\t\t\tShould cost\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="message-icon" ng-mouseenter="vm.showCostPopover=true">\n\t\t\t\t\t\t\t\t<i class="icon icon-info"></i>\n\t\t\t\t\t\t\t\t<div class="message-icon__dropdown message-icon__dropdown_position_left" ng-if="vm.showCostPopover">\n\t\t\t\t\t\t\t\t\t\t<i class="message-icon__close icon icon-close" ng-click="vm.showCostPopover=false"></i>\n\t\t\t\t\t\t\t\t\t\t<h4>How we calculate \u2018Should cost\u2019</h4>\n\n\t\t\t\t\t\t\t\t\t\t<p>We\u2019re able to compare and benchmark against thousands of similar tasks that are completed on the\n\t\t\t\t\t\t\t\t\t\t\t\tObviously Manage platform.</p>\n\n\t\t\t\t\t\t\t\t\t\t<p>This helps you see whether the costs you\u2019re quoted for comparable work are low, high or about\n\t\t\t\t\t\t\t\t\t\t\t\tright.</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="line-info__currency select select_without-border select_back-white select_currency">\n\t\t\t\t\t\t<ui-select ng-model="vm.baseCurrency" search-enabled="false"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.currencyChanged(vm.baseCurrency)">\n\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected"></span>\n\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t<ui-select-choices repeat="currency in vm.convertableCurrencies">\n\t\t\t\t\t\t\t\t\t\t<span ng-bind="currency"></span>\n\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t</ui-select>\n\t\t\t\t</div>\n\t\t\t\t<div class="line-info__hamburger-menu-wrapper">\n\t\t\t\t\t\t<dropdown-toggle close-on-click="true" pane-align="right" class="line-info__hamburger-menu hamburger-menu">\n\t\t\t\t\t\t\t\t<toggle>\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue button_nowrap hamburger-menu__button hamburger-menu__button_menu">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-menu"></i>\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</toggle>\n\t\t\t\t\t\t\t\t<pane>\n\t\t\t\t\t\t\t\t\t\t<ul class="hamburger-menu-panel">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="hamburger-menu-panel__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href ng-click="vm.downloadExportedFile()"><i class="icon icon-download"></i> Download CSV\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\treport</a>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</pane>\n\t\t\t\t\t\t</dropdown-toggle>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<div class="tasks-list">\n\t\t<div class="tasks-list__inner" infinite-scroll="vm.loadMore()" infinite-scroll-distance="1"\n\t\t\t\t ng-if="!vm.displayPlaceholders"\n\t\t\t\t infinite-scroll-immediate-check="false" infinite-scroll-disabled="!vm.tasks.$resolved">\n\t\t\t\t<div class="tasks-list__item task-item" ng-repeat="task in vm.tasks"\n\t\t\t\t\t\t ng-class="{\'task-item_active\': task.$isExpanded}" ng-init="vm.initTaskState(task)">\n\t\t\t\t\t\t<div class="task-item__head" ng-click="vm.toggleExpand(task)">\n\t\t\t\t\t\t\t\t<div class="task-item__main">\n\t\t\t\t\t\t\t\t\t\t<div class="task-item__icon" ng-switch="task.sub_matter_data.matter_type_slug">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-tm_circle" ng-switch-when="trademarks"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-lamp-circle" ng-switch-when="patents"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-carts" ng-switch-when="Designs"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-grow" ng-switch-default></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-item__context">\n\t\t\t\t\t\t\t\t\t\t\t\t<h3 class="task-item__title">{{ ::task.title }}&nbsp;({{ ::task.sub_matter_data.defining_repr\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t}})</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__text">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__id" ng-if="::task.sub_matter_data.application_number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::task.sub_matter_data.application_number }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-if="::task.image_url" class="task-item__image">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ ::task.image_url }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__description">{{ ::task.sub_matter_data.title }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__text" ng-if="::task.sub_matter_data.additional_number">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__id">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::task.sub_matter_data.additional_number }}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="task-item__actions">\n\t\t\t\t\t\t\t\t\t\t<div class="task-item__action task-item__action_status">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__action-title task-item__action-title_task-discarder"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="task.budget_status===\'not_included\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDiscarded\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__action-title" ng-class="\'task-item__action-title_task-\' + task.status"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="task.budget_status!==\'not_included\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::vm.TaskStatusLabels[task.status] }}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="task-item__action-button" ng-if="!task.enquiry_archived"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-switch="task.$isExpanded">\n                            <span ng-switch-when="true">Close\n                                <i class="icon icon-up-open"></i>\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-default>Show actions\n                                <i class="icon icon-down-open"></i>\n                            </span>\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-item__action"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-class="::{\'task-item__action_cost\': task.visibility_type === \'invisible\', \'task-item__action_cost_active\': task.visibility_type === \'normal\', \'task-item__action_cost_old\': task.visibility_type === \'past\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__action-title" ng-switch="task.visibility_type">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-when="past">Should have cost</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-switch-default>Should cost</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__action-text" ng-click="vm.requestVisibility(task)"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t cmnt-stop-propagation tooltip="{{ task.$budget_tooltip }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::((task.$budgets_sum|currency:task.converted_multiplied_budget.symbol:0) || \'$ 000\')}}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="task-item__action-button" ng-if="::task.visibility_type===\'invisible\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.requestVisibility(task)" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-right-open-mini"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tReveal\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="task-item__action task-item__action_date">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__action-title task-item__action-title_date" ng-if="::task.due_date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::task.due_date|cmntCustomDateFormat:"YYYY" }}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="task-item__action-text" ng-if="::task.due_date">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ ::task.due_date|cmntCustomDateFormat:"DD MMM" }}\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="task-item__action-button" ng-click="vm.setBudgetStatus(task, \'maybe_included\')"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="task.owned && !vm.currentUser.is_read_only && task.budget_status === \'not_included\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-basket-download" ng-if="!task.$isBudgetChanges"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-spinner icon-spin6" ng-if="task.$isBudgetChanges"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tRestore\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="task-item__action-button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="vm.setBudgetStatus(task, \'not_included\')"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-if="task.owned && !vm.currentUser.is_read_only && task.budget_status !== \'not_included\'"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\ttype="button" cmnt-stop-propagation>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-basket" ng-if="!task.$isBudgetChanges"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-spinner icon-spin6" ng-if="task.$isBudgetChanges"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDiscard\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="task-item__body" ng-if="task.$isExpanded">\n\t\t\t\t\t\t\t\t<div class="task-item__description-container" ng-if="::task.text">\n\t\t\t\t\t\t\t\t\t\t<div class="task-item__description-text"\n\t\t\t\t\t\t\t\t\t\t\t\t ng-bind-html="task.text|escapeHtml|convertLineBreaks"></div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class="case-handle"\n\t\t\t\t\t\t\t\t\t\t ng-if="::(task.owned && !task.community && !task.enquiry_archived && !vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t<div class="case-handle__item case-handle__item_title">\n\t\t\t\t\t\t\t\t\t\t\t\tActions:\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="case-handle__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_width_200 filter__select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="task.$quoteAction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind="$select.selected.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="action.value as action in task.$quoteActions">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="action.label"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="case-handle__item">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_blue"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.getQuotations(task)" ng-disabled="!task.$quoteAction">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tStart talking!\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<cmnt-inline-enquiry task="task" current-user="vm.currentUser"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-if="task.enquiry && !task.enquiry_archived"></cmnt-inline-enquiry>\n\n\t\t\t\t\t\t\t\t<cmnt-loading-indicator resource="task.$enquiry" ng-if="task.community"></cmnt-loading-indicator>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div ng-if="::vm.ordering===\'-due_date_normalized\'">\n\t\t\t\t\t\t\t\t<div class="task-item__theme-line theme-line"\n\t\t\t\t\t\t\t\t\t\t ng-if="task.visibility_type === \'invisible\' && (vm.tasks[$index+1].visibility_type === \'normal\' || vm.tasks[$index+1].visibility_type === \'past\')">\n\t\t\t\t\t\t\t\t\t\t<div class="theme-line__context">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="theme-line__title">Subscription: {{ ::vm.priceVisibilityDays }} days price\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tvisibility\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<a href="" class="theme-line__link" ng-click="vm.requestVisibility()">Change</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="task-item__theme-line theme-line"\n\t\t\t\t\t\t\t\t\t\t ng-if="task.visibility_type === \'normal\' && vm.tasks[$index+1].visibility_type === \'past\'">\n\t\t\t\t\t\t\t\t\t\t<div class="theme-line__context">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="theme-line__title">Past activities</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div ng-if="::vm.ordering===\'due_date_normalized\'">\n\t\t\t\t\t\t\t\t<div class="task-item__theme-line theme-line"\n\t\t\t\t\t\t\t\t\t\t ng-if="(task.visibility_type === \'normal\' || task.visibility_type === \'past\') && (vm.tasks[$index+1].visibility_type === \'invisible\')">\n\t\t\t\t\t\t\t\t\t\t<div class="theme-line__context">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="theme-line__title">Subscription: {{ ::vm.priceVisibilityDays }} days price\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tvisibility\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<a href="" class="theme-line__link" ng-click="vm.requestVisibility()">Change</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="task-item__theme-line theme-line"\n\t\t\t\t\t\t\t\t\t\t ng-if="task.visibility_type === \'past\' && vm.tasks[$index+1].visibility_type === \'normal\'">\n\t\t\t\t\t\t\t\t\t\t<div class="theme-line__context">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="theme-line__title">Past activities</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-loading-indicator class="loading-indicator_align-center loading-indicator_white-spinner"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tresource="vm.tasks" ng-if="!vm.tasks.$initial">\n\t\t\t\t</cmnt-loading-indicator>\n\n\t\t\t\t<cmnt-empty-result resource="vm.tasks" title="There are no tasks." extra-class="empty-result_theme-white">\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tTry to expand the date range\n\t\t\t\t\t\t\t\t<b>or</b> <a ng-click="Navigation.go(\'community.search\')">find and fetch</a> your patents and trademarks\n\t\t\t\t\t\t</p>\n\t\t\t\t</cmnt-empty-result>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/boost/boost.modal.html','<div class="modal">\n\t\t<div class="modal-body">\n\t\t\t\t<div class="boost-user">\n\t\t\t\t\t\t<img class="boost-user__image" ng-src="{{ vm.profile.avatar }}" alt="">\n\t\t\t\t\t\t<div class="boost-user__name">{{ vm.profile.name }}</div>\n\t\t\t\t\t\t<div class="boost-user__city">{{ vm.profile.organization.title }}</div>\n\t\t\t\t\t\t<label class="boost-user__score">Community Score: <b>{{ vm.profile.community_score }}</b></label>\n\t\t\t\t</div>\n\t\t\t\t<p class="modal-body__text" ng-if="vm.currentUser.first_name">Hi <b>{{ vm.currentUser.first_name }}</b>!</p>\n\t\t\t\t<p class="modal-body__text">If you want to boost your community profile and appear higher on the search results,\n\t\t\t\t\t\tthere are three ways to do this:</p>\n\t\t\t\t<ul class="boost-list">\n\t\t\t\t\t\t<li class="boost-list__item">\n\t\t\t\t\t\t\t\t<span class="boost-list__number">1</span>\n\t\t\t\t\t\t\t\t<p class="boost-list__text">Send cases to other members on the platform. Every time you send a case\n\t\t\t\t\t\t\t\t\t\tthrough the Obviously Manage platform, even to your existing colleagues, your score is boosted once the case\n\t\t\t\t\t\t\t\t\t\tis completed</p>\n\t\t\t\t\t\t\t\t<button type="button" class="button button_size_s button_color_blue" ng-click="vm.startNewCase()">Start\n\t\t\t\t\t\t\t\t\t\ta new case\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="boost-list__item">\n\t\t\t\t\t\t\t\t<span class="boost-list__number">2</span>\n\t\t\t\t\t\t\t\t<p class="boost-list__text">Refer another attorney to the community - when you refer another attorney\n\t\t\t\t\t\t\t\t\t\t(from another firm) and this attorney signs up, your scoring is boosted.</p>\n\t\t\t\t\t\t\t\t<button type="button" class="button button_size_s button_color_blue" ng-click="vm.referAnAttorney()">\n\t\t\t\t\t\t\t\t\t\tRefer an attorney now\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<li class="boost-list__item">\n\t\t\t\t\t\t\t\t<span class="boost-list__number">3</span>\n\t\t\t\t\t\t\t\t<p class="boost-list__text">Invite a member of your team to the community - when you invite a team\n\t\t\t\t\t\t\t\t\t\tmember who signs up, your score is boosted.</p>\n\t\t\t\t\t\t\t\t<button type="button" class="button button_size_s button_color_blue" ng-click="vm.inviteMember()">Invite\n\t\t\t\t\t\t\t\t\t\ta team member now\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/boost/existingMemberWarning.modal.html','<div class="modal">\n\t\t<div class="modal-header modal-header_theme-blue">\n\t\t\t\t<h2 class="modal-header__title">This person is an existing Obviously Manage member</h2>\n\t\t</div>\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">You cannot invite him and be rewarded with a community score as he is already a\n\t\t\t\t\t\tmember.</p>\n\t\t\t\t<p class="modal-body__text">However, we will mark this person as an existing contact to make it easier for you\n\t\t\t\t\t\tto work with him.</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t<button class="button button_size_m button_color_blue" ng-click="$close()">Ok</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/boost/referAttorney.modal.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title modal-header__title_align-center">Invite an Attorney</h2>\n\t\t\t\t<h3 class="modal-header__subtitle modal-header__subtitle_align-center">and boost your community score</h3>\n\t\t</div>\n\t\t<div class="modal-body" ng-if-start="vm.step === 1">\n\t\t\t\t<p class="modal-body__text">Help a colleague grow their network by inviting them to the Obviously Manage community.</p>\n\t\t\t\t<p class="modal-body__text">We encourage referals between attorneys by boosting your community score for each\n\t\t\t\t\t\tattorney that signs up following your invitation.</p>\n\t\t\t\t<div class="boost-points">\n\t\t\t\t\t\t<div class="boost-point">\n\t\t\t\t\t\t\t\t<div class="boost-point__pane">\n\t\t\t\t\t\t\t\t\t\t<div class="boost-point__plus">+</div>\n\t\t\t\t\t\t\t\t\t\t<div class="boost-point__count">{{ ::vm.ScoreAction.REFERRAL }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="boost-point__text">Points for you</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="boost-point">\n\t\t\t\t\t\t\t\t<div class="boost-point__pane">\n\t\t\t\t\t\t\t\t\t\t<div class="boost-point__plus">+</div>\n\t\t\t\t\t\t\t\t\t\t<div class="boost-point__count">{{ ::vm.ScoreAction.REFERRAL_INVITEE }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p class="boost-point__text">Points for the attorney you invited</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-center" ng-if-end>\n\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t<button ng-click="$dismiss()" class="button button_size_m button_transparent button_border_blue">\n\t\t\t\t\t\t\t\tCANCEL\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_m button_color_blue" ng-click="vm.next()">INVITE</button>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="modal-body" ng-if-start="vm.step === 2">\n\t\t\t\t<form cmnt-handle-errors>\n\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Email</label>\n\t\t\t\t\t\t\t\t\t\t<input id="attorneyEmail" placeholder="Email" type="text" class="field__text" name="email"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.attorneyEmail" autofocus/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field-textarea field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Message</label>\n\t\t\t\t\t\t\t\t\t\t<textarea id="inviteMessage" class="field__text modal-body__textarea" ng-model="vm.message"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tname="message">\n                    </textarea>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right" ng-if-end>\n\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t<button ng-click="$dismiss()" class="button button_size_m button_transparent button_border_blue">\n\t\t\t\t\t\t\t\tCANCEL\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_m button_color_blue" cmnt-spinner-action="vm.invite()">INVITE</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/boost/unchangedWarning.modal.html','<div class="modal">\n\t\t<div class="modal-header modal-header_theme-red">\n\t\t\t\t<h2 class="modal-header__title">Default message unchanged</h2>\n\t\t</div>\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">\n\t\t\t\t\t\tAre you sure you want to leave the default invitation message unchaged? Notice that the default message\n\t\t\t\t\t\tdoesn\'t have a name on the first line.\n\t\t\t\t</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right">\n\t\t\t\t<div class="button-group">\n\t\t\t\t\t\t<button ng-click="$dismiss()" class="button button_size_m button_transparent button_border_blue">\n\t\t\t\t\t\t\t\tNo, let me change the message\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_m button_color_blue" ng-click="$close()">Yes, I\'m sure</button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/forms/forms.html','<div class="profile-body-container">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-file-2"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\tMy custom forms\n\t\t\t\t\t\t<i ng-if-end class="like profile-title__like icon icon-heart">\n\t\t\t\t\t\t\t\t<span class="like__value">50</span>\n\t\t\t\t\t\t</i>\n\t\t\t\t</h3>\n\t\t\t\t<div class="dashed-container dashed-container_forms">\n\t\t\t\t\t\t<label class="dashed-container__label">Forms that I typically need my clients to use</label>\n\t\t\t\t\t\t<div class="dashed-container__border">\n\t\t\t\t\t\t\t\t<button class="dashed-container__add">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\tAdd form\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="file">\n\t\t\t\t\t\t<i class="file__icon icon icon-file-2"></i>\n\t\t\t\t\t\t<div class="file-detail">\n\t\t\t\t\t\t\t\t<div class="file-detail__name">FileName.pdf</div>\n\t\t\t\t\t\t\t\t<div class="file-detail__size">632kb</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<button class="button button_only-icon button_color_purple"><i class="icon icon-delete"></i></button>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n\n<div class="profile-body-container">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-file-2"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\tDefault Obviously Manage forms\n\t\t\t\t\t\t<i ng-if-end class="like profile-title__like icon icon-heart">\n\t\t\t\t\t\t\t\t<span class="like__value">50</span>\n\t\t\t\t\t\t</i>\n\t\t\t\t</h3>\n\t\t\t\t<div class="file-group">\n\t\t\t\t\t\t<label class="file-group__label">Make these Obviously Manage forms available to your clients</label>\n\t\t\t\t\t\t<div class="file">\n\t\t\t\t\t\t\t\t<label class="file__checkbox checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox"/>\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<i class="file__icon icon icon-file-2"></i>\n\t\t\t\t\t\t\t\t<div class="file-detail">\n\t\t\t\t\t\t\t\t\t\t<div class="file-detail__name">FileName.pdf</div>\n\t\t\t\t\t\t\t\t\t\t<div class="file-detail__size">632kb</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="file">\n\t\t\t\t\t\t\t\t<label class="file__checkbox checkbox checkbox_color-blue">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox"/>\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<i class="file__icon icon icon-file-2"></i>\n\t\t\t\t\t\t\t\t<div class="file-detail">\n\t\t\t\t\t\t\t\t\t\t<div class="file-detail__name">FileName.pdf</div>\n\t\t\t\t\t\t\t\t\t\t<div class="file-detail__size">632kb</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/members/invite.modal.html','<div class="modal">\n\t\t<div class="modal-header">\n\t\t\t\t<h2 class="modal-header__title">Invite your colleagues to Obviously Manage</h2>\n\t\t</div>\n\n\t\t<form cmnt-handle-errors>\n\t\t\t\t<div class="modal-body">\n\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t<label class="field__label" for="newFollowerEmail">Email</label>\n\t\t\t\t\t\t\t\t<input id="newFollowerEmail" type="text" ng-model=\'vm.email\' class=\'field__text\' name="email"\n\t\t\t\t\t\t\t\t\t\t\t autofocus/>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class="button button_size_s button_color_darkblue" submit cmnt-spinner-action=\'vm.invite()\'>Send\n\t\t\t\t\t\t\t\tinvite\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</form>\n</div>\n');
$templateCache.put('profile/members/members.html','<div class="profile-body-container">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-profile"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title profile-body__title_space-between">\n\t\t\t\t\t\tPrimary contact\n\t\t\t\t\t\t<button id="inviteMemberButton" class="button button_size_s button_color_darkblue" ng-click="vm.invite()"\n\t\t\t\t\t\t\t\t\t\ttype="button" ng-if="!vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\tInvite your colleagues\n\t\t\t\t\t\t</button>\n\t\t\t\t</h3>\n\t\t\t\t<p class="profile-body__text" ng-if="vm.currentUser.id==vm.primaryOrganization.owner">Set who will be the\n\t\t\t\t\t\tprimary contact for your firm. Their name and picture will be used as the main<br/>identity for your firm.\n\t\t\t\t</p>\n\t\t\t\t<div class="members-list members-list_team">\n\t\t\t\t\t\t<div class="members-item" ng-repeat="member in vm.members">\n\t\t\t\t\t\t\t\t<label class="members-item__checkbox checkbox checkbox_color-blue"\n\t\t\t\t\t\t\t\t\t\t\t ng-if="::(vm.currentUser.id==vm.primaryOrganization.owner&&member.user.is_active&&!member.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t ng-class="{checkbox_checked: vm.profile.representative==member.id}"\n\t\t\t\t\t\t\t\t\t\t\t cmnt-spinner-action="vm.setRepresentative(member)">\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t<img class="members-item__picture" ng-src="{{ ::member.user.avatar_80 }}">\n\t\t\t\t\t\t\t\t<div class="members-item__name">\n\t\t\t\t\t\t\t\t\t\t{{ ::member.user.repr }}<span ng-if="::member.is_read_only">&nbsp;(read only member)</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<a href="" cmnt-confirm-click="vm.remove(member)" class="members-item__remove"\n\t\t\t\t\t\t\t\t\t ng-if="::(vm.primaryOrganization.owner!==member.user.id&&vm.currentUser.id!==member.user.id&&!vm.currentUser.is_read_only)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-cancel"></i>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/personal/personal.html','<div class="profile-tab">\n\t\t<div class="profile-tab__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-profile"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">About me</h3>\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="accountForm" class="profile-body__settings"\n\t\t\t\t\t\t\t\t\t\t\tng-if="vm.userModel.is_active">\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group field-group_icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-profile"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="First"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.first_name" name="first_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Last"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.last_name" name="last_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<!--div class="field field_icon field_size_s field_border form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-build"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Company</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" ng-model="vm.company" name="company">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_icon field_size_s field_border form-group_icon" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-email"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Email</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" ng-model="vm.newEmail" name="email">\n\t\t\t\t\t\t\t\t\t\t\t\t</div-->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-actions">\n\t\t\t\t\t\t\t\t\t\t\t\t<a href class="form-actions__link" ng-click="vm.passwordFormShowed=!vm.passwordFormShowed">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tChange password\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river" cmnt-submit ng-click="vm.save()">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="passwordChangeForm" ng-show="vm.passwordFormShowed"\n\t\t\t\t\t\t\t\t\t\t\tclass="profile-body__settings profile-body__settings_password">\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Old password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="password" class="field__text" name="original_password"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.passwordModel.original_password"/>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">New password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" ng-model="vm.passwordModel.password1"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="password1"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t autocomplete="off" tooltip-html-unsafe="{{::vm.passwordRules}}"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t tooltip-trigger="focus" tooltip-placement="top"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-password-strength password="vm.passwordModel.password1"></cmnt-password-strength>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Repeat new password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input type="password" class="field__text" name="password2" autocomplete="off"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.passwordModel.password2"/>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="form-actions form-actions_offset-top form-actions_align-right">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="passwordChangeForm.$pristine"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.changePassword(passwordChangeForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t\t\t<form cmnt-handle-errors name="activateForm" class="profile-body__settings"\n\t\t\t\t\t\t\t\t\t\t\tng-if="!vm.userModel.is_active">\n\t\t\t\t\t\t\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\t\t\t\t\t\t\t\t\t\t<div class="field-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field-group field-group_icon">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="field__icon field__icon_absolute icon icon-profile"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group__label">Name</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="First"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.first_name" name="first_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_width_half field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="text" placeholder="Last"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.userModel.last_name" name="last_name"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="field__label">Choose a password</label>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="field__text" type="password" ng-model="vm.passwordModel.newPassword"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t name="password"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t autocomplete="off">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-password-strength password="vm.passwordModel.newPassword"></cmnt-password-strength>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="login-checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="checkbox-list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.agreeToTou"/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">\n                                    I agree to the <a target="_blank" ng-href="{{::vm.termsOfUseUrl}}">Terms of use and privacy policy</a>\n                                </span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="form-actions form-actions_offset-top form-actions_align-right">\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river" type="submit"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="!vm.agreeToTou"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.activateUser(activateForm)">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tActivate\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</form>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!--div class="profile-body-container" ng-if="vm.userModel.is_active">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-linkedin-squared"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">{{ vm.userModel.linkedin_url ? \'\' : \'Connect \' }}LinkedIn account</h3>\n\t\t\t\t\t\t\t\t<div class="profile-body__settings">\n\t\t\t\t\t\t\t\t\t\t<a ng-if="!vm.userModel.linkedin_url" class="button button_size_s button_color_darkblue"\n\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.connectLinkedIn()">\n\t\t\t\t\t\t\t\t\t\t\t\tConnect LinkedIn\n\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t<div class="field field_size_s field_border" ng-if="vm.userModel.linkedin_url">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="field__text" ng-model="vm.userModel.linkedin_url" readonly>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div-->\n\t\t</div>\n\t\t<div class="profile-tab__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-photo"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">Picture</h3>\n\t\t\t\t\t\t\t\t<p class="profile-body__text">We recommend using a photo of yourself to present your firm as friendly\n\t\t\t\t\t\t\t\t\t\tand approachable</p>\n\t\t\t\t\t\t\t\t<div class="alert alert_theme_default" ng-if="vm.avatarErrors">Avatar error: {{ vm.avatarErrors }}</div>\n\t\t\t\t\t\t\t\t<button class="picture-uploader picture-uploader_user picture-uploader_personal-picture"\n\t\t\t\t\t\t\t\t\t\t\t\tng-file-select ng-file-change="vm.uploadAvatar($files)" accept="image/*" ng-capture="\'camera\'"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'picture-uploader_no-border\': vm.userModel.has_avatar}">\n\t\t\t\t\t\t\t\t\t\t<img ng-src="{{ vm.userModel.avatar_160 }}" ng-if="vm.userModel.has_avatar">\n\t\t\t\t\t\t\t\t\t\t<i ng-if-start="!vm.userModel.has_avatar" class="picture-uploader__icon icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t<span ng-if-end>Profile picture</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!--div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-news"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">News</h3>\n\t\t\t\t\t\t\t\t<label class="checkbox checkbox_color-darkgray">\n\t\t\t\t\t\t\t\t\t\t<input class="checkbox__input" type="checkbox" ng-model="vm.agreeToTou"/>\n\t\t\t\t\t\t\t\t\t\t<i class="checkbox__icon icon icon-checkbox"></i>\n\t\t\t\t\t\t\t\t\t\t<span class="checkbox__title">\n\t\t\t\t\t\t\t\t\t\t\t\tSend me occasional Pekama news\n\t\t\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div-->\n\t\t</div>\n</div>\n');
$templateCache.put('profile/services/myProfilePledges.directive.html','<div class="profile-pledge">\n\t\t<div class="profile-pledge-item" ng-repeat="pledge in vm.pledges|orderBy:\'id\'">\n\t\t\t\t<h6 class="profile-pledge__title">{{ pledge.text }}</h6>\n\t\t\t\t<p class="profile-pledge__text">{{ pledge.help_text }}</p>\n\t\t\t\t<div class="toggle-group toggle-group_size-xs toggle-group_color-blue">\n\t\t\t\t\t\t<label class="toggle-group__label">\n\t\t\t\t\t\t\t\t<input class="toggle-group__radio" type="radio" name="pledge-{{ pledge.id }}"\n\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.pledgeAnswers[pledge.id]" ng-value="true"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.updatePledgeAnswer(pledge.id)" ng-disabled="::vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t<span class="toggle-group__button">Yes</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t\t\t<label class="toggle-group__label">\n\t\t\t\t\t\t\t\t<input class="toggle-group__radio" type="radio" name="pledge-{{ pledge.id }}"\n\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.pledgeAnswers[pledge.id]" ng-value="false"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.updatePledgeAnswer(pledge.id)" ng-disabled="::vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t<span class="toggle-group__button">No</span>\n\t\t\t\t\t\t</label>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/services/myProfileServices.directive.html','<div class="dashed-container">\n\t\t<label class="dashed-container__label">I offer these services, and here are my typical fees</label>\n\n\t\t<!-- Creation form -->\n\t\t<form class="dashed-container__border service-form" cmnt-handle-errors name="addService"\n\t\t\t\t\tng-if="!vm.currentUser.is_read_only">\n\t\t\t\t<cmnt-form-errors></cmnt-form-errors>\n\n\t\t\t\t<!-- Service params -->\n\t\t\t\t<div class="field-group-flex">\n\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item">\n\t\t\t\t\t\t\t\t<label class="select__label">IP Type</label>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.newService.matter_type" ng-change="vm.matterTypeChanged(vm.newService)">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.title }}\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="matterType.id as matterType in vm.matterTypes|filter:{title:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="matterType.title | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item"\n\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t<label class="select__label">Service</label>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.newService.expertise_type" name="expertise_type"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="!vm.newService.matter_type">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.value }}\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="expertiseType.id as expertiseType in vm.expertiseTypes[vm.newService.matter_type]|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="expertiseType.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item"\n\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t<label class="select__label">Jurisdiction</label>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.newService.jurisdiction" name="jurisdiction"\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-disabled="!vm.newService.matter_type">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.value }}\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="defining.id as defining in vm.definings[vm.newService.matter_type]|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="defining.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item"\n\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t<label class="select__label">Handling team member</label>\n\t\t\t\t\t\t\t\t<ui-select ng-model="vm.newService.handling_member" name="handling_member">\n\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="{{ vm.defaultMemberLabel }}" allow-clear="true">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.user.full_name }}\n\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="member.id as member in vm.members">\n\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="member.user.full_name | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Description -->\n\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-20">\n\t\t\t\t\t\t<div class="field field_size_s field_border field-group-flex__item field-group-flex__item_no-margin"\n\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t<button class="dashed-container__add dashed-container__add_services" ng-if="vm.placeholderIsVisible"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.focusDescription()">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\tDescribe any specific details of this service\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<input type="text" class="field__text" ng-model="vm.newService.description" name="description"\n\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.hidePlaceholder()" cmnt-focus-me="vm.descriptionIsFocused">\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!-- Add button -->\n\t\t\t\t\t\t<button class="button button_only-icon button_color_darkblue button_autoresponder field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\tng-disabled="vm.serviceButtonDisabled(vm.newService, addService)"\n\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': vm.newService.autoresponse}"\n\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.addService(addService)">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus" ng-if="!vm.newService._inProgress"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- Autoresponder -->\n\t\t\t\t<div class="field-group-flex service-form__autoresponse field-group-flex_offset-right-25">\n\t\t\t\t\t\t<div class="field field-group-flex__item">\n\t\t\t\t\t\t\t\t<label class="service-form__checkbox">\n\t\t\t\t\t\t\t\t\t\t<input type="checkbox" ng-model="vm.newService.autoresponse"> Automatically reply to enquiries\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="field field-group-flex__item service-form__attach" ng-if="vm.newService.autoresponse">\n\t\t\t\t\t\t\t\t<button class="button button_attach" ng-file-select ng-multiple="true"\n\t\t\t\t\t\t\t\t\t\t\t\tng-file-change="vm.startUploading($files, vm.uploadService)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-attach-file"></i> Attach file\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-20"\n\t\t\t\t\t\t ng-if="vm.newService.autoresponse">\n\t\t\t\t\t\t<div class="field field-textarea field_border field-group-flex__item field-group-flex__item_no-margin"\n\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t<text-angular class="field__text" ng-model="vm.newService.autoresponse_text" cmnt-focus-me="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-file-drop="vm.fileDropHandler" name="template_text"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-text-editor-class="field__text" required>\n\t\t\t\t\t\t\t\t</text-angular>\n\n\t\t\t\t\t\t\t\t<div class="service-form__attachments" ng-if="vm.uploadService.attachments.length > 0">\n\t\t\t\t\t\t\t\t\t\t<cmnt-attachments-list service="vm.uploadService" class="service-form__attachments">\n\t\t\t\t\t\t\t\t\t\t</cmnt-attachments-list>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<button class="button button_only-icon button_color_darkblue button_autoresponder field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\tng-disabled="vm.serviceButtonDisabled(vm.newService, addService)"\n\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.addService(addService)">\n\t\t\t\t\t\t\t\t<i class="icon icon-plus" ng-if="!vm.newService._inProgress"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t</form>\n\n\t\t<!-- Read/edit forms -->\n\t\t<div class="dashed-container__border dashed-container_border-transparent">\n\t\t\t\t<form ng-repeat="service in vm.services|orderBy:\'matter_type_repr.title\'" cmnt-handle-errors\n\t\t\t\t\t\t\tng-init="rowModel = vm.getServiceRowModel(service)" name="editServiceFrom"\n\t\t\t\t\t\t\tclass="field-group-flex-list service-form">\n\n\t\t\t\t\t\t<cmnt-form-errors ng-if="service._isEditing"></cmnt-form-errors>\n\n\t\t\t\t\t\t<!--Read state-->\n\t\t\t\t\t\t<div class="field-group-flex field-group_ellipsis" ng-if-start="!service._isEditing">\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_fill-gray field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">IP Type</label>\n\t\t\t\t\t\t\t\t\t\t<div class="field__text field__text_static">{{ service.matter_type_repr.title }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_fill-gray field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Service</label>\n\t\t\t\t\t\t\t\t\t\t<div class="field__text field__text_static">{{ service.expertise_type_repr.value }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_fill-gray field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Jurisdiction</label>\n\t\t\t\t\t\t\t\t\t\t<div class="field__text field__text_static">{{ service.jurisdiction_repr.value }}</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_fill-gray field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Handling member</label>\n\n\t\t\t\t\t\t\t\t\t\t<div class="field__text field__text_static" ng-if="service.handling_member">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ (vm.members|filter:{id: service.handling_member})[0].user.full_name }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="field__text field__text_static" ng-if="!service.handling_member">\n\t\t\t\t\t\t\t\t\t\t\t\t{{ vm.defaultMemberLabel }}\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-12">\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_theme_fill-gray field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<div class="field__text field__text_static">{{ service.description }}</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_darkblue field-group-flex__item" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="service._isEditing=true" ng-if="::(!vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': service.autoresponse}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-edit"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_purple field-group-flex__item" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="vm.removeService(service)" ng-if="::(!vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': service.autoresponse}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-12 field_theme_fill-gray"\n\t\t\t\t\t\t\t\t ng-if-end ng-show="service.autoresponse">\n\t\t\t\t\t\t\t\t<div class="field field-textarea field-group-flex__item" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="field__label">Automatically replying with:</label>\n\n\t\t\t\t\t\t\t\t\t\t<text-angular class="field__text" ng-model="rowModel.autoresponse_text" cmnt-focus-me="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-disabled="true" ta-file-drop="vm.fileDropHandler" required\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-text-editor-class="field__text">\n\t\t\t\t\t\t\t\t\t\t</text-angular>\n\n\t\t\t\t\t\t\t\t\t\t<div class="attach-files">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="attach-file" ng-repeat="attachment in service.autoresponse_files">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-file-2 attach-file__icon"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="attach-file__description">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="attach-file__name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ attachment.name|cmntMiddleTruncate:30}}\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="attach-file__size">{{ attachment.size|filesize }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_darkblue field-group-flex__item" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="service._isEditing=true" ng-if="::(!vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': !service.autoresponse}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-edit"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_purple field-group-flex__item" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-confirm-click="vm.removeService(service)" ng-if="::(!vm.currentUser.is_read_only)"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': !service.autoresponse}">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!--Read state-->\n\n\t\t\t\t\t\t<!--Editing state-->\n\t\t\t\t\t\t<div class="field-group-flex" ng-if-start="service._isEditing">\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">IP Type</label>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="rowModel.matter_type" ng-change="vm.matterTypeChanged(rowModel)">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.title }}\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="matterType.id as matterType in vm.matterTypes|filter:{title:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="matterType.title | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Service</label>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="rowModel.expertise_type" name="expertise_type">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.value }}\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="expertiseType.id as expertiseType in vm.expertiseTypes[rowModel.matter_type]|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="expertiseType.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s select_placeholder-i field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Jurisdiction</label>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="rowModel.jurisdiction" name="jurisdiction">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Select">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.value }}\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="defining.id as defining in vm.definings[rowModel.matter_type]|filter:{value:$select.search}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="defining.value | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="select select_theme_gray select_size_s field-group-flex__item" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<label class="select__label">Handling member</label>\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="rowModel.handling_member" name="handling_member">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="{{ vm.defaultMemberLabel }}" allow-clear="true">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t{{ $select.selected.user.full_name }}\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices repeat="member.id as member in vm.members">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="member.user.full_name | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-12">\n\t\t\t\t\t\t\t\t<div class="field field_size_s field_border field_theme_gray field-group-flex__item field-group-flex__item_no-margin"\n\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<input type="text" class="field__text" ng-model="rowModel.description" name="description">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_darkblue button_autoresponder field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\t\t\ttype="button" ng-class="{\'button_hide-opacity\': rowModel.autoresponse}"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.updateService(service, rowModel, editServiceFrom)"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="vm.serviceButtonDisabled(rowModel, editServiceFrom)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-confirm" ng-if="!rowModel._inProgress"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_purple field-group-flex__item" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': rowModel.autoresponse}"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="service._isEditing=false">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete-line"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-25 service-form__autoresponse">\n\t\t\t\t\t\t\t\t<div class="field field-group-flex__item">\n\t\t\t\t\t\t\t\t\t\t<label class="service-form__checkbox">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="checkbox" ng-model="rowModel.autoresponse"> Automatically reply to enquiries\n\t\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="field field-group-flex__item service-form__attach" ng-if="rowModel.autoresponse">\n\t\t\t\t\t\t\t\t\t\t<button class="button button_attach" ng-file-select ng-multiple="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-file-change="vm.startUploading($files, rowModel._uploadService)">\n\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-attach-file"></i> Attach\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<!--Autoresponder-->\n\t\t\t\t\t\t<div class="field-group-flex field-group-flex_offset-top field-group-flex_offset-right-12"\n\t\t\t\t\t\t\t\t ng-if="rowModel.autoresponse" ng-if-end>\n\t\t\t\t\t\t\t\t<div class="field field-textarea field_border field-group-flex__item field-group-flex__item_no-margin"\n\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t<text-angular class="field__text" ng-model="rowModel.autoresponse_text" cmnt-focus-me="true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tta-file-drop="vm.fileDropHandler" required ta-text-editor-class="field__text">\n\t\t\t\t\t\t\t\t\t\t</text-angular>\n\n\t\t\t\t\t\t\t\t\t\t<div class="service-form__attachments" ng-if="rowModel._uploadService.attachments.length > 0">\n\t\t\t\t\t\t\t\t\t\t\t\t<cmnt-attachments-list service="rowModel._uploadService"></cmnt-attachments-list>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_darkblue button_autoresponder field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': !rowModel.autoresponse}"\n\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.updateService(service, rowModel, editServiceFrom)"\n\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="vm.serviceButtonDisabled(rowModel, editServiceFrom)">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-confirm" ng-if="!rowModel._inProgress"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button class="button button_only-icon button_color_purple field-group-flex__item" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{\'button_hide-opacity\': !rowModel.autoresponse}"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="service._isEditing=false">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete-line"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<!--Editing state -->\n\t\t\t\t</form>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/services/services.html','<div class="profile-body-container">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-dollar-round"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\tServices\n\t\t\t\t</h3>\n\n\t\t\t\t<cmnt-my-profile-services my-profile="vm.myProfile"></cmnt-my-profile-services>\n\t\t</div>\n</div>\n<div class="profile-body-container">\n\t\t<div class="profile-body-container__icon">\n\t\t\t\t<i class="icon icon-confirm-round"></i>\n\t\t</div>\n\t\t<div class="profile-body-container__content">\n\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\tPledges I make to the community\n\t\t\t\t</h3>\n\t\t\t\t<cmnt-my-profile-pledges></cmnt-my-profile-pledges>\n\t\t</div>\n</div>\n');
$templateCache.put('profile/team/team.html','<div class="profile-tab">\n\t\t<div class="profile-tab__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-build"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<form class="profile-body-container__content profile-body-container__content_overflow" cmnt-handle-errors\n\t\t\t\t\t\t\t\t\tname="organizationForm">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">{{ vm.organizationModel.title }}</h3>\n\t\t\t\t\t\t\t\t<div class="dashed-container">\n\t\t\t\t\t\t\t\t\t\t<div class="dashed-container__border field-group-flex-list" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="dashed-container__add" ng-show="vm.isWebsitePlcVisible"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.focusInput(\'Website\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tWebsite address\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<input class="dashed-container__field" ng-hide="vm.isWebsitePlcVisible"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model="vm.profile.website" name="website" maxlength="200"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t placeholder="http://example.com" ng-focus="vm.onWebSiteFocus()"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-blur="vm.onWebSiteBlur()" cmnt-focus-me="vm.isWebsiteFocused"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="vm.isOrganizationDataChanged=true" ng-disabled="vm.currentUser.is_read_only">\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="dashed-container__border dashed-container__border_textarea field-group-flex-list"\n\t\t\t\t\t\t\t\t\t\t\t\t cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="dashed-container__add dashed-container__add_text-left"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-show="vm.isDescriptionPlcVisible"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.focusInput(\'Description\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tGive some general information about your firm, its history and competitive advantages\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<textarea class="dashed-container__field dashed-container__field_textarea"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-hide="vm.isDescriptionPlcVisible" ng-model="vm.profile.description"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tname="description" maxlength="512" cmnt-focus-me="vm.isDescriptionFocused"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-change="vm.isOrganizationDataChanged=true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="vm.currentUser.is_read_only">\n                        </textarea>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-actions form-actions_offset-top form-actions_align-right"\n\t\t\t\t\t\t\t\t\t\t ng-if="vm.isOrganizationDataChanged">\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river" type="button"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-disabled="organizationForm.$pristine"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.updateOrganizationData(organizationForm)">\n\t\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-portfolio"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<form class="profile-body-container__content" cmnt-handle-errors name="competenceForm">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\t\t\t\t\tExpertise\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<div class="dashed-container">\n\t\t\t\t\t\t\t\t\t\t<div class="dashed-container__border dashed-container__border_textarea" cmnt-field-errors>\n\t\t\t\t\t\t\t\t\t\t\t\t<button class="dashed-container__add" ng-show="vm.isCompetencePlcVisible"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-click="vm.focusInput(\'Competence\')">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-plus"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tAdd Expertise\n\t\t\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t\t\t\t\t<textarea class="dashed-container__field dashed-container__field_textarea"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-hide="vm.isCompetencePlcVisible" ng-model="vm.profile.competence"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tname="competence" maxlength="512" ng-focus="isTooltipShowed=true"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-blur="isTooltipShowed=false" cmnt-focus-me="vm.isCompetenceFocused"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tng-change="vm.isCompetenceChanged=true" ng-disabled="vm.currentUser.is_read_only">\n                        </textarea>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t<div class="dashed-container-tooltip" ng-if="isTooltipShowed">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="dashed-container-tooltip__title">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tList your significant areas of expertise.\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="dashed-container-tooltip__text">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tSome examples:\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t<ul class="dashed-container-tooltip__list">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Medical devices</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Software</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Algorithms</li>\n\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="form-actions form-actions_offset-top form-actions_align-right"\n\t\t\t\t\t\t\t\t\t\t ng-if="vm.isCompetenceChanged">\n\t\t\t\t\t\t\t\t\t\t<button class="button button_size_s button_color_river" ng-disabled="competenceForm.$pristine"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tcmnt-spinner-action="vm.updateCompetence(competenceForm)" type="button">\n\t\t\t\t\t\t\t\t\t\t\t\tSave\n\t\t\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<div class="profile-tab__pane">\n\t\t\t\t<div class="profile-body-container">\n\t\t\t\t\t\t<div class="profile-body-container__icon">\n\t\t\t\t\t\t\t\t<i class="icon icon-heart"></i>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="profile-body-container__content">\n\t\t\t\t\t\t\t\t<h3 class="profile-body__title">\n\t\t\t\t\t\t\t\t\t\tCommunity score\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<div class="community-score">\n\t\t\t\t\t\t\t\t\t\t<span class="community-score__number">{{ vm.profile.community_score }}</span>\n\t\t\t\t\t\t\t\t\t\t<div class="community-score__title" ng-if="!vm.currentUser.is_read_only">How to <a href\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-click="vm.boostScore()">boost\n\t\t\t\t\t\t\t\t\t\t\t\tyour community score</a></div>\n\t\t\t\t\t\t\t\t\t\t<ul class="community-score-list">\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="community-score-list__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__number">{{ vm.casesReceived.count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__label">cases received</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="community-score-list__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__number">{{ vm.casesSent.count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__label">cases sent</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t\t<li class="community-score-list__item">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__number">{{ vm.invitedUsers.count }}</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="community-score-list__label">people invited to Obviously Manage</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('reports/_table_cells/amount.html','{{ object[column.name].amount|number:2}} {{ object[column.name].currency }}');
$templateCache.put('reports/_table_cells/date.html','{{ object[column.name]|cmntDateFormat }}\n');
$templateCache.put('reports/_table_cells/due_date.html','<p ng-class="{\'task-past-due\': (object|cmntDueDateExceeded)}">\n\t\t{{ object[column.name]|cmntDateFormat }}\n</p>\n');
$templateCache.put('reports/_table_cells/htmltext.html','<div ng-bind-html="object[column.name]"></div>');
$templateCache.put('reports/_table_cells/image.html','<img ng-if="object[column.name]" ng-src="{{ object[column.name] }}">');
$templateCache.put('reports/_table_cells/importance.html','<p ng-class="object[column.name].importance_class">{{ object[column.name].repr }}</p>');
$templateCache.put('reports/_table_cells/label.html','<span class="status status-{{ object[column.name].color }}">{{ object[column.name].repr }}</span>');
$templateCache.put('reports/_table_cells/link.html','<span>{{ object[column.name] }}</span>');
$templateCache.put('reports/_table_cells/list.html','<p ng-repeat="item in object[column.name] track by $index">{{ item }}</p>');
$templateCache.put('reports/_table_cells/memobox.html','<p>{{ object[column.name].title }}</p>\n<div>\n\t\t{{ object[column.name].ref_no }}\n\t\t<p ng-repeat="number in object[column.name].numbers track by $index">\n\t\t\t\t{{ number }}\n\t\t</p>\n</div>\n');
$templateCache.put('reports/_table_cells/orderedlinelist.html','<span ng-repeat="item in object[column.name] track by $index">{{ item }}<span ng-if="!$last">, </span></span>');
$templateCache.put('reports/_table_cells/text.html','{{ object[column.name] }}');
$templateCache.put('reports/events/bulk_actions.html','<ul class="list" disable-controls="listLoaded === false || !objects.$resolved">\n\t\t<li>\n\t\t\t\t<a href="" class="btn-link" cmnt-confirm-click="bulkDelete()">Delete</a>\n\t\t</li>\n</ul>\n');
$templateCache.put('reports/export/export.directive.html','<span class="list-label">Export to</span>\n<ul class="list">\n\t\t<li ng-repeat="exportFormat in formats">\n\t\t\t\t<a href ng-click="downloadExportedFile(exportFormat)" class="list__link">{{ exportFormat.title }}</a>\n\t\t</li>\n</ul>\n');
$templateCache.put('reports/export/exportResult.modal.html','<div class="modal">\n    <div class="modal-header">\n        <h2 class="modal-header__title modal-header__title_align-center">Report generation</h2>\n    </div>\n\n    <div class="modal-body">\n        <p class="modal-body__text">\n            <div class="progress-bar progress-bar_size_m" ng-if="!vm.downloadLink"\n                 ng-style="{width: vm.progress + \'%\'}">\n                {{ vm.progress }}%\n            </div>\n            <a ng-href="{{ vm.downloadLink }}" ng-if="vm.downloadLink" download>Download report</a>\n        </p>\n    </div>\n    <div class="modal-footer modal-footer_align-right modal-footer_align-items-center">\n        <button class="button button_size_s button_transparent button_border_silver" ng-click=\'vm.cancel()\'>Close</button>\n    </div>\n</div>');
$templateCache.put('reports/export/exportResults.html','<section class="head-report">\n\t\t<div class="head-report__inner">\n\t\t\t\t<div class="head-report__content">\n\t\t\t\t\t\t<h2 class="head-report__title">EXPORT</h2>\n\t\t\t\t</div>\n\t\t\t\t<div class="head-report__buttons">\n\t\t\t\t\t\t<button class="button button_transparent" ng-click="vm.loadExportResults()"><i class="icon icon-arrows-cw"></i></button>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n<section class="reports-body">\n\t\t<cmnt-loading-indicator resource="vm.exportResults"></cmnt-loading-indicator>\n\n\t\t<cmnt-empty-result resource="vm.exportResults"\n\t\t\t\t\t\t\t\t\t\t\t title="No data available."></cmnt-empty-result>\n\n\t\t<div class="reports-body__export" ng-if="vm.exportResults.length">\n\t\t\t\t<div class="export" ng-repeat="exportItem in vm.exportResults">\n\t\t\t\t\t\t<div class="export__item flex flex_column">\n\t\t\t\t\t\t\t\t<div class="flex flex_space-between flex_align-center export__item_mb-15">\n\t\t\t\t\t\t\t\t\t\t<span>{{ ::(exportItem.created | cmntCustomDateFormat: \'DD-MM-YYYY, HH:mm:ss\') }} - {{ ::exportItem.user_name }}</span>\n\n\t\t\t\t\t\t\t\t\t\t<div class="export__progress">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class="progress-bar-static">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class="progress-bar-static__inner" ng-style="{width: exportItem.progress + \'%\'}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="progress-bar-static__progress">{{ exportItem.progress }}%</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t<div class="flex export__status">\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-switch on="exportItem.status">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="export__label" ng-switch-when="finished">READY</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="export__label" ng-switch-when="received">QUEUED</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="export__label" ng-switch-when="in_progress">IN PROGRESS</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="export__label" ng-switch-when="failed">FAILED</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ng-switch>\n\t\t\t\t\t\t\t\t\t\t\t\t<a class="export__download" href="{{ exportItem.url }}" download\n\t\t\t\t\t\t\t\t\t\t\t\t\t uib-tooltip="Download report" ng-if="exportItem.status === \'finished\'">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-download"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</section>\n\n<nav class="pagination-holder">\n\t\t<pagination ng-if="vm.exportResults.$resolved && vm.exportResults.length" items-per-page="vm.paginationService.pageSize"\n\t\t\t\t\t\t\t\ttotal-items="vm.paginationService.totalItems" max-size="vm.paginationService.maxSize"\n\t\t\t\t\t\t\t\tpage="vm.paginationService.currentPage" on-select-page="vm.changePage()"\n\t\t\t\t\t\t\t\tprevious-text="<" next-text=">">\n\t\t</pagination>\n</nav>\n');
$templateCache.put('reports/filtering/columnChooser.directive.html','<div>\n\t\t<table>\n\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="column-filter-container">\n\t\t\t\t\t\t\t\t<input class="form-control column-filter" type="text" ng-model="availableFilter"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="filterAvailableColumns()" placeholder="Start typing column name...">\n\t\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t\t\t<tr>\n\t\t\t\t\t\t<td class="column-list-container">\n\t\t\t\t\t\t\t\t<span class="column-list-label">Available Columns</span>\n\t\t\t\t\t\t\t\t<ul ui-sortable="sortableOptions" class="column-list" ng-model=\'filteredAvailable\'\n\t\t\t\t\t\t\t\t\t\tcmnt-prevent-outer-scroll>\n\t\t\t\t\t\t\t\t\t\t<li ng-repeat="column in filteredAvailable" ng-click="select(column, \'left\')"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{selected: column.selected}">{{ column.title }}\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t<td class="button-container">\n\t\t\t\t\t\t\t\t<button ng-click="moveRight()" ng-disabled="!currentItem"\n\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_transparent button_border_silver">\u2192\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t<button ng-click="moveLeft()" ng-disabled="!currentItem"\n\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_transparent button_border_silver">\u2190\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t<td class="column-list-container">\n\t\t\t\t\t\t\t\t<span class="column-list-label">Displayed Columns</span>\n\t\t\t\t\t\t\t\t<ul ui-sortable="sortableOptions" class="column-list" ng-model=\'chosenColumns\'\n\t\t\t\t\t\t\t\t\t\tcmnt-prevent-outer-scroll>\n\t\t\t\t\t\t\t\t\t\t<li ng-repeat="column in chosenColumns" ng-click="select(column, \'right\')"\n\t\t\t\t\t\t\t\t\t\t\t\tng-class="{selected: column.selected}">{{ column.title }}\n\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</td>\n\n\t\t\t\t\t\t<td class="button-container">\n\t\t\t\t\t\t\t\t<button ng-click="moveUp()" ng-disabled="!rightActive"\n\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_transparent button_border_silver">\u2191\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<br>\n\t\t\t\t\t\t\t\t<button ng-click="moveDown()" ng-disabled="!rightActive"\n\t\t\t\t\t\t\t\t\t\t\t\tclass="button button_size_xs button_transparent button_border_silver">\u2193\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</td>\n\t\t\t\t</tr>\n\t\t</table>\n</div>\n');
$templateCache.put('reports/filtering/column_chooser_modal.html','<div class="modal">\n\t\t<div class="modal-body">\n\t\t\t\t<cmnt-column-chooser all-columns="availableColumns" chosen-columns="chosenColumns"></cmnt-column-chooser>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-space-between">\n\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" type="button"\n\t\t\t\t\t\t\t\tng-click=\'$dismiss()\'>Cancel\n\t\t\t\t</button>\n\t\t\t\t<button class="button button_size_s button_color_darkblue" type="submit" ng-click=\'apply()\'>Apply</button>\n\t\t</div>\n</div>\n');
$templateCache.put('reports/filtering/filter_row.html','<label class="field__label">{{ baseFilter.label }}</label>\n\n<div class="filter-instance" ng-repeat="filterInstance in filterInstancesMap[baseFilter.key].filterInstances">\n\t\t<div ng-if="filterInstance.baseFilter.type == \'fs\'">\n\t\t\t\t<input class=\'field__text\' ng-model=\'filterInstance.values[0].valueParts[0]\'\n\t\t\t\t\t\t\t ng-change="filteringService.hasChanges = true;delayFilterInstanceChanged(filterInstance)">\n\t\t</div>\n\n\t\t<div class="field-group-flex field-group-flex_align-start" ng-if="filterInstance.baseFilter.type != \'fs\'">\n\t\t\t\t<div class="select select_theme_gray select_size_s select_fixed-width_80 field-group-flex__item">\n\t\t\t\t\t\t<ui-select ng-model="filterInstance.negated"\n\t\t\t\t\t\t\t\t\t\t\t ng-change="filteringService.hasChanges=true;filterInstanceChanged(filterInstance)">\n\t\t\t\t\t\t\t\t<ui-select-match placeholder="Pick one...">{{$select.selected.name}}</ui-select-match>\n\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\trepeat="lookup.value as lookup in lookups.negated | filter: $select.search track by lookup.name">\n\t\t\t\t\t\t\t\t\t\t<div>{{ lookup.name }}</div>\n\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t</ui-select>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="field-group-flex__item">\n\t\t\t\t\t\t<div class="value-struct" ng-repeat="valueStruct in filterInstance.values">\n\t\t\t\t\t\t\t\t<div ng-if="valueStruct.type === \'tx\'">\n\t\t\t\t\t\t\t\t\t\t<input class=\'field__text\' ng-model=\'valueStruct.valueParts[0]\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="filteringService.hasChanges=true;delayFilterInstanceChanged(filterInstance)">\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!--Facets -->\n\t\t\t\t\t\t\t\t<div ng-if="valueStruct.type === \'sl\'" class="select select_theme_gray select_size_s">\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="valueStruct.valueParts[0]"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="filteringService.hasChanges=true;filterInstanceChanged(filterInstance)">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Pick one...">{{$select.selected.label}}</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="facet.val as facet in valueStruct.facets | filter:{label: $select.search} track by facet.val">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-bind-html="facet.label | highlight: $select.search"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span ng-if="facet.count !== undefined"> ({{ facet.count }})</span>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<!--Dates -->\n\t\t\t\t\t\t\t\t<div class="value-struct select select_theme_gray select_size_s" ng-if-start="valueStruct.type === \'dt\'"\n\t\t\t\t\t\t\t\t\t\t class="select select_theme_gray select_size_s">\n\t\t\t\t\t\t\t\t\t\t<ui-select ng-model="filterInstance.lookup"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="filteringService.hasChanges=true; dateLookupChanged(filterInstance.lookup, valueStruct); filterInstanceChanged(filterInstance)">\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-match placeholder="Pick one...">{{$select.selected.name}}</ui-select-match>\n\t\t\t\t\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\trepeat="lookup.value as lookup in lookups.dt | filter: $select.search track by lookup.name">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div>{{ lookup.name }}</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="value-struct" ng-if="[\'exact\', \'lte\', \'gte\', \'range\'].indexOf(filterInstance.lookup)>-1">\n\t\t\t\t\t\t\t\t\t\t<input class=\'field__text\' moment-picker ng-model="valueStruct.valueParts[0]"\n\t\t\t\t\t\t\t\t\t\t\t\t\t change="filteringService.hasChanges=true;filterInstanceChanged(filterInstance)">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="value-struct" ng-if="filterInstance.lookup === \'range\'">\n\t\t\t\t\t\t\t\t\t\t<input class=\'field__text\' moment-picker ng-model="valueStruct.valueParts[1]"\n\t\t\t\t\t\t\t\t\t\t\t\t\t change="filteringService.hasChanges=true;filterInstanceChanged(filterInstance)">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class="value-struct" ng-if="dayLookups.indexOf(filterInstance.lookup)>-1"\n\t\t\t\t\t\t\t\t\t\t ng-if-end>\n\t\t\t\t\t\t\t\t\t\t<div class="field-group-flex field-group-flex_align-center">\n\t\t\t\t\t\t\t\t\t\t\t\t<input type="text" class="field__text field-group-flex__item"\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-model=\'valueStruct.valueParts[0]\'\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t ng-change="filteringService.hasChanges=true;delayFilterInstanceChanged(filterInstance)"/>\n\t\t\t\t\t\t\t\t\t\t\t\t<label class="field-group-flex__item value-struct__label">Days</label>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\n\t\t\t\t<div class="field-group-flex__item field-group-flex__item_maxwidth_60">\n\t\t\t\t\t\t<div class="button-group button-group_join">\n\t\t\t\t\t\t\t\t<button class="report-filter-button button button_transparent button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="filteringService.hasChanges=true; removeFilterInstance(filterInstance)" type="button">\n\t\t\t\t\t\t\t\t\t\t<i class="icon icon-delete"></i></button>\n\t\t\t\t\t\t\t\t<button ng-if="$last" class="report-filter-button button button_transparent button_border_silver"\n\t\t\t\t\t\t\t\t\t\t\t\tng-click="filteringService.hasChanges=true; copyFilterInstance(filterInstance)" type="button">OR\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\n</div>\n');
$templateCache.put('reports/filtering/filtering.directive.html','<div class="field-list">\n\t\t<div class="field field_size_s field_border" ng-repeat="baseFilter in baseFilters|limitTo:visibleFiltersCount">\n\t\t\t\t<ng-include src="\'reports/filtering/filter_row.html\'"></ng-include>\n\t\t</div>\n\t\t<div class="field" ng-show="!filtersCollapsed" ng-if-start="baseFilters.length > visibleFiltersCount">\n\t\t\t\t<div class="field field_size_s field_border"\n\t\t\t\t\t\t ng-repeat="baseFilter in baseFilters|limitTo:visibleFiltersCount - baseFilters.length">\n\t\t\t\t\t\t<ng-include src="\'reports/filtering/filter_row.html\'"></ng-include>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="field search-sidebar__advanced" ng-if-end>\n\t\t\t\t<a href="" ng-click="filtersCollapsed = !filtersCollapsed" class="search-sidebar__advanced-link">\n\t\t\t\t\t\t<span ng-if="filtersCollapsed">Advanced filters...</span><span ng-if="!filtersCollapsed">Hide advanced filters</span>\n\t\t\t\t</a>\n\t\t</div>\n</div>\n\n');
$templateCache.put('reports/memoboxes/bulk_actions.html','<ul class="list" disable-controls="listLoaded === false || !objects.$resolved">\n\t\t<li>\n\t\t\t\t<a href="" class="btn-link" cmnt-confirm-click="bulkArchive()">Delete</a>\n\t\t</li>\n</ul>\n');
$templateCache.put('reports/memoboxes/headingButtons.html','<div class="flex">\n\t\t<div class="switch-holder flex" ng-if="uiState.view==\'list\'">\n\t\t\t\t<div class="switch-holder__text">Dark mode</div>\n\t\t\t\t<div class="switch">\n\t\t\t\t\t\t<input class="switch__input" type="checkbox" id="themeSwitch">\n\t\t\t\t\t\t<label aria-hidden="true" class="switch__label" for="themeSwitch" ng-click="toggleDarkMode()"></label>\n\t\t\t\t\t\t<div aria-hidden="true" class="switch__marker"></div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="switch-holder flex" ng-if="uiState.view==\'reports\'">\n\t\t\t\t<div class="switch-holder__text switch-holder__text_white">Classification text</div>\n\t\t\t\t<div class="switch">\n\t\t\t\t\t\t<input class="switch__input" type="checkbox" id="classTextSwitch" ng-checked="classificationTextColumn">\n\t\t\t\t\t\t<label aria-hidden="true" class="switch__label" for="classTextSwitch" ng-click="toggleClassificationText()"></label>\n\t\t\t\t\t\t<div aria-hidden="true" class="switch__marker"></div>\n\t\t\t\t</div>\n\t\t</div>\n\n\t\t<a class="button button_enlarged button_color_flamingo reports-body__view-btn"\n\t\t\t ng-class="{\'button_color_flamingo_active\': uiState.view==\'list\'}"\n\t\t\t ui-sref="community.ip.projects">List\n\t\t</a>\n\n\t\t<a class="button button_enlarged button_color_flamingo reports-body__view-btn"\n\t\t\t ng-class="{\'button_color_flamingo_active\': uiState.view==\'reports\'}"\n\t\t\t ui-sref="community.reports.projects">Report\n\t\t</a>\n</div>\n');
$templateCache.put('reports/tasks/bulk_actions.html','<ul class="list" disable-controls="listLoaded === false || !objects.$resolved">\n\t\t<li>\n\t\t\t\t<a href="" class="btn-link" cmnt-confirm-click="bulkDelete()">Delete</a>\n\t\t</li>\n</ul>\n');
$templateCache.put('core/uihelpers/partyStat.modal/partyStat.modal.html','<div class="modal">\n\t\t<div class="modal-body">\n\t\t\t\t<p class="modal-body__text">We found about {{ vm.stat.official_count }} patents. We are updating our records and\n\t\t\t\t\t\twill display results shortly.</p>\n\t\t\t\t<p class="modal-body__text">\n\t\t\t\t<div class="progress-bar progress-bar_size_m"\n\t\t\t\t\t\t ng-style="{width: vm.progress + \'%\'}">\n\t\t\t\t\t\t{{ vm.progress }}%\n\t\t\t\t</div>\n\t\t\t\t</p>\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right modal-footer_align-items-center">\n\t\t\t\t<div class="modal-footer__text">Showing results in: {{ vm.countdown }} seconds.</div>\n\t\t\t\t<button class="button button_size_s button_color_blue" ng-click=\'vm.showResults()\'>Show results now!</button>\n\t\t</div>\n</div>\n');
$templateCache.put('ip/projects/files/sharedFiles.modal.html','<div class="modal shared-files-modal">\n\t\t<div class="modal-header shared-files-modal__header">\n\t\t\t\t<h3 class="modal-title">Official & Client Docs (shared)</h3>\n\t\t</div>\n\n\t\t<div class="modal-body shared-files-modal__body">\n\t\t\t\t<div class="shared-files-modal__breadcrumbs">\n\t\t\t\t\t\t<a ng-click="vm.goToRoot()"><i class="icon icon-home"></i><i class="icon icon-right-open-mini"></i></a>\n\t\t\t\t\t\t<a ng-if="vm.childFolderName">{{ vm.childFolderName }}</a>\n\t\t\t\t</div>\n\n\t\t\t\t<cmnt-empty-result resource="vm.files" title="No files to show"></cmnt-empty-result>\n\n\t\t\t\t<cmnt-loading-indicator resource="vm.files"></cmnt-loading-indicator>\n\n\t\t\t\t<table class="table-container report-style shared-files-table" ng-if="vm.files.length">\n\t\t\t\t\t\t<thead class="shared-files-table__head">\n\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t\t\t<th>Filename</th>\n\t\t\t\t\t\t\t\t\t\t<th>Size</th>\n\t\t\t\t\t\t\t\t\t\t<th>Date</th>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t<tbody class="shared-files-table__body">\n\t\t\t\t\t\t\t\t<tr ng-repeat="file in vm.files | orderBy: [\'-is_dir\', \'name\']">\n\t\t\t\t\t\t\t\t\t\t<td ng-if="::file.is_dir">\n\t\t\t\t\t\t\t\t\t\t\t\t<a ng-click="vm.openChildFolder(file)" href="">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon icon-folder"></i>{{ ::file.name | cmntMiddleTruncate:35  }}\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if="::!file.is_dir">\n\t\t\t\t\t\t\t\t\t\t\t\t<a ng-href="{{ ::vm.downloadLink(file.signed_url) }}" target="_blank" tooltip="{{ ::file.name }}">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class="icon" ng-class="::vm.$fileIcon(file)"></i>{{ ::file.name | cmntMiddleTruncate:35 }}\n\t\t\t\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if="::file.is_dir">{{ file.children_cnt }}\n\t\t\t\t\t\t\t\t\t\t\t\t<ng-pluralize count="::file.children_cnt" when="{\'1\': \'document\', \'other\': \'documents\'}"></ng-pluralize>\n\t\t\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t\t\t<td ng-if="::!file.is_dir">{{ ::file.size | filesize }}</td>\n\t\t\t\t\t\t\t\t\t\t<td>{{ ::file.created | cmntDateFormat }}</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\n\t\t</div>\n\t\t<div class="modal-footer modal-footer_align-right modal-footer_align-items-center">\n\t\t\t\t<button class="button button_size_s button_transparent button_border_silver" ng-click=\'$dismiss()\'>Close</button>\n\t\t</div>\n</div>\n');}]);
})();
(function() {
'use strict';
angular.module('community.core').run(['$templateCache', function($templateCache) {$templateCache.put('selectize/choices.tpl.html','<div ng-show="$select.open" class="ui-select-choices ui-select-dropdown selectize-dropdown"\n\t\t ng-class="{\'single\': !$select.multiple, \'multi\': $select.multiple}">\n\t\t<div class="ui-select-choices-content selectize-dropdown-content">\n\t\t\t\t<div class="ui-select-choices-group optgroup">\n\t\t\t\t\t\t<div ng-show="$select.isGrouped" class="ui-select-choices-group-label optgroup-header"\n\t\t\t\t\t\t\t\t ng-bind="$group.name"></div>\n\t\t\t\t\t\t<div role="option" class="ui-select-choices-row"\n\t\t\t\t\t\t\t\t ng-class="{active: $select.isActive(this), disabled: $select.isDisabled(this)}">\n\t\t\t\t\t\t\t\t<div class="option ui-select-choices-row-inner" data-selectable=""></div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class="ui-select-extra-option" ng-class="$select.extraOption.class" ng-if="$select.extraOption">\n\t\t\t\t\t\t\t\t<div class="option" ng-click="$select.extraOptionClick()">\n\t\t\t\t\t\t\t\t\t\t{{ $select.extraOption.label }}\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n</div>\n');
$templateCache.put('selectize/match.tpl.html','<div ng-hide="$select.searchEnabled && ($select.open || $select.isEmpty())" class="ui-select-match">\n\t<span ng-show="!$select.searchEnabled && ($select.isEmpty() || $select.open)"\n\t\t\t\tclass="ui-select-placeholder text-muted">\n\t    {{$select.placeholder}}\n\t</span>\n\n\t\t<span class="ui-select-match-text" ng-hide="$select.isEmpty() || $select.open" ng-transclude=""></span>\n\n\t\t<a ng-show="$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)"\n\t\t\t aria-label="{{ $select.baseTitle }} clear" ng-click="$select.clear($event)" class="clear-icon">\n\t\t\t\t<i class="icon icon-cancel" aria-hidden="true"></i>\n\t\t</a>\n</div>\n');
$templateCache.put('template/pagination/pagination.html','<ul class="pagination" role="navigation" aria-label="Pagination">\n\t\t<li ng-repeat="page in pages" class="pagination__item"\n\t\t\t\tng-class="{\n        \'pagination-previous\': $first,\n        \'pagination-next\': $last,\n        current: page.active,\n        pagination__item_unavailable: page.disabled\n        }">\n\t\t\t\t<button ng-if="!page.active" ng-click="selectPage(page.number)"\n\t\t\t\t\t\t\t\tclass="pagination__button button button_size_s button_transparent button_border_silver button_text_blue">\n\t\t\t\t\t\t{{ page.text }}\n\t\t\t\t</button>\n\t\t\t\t<button ng-if="page.active" ng-click="selectPage(page.number)"\n\t\t\t\t\t\t\t\tclass="pagination__button pagination__button_active button button_size_s button_color_blue">{{ page.text\n\t\t\t\t\t\t}}\n\t\t\t\t</button>\n\t\t</li>\n</ul>\n');
$templateCache.put('template/typeahead/typeahead-match.html','<a tabindex="-1" bind-html-unsafe="match.label | typeaheadHighlight:query"></a>');
$templateCache.put('template/typeahead/typeahead-popup.html','<ul class="dropdown-pane is-open menu vertical" ng-show="isOpen() && !moveInProgress"\n\t\tng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n\t\t<li class="typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }"\n\t\t\t\tng-mouseenter="selectActive($index)" ng-click="selectMatch($index)">\n\t\t\t\t<div typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n\t\t</li>\n</ul>\n');}]);
})();